// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  BooleanType: { input: any; output: any };
  CustomData: { input: any; output: any };
  Date: { input: any; output: any };
  DateTime: { input: any; output: any };
  FloatType: { input: any; output: any };
  IntType: { input: any; output: any };
  ItemId: { input: any; output: any };
  JsonField: { input: any; output: any };
  MetaTagAttributes: { input: any; output: any };
  UploadId: { input: any; output: any };
};

export type AboutUsPageModelContentAreaField =
  | ArticlesBlockRecord
  | BrandsBlockRecord
  | BulletListRecord
  | DocumentLinkBlockRecord
  | EmployeeRecord
  | GridContainerBlockRecord
  | HeroBlockRecord
  | ImageRecord
  | JobsListBlockRecord
  | NewsAndReportsListBlockRecord
  | NewsListBlockRecord
  | OfficesBlockRecord
  | PlugBlockRecord
  | SimpleTitleAndTextBlockRecord
  | SliderBlockRecord
  | StatementBlockRecord
  | SubheadingBlockRecord
  | SustainabilityReportsBlockRecord
  | TextBlockRecord
  | TwoColumnImageAndTextRecord
  | TwoColumnTextIntroRecord
  | VideoRecord;

export type AboutUsPageModelContentAreaFieldListListNonNullMultiLocaleField = {
  __typename?: 'AboutUsPageModelContentAreaFieldListListNonNullMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value: Array<AboutUsPageModelContentAreaField>;
};

export type AboutUsPageModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<AboutUsPageModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AboutUsPageModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _locales?: InputMaybe<LocalesFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  pageName?: InputMaybe<StringFilter>;
  seo?: InputMaybe<SeoFilter>;
  slug?: InputMaybe<SlugFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum AboutUsPageModelOrderBy {
  CreatedAtAsc = '_createdAt_ASC',
  CreatedAtDesc = '_createdAt_DESC',
  FirstPublishedAtAsc = '_firstPublishedAt_ASC',
  FirstPublishedAtDesc = '_firstPublishedAt_DESC',
  IsValidAsc = '_isValid_ASC',
  IsValidDesc = '_isValid_DESC',
  PublicationScheduledAtAsc = '_publicationScheduledAt_ASC',
  PublicationScheduledAtDesc = '_publicationScheduledAt_DESC',
  PublishedAtAsc = '_publishedAt_ASC',
  PublishedAtDesc = '_publishedAt_DESC',
  StatusAsc = '_status_ASC',
  StatusDesc = '_status_DESC',
  UnpublishingScheduledAtAsc = '_unpublishingScheduledAt_ASC',
  UnpublishingScheduledAtDesc = '_unpublishingScheduledAt_DESC',
  UpdatedAtAsc = '_updatedAt_ASC',
  UpdatedAtDesc = '_updatedAt_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PageNameAsc = 'pageName_ASC',
  PageNameDesc = 'pageName_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

/** Record of type About Page (about_us_page) */
export type AboutUsPageRecord = RecordInterface & {
  __typename?: 'AboutUsPageRecord';
  _allContentAreaLocales?: Maybe<
    Array<AboutUsPageModelContentAreaFieldListListNonNullMultiLocaleField>
  >;
  _allSeoLocales?: Maybe<Array<SeoFieldMultiLocaleField>>;
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  contentArea: Array<AboutUsPageModelContentAreaField>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  pageName?: Maybe<Scalars['String']['output']>;
  seo?: Maybe<SeoField>;
  slug?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Record of type About Page (about_us_page) */
export type AboutUsPageRecord_AllContentAreaLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type About Page (about_us_page) */
export type AboutUsPageRecord_AllSeoLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type About Page (about_us_page) */
export type AboutUsPageRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type About Page (about_us_page) */
export type AboutUsPageRecordContentAreaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type About Page (about_us_page) */
export type AboutUsPageRecordSeoArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Articles Block (articles_block) */
export type ArticlesBlockRecord = RecordInterface & {
  __typename?: 'ArticlesBlockRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  ctaText?: Maybe<Scalars['String']['output']>;
  ctaUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ItemId']['output'];
  isJobArticles?: Maybe<Scalars['BooleanType']['output']>;
  jobPages: Array<JobOpportunitiesPageRecord>;
  newsPages: Array<NewsPageRecord>;
  reportPages: Array<ReportsListingRecord>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Block of type Articles Block (articles_block) */
export type ArticlesBlockRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Specifies how to filter Boolean fields */
export type BooleanFilter = {
  /** Search for records with an exact match */
  eq?: InputMaybe<Scalars['BooleanType']['input']>;
};

export type BooleanTypeMultiLocaleField = {
  __typename?: 'BooleanTypeMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<Scalars['BooleanType']['output']>;
};

export type BrandPageModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<BrandPageModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BrandPageModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _locales?: InputMaybe<LocalesFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  brandName?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  description?: InputMaybe<TextFilter>;
  heroImage?: InputMaybe<FileFilter>;
  heroImageMobile?: InputMaybe<FileFilter>;
  heroTitle?: InputMaybe<StringFilter>;
  id?: InputMaybe<ItemIdFilter>;
  imageForListview?: InputMaybe<FileFilter>;
  linkToWebsite?: InputMaybe<StringFilter>;
  linkToWebsiteText?: InputMaybe<StringFilter>;
  logo?: InputMaybe<FileFilter>;
  seo?: InputMaybe<SeoFilter>;
  slug?: InputMaybe<SlugFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum BrandPageModelOrderBy {
  CreatedAtAsc = '_createdAt_ASC',
  CreatedAtDesc = '_createdAt_DESC',
  FirstPublishedAtAsc = '_firstPublishedAt_ASC',
  FirstPublishedAtDesc = '_firstPublishedAt_DESC',
  IsValidAsc = '_isValid_ASC',
  IsValidDesc = '_isValid_DESC',
  PublicationScheduledAtAsc = '_publicationScheduledAt_ASC',
  PublicationScheduledAtDesc = '_publicationScheduledAt_DESC',
  PublishedAtAsc = '_publishedAt_ASC',
  PublishedAtDesc = '_publishedAt_DESC',
  StatusAsc = '_status_ASC',
  StatusDesc = '_status_DESC',
  UnpublishingScheduledAtAsc = '_unpublishingScheduledAt_ASC',
  UnpublishingScheduledAtDesc = '_unpublishingScheduledAt_DESC',
  UpdatedAtAsc = '_updatedAt_ASC',
  UpdatedAtDesc = '_updatedAt_DESC',
  BrandNameAsc = 'brandName_ASC',
  BrandNameDesc = 'brandName_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  HeroTitleAsc = 'heroTitle_ASC',
  HeroTitleDesc = 'heroTitle_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  LinkToWebsiteTextAsc = 'linkToWebsiteText_ASC',
  LinkToWebsiteTextDesc = 'linkToWebsiteText_DESC',
  LinkToWebsiteAsc = 'linkToWebsite_ASC',
  LinkToWebsiteDesc = 'linkToWebsite_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

/** Record of type Brand page (brand_page) */
export type BrandPageRecord = RecordInterface & {
  __typename?: 'BrandPageRecord';
  _allDescriptionLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allHeroTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allLinkToWebsiteLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allLinkToWebsiteTextLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allSeoLocales?: Maybe<Array<SeoFieldMultiLocaleField>>;
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  brandName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  heroImage?: Maybe<FileField>;
  heroImageMobile?: Maybe<FileField>;
  heroTitle?: Maybe<Scalars['String']['output']>;
  id: Scalars['ItemId']['output'];
  imageForListview?: Maybe<FileField>;
  linkToWebsite?: Maybe<Scalars['String']['output']>;
  linkToWebsiteText?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<FileField>;
  seo?: Maybe<SeoField>;
  slug?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Record of type Brand page (brand_page) */
export type BrandPageRecord_AllDescriptionLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
  markdown?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Record of type Brand page (brand_page) */
export type BrandPageRecord_AllHeroTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Brand page (brand_page) */
export type BrandPageRecord_AllLinkToWebsiteLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Brand page (brand_page) */
export type BrandPageRecord_AllLinkToWebsiteTextLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Brand page (brand_page) */
export type BrandPageRecord_AllSeoLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Brand page (brand_page) */
export type BrandPageRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Brand page (brand_page) */
export type BrandPageRecordDescriptionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
  markdown?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Record of type Brand page (brand_page) */
export type BrandPageRecordHeroTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Brand page (brand_page) */
export type BrandPageRecordLinkToWebsiteArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Brand page (brand_page) */
export type BrandPageRecordLinkToWebsiteTextArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Brand page (brand_page) */
export type BrandPageRecordSeoArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Brands Block (brands_block) */
export type BrandsBlockRecord = RecordInterface & {
  __typename?: 'BrandsBlockRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  brands: Array<BrandPageRecord>;
  createdAt: Scalars['DateTime']['output'];
  hideLabels?: Maybe<Scalars['BooleanType']['output']>;
  id: Scalars['ItemId']['output'];
  introText?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Block of type Brands Block (brands_block) */
export type BrandsBlockRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Brands Block (brands_block) */
export type BrandsBlockRecordIntroTextArgs = {
  markdown?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BrandsListPageModelContentAreaField =
  | ArticlesBlockRecord
  | BrandsBlockRecord
  | BulletListRecord
  | DocumentLinkBlockRecord
  | EmployeeRecord
  | GridContainerBlockRecord
  | HeroBlockRecord
  | ImageRecord
  | NewsAndReportsListBlockRecord
  | NewsListBlockRecord
  | OfficesBlockRecord
  | PlugBlockRecord
  | ReportsListBlockRecord
  | SimpleTitleAndTextBlockRecord
  | SliderBlockRecord
  | StatementBlockRecord
  | SubheadingBlockRecord
  | SustainabilityReportsBlockRecord
  | TextBlockRecord
  | TwoColumnImageAndTextRecord
  | TwoColumnTextIntroRecord
  | VideoRecord;

export type BrandsListPageModelContentAreaFieldListListNonNullMultiLocaleField =
  {
    __typename?: 'BrandsListPageModelContentAreaFieldListListNonNullMultiLocaleField';
    locale?: Maybe<SiteLocale>;
    value: Array<BrandsListPageModelContentAreaField>;
  };

/** Record of type Brands Index Page (brands_list_page) */
export type BrandsListPageRecord = RecordInterface & {
  __typename?: 'BrandsListPageRecord';
  _allContentAreaLocales?: Maybe<
    Array<BrandsListPageModelContentAreaFieldListListNonNullMultiLocaleField>
  >;
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  contentArea: Array<BrandsListPageModelContentAreaField>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  seo?: Maybe<SeoField>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Record of type Brands Index Page (brands_list_page) */
export type BrandsListPageRecord_AllContentAreaLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Brands Index Page (brands_list_page) */
export type BrandsListPageRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Brands Index Page (brands_list_page) */
export type BrandsListPageRecordContentAreaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Bullet List Block (bullet_list) */
export type BulletListRecord = RecordInterface & {
  __typename?: 'BulletListRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  bullets?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  numberedList?: Maybe<Scalars['BooleanType']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Block of type Bullet List Block (bullet_list) */
export type BulletListRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Bullet List Block (bullet_list) */
export type BulletListRecordBulletsArgs = {
  markdown?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CampaignPageModelContentAreaField =
  | ArticlesBlockRecord
  | BrandsBlockRecord
  | BulletListRecord
  | DocumentLinkBlockRecord
  | EmployeeRecord
  | GridContainerBlockRecord
  | HeroBlockRecord
  | ImageRecord
  | JobsListBlockRecord
  | NewsAndReportsListBlockRecord
  | NewsListBlockRecord
  | OfficesBlockRecord
  | PlugBlockRecord
  | SimpleTitleAndTextBlockRecord
  | SliderBlockRecord
  | StatementBlockRecord
  | SubheadingBlockRecord
  | SustainabilityReportsBlockRecord
  | TextBlockRecord
  | TwoColumnImageAndTextRecord
  | TwoColumnTextIntroRecord
  | VideoRecord;

export type CampaignPageModelContentAreaFieldListListNonNullMultiLocaleField = {
  __typename?: 'CampaignPageModelContentAreaFieldListListNonNullMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value: Array<CampaignPageModelContentAreaField>;
};

export type CampaignPageModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<CampaignPageModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CampaignPageModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _locales?: InputMaybe<LocalesFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  pageName?: InputMaybe<StringFilter>;
  seo?: InputMaybe<SeoFilter>;
  slug?: InputMaybe<SlugFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum CampaignPageModelOrderBy {
  CreatedAtAsc = '_createdAt_ASC',
  CreatedAtDesc = '_createdAt_DESC',
  FirstPublishedAtAsc = '_firstPublishedAt_ASC',
  FirstPublishedAtDesc = '_firstPublishedAt_DESC',
  IsValidAsc = '_isValid_ASC',
  IsValidDesc = '_isValid_DESC',
  PublicationScheduledAtAsc = '_publicationScheduledAt_ASC',
  PublicationScheduledAtDesc = '_publicationScheduledAt_DESC',
  PublishedAtAsc = '_publishedAt_ASC',
  PublishedAtDesc = '_publishedAt_DESC',
  StatusAsc = '_status_ASC',
  StatusDesc = '_status_DESC',
  UnpublishingScheduledAtAsc = '_unpublishingScheduledAt_ASC',
  UnpublishingScheduledAtDesc = '_unpublishingScheduledAt_DESC',
  UpdatedAtAsc = '_updatedAt_ASC',
  UpdatedAtDesc = '_updatedAt_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PageNameAsc = 'pageName_ASC',
  PageNameDesc = 'pageName_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

/** Record of type Campaign Page (campaign_page) */
export type CampaignPageRecord = RecordInterface & {
  __typename?: 'CampaignPageRecord';
  _allContentAreaLocales?: Maybe<
    Array<CampaignPageModelContentAreaFieldListListNonNullMultiLocaleField>
  >;
  _allSeoLocales?: Maybe<Array<SeoFieldMultiLocaleField>>;
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  contentArea: Array<CampaignPageModelContentAreaField>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  pageName?: Maybe<Scalars['String']['output']>;
  seo?: Maybe<SeoField>;
  slug?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Record of type Campaign Page (campaign_page) */
export type CampaignPageRecord_AllContentAreaLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Campaign Page (campaign_page) */
export type CampaignPageRecord_AllSeoLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Campaign Page (campaign_page) */
export type CampaignPageRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Campaign Page (campaign_page) */
export type CampaignPageRecordContentAreaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Campaign Page (campaign_page) */
export type CampaignPageRecordSeoArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

export type CollectionMetadata = {
  __typename?: 'CollectionMetadata';
  count: Scalars['IntType']['output'];
};

export enum ColorBucketType {
  Black = 'black',
  Blue = 'blue',
  Brown = 'brown',
  Cyan = 'cyan',
  Green = 'green',
  Grey = 'grey',
  Orange = 'orange',
  Pink = 'pink',
  Purple = 'purple',
  Red = 'red',
  White = 'white',
  Yellow = 'yellow',
}

export type ColorField = {
  __typename?: 'ColorField';
  alpha: Scalars['IntType']['output'];
  blue: Scalars['IntType']['output'];
  cssRgb: Scalars['String']['output'];
  green: Scalars['IntType']['output'];
  hex: Scalars['String']['output'];
  red: Scalars['IntType']['output'];
};

/** Record of type Consent box (consent_box) */
export type ConsentBoxRecord = RecordInterface & {
  __typename?: 'ConsentBoxRecord';
  _allDescriptionLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allOkLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allSettingsCookiePolicyTextLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allSettingsSaveButtonLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allSettingsTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allSettingsToggleLabelLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allSettingsToggleTextLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ItemId']['output'];
  ok?: Maybe<Scalars['String']['output']>;
  settingsButton?: Maybe<Scalars['String']['output']>;
  settingsCookiePolicyText?: Maybe<Scalars['String']['output']>;
  settingsSaveButton?: Maybe<Scalars['String']['output']>;
  settingsTitle?: Maybe<Scalars['String']['output']>;
  settingsToggleLabel?: Maybe<Scalars['String']['output']>;
  settingsToggleText?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Record of type Consent box (consent_box) */
export type ConsentBoxRecord_AllDescriptionLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
  markdown?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Record of type Consent box (consent_box) */
export type ConsentBoxRecord_AllOkLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Consent box (consent_box) */
export type ConsentBoxRecord_AllSettingsCookiePolicyTextLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
  markdown?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Record of type Consent box (consent_box) */
export type ConsentBoxRecord_AllSettingsSaveButtonLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Consent box (consent_box) */
export type ConsentBoxRecord_AllSettingsTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Consent box (consent_box) */
export type ConsentBoxRecord_AllSettingsToggleLabelLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Consent box (consent_box) */
export type ConsentBoxRecord_AllSettingsToggleTextLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
  markdown?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Record of type Consent box (consent_box) */
export type ConsentBoxRecord_AllTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Consent box (consent_box) */
export type ConsentBoxRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Consent box (consent_box) */
export type ConsentBoxRecordDescriptionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
  markdown?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Record of type Consent box (consent_box) */
export type ConsentBoxRecordOkArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Consent box (consent_box) */
export type ConsentBoxRecordSettingsCookiePolicyTextArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
  markdown?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Record of type Consent box (consent_box) */
export type ConsentBoxRecordSettingsSaveButtonArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Consent box (consent_box) */
export type ConsentBoxRecordSettingsTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Consent box (consent_box) */
export type ConsentBoxRecordSettingsToggleLabelArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Consent box (consent_box) */
export type ConsentBoxRecordSettingsToggleTextArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
  markdown?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Record of type Consent box (consent_box) */
export type ConsentBoxRecordTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

export type ContactPageModelContentAreaField =
  | ArticlesBlockRecord
  | BrandsBlockRecord
  | BulletListRecord
  | DocumentLinkBlockRecord
  | EmployeeRecord
  | GridContainerBlockRecord
  | HeroBlockRecord
  | ImageRecord
  | JobsListBlockRecord
  | NewsAndReportsListBlockRecord
  | NewsListBlockRecord
  | OfficesBlockRecord
  | PlugBlockRecord
  | SimpleTitleAndTextBlockRecord
  | SliderBlockRecord
  | StatementBlockRecord
  | SubheadingBlockRecord
  | SustainabilityReportsBlockRecord
  | TextBlockRecord
  | TwoColumnImageAndTextRecord
  | TwoColumnTextIntroRecord
  | VideoRecord;

export type ContactPageModelContentAreaFieldListListNonNullMultiLocaleField = {
  __typename?: 'ContactPageModelContentAreaFieldListListNonNullMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value: Array<ContactPageModelContentAreaField>;
};

/** Record of type Contact page (contact_page) */
export type ContactPageRecord = RecordInterface & {
  __typename?: 'ContactPageRecord';
  _allContentAreaLocales?: Maybe<
    Array<ContactPageModelContentAreaFieldListListNonNullMultiLocaleField>
  >;
  _allSeoLocales?: Maybe<Array<SeoFieldMultiLocaleField>>;
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  contentArea: Array<ContactPageModelContentAreaField>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  seo?: Maybe<SeoField>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Record of type Contact page (contact_page) */
export type ContactPageRecord_AllContentAreaLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Contact page (contact_page) */
export type ContactPageRecord_AllSeoLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Contact page (contact_page) */
export type ContactPageRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Contact page (contact_page) */
export type ContactPageRecordContentAreaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Contact page (contact_page) */
export type ContactPageRecordSeoArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Specifies how to filter by creation datetime */
export type CreatedAtFilter = {
  /** Filter records with a value that's within the specified minute range. Seconds and milliseconds are truncated from the argument. */
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records with a value that's strictly greater than the one specified. Seconds and milliseconds are truncated from the argument. */
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's greater than or equal to than the one specified. Seconds and milliseconds are truncated from the argument. */
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's less than the one specified. Seconds and milliseconds are truncated from the argument. */
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's less or equal than the one specified. Seconds and milliseconds are truncated from the argument. */
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's outside the specified minute range. Seconds and milliseconds are truncated from the argument. */
  neq?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Block of type CTA Button (cta_button) */
export type CtaButtonRecord = RecordInterface & {
  __typename?: 'CtaButtonRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  text?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
  variant?: Maybe<Scalars['String']['output']>;
};

/** Block of type CTA Button (cta_button) */
export type CtaButtonRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Specifies how to filter Date fields */
export type DateFilter = {
  /** Search for records with an exact match */
  eq?: InputMaybe<Scalars['Date']['input']>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records with a value that's strictly greater than the one specified */
  gt?: InputMaybe<Scalars['Date']['input']>;
  /** Filter records with a value that's greater than or equal to the one specified */
  gte?: InputMaybe<Scalars['Date']['input']>;
  /** Filter records with a value that's less than the one specified */
  lt?: InputMaybe<Scalars['Date']['input']>;
  /** Filter records with a value that's less or equal than the one specified */
  lte?: InputMaybe<Scalars['Date']['input']>;
  /** Exclude records with an exact match */
  neq?: InputMaybe<Scalars['Date']['input']>;
};

/** Block of type Document Link Block (document_link_block) */
export type DocumentLinkBlockRecord = RecordInterface & {
  __typename?: 'DocumentLinkBlockRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  documents: Array<FileField>;
  id: Scalars['ItemId']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Block of type Document Link Block (document_link_block) */
export type DocumentLinkBlockRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Employee Block (employee) */
export type EmployeeRecord = RecordInterface & {
  __typename?: 'EmployeeRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ItemId']['output'];
  introText?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  profileImage?: Maybe<FileField>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Block of type Employee Block (employee) */
export type EmployeeRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Employee Block (employee) */
export type EmployeeRecordDescriptionArgs = {
  markdown?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Block of type Employee Block (employee) */
export type EmployeeRecordIntroTextArgs = {
  markdown?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum FaviconType {
  AppleTouchIcon = 'appleTouchIcon',
  Icon = 'icon',
  MsApplication = 'msApplication',
}

/** Record of type Feature toggle (feature_toggle) */
export type FeatureToggleRecord = RecordInterface & {
  __typename?: 'FeatureToggleRecord';
  _allJobOpportunitiesPageContentAreaLocales?: Maybe<
    Array<BooleanTypeMultiLocaleField>
  >;
  _allLandingPageContentAreaLocales?: Maybe<Array<BooleanTypeMultiLocaleField>>;
  _allNewsPageContentAreaLocales?: Maybe<Array<BooleanTypeMultiLocaleField>>;
  _allSustainabilityPageContentAreaLocales?: Maybe<
    Array<BooleanTypeMultiLocaleField>
  >;
  _allTestFieldLocales?: Maybe<Array<BooleanTypeMultiLocaleField>>;
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  jobOpportunitiesPageContentArea?: Maybe<Scalars['BooleanType']['output']>;
  landingPageContentArea?: Maybe<Scalars['BooleanType']['output']>;
  newsPageContentArea?: Maybe<Scalars['BooleanType']['output']>;
  sustainabilityPageContentArea?: Maybe<Scalars['BooleanType']['output']>;
  testField?: Maybe<Scalars['BooleanType']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Record of type Feature toggle (feature_toggle) */
export type FeatureToggleRecord_AllJobOpportunitiesPageContentAreaLocalesArgs =
  {
    fallbackLocales?: InputMaybe<Array<SiteLocale>>;
    locale?: InputMaybe<SiteLocale>;
  };

/** Record of type Feature toggle (feature_toggle) */
export type FeatureToggleRecord_AllLandingPageContentAreaLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Feature toggle (feature_toggle) */
export type FeatureToggleRecord_AllNewsPageContentAreaLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Feature toggle (feature_toggle) */
export type FeatureToggleRecord_AllSustainabilityPageContentAreaLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Feature toggle (feature_toggle) */
export type FeatureToggleRecord_AllTestFieldLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Feature toggle (feature_toggle) */
export type FeatureToggleRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Feature toggle (feature_toggle) */
export type FeatureToggleRecordJobOpportunitiesPageContentAreaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Feature toggle (feature_toggle) */
export type FeatureToggleRecordLandingPageContentAreaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Feature toggle (feature_toggle) */
export type FeatureToggleRecordNewsPageContentAreaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Feature toggle (feature_toggle) */
export type FeatureToggleRecordSustainabilityPageContentAreaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Feature toggle (feature_toggle) */
export type FeatureToggleRecordTestFieldArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

export type FileField = FileFieldInterface & {
  __typename?: 'FileField';
  _createdAt: Scalars['DateTime']['output'];
  /** The DatoCMS URL where you can edit this entity. To use this field, you need to set a X-Base-Editing-Url header in the request */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  alt?: Maybe<Scalars['String']['output']>;
  author?: Maybe<Scalars['String']['output']>;
  basename: Scalars['String']['output'];
  blurUpThumb?: Maybe<Scalars['String']['output']>;
  blurhash?: Maybe<Scalars['String']['output']>;
  colors: Array<ColorField>;
  copyright?: Maybe<Scalars['String']['output']>;
  customData: Scalars['CustomData']['output'];
  exifInfo: Scalars['CustomData']['output'];
  filename: Scalars['String']['output'];
  focalPoint?: Maybe<FocalPoint>;
  format: Scalars['String']['output'];
  height?: Maybe<Scalars['IntType']['output']>;
  id: Scalars['UploadId']['output'];
  md5: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  responsiveImage?: Maybe<ResponsiveImage>;
  size: Scalars['IntType']['output'];
  smartTags: Array<Scalars['String']['output']>;
  tags: Array<Scalars['String']['output']>;
  thumbhash?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
  video?: Maybe<UploadVideoField>;
  width?: Maybe<Scalars['IntType']['output']>;
};

export type FileFieldAltArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

export type FileFieldBlurUpThumbArgs = {
  imgixParams?: InputMaybe<ImgixParams>;
  punch?: Scalars['Float']['input'];
  quality?: Scalars['Int']['input'];
  size?: Scalars['Int']['input'];
};

export type FileFieldCustomDataArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

export type FileFieldFocalPointArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

export type FileFieldResponsiveImageArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  imgixParams?: InputMaybe<ImgixParams>;
  locale?: InputMaybe<SiteLocale>;
  sizes?: InputMaybe<Scalars['String']['input']>;
};

export type FileFieldTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

export type FileFieldUrlArgs = {
  imgixParams?: InputMaybe<ImgixParams>;
};

export type FileFieldInterface = {
  _createdAt: Scalars['DateTime']['output'];
  /** The DatoCMS URL where you can edit this entity. To use this field, you need to set a X-Base-Editing-Url header in the request */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  alt?: Maybe<Scalars['String']['output']>;
  author?: Maybe<Scalars['String']['output']>;
  basename: Scalars['String']['output'];
  blurUpThumb?: Maybe<Scalars['String']['output']>;
  blurhash?: Maybe<Scalars['String']['output']>;
  colors: Array<ColorField>;
  copyright?: Maybe<Scalars['String']['output']>;
  customData: Scalars['CustomData']['output'];
  exifInfo: Scalars['CustomData']['output'];
  filename: Scalars['String']['output'];
  focalPoint?: Maybe<FocalPoint>;
  format: Scalars['String']['output'];
  height?: Maybe<Scalars['IntType']['output']>;
  id: Scalars['UploadId']['output'];
  md5: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  responsiveImage?: Maybe<ResponsiveImage>;
  size: Scalars['IntType']['output'];
  smartTags: Array<Scalars['String']['output']>;
  tags: Array<Scalars['String']['output']>;
  thumbhash?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
  video?: Maybe<UploadVideoField>;
  width?: Maybe<Scalars['IntType']['output']>;
};

export type FileFieldInterfaceAltArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

export type FileFieldInterfaceBlurUpThumbArgs = {
  imgixParams?: InputMaybe<ImgixParams>;
  punch?: Scalars['Float']['input'];
  quality?: Scalars['Int']['input'];
  size?: Scalars['Int']['input'];
};

export type FileFieldInterfaceCustomDataArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

export type FileFieldInterfaceFocalPointArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

export type FileFieldInterfaceResponsiveImageArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  imgixParams?: InputMaybe<ImgixParams>;
  locale?: InputMaybe<SiteLocale>;
  sizes?: InputMaybe<Scalars['String']['input']>;
};

export type FileFieldInterfaceTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

export type FileFieldInterfaceUrlArgs = {
  imgixParams?: InputMaybe<ImgixParams>;
};

/** Specifies how to filter Single-file/image fields */
export type FileFilter = {
  /** Search for records with an exact match. The specified value must be an Upload ID */
  eq?: InputMaybe<Scalars['UploadId']['input']>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records that have one of the specified uploads */
  in?: InputMaybe<Array<InputMaybe<Scalars['UploadId']['input']>>>;
  /** Exclude records with an exact match. The specified value must be an Upload ID */
  neq?: InputMaybe<Scalars['UploadId']['input']>;
  /** Filter records that do not have one of the specified uploads */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['UploadId']['input']>>>;
};

/** Block of type Footer Menu Item (footer_menu_item) */
export type FooterMenuItemRecord = RecordInterface & {
  __typename?: 'FooterMenuItemRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  heading?: Maybe<Scalars['String']['output']>;
  id: Scalars['ItemId']['output'];
  includeCookieToggle?: Maybe<Scalars['BooleanType']['output']>;
  links: Array<LinkRecord>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Block of type Footer Menu Item (footer_menu_item) */
export type FooterMenuItemRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type FooterMenuItemRecordListListNonNullMultiLocaleField = {
  __typename?: 'FooterMenuItemRecordListListNonNullMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value: Array<FooterMenuItemRecord>;
};

/** Record of type Footer (footer) */
export type FooterRecord = RecordInterface & {
  __typename?: 'FooterRecord';
  _allBottomIntroLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allCookieSettingsLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allHultaforsBrandsLocales?: Maybe<
    Array<LinkRecordListListNonNullMultiLocaleField>
  >;
  _allIntroTextLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allMenuItemsLocales?: Maybe<
    Array<FooterMenuItemRecordListListNonNullMultiLocaleField>
  >;
  _allMenuLocales?: Maybe<Array<LinkRecordListListNonNullMultiLocaleField>>;
  _allMoreInfoTextLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allPartnerLoginLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allSelectCountryLabelLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allSocialMediaLabelLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allSocialMediaMenuLocales?: Maybe<
    Array<IconLinkRecordListListNonNullMultiLocaleField>
  >;
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  bottomIntro?: Maybe<Scalars['String']['output']>;
  cookieSettings?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  footerLogo?: Maybe<FileField>;
  hultaforsBrands: Array<LinkRecord>;
  id: Scalars['ItemId']['output'];
  introText?: Maybe<Scalars['String']['output']>;
  menu: Array<LinkRecord>;
  menuItems: Array<FooterMenuItemRecord>;
  moreInfoText?: Maybe<Scalars['String']['output']>;
  partnerLogin?: Maybe<Scalars['String']['output']>;
  selectCountryLabel?: Maybe<Scalars['String']['output']>;
  socialMediaLabel?: Maybe<Scalars['String']['output']>;
  socialMediaMenu: Array<IconLinkRecord>;
  updatedAt: Scalars['DateTime']['output'];
  useNewFooter?: Maybe<Scalars['BooleanType']['output']>;
};

/** Record of type Footer (footer) */
export type FooterRecord_AllBottomIntroLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
  markdown?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Record of type Footer (footer) */
export type FooterRecord_AllCookieSettingsLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Footer (footer) */
export type FooterRecord_AllHultaforsBrandsLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Footer (footer) */
export type FooterRecord_AllIntroTextLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
  markdown?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Record of type Footer (footer) */
export type FooterRecord_AllMenuItemsLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Footer (footer) */
export type FooterRecord_AllMenuLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Footer (footer) */
export type FooterRecord_AllMoreInfoTextLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
  markdown?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Record of type Footer (footer) */
export type FooterRecord_AllPartnerLoginLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Footer (footer) */
export type FooterRecord_AllSelectCountryLabelLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Footer (footer) */
export type FooterRecord_AllSocialMediaLabelLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Footer (footer) */
export type FooterRecord_AllSocialMediaMenuLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Footer (footer) */
export type FooterRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Footer (footer) */
export type FooterRecordBottomIntroArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
  markdown?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Record of type Footer (footer) */
export type FooterRecordCookieSettingsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Footer (footer) */
export type FooterRecordHultaforsBrandsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Footer (footer) */
export type FooterRecordIntroTextArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
  markdown?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Record of type Footer (footer) */
export type FooterRecordMenuArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Footer (footer) */
export type FooterRecordMenuItemsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Footer (footer) */
export type FooterRecordMoreInfoTextArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
  markdown?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Record of type Footer (footer) */
export type FooterRecordPartnerLoginArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Footer (footer) */
export type FooterRecordSelectCountryLabelArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Footer (footer) */
export type FooterRecordSocialMediaLabelArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Footer (footer) */
export type FooterRecordSocialMediaMenuArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Fullscreen image CTA (fullscreen_image_cta) */
export type FullscreenImageCtaRecord = RecordInterface & {
  __typename?: 'FullscreenImageCtaRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  ctaText?: Maybe<Scalars['String']['output']>;
  ctaUrl?: Maybe<Scalars['String']['output']>;
  header?: Maybe<Scalars['String']['output']>;
  id: Scalars['ItemId']['output'];
  image?: Maybe<FileField>;
  text?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Block of type Fullscreen image CTA (fullscreen_image_cta) */
export type FullscreenImageCtaRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Fullscreen image CTA (fullscreen_image_cta) */
export type FullscreenImageCtaRecordTextArgs = {
  markdown?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Record of type Global data (global) */
export type GlobalRecord = RecordInterface & {
  __typename?: 'GlobalRecord';
  _allChangeLanguageLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allClearIconLabelLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allCloseLabelLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allDeadlineLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allErrorMessageLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allFirstPageLabelLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allGoToPageLabelLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allLanguagesLocales?: Maybe<
    Array<LanguageRecordListListNonNullMultiLocaleField>
  >;
  _allLastPageLabelLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allLoadMoreNewsLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allLoadMoreReportsLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allLoadingLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allLocalWebLabelLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allMenuLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allMoreNewsCtaLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allMoreNewsHeaderLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allMoreReportsCtaLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allNextLabelLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allNextPageLabelLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allNoSearchResultsLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allPartnerPortalLabelLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allPartnerPortalUrlLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allPlayLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allPreviousLabelLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allPreviousPageLabelLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allSearchBoxPlaceholderLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allSearchIconLabelLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allSearchResultCountLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allSearchResultsPageTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allShopLinkTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allShowMoreJobsLabelLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allSliderNavigationLabelLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allViewAllButtonLabelLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allViewOnMapLabelLocales?: Maybe<Array<StringMultiLocaleField>>;
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  changeLanguage?: Maybe<Scalars['String']['output']>;
  clearIconLabel?: Maybe<Scalars['String']['output']>;
  closeLabel?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deadline?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  firstPageLabel?: Maybe<Scalars['String']['output']>;
  goToPageLabel?: Maybe<Scalars['String']['output']>;
  id: Scalars['ItemId']['output'];
  languages: Array<LanguageRecord>;
  lastPageLabel?: Maybe<Scalars['String']['output']>;
  loadMoreNews?: Maybe<Scalars['String']['output']>;
  loadMoreReports?: Maybe<Scalars['String']['output']>;
  loading?: Maybe<Scalars['String']['output']>;
  localWebLabel?: Maybe<Scalars['String']['output']>;
  menu?: Maybe<Scalars['String']['output']>;
  moreNewsCta?: Maybe<Scalars['String']['output']>;
  moreNewsHeader?: Maybe<Scalars['String']['output']>;
  moreReportsCta?: Maybe<Scalars['String']['output']>;
  navigationLogo?: Maybe<FileField>;
  nextLabel?: Maybe<Scalars['String']['output']>;
  nextPageLabel?: Maybe<Scalars['String']['output']>;
  noSearchResults?: Maybe<Scalars['String']['output']>;
  partnerPortalLabel?: Maybe<Scalars['String']['output']>;
  partnerPortalUrl?: Maybe<Scalars['String']['output']>;
  play?: Maybe<Scalars['String']['output']>;
  previousLabel?: Maybe<Scalars['String']['output']>;
  previousPageLabel?: Maybe<Scalars['String']['output']>;
  searchBoxPlaceholder?: Maybe<Scalars['String']['output']>;
  searchIconLabel?: Maybe<Scalars['String']['output']>;
  searchResultCount?: Maybe<Scalars['String']['output']>;
  searchResultsPageTitle?: Maybe<Scalars['String']['output']>;
  shopLinkTitle?: Maybe<Scalars['String']['output']>;
  shopLinkUrl?: Maybe<Scalars['String']['output']>;
  showMoreJobsLabel?: Maybe<Scalars['String']['output']>;
  sliderNavigationLabel?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  viewAllButtonLabel?: Maybe<Scalars['String']['output']>;
  viewOnMapLabel?: Maybe<Scalars['String']['output']>;
};

/** Record of type Global data (global) */
export type GlobalRecord_AllChangeLanguageLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Global data (global) */
export type GlobalRecord_AllClearIconLabelLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Global data (global) */
export type GlobalRecord_AllCloseLabelLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Global data (global) */
export type GlobalRecord_AllDeadlineLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Global data (global) */
export type GlobalRecord_AllErrorMessageLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Global data (global) */
export type GlobalRecord_AllFirstPageLabelLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Global data (global) */
export type GlobalRecord_AllGoToPageLabelLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Global data (global) */
export type GlobalRecord_AllLanguagesLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Global data (global) */
export type GlobalRecord_AllLastPageLabelLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Global data (global) */
export type GlobalRecord_AllLoadMoreNewsLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Global data (global) */
export type GlobalRecord_AllLoadMoreReportsLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Global data (global) */
export type GlobalRecord_AllLoadingLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Global data (global) */
export type GlobalRecord_AllLocalWebLabelLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Global data (global) */
export type GlobalRecord_AllMenuLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Global data (global) */
export type GlobalRecord_AllMoreNewsCtaLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Global data (global) */
export type GlobalRecord_AllMoreNewsHeaderLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Global data (global) */
export type GlobalRecord_AllMoreReportsCtaLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Global data (global) */
export type GlobalRecord_AllNextLabelLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Global data (global) */
export type GlobalRecord_AllNextPageLabelLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Global data (global) */
export type GlobalRecord_AllNoSearchResultsLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Global data (global) */
export type GlobalRecord_AllPartnerPortalLabelLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Global data (global) */
export type GlobalRecord_AllPartnerPortalUrlLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Global data (global) */
export type GlobalRecord_AllPlayLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Global data (global) */
export type GlobalRecord_AllPreviousLabelLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Global data (global) */
export type GlobalRecord_AllPreviousPageLabelLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Global data (global) */
export type GlobalRecord_AllSearchBoxPlaceholderLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Global data (global) */
export type GlobalRecord_AllSearchIconLabelLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Global data (global) */
export type GlobalRecord_AllSearchResultCountLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Global data (global) */
export type GlobalRecord_AllSearchResultsPageTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Global data (global) */
export type GlobalRecord_AllShopLinkTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Global data (global) */
export type GlobalRecord_AllShowMoreJobsLabelLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Global data (global) */
export type GlobalRecord_AllSliderNavigationLabelLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Global data (global) */
export type GlobalRecord_AllViewAllButtonLabelLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Global data (global) */
export type GlobalRecord_AllViewOnMapLabelLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Global data (global) */
export type GlobalRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Global data (global) */
export type GlobalRecordChangeLanguageArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Global data (global) */
export type GlobalRecordClearIconLabelArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Global data (global) */
export type GlobalRecordCloseLabelArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Global data (global) */
export type GlobalRecordDeadlineArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Global data (global) */
export type GlobalRecordErrorMessageArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Global data (global) */
export type GlobalRecordFirstPageLabelArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Global data (global) */
export type GlobalRecordGoToPageLabelArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Global data (global) */
export type GlobalRecordLanguagesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Global data (global) */
export type GlobalRecordLastPageLabelArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Global data (global) */
export type GlobalRecordLoadMoreNewsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Global data (global) */
export type GlobalRecordLoadMoreReportsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Global data (global) */
export type GlobalRecordLoadingArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Global data (global) */
export type GlobalRecordLocalWebLabelArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Global data (global) */
export type GlobalRecordMenuArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Global data (global) */
export type GlobalRecordMoreNewsCtaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Global data (global) */
export type GlobalRecordMoreNewsHeaderArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Global data (global) */
export type GlobalRecordMoreReportsCtaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Global data (global) */
export type GlobalRecordNextLabelArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Global data (global) */
export type GlobalRecordNextPageLabelArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Global data (global) */
export type GlobalRecordNoSearchResultsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Global data (global) */
export type GlobalRecordPartnerPortalLabelArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Global data (global) */
export type GlobalRecordPartnerPortalUrlArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Global data (global) */
export type GlobalRecordPlayArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Global data (global) */
export type GlobalRecordPreviousLabelArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Global data (global) */
export type GlobalRecordPreviousPageLabelArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Global data (global) */
export type GlobalRecordSearchBoxPlaceholderArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Global data (global) */
export type GlobalRecordSearchIconLabelArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Global data (global) */
export type GlobalRecordSearchResultCountArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Global data (global) */
export type GlobalRecordSearchResultsPageTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Global data (global) */
export type GlobalRecordShopLinkTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Global data (global) */
export type GlobalRecordShowMoreJobsLabelArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Global data (global) */
export type GlobalRecordSliderNavigationLabelArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Global data (global) */
export type GlobalRecordViewAllButtonLabelArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Global data (global) */
export type GlobalRecordViewOnMapLabelArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

export type GlobalSeoField = {
  __typename?: 'GlobalSeoField';
  facebookPageUrl?: Maybe<Scalars['String']['output']>;
  fallbackSeo?: Maybe<SeoField>;
  siteName?: Maybe<Scalars['String']['output']>;
  titleSuffix?: Maybe<Scalars['String']['output']>;
  twitterAccount?: Maybe<Scalars['String']['output']>;
};

export type GridContainerBlockModelContentField =
  | GridFourcolBlockRecord
  | GridThreecolBlockRecord
  | GridTwocolBlockRecord;

/** Block of type 🔢 Grid Container Block (grid_container_block) */
export type GridContainerBlockRecord = RecordInterface & {
  __typename?: 'GridContainerBlockRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  backgroundColor?: Maybe<ColorField>;
  content: Array<GridContainerBlockModelContentField>;
  createdAt: Scalars['DateTime']['output'];
  fullwidth?: Maybe<Scalars['BooleanType']['output']>;
  gap?: Maybe<Scalars['BooleanType']['output']>;
  id: Scalars['ItemId']['output'];
  textColor?: Maybe<ColorField>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Block of type 🔢 Grid Container Block (grid_container_block) */
export type GridContainerBlockRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type GridFourcolBlockModelContentField =
  | ImageRecord
  | MediaWithCaptionRecord
  | TextBlockRecord;

/** Block of type 4️⃣ Grid Row 4 Columns (grid_fourcol_block) */
export type GridFourcolBlockRecord = RecordInterface & {
  __typename?: 'GridFourcolBlockRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  content: Array<GridFourcolBlockModelContentField>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Block of type 4️⃣ Grid Row 4 Columns (grid_fourcol_block) */
export type GridFourcolBlockRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type GridThreecolBlockModelContentField =
  | GridTwocolBlockRecord
  | ImageRecord
  | MediaWithCaptionRecord
  | TextBlockRecord;

/** Block of type 3️⃣ Grid Row 3 Columns (grid_threecol_block) */
export type GridThreecolBlockRecord = RecordInterface & {
  __typename?: 'GridThreecolBlockRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  content: Array<GridThreecolBlockModelContentField>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Block of type 3️⃣ Grid Row 3 Columns (grid_threecol_block) */
export type GridThreecolBlockRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type GridTwocolBlockModelContentField =
  | ImageRecord
  | MediaWithCaptionRecord
  | NewsListBlockRecord
  | ReportsListBlockRecord
  | TextBlockRecord;

/** Block of type 2️⃣ Grid Row 2 Columns (grid_twocol_block) */
export type GridTwocolBlockRecord = RecordInterface & {
  __typename?: 'GridTwocolBlockRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  content: Array<GridTwocolBlockModelContentField>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Block of type 2️⃣ Grid Row 2 Columns (grid_twocol_block) */
export type GridTwocolBlockRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Hero Block (hero_block) */
export type HeroBlockRecord = RecordInterface & {
  __typename?: 'HeroBlockRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  boxColor?: Maybe<ColorField>;
  createdAt: Scalars['DateTime']['output'];
  ctaButtons: Array<CtaButtonRecord>;
  ctaText?: Maybe<Scalars['String']['output']>;
  ctaUrl?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  fullWidth?: Maybe<Scalars['BooleanType']['output']>;
  id: Scalars['ItemId']['output'];
  image?: Maybe<FileField>;
  imageOverlay?: Maybe<OverlayRecord>;
  textColor?: Maybe<ColorField>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  video?: Maybe<FileField>;
};

/** Block of type Hero Block (hero_block) */
export type HeroBlockRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Hero Block (hero_block) */
export type HeroBlockRecordDescriptionArgs = {
  markdown?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Block of type Icon link (icon_link) */
export type IconLinkRecord = RecordInterface & {
  __typename?: 'IconLinkRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  icon?: Maybe<FileField>;
  id: Scalars['ItemId']['output'];
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

/** Block of type Icon link (icon_link) */
export type IconLinkRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type IconLinkRecordListListNonNullMultiLocaleField = {
  __typename?: 'IconLinkRecordListListNonNullMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value: Array<IconLinkRecord>;
};

/** Block of type Image Block (image) */
export type ImageRecord = RecordInterface & {
  __typename?: 'ImageRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  fullWidth?: Maybe<Scalars['BooleanType']['output']>;
  id: Scalars['ItemId']['output'];
  image?: Maybe<FileField>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Block of type Image Block (image) */
export type ImageRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type ImgixParams = {
  /**
   * Aspect Ratio
   *
   * Specifies an aspect ratio to maintain when resizing and cropping the image
   *
   * Depends on: `fit=crop`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/aspect-ratio)
   */
  ar?: InputMaybe<Scalars['String']['input']>;
  /**
   * Automatic
   *
   * Applies automatic enhancements to images.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/automatic)
   */
  auto?: InputMaybe<Array<ImgixParamsAuto>>;
  /**
   * Background Color
   *
   * Colors the background of padded and partially-transparent images.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/background-color)
   */
  bg?: InputMaybe<Scalars['String']['input']>;
  /**
   * Background Removal
   *
   * Removes background from image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/background/background-removal)
   */
  bgRemove?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Background Removal Fallback
   *
   * Overrides default fallback behavior for bg-remove failures.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/background/background-removal-fallback)
   */
  bgRemoveFallback?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Background Removal Foreground Type
   *
   * Specifies the image foreground type for background removal.
   *
   * Depends on: `bg-remove=true`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/background/background-removal-foreground-type)
   */
  bgRemoveFgType?: InputMaybe<Array<ImgixParamsBgRemoveFgType>>;
  /**
   * Background Removal Semi Transparency
   *
   * Enables background removal while retaining semi-transparent areas.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/background/background-removal-semi-transparency)
   */
  bgRemoveSemiTransparency?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Background Replacement
   *
   * Replaces background from image using a string based prompt.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/background/background-replacement)
   */
  bgReplace?: InputMaybe<Scalars['String']['input']>;
  /**
   * Background Replace Fallback
   *
   * Overrides default fallback behavior for bg-replace failures.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/background/background-replace-fallback)
   */
  bgReplaceFallback?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Background Replacement Negative Prompt
   *
   * Provides a negative text suggestion for background replacement.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/background/background-replacement-negative-prompt)
   */
  bgReplaceNegPrompt?: InputMaybe<Scalars['String']['input']>;
  /**
   * Blend
   *
   * Specifies the location of the blend image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend)
   */
  blend?: InputMaybe<Scalars['String']['input']>;
  /**
   * Blend Align
   *
   * Changes the blend alignment relative to the parent image.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-align)
   */
  blendAlign?: InputMaybe<Array<ImgixParamsBlendAlign>>;
  /**
   * Blend Alpha
   *
   * Changes the alpha of the blend image.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-alpha)
   */
  blendAlpha?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Blend Color
   *
   * Specifies a color to use when applying the blend.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-color)
   */
  blendColor?: InputMaybe<Scalars['String']['input']>;
  /**
   * Blend Crop
   *
   * Specifies the type of crop for blend images.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-crop)
   */
  blendCrop?: InputMaybe<Array<ImgixParamsBlendCrop>>;
  /**
   * Blend Fit
   *
   * Specifies the fit mode for blend images.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-fit)
   */
  blendFit?: InputMaybe<ImgixParamsBlendFit>;
  /**
   * Blend Height
   *
   * Adjusts the height of the blend image.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-height)
   */
  blendH?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Blend Mode
   *
   * Sets the blend mode for a blend image.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-mode)
   */
  blendMode?: InputMaybe<ImgixParamsBlendMode>;
  /**
   * Blend Padding
   *
   * Applies padding to the blend image.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-padding)
   */
  blendPad?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Blend Size
   *
   * Adjusts the size of the blend image.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-size)
   */
  blendSize?: InputMaybe<ImgixParamsBlendSize>;
  /**
   * Blend Width
   *
   * Adjusts the width of the blend image.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-width)
   */
  blendW?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Blend X Position
   *
   * Adjusts the x-offset of the blend image relative to its parent.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-x-position)
   */
  blendX?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Blend Y Position
   *
   * Adjusts the y-offset of the blend image relative to its parent.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-y-position)
   */
  blendY?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Gaussian Blur
   *
   * Applies a gaussian blur to an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/stylize/gaussian-blur)
   */
  blur?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Border Size & Color
   *
   * Applies a border to an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size)
   */
  border?: InputMaybe<Scalars['String']['input']>;
  /**
   * Border Bottom
   *
   * Sets bottom border of an image.
   *
   * Depends on: `border`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/border-bottom)
   */
  borderBottom?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Border Left
   *
   * Sets left border of an image.
   *
   * Depends on: `border`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/border-left)
   */
  borderLeft?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Outer Border Radius
   *
   * Sets the outer radius of the image's border in pixels.
   *
   * Depends on: `border`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/outer-border-radius)
   */
  borderRadius?: InputMaybe<Scalars['String']['input']>;
  /**
   * Inner Border Radius
   *
   * Sets the inner radius of the image's border in pixels.
   *
   * Depends on: `border`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/inner-border-radius)
   */
  borderRadiusInner?: InputMaybe<Scalars['String']['input']>;
  /**
   * Border Right
   *
   * Sets right border of an image.
   *
   * Depends on: `border`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/border-right)
   */
  borderRight?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Border Top
   *
   * Sets top border of an image.
   *
   * Depends on: `border`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/border-top)
   */
  borderTop?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Brightness
   *
   * Adjusts the brightness of the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/brightness)
   */
  bri?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Client Hints
   *
   * Sets one or more Client-Hints headers
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/client-hints)
   */
  ch?: InputMaybe<Array<ImgixParamsCh>>;
  /**
   * Chroma Subsampling
   *
   * Specifies the output chroma subsampling rate.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/chroma-subsampling)
   */
  chromasub?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Color Quantization
   *
   * Limits the number of unique colors in an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/color-quantization)
   */
  colorquant?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Palette Color Count
   *
   * Specifies how many colors to include in a palette-extraction response.
   *
   * Depends on: `palette`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/color-palette/palette-color-count)
   */
  colors?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Contrast
   *
   * Adjusts the contrast of the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/contrast)
   */
  con?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Mask Corner Radius
   *
   * Specifies the radius value for a rounded corner mask.
   *
   * Depends on: `mask=corners`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/mask-image/mask-corner-radius)
   */
  cornerRadius?: InputMaybe<Scalars['String']['input']>;
  /**
   * Crop Mode
   *
   * Specifies how to crop an image.
   *
   * Depends on: `fit=crop`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/crop-mode)
   */
  crop?: InputMaybe<Array<ImgixParamsCrop>>;
  /**
   * Color Space
   *
   * Specifies the color space of the output image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/color-space)
   */
  cs?: InputMaybe<ImgixParamsCs>;
  /**
   * Download
   *
   * Forces a URL to use send-file in its response.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/download)
   */
  dl?: InputMaybe<Scalars['String']['input']>;
  /**
   * Dots Per Inch
   *
   * Sets the DPI value in the EXIF header.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/dots-per-inch)
   */
  dpi?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Device Pixel Ratio
   *
   * Adjusts the device-pixel ratio of the output image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/device-pixel-ratio)
   */
  dpr?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Duotone
   *
   * Applies a duotone effect to the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/stylize/duotone)
   */
  duotone?: InputMaybe<Scalars['String']['input']>;
  /**
   * Duotone Alpha
   *
   * Changes the alpha of the duotone effect atop the source image.
   *
   * Depends on: `duotone`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/stylize/duotone-alpha)
   */
  duotoneAlpha?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Exposure
   *
   * Adjusts the exposure of the output image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/exposure)
   */
  exp?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Url Expiration Timestamp
   *
   * A Unix timestamp specifying a UTC time. Requests made to this URL after that time will output a 404 status code.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/expiration)
   */
  expires?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Face Blur
   *
   * Specifies the amount of blur to apply to detected faces. Defaults to 0.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/face-detection/face-blur)
   */
  faceBlur?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Face Pixelation
   *
   * Specifies the pixelation amount of the face.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/face-detection/face-pixelation)
   */
  facePixel?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Face Index
   *
   * Selects a face to crop to.
   *
   * Depends on: `fit=facearea`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/face-detection/face-index)
   */
  faceindex?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Face Padding
   *
   * Adjusts padding around a selected face.
   *
   * Depends on: `fit=facearea`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/face-detection/face-padding)
   */
  facepad?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Json Face Data
   *
   * Specifies that face data should be included in output when combined with `fm=json`.
   *
   * Depends on: `fm=json`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/face-detection/json-face-data)
   */
  faces?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Fill Mode
   *
   * Determines how to fill in additional space created by the fit setting
   *
   * Depends on: `fit`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-mode)
   */
  fill?: InputMaybe<ImgixParamsFill>;
  /**
   * Fill Color
   *
   * Sets the fill color for images with additional space created by the fit setting
   *
   * Depends on: `fill=solid`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-color)
   */
  fillColor?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fill Generative Fallback
   *
   * Sets the fallback behavior for generative fill.
   *
   * Depends on: `fit=fill`, `fill=gen`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-generative-fallback)
   */
  fillGenFallback?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Fill Generative Negative Prompt
   *
   * Provides a negative text suggestion to the generative fill parameter. Used to reduce the probability of a subject, detail, or object appearing in generative output.
   *
   * Depends on: `fit=fill`, `fill=gen`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-generative-negative-prompt)
   */
  fillGenNegPrompt?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fill Generative Position
   *
   * Sets the position of the Origin Image in relation to the generative fill.
   *
   * Depends on: `fit=fill`, `fill=gen`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-generative-position)
   */
  fillGenPos?: InputMaybe<Array<ImgixParamsFillGenPos>>;
  /**
   * Fill Generative Prompt
   *
   * Provides a text suggestion to the generative fill parameter.
   *
   * Depends on: `fit=fill`, `fill=gen`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-generative-prompt)
   */
  fillGenPrompt?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fill Generative Seed
   *
   * Sets the generative seed value. Used to generate similar outputs from different prompts.
   *
   * Depends on: `fit=fill`, `fill=gen`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-generative-seed)
   */
  fillGenSeed?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Fill Gradient Color Space
   *
   * Defines the color space as linear, sRGB, Oklab, HSL, or LCH for gradient color interpolation
   *
   * Depends on: `fit=fill`, `fill=gradient`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-gradient-color-space)
   */
  fillGradientCs?: InputMaybe<ImgixParamsFillGradientCs>;
  /**
   * Fill Gradient Linear
   *
   * Blends a gradient between two colors, {color1} and {color2}, along a straight path
   *
   * Depends on: `fit=fill`, `fill=gradient`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-gradient-linear)
   */
  fillGradientLinear?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fill Gradient Linear Direction
   *
   * The fill-gradient-linear-direction specifies the gradient's direction, flowing towards the bottom, top, right, or left
   *
   * Depends on: `fit=fill`, `fill=gen`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-gradient-linear-direction)
   */
  fillGradientLinearDirection?: InputMaybe<
    Array<ImgixParamsFillGradientLinearDirection>
  >;
  /**
   * Fill Gradient Radial
   *
   * The fill-gradient-radial parameter creates a circular gradient transitioning from a central color (Color1) to an outer color (Color2)
   *
   * Depends on: `fit=fill`, `fill=gradient`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-gradient-radial)
   */
  fillGradientRadial?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fill Gradient Radial Radius
   *
   * Parameter defines the radial gradient's radius as pixels or a percentage (0.0-1.0) of the image's smallest dimension
   *
   * Depends on: `fit=fill`, `fill=gradient`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-gradient-radial-radius)
   */
  fillGradientRadialRadius?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fill Gradient Radial X
   *
   * Specifies the location of the radial gradient's center along the x-axis, using either a pixel value or a floating point percentage (ranging from 0.0 to 1.0) of the image's width
   *
   * Depends on: `fit=fill`, `fill=gradient`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-gradient-radial-x)
   */
  fillGradientRadialX?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Fill Gradient Radial Y
   *
   * Parameter sets the radial gradient's center on the y-axis, using pixels or a 0.0 to 1.0 percentage of the image's height
   *
   * Depends on: `fit=fill`, `fill=gradient`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-gradient-radial-y)
   */
  fillGradientRadialY?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Fill Gradient Type
   *
   * Specifies if a gradient is radial (circular) or linear (straight)
   *
   * Depends on: `fit=fill`, `fill=gradient`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-gradient-type)
   */
  fillGradientType?: InputMaybe<ImgixParamsFillGradientType>;
  /**
   * Resize Fit Mode
   *
   * Specifies how to map the source image to the output image dimensions.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/resize-fit-mode)
   */
  fit?: InputMaybe<ImgixParamsFit>;
  /**
   * Flip Axis
   *
   * Flips an image on a specified axis.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/rotation/flip-axis)
   */
  flip?: InputMaybe<ImgixParamsFlip>;
  /**
   * Output Format
   *
   * Changes the format of the output image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/output-format)
   */
  fm?: InputMaybe<ImgixParamsFm>;
  /**
   * Focal Point Debug
   *
   * Displays crosshairs identifying the location of the set focal point
   *
   * Depends on: `fit=crop`, `crop=focalpoint`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/focal-point-crop/focal-point-debug)
   */
  fpDebug?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Focal Point X Position
   *
   * Sets the relative horizontal value for the focal point of an image
   *
   * Depends on: `fit=crop`, `crop=focalpoint`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/focal-point-crop/focal-point-x-position)
   */
  fpX?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Focal Point Y Position
   *
   * Sets the relative vertical value for the focal point of an image
   *
   * Depends on: `fit=crop`, `crop=focalpoint`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/focal-point-crop/focal-point-y-position)
   */
  fpY?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Focal Point Zoom
   *
   * Sets the relative zoom value for the focal point of an image
   *
   * Depends on: `fit=crop`, `crop=focalpoint`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/focal-point-crop/focal-point-zoom)
   */
  fpZ?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Frames Per Second
   *
   * Specifies the framerate of the generated image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/animation/frames-per-second)
   */
  fps?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Frame Selection
   *
   * Specifies the frame of an animated image to use.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/animation/frame-selection)
   */
  frame?: InputMaybe<Scalars['String']['input']>;
  /**
   * Gamma
   *
   * Adjusts the gamma of the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/gamma)
   */
  gam?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Animated Gif Quality
   *
   * Specifies the quality of the animated gif. The higher the value, the better more compression is applied.
   *
   * Depends on: `fm=gif`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/animation/animated-gif-quality)
   */
  gifQ?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Grid Colors
   *
   * Sets grid colors for the transparency checkerboard grid.
   *
   * Depends on: `transparency`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/grid-colors)
   */
  gridColors?: InputMaybe<Scalars['String']['input']>;
  /**
   * Grid Size
   *
   * Sets grid size for the transparency checkerboard grid.
   *
   * Depends on: `transparency`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/grid-size)
   */
  gridSize?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Image Height
   *
   * Adjusts the height of the output image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/image-height)
   */
  h?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Highlight
   *
   * Adjusts the highlights of the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/highlight)
   */
  high?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Halftone
   *
   * Applies a half-tone effect to the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/stylize/halftone)
   */
  htn?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Hue Shift
   *
   * Adjusts the hue of the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/hue-shift)
   */
  hue?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Frame Interval
   *
   * Displays every Nth frame starting with the first frame.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/animation/frame-interval)
   */
  interval?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Invert
   *
   * Inverts the colors on the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/invert)
   */
  invert?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Iptc Passthrough
   *
   * Determine if IPTC data should be passed for JPEG images.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/iptc-passthrough)
   */
  iptc?: InputMaybe<ImgixParamsIptc>;
  /**
   * Jpg Progressive
   *
   * Specifies whether or not a jpg/jpeg uses progressive (true) or baseline (false)
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/jpg-progressive)
   */
  jpgProgressive?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Animation Loop Count
   *
   * Specifies the number of times an animated image should repeat. A value of 0 means infinite looping.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/animation)
   */
  loop?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Lossless Compression
   *
   * Specifies that the output image should be a lossless variant.
   *
   * Depends on: `fm=webp`, `fm=jxr`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/lossless-compression)
   */
  lossless?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * License Plate Blur
   *
   * Specifies the amount of blur to apply to detected license plates. Defaults to 0.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/license-plate-detection/license-plate-blur)
   */
  lpBlur?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Watermark Image Url
   *
   * Specifies the location of the watermark image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-image-url)
   */
  mark?: InputMaybe<Scalars['String']['input']>;
  /**
   * Watermark Alignment Mode
   *
   * Changes the watermark alignment relative to the parent image.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-alignment-mode)
   */
  markAlign?: InputMaybe<Array<ImgixParamsMarkAlign>>;
  /**
   * Watermark Alpha
   *
   * Changes the alpha of the watermark image.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-alpha)
   */
  markAlpha?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Watermark Base Url
   *
   * Changes base URL of the watermark image.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-base-url)
   */
  markBase?: InputMaybe<Scalars['String']['input']>;
  /**
   * Watermark Fit Mode
   *
   * Specifies the fit mode for watermark images.
   *
   * Depends on: `mark`, `markw`, `markh`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-fit-mode)
   */
  markFit?: InputMaybe<ImgixParamsMarkFit>;
  /**
   * Watermark Height
   *
   * Adjusts the height of the watermark image.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-height)
   */
  markH?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Watermark If Minimum Height
   *
   * Displays the watermark if rendered base image pixel height is equal to or larger than the supplied value
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-if-minimum-height)
   */
  markIfMinHeight?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Watermark If Minimum Width
   *
   * Displays the watermark if rendered base image pixel width is equal to or larger than the supplied value
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-if-minimum-width)
   */
  markIfMinWidth?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Watermark Padding
   *
   * Applies padding to the watermark image.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-padding)
   */
  markPad?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Watermark Rotation
   *
   * Rotates a watermark or tiled watermarks by a specified number of degrees.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-rotation)
   */
  markRot?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Watermark Scale
   *
   * Adjusts the scale of the watermark image.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-scale)
   */
  markScale?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Watermark Tile
   *
   * Adds tiled watermark.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-tile)
   */
  markTile?: InputMaybe<ImgixParamsMarkTile>;
  /**
   * Watermark Width
   *
   * Adjusts the width of the watermark image.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-width)
   */
  markW?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Watermark X Position
   *
   * Adjusts the x-offset of the watermark image relative to its parent.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-x-position)
   */
  markX?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Watermark Y Position
   *
   * Adjusts the y-offset of the watermark image relative to its parent.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-y-position)
   */
  markY?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Mask Type
   *
   * Defines the type of mask and specifies the URL if that type is selected.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/mask-image/mask-type)
   */
  mask?: InputMaybe<Scalars['String']['input']>;
  /**
   * Mask Background Color
   *
   * Colors the background of the transparent mask area of images
   *
   * Depends on: `mask`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/mask-image/mask-background-color)
   */
  maskBg?: InputMaybe<Scalars['String']['input']>;
  /**
   * Maximum Height
   *
   * Specifies the maximum height of the output image in pixels.
   *
   * Depends on: `fit=crop`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/maximum-height)
   */
  maxH?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Maximum Width
   *
   * Specifies the maximum width of the output image in pixels.
   *
   * Depends on: `fit=crop`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/maximum-width)
   */
  maxW?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Minimum Height
   *
   * Specifies the minimum height of the output image in pixels.
   *
   * Depends on: `fit=crop`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/minimum-height)
   */
  minH?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Minimum Width
   *
   * Specifies the minimum width of the output image in pixels.
   *
   * Depends on: `fit=crop`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/minimum-width)
   */
  minW?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Monochrome
   *
   * Applies a monochrome effect to the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/stylize/monochrome)
   */
  monochrome?: InputMaybe<Scalars['String']['input']>;
  /**
   * Noise Reduction Bound
   *
   * Reduces the noise in an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/noise-reduction/noise-reduction-bound)
   */
  nr?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Noise Reduction Sharpen
   *
   * Provides a threshold by which to sharpen an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/noise-reduction/noise-reduction-sharpen)
   */
  nrs?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Object Removal Negative Prompt
   *
   * Provides a negative text suggestion to object-removal-prompt. Used to reduce the probability of a subject, detail, or object appearing in generative output.
   *
   * Depends on: `object-removal-rect`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/object-manipulation/object-removal-negative-prompt)
   */
  objectRemovalNegativePrompt?: InputMaybe<Scalars['String']['input']>;
  /**
   * Object Removal Prompt
   *
   * Suggest auto generative fill for the object-removal-rect parameter
   *
   * Depends on: `object-removal-rect`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/object-manipulation/object-removal-prompt)
   */
  objectRemovalPrompt?: InputMaybe<Scalars['String']['input']>;
  /**
   * Object Removal
   *
   * Using a specified rectangle, an object is removed from the image
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/object-manipulation/object-removal)
   */
  objectRemovalRect?: InputMaybe<Scalars['String']['input']>;
  /**
   * Object Removal Seed
   *
   * Sets the generative seed value for object-removal. Used to generate new outputs from the same prompt
   *
   * Depends on: `object-removal-rect`, `object-removal-prompt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/object-manipulation/object-removal-seed)
   */
  objectRemovalSeed?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Orientation
   *
   * Changes the image orientation.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/rotation/orientation)
   */
  orient?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Padding
   *
   * Pads an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/padding)
   */
  pad?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Padding Bottom
   *
   * Sets bottom padding of an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/padding-bottom)
   */
  padBottom?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Padding Left
   *
   * Sets left padding of an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/padding-left)
   */
  padLeft?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Padding Right
   *
   * Sets right padding of an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/padding-right)
   */
  padRight?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Padding Top
   *
   * Sets top padding of an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/padding-top)
   */
  padTop?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Pdf Page Number
   *
   * Selects a page from a PDF for display.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/pdf/pdf-page-number)
   */
  page?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Color Palette Extraction
   *
   * Specifies an output format for palette-extraction.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/color-palette/color-palette-extraction)
   */
  palette?: InputMaybe<ImgixParamsPalette>;
  /**
   * Pdf Annotation
   *
   * Enables or disables PDF annotation.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/pdf/pdf-annotation)
   */
  pdfAnnotation?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Css Prefix
   *
   * Specifies a CSS prefix for all classes in palette-extraction.
   *
   * Depends on: `palette=css`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/color-palette/css-prefix)
   */
  prefix?: InputMaybe<Scalars['String']['input']>;
  /**
   * Pixellate
   *
   * Applies a pixelation effect to an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/stylize/pixellate)
   */
  px?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Output Quality
   *
   * Adjusts the quality of an output image.
   *
   * Depends on: `fm=avif`, `fm=jpg`, `fm=pjpg`, `fm=webp`, `fm=jxr`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/output-quality)
   */
  q?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Rasterize Bypass
   *
   * Bypasses all rendering parameters (including default parameters) and serves the original image. Works for svg+xml,x-eps,pdf, and vnd.adobe.illustrator.
   */
  rasterizeBypass?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Source Rectangle Region
   *
   * Crops an image to a specified rectangle.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/source-rectangle-region)
   */
  rect?: InputMaybe<Scalars['String']['input']>;
  /**
   * Reverse
   *
   * Reverses the frame order on the source animation.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/animation/reverse)
   */
  reverse?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Rotation
   *
   * Rotates an image by a specified number of degrees.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/rotation/rotation)
   */
  rot?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Rotation Type
   *
   * Changes the rotation type.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/rotation/rotation-type)
   */
  rotType?: InputMaybe<ImgixParamsRotType>;
  /**
   * Saturation
   *
   * Adjusts the saturation of an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/saturation)
   */
  sat?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Sepia Tone
   *
   * Applies a sepia effect to an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/stylize/sepia-tone)
   */
  sepia?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Shadow
   *
   * Adjusts the highlights of the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/shadow)
   */
  shad?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Sharpen
   *
   * Adjusts the sharpness of the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/sharpen)
   */
  sharp?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Frame Skip
   *
   * Skips every Nth frame starting with the first frame.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/animation/frame-skip)
   */
  skip?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Bypasses any [DatoCMS Automatic Image Optimization](https://www.datocms.com/docs/cdn-settings/advanced-asset-settings) that might be set up for the project.
   *
   * Exercise caution when using this parameter, as it could significantly increase your bandwidth costs.
   */
  skipDefaultOptimizations?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Sanitize Svg
   *
   * Specifies whether to sanitize an SVG.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/sanitize-svg)
   */
  svgSanitize?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Transparency
   *
   * Adds checkerboard behind images which support transparency.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/transparency)
   */
  transparency?: InputMaybe<ImgixParamsTransparency>;
  /**
   * Trim Image
   *
   * Trims the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/trim/trim-image)
   */
  trim?: InputMaybe<ImgixParamsTrim>;
  /**
   * Trim Alpha
   *
   * Specifies a trim alpha on a trim operation.
   *
   * Depends on: `trim=alpha`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/trim/trim-alpha)
   */
  trimAlpha?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Trim Color
   *
   * Specifies a trim color on a trim operation.
   *
   * Depends on: `trim=color`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/trim/trim-color)
   */
  trimColor?: InputMaybe<Scalars['String']['input']>;
  /**
   * Trim Mean Difference
   *
   * Specifies the mean difference on a trim operation.
   *
   * Depends on: `trim=auto`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/trim/trim-mean-difference)
   */
  trimMd?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Trim Padding
   *
   * Pads the area of the source image before trimming.
   *
   * Depends on: `trim`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/trim/trim-padding)
   */
  trimPad?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Trim Standard Deviation
   *
   * Specifies the standard deviation on a trim operation.
   *
   * Depends on: `trim=auto`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/trim/trim-standard-deviation)
   */
  trimSd?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Trim Tolerance
   *
   * Specifies the tolerance on a trim operation.
   *
   * Depends on: `trim=color`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/trim/trim-tolerance)
   */
  trimTol?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Text String
   *
   * Sets the text string to render.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-string)
   */
  txt?: InputMaybe<Scalars['String']['input']>;
  /**
   * Text Align
   *
   * Sets the vertical and horizontal alignment of rendered text relative to the base image.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-align)
   */
  txtAlign?: InputMaybe<Array<ImgixParamsTxtAlign>>;
  /**
   * Text Clipping Mode
   *
   * Sets the clipping properties of rendered text.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-clipping-mode)
   */
  txtClip?: InputMaybe<Array<ImgixParamsTxtClip>>;
  /**
   * Text Color
   *
   * Specifies the color of rendered text.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-color)
   */
  txtColor?: InputMaybe<Scalars['String']['input']>;
  /**
   * Text Fit Mode
   *
   * Specifies the fit approach for rendered text.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-fit-mode)
   */
  txtFit?: InputMaybe<ImgixParamsTxtFit>;
  /**
   * Text Font
   *
   * Selects a font for rendered text.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-font)
   */
  txtFont?: InputMaybe<Scalars['String']['input']>;
  /**
   * Text Leading
   *
   * Sets the leading (line spacing) for rendered text. Only works on the multi-line text endpoint.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/typesetting-endpoint/text-leading)
   */
  txtLead?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Text Outline
   *
   * Outlines the rendered text with a specified color.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-outline)
   */
  txtLine?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Text Outline Color
   *
   * Specifies a text outline color.
   *
   * Depends on: `txt`, `txtline`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-outline-color)
   */
  txtLineColor?: InputMaybe<Scalars['String']['input']>;
  /**
   * Text Padding
   *
   * Specifies the padding (in device-independent pixels) between a textbox and the edges of the base image.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-padding)
   */
  txtPad?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Text Shadow
   *
   * Applies a shadow to rendered text.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-shadow)
   */
  txtShad?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Text Font Size
   *
   * Sets the font size of rendered text.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-font-size)
   */
  txtSize?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Text Tracking
   *
   * Sets the tracking (letter spacing) for rendered text. Only works on the multi-line text endpoint.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/typesetting-endpoint/text-tracking)
   */
  txtTrack?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Text Width
   *
   * Sets the width of rendered text.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-width)
   */
  txtWidth?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Text X Position
   *
   * Sets the horizontal (x) position of the text in pixels relative to the left edge of the base image.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-x-position)
   */
  txtX?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Text Y Position
   *
   * Sets the vertical (y) position of the text in pixels relative to the top edge of the base image.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-y-position)
   */
  txtY?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Super Resolution
   *
   * Uses generative AI fill to upscale low resolution images.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/super-resolution)
   */
  upscale?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Super Resolution Fallback
   *
   * Overrides default fallback behavior for super resolution failures
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/super-resolution)
   */
  upscaleFallback?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Unsharp Mask
   *
   * Sharpens the source image using an unsharp mask.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/unsharp-mask)
   */
  usm?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Unsharp Mask Radius
   *
   * Specifies the radius for an unsharp mask operation.
   *
   * Depends on: `usm`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/unsharp-mask-radius)
   */
  usmrad?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Vibrance
   *
   * Adjusts the vibrance of an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/vibrance)
   */
  vib?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Image Width
   *
   * Adjusts the width of the output image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/image-width)
   */
  w?: InputMaybe<Scalars['FloatType']['input']>;
};

export enum ImgixParamsAuto {
  Compress = 'compress',
  Enhance = 'enhance',
  Format = 'format',
  Redeye = 'redeye',
}

export enum ImgixParamsBgRemoveFgType {
  Auto = 'auto',
  Car = 'car',
}

export enum ImgixParamsBlendAlign {
  Bottom = 'bottom',
  Center = 'center',
  Left = 'left',
  Middle = 'middle',
  Right = 'right',
  Top = 'top',
}

export enum ImgixParamsBlendCrop {
  Bottom = 'bottom',
  Faces = 'faces',
  Left = 'left',
  Right = 'right',
  Top = 'top',
}

export enum ImgixParamsBlendFit {
  Clamp = 'clamp',
  Clip = 'clip',
  Crop = 'crop',
  Max = 'max',
  Scale = 'scale',
}

export enum ImgixParamsBlendMode {
  Burn = 'burn',
  Color = 'color',
  Darken = 'darken',
  Difference = 'difference',
  Dodge = 'dodge',
  Exclusion = 'exclusion',
  Hardlight = 'hardlight',
  Hue = 'hue',
  Lighten = 'lighten',
  Luminosity = 'luminosity',
  Multiply = 'multiply',
  Normal = 'normal',
  Overlay = 'overlay',
  Saturation = 'saturation',
  Screen = 'screen',
  Softlight = 'softlight',
}

export enum ImgixParamsBlendSize {
  Inherit = 'inherit',
}

export enum ImgixParamsCh {
  Dpr = 'dpr',
  SaveData = 'saveData',
  Width = 'width',
}

export enum ImgixParamsCrop {
  Bottom = 'bottom',
  Edges = 'edges',
  Entropy = 'entropy',
  Faces = 'faces',
  Focalpoint = 'focalpoint',
  Left = 'left',
  Right = 'right',
  Top = 'top',
}

export enum ImgixParamsCs {
  Adobergb1998 = 'adobergb1998',
  Origin = 'origin',
  Srgb = 'srgb',
  Strip = 'strip',
  Tinysrgb = 'tinysrgb',
}

export enum ImgixParamsFill {
  Blur = 'blur',
  Gen = 'gen',
  Generative = 'generative',
  Gradient = 'gradient',
  Solid = 'solid',
}

export enum ImgixParamsFillGenPos {
  Bottom = 'bottom',
  Center = 'center',
  Left = 'left',
  Middle = 'middle',
  Right = 'right',
  Top = 'top',
}

export enum ImgixParamsFillGradientCs {
  Hsl = 'hsl',
  Lch = 'lch',
  Linear = 'linear',
  Oklab = 'oklab',
  Srgb = 'srgb',
}

export enum ImgixParamsFillGradientLinearDirection {
  Bottom = 'bottom',
  Left = 'left',
  Right = 'right',
  Top = 'top',
}

export enum ImgixParamsFillGradientType {
  Linear = 'linear',
  Radial = 'radial',
}

export enum ImgixParamsFit {
  Clamp = 'clamp',
  Clip = 'clip',
  Crop = 'crop',
  Facearea = 'facearea',
  Fill = 'fill',
  Fillmax = 'fillmax',
  Max = 'max',
  Min = 'min',
  Scale = 'scale',
}

export enum ImgixParamsFlip {
  H = 'h',
  Hv = 'hv',
  V = 'v',
}

export enum ImgixParamsFm {
  Avif = 'avif',
  Blurhash = 'blurhash',
  Gif = 'gif',
  Jp2 = 'jp2',
  Jpg = 'jpg',
  Json = 'json',
  Jxr = 'jxr',
  Mp4 = 'mp4',
  Pjpg = 'pjpg',
  Png = 'png',
  Png8 = 'png8',
  Png32 = 'png32',
  Webm = 'webm',
  Webp = 'webp',
}

export enum ImgixParamsIptc {
  Allow = 'allow',
  Block = 'block',
}

export enum ImgixParamsMarkAlign {
  Bottom = 'bottom',
  Center = 'center',
  Left = 'left',
  Middle = 'middle',
  Right = 'right',
  Top = 'top',
}

export enum ImgixParamsMarkFit {
  Clip = 'clip',
  Crop = 'crop',
  Fill = 'fill',
  Max = 'max',
  Scale = 'scale',
}

export enum ImgixParamsMarkTile {
  Grid = 'grid',
}

export enum ImgixParamsPalette {
  Css = 'css',
  Json = 'json',
}

export enum ImgixParamsRotType {
  Pivot = 'pivot',
  Straighten = 'straighten',
}

export enum ImgixParamsTransparency {
  Grid = 'grid',
}

export enum ImgixParamsTrim {
  Alpha = 'alpha',
  Auto = 'auto',
  Color = 'color',
}

export enum ImgixParamsTxtAlign {
  Bottom = 'bottom',
  Center = 'center',
  Left = 'left',
  Middle = 'middle',
  Right = 'right',
  Top = 'top',
}

export enum ImgixParamsTxtClip {
  Ellipsis = 'ellipsis',
  End = 'end',
  Middle = 'middle',
  Start = 'start',
}

export enum ImgixParamsTxtFit {
  Max = 'max',
}

export type ImportHistoryModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<ImportHistoryModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ImportHistoryModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  importHistory?: InputMaybe<JsonFilter>;
  position?: InputMaybe<PositionFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum ImportHistoryModelOrderBy {
  CreatedAtAsc = '_createdAt_ASC',
  CreatedAtDesc = '_createdAt_DESC',
  FirstPublishedAtAsc = '_firstPublishedAt_ASC',
  FirstPublishedAtDesc = '_firstPublishedAt_DESC',
  IsValidAsc = '_isValid_ASC',
  IsValidDesc = '_isValid_DESC',
  PublicationScheduledAtAsc = '_publicationScheduledAt_ASC',
  PublicationScheduledAtDesc = '_publicationScheduledAt_DESC',
  PublishedAtAsc = '_publishedAt_ASC',
  PublishedAtDesc = '_publishedAt_DESC',
  StatusAsc = '_status_ASC',
  StatusDesc = '_status_DESC',
  UnpublishingScheduledAtAsc = '_unpublishingScheduledAt_ASC',
  UnpublishingScheduledAtDesc = '_unpublishingScheduledAt_DESC',
  UpdatedAtAsc = '_updatedAt_ASC',
  UpdatedAtDesc = '_updatedAt_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PositionAsc = 'position_ASC',
  PositionDesc = 'position_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

/** Record of type Import history (import_history) */
export type ImportHistoryRecord = RecordInterface & {
  __typename?: 'ImportHistoryRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  importHistory?: Maybe<Scalars['JsonField']['output']>;
  position?: Maybe<Scalars['IntType']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Record of type Import history (import_history) */
export type ImportHistoryRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Specifies how to filter by usage */
export type InUseFilter = {
  /** Search uploads that are currently used by some record or not */
  eq?: InputMaybe<Scalars['BooleanType']['input']>;
};

/** Specifies how to filter by ID */
export type ItemIdFilter = {
  /** Search the record with the specified ID */
  eq?: InputMaybe<Scalars['ItemId']['input']>;
  /** Search records with the specified IDs */
  in?: InputMaybe<Array<InputMaybe<Scalars['ItemId']['input']>>>;
  /** Exclude the record with the specified ID */
  neq?: InputMaybe<Scalars['ItemId']['input']>;
  /** Search records that do not have the specified IDs */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ItemId']['input']>>>;
};

export type ItemModelPageLinkField =
  | AboutUsPageRecord
  | BrandPageRecord
  | SustainabilityPageRecord;

/** Block of type Item (item) */
export type ItemRecord = RecordInterface & {
  __typename?: 'ItemRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  pageLink?: Maybe<ItemModelPageLinkField>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Block of type Item (item) */
export type ItemRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type ItemRecordListListNonNullMultiLocaleField = {
  __typename?: 'ItemRecordListListNonNullMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value: Array<ItemRecord>;
};

export enum ItemStatus {
  Draft = 'draft',
  Published = 'published',
  Updated = 'updated',
}

export type JobOpportunitiesListPageModelContentAreaField =
  | ArticlesBlockRecord
  | BrandsBlockRecord
  | BulletListRecord
  | DocumentLinkBlockRecord
  | EmployeeRecord
  | HeroBlockRecord
  | ImageRecord
  | JobsListBlockRecord
  | NewsListBlockRecord
  | OfficesBlockRecord
  | PlugBlockRecord
  | SimpleTitleAndTextBlockRecord
  | SliderBlockRecord
  | StatementBlockRecord
  | TextBlockRecord
  | TwoColumnImageAndTextRecord
  | TwoColumnTextIntroRecord
  | VideoRecord;

export type JobOpportunitiesListPageModelContentAreaFieldListListNonNullMultiLocaleField =
  {
    __typename?: 'JobOpportunitiesListPageModelContentAreaFieldListListNonNullMultiLocaleField';
    locale?: Maybe<SiteLocale>;
    value: Array<JobOpportunitiesListPageModelContentAreaField>;
  };

/** Record of type 🗂️ Jobs Index Page (job_opportunities_list_page) */
export type JobOpportunitiesListPageRecord = RecordInterface & {
  __typename?: 'JobOpportunitiesListPageRecord';
  _allContentAreaLocales?: Maybe<
    Array<JobOpportunitiesListPageModelContentAreaFieldListListNonNullMultiLocaleField>
  >;
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  contentArea: Array<JobOpportunitiesListPageModelContentAreaField>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  seo?: Maybe<SeoField>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Record of type 🗂️ Jobs Index Page (job_opportunities_list_page) */
export type JobOpportunitiesListPageRecord_AllContentAreaLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type 🗂️ Jobs Index Page (job_opportunities_list_page) */
export type JobOpportunitiesListPageRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type 🗂️ Jobs Index Page (job_opportunities_list_page) */
export type JobOpportunitiesListPageRecordContentAreaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

export type JobOpportunitiesPageModelContentAreaField =
  | ArticlesBlockRecord
  | BrandsBlockRecord
  | BulletListRecord
  | DocumentLinkBlockRecord
  | EmployeeRecord
  | HeroBlockRecord
  | ImageRecord
  | JobsListBlockRecord
  | NewsListBlockRecord
  | OfficesBlockRecord
  | PlugBlockRecord
  | SimpleTitleAndTextBlockRecord
  | SliderBlockRecord
  | StatementBlockRecord
  | TextBlockRecord
  | TwoColumnImageAndTextRecord
  | TwoColumnTextIntroRecord
  | VideoRecord;

export type JobOpportunitiesPageModelContentAreaFieldListListNonNullMultiLocaleField =
  {
    __typename?: 'JobOpportunitiesPageModelContentAreaFieldListListNonNullMultiLocaleField';
    locale?: Maybe<SiteLocale>;
    value: Array<JobOpportunitiesPageModelContentAreaField>;
  };

export type JobOpportunitiesPageModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<JobOpportunitiesPageModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<JobOpportunitiesPageModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _locales?: InputMaybe<LocalesFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  applicationDeadline?: InputMaybe<DateFilter>;
  category?: InputMaybe<StringFilter>;
  country?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  department?: InputMaybe<StringFilter>;
  id?: InputMaybe<ItemIdFilter>;
  pageName?: InputMaybe<StringFilter>;
  publishDate?: InputMaybe<DateFilter>;
  seo?: InputMaybe<SeoFilter>;
  slug?: InputMaybe<SlugFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum JobOpportunitiesPageModelOrderBy {
  CreatedAtAsc = '_createdAt_ASC',
  CreatedAtDesc = '_createdAt_DESC',
  FirstPublishedAtAsc = '_firstPublishedAt_ASC',
  FirstPublishedAtDesc = '_firstPublishedAt_DESC',
  IsValidAsc = '_isValid_ASC',
  IsValidDesc = '_isValid_DESC',
  PublicationScheduledAtAsc = '_publicationScheduledAt_ASC',
  PublicationScheduledAtDesc = '_publicationScheduledAt_DESC',
  PublishedAtAsc = '_publishedAt_ASC',
  PublishedAtDesc = '_publishedAt_DESC',
  StatusAsc = '_status_ASC',
  StatusDesc = '_status_DESC',
  UnpublishingScheduledAtAsc = '_unpublishingScheduledAt_ASC',
  UnpublishingScheduledAtDesc = '_unpublishingScheduledAt_DESC',
  UpdatedAtAsc = '_updatedAt_ASC',
  UpdatedAtDesc = '_updatedAt_DESC',
  ApplicationDeadlineAsc = 'applicationDeadline_ASC',
  ApplicationDeadlineDesc = 'applicationDeadline_DESC',
  CategoryAsc = 'category_ASC',
  CategoryDesc = 'category_DESC',
  CountryAsc = 'country_ASC',
  CountryDesc = 'country_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DepartmentAsc = 'department_ASC',
  DepartmentDesc = 'department_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PageNameAsc = 'pageName_ASC',
  PageNameDesc = 'pageName_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

/** Record of type 🧑‍💼 Job Listing (job_opportunities_page) */
export type JobOpportunitiesPageRecord = RecordInterface & {
  __typename?: 'JobOpportunitiesPageRecord';
  _allContentAreaLocales?: Maybe<
    Array<JobOpportunitiesPageModelContentAreaFieldListListNonNullMultiLocaleField>
  >;
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  applicationDeadline?: Maybe<Scalars['Date']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  contentArea: Array<JobOpportunitiesPageModelContentAreaField>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  department?: Maybe<Scalars['String']['output']>;
  id: Scalars['ItemId']['output'];
  pageName?: Maybe<Scalars['String']['output']>;
  publishDate?: Maybe<Scalars['Date']['output']>;
  seo?: Maybe<SeoField>;
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Record of type 🧑‍💼 Job Listing (job_opportunities_page) */
export type JobOpportunitiesPageRecord_AllContentAreaLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type 🧑‍💼 Job Listing (job_opportunities_page) */
export type JobOpportunitiesPageRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type 🧑‍💼 Job Listing (job_opportunities_page) */
export type JobOpportunitiesPageRecordContentAreaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type 🧑‍💼 Jobs List Block (jobs_list_block) */
export type JobsListBlockRecord = RecordInterface & {
  __typename?: 'JobsListBlockRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Block of type 🧑‍💼 Jobs List Block (jobs_list_block) */
export type JobsListBlockRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Specifies how to filter JSON fields */
export type JsonFilter = {
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
};

export type LandingPageModelContentAreaField =
  | ArticlesBlockRecord
  | BrandsBlockRecord
  | BulletListRecord
  | DocumentLinkBlockRecord
  | EmployeeRecord
  | GridContainerBlockRecord
  | HeroBlockRecord
  | ImageRecord
  | JobsListBlockRecord
  | NewsAndReportsListBlockRecord
  | NewsListBlockRecord
  | OfficesBlockRecord
  | PlugBlockRecord
  | SimpleTitleAndTextBlockRecord
  | SliderBlockRecord
  | StatementBlockRecord
  | SubheadingBlockRecord
  | SustainabilityReportsBlockRecord
  | TextBlockRecord
  | TwoColumnImageAndTextRecord
  | TwoColumnTextIntroRecord
  | VideoRecord;

export type LandingPageModelContentAreaFieldListListNonNullMultiLocaleField = {
  __typename?: 'LandingPageModelContentAreaFieldListListNonNullMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value: Array<LandingPageModelContentAreaField>;
};

/** Record of type Landing Page (landing_page) */
export type LandingPageRecord = RecordInterface & {
  __typename?: 'LandingPageRecord';
  _allContentAreaLocales?: Maybe<
    Array<LandingPageModelContentAreaFieldListListNonNullMultiLocaleField>
  >;
  _allSeoLocales?: Maybe<Array<SeoFieldMultiLocaleField>>;
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  contentArea: Array<LandingPageModelContentAreaField>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  seo?: Maybe<SeoField>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Record of type Landing Page (landing_page) */
export type LandingPageRecord_AllContentAreaLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Landing Page (landing_page) */
export type LandingPageRecord_AllSeoLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Landing Page (landing_page) */
export type LandingPageRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Landing Page (landing_page) */
export type LandingPageRecordContentAreaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Landing Page (landing_page) */
export type LandingPageRecordSeoArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

export type LanguageModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<LanguageModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<LanguageModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  flag?: InputMaybe<StringFilter>;
  id?: InputMaybe<ItemIdFilter>;
  name?: InputMaybe<StringFilter>;
  symbol?: InputMaybe<FileFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
  url?: InputMaybe<StringFilter>;
};

export enum LanguageModelOrderBy {
  CreatedAtAsc = '_createdAt_ASC',
  CreatedAtDesc = '_createdAt_DESC',
  FirstPublishedAtAsc = '_firstPublishedAt_ASC',
  FirstPublishedAtDesc = '_firstPublishedAt_DESC',
  IsValidAsc = '_isValid_ASC',
  IsValidDesc = '_isValid_DESC',
  PublicationScheduledAtAsc = '_publicationScheduledAt_ASC',
  PublicationScheduledAtDesc = '_publicationScheduledAt_DESC',
  PublishedAtAsc = '_publishedAt_ASC',
  PublishedAtDesc = '_publishedAt_DESC',
  StatusAsc = '_status_ASC',
  StatusDesc = '_status_DESC',
  UnpublishingScheduledAtAsc = '_unpublishingScheduledAt_ASC',
  UnpublishingScheduledAtDesc = '_unpublishingScheduledAt_DESC',
  UpdatedAtAsc = '_updatedAt_ASC',
  UpdatedAtDesc = '_updatedAt_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  FlagAsc = 'flag_ASC',
  FlagDesc = 'flag_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC',
}

/** Record of type Language (language) */
export type LanguageRecord = RecordInterface & {
  __typename?: 'LanguageRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  flag?: Maybe<Scalars['String']['output']>;
  id: Scalars['ItemId']['output'];
  name?: Maybe<Scalars['String']['output']>;
  symbol?: Maybe<FileField>;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

/** Record of type Language (language) */
export type LanguageRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type LanguageRecordListListNonNullMultiLocaleField = {
  __typename?: 'LanguageRecordListListNonNullMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value: Array<LanguageRecord>;
};

/** Block of type Link (link) */
export type LinkRecord = RecordInterface & {
  __typename?: 'LinkRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

/** Block of type Link (link) */
export type LinkRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type LinkRecordListListNonNullMultiLocaleField = {
  __typename?: 'LinkRecordListListNonNullMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value: Array<LinkRecord>;
};

/** Specifies how to filter by locale */
export type LocalesFilter = {
  /** Filter records that are localized in all the specified locales */
  allIn?: InputMaybe<Array<SiteLocale>>;
  /** Filter records that are localized in at least one of the specified locales */
  anyIn?: InputMaybe<Array<SiteLocale>>;
  /** Filter records that are not localized in any of the specified locales */
  notIn?: InputMaybe<Array<SiteLocale>>;
};

/** Block of type Media with Caption (media_with_caption) */
export type MediaWithCaptionRecord = RecordInterface & {
  __typename?: 'MediaWithCaptionRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  caption?: Maybe<TextBlockRecord>;
  centerText?: Maybe<Scalars['BooleanType']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  media?: Maybe<ImageRecord>;
  textOnImage?: Maybe<Scalars['BooleanType']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Block of type Media with Caption (media_with_caption) */
export type MediaWithCaptionRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Menu item (menu_item) */
export type MenuItemRecord = RecordInterface & {
  __typename?: 'MenuItemRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  submenu?: Maybe<SubmenuRecord>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

/** Block of type Menu item (menu_item) */
export type MenuItemRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type MenuItemRecordListListNonNullMultiLocaleField = {
  __typename?: 'MenuItemRecordListListNonNullMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value: Array<MenuItemRecord>;
};

/** Record of type Menu (menu) */
export type MenuRecord = RecordInterface & {
  __typename?: 'MenuRecord';
  _allMenuItemsLocales?: Maybe<
    Array<MenuItemRecordListListNonNullMultiLocaleField>
  >;
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  menuItems: Array<MenuItemRecord>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Record of type Menu (menu) */
export type MenuRecord_AllMenuItemsLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Menu (menu) */
export type MenuRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Menu (menu) */
export type MenuRecordMenuItemsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

export enum MuxThumbnailFormatType {
  Gif = 'gif',
  Jpg = 'jpg',
  Png = 'png',
}

/** Block of type News and Reports List Block (news_and_reports_list_block) */
export type NewsAndReportsListBlockRecord = RecordInterface & {
  __typename?: 'NewsAndReportsListBlockRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  news: Array<NewsPageRecord>;
  newsImage?: Maybe<FileField>;
  newsTitle?: Maybe<Scalars['String']['output']>;
  reports: Array<ReportsListingRecord>;
  reportsImage?: Maybe<FileField>;
  reportsTitle?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Block of type News and Reports List Block (news_and_reports_list_block) */
export type NewsAndReportsListBlockRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type 🗞️  News List Block (news_list_block) */
export type NewsListBlockRecord = RecordInterface & {
  __typename?: 'NewsListBlockRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  itemsToShow?: Maybe<Scalars['IntType']['output']>;
  largeTitle?: Maybe<Scalars['BooleanType']['output']>;
  standalone?: Maybe<Scalars['BooleanType']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Block of type 🗞️  News List Block (news_list_block) */
export type NewsListBlockRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type NewsListPageModelContentAreaField =
  | ArticlesBlockRecord
  | BrandsBlockRecord
  | BulletListRecord
  | DocumentLinkBlockRecord
  | EmployeeRecord
  | HeroBlockRecord
  | ImageRecord
  | JobsListBlockRecord
  | NewsAndReportsListBlockRecord
  | NewsListBlockRecord
  | OfficesBlockRecord
  | PlugBlockRecord
  | SimpleTitleAndTextBlockRecord
  | SliderBlockRecord
  | StatementBlockRecord
  | TextBlockRecord
  | TwoColumnImageAndTextRecord
  | TwoColumnTextIntroRecord
  | VideoRecord;

export type NewsListPageModelContentAreaFieldListListNonNullMultiLocaleField = {
  __typename?: 'NewsListPageModelContentAreaFieldListListNonNullMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value: Array<NewsListPageModelContentAreaField>;
};

/** Record of type 🗂️ News Index Page (news_list_page) */
export type NewsListPageRecord = RecordInterface & {
  __typename?: 'NewsListPageRecord';
  _allContentAreaLocales?: Maybe<
    Array<NewsListPageModelContentAreaFieldListListNonNullMultiLocaleField>
  >;
  _allSeoLocales?: Maybe<Array<SeoFieldMultiLocaleField>>;
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  contentArea: Array<NewsListPageModelContentAreaField>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  seo?: Maybe<SeoField>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Record of type 🗂️ News Index Page (news_list_page) */
export type NewsListPageRecord_AllContentAreaLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type 🗂️ News Index Page (news_list_page) */
export type NewsListPageRecord_AllSeoLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type 🗂️ News Index Page (news_list_page) */
export type NewsListPageRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type 🗂️ News Index Page (news_list_page) */
export type NewsListPageRecordContentAreaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type 🗂️ News Index Page (news_list_page) */
export type NewsListPageRecordSeoArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

export type NewsPageModelContentAreaField =
  | ArticlesBlockRecord
  | BrandsBlockRecord
  | BulletListRecord
  | DocumentLinkBlockRecord
  | EmployeeRecord
  | HeroBlockRecord
  | ImageRecord
  | JobsListBlockRecord
  | NewsAndReportsListBlockRecord
  | NewsListBlockRecord
  | OfficesBlockRecord
  | PlugBlockRecord
  | SimpleTitleAndTextBlockRecord
  | SliderBlockRecord
  | StatementBlockRecord
  | TextBlockRecord
  | TwoColumnImageAndTextRecord
  | TwoColumnTextIntroRecord
  | VideoRecord;

export type NewsPageModelContentAreaFieldListListNonNullMultiLocaleField = {
  __typename?: 'NewsPageModelContentAreaFieldListListNonNullMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value: Array<NewsPageModelContentAreaField>;
};

export type NewsPageModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<NewsPageModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<NewsPageModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _locales?: InputMaybe<LocalesFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  category?: InputMaybe<StringFilter>;
  country?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  image?: InputMaybe<FileFilter>;
  pageName?: InputMaybe<StringFilter>;
  publishDate?: InputMaybe<DateFilter>;
  seo?: InputMaybe<SeoFilter>;
  slug?: InputMaybe<SlugFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum NewsPageModelOrderBy {
  CreatedAtAsc = '_createdAt_ASC',
  CreatedAtDesc = '_createdAt_DESC',
  FirstPublishedAtAsc = '_firstPublishedAt_ASC',
  FirstPublishedAtDesc = '_firstPublishedAt_DESC',
  IsValidAsc = '_isValid_ASC',
  IsValidDesc = '_isValid_DESC',
  PublicationScheduledAtAsc = '_publicationScheduledAt_ASC',
  PublicationScheduledAtDesc = '_publicationScheduledAt_DESC',
  PublishedAtAsc = '_publishedAt_ASC',
  PublishedAtDesc = '_publishedAt_DESC',
  StatusAsc = '_status_ASC',
  StatusDesc = '_status_DESC',
  UnpublishingScheduledAtAsc = '_unpublishingScheduledAt_ASC',
  UnpublishingScheduledAtDesc = '_unpublishingScheduledAt_DESC',
  UpdatedAtAsc = '_updatedAt_ASC',
  UpdatedAtDesc = '_updatedAt_DESC',
  CategoryAsc = 'category_ASC',
  CategoryDesc = 'category_DESC',
  CountryAsc = 'country_ASC',
  CountryDesc = 'country_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PageNameAsc = 'pageName_ASC',
  PageNameDesc = 'pageName_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

/** Record of type 📰 News Story (news_page) */
export type NewsPageRecord = RecordInterface & {
  __typename?: 'NewsPageRecord';
  _allContentAreaLocales?: Maybe<
    Array<NewsPageModelContentAreaFieldListListNonNullMultiLocaleField>
  >;
  _allSeoLocales?: Maybe<Array<SeoFieldMultiLocaleField>>;
  _allTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  category?: Maybe<Scalars['String']['output']>;
  contentArea: Array<NewsPageModelContentAreaField>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  image?: Maybe<FileField>;
  pageName?: Maybe<Scalars['String']['output']>;
  publishDate?: Maybe<Scalars['Date']['output']>;
  seo?: Maybe<SeoField>;
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Record of type 📰 News Story (news_page) */
export type NewsPageRecord_AllContentAreaLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type 📰 News Story (news_page) */
export type NewsPageRecord_AllSeoLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type 📰 News Story (news_page) */
export type NewsPageRecord_AllTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type 📰 News Story (news_page) */
export type NewsPageRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type 📰 News Story (news_page) */
export type NewsPageRecordContentAreaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type 📰 News Story (news_page) */
export type NewsPageRecordSeoArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type 📰 News Story (news_page) */
export type NewsPageRecordTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

export type OfficeModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<OfficeModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<OfficeModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _locales?: InputMaybe<LocalesFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  address?: InputMaybe<StringFilter>;
  city?: InputMaybe<StringFilter>;
  country?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  email?: InputMaybe<StringFilter>;
  id?: InputMaybe<ItemIdFilter>;
  name?: InputMaybe<StringFilter>;
  phoneNumber?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
  websiteUrl?: InputMaybe<StringFilter>;
  zipCode?: InputMaybe<StringFilter>;
};

export enum OfficeModelOrderBy {
  CreatedAtAsc = '_createdAt_ASC',
  CreatedAtDesc = '_createdAt_DESC',
  FirstPublishedAtAsc = '_firstPublishedAt_ASC',
  FirstPublishedAtDesc = '_firstPublishedAt_DESC',
  IsValidAsc = '_isValid_ASC',
  IsValidDesc = '_isValid_DESC',
  PublicationScheduledAtAsc = '_publicationScheduledAt_ASC',
  PublicationScheduledAtDesc = '_publicationScheduledAt_DESC',
  PublishedAtAsc = '_publishedAt_ASC',
  PublishedAtDesc = '_publishedAt_DESC',
  StatusAsc = '_status_ASC',
  StatusDesc = '_status_DESC',
  UnpublishingScheduledAtAsc = '_unpublishingScheduledAt_ASC',
  UnpublishingScheduledAtDesc = '_unpublishingScheduledAt_DESC',
  UpdatedAtAsc = '_updatedAt_ASC',
  UpdatedAtDesc = '_updatedAt_DESC',
  AddressAsc = 'address_ASC',
  AddressDesc = 'address_DESC',
  CityAsc = 'city_ASC',
  CityDesc = 'city_DESC',
  CountryAsc = 'country_ASC',
  CountryDesc = 'country_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  EmailAsc = 'email_ASC',
  EmailDesc = 'email_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PhoneNumberAsc = 'phoneNumber_ASC',
  PhoneNumberDesc = 'phoneNumber_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  WebsiteUrlAsc = 'websiteUrl_ASC',
  WebsiteUrlDesc = 'websiteUrl_DESC',
  ZipCodeAsc = 'zipCode_ASC',
  ZipCodeDesc = 'zipCode_DESC',
}

/** Record of type Office (office) */
export type OfficeRecord = RecordInterface & {
  __typename?: 'OfficeRecord';
  _allCountryLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allNameLocales?: Maybe<Array<StringMultiLocaleField>>;
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ItemId']['output'];
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  websiteUrl?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

/** Record of type Office (office) */
export type OfficeRecord_AllCountryLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Office (office) */
export type OfficeRecord_AllNameLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Office (office) */
export type OfficeRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Office (office) */
export type OfficeRecordCountryArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Office (office) */
export type OfficeRecordNameArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Offices Block (offices_block) */
export type OfficesBlockRecord = RecordInterface & {
  __typename?: 'OfficesBlockRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  localWebLabel?: Maybe<Scalars['String']['output']>;
  offices: Array<OfficeRecord>;
  updatedAt: Scalars['DateTime']['output'];
  viewOnMapLabel?: Maybe<Scalars['String']['output']>;
};

/** Block of type Offices Block (offices_block) */
export type OfficesBlockRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Specifies how to filter by image orientation */
export type OrientationFilter = {
  /** Search uploads with the specified orientation */
  eq?: InputMaybe<UploadOrientation>;
  /** Exclude uploads with the specified orientation */
  neq?: InputMaybe<UploadOrientation>;
};

/** Block of type Overlay (overlay) */
export type OverlayRecord = RecordInterface & {
  __typename?: 'OverlayRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  color?: Maybe<ColorField>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  opacity?: Maybe<Scalars['IntType']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Block of type Overlay (overlay) */
export type OverlayRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Page Navigation Block (page_navigation_block) */
export type PageNavigationBlockRecord = RecordInterface & {
  __typename?: 'PageNavigationBlockRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  label?: Maybe<Scalars['String']['output']>;
  links: Array<LinkRecord>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Block of type Page Navigation Block (page_navigation_block) */
export type PageNavigationBlockRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Page not found (page_not_found) */
export type PageNotFoundRecord = RecordInterface & {
  __typename?: 'PageNotFoundRecord';
  _allBackToHomeScreenButtonLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allDescriptionLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allHeaderLocales?: Maybe<Array<StringMultiLocaleField>>;
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  backToHomeScreenButton?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  header?: Maybe<Scalars['String']['output']>;
  id: Scalars['ItemId']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Record of type Page not found (page_not_found) */
export type PageNotFoundRecord_AllBackToHomeScreenButtonLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Page not found (page_not_found) */
export type PageNotFoundRecord_AllDescriptionLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
  markdown?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Record of type Page not found (page_not_found) */
export type PageNotFoundRecord_AllHeaderLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Page not found (page_not_found) */
export type PageNotFoundRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Page not found (page_not_found) */
export type PageNotFoundRecordBackToHomeScreenButtonArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Page not found (page_not_found) */
export type PageNotFoundRecordDescriptionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
  markdown?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Record of type Page not found (page_not_found) */
export type PageNotFoundRecordHeaderArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Plug Block (plug_block) */
export type PlugBlockRecord = RecordInterface & {
  __typename?: 'PlugBlockRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  brands: Array<BrandPageRecord>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ItemId']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Block of type Plug Block (plug_block) */
export type PlugBlockRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Plug Block (plug_block) */
export type PlugBlockRecordDescriptionArgs = {
  markdown?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Specifies how to filter by position (sorted and tree-like collections) */
export type PositionFilter = {
  /** Search for records with an exact match */
  eq?: InputMaybe<Scalars['IntType']['input']>;
  /** Filter records with a value that's strictly greater than the one specified */
  gt?: InputMaybe<Scalars['IntType']['input']>;
  /** Filter records with a value that's greater than or equal to the one specified */
  gte?: InputMaybe<Scalars['IntType']['input']>;
  /** Filter records with a value that's less than the one specified */
  lt?: InputMaybe<Scalars['IntType']['input']>;
  /** Filter records with a value that's less or equal than the one specified */
  lte?: InputMaybe<Scalars['IntType']['input']>;
  /** Exclude records with an exact match */
  neq?: InputMaybe<Scalars['IntType']['input']>;
};

/** Specifies how to filter by publication datetime */
export type PublishedAtFilter = {
  /** Filter records with a value that's within the specified minute range. Seconds and milliseconds are truncated from the argument. */
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records with a value that's strictly greater than the one specified. Seconds and milliseconds are truncated from the argument. */
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's greater than or equal to than the one specified. Seconds and milliseconds are truncated from the argument. */
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's less than the one specified. Seconds and milliseconds are truncated from the argument. */
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's less or equal than the one specified. Seconds and milliseconds are truncated from the argument. */
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's outside the specified minute range. Seconds and milliseconds are truncated from the argument. */
  neq?: InputMaybe<Scalars['DateTime']['input']>;
};

/** The query root for this schema */
export type Query = {
  __typename?: 'Query';
  /** Returns meta information regarding a record collection */
  _allAboutUsPagesMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allBrandPagesMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allCampaignPagesMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allImportHistoriesMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allJobOpportunitiesPagesMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allLanguagesMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allNewsPagesMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allOfficesMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allReportsListingsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allSubmenusMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allSustainabilityPagesMeta: CollectionMetadata;
  /** Returns meta information regarding an assets collection */
  _allUploadsMeta: CollectionMetadata;
  /** Returns the single instance record */
  _site: Site;
  /** Returns a specific record */
  aboutUsPage?: Maybe<AboutUsPageRecord>;
  /** Returns a collection of records */
  allAboutUsPages: Array<AboutUsPageRecord>;
  /** Returns a collection of records */
  allBrandPages: Array<BrandPageRecord>;
  /** Returns a collection of records */
  allCampaignPages: Array<CampaignPageRecord>;
  /** Returns a collection of records */
  allImportHistories: Array<ImportHistoryRecord>;
  /** Returns a collection of records */
  allJobOpportunitiesPages: Array<JobOpportunitiesPageRecord>;
  /** Returns a collection of records */
  allLanguages: Array<LanguageRecord>;
  /** Returns a collection of records */
  allNewsPages: Array<NewsPageRecord>;
  /** Returns a collection of records */
  allOffices: Array<OfficeRecord>;
  /** Returns a collection of records */
  allReportsListings: Array<ReportsListingRecord>;
  /** Returns a collection of records */
  allSubmenus: Array<SubmenuRecord>;
  /** Returns a collection of records */
  allSustainabilityPages: Array<SustainabilityPageRecord>;
  /** Returns a collection of assets */
  allUploads: Array<FileField>;
  /** Returns a specific record */
  brandPage?: Maybe<BrandPageRecord>;
  /** Returns the single instance record */
  brandsListPage?: Maybe<BrandsListPageRecord>;
  /** Returns a specific record */
  campaignPage?: Maybe<CampaignPageRecord>;
  /** Returns the single instance record */
  consentBox?: Maybe<ConsentBoxRecord>;
  /** Returns the single instance record */
  contactPage?: Maybe<ContactPageRecord>;
  /** Returns the single instance record */
  featureToggle?: Maybe<FeatureToggleRecord>;
  /** Returns the single instance record */
  footer?: Maybe<FooterRecord>;
  /** Returns the single instance record */
  global?: Maybe<GlobalRecord>;
  /** Returns a specific record */
  importHistory?: Maybe<ImportHistoryRecord>;
  /** Returns the single instance record */
  jobOpportunitiesListPage?: Maybe<JobOpportunitiesListPageRecord>;
  /** Returns a specific record */
  jobOpportunitiesPage?: Maybe<JobOpportunitiesPageRecord>;
  /** Returns the single instance record */
  landingPage?: Maybe<LandingPageRecord>;
  /** Returns a specific record */
  language?: Maybe<LanguageRecord>;
  /** Returns the single instance record */
  menu?: Maybe<MenuRecord>;
  /** Returns the single instance record */
  newsListPage?: Maybe<NewsListPageRecord>;
  /** Returns a specific record */
  newsPage?: Maybe<NewsPageRecord>;
  /** Returns a specific record */
  office?: Maybe<OfficeRecord>;
  /** Returns the single instance record */
  pageNotFound?: Maybe<PageNotFoundRecord>;
  /** Returns the single instance record */
  reportsListPage?: Maybe<ReportsListPageRecord>;
  /** Returns a specific record */
  reportsListing?: Maybe<ReportsListingRecord>;
  /** Returns the single instance record */
  siteLocale?: Maybe<SiteLocaleRecord>;
  /** Returns a specific record */
  submenu?: Maybe<SubmenuRecord>;
  /** Returns the single instance record */
  sustainabilityIndexPage?: Maybe<SustainabilityIndexPageRecord>;
  /** Returns a specific record */
  sustainabilityPage?: Maybe<SustainabilityPageRecord>;
  /** Returns a specific asset */
  upload?: Maybe<FileField>;
};

/** The query root for this schema */
export type Query_AllAboutUsPagesMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<AboutUsPageModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};

/** The query root for this schema */
export type Query_AllBrandPagesMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<BrandPageModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};

/** The query root for this schema */
export type Query_AllCampaignPagesMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<CampaignPageModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};

/** The query root for this schema */
export type Query_AllImportHistoriesMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<ImportHistoryModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};

/** The query root for this schema */
export type Query_AllJobOpportunitiesPagesMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<JobOpportunitiesPageModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};

/** The query root for this schema */
export type Query_AllLanguagesMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<LanguageModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};

/** The query root for this schema */
export type Query_AllNewsPagesMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<NewsPageModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};

/** The query root for this schema */
export type Query_AllOfficesMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<OfficeModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};

/** The query root for this schema */
export type Query_AllReportsListingsMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<ReportsListingModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};

/** The query root for this schema */
export type Query_AllSubmenusMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<SubmenuModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};

/** The query root for this schema */
export type Query_AllSustainabilityPagesMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<SustainabilityPageModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};

/** The query root for this schema */
export type Query_AllUploadsMetaArgs = {
  filter?: InputMaybe<UploadFilter>;
  locale?: InputMaybe<SiteLocale>;
};

/** The query root for this schema */
export type Query_SiteArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** The query root for this schema */
export type QueryAboutUsPageArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<AboutUsPageModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<AboutUsPageModelOrderBy>>>;
};

/** The query root for this schema */
export type QueryAllAboutUsPagesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<AboutUsPageModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<AboutUsPageModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
};

/** The query root for this schema */
export type QueryAllBrandPagesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<BrandPageModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<BrandPageModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
};

/** The query root for this schema */
export type QueryAllCampaignPagesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<CampaignPageModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<CampaignPageModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
};

/** The query root for this schema */
export type QueryAllImportHistoriesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<ImportHistoryModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<ImportHistoryModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
};

/** The query root for this schema */
export type QueryAllJobOpportunitiesPagesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<JobOpportunitiesPageModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<JobOpportunitiesPageModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
};

/** The query root for this schema */
export type QueryAllLanguagesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<LanguageModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<LanguageModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
};

/** The query root for this schema */
export type QueryAllNewsPagesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<NewsPageModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<NewsPageModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
};

/** The query root for this schema */
export type QueryAllOfficesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<OfficeModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<OfficeModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
};

/** The query root for this schema */
export type QueryAllReportsListingsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<ReportsListingModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<ReportsListingModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
};

/** The query root for this schema */
export type QueryAllSubmenusArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<SubmenuModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<SubmenuModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
};

/** The query root for this schema */
export type QueryAllSustainabilityPagesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<SustainabilityPageModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<SustainabilityPageModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
};

/** The query root for this schema */
export type QueryAllUploadsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<UploadFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<UploadOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
};

/** The query root for this schema */
export type QueryBrandPageArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<BrandPageModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<BrandPageModelOrderBy>>>;
};

/** The query root for this schema */
export type QueryBrandsListPageArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** The query root for this schema */
export type QueryCampaignPageArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<CampaignPageModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<CampaignPageModelOrderBy>>>;
};

/** The query root for this schema */
export type QueryConsentBoxArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** The query root for this schema */
export type QueryContactPageArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** The query root for this schema */
export type QueryFeatureToggleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** The query root for this schema */
export type QueryFooterArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** The query root for this schema */
export type QueryGlobalArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** The query root for this schema */
export type QueryImportHistoryArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<ImportHistoryModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<ImportHistoryModelOrderBy>>>;
};

/** The query root for this schema */
export type QueryJobOpportunitiesListPageArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** The query root for this schema */
export type QueryJobOpportunitiesPageArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<JobOpportunitiesPageModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<JobOpportunitiesPageModelOrderBy>>>;
};

/** The query root for this schema */
export type QueryLandingPageArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** The query root for this schema */
export type QueryLanguageArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<LanguageModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<LanguageModelOrderBy>>>;
};

/** The query root for this schema */
export type QueryMenuArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** The query root for this schema */
export type QueryNewsListPageArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** The query root for this schema */
export type QueryNewsPageArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<NewsPageModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<NewsPageModelOrderBy>>>;
};

/** The query root for this schema */
export type QueryOfficeArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<OfficeModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<OfficeModelOrderBy>>>;
};

/** The query root for this schema */
export type QueryPageNotFoundArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** The query root for this schema */
export type QueryReportsListPageArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** The query root for this schema */
export type QueryReportsListingArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<ReportsListingModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<ReportsListingModelOrderBy>>>;
};

/** The query root for this schema */
export type QuerySiteLocaleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** The query root for this schema */
export type QuerySubmenuArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<SubmenuModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<SubmenuModelOrderBy>>>;
};

/** The query root for this schema */
export type QuerySustainabilityIndexPageArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** The query root for this schema */
export type QuerySustainabilityPageArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<SustainabilityPageModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<SustainabilityPageModelOrderBy>>>;
};

/** The query root for this schema */
export type QueryUploadArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<UploadFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<UploadOrderBy>>>;
};

export type RecordInterface = {
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
};

export type RecordInterface_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type 🗞️ Report List Block (reports_list_block) */
export type ReportsListBlockRecord = RecordInterface & {
  __typename?: 'ReportsListBlockRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  largeTitle?: Maybe<Scalars['BooleanType']['output']>;
  standalone?: Maybe<Scalars['BooleanType']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Block of type 🗞️ Report List Block (reports_list_block) */
export type ReportsListBlockRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type ReportsListPageModelContentAreaField =
  | ArticlesBlockRecord
  | BrandsBlockRecord
  | BulletListRecord
  | DocumentLinkBlockRecord
  | EmployeeRecord
  | HeroBlockRecord
  | ImageRecord
  | JobsListBlockRecord
  | NewsAndReportsListBlockRecord
  | NewsListBlockRecord
  | OfficesBlockRecord
  | PlugBlockRecord
  | ReportsListBlockRecord
  | SimpleTitleAndTextBlockRecord
  | SliderBlockRecord
  | StatementBlockRecord
  | TextBlockRecord
  | TwoColumnImageAndTextRecord
  | TwoColumnTextIntroRecord
  | VideoRecord;

export type ReportsListPageModelContentAreaFieldListListNonNullMultiLocaleField =
  {
    __typename?: 'ReportsListPageModelContentAreaFieldListListNonNullMultiLocaleField';
    locale?: Maybe<SiteLocale>;
    value: Array<ReportsListPageModelContentAreaField>;
  };

/** Record of type 🗂️ Reports Index Page (reports_list_page) */
export type ReportsListPageRecord = RecordInterface & {
  __typename?: 'ReportsListPageRecord';
  _allContentAreaLocales?: Maybe<
    Array<ReportsListPageModelContentAreaFieldListListNonNullMultiLocaleField>
  >;
  _allSeoLocales?: Maybe<Array<SeoFieldMultiLocaleField>>;
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  contentArea: Array<ReportsListPageModelContentAreaField>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  seo?: Maybe<SeoField>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Record of type 🗂️ Reports Index Page (reports_list_page) */
export type ReportsListPageRecord_AllContentAreaLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type 🗂️ Reports Index Page (reports_list_page) */
export type ReportsListPageRecord_AllSeoLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type 🗂️ Reports Index Page (reports_list_page) */
export type ReportsListPageRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type 🗂️ Reports Index Page (reports_list_page) */
export type ReportsListPageRecordContentAreaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type 🗂️ Reports Index Page (reports_list_page) */
export type ReportsListPageRecordSeoArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

export type ReportsListingModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<ReportsListingModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ReportsListingModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _locales?: InputMaybe<LocalesFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  category?: InputMaybe<StringFilter>;
  country?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  image?: InputMaybe<FileFilter>;
  pageName?: InputMaybe<StringFilter>;
  pdf?: InputMaybe<FileFilter>;
  publishDate?: InputMaybe<DateFilter>;
  seo?: InputMaybe<SeoFilter>;
  slug?: InputMaybe<SlugFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum ReportsListingModelOrderBy {
  CreatedAtAsc = '_createdAt_ASC',
  CreatedAtDesc = '_createdAt_DESC',
  FirstPublishedAtAsc = '_firstPublishedAt_ASC',
  FirstPublishedAtDesc = '_firstPublishedAt_DESC',
  IsValidAsc = '_isValid_ASC',
  IsValidDesc = '_isValid_DESC',
  PublicationScheduledAtAsc = '_publicationScheduledAt_ASC',
  PublicationScheduledAtDesc = '_publicationScheduledAt_DESC',
  PublishedAtAsc = '_publishedAt_ASC',
  PublishedAtDesc = '_publishedAt_DESC',
  StatusAsc = '_status_ASC',
  StatusDesc = '_status_DESC',
  UnpublishingScheduledAtAsc = '_unpublishingScheduledAt_ASC',
  UnpublishingScheduledAtDesc = '_unpublishingScheduledAt_DESC',
  UpdatedAtAsc = '_updatedAt_ASC',
  UpdatedAtDesc = '_updatedAt_DESC',
  CategoryAsc = 'category_ASC',
  CategoryDesc = 'category_DESC',
  CountryAsc = 'country_ASC',
  CountryDesc = 'country_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PageNameAsc = 'pageName_ASC',
  PageNameDesc = 'pageName_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

/** Record of type 📰 Report Listing (reports_listing) */
export type ReportsListingRecord = RecordInterface & {
  __typename?: 'ReportsListingRecord';
  _allSeoLocales?: Maybe<Array<SeoFieldMultiLocaleField>>;
  _allTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  category?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  image?: Maybe<FileField>;
  pageName?: Maybe<Scalars['String']['output']>;
  pdf?: Maybe<FileField>;
  publishDate?: Maybe<Scalars['Date']['output']>;
  seo?: Maybe<SeoField>;
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Record of type 📰 Report Listing (reports_listing) */
export type ReportsListingRecord_AllSeoLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type 📰 Report Listing (reports_listing) */
export type ReportsListingRecord_AllTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type 📰 Report Listing (reports_listing) */
export type ReportsListingRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type 📰 Report Listing (reports_listing) */
export type ReportsListingRecordSeoArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type 📰 Report Listing (reports_listing) */
export type ReportsListingRecordTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Specifies how to filter by upload type */
export type ResolutionFilter = {
  /** Search uploads with the specified resolution */
  eq?: InputMaybe<ResolutionType>;
  /** Search uploads with the specified resolutions */
  in?: InputMaybe<Array<InputMaybe<ResolutionType>>>;
  /** Exclude uploads with the specified resolution */
  neq?: InputMaybe<ResolutionType>;
  /** Search uploads without the specified resolutions */
  notIn?: InputMaybe<Array<InputMaybe<ResolutionType>>>;
};

export enum ResolutionType {
  Icon = 'icon',
  Large = 'large',
  Medium = 'medium',
  Small = 'small',
}

export type ResponsiveImage = {
  __typename?: 'ResponsiveImage';
  alt?: Maybe<Scalars['String']['output']>;
  aspectRatio: Scalars['FloatType']['output'];
  base64?: Maybe<Scalars['String']['output']>;
  bgColor?: Maybe<Scalars['String']['output']>;
  height: Scalars['IntType']['output'];
  sizes: Scalars['String']['output'];
  src: Scalars['String']['output'];
  srcSet: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  webpSrcSet: Scalars['String']['output'];
  width: Scalars['IntType']['output'];
};

export type SeoField = {
  __typename?: 'SeoField';
  description?: Maybe<Scalars['String']['output']>;
  image?: Maybe<FileField>;
  noIndex?: Maybe<Scalars['BooleanType']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  twitterCard?: Maybe<Scalars['String']['output']>;
};

export type SeoFieldMultiLocaleField = {
  __typename?: 'SeoFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<SeoField>;
};

/** Specifies how to filter SEO meta tags fields */
export type SeoFilter = {
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
};

/** Block of type Simple Title and Text Block (simple_title_and_text_block) */
export type SimpleTitleAndTextBlockRecord = RecordInterface & {
  __typename?: 'SimpleTitleAndTextBlockRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ItemId']['output'];
  title?: Maybe<Scalars['String']['output']>;
  topLabel?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Block of type Simple Title and Text Block (simple_title_and_text_block) */
export type SimpleTitleAndTextBlockRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Simple Title and Text Block (simple_title_and_text_block) */
export type SimpleTitleAndTextBlockRecordDescriptionArgs = {
  markdown?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Site = {
  __typename?: 'Site';
  favicon?: Maybe<FileField>;
  faviconMetaTags: Array<Tag>;
  globalSeo?: Maybe<GlobalSeoField>;
  locales: Array<SiteLocale>;
  noIndex?: Maybe<Scalars['BooleanType']['output']>;
};

export type SiteFaviconMetaTagsArgs = {
  variants?: InputMaybe<Array<InputMaybe<FaviconType>>>;
};

export type SiteGlobalSeoArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

export enum SiteLocale {
  Da = 'da',
  De = 'de',
  DeAt = 'de_AT',
  DeCh = 'de_CH',
  En = 'en',
  EnGb = 'en_GB',
  EnIe = 'en_IE',
  Fi = 'fi',
  FrCh = 'fr_CH',
  FrFr = 'fr_FR',
  ItIt = 'it_IT',
  NlBe = 'nl_BE',
  NlNl = 'nl_NL',
  No = 'no',
  PlPl = 'pl_PL',
  Sv = 'sv',
}

/** Record of type Site Locale (site_locale) */
export type SiteLocaleRecord = RecordInterface & {
  __typename?: 'SiteLocaleRecord';
  _allEnabledLocales?: Maybe<Array<BooleanTypeMultiLocaleField>>;
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  enabled?: Maybe<Scalars['BooleanType']['output']>;
  id: Scalars['ItemId']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Record of type Site Locale (site_locale) */
export type SiteLocaleRecord_AllEnabledLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Site Locale (site_locale) */
export type SiteLocaleRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Site Locale (site_locale) */
export type SiteLocaleRecordEnabledArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Slider Block (slider_block) */
export type SliderBlockRecord = RecordInterface & {
  __typename?: 'SliderBlockRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  arrows?: Maybe<Scalars['BooleanType']['output']>;
  createdAt: Scalars['DateTime']['output'];
  delay?: Maybe<Scalars['IntType']['output']>;
  id: Scalars['ItemId']['output'];
  navigationDots?: Maybe<Scalars['BooleanType']['output']>;
  slideAnimation?: Maybe<Scalars['BooleanType']['output']>;
  slides: Array<HeroBlockRecord>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Block of type Slider Block (slider_block) */
export type SliderBlockRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Specifies how to filter Slug fields */
export type SlugFilter = {
  /** Search for records with an exact match */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Filter records that have one of the specified slugs */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Exclude records with an exact match */
  neq?: InputMaybe<Scalars['String']['input']>;
  /** Filter records that do have one of the specified slugs */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** Block of type Statement Block (statement_block) */
export type StatementBlockRecord = RecordInterface & {
  __typename?: 'StatementBlockRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  backgroundImage?: Maybe<FileField>;
  blackBackground?: Maybe<Scalars['BooleanType']['output']>;
  createdAt: Scalars['DateTime']['output'];
  header?: Maybe<Scalars['String']['output']>;
  id: Scalars['ItemId']['output'];
  imageOverlay?: Maybe<OverlayRecord>;
  linkText?: Maybe<Scalars['String']['output']>;
  linkUrl?: Maybe<Scalars['String']['output']>;
  small?: Maybe<Scalars['BooleanType']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Block of type Statement Block (statement_block) */
export type StatementBlockRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Statement Block (statement_block) */
export type StatementBlockRecordTextArgs = {
  markdown?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Specifies how to filter by status */
export type StatusFilter = {
  /** Search the record with the specified status */
  eq?: InputMaybe<ItemStatus>;
  /** Search records with the specified statuses */
  in?: InputMaybe<Array<InputMaybe<ItemStatus>>>;
  /** Exclude the record with the specified status */
  neq?: InputMaybe<ItemStatus>;
  /** Search records without the specified statuses */
  notIn?: InputMaybe<Array<InputMaybe<ItemStatus>>>;
};

/** Specifies how to filter Single-line string fields */
export type StringFilter = {
  /** Search for records with an exact match */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Filter records with the specified field defined (i.e. with any value) or not [DEPRECATED] */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records that equal one of the specified values */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Filter records with the specified field set as blank (null or empty string) */
  isBlank?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records with the specified field present (neither null, nor empty string) */
  isPresent?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude records with an exact match */
  neq?: InputMaybe<Scalars['String']['input']>;
  /** Filter records that do not equal one of the specified values */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Exclude records based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

export type StringMatchesFilter = {
  caseSensitive?: InputMaybe<Scalars['BooleanType']['input']>;
  pattern: Scalars['String']['input'];
  regexp?: InputMaybe<Scalars['BooleanType']['input']>;
};

export type StringMultiLocaleField = {
  __typename?: 'StringMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<Scalars['String']['output']>;
};

/** Block of type Subheading Block (subheading_block) */
export type SubheadingBlockRecord = RecordInterface & {
  __typename?: 'SubheadingBlockRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  backgroundColor?: Maybe<ColorField>;
  createdAt: Scalars['DateTime']['output'];
  ctaButton?: Maybe<CtaButtonRecord>;
  id: Scalars['ItemId']['output'];
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Block of type Subheading Block (subheading_block) */
export type SubheadingBlockRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Subheading Block (subheading_block) */
export type SubheadingBlockRecordTextArgs = {
  markdown?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubmenuModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<SubmenuModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<SubmenuModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _locales?: InputMaybe<LocalesFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum SubmenuModelOrderBy {
  CreatedAtAsc = '_createdAt_ASC',
  CreatedAtDesc = '_createdAt_DESC',
  FirstPublishedAtAsc = '_firstPublishedAt_ASC',
  FirstPublishedAtDesc = '_firstPublishedAt_DESC',
  IsValidAsc = '_isValid_ASC',
  IsValidDesc = '_isValid_DESC',
  PublicationScheduledAtAsc = '_publicationScheduledAt_ASC',
  PublicationScheduledAtDesc = '_publicationScheduledAt_DESC',
  PublishedAtAsc = '_publishedAt_ASC',
  PublishedAtDesc = '_publishedAt_DESC',
  StatusAsc = '_status_ASC',
  StatusDesc = '_status_DESC',
  UnpublishingScheduledAtAsc = '_unpublishingScheduledAt_ASC',
  UnpublishingScheduledAtDesc = '_unpublishingScheduledAt_DESC',
  UpdatedAtAsc = '_updatedAt_ASC',
  UpdatedAtDesc = '_updatedAt_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

/** Record of type Submenu (submenu) */
export type SubmenuRecord = RecordInterface & {
  __typename?: 'SubmenuRecord';
  _allMenuItemsLocales?: Maybe<
    Array<ItemRecordListListNonNullMultiLocaleField>
  >;
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  menuItems: Array<ItemRecord>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Record of type Submenu (submenu) */
export type SubmenuRecord_AllMenuItemsLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Submenu (submenu) */
export type SubmenuRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Submenu (submenu) */
export type SubmenuRecordMenuItemsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

export type SustainabilityIndexPageModelContentAreaField =
  | ArticlesBlockRecord
  | BrandsBlockRecord
  | BulletListRecord
  | DocumentLinkBlockRecord
  | EmployeeRecord
  | GridContainerBlockRecord
  | HeroBlockRecord
  | ImageRecord
  | NewsAndReportsListBlockRecord
  | NewsListBlockRecord
  | OfficesBlockRecord
  | PageNavigationBlockRecord
  | PlugBlockRecord
  | ReportsListBlockRecord
  | SimpleTitleAndTextBlockRecord
  | SliderBlockRecord
  | StatementBlockRecord
  | SubheadingBlockRecord
  | SustainabilityReportsBlockRecord
  | TextBlockRecord
  | TwoColumnImageAndTextRecord
  | TwoColumnTextIntroRecord
  | VideoRecord;

export type SustainabilityIndexPageModelContentAreaFieldListListNonNullMultiLocaleField =
  {
    __typename?: 'SustainabilityIndexPageModelContentAreaFieldListListNonNullMultiLocaleField';
    locale?: Maybe<SiteLocale>;
    value: Array<SustainabilityIndexPageModelContentAreaField>;
  };

/** Record of type Sustainability Index Page (sustainability_index_page) */
export type SustainabilityIndexPageRecord = RecordInterface & {
  __typename?: 'SustainabilityIndexPageRecord';
  _allContentAreaLocales?: Maybe<
    Array<SustainabilityIndexPageModelContentAreaFieldListListNonNullMultiLocaleField>
  >;
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  contentArea: Array<SustainabilityIndexPageModelContentAreaField>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  seo?: Maybe<SeoField>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Record of type Sustainability Index Page (sustainability_index_page) */
export type SustainabilityIndexPageRecord_AllContentAreaLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Sustainability Index Page (sustainability_index_page) */
export type SustainabilityIndexPageRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Sustainability Index Page (sustainability_index_page) */
export type SustainabilityIndexPageRecordContentAreaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

export type SustainabilityPageModelContentAreaField =
  | ArticlesBlockRecord
  | BrandsBlockRecord
  | BulletListRecord
  | DocumentLinkBlockRecord
  | EmployeeRecord
  | GridContainerBlockRecord
  | HeroBlockRecord
  | ImageRecord
  | JobsListBlockRecord
  | NewsAndReportsListBlockRecord
  | NewsListBlockRecord
  | OfficesBlockRecord
  | PageNavigationBlockRecord
  | PlugBlockRecord
  | SimpleTitleAndTextBlockRecord
  | SliderBlockRecord
  | StatementBlockRecord
  | SubheadingBlockRecord
  | SustainabilityReportsBlockRecord
  | TextBlockRecord
  | TwoColumnImageAndTextRecord
  | TwoColumnTextIntroRecord
  | VideoRecord;

export type SustainabilityPageModelContentAreaFieldListListNonNullMultiLocaleField =
  {
    __typename?: 'SustainabilityPageModelContentAreaFieldListListNonNullMultiLocaleField';
    locale?: Maybe<SiteLocale>;
    value: Array<SustainabilityPageModelContentAreaField>;
  };

export type SustainabilityPageModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<SustainabilityPageModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<SustainabilityPageModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _locales?: InputMaybe<LocalesFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  pageName?: InputMaybe<StringFilter>;
  seo?: InputMaybe<SeoFilter>;
  slug?: InputMaybe<SlugFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum SustainabilityPageModelOrderBy {
  CreatedAtAsc = '_createdAt_ASC',
  CreatedAtDesc = '_createdAt_DESC',
  FirstPublishedAtAsc = '_firstPublishedAt_ASC',
  FirstPublishedAtDesc = '_firstPublishedAt_DESC',
  IsValidAsc = '_isValid_ASC',
  IsValidDesc = '_isValid_DESC',
  PublicationScheduledAtAsc = '_publicationScheduledAt_ASC',
  PublicationScheduledAtDesc = '_publicationScheduledAt_DESC',
  PublishedAtAsc = '_publishedAt_ASC',
  PublishedAtDesc = '_publishedAt_DESC',
  StatusAsc = '_status_ASC',
  StatusDesc = '_status_DESC',
  UnpublishingScheduledAtAsc = '_unpublishingScheduledAt_ASC',
  UnpublishingScheduledAtDesc = '_unpublishingScheduledAt_DESC',
  UpdatedAtAsc = '_updatedAt_ASC',
  UpdatedAtDesc = '_updatedAt_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PageNameAsc = 'pageName_ASC',
  PageNameDesc = 'pageName_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
}

/** Record of type Sustainability Page (sustainability_page) */
export type SustainabilityPageRecord = RecordInterface & {
  __typename?: 'SustainabilityPageRecord';
  _allContentAreaLocales?: Maybe<
    Array<SustainabilityPageModelContentAreaFieldListListNonNullMultiLocaleField>
  >;
  _allSeoLocales?: Maybe<Array<SeoFieldMultiLocaleField>>;
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  contentArea: Array<SustainabilityPageModelContentAreaField>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  pageName?: Maybe<Scalars['String']['output']>;
  seo?: Maybe<SeoField>;
  slug?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Record of type Sustainability Page (sustainability_page) */
export type SustainabilityPageRecord_AllContentAreaLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Sustainability Page (sustainability_page) */
export type SustainabilityPageRecord_AllSeoLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Sustainability Page (sustainability_page) */
export type SustainabilityPageRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Sustainability Page (sustainability_page) */
export type SustainabilityPageRecordContentAreaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Sustainability Page (sustainability_page) */
export type SustainabilityPageRecordSeoArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Sustainability Reports Block (sustainability_reports_block) */
export type SustainabilityReportsBlockRecord = RecordInterface & {
  __typename?: 'SustainabilityReportsBlockRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  reports: Array<FileField>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Block of type Sustainability Reports Block (sustainability_reports_block) */
export type SustainabilityReportsBlockRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type Tag = {
  __typename?: 'Tag';
  attributes?: Maybe<Scalars['MetaTagAttributes']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  tag: Scalars['String']['output'];
};

/** Block of type Text Block (text_block) */
export type TextBlockRecord = RecordInterface & {
  __typename?: 'TextBlockRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  ctaButtons: Array<CtaButtonRecord>;
  header?: Maybe<Scalars['String']['output']>;
  id: Scalars['ItemId']['output'];
  introText?: Maybe<Scalars['String']['output']>;
  smallHeader?: Maybe<Scalars['BooleanType']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Block of type Text Block (text_block) */
export type TextBlockRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Text Block (text_block) */
export type TextBlockRecordIntroTextArgs = {
  markdown?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Block of type Text Block (text_block) */
export type TextBlockRecordTextArgs = {
  markdown?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Specifies how to filter text fields */
export type TextFilter = {
  /** Filter records with the specified field defined (i.e. with any value) or not [DEPRECATED] */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records with the specified field set as blank (null or empty string) */
  isBlank?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records with the specified field present (neither null, nor empty string) */
  isPresent?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude records based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

/** Block of type Two Column Image and Text Block (two_column_image_and_text) */
export type TwoColumnImageAndTextRecord = RecordInterface & {
  __typename?: 'TwoColumnImageAndTextRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  image?: Maybe<FileField>;
  reverse?: Maybe<Scalars['BooleanType']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Block of type Two Column Image and Text Block (two_column_image_and_text) */
export type TwoColumnImageAndTextRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Two Column Image and Text Block (two_column_image_and_text) */
export type TwoColumnImageAndTextRecordTextArgs = {
  markdown?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Block of type Two Column Text Intro Block (two_column_text_intro) */
export type TwoColumnTextIntroRecord = RecordInterface & {
  __typename?: 'TwoColumnTextIntroRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  header?: Maybe<Scalars['String']['output']>;
  id: Scalars['ItemId']['output'];
  introText?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Block of type Two Column Text Intro Block (two_column_text_intro) */
export type TwoColumnTextIntroRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Two Column Text Intro Block (two_column_text_intro) */
export type TwoColumnTextIntroRecordIntroTextArgs = {
  markdown?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Block of type Two Column Text Intro Block (two_column_text_intro) */
export type TwoColumnTextIntroRecordTextArgs = {
  markdown?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Specifies how to filter by upload type */
export type TypeFilter = {
  /** Search uploads with the specified type */
  eq?: InputMaybe<UploadType>;
  /** Search uploads with the specified types */
  in?: InputMaybe<Array<InputMaybe<UploadType>>>;
  /** Exclude uploads with the specified type */
  neq?: InputMaybe<UploadType>;
  /** Search uploads without the specified types */
  notIn?: InputMaybe<Array<InputMaybe<UploadType>>>;
};

/** Specifies how to filter by update datetime */
export type UpdatedAtFilter = {
  /** Filter records with a value that's within the specified minute range. Seconds and milliseconds are truncated from the argument. */
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records with a value that's strictly greater than the one specified. Seconds and milliseconds are truncated from the argument. */
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's greater than or equal to than the one specified. Seconds and milliseconds are truncated from the argument. */
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's less than the one specified. Seconds and milliseconds are truncated from the argument. */
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's less or equal than the one specified. Seconds and milliseconds are truncated from the argument. */
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's outside the specified minute range. Seconds and milliseconds are truncated from the argument. */
  neq?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Specifies how to filter by default alt */
export type UploadAltFilter = {
  /** Search the uploads with the specified alt */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Filter uploads with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Search uploads with the specified values as default alt */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude the uploads with the specified alt */
  neq?: InputMaybe<Scalars['String']['input']>;
  /** Search uploads that do not have the specified values as default alt */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

/** Specifies how to filter by auhtor */
export type UploadAuthorFilter = {
  /** Filter uploads with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

/** Specifies how to filter by basename */
export type UploadBasenameFilter = {
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

/** Specifies how to filter by colors */
export type UploadColorsFilter = {
  /** Filter uploads that have all of the specified colors */
  allIn?: InputMaybe<Array<InputMaybe<ColorBucketType>>>;
  /** Filter uploads that have at least one of the specified colors */
  anyIn?: InputMaybe<Array<InputMaybe<ColorBucketType>>>;
  /** Filter uploads that have the specified colors */
  contains?: InputMaybe<ColorBucketType>;
  /** Search for uploads with an exact match */
  eq?: InputMaybe<Array<InputMaybe<ColorBucketType>>>;
  /** Filter uploads that do not have any of the specified colors */
  notIn?: InputMaybe<Array<InputMaybe<ColorBucketType>>>;
};

/** Specifies how to filter by copyright */
export type UploadCopyrightFilter = {
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

/** Specifies how to filter by creation datetime */
export type UploadCreatedAtFilter = {
  /** Search for uploads with an exact match */
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter uploads with a value that's strictly greater than the one specified */
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter uploads with a value that's greater than or equal to the one specified */
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter uploads with a value that's less than the one specified */
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter uploads with a value that's less or equal than the one specified */
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Exclude uploads with an exact match */
  neq?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Specifies how to filter by filename */
export type UploadFilenameFilter = {
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

export type UploadFilter = {
  AND?: InputMaybe<Array<InputMaybe<UploadFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<UploadFilter>>>;
  _createdAt?: InputMaybe<UploadCreatedAtFilter>;
  _updatedAt?: InputMaybe<UploadUpdatedAtFilter>;
  alt?: InputMaybe<UploadAltFilter>;
  author?: InputMaybe<UploadAuthorFilter>;
  basename?: InputMaybe<UploadBasenameFilter>;
  colors?: InputMaybe<UploadColorsFilter>;
  copyright?: InputMaybe<UploadCopyrightFilter>;
  filename?: InputMaybe<UploadFilenameFilter>;
  format?: InputMaybe<UploadFormatFilter>;
  height?: InputMaybe<UploadHeightFilter>;
  id?: InputMaybe<UploadIdFilter>;
  inUse?: InputMaybe<InUseFilter>;
  md5?: InputMaybe<UploadMd5Filter>;
  mimeType?: InputMaybe<UploadMimeTypeFilter>;
  notes?: InputMaybe<UploadNotesFilter>;
  orientation?: InputMaybe<OrientationFilter>;
  resolution?: InputMaybe<ResolutionFilter>;
  size?: InputMaybe<UploadSizeFilter>;
  smartTags?: InputMaybe<UploadTagsFilter>;
  tags?: InputMaybe<UploadTagsFilter>;
  title?: InputMaybe<UploadTitleFilter>;
  type?: InputMaybe<TypeFilter>;
  width?: InputMaybe<UploadWidthFilter>;
};

/** Specifies how to filter by format */
export type UploadFormatFilter = {
  /** Search the asset with the specified format */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Search assets with the specified formats */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Exclude the asset with the specified format */
  neq?: InputMaybe<Scalars['String']['input']>;
  /** Search assets that do not have the specified formats */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** Specifies how to filter by height */
export type UploadHeightFilter = {
  /** Search assets with the specified height */
  eq?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets larger than the specified height */
  gt?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets larger or equal to the specified height */
  gte?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets smaller than the specified height */
  lt?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets larger or equal to the specified height */
  lte?: InputMaybe<Scalars['IntType']['input']>;
  /** Search assets that do not have the specified height */
  neq?: InputMaybe<Scalars['IntType']['input']>;
};

/** Specifies how to filter by ID */
export type UploadIdFilter = {
  /** Search the asset with the specified ID */
  eq?: InputMaybe<Scalars['UploadId']['input']>;
  /** Search assets with the specified IDs */
  in?: InputMaybe<Array<InputMaybe<Scalars['UploadId']['input']>>>;
  /** Exclude the asset with the specified ID */
  neq?: InputMaybe<Scalars['UploadId']['input']>;
  /** Search assets that do not have the specified IDs */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['UploadId']['input']>>>;
};

/** Specifies how to filter by MD5 */
export type UploadMd5Filter = {
  /** Search the asset with the specified MD5 */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Search assets with the specified MD5s */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Exclude the asset with the specified MD5 */
  neq?: InputMaybe<Scalars['String']['input']>;
  /** Search assets that do not have the specified MD5s */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** Specifies how to filter by mime type */
export type UploadMimeTypeFilter = {
  /** Search the asset with the specified mime type */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Search assets with the specified mime types */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude the asset with the specified mime type */
  neq?: InputMaybe<Scalars['String']['input']>;
  /** Search assets that do not have the specified mime types */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

/** Specifies how to filter by notes */
export type UploadNotesFilter = {
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

export enum UploadOrderBy {
  CreatedAtAsc = '_createdAt_ASC',
  CreatedAtDesc = '_createdAt_DESC',
  UpdatedAtAsc = '_updatedAt_ASC',
  UpdatedAtDesc = '_updatedAt_DESC',
  BasenameAsc = 'basename_ASC',
  BasenameDesc = 'basename_DESC',
  FilenameAsc = 'filename_ASC',
  FilenameDesc = 'filename_DESC',
  FormatAsc = 'format_ASC',
  FormatDesc = 'format_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  MimeTypeAsc = 'mimeType_ASC',
  MimeTypeDesc = 'mimeType_DESC',
  ResolutionAsc = 'resolution_ASC',
  ResolutionDesc = 'resolution_DESC',
  SizeAsc = 'size_ASC',
  SizeDesc = 'size_DESC',
}

export enum UploadOrientation {
  Landscape = 'landscape',
  Portrait = 'portrait',
  Square = 'square',
}

/** Specifies how to filter by size */
export type UploadSizeFilter = {
  /** Search assets with the specified size (in bytes) */
  eq?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets larger than the specified size (in bytes) */
  gt?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets larger or equal to the specified size (in bytes) */
  gte?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets smaller than the specified size (in bytes) */
  lt?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets larger or equal to the specified size (in bytes) */
  lte?: InputMaybe<Scalars['IntType']['input']>;
  /** Search assets that do not have the specified size (in bytes) */
  neq?: InputMaybe<Scalars['IntType']['input']>;
};

/** Specifies how to filter by tags */
export type UploadTagsFilter = {
  /** Filter uploads linked to all of the specified tags */
  allIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter uploads linked to at least one of the specified tags */
  anyIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter uploads linked to the specified tag */
  contains?: InputMaybe<Scalars['String']['input']>;
  /** Search for uploads with an exact match */
  eq?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter uploads not linked to any of the specified tags */
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Specifies how to filter by default title */
export type UploadTitleFilter = {
  /** Search the asset with the specified title */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Filter assets with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Search assets with the specified as default title */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude the asset with the specified title */
  neq?: InputMaybe<Scalars['String']['input']>;
  /** Search assets that do not have the specified as default title */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

export enum UploadType {
  Archive = 'archive',
  Audio = 'audio',
  Image = 'image',
  Pdfdocument = 'pdfdocument',
  Presentation = 'presentation',
  Richtext = 'richtext',
  Spreadsheet = 'spreadsheet',
  Video = 'video',
}

/** Specifies how to filter by update datetime */
export type UploadUpdatedAtFilter = {
  /** Search for uploads with an exact match */
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter uploads with a value that's strictly greater than the one specified */
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter uploads with a value that's greater than or equal to the one specified */
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter uploads with a value that's less than the one specified */
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter uploads with a value that's less or equal than the one specified */
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Exclude uploads with an exact match */
  neq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UploadVideoField = {
  __typename?: 'UploadVideoField';
  alt?: Maybe<Scalars['String']['output']>;
  blurUpThumb?: Maybe<Scalars['String']['output']>;
  blurhash?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  framerate?: Maybe<Scalars['Int']['output']>;
  height: Scalars['IntType']['output'];
  mp4Url?: Maybe<Scalars['String']['output']>;
  muxAssetId: Scalars['String']['output'];
  muxPlaybackId: Scalars['String']['output'];
  streamingUrl: Scalars['String']['output'];
  thumbhash?: Maybe<Scalars['String']['output']>;
  thumbnailUrl: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  width: Scalars['IntType']['output'];
};

export type UploadVideoFieldAltArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

export type UploadVideoFieldBlurUpThumbArgs = {
  imgixParams?: InputMaybe<ImgixParams>;
  punch?: Scalars['Float']['input'];
  quality?: Scalars['Int']['input'];
  size?: Scalars['Int']['input'];
};

export type UploadVideoFieldMp4UrlArgs = {
  exactRes?: InputMaybe<VideoMp4Res>;
  res?: InputMaybe<VideoMp4Res>;
};

export type UploadVideoFieldThumbnailUrlArgs = {
  format?: InputMaybe<MuxThumbnailFormatType>;
};

export type UploadVideoFieldTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Specifies how to filter by width */
export type UploadWidthFilter = {
  /** Search assets with the specified width */
  eq?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets larger than the specified width */
  gt?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets larger or equal to the specified width */
  gte?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets smaller than the specified width */
  lt?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets larger or equal to the specified width */
  lte?: InputMaybe<Scalars['IntType']['input']>;
  /** Search assets that do not have the specified width */
  neq?: InputMaybe<Scalars['IntType']['input']>;
};

export enum VideoMp4Res {
  High = 'high',
  Low = 'low',
  Medium = 'medium',
}

/** Block of type Video Block (video) */
export type VideoRecord = RecordInterface & {
  __typename?: 'VideoRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  autoplay?: Maybe<Scalars['BooleanType']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  updatedAt: Scalars['DateTime']['output'];
  video?: Maybe<FileField>;
  videoThumbnail?: Maybe<FileField>;
};

/** Block of type Video Block (video) */
export type VideoRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type FocalPoint = {
  __typename?: 'focalPoint';
  x: Scalars['FloatType']['output'];
  y: Scalars['FloatType']['output'];
};

export type CollectionMetadataFragment = {
  __typename?: 'CollectionMetadata';
  count: any;
};

export type HeroBlockFragment = {
  __typename?: 'HeroBlockRecord';
  id: any;
  title?: string | null;
  description?: string | null;
  ctaText?: string | null;
  ctaUrl?: string | null;
  fullWidth?: any | null;
  boxColor?: { __typename?: 'ColorField'; hex: string } | null;
  textColor?: { __typename?: 'ColorField'; hex: string } | null;
  image?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
  imageOverlay?: {
    __typename?: 'OverlayRecord';
    id: any;
    opacity?: any | null;
    color?: { __typename?: 'ColorField'; hex: string } | null;
  } | null;
  ctaButtons: Array<{
    __typename?: 'CtaButtonRecord';
    id: any;
    text?: string | null;
    url?: string | null;
    variant?: string | null;
  }>;
  video?: {
    __typename?: 'FileField';
    blurUpThumb?: string | null;
    title?: string | null;
    alt?: string | null;
    video?: {
      __typename?: 'UploadVideoField';
      muxPlaybackId: string;
      width: any;
      height: any;
    } | null;
  } | null;
};

export type ArticlesBlockFragment = {
  __typename?: 'ArticlesBlockRecord';
  id: any;
  title?: string | null;
  isJobArticles?: any | null;
  ctaText?: string | null;
  ctaUrl?: string | null;
  jobPages: Array<{
    __typename?: 'JobOpportunitiesPageRecord';
    id: any;
    slug?: string | null;
    title?: string | null;
    publishDate?: any | null;
    category?: string | null;
    country?: string | null;
    department?: string | null;
  }>;
  newsPages: Array<{
    __typename?: 'NewsPageRecord';
    id: any;
    slug?: string | null;
    title?: string | null;
    publishDate?: any | null;
    category?: string | null;
    country?: string | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
  }>;
  reportPages: Array<{
    __typename?: 'ReportsListingRecord';
    id: any;
    slug?: string | null;
    title?: string | null;
    publishDate?: any | null;
    category?: string | null;
    country?: string | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
    pdf?: {
      __typename?: 'FileField';
      alt?: string | null;
      filename: string;
      format: string;
      size: any;
      title?: string | null;
      url: string;
      uploadId: any;
    } | null;
  }>;
};

export type BrandsBlockFragment = {
  __typename?: 'BrandsBlockRecord';
  id: any;
  title?: string | null;
  introText?: string | null;
  hideLabels?: any | null;
  brands: Array<{
    __typename?: 'BrandPageRecord';
    id: any;
    brandName?: string | null;
    slug?: string | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      tags: Array<string>;
      title?: string | null;
      url: string;
      width?: any | null;
      height?: any | null;
      format: string;
      responsiveImage?: {
        __typename?: 'ResponsiveImage';
        aspectRatio: any;
        base64?: string | null;
        bgColor?: string | null;
        height: any;
        sizes: string;
        src: string;
        srcSet: string;
        webpSrcSet: string;
        width: any;
      } | null;
    } | null;
    imageLoad?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
  }>;
};

export type BulletListBlockFragment = {
  __typename?: 'BulletListRecord';
  id: any;
  bullets?: string | null;
  numberedList?: any | null;
  title?: string | null;
};

export type CtaButtonFragment = {
  __typename?: 'CtaButtonRecord';
  id: any;
  text?: string | null;
  url?: string | null;
  variant?: string | null;
};

export type DocumentLinkBlockFragment = {
  __typename?: 'DocumentLinkBlockRecord';
  id: any;
  documents: Array<{
    __typename?: 'FileField';
    alt?: string | null;
    filename: string;
    format: string;
    size: any;
    title?: string | null;
    url: string;
    uploadId: any;
  }>;
};

export type EmployeeBlockFragment = {
  __typename?: 'EmployeeRecord';
  id: any;
  name?: string | null;
  title?: string | null;
  introText?: string | null;
  description?: string | null;
  image?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
};

export type FooterMenuItemFragment = {
  __typename?: 'FooterMenuItemRecord';
  heading?: string | null;
  includeCookieToggle?: any | null;
  links: Array<{
    __typename?: 'LinkRecord';
    url?: string | null;
    title?: string | null;
  }>;
};

export type GridContainerBlockFragment = {
  __typename?: 'GridContainerBlockRecord';
  id: any;
  fullwidth?: any | null;
  gap?: any | null;
  backgroundColor?: { __typename?: 'ColorField'; hex: string } | null;
  textColor?: { __typename?: 'ColorField'; hex: string } | null;
  content: Array<
    | {
        __typename?: 'GridFourcolBlockRecord';
        id: any;
        content: Array<
          | {
              __typename?: 'ImageRecord';
              id: any;
              fullWidth?: any | null;
              image?: {
                __typename?: 'FileField';
                alt?: string | null;
                responsiveImage?: {
                  __typename?: 'ResponsiveImage';
                  aspectRatio: any;
                  base64?: string | null;
                  bgColor?: string | null;
                  height: any;
                  sizes: string;
                  src: string;
                  srcSet: string;
                  webpSrcSet: string;
                  width: any;
                } | null;
              } | null;
              imageLoad?: {
                __typename?: 'FileField';
                alt?: string | null;
                title?: string | null;
                url: string;
                blurUpThumb?: string | null;
                focalPoint?: {
                  __typename?: 'focalPoint';
                  x: any;
                  y: any;
                } | null;
                colors: Array<{ __typename?: 'ColorField'; hex: string }>;
              } | null;
            }
          | {
              __typename?: 'MediaWithCaptionRecord';
              id: any;
              centerText?: any | null;
              textOnImage?: any | null;
              media?: {
                __typename?: 'ImageRecord';
                id: any;
                fullWidth?: any | null;
                image?: {
                  __typename?: 'FileField';
                  alt?: string | null;
                  responsiveImage?: {
                    __typename?: 'ResponsiveImage';
                    aspectRatio: any;
                    base64?: string | null;
                    bgColor?: string | null;
                    height: any;
                    sizes: string;
                    src: string;
                    srcSet: string;
                    webpSrcSet: string;
                    width: any;
                  } | null;
                } | null;
                imageLoad?: {
                  __typename?: 'FileField';
                  alt?: string | null;
                  title?: string | null;
                  url: string;
                  blurUpThumb?: string | null;
                  focalPoint?: {
                    __typename?: 'focalPoint';
                    x: any;
                    y: any;
                  } | null;
                  colors: Array<{ __typename?: 'ColorField'; hex: string }>;
                } | null;
              } | null;
              caption?: {
                __typename?: 'TextBlockRecord';
                id: any;
                smallHeader?: any | null;
                header?: string | null;
                text?: string | null;
                introText?: string | null;
                ctaButtons: Array<{
                  __typename?: 'CtaButtonRecord';
                  id: any;
                  text?: string | null;
                  url?: string | null;
                  variant?: string | null;
                }>;
              } | null;
            }
          | {
              __typename?: 'TextBlockRecord';
              id: any;
              smallHeader?: any | null;
              header?: string | null;
              text?: string | null;
              introText?: string | null;
              ctaButtons: Array<{
                __typename?: 'CtaButtonRecord';
                id: any;
                text?: string | null;
                url?: string | null;
                variant?: string | null;
              }>;
            }
        >;
      }
    | {
        __typename?: 'GridThreecolBlockRecord';
        id: any;
        content: Array<
          | {
              __typename?: 'GridTwocolBlockRecord';
              id: any;
              content: Array<
                | {
                    __typename?: 'ImageRecord';
                    id: any;
                    fullWidth?: any | null;
                    image?: {
                      __typename?: 'FileField';
                      alt?: string | null;
                      responsiveImage?: {
                        __typename?: 'ResponsiveImage';
                        aspectRatio: any;
                        base64?: string | null;
                        bgColor?: string | null;
                        height: any;
                        sizes: string;
                        src: string;
                        srcSet: string;
                        webpSrcSet: string;
                        width: any;
                      } | null;
                    } | null;
                    imageLoad?: {
                      __typename?: 'FileField';
                      alt?: string | null;
                      title?: string | null;
                      url: string;
                      blurUpThumb?: string | null;
                      focalPoint?: {
                        __typename?: 'focalPoint';
                        x: any;
                        y: any;
                      } | null;
                      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
                    } | null;
                  }
                | {
                    __typename?: 'MediaWithCaptionRecord';
                    id: any;
                    centerText?: any | null;
                    textOnImage?: any | null;
                    media?: {
                      __typename?: 'ImageRecord';
                      id: any;
                      fullWidth?: any | null;
                      image?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        responsiveImage?: {
                          __typename?: 'ResponsiveImage';
                          aspectRatio: any;
                          base64?: string | null;
                          bgColor?: string | null;
                          height: any;
                          sizes: string;
                          src: string;
                          srcSet: string;
                          webpSrcSet: string;
                          width: any;
                        } | null;
                      } | null;
                      imageLoad?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        title?: string | null;
                        url: string;
                        blurUpThumb?: string | null;
                        focalPoint?: {
                          __typename?: 'focalPoint';
                          x: any;
                          y: any;
                        } | null;
                        colors: Array<{
                          __typename?: 'ColorField';
                          hex: string;
                        }>;
                      } | null;
                    } | null;
                    caption?: {
                      __typename?: 'TextBlockRecord';
                      id: any;
                      smallHeader?: any | null;
                      header?: string | null;
                      text?: string | null;
                      introText?: string | null;
                      ctaButtons: Array<{
                        __typename?: 'CtaButtonRecord';
                        id: any;
                        text?: string | null;
                        url?: string | null;
                        variant?: string | null;
                      }>;
                    } | null;
                  }
                | {
                    __typename?: 'NewsListBlockRecord';
                    id: any;
                    title?: string | null;
                    standalone?: any | null;
                    largeTitle?: any | null;
                    itemsToShow?: any | null;
                  }
                | {
                    __typename?: 'ReportsListBlockRecord';
                    id: any;
                    title?: string | null;
                    standalone?: any | null;
                    largeTitle?: any | null;
                  }
                | {
                    __typename?: 'TextBlockRecord';
                    id: any;
                    smallHeader?: any | null;
                    header?: string | null;
                    text?: string | null;
                    introText?: string | null;
                    ctaButtons: Array<{
                      __typename?: 'CtaButtonRecord';
                      id: any;
                      text?: string | null;
                      url?: string | null;
                      variant?: string | null;
                    }>;
                  }
              >;
            }
          | {
              __typename?: 'ImageRecord';
              id: any;
              fullWidth?: any | null;
              image?: {
                __typename?: 'FileField';
                alt?: string | null;
                responsiveImage?: {
                  __typename?: 'ResponsiveImage';
                  aspectRatio: any;
                  base64?: string | null;
                  bgColor?: string | null;
                  height: any;
                  sizes: string;
                  src: string;
                  srcSet: string;
                  webpSrcSet: string;
                  width: any;
                } | null;
              } | null;
              imageLoad?: {
                __typename?: 'FileField';
                alt?: string | null;
                title?: string | null;
                url: string;
                blurUpThumb?: string | null;
                focalPoint?: {
                  __typename?: 'focalPoint';
                  x: any;
                  y: any;
                } | null;
                colors: Array<{ __typename?: 'ColorField'; hex: string }>;
              } | null;
            }
          | {
              __typename?: 'MediaWithCaptionRecord';
              id: any;
              centerText?: any | null;
              textOnImage?: any | null;
              media?: {
                __typename?: 'ImageRecord';
                id: any;
                fullWidth?: any | null;
                image?: {
                  __typename?: 'FileField';
                  alt?: string | null;
                  responsiveImage?: {
                    __typename?: 'ResponsiveImage';
                    aspectRatio: any;
                    base64?: string | null;
                    bgColor?: string | null;
                    height: any;
                    sizes: string;
                    src: string;
                    srcSet: string;
                    webpSrcSet: string;
                    width: any;
                  } | null;
                } | null;
                imageLoad?: {
                  __typename?: 'FileField';
                  alt?: string | null;
                  title?: string | null;
                  url: string;
                  blurUpThumb?: string | null;
                  focalPoint?: {
                    __typename?: 'focalPoint';
                    x: any;
                    y: any;
                  } | null;
                  colors: Array<{ __typename?: 'ColorField'; hex: string }>;
                } | null;
              } | null;
              caption?: {
                __typename?: 'TextBlockRecord';
                id: any;
                smallHeader?: any | null;
                header?: string | null;
                text?: string | null;
                introText?: string | null;
                ctaButtons: Array<{
                  __typename?: 'CtaButtonRecord';
                  id: any;
                  text?: string | null;
                  url?: string | null;
                  variant?: string | null;
                }>;
              } | null;
            }
          | {
              __typename?: 'TextBlockRecord';
              id: any;
              smallHeader?: any | null;
              header?: string | null;
              text?: string | null;
              introText?: string | null;
              ctaButtons: Array<{
                __typename?: 'CtaButtonRecord';
                id: any;
                text?: string | null;
                url?: string | null;
                variant?: string | null;
              }>;
            }
        >;
      }
    | {
        __typename?: 'GridTwocolBlockRecord';
        id: any;
        content: Array<
          | {
              __typename?: 'ImageRecord';
              id: any;
              fullWidth?: any | null;
              image?: {
                __typename?: 'FileField';
                alt?: string | null;
                responsiveImage?: {
                  __typename?: 'ResponsiveImage';
                  aspectRatio: any;
                  base64?: string | null;
                  bgColor?: string | null;
                  height: any;
                  sizes: string;
                  src: string;
                  srcSet: string;
                  webpSrcSet: string;
                  width: any;
                } | null;
              } | null;
              imageLoad?: {
                __typename?: 'FileField';
                alt?: string | null;
                title?: string | null;
                url: string;
                blurUpThumb?: string | null;
                focalPoint?: {
                  __typename?: 'focalPoint';
                  x: any;
                  y: any;
                } | null;
                colors: Array<{ __typename?: 'ColorField'; hex: string }>;
              } | null;
            }
          | {
              __typename?: 'MediaWithCaptionRecord';
              id: any;
              centerText?: any | null;
              textOnImage?: any | null;
              media?: {
                __typename?: 'ImageRecord';
                id: any;
                fullWidth?: any | null;
                image?: {
                  __typename?: 'FileField';
                  alt?: string | null;
                  responsiveImage?: {
                    __typename?: 'ResponsiveImage';
                    aspectRatio: any;
                    base64?: string | null;
                    bgColor?: string | null;
                    height: any;
                    sizes: string;
                    src: string;
                    srcSet: string;
                    webpSrcSet: string;
                    width: any;
                  } | null;
                } | null;
                imageLoad?: {
                  __typename?: 'FileField';
                  alt?: string | null;
                  title?: string | null;
                  url: string;
                  blurUpThumb?: string | null;
                  focalPoint?: {
                    __typename?: 'focalPoint';
                    x: any;
                    y: any;
                  } | null;
                  colors: Array<{ __typename?: 'ColorField'; hex: string }>;
                } | null;
              } | null;
              caption?: {
                __typename?: 'TextBlockRecord';
                id: any;
                smallHeader?: any | null;
                header?: string | null;
                text?: string | null;
                introText?: string | null;
                ctaButtons: Array<{
                  __typename?: 'CtaButtonRecord';
                  id: any;
                  text?: string | null;
                  url?: string | null;
                  variant?: string | null;
                }>;
              } | null;
            }
          | {
              __typename?: 'NewsListBlockRecord';
              id: any;
              title?: string | null;
              standalone?: any | null;
              largeTitle?: any | null;
              itemsToShow?: any | null;
            }
          | {
              __typename?: 'ReportsListBlockRecord';
              id: any;
              title?: string | null;
              standalone?: any | null;
              largeTitle?: any | null;
            }
          | {
              __typename?: 'TextBlockRecord';
              id: any;
              smallHeader?: any | null;
              header?: string | null;
              text?: string | null;
              introText?: string | null;
              ctaButtons: Array<{
                __typename?: 'CtaButtonRecord';
                id: any;
                text?: string | null;
                url?: string | null;
                variant?: string | null;
              }>;
            }
        >;
      }
  >;
};

export type GridFourColBlockFragment = {
  __typename?: 'GridFourcolBlockRecord';
  id: any;
  content: Array<
    | {
        __typename?: 'ImageRecord';
        id: any;
        fullWidth?: any | null;
        image?: {
          __typename?: 'FileField';
          alt?: string | null;
          responsiveImage?: {
            __typename?: 'ResponsiveImage';
            aspectRatio: any;
            base64?: string | null;
            bgColor?: string | null;
            height: any;
            sizes: string;
            src: string;
            srcSet: string;
            webpSrcSet: string;
            width: any;
          } | null;
        } | null;
        imageLoad?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
      }
    | {
        __typename?: 'MediaWithCaptionRecord';
        id: any;
        centerText?: any | null;
        textOnImage?: any | null;
        media?: {
          __typename?: 'ImageRecord';
          id: any;
          fullWidth?: any | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageLoad?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
        } | null;
        caption?: {
          __typename?: 'TextBlockRecord';
          id: any;
          smallHeader?: any | null;
          header?: string | null;
          text?: string | null;
          introText?: string | null;
          ctaButtons: Array<{
            __typename?: 'CtaButtonRecord';
            id: any;
            text?: string | null;
            url?: string | null;
            variant?: string | null;
          }>;
        } | null;
      }
    | {
        __typename?: 'TextBlockRecord';
        id: any;
        smallHeader?: any | null;
        header?: string | null;
        text?: string | null;
        introText?: string | null;
        ctaButtons: Array<{
          __typename?: 'CtaButtonRecord';
          id: any;
          text?: string | null;
          url?: string | null;
          variant?: string | null;
        }>;
      }
  >;
};

export type GridThreeColBlockFragment = {
  __typename?: 'GridThreecolBlockRecord';
  id: any;
  content: Array<
    | {
        __typename?: 'GridTwocolBlockRecord';
        id: any;
        content: Array<
          | {
              __typename?: 'ImageRecord';
              id: any;
              fullWidth?: any | null;
              image?: {
                __typename?: 'FileField';
                alt?: string | null;
                responsiveImage?: {
                  __typename?: 'ResponsiveImage';
                  aspectRatio: any;
                  base64?: string | null;
                  bgColor?: string | null;
                  height: any;
                  sizes: string;
                  src: string;
                  srcSet: string;
                  webpSrcSet: string;
                  width: any;
                } | null;
              } | null;
              imageLoad?: {
                __typename?: 'FileField';
                alt?: string | null;
                title?: string | null;
                url: string;
                blurUpThumb?: string | null;
                focalPoint?: {
                  __typename?: 'focalPoint';
                  x: any;
                  y: any;
                } | null;
                colors: Array<{ __typename?: 'ColorField'; hex: string }>;
              } | null;
            }
          | {
              __typename?: 'MediaWithCaptionRecord';
              id: any;
              centerText?: any | null;
              textOnImage?: any | null;
              media?: {
                __typename?: 'ImageRecord';
                id: any;
                fullWidth?: any | null;
                image?: {
                  __typename?: 'FileField';
                  alt?: string | null;
                  responsiveImage?: {
                    __typename?: 'ResponsiveImage';
                    aspectRatio: any;
                    base64?: string | null;
                    bgColor?: string | null;
                    height: any;
                    sizes: string;
                    src: string;
                    srcSet: string;
                    webpSrcSet: string;
                    width: any;
                  } | null;
                } | null;
                imageLoad?: {
                  __typename?: 'FileField';
                  alt?: string | null;
                  title?: string | null;
                  url: string;
                  blurUpThumb?: string | null;
                  focalPoint?: {
                    __typename?: 'focalPoint';
                    x: any;
                    y: any;
                  } | null;
                  colors: Array<{ __typename?: 'ColorField'; hex: string }>;
                } | null;
              } | null;
              caption?: {
                __typename?: 'TextBlockRecord';
                id: any;
                smallHeader?: any | null;
                header?: string | null;
                text?: string | null;
                introText?: string | null;
                ctaButtons: Array<{
                  __typename?: 'CtaButtonRecord';
                  id: any;
                  text?: string | null;
                  url?: string | null;
                  variant?: string | null;
                }>;
              } | null;
            }
          | {
              __typename?: 'NewsListBlockRecord';
              id: any;
              title?: string | null;
              standalone?: any | null;
              largeTitle?: any | null;
              itemsToShow?: any | null;
            }
          | {
              __typename?: 'ReportsListBlockRecord';
              id: any;
              title?: string | null;
              standalone?: any | null;
              largeTitle?: any | null;
            }
          | {
              __typename?: 'TextBlockRecord';
              id: any;
              smallHeader?: any | null;
              header?: string | null;
              text?: string | null;
              introText?: string | null;
              ctaButtons: Array<{
                __typename?: 'CtaButtonRecord';
                id: any;
                text?: string | null;
                url?: string | null;
                variant?: string | null;
              }>;
            }
        >;
      }
    | {
        __typename?: 'ImageRecord';
        id: any;
        fullWidth?: any | null;
        image?: {
          __typename?: 'FileField';
          alt?: string | null;
          responsiveImage?: {
            __typename?: 'ResponsiveImage';
            aspectRatio: any;
            base64?: string | null;
            bgColor?: string | null;
            height: any;
            sizes: string;
            src: string;
            srcSet: string;
            webpSrcSet: string;
            width: any;
          } | null;
        } | null;
        imageLoad?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
      }
    | {
        __typename?: 'MediaWithCaptionRecord';
        id: any;
        centerText?: any | null;
        textOnImage?: any | null;
        media?: {
          __typename?: 'ImageRecord';
          id: any;
          fullWidth?: any | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageLoad?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
        } | null;
        caption?: {
          __typename?: 'TextBlockRecord';
          id: any;
          smallHeader?: any | null;
          header?: string | null;
          text?: string | null;
          introText?: string | null;
          ctaButtons: Array<{
            __typename?: 'CtaButtonRecord';
            id: any;
            text?: string | null;
            url?: string | null;
            variant?: string | null;
          }>;
        } | null;
      }
    | {
        __typename?: 'TextBlockRecord';
        id: any;
        smallHeader?: any | null;
        header?: string | null;
        text?: string | null;
        introText?: string | null;
        ctaButtons: Array<{
          __typename?: 'CtaButtonRecord';
          id: any;
          text?: string | null;
          url?: string | null;
          variant?: string | null;
        }>;
      }
  >;
};

export type GridTwoColBlockFragment = {
  __typename?: 'GridTwocolBlockRecord';
  id: any;
  content: Array<
    | {
        __typename?: 'ImageRecord';
        id: any;
        fullWidth?: any | null;
        image?: {
          __typename?: 'FileField';
          alt?: string | null;
          responsiveImage?: {
            __typename?: 'ResponsiveImage';
            aspectRatio: any;
            base64?: string | null;
            bgColor?: string | null;
            height: any;
            sizes: string;
            src: string;
            srcSet: string;
            webpSrcSet: string;
            width: any;
          } | null;
        } | null;
        imageLoad?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
      }
    | {
        __typename?: 'MediaWithCaptionRecord';
        id: any;
        centerText?: any | null;
        textOnImage?: any | null;
        media?: {
          __typename?: 'ImageRecord';
          id: any;
          fullWidth?: any | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageLoad?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
        } | null;
        caption?: {
          __typename?: 'TextBlockRecord';
          id: any;
          smallHeader?: any | null;
          header?: string | null;
          text?: string | null;
          introText?: string | null;
          ctaButtons: Array<{
            __typename?: 'CtaButtonRecord';
            id: any;
            text?: string | null;
            url?: string | null;
            variant?: string | null;
          }>;
        } | null;
      }
    | {
        __typename?: 'NewsListBlockRecord';
        id: any;
        title?: string | null;
        standalone?: any | null;
        largeTitle?: any | null;
        itemsToShow?: any | null;
      }
    | {
        __typename?: 'ReportsListBlockRecord';
        id: any;
        title?: string | null;
        standalone?: any | null;
        largeTitle?: any | null;
      }
    | {
        __typename?: 'TextBlockRecord';
        id: any;
        smallHeader?: any | null;
        header?: string | null;
        text?: string | null;
        introText?: string | null;
        ctaButtons: Array<{
          __typename?: 'CtaButtonRecord';
          id: any;
          text?: string | null;
          url?: string | null;
          variant?: string | null;
        }>;
      }
  >;
};

export type IconLinkFragment = {
  __typename?: 'IconLinkRecord';
  url?: string | null;
  icon?: {
    __typename?: 'FileField';
    alt?: string | null;
    tags: Array<string>;
    title?: string | null;
    url: string;
    width?: any | null;
    height?: any | null;
    format: string;
  } | null;
};

export type ImageBlockFragment = {
  __typename?: 'ImageRecord';
  id: any;
  fullWidth?: any | null;
  image?: {
    __typename?: 'FileField';
    alt?: string | null;
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  imageLoad?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
};

export type JobsListBlockFragment = {
  __typename?: 'JobsListBlockRecord';
  id: any;
  title?: string | null;
};

export type LinkFragment = {
  __typename?: 'LinkRecord';
  id: any;
  title?: string | null;
  url?: string | null;
};

export type NewsAndReportsListBlockFragment = {
  __typename?: 'NewsAndReportsListBlockRecord';
  newsTitle?: string | null;
  reportsTitle?: string | null;
  newsImage?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
  news: Array<{
    __typename?: 'NewsPageRecord';
    id: any;
    title?: string | null;
    slug?: string | null;
    publishDate?: any | null;
    category?: string | null;
  }>;
  reportsImage?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
  reports: Array<{
    __typename?: 'ReportsListingRecord';
    id: any;
    title?: string | null;
    slug?: string | null;
    publishDate?: any | null;
    category?: string | null;
    pdf?: {
      __typename?: 'FileField';
      alt?: string | null;
      filename: string;
      format: string;
      size: any;
      title?: string | null;
      url: string;
      uploadId: any;
    } | null;
  }>;
};

export type NewsListBlockFragment = {
  __typename?: 'NewsListBlockRecord';
  id: any;
  title?: string | null;
  standalone?: any | null;
  largeTitle?: any | null;
  itemsToShow?: any | null;
};

export type OfficesBlockFragment = {
  __typename?: 'OfficesBlockRecord';
  id: any;
  offices: Array<{
    __typename?: 'OfficeRecord';
    id: any;
    name?: string | null;
    address?: string | null;
    zipCode?: string | null;
    city?: string | null;
    country?: string | null;
    email?: string | null;
    websiteUrl?: string | null;
    phoneNumber?: string | null;
  }>;
};

export type PageNavigationBlockFragment = {
  __typename?: 'PageNavigationBlockRecord';
  id: any;
  label?: string | null;
  links: Array<{
    __typename?: 'LinkRecord';
    id: any;
    title?: string | null;
    url?: string | null;
  }>;
};

export type PlugBlockFragment = {
  __typename?: 'PlugBlockRecord';
  id: any;
  title?: string | null;
  description?: string | null;
  brands: Array<{
    __typename?: 'BrandPageRecord';
    id: any;
    brandName?: string | null;
    slug?: string | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      tags: Array<string>;
      title?: string | null;
      url: string;
      width?: any | null;
      height?: any | null;
      format: string;
      responsiveImage?: {
        __typename?: 'ResponsiveImage';
        aspectRatio: any;
        base64?: string | null;
        bgColor?: string | null;
        height: any;
        sizes: string;
        src: string;
        srcSet: string;
        webpSrcSet: string;
        width: any;
      } | null;
    } | null;
    imageLoad?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
  }>;
};

export type ReportsListBlockFragment = {
  __typename?: 'ReportsListBlockRecord';
  id: any;
  title?: string | null;
  standalone?: any | null;
  largeTitle?: any | null;
};

export type SimpleTitleAndTextBlockFragment = {
  __typename?: 'SimpleTitleAndTextBlockRecord';
  id: any;
  title?: string | null;
  topLabel?: string | null;
  description?: string | null;
};

export type SliderBlockFragment = {
  __typename?: 'SliderBlockRecord';
  title?: string | null;
  arrows?: any | null;
  slideAnimation?: any | null;
  delay?: any | null;
  dots?: any | null;
  heroes: Array<{
    __typename?: 'HeroBlockRecord';
    id: any;
    title?: string | null;
    description?: string | null;
    ctaText?: string | null;
    ctaUrl?: string | null;
    fullWidth?: any | null;
    boxColor?: { __typename?: 'ColorField'; hex: string } | null;
    textColor?: { __typename?: 'ColorField'; hex: string } | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
    imageOverlay?: {
      __typename?: 'OverlayRecord';
      id: any;
      opacity?: any | null;
      color?: { __typename?: 'ColorField'; hex: string } | null;
    } | null;
    ctaButtons: Array<{
      __typename?: 'CtaButtonRecord';
      id: any;
      text?: string | null;
      url?: string | null;
      variant?: string | null;
    }>;
    video?: {
      __typename?: 'FileField';
      blurUpThumb?: string | null;
      title?: string | null;
      alt?: string | null;
      video?: {
        __typename?: 'UploadVideoField';
        muxPlaybackId: string;
        width: any;
        height: any;
      } | null;
    } | null;
  }>;
};

export type StatementBlockFragment = {
  __typename?: 'StatementBlockRecord';
  id: any;
  text?: string | null;
  blackBackground?: any | null;
  header?: string | null;
  small?: any | null;
  linkText?: string | null;
  linkUrl?: string | null;
  imageMobile?: {
    __typename?: 'FileField';
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  imageTablet?: {
    __typename?: 'FileField';
    alt?: string | null;
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  imageDesktop?: {
    __typename?: 'FileField';
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  imageLoad?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
  imageOverlay?: {
    __typename?: 'OverlayRecord';
    id: any;
    opacity?: any | null;
    color?: { __typename?: 'ColorField'; hex: string } | null;
  } | null;
};

export type SubheadingBlockFragment = {
  __typename?: 'SubheadingBlockRecord';
  id: any;
  title?: string | null;
  text?: string | null;
  ctaButton?: {
    __typename?: 'CtaButtonRecord';
    id: any;
    text?: string | null;
    url?: string | null;
    variant?: string | null;
  } | null;
  backgroundColor?: { __typename?: 'ColorField'; hex: string } | null;
};

export type SustainabilityReportsBlockFragment = {
  __typename?: 'SustainabilityReportsBlockRecord';
  id: any;
  title?: string | null;
  reports: Array<{
    __typename?: 'FileField';
    alt?: string | null;
    filename: string;
    format: string;
    size: any;
    title?: string | null;
    url: string;
    uploadId: any;
  }>;
};

export type TextBlockFragment = {
  __typename?: 'TextBlockRecord';
  id: any;
  smallHeader?: any | null;
  header?: string | null;
  text?: string | null;
  introText?: string | null;
  ctaButtons: Array<{
    __typename?: 'CtaButtonRecord';
    id: any;
    text?: string | null;
    url?: string | null;
    variant?: string | null;
  }>;
};

export type TwoColumnImageAndTextBlockFragment = {
  __typename?: 'TwoColumnImageAndTextRecord';
  id: any;
  text?: string | null;
  title?: string | null;
  reverse?: any | null;
  image?: {
    __typename?: 'FileField';
    alt?: string | null;
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  imageLoad?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
};

export type TwoColumnTextIntroBlockFragment = {
  __typename?: 'TwoColumnTextIntroRecord';
  id: any;
  introText?: string | null;
  text?: string | null;
  header?: string | null;
};

export type VideoBlockFragment = {
  __typename?: 'VideoRecord';
  id: any;
  autoplay?: any | null;
  video?: {
    __typename?: 'FileField';
    title?: string | null;
    video?: {
      __typename?: 'UploadVideoField';
      mp4Url?: string | null;
      streamingUrl: string;
      thumbnailUrl: string;
      mp4Low?: string | null;
    } | null;
  } | null;
  videoThumbnail?: {
    __typename?: 'FileField';
    alt?: string | null;
    tags: Array<string>;
    title?: string | null;
    url: string;
    width?: any | null;
    height?: any | null;
    format: string;
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  muxVideo?: {
    __typename?: 'FileField';
    blurUpThumb?: string | null;
    title?: string | null;
    alt?: string | null;
    video?: {
      __typename?: 'UploadVideoField';
      muxPlaybackId: string;
      width: any;
      height: any;
    } | null;
  } | null;
};

export type BrandFragment = {
  __typename?: 'BrandPageRecord';
  id: any;
  brandName?: string | null;
  slug?: string | null;
  image?: {
    __typename?: 'FileField';
    alt?: string | null;
    tags: Array<string>;
    title?: string | null;
    url: string;
    width?: any | null;
    height?: any | null;
    format: string;
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  imageLoad?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
};

export type BulletListFragment = {
  __typename?: 'BulletListRecord';
  id: any;
  bullets?: string | null;
  numberedList?: any | null;
  title?: string | null;
};

export type DynamicContentImageFragment = {
  __typename?: 'ImageRecord';
  id: any;
  fullWidth?: any | null;
  image?: {
    __typename?: 'FileField';
    alt?: string | null;
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
};

export type EmployeeFragment = {
  __typename?: 'EmployeeRecord';
  id: any;
  name?: string | null;
  title?: string | null;
  introText?: string | null;
  description?: string | null;
  profileImage?: {
    __typename?: 'FileField';
    alt?: string | null;
    tags: Array<string>;
    title?: string | null;
    url: string;
    width?: any | null;
    height?: any | null;
    format: string;
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  image?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
};

export type FullscreenImageCtaFragment = {
  __typename?: 'FullscreenImageCtaRecord';
  id: any;
  header?: string | null;
  text?: string | null;
  ctaText?: string | null;
  ctaUrl?: string | null;
  imageMobile?: {
    __typename?: 'FileField';
    alt?: string | null;
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  imageTablet?: {
    __typename?: 'FileField';
    alt?: string | null;
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  image?: {
    __typename?: 'FileField';
    alt?: string | null;
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
};

export type TextFragment = {
  __typename?: 'TextBlockRecord';
  id: any;
  smallHeader?: any | null;
  header?: string | null;
  text?: string | null;
  introText?: string | null;
};

export type TwoColumnImageAndTextFragment = {
  __typename?: 'TwoColumnImageAndTextRecord';
  id: any;
  text?: string | null;
  title?: string | null;
  reverse?: any | null;
  image?: {
    __typename?: 'FileField';
    alt?: string | null;
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  imageLoad?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
};

export type TwoColumnTextIntroFragment = {
  __typename?: 'TwoColumnTextIntroRecord';
  id: any;
  introText?: string | null;
  text?: string | null;
  header?: string | null;
};

export type VideoFragment = {
  __typename?: 'VideoRecord';
  id: any;
  video?: {
    __typename?: 'FileField';
    title?: string | null;
    video?: {
      __typename?: 'UploadVideoField';
      mp4Url?: string | null;
      streamingUrl: string;
      thumbnailUrl: string;
      mp4Low?: string | null;
    } | null;
  } | null;
  videoThumbnail?: {
    __typename?: 'FileField';
    alt?: string | null;
    tags: Array<string>;
    title?: string | null;
    url: string;
    width?: any | null;
    height?: any | null;
    format: string;
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
};

export type FeatureToggleFragment = {
  __typename?: 'FeatureToggleRecord';
  landingPageContentArea?: any | null;
  newsPageContentArea?: any | null;
};

export type FooterFragment = {
  __typename?: 'FooterRecord';
  bottomIntro?: string | null;
  cookieSettings?: string | null;
  introText?: string | null;
  moreInfoText?: string | null;
  partnerLogin?: string | null;
  selectCountryLabel?: string | null;
  socialMediaLabel?: string | null;
  useNewFooter?: any | null;
  footerLogo?: {
    __typename?: 'FileField';
    alt?: string | null;
    tags: Array<string>;
    title?: string | null;
    url: string;
    width?: any | null;
    height?: any | null;
    format: string;
  } | null;
  hultaforsBrands: Array<{
    __typename?: 'LinkRecord';
    id: any;
    title?: string | null;
    url?: string | null;
  }>;
  menu: Array<{
    __typename?: 'LinkRecord';
    id: any;
    title?: string | null;
    url?: string | null;
  }>;
  menuItems: Array<{
    __typename?: 'FooterMenuItemRecord';
    heading?: string | null;
    includeCookieToggle?: any | null;
    links: Array<{
      __typename?: 'LinkRecord';
      url?: string | null;
      title?: string | null;
    }>;
  }>;
  socialMediaMenu: Array<{
    __typename?: 'IconLinkRecord';
    url?: string | null;
    icon?: {
      __typename?: 'FileField';
      alt?: string | null;
      tags: Array<string>;
      title?: string | null;
      url: string;
      width?: any | null;
      height?: any | null;
      format: string;
    } | null;
  }>;
};

export type GlobalContentFragment = {
  __typename?: 'GlobalRecord';
  changeLanguage?: string | null;
  closeLabel?: string | null;
  deadline?: string | null;
  errorMessage?: string | null;
  loading?: string | null;
  loadMoreNews?: string | null;
  localWebLabel?: string | null;
  menu?: string | null;
  moreNewsCta?: string | null;
  moreNewsHeader?: string | null;
  partnerPortalLabel?: string | null;
  partnerPortalUrl?: string | null;
  play?: string | null;
  shopLinkTitle?: string | null;
  shopLinkUrl?: string | null;
  showMoreJobsLabel?: string | null;
  viewOnMapLabel?: string | null;
  nextLabel?: string | null;
  previousLabel?: string | null;
  sliderNavigationLabel?: string | null;
  moreReportsCta?: string | null;
  loadMoreReports?: string | null;
  clearIconLabel?: string | null;
  searchIconLabel?: string | null;
  searchBoxPlaceholder?: string | null;
  viewAllButtonLabel?: string | null;
  searchResultsPageTitle?: string | null;
  firstPageLabel?: string | null;
  previousPageLabel?: string | null;
  nextPageLabel?: string | null;
  lastPageLabel?: string | null;
  goToPageLabel?: string | null;
  searchResultCount?: string | null;
  noSearchResults?: string | null;
  navigationLogo?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  languages: Array<{
    __typename?: 'LanguageRecord';
    name?: string | null;
    url?: string | null;
    flag?: string | null;
    symbol?: {
      __typename?: 'FileField';
      alt?: string | null;
      tags: Array<string>;
      title?: string | null;
      url: string;
      width?: any | null;
      height?: any | null;
      format: string;
    } | null;
  }>;
};

export type DynamicImageFragment = {
  __typename?: 'FileField';
  alt?: string | null;
  responsiveImage?: {
    __typename?: 'ResponsiveImage';
    aspectRatio: any;
    base64?: string | null;
    bgColor?: string | null;
    height: any;
    sizes: string;
    src: string;
    srcSet: string;
    webpSrcSet: string;
    width: any;
  } | null;
};

export type HeroImageDesktopFragment = {
  __typename?: 'FileField';
  alt?: string | null;
  responsiveImage?: {
    __typename?: 'ResponsiveImage';
    aspectRatio: any;
    base64?: string | null;
    bgColor?: string | null;
    height: any;
    sizes: string;
    src: string;
    srcSet: string;
    webpSrcSet: string;
    width: any;
  } | null;
};

export type HeroImageLandscapeFragment = {
  __typename?: 'FileField';
  alt?: string | null;
  responsiveImage?: {
    __typename?: 'ResponsiveImage';
    aspectRatio: any;
    base64?: string | null;
    bgColor?: string | null;
    height: any;
    sizes: string;
    src: string;
    srcSet: string;
    webpSrcSet: string;
    width: any;
  } | null;
};

export type HeroImageMobileFragment = {
  __typename?: 'FileField';
  alt?: string | null;
  responsiveImage?: {
    __typename?: 'ResponsiveImage';
    aspectRatio: any;
    base64?: string | null;
    bgColor?: string | null;
    height: any;
    sizes: string;
    src: string;
    srcSet: string;
    webpSrcSet: string;
    width: any;
  } | null;
};

export type HeroImagePortraitFragment = {
  __typename?: 'FileField';
  alt?: string | null;
  responsiveImage?: {
    __typename?: 'ResponsiveImage';
    aspectRatio: any;
    base64?: string | null;
    bgColor?: string | null;
    height: any;
    sizes: string;
    src: string;
    srcSet: string;
    webpSrcSet: string;
    width: any;
  } | null;
};

export type HeroImageTabletFragment = {
  __typename?: 'FileField';
  alt?: string | null;
  responsiveImage?: {
    __typename?: 'ResponsiveImage';
    aspectRatio: any;
    base64?: string | null;
    bgColor?: string | null;
    height: any;
    sizes: string;
    src: string;
    srcSet: string;
    webpSrcSet: string;
    width: any;
  } | null;
};

export type LogoFragment = {
  __typename?: 'FileField';
  alt?: string | null;
  responsiveImage?: {
    __typename?: 'ResponsiveImage';
    width: any;
    height: any;
    aspectRatio: any;
    base64?: string | null;
    bgColor?: string | null;
    sizes: string;
    src: string;
    srcSet: string;
    webpSrcSet: string;
  } | null;
};

export type JobOpportunitiesPageListingFragment = {
  __typename?: 'JobOpportunitiesPageRecord';
  id: any;
  slug?: string | null;
  title?: string | null;
  publishDate?: any | null;
  category?: string | null;
  country?: string | null;
  department?: string | null;
};

export type LanguageFragment = {
  __typename?: 'LanguageRecord';
  name?: string | null;
  url?: string | null;
  flag?: string | null;
  symbol?: {
    __typename?: 'FileField';
    alt?: string | null;
    tags: Array<string>;
    title?: string | null;
    url: string;
    width?: any | null;
    height?: any | null;
    format: string;
  } | null;
};

export type MediaWithCaptionFragment = {
  __typename?: 'MediaWithCaptionRecord';
  id: any;
  centerText?: any | null;
  textOnImage?: any | null;
  media?: {
    __typename?: 'ImageRecord';
    id: any;
    fullWidth?: any | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      responsiveImage?: {
        __typename?: 'ResponsiveImage';
        aspectRatio: any;
        base64?: string | null;
        bgColor?: string | null;
        height: any;
        sizes: string;
        src: string;
        srcSet: string;
        webpSrcSet: string;
        width: any;
      } | null;
    } | null;
    imageLoad?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
  } | null;
  caption?: {
    __typename?: 'TextBlockRecord';
    id: any;
    smallHeader?: any | null;
    header?: string | null;
    text?: string | null;
    introText?: string | null;
    ctaButtons: Array<{
      __typename?: 'CtaButtonRecord';
      id: any;
      text?: string | null;
      url?: string | null;
      variant?: string | null;
    }>;
  } | null;
};

export type MenuFragment = {
  __typename?: 'MenuRecord';
  menuItems: Array<{
    __typename?: 'MenuItemRecord';
    id: any;
    title?: string | null;
    url?: string | null;
    submenu?: {
      __typename?: 'SubmenuRecord';
      title?: string | null;
      menuItems: Array<{
        __typename?: 'ItemRecord';
        title?: string | null;
        pageLink?:
          | { __typename?: 'AboutUsPageRecord'; slug?: string | null }
          | { __typename?: 'BrandPageRecord'; slug?: string | null }
          | { __typename?: 'SustainabilityPageRecord'; slug?: string | null }
          | null;
      }>;
    } | null;
  }>;
};

export type MenuItemFragment = {
  __typename?: 'MenuItemRecord';
  id: any;
  title?: string | null;
  url?: string | null;
  submenu?: {
    __typename?: 'SubmenuRecord';
    title?: string | null;
    menuItems: Array<{
      __typename?: 'ItemRecord';
      title?: string | null;
      pageLink?:
        | { __typename?: 'AboutUsPageRecord'; slug?: string | null }
        | { __typename?: 'BrandPageRecord'; slug?: string | null }
        | { __typename?: 'SustainabilityPageRecord'; slug?: string | null }
        | null;
    }>;
  } | null;
};

export type NewsPageListingFragment = {
  __typename?: 'NewsPageRecord';
  id: any;
  slug?: string | null;
  title?: string | null;
  publishDate?: any | null;
  category?: string | null;
  country?: string | null;
  image?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
};

export type OfficeFragment = {
  __typename?: 'OfficeRecord';
  id: any;
  name?: string | null;
  address?: string | null;
  zipCode?: string | null;
  city?: string | null;
  country?: string | null;
  email?: string | null;
  websiteUrl?: string | null;
  phoneNumber?: string | null;
};

export type OverlayFragment = {
  __typename?: 'OverlayRecord';
  id: any;
  opacity?: any | null;
  color?: { __typename?: 'ColorField'; hex: string } | null;
};

type AboutUsPageContentArea_ArticlesBlockRecord_Fragment = {
  __typename?: 'ArticlesBlockRecord';
  id: any;
  title?: string | null;
  isJobArticles?: any | null;
  ctaText?: string | null;
  ctaUrl?: string | null;
  jobPages: Array<{
    __typename?: 'JobOpportunitiesPageRecord';
    id: any;
    slug?: string | null;
    title?: string | null;
    publishDate?: any | null;
    category?: string | null;
    country?: string | null;
    department?: string | null;
  }>;
  newsPages: Array<{
    __typename?: 'NewsPageRecord';
    id: any;
    slug?: string | null;
    title?: string | null;
    publishDate?: any | null;
    category?: string | null;
    country?: string | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
  }>;
  reportPages: Array<{
    __typename?: 'ReportsListingRecord';
    id: any;
    slug?: string | null;
    title?: string | null;
    publishDate?: any | null;
    category?: string | null;
    country?: string | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
    pdf?: {
      __typename?: 'FileField';
      alt?: string | null;
      filename: string;
      format: string;
      size: any;
      title?: string | null;
      url: string;
      uploadId: any;
    } | null;
  }>;
};

type AboutUsPageContentArea_BrandsBlockRecord_Fragment = {
  __typename?: 'BrandsBlockRecord';
  id: any;
  title?: string | null;
  introText?: string | null;
  hideLabels?: any | null;
  brands: Array<{
    __typename?: 'BrandPageRecord';
    id: any;
    brandName?: string | null;
    slug?: string | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      tags: Array<string>;
      title?: string | null;
      url: string;
      width?: any | null;
      height?: any | null;
      format: string;
      responsiveImage?: {
        __typename?: 'ResponsiveImage';
        aspectRatio: any;
        base64?: string | null;
        bgColor?: string | null;
        height: any;
        sizes: string;
        src: string;
        srcSet: string;
        webpSrcSet: string;
        width: any;
      } | null;
    } | null;
    imageLoad?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
  }>;
};

type AboutUsPageContentArea_BulletListRecord_Fragment = {
  __typename?: 'BulletListRecord';
  id: any;
  bullets?: string | null;
  numberedList?: any | null;
  title?: string | null;
};

type AboutUsPageContentArea_DocumentLinkBlockRecord_Fragment = {
  __typename?: 'DocumentLinkBlockRecord';
  id: any;
  documents: Array<{
    __typename?: 'FileField';
    alt?: string | null;
    filename: string;
    format: string;
    size: any;
    title?: string | null;
    url: string;
    uploadId: any;
  }>;
};

type AboutUsPageContentArea_EmployeeRecord_Fragment = {
  __typename?: 'EmployeeRecord';
  id: any;
  name?: string | null;
  title?: string | null;
  introText?: string | null;
  description?: string | null;
  image?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
};

type AboutUsPageContentArea_GridContainerBlockRecord_Fragment = {
  __typename?: 'GridContainerBlockRecord';
  id: any;
  fullwidth?: any | null;
  gap?: any | null;
  backgroundColor?: { __typename?: 'ColorField'; hex: string } | null;
  textColor?: { __typename?: 'ColorField'; hex: string } | null;
  content: Array<
    | {
        __typename?: 'GridFourcolBlockRecord';
        id: any;
        content: Array<
          | {
              __typename?: 'ImageRecord';
              id: any;
              fullWidth?: any | null;
              image?: {
                __typename?: 'FileField';
                alt?: string | null;
                responsiveImage?: {
                  __typename?: 'ResponsiveImage';
                  aspectRatio: any;
                  base64?: string | null;
                  bgColor?: string | null;
                  height: any;
                  sizes: string;
                  src: string;
                  srcSet: string;
                  webpSrcSet: string;
                  width: any;
                } | null;
              } | null;
              imageLoad?: {
                __typename?: 'FileField';
                alt?: string | null;
                title?: string | null;
                url: string;
                blurUpThumb?: string | null;
                focalPoint?: {
                  __typename?: 'focalPoint';
                  x: any;
                  y: any;
                } | null;
                colors: Array<{ __typename?: 'ColorField'; hex: string }>;
              } | null;
            }
          | {
              __typename?: 'MediaWithCaptionRecord';
              id: any;
              centerText?: any | null;
              textOnImage?: any | null;
              media?: {
                __typename?: 'ImageRecord';
                id: any;
                fullWidth?: any | null;
                image?: {
                  __typename?: 'FileField';
                  alt?: string | null;
                  responsiveImage?: {
                    __typename?: 'ResponsiveImage';
                    aspectRatio: any;
                    base64?: string | null;
                    bgColor?: string | null;
                    height: any;
                    sizes: string;
                    src: string;
                    srcSet: string;
                    webpSrcSet: string;
                    width: any;
                  } | null;
                } | null;
                imageLoad?: {
                  __typename?: 'FileField';
                  alt?: string | null;
                  title?: string | null;
                  url: string;
                  blurUpThumb?: string | null;
                  focalPoint?: {
                    __typename?: 'focalPoint';
                    x: any;
                    y: any;
                  } | null;
                  colors: Array<{ __typename?: 'ColorField'; hex: string }>;
                } | null;
              } | null;
              caption?: {
                __typename?: 'TextBlockRecord';
                id: any;
                smallHeader?: any | null;
                header?: string | null;
                text?: string | null;
                introText?: string | null;
                ctaButtons: Array<{
                  __typename?: 'CtaButtonRecord';
                  id: any;
                  text?: string | null;
                  url?: string | null;
                  variant?: string | null;
                }>;
              } | null;
            }
          | {
              __typename?: 'TextBlockRecord';
              id: any;
              smallHeader?: any | null;
              header?: string | null;
              text?: string | null;
              introText?: string | null;
              ctaButtons: Array<{
                __typename?: 'CtaButtonRecord';
                id: any;
                text?: string | null;
                url?: string | null;
                variant?: string | null;
              }>;
            }
        >;
      }
    | {
        __typename?: 'GridThreecolBlockRecord';
        id: any;
        content: Array<
          | {
              __typename?: 'GridTwocolBlockRecord';
              id: any;
              content: Array<
                | {
                    __typename?: 'ImageRecord';
                    id: any;
                    fullWidth?: any | null;
                    image?: {
                      __typename?: 'FileField';
                      alt?: string | null;
                      responsiveImage?: {
                        __typename?: 'ResponsiveImage';
                        aspectRatio: any;
                        base64?: string | null;
                        bgColor?: string | null;
                        height: any;
                        sizes: string;
                        src: string;
                        srcSet: string;
                        webpSrcSet: string;
                        width: any;
                      } | null;
                    } | null;
                    imageLoad?: {
                      __typename?: 'FileField';
                      alt?: string | null;
                      title?: string | null;
                      url: string;
                      blurUpThumb?: string | null;
                      focalPoint?: {
                        __typename?: 'focalPoint';
                        x: any;
                        y: any;
                      } | null;
                      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
                    } | null;
                  }
                | {
                    __typename?: 'MediaWithCaptionRecord';
                    id: any;
                    centerText?: any | null;
                    textOnImage?: any | null;
                    media?: {
                      __typename?: 'ImageRecord';
                      id: any;
                      fullWidth?: any | null;
                      image?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        responsiveImage?: {
                          __typename?: 'ResponsiveImage';
                          aspectRatio: any;
                          base64?: string | null;
                          bgColor?: string | null;
                          height: any;
                          sizes: string;
                          src: string;
                          srcSet: string;
                          webpSrcSet: string;
                          width: any;
                        } | null;
                      } | null;
                      imageLoad?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        title?: string | null;
                        url: string;
                        blurUpThumb?: string | null;
                        focalPoint?: {
                          __typename?: 'focalPoint';
                          x: any;
                          y: any;
                        } | null;
                        colors: Array<{
                          __typename?: 'ColorField';
                          hex: string;
                        }>;
                      } | null;
                    } | null;
                    caption?: {
                      __typename?: 'TextBlockRecord';
                      id: any;
                      smallHeader?: any | null;
                      header?: string | null;
                      text?: string | null;
                      introText?: string | null;
                      ctaButtons: Array<{
                        __typename?: 'CtaButtonRecord';
                        id: any;
                        text?: string | null;
                        url?: string | null;
                        variant?: string | null;
                      }>;
                    } | null;
                  }
                | {
                    __typename?: 'NewsListBlockRecord';
                    id: any;
                    title?: string | null;
                    standalone?: any | null;
                    largeTitle?: any | null;
                    itemsToShow?: any | null;
                  }
                | {
                    __typename?: 'ReportsListBlockRecord';
                    id: any;
                    title?: string | null;
                    standalone?: any | null;
                    largeTitle?: any | null;
                  }
                | {
                    __typename?: 'TextBlockRecord';
                    id: any;
                    smallHeader?: any | null;
                    header?: string | null;
                    text?: string | null;
                    introText?: string | null;
                    ctaButtons: Array<{
                      __typename?: 'CtaButtonRecord';
                      id: any;
                      text?: string | null;
                      url?: string | null;
                      variant?: string | null;
                    }>;
                  }
              >;
            }
          | {
              __typename?: 'ImageRecord';
              id: any;
              fullWidth?: any | null;
              image?: {
                __typename?: 'FileField';
                alt?: string | null;
                responsiveImage?: {
                  __typename?: 'ResponsiveImage';
                  aspectRatio: any;
                  base64?: string | null;
                  bgColor?: string | null;
                  height: any;
                  sizes: string;
                  src: string;
                  srcSet: string;
                  webpSrcSet: string;
                  width: any;
                } | null;
              } | null;
              imageLoad?: {
                __typename?: 'FileField';
                alt?: string | null;
                title?: string | null;
                url: string;
                blurUpThumb?: string | null;
                focalPoint?: {
                  __typename?: 'focalPoint';
                  x: any;
                  y: any;
                } | null;
                colors: Array<{ __typename?: 'ColorField'; hex: string }>;
              } | null;
            }
          | {
              __typename?: 'MediaWithCaptionRecord';
              id: any;
              centerText?: any | null;
              textOnImage?: any | null;
              media?: {
                __typename?: 'ImageRecord';
                id: any;
                fullWidth?: any | null;
                image?: {
                  __typename?: 'FileField';
                  alt?: string | null;
                  responsiveImage?: {
                    __typename?: 'ResponsiveImage';
                    aspectRatio: any;
                    base64?: string | null;
                    bgColor?: string | null;
                    height: any;
                    sizes: string;
                    src: string;
                    srcSet: string;
                    webpSrcSet: string;
                    width: any;
                  } | null;
                } | null;
                imageLoad?: {
                  __typename?: 'FileField';
                  alt?: string | null;
                  title?: string | null;
                  url: string;
                  blurUpThumb?: string | null;
                  focalPoint?: {
                    __typename?: 'focalPoint';
                    x: any;
                    y: any;
                  } | null;
                  colors: Array<{ __typename?: 'ColorField'; hex: string }>;
                } | null;
              } | null;
              caption?: {
                __typename?: 'TextBlockRecord';
                id: any;
                smallHeader?: any | null;
                header?: string | null;
                text?: string | null;
                introText?: string | null;
                ctaButtons: Array<{
                  __typename?: 'CtaButtonRecord';
                  id: any;
                  text?: string | null;
                  url?: string | null;
                  variant?: string | null;
                }>;
              } | null;
            }
          | {
              __typename?: 'TextBlockRecord';
              id: any;
              smallHeader?: any | null;
              header?: string | null;
              text?: string | null;
              introText?: string | null;
              ctaButtons: Array<{
                __typename?: 'CtaButtonRecord';
                id: any;
                text?: string | null;
                url?: string | null;
                variant?: string | null;
              }>;
            }
        >;
      }
    | {
        __typename?: 'GridTwocolBlockRecord';
        id: any;
        content: Array<
          | {
              __typename?: 'ImageRecord';
              id: any;
              fullWidth?: any | null;
              image?: {
                __typename?: 'FileField';
                alt?: string | null;
                responsiveImage?: {
                  __typename?: 'ResponsiveImage';
                  aspectRatio: any;
                  base64?: string | null;
                  bgColor?: string | null;
                  height: any;
                  sizes: string;
                  src: string;
                  srcSet: string;
                  webpSrcSet: string;
                  width: any;
                } | null;
              } | null;
              imageLoad?: {
                __typename?: 'FileField';
                alt?: string | null;
                title?: string | null;
                url: string;
                blurUpThumb?: string | null;
                focalPoint?: {
                  __typename?: 'focalPoint';
                  x: any;
                  y: any;
                } | null;
                colors: Array<{ __typename?: 'ColorField'; hex: string }>;
              } | null;
            }
          | {
              __typename?: 'MediaWithCaptionRecord';
              id: any;
              centerText?: any | null;
              textOnImage?: any | null;
              media?: {
                __typename?: 'ImageRecord';
                id: any;
                fullWidth?: any | null;
                image?: {
                  __typename?: 'FileField';
                  alt?: string | null;
                  responsiveImage?: {
                    __typename?: 'ResponsiveImage';
                    aspectRatio: any;
                    base64?: string | null;
                    bgColor?: string | null;
                    height: any;
                    sizes: string;
                    src: string;
                    srcSet: string;
                    webpSrcSet: string;
                    width: any;
                  } | null;
                } | null;
                imageLoad?: {
                  __typename?: 'FileField';
                  alt?: string | null;
                  title?: string | null;
                  url: string;
                  blurUpThumb?: string | null;
                  focalPoint?: {
                    __typename?: 'focalPoint';
                    x: any;
                    y: any;
                  } | null;
                  colors: Array<{ __typename?: 'ColorField'; hex: string }>;
                } | null;
              } | null;
              caption?: {
                __typename?: 'TextBlockRecord';
                id: any;
                smallHeader?: any | null;
                header?: string | null;
                text?: string | null;
                introText?: string | null;
                ctaButtons: Array<{
                  __typename?: 'CtaButtonRecord';
                  id: any;
                  text?: string | null;
                  url?: string | null;
                  variant?: string | null;
                }>;
              } | null;
            }
          | {
              __typename?: 'NewsListBlockRecord';
              id: any;
              title?: string | null;
              standalone?: any | null;
              largeTitle?: any | null;
              itemsToShow?: any | null;
            }
          | {
              __typename?: 'ReportsListBlockRecord';
              id: any;
              title?: string | null;
              standalone?: any | null;
              largeTitle?: any | null;
            }
          | {
              __typename?: 'TextBlockRecord';
              id: any;
              smallHeader?: any | null;
              header?: string | null;
              text?: string | null;
              introText?: string | null;
              ctaButtons: Array<{
                __typename?: 'CtaButtonRecord';
                id: any;
                text?: string | null;
                url?: string | null;
                variant?: string | null;
              }>;
            }
        >;
      }
  >;
};

type AboutUsPageContentArea_HeroBlockRecord_Fragment = {
  __typename?: 'HeroBlockRecord';
  id: any;
  title?: string | null;
  description?: string | null;
  ctaText?: string | null;
  ctaUrl?: string | null;
  fullWidth?: any | null;
  boxColor?: { __typename?: 'ColorField'; hex: string } | null;
  textColor?: { __typename?: 'ColorField'; hex: string } | null;
  image?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
  imageOverlay?: {
    __typename?: 'OverlayRecord';
    id: any;
    opacity?: any | null;
    color?: { __typename?: 'ColorField'; hex: string } | null;
  } | null;
  ctaButtons: Array<{
    __typename?: 'CtaButtonRecord';
    id: any;
    text?: string | null;
    url?: string | null;
    variant?: string | null;
  }>;
  video?: {
    __typename?: 'FileField';
    blurUpThumb?: string | null;
    title?: string | null;
    alt?: string | null;
    video?: {
      __typename?: 'UploadVideoField';
      muxPlaybackId: string;
      width: any;
      height: any;
    } | null;
  } | null;
};

type AboutUsPageContentArea_ImageRecord_Fragment = {
  __typename?: 'ImageRecord';
  id: any;
  fullWidth?: any | null;
  image?: {
    __typename?: 'FileField';
    alt?: string | null;
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  imageLoad?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
};

type AboutUsPageContentArea_JobsListBlockRecord_Fragment = {
  __typename?: 'JobsListBlockRecord';
  id: any;
  title?: string | null;
};

type AboutUsPageContentArea_NewsAndReportsListBlockRecord_Fragment = {
  __typename?: 'NewsAndReportsListBlockRecord';
  newsTitle?: string | null;
  reportsTitle?: string | null;
  newsImage?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
  news: Array<{
    __typename?: 'NewsPageRecord';
    id: any;
    title?: string | null;
    slug?: string | null;
    publishDate?: any | null;
    category?: string | null;
  }>;
  reportsImage?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
  reports: Array<{
    __typename?: 'ReportsListingRecord';
    id: any;
    title?: string | null;
    slug?: string | null;
    publishDate?: any | null;
    category?: string | null;
    pdf?: {
      __typename?: 'FileField';
      alt?: string | null;
      filename: string;
      format: string;
      size: any;
      title?: string | null;
      url: string;
      uploadId: any;
    } | null;
  }>;
};

type AboutUsPageContentArea_NewsListBlockRecord_Fragment = {
  __typename?: 'NewsListBlockRecord';
  id: any;
  title?: string | null;
  standalone?: any | null;
  largeTitle?: any | null;
  itemsToShow?: any | null;
};

type AboutUsPageContentArea_OfficesBlockRecord_Fragment = {
  __typename?: 'OfficesBlockRecord';
  id: any;
  offices: Array<{
    __typename?: 'OfficeRecord';
    id: any;
    name?: string | null;
    address?: string | null;
    zipCode?: string | null;
    city?: string | null;
    country?: string | null;
    email?: string | null;
    websiteUrl?: string | null;
    phoneNumber?: string | null;
  }>;
};

type AboutUsPageContentArea_PlugBlockRecord_Fragment = {
  __typename?: 'PlugBlockRecord';
  id: any;
  title?: string | null;
  description?: string | null;
  brands: Array<{
    __typename?: 'BrandPageRecord';
    id: any;
    brandName?: string | null;
    slug?: string | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      tags: Array<string>;
      title?: string | null;
      url: string;
      width?: any | null;
      height?: any | null;
      format: string;
      responsiveImage?: {
        __typename?: 'ResponsiveImage';
        aspectRatio: any;
        base64?: string | null;
        bgColor?: string | null;
        height: any;
        sizes: string;
        src: string;
        srcSet: string;
        webpSrcSet: string;
        width: any;
      } | null;
    } | null;
    imageLoad?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
  }>;
};

type AboutUsPageContentArea_SimpleTitleAndTextBlockRecord_Fragment = {
  __typename?: 'SimpleTitleAndTextBlockRecord';
  id: any;
  title?: string | null;
  topLabel?: string | null;
  description?: string | null;
};

type AboutUsPageContentArea_SliderBlockRecord_Fragment = {
  __typename?: 'SliderBlockRecord';
  title?: string | null;
  arrows?: any | null;
  slideAnimation?: any | null;
  delay?: any | null;
  dots?: any | null;
  heroes: Array<{
    __typename?: 'HeroBlockRecord';
    id: any;
    title?: string | null;
    description?: string | null;
    ctaText?: string | null;
    ctaUrl?: string | null;
    fullWidth?: any | null;
    boxColor?: { __typename?: 'ColorField'; hex: string } | null;
    textColor?: { __typename?: 'ColorField'; hex: string } | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
    imageOverlay?: {
      __typename?: 'OverlayRecord';
      id: any;
      opacity?: any | null;
      color?: { __typename?: 'ColorField'; hex: string } | null;
    } | null;
    ctaButtons: Array<{
      __typename?: 'CtaButtonRecord';
      id: any;
      text?: string | null;
      url?: string | null;
      variant?: string | null;
    }>;
    video?: {
      __typename?: 'FileField';
      blurUpThumb?: string | null;
      title?: string | null;
      alt?: string | null;
      video?: {
        __typename?: 'UploadVideoField';
        muxPlaybackId: string;
        width: any;
        height: any;
      } | null;
    } | null;
  }>;
};

type AboutUsPageContentArea_StatementBlockRecord_Fragment = {
  __typename?: 'StatementBlockRecord';
  id: any;
  text?: string | null;
  blackBackground?: any | null;
  header?: string | null;
  small?: any | null;
  linkText?: string | null;
  linkUrl?: string | null;
  imageMobile?: {
    __typename?: 'FileField';
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  imageTablet?: {
    __typename?: 'FileField';
    alt?: string | null;
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  imageDesktop?: {
    __typename?: 'FileField';
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  imageLoad?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
  imageOverlay?: {
    __typename?: 'OverlayRecord';
    id: any;
    opacity?: any | null;
    color?: { __typename?: 'ColorField'; hex: string } | null;
  } | null;
};

type AboutUsPageContentArea_SubheadingBlockRecord_Fragment = {
  __typename?: 'SubheadingBlockRecord';
  id: any;
  title?: string | null;
  text?: string | null;
  ctaButton?: {
    __typename?: 'CtaButtonRecord';
    id: any;
    text?: string | null;
    url?: string | null;
    variant?: string | null;
  } | null;
  backgroundColor?: { __typename?: 'ColorField'; hex: string } | null;
};

type AboutUsPageContentArea_SustainabilityReportsBlockRecord_Fragment = {
  __typename?: 'SustainabilityReportsBlockRecord';
  id: any;
  title?: string | null;
  reports: Array<{
    __typename?: 'FileField';
    alt?: string | null;
    filename: string;
    format: string;
    size: any;
    title?: string | null;
    url: string;
    uploadId: any;
  }>;
};

type AboutUsPageContentArea_TextBlockRecord_Fragment = {
  __typename?: 'TextBlockRecord';
  id: any;
  smallHeader?: any | null;
  header?: string | null;
  text?: string | null;
  introText?: string | null;
  ctaButtons: Array<{
    __typename?: 'CtaButtonRecord';
    id: any;
    text?: string | null;
    url?: string | null;
    variant?: string | null;
  }>;
};

type AboutUsPageContentArea_TwoColumnImageAndTextRecord_Fragment = {
  __typename?: 'TwoColumnImageAndTextRecord';
  id: any;
  text?: string | null;
  title?: string | null;
  reverse?: any | null;
  image?: {
    __typename?: 'FileField';
    alt?: string | null;
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  imageLoad?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
};

type AboutUsPageContentArea_TwoColumnTextIntroRecord_Fragment = {
  __typename?: 'TwoColumnTextIntroRecord';
  id: any;
  introText?: string | null;
  text?: string | null;
  header?: string | null;
};

type AboutUsPageContentArea_VideoRecord_Fragment = {
  __typename?: 'VideoRecord';
  id: any;
  autoplay?: any | null;
  video?: {
    __typename?: 'FileField';
    title?: string | null;
    video?: {
      __typename?: 'UploadVideoField';
      mp4Url?: string | null;
      streamingUrl: string;
      thumbnailUrl: string;
      mp4Low?: string | null;
    } | null;
  } | null;
  videoThumbnail?: {
    __typename?: 'FileField';
    alt?: string | null;
    tags: Array<string>;
    title?: string | null;
    url: string;
    width?: any | null;
    height?: any | null;
    format: string;
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  muxVideo?: {
    __typename?: 'FileField';
    blurUpThumb?: string | null;
    title?: string | null;
    alt?: string | null;
    video?: {
      __typename?: 'UploadVideoField';
      muxPlaybackId: string;
      width: any;
      height: any;
    } | null;
  } | null;
};

export type AboutUsPageContentAreaFragment =
  | AboutUsPageContentArea_ArticlesBlockRecord_Fragment
  | AboutUsPageContentArea_BrandsBlockRecord_Fragment
  | AboutUsPageContentArea_BulletListRecord_Fragment
  | AboutUsPageContentArea_DocumentLinkBlockRecord_Fragment
  | AboutUsPageContentArea_EmployeeRecord_Fragment
  | AboutUsPageContentArea_GridContainerBlockRecord_Fragment
  | AboutUsPageContentArea_HeroBlockRecord_Fragment
  | AboutUsPageContentArea_ImageRecord_Fragment
  | AboutUsPageContentArea_JobsListBlockRecord_Fragment
  | AboutUsPageContentArea_NewsAndReportsListBlockRecord_Fragment
  | AboutUsPageContentArea_NewsListBlockRecord_Fragment
  | AboutUsPageContentArea_OfficesBlockRecord_Fragment
  | AboutUsPageContentArea_PlugBlockRecord_Fragment
  | AboutUsPageContentArea_SimpleTitleAndTextBlockRecord_Fragment
  | AboutUsPageContentArea_SliderBlockRecord_Fragment
  | AboutUsPageContentArea_StatementBlockRecord_Fragment
  | AboutUsPageContentArea_SubheadingBlockRecord_Fragment
  | AboutUsPageContentArea_SustainabilityReportsBlockRecord_Fragment
  | AboutUsPageContentArea_TextBlockRecord_Fragment
  | AboutUsPageContentArea_TwoColumnImageAndTextRecord_Fragment
  | AboutUsPageContentArea_TwoColumnTextIntroRecord_Fragment
  | AboutUsPageContentArea_VideoRecord_Fragment;

export type AboutUsPageContentFragment = {
  __typename?: 'AboutUsPageRecord';
  id: any;
  pageLocales: Array<SiteLocale>;
  seo?: {
    __typename?: 'SeoField';
    description?: string | null;
    title?: string | null;
    image?: {
      __typename?: 'FileField';
      url: string;
      alt?: string | null;
      title?: string | null;
    } | null;
  } | null;
  contentArea: Array<
    | {
        __typename?: 'ArticlesBlockRecord';
        id: any;
        title?: string | null;
        isJobArticles?: any | null;
        ctaText?: string | null;
        ctaUrl?: string | null;
        jobPages: Array<{
          __typename?: 'JobOpportunitiesPageRecord';
          id: any;
          slug?: string | null;
          title?: string | null;
          publishDate?: any | null;
          category?: string | null;
          country?: string | null;
          department?: string | null;
        }>;
        newsPages: Array<{
          __typename?: 'NewsPageRecord';
          id: any;
          slug?: string | null;
          title?: string | null;
          publishDate?: any | null;
          category?: string | null;
          country?: string | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
        }>;
        reportPages: Array<{
          __typename?: 'ReportsListingRecord';
          id: any;
          slug?: string | null;
          title?: string | null;
          publishDate?: any | null;
          category?: string | null;
          country?: string | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
          pdf?: {
            __typename?: 'FileField';
            alt?: string | null;
            filename: string;
            format: string;
            size: any;
            title?: string | null;
            url: string;
            uploadId: any;
          } | null;
        }>;
      }
    | {
        __typename?: 'BrandsBlockRecord';
        id: any;
        title?: string | null;
        introText?: string | null;
        hideLabels?: any | null;
        brands: Array<{
          __typename?: 'BrandPageRecord';
          id: any;
          brandName?: string | null;
          slug?: string | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            tags: Array<string>;
            title?: string | null;
            url: string;
            width?: any | null;
            height?: any | null;
            format: string;
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageLoad?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
        }>;
      }
    | {
        __typename?: 'BulletListRecord';
        id: any;
        bullets?: string | null;
        numberedList?: any | null;
        title?: string | null;
      }
    | {
        __typename?: 'DocumentLinkBlockRecord';
        id: any;
        documents: Array<{
          __typename?: 'FileField';
          alt?: string | null;
          filename: string;
          format: string;
          size: any;
          title?: string | null;
          url: string;
          uploadId: any;
        }>;
      }
    | {
        __typename?: 'EmployeeRecord';
        id: any;
        name?: string | null;
        title?: string | null;
        introText?: string | null;
        description?: string | null;
        image?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
      }
    | {
        __typename?: 'GridContainerBlockRecord';
        id: any;
        fullwidth?: any | null;
        gap?: any | null;
        backgroundColor?: { __typename?: 'ColorField'; hex: string } | null;
        textColor?: { __typename?: 'ColorField'; hex: string } | null;
        content: Array<
          | {
              __typename?: 'GridFourcolBlockRecord';
              id: any;
              content: Array<
                | {
                    __typename?: 'ImageRecord';
                    id: any;
                    fullWidth?: any | null;
                    image?: {
                      __typename?: 'FileField';
                      alt?: string | null;
                      responsiveImage?: {
                        __typename?: 'ResponsiveImage';
                        aspectRatio: any;
                        base64?: string | null;
                        bgColor?: string | null;
                        height: any;
                        sizes: string;
                        src: string;
                        srcSet: string;
                        webpSrcSet: string;
                        width: any;
                      } | null;
                    } | null;
                    imageLoad?: {
                      __typename?: 'FileField';
                      alt?: string | null;
                      title?: string | null;
                      url: string;
                      blurUpThumb?: string | null;
                      focalPoint?: {
                        __typename?: 'focalPoint';
                        x: any;
                        y: any;
                      } | null;
                      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
                    } | null;
                  }
                | {
                    __typename?: 'MediaWithCaptionRecord';
                    id: any;
                    centerText?: any | null;
                    textOnImage?: any | null;
                    media?: {
                      __typename?: 'ImageRecord';
                      id: any;
                      fullWidth?: any | null;
                      image?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        responsiveImage?: {
                          __typename?: 'ResponsiveImage';
                          aspectRatio: any;
                          base64?: string | null;
                          bgColor?: string | null;
                          height: any;
                          sizes: string;
                          src: string;
                          srcSet: string;
                          webpSrcSet: string;
                          width: any;
                        } | null;
                      } | null;
                      imageLoad?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        title?: string | null;
                        url: string;
                        blurUpThumb?: string | null;
                        focalPoint?: {
                          __typename?: 'focalPoint';
                          x: any;
                          y: any;
                        } | null;
                        colors: Array<{
                          __typename?: 'ColorField';
                          hex: string;
                        }>;
                      } | null;
                    } | null;
                    caption?: {
                      __typename?: 'TextBlockRecord';
                      id: any;
                      smallHeader?: any | null;
                      header?: string | null;
                      text?: string | null;
                      introText?: string | null;
                      ctaButtons: Array<{
                        __typename?: 'CtaButtonRecord';
                        id: any;
                        text?: string | null;
                        url?: string | null;
                        variant?: string | null;
                      }>;
                    } | null;
                  }
                | {
                    __typename?: 'TextBlockRecord';
                    id: any;
                    smallHeader?: any | null;
                    header?: string | null;
                    text?: string | null;
                    introText?: string | null;
                    ctaButtons: Array<{
                      __typename?: 'CtaButtonRecord';
                      id: any;
                      text?: string | null;
                      url?: string | null;
                      variant?: string | null;
                    }>;
                  }
              >;
            }
          | {
              __typename?: 'GridThreecolBlockRecord';
              id: any;
              content: Array<
                | {
                    __typename?: 'GridTwocolBlockRecord';
                    id: any;
                    content: Array<
                      | {
                          __typename?: 'ImageRecord';
                          id: any;
                          fullWidth?: any | null;
                          image?: {
                            __typename?: 'FileField';
                            alt?: string | null;
                            responsiveImage?: {
                              __typename?: 'ResponsiveImage';
                              aspectRatio: any;
                              base64?: string | null;
                              bgColor?: string | null;
                              height: any;
                              sizes: string;
                              src: string;
                              srcSet: string;
                              webpSrcSet: string;
                              width: any;
                            } | null;
                          } | null;
                          imageLoad?: {
                            __typename?: 'FileField';
                            alt?: string | null;
                            title?: string | null;
                            url: string;
                            blurUpThumb?: string | null;
                            focalPoint?: {
                              __typename?: 'focalPoint';
                              x: any;
                              y: any;
                            } | null;
                            colors: Array<{
                              __typename?: 'ColorField';
                              hex: string;
                            }>;
                          } | null;
                        }
                      | {
                          __typename?: 'MediaWithCaptionRecord';
                          id: any;
                          centerText?: any | null;
                          textOnImage?: any | null;
                          media?: {
                            __typename?: 'ImageRecord';
                            id: any;
                            fullWidth?: any | null;
                            image?: {
                              __typename?: 'FileField';
                              alt?: string | null;
                              responsiveImage?: {
                                __typename?: 'ResponsiveImage';
                                aspectRatio: any;
                                base64?: string | null;
                                bgColor?: string | null;
                                height: any;
                                sizes: string;
                                src: string;
                                srcSet: string;
                                webpSrcSet: string;
                                width: any;
                              } | null;
                            } | null;
                            imageLoad?: {
                              __typename?: 'FileField';
                              alt?: string | null;
                              title?: string | null;
                              url: string;
                              blurUpThumb?: string | null;
                              focalPoint?: {
                                __typename?: 'focalPoint';
                                x: any;
                                y: any;
                              } | null;
                              colors: Array<{
                                __typename?: 'ColorField';
                                hex: string;
                              }>;
                            } | null;
                          } | null;
                          caption?: {
                            __typename?: 'TextBlockRecord';
                            id: any;
                            smallHeader?: any | null;
                            header?: string | null;
                            text?: string | null;
                            introText?: string | null;
                            ctaButtons: Array<{
                              __typename?: 'CtaButtonRecord';
                              id: any;
                              text?: string | null;
                              url?: string | null;
                              variant?: string | null;
                            }>;
                          } | null;
                        }
                      | {
                          __typename?: 'NewsListBlockRecord';
                          id: any;
                          title?: string | null;
                          standalone?: any | null;
                          largeTitle?: any | null;
                          itemsToShow?: any | null;
                        }
                      | {
                          __typename?: 'ReportsListBlockRecord';
                          id: any;
                          title?: string | null;
                          standalone?: any | null;
                          largeTitle?: any | null;
                        }
                      | {
                          __typename?: 'TextBlockRecord';
                          id: any;
                          smallHeader?: any | null;
                          header?: string | null;
                          text?: string | null;
                          introText?: string | null;
                          ctaButtons: Array<{
                            __typename?: 'CtaButtonRecord';
                            id: any;
                            text?: string | null;
                            url?: string | null;
                            variant?: string | null;
                          }>;
                        }
                    >;
                  }
                | {
                    __typename?: 'ImageRecord';
                    id: any;
                    fullWidth?: any | null;
                    image?: {
                      __typename?: 'FileField';
                      alt?: string | null;
                      responsiveImage?: {
                        __typename?: 'ResponsiveImage';
                        aspectRatio: any;
                        base64?: string | null;
                        bgColor?: string | null;
                        height: any;
                        sizes: string;
                        src: string;
                        srcSet: string;
                        webpSrcSet: string;
                        width: any;
                      } | null;
                    } | null;
                    imageLoad?: {
                      __typename?: 'FileField';
                      alt?: string | null;
                      title?: string | null;
                      url: string;
                      blurUpThumb?: string | null;
                      focalPoint?: {
                        __typename?: 'focalPoint';
                        x: any;
                        y: any;
                      } | null;
                      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
                    } | null;
                  }
                | {
                    __typename?: 'MediaWithCaptionRecord';
                    id: any;
                    centerText?: any | null;
                    textOnImage?: any | null;
                    media?: {
                      __typename?: 'ImageRecord';
                      id: any;
                      fullWidth?: any | null;
                      image?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        responsiveImage?: {
                          __typename?: 'ResponsiveImage';
                          aspectRatio: any;
                          base64?: string | null;
                          bgColor?: string | null;
                          height: any;
                          sizes: string;
                          src: string;
                          srcSet: string;
                          webpSrcSet: string;
                          width: any;
                        } | null;
                      } | null;
                      imageLoad?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        title?: string | null;
                        url: string;
                        blurUpThumb?: string | null;
                        focalPoint?: {
                          __typename?: 'focalPoint';
                          x: any;
                          y: any;
                        } | null;
                        colors: Array<{
                          __typename?: 'ColorField';
                          hex: string;
                        }>;
                      } | null;
                    } | null;
                    caption?: {
                      __typename?: 'TextBlockRecord';
                      id: any;
                      smallHeader?: any | null;
                      header?: string | null;
                      text?: string | null;
                      introText?: string | null;
                      ctaButtons: Array<{
                        __typename?: 'CtaButtonRecord';
                        id: any;
                        text?: string | null;
                        url?: string | null;
                        variant?: string | null;
                      }>;
                    } | null;
                  }
                | {
                    __typename?: 'TextBlockRecord';
                    id: any;
                    smallHeader?: any | null;
                    header?: string | null;
                    text?: string | null;
                    introText?: string | null;
                    ctaButtons: Array<{
                      __typename?: 'CtaButtonRecord';
                      id: any;
                      text?: string | null;
                      url?: string | null;
                      variant?: string | null;
                    }>;
                  }
              >;
            }
          | {
              __typename?: 'GridTwocolBlockRecord';
              id: any;
              content: Array<
                | {
                    __typename?: 'ImageRecord';
                    id: any;
                    fullWidth?: any | null;
                    image?: {
                      __typename?: 'FileField';
                      alt?: string | null;
                      responsiveImage?: {
                        __typename?: 'ResponsiveImage';
                        aspectRatio: any;
                        base64?: string | null;
                        bgColor?: string | null;
                        height: any;
                        sizes: string;
                        src: string;
                        srcSet: string;
                        webpSrcSet: string;
                        width: any;
                      } | null;
                    } | null;
                    imageLoad?: {
                      __typename?: 'FileField';
                      alt?: string | null;
                      title?: string | null;
                      url: string;
                      blurUpThumb?: string | null;
                      focalPoint?: {
                        __typename?: 'focalPoint';
                        x: any;
                        y: any;
                      } | null;
                      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
                    } | null;
                  }
                | {
                    __typename?: 'MediaWithCaptionRecord';
                    id: any;
                    centerText?: any | null;
                    textOnImage?: any | null;
                    media?: {
                      __typename?: 'ImageRecord';
                      id: any;
                      fullWidth?: any | null;
                      image?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        responsiveImage?: {
                          __typename?: 'ResponsiveImage';
                          aspectRatio: any;
                          base64?: string | null;
                          bgColor?: string | null;
                          height: any;
                          sizes: string;
                          src: string;
                          srcSet: string;
                          webpSrcSet: string;
                          width: any;
                        } | null;
                      } | null;
                      imageLoad?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        title?: string | null;
                        url: string;
                        blurUpThumb?: string | null;
                        focalPoint?: {
                          __typename?: 'focalPoint';
                          x: any;
                          y: any;
                        } | null;
                        colors: Array<{
                          __typename?: 'ColorField';
                          hex: string;
                        }>;
                      } | null;
                    } | null;
                    caption?: {
                      __typename?: 'TextBlockRecord';
                      id: any;
                      smallHeader?: any | null;
                      header?: string | null;
                      text?: string | null;
                      introText?: string | null;
                      ctaButtons: Array<{
                        __typename?: 'CtaButtonRecord';
                        id: any;
                        text?: string | null;
                        url?: string | null;
                        variant?: string | null;
                      }>;
                    } | null;
                  }
                | {
                    __typename?: 'NewsListBlockRecord';
                    id: any;
                    title?: string | null;
                    standalone?: any | null;
                    largeTitle?: any | null;
                    itemsToShow?: any | null;
                  }
                | {
                    __typename?: 'ReportsListBlockRecord';
                    id: any;
                    title?: string | null;
                    standalone?: any | null;
                    largeTitle?: any | null;
                  }
                | {
                    __typename?: 'TextBlockRecord';
                    id: any;
                    smallHeader?: any | null;
                    header?: string | null;
                    text?: string | null;
                    introText?: string | null;
                    ctaButtons: Array<{
                      __typename?: 'CtaButtonRecord';
                      id: any;
                      text?: string | null;
                      url?: string | null;
                      variant?: string | null;
                    }>;
                  }
              >;
            }
        >;
      }
    | {
        __typename?: 'HeroBlockRecord';
        id: any;
        title?: string | null;
        description?: string | null;
        ctaText?: string | null;
        ctaUrl?: string | null;
        fullWidth?: any | null;
        boxColor?: { __typename?: 'ColorField'; hex: string } | null;
        textColor?: { __typename?: 'ColorField'; hex: string } | null;
        image?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
        imageOverlay?: {
          __typename?: 'OverlayRecord';
          id: any;
          opacity?: any | null;
          color?: { __typename?: 'ColorField'; hex: string } | null;
        } | null;
        ctaButtons: Array<{
          __typename?: 'CtaButtonRecord';
          id: any;
          text?: string | null;
          url?: string | null;
          variant?: string | null;
        }>;
        video?: {
          __typename?: 'FileField';
          blurUpThumb?: string | null;
          title?: string | null;
          alt?: string | null;
          video?: {
            __typename?: 'UploadVideoField';
            muxPlaybackId: string;
            width: any;
            height: any;
          } | null;
        } | null;
      }
    | {
        __typename?: 'ImageRecord';
        id: any;
        fullWidth?: any | null;
        image?: {
          __typename?: 'FileField';
          alt?: string | null;
          responsiveImage?: {
            __typename?: 'ResponsiveImage';
            aspectRatio: any;
            base64?: string | null;
            bgColor?: string | null;
            height: any;
            sizes: string;
            src: string;
            srcSet: string;
            webpSrcSet: string;
            width: any;
          } | null;
        } | null;
        imageLoad?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
      }
    | { __typename?: 'JobsListBlockRecord'; id: any; title?: string | null }
    | {
        __typename?: 'NewsAndReportsListBlockRecord';
        newsTitle?: string | null;
        reportsTitle?: string | null;
        newsImage?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
        news: Array<{
          __typename?: 'NewsPageRecord';
          id: any;
          title?: string | null;
          slug?: string | null;
          publishDate?: any | null;
          category?: string | null;
        }>;
        reportsImage?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
        reports: Array<{
          __typename?: 'ReportsListingRecord';
          id: any;
          title?: string | null;
          slug?: string | null;
          publishDate?: any | null;
          category?: string | null;
          pdf?: {
            __typename?: 'FileField';
            alt?: string | null;
            filename: string;
            format: string;
            size: any;
            title?: string | null;
            url: string;
            uploadId: any;
          } | null;
        }>;
      }
    | {
        __typename?: 'NewsListBlockRecord';
        id: any;
        title?: string | null;
        standalone?: any | null;
        largeTitle?: any | null;
        itemsToShow?: any | null;
      }
    | {
        __typename?: 'OfficesBlockRecord';
        id: any;
        offices: Array<{
          __typename?: 'OfficeRecord';
          id: any;
          name?: string | null;
          address?: string | null;
          zipCode?: string | null;
          city?: string | null;
          country?: string | null;
          email?: string | null;
          websiteUrl?: string | null;
          phoneNumber?: string | null;
        }>;
      }
    | {
        __typename?: 'PlugBlockRecord';
        id: any;
        title?: string | null;
        description?: string | null;
        brands: Array<{
          __typename?: 'BrandPageRecord';
          id: any;
          brandName?: string | null;
          slug?: string | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            tags: Array<string>;
            title?: string | null;
            url: string;
            width?: any | null;
            height?: any | null;
            format: string;
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageLoad?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
        }>;
      }
    | {
        __typename?: 'SimpleTitleAndTextBlockRecord';
        id: any;
        title?: string | null;
        topLabel?: string | null;
        description?: string | null;
      }
    | {
        __typename?: 'SliderBlockRecord';
        title?: string | null;
        arrows?: any | null;
        slideAnimation?: any | null;
        delay?: any | null;
        dots?: any | null;
        heroes: Array<{
          __typename?: 'HeroBlockRecord';
          id: any;
          title?: string | null;
          description?: string | null;
          ctaText?: string | null;
          ctaUrl?: string | null;
          fullWidth?: any | null;
          boxColor?: { __typename?: 'ColorField'; hex: string } | null;
          textColor?: { __typename?: 'ColorField'; hex: string } | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
          imageOverlay?: {
            __typename?: 'OverlayRecord';
            id: any;
            opacity?: any | null;
            color?: { __typename?: 'ColorField'; hex: string } | null;
          } | null;
          ctaButtons: Array<{
            __typename?: 'CtaButtonRecord';
            id: any;
            text?: string | null;
            url?: string | null;
            variant?: string | null;
          }>;
          video?: {
            __typename?: 'FileField';
            blurUpThumb?: string | null;
            title?: string | null;
            alt?: string | null;
            video?: {
              __typename?: 'UploadVideoField';
              muxPlaybackId: string;
              width: any;
              height: any;
            } | null;
          } | null;
        }>;
      }
    | {
        __typename?: 'StatementBlockRecord';
        id: any;
        text?: string | null;
        blackBackground?: any | null;
        header?: string | null;
        small?: any | null;
        linkText?: string | null;
        linkUrl?: string | null;
        imageMobile?: {
          __typename?: 'FileField';
          responsiveImage?: {
            __typename?: 'ResponsiveImage';
            aspectRatio: any;
            base64?: string | null;
            bgColor?: string | null;
            height: any;
            sizes: string;
            src: string;
            srcSet: string;
            webpSrcSet: string;
            width: any;
          } | null;
        } | null;
        imageTablet?: {
          __typename?: 'FileField';
          alt?: string | null;
          responsiveImage?: {
            __typename?: 'ResponsiveImage';
            aspectRatio: any;
            base64?: string | null;
            bgColor?: string | null;
            height: any;
            sizes: string;
            src: string;
            srcSet: string;
            webpSrcSet: string;
            width: any;
          } | null;
        } | null;
        imageDesktop?: {
          __typename?: 'FileField';
          responsiveImage?: {
            __typename?: 'ResponsiveImage';
            aspectRatio: any;
            base64?: string | null;
            bgColor?: string | null;
            height: any;
            sizes: string;
            src: string;
            srcSet: string;
            webpSrcSet: string;
            width: any;
          } | null;
        } | null;
        imageLoad?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
        imageOverlay?: {
          __typename?: 'OverlayRecord';
          id: any;
          opacity?: any | null;
          color?: { __typename?: 'ColorField'; hex: string } | null;
        } | null;
      }
    | {
        __typename?: 'SubheadingBlockRecord';
        id: any;
        title?: string | null;
        text?: string | null;
        ctaButton?: {
          __typename?: 'CtaButtonRecord';
          id: any;
          text?: string | null;
          url?: string | null;
          variant?: string | null;
        } | null;
        backgroundColor?: { __typename?: 'ColorField'; hex: string } | null;
      }
    | {
        __typename?: 'SustainabilityReportsBlockRecord';
        id: any;
        title?: string | null;
        reports: Array<{
          __typename?: 'FileField';
          alt?: string | null;
          filename: string;
          format: string;
          size: any;
          title?: string | null;
          url: string;
          uploadId: any;
        }>;
      }
    | {
        __typename?: 'TextBlockRecord';
        id: any;
        smallHeader?: any | null;
        header?: string | null;
        text?: string | null;
        introText?: string | null;
        ctaButtons: Array<{
          __typename?: 'CtaButtonRecord';
          id: any;
          text?: string | null;
          url?: string | null;
          variant?: string | null;
        }>;
      }
    | {
        __typename?: 'TwoColumnImageAndTextRecord';
        id: any;
        text?: string | null;
        title?: string | null;
        reverse?: any | null;
        image?: {
          __typename?: 'FileField';
          alt?: string | null;
          responsiveImage?: {
            __typename?: 'ResponsiveImage';
            aspectRatio: any;
            base64?: string | null;
            bgColor?: string | null;
            height: any;
            sizes: string;
            src: string;
            srcSet: string;
            webpSrcSet: string;
            width: any;
          } | null;
        } | null;
        imageLoad?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
      }
    | {
        __typename?: 'TwoColumnTextIntroRecord';
        id: any;
        introText?: string | null;
        text?: string | null;
        header?: string | null;
      }
    | {
        __typename?: 'VideoRecord';
        id: any;
        autoplay?: any | null;
        video?: {
          __typename?: 'FileField';
          title?: string | null;
          video?: {
            __typename?: 'UploadVideoField';
            mp4Url?: string | null;
            streamingUrl: string;
            thumbnailUrl: string;
            mp4Low?: string | null;
          } | null;
        } | null;
        videoThumbnail?: {
          __typename?: 'FileField';
          alt?: string | null;
          tags: Array<string>;
          title?: string | null;
          url: string;
          width?: any | null;
          height?: any | null;
          format: string;
          responsiveImage?: {
            __typename?: 'ResponsiveImage';
            aspectRatio: any;
            base64?: string | null;
            bgColor?: string | null;
            height: any;
            sizes: string;
            src: string;
            srcSet: string;
            webpSrcSet: string;
            width: any;
          } | null;
        } | null;
        muxVideo?: {
          __typename?: 'FileField';
          blurUpThumb?: string | null;
          title?: string | null;
          alt?: string | null;
          video?: {
            __typename?: 'UploadVideoField';
            muxPlaybackId: string;
            width: any;
            height: any;
          } | null;
        } | null;
      }
  >;
};

export type BrandPageContentFragment = {
  __typename?: 'BrandPageRecord';
  heroTitle?: string | null;
  linkToWebsite?: string | null;
  linkToWebsiteText?: string | null;
  brandName?: string | null;
  description?: string | null;
  slug?: string | null;
  pageLocales: Array<SiteLocale>;
  heroImage?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
  seo?: {
    __typename?: 'SeoField';
    description?: string | null;
    title?: string | null;
    image?: {
      __typename?: 'FileField';
      url: string;
      alt?: string | null;
      title?: string | null;
    } | null;
  } | null;
  logo?: {
    __typename?: 'FileField';
    alt?: string | null;
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      width: any;
      height: any;
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
    } | null;
  } | null;
};

type BrandsListPageContentArea_ArticlesBlockRecord_Fragment = {
  __typename?: 'ArticlesBlockRecord';
  id: any;
  title?: string | null;
  isJobArticles?: any | null;
  ctaText?: string | null;
  ctaUrl?: string | null;
  jobPages: Array<{
    __typename?: 'JobOpportunitiesPageRecord';
    id: any;
    slug?: string | null;
    title?: string | null;
    publishDate?: any | null;
    category?: string | null;
    country?: string | null;
    department?: string | null;
  }>;
  newsPages: Array<{
    __typename?: 'NewsPageRecord';
    id: any;
    slug?: string | null;
    title?: string | null;
    publishDate?: any | null;
    category?: string | null;
    country?: string | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
  }>;
  reportPages: Array<{
    __typename?: 'ReportsListingRecord';
    id: any;
    slug?: string | null;
    title?: string | null;
    publishDate?: any | null;
    category?: string | null;
    country?: string | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
    pdf?: {
      __typename?: 'FileField';
      alt?: string | null;
      filename: string;
      format: string;
      size: any;
      title?: string | null;
      url: string;
      uploadId: any;
    } | null;
  }>;
};

type BrandsListPageContentArea_BrandsBlockRecord_Fragment = {
  __typename?: 'BrandsBlockRecord';
  id: any;
  title?: string | null;
  introText?: string | null;
  hideLabels?: any | null;
  brands: Array<{
    __typename?: 'BrandPageRecord';
    id: any;
    brandName?: string | null;
    slug?: string | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      tags: Array<string>;
      title?: string | null;
      url: string;
      width?: any | null;
      height?: any | null;
      format: string;
      responsiveImage?: {
        __typename?: 'ResponsiveImage';
        aspectRatio: any;
        base64?: string | null;
        bgColor?: string | null;
        height: any;
        sizes: string;
        src: string;
        srcSet: string;
        webpSrcSet: string;
        width: any;
      } | null;
    } | null;
    imageLoad?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
  }>;
};

type BrandsListPageContentArea_BulletListRecord_Fragment = {
  __typename?: 'BulletListRecord';
  id: any;
  bullets?: string | null;
  numberedList?: any | null;
  title?: string | null;
};

type BrandsListPageContentArea_DocumentLinkBlockRecord_Fragment = {
  __typename?: 'DocumentLinkBlockRecord';
  id: any;
  documents: Array<{
    __typename?: 'FileField';
    alt?: string | null;
    filename: string;
    format: string;
    size: any;
    title?: string | null;
    url: string;
    uploadId: any;
  }>;
};

type BrandsListPageContentArea_EmployeeRecord_Fragment = {
  __typename?: 'EmployeeRecord';
  id: any;
  name?: string | null;
  title?: string | null;
  introText?: string | null;
  description?: string | null;
  image?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
};

type BrandsListPageContentArea_GridContainerBlockRecord_Fragment = {
  __typename?: 'GridContainerBlockRecord';
  id: any;
  fullwidth?: any | null;
  gap?: any | null;
  backgroundColor?: { __typename?: 'ColorField'; hex: string } | null;
  textColor?: { __typename?: 'ColorField'; hex: string } | null;
  content: Array<
    | {
        __typename?: 'GridFourcolBlockRecord';
        id: any;
        content: Array<
          | {
              __typename?: 'ImageRecord';
              id: any;
              fullWidth?: any | null;
              image?: {
                __typename?: 'FileField';
                alt?: string | null;
                responsiveImage?: {
                  __typename?: 'ResponsiveImage';
                  aspectRatio: any;
                  base64?: string | null;
                  bgColor?: string | null;
                  height: any;
                  sizes: string;
                  src: string;
                  srcSet: string;
                  webpSrcSet: string;
                  width: any;
                } | null;
              } | null;
              imageLoad?: {
                __typename?: 'FileField';
                alt?: string | null;
                title?: string | null;
                url: string;
                blurUpThumb?: string | null;
                focalPoint?: {
                  __typename?: 'focalPoint';
                  x: any;
                  y: any;
                } | null;
                colors: Array<{ __typename?: 'ColorField'; hex: string }>;
              } | null;
            }
          | {
              __typename?: 'MediaWithCaptionRecord';
              id: any;
              centerText?: any | null;
              textOnImage?: any | null;
              media?: {
                __typename?: 'ImageRecord';
                id: any;
                fullWidth?: any | null;
                image?: {
                  __typename?: 'FileField';
                  alt?: string | null;
                  responsiveImage?: {
                    __typename?: 'ResponsiveImage';
                    aspectRatio: any;
                    base64?: string | null;
                    bgColor?: string | null;
                    height: any;
                    sizes: string;
                    src: string;
                    srcSet: string;
                    webpSrcSet: string;
                    width: any;
                  } | null;
                } | null;
                imageLoad?: {
                  __typename?: 'FileField';
                  alt?: string | null;
                  title?: string | null;
                  url: string;
                  blurUpThumb?: string | null;
                  focalPoint?: {
                    __typename?: 'focalPoint';
                    x: any;
                    y: any;
                  } | null;
                  colors: Array<{ __typename?: 'ColorField'; hex: string }>;
                } | null;
              } | null;
              caption?: {
                __typename?: 'TextBlockRecord';
                id: any;
                smallHeader?: any | null;
                header?: string | null;
                text?: string | null;
                introText?: string | null;
                ctaButtons: Array<{
                  __typename?: 'CtaButtonRecord';
                  id: any;
                  text?: string | null;
                  url?: string | null;
                  variant?: string | null;
                }>;
              } | null;
            }
          | {
              __typename?: 'TextBlockRecord';
              id: any;
              smallHeader?: any | null;
              header?: string | null;
              text?: string | null;
              introText?: string | null;
              ctaButtons: Array<{
                __typename?: 'CtaButtonRecord';
                id: any;
                text?: string | null;
                url?: string | null;
                variant?: string | null;
              }>;
            }
        >;
      }
    | {
        __typename?: 'GridThreecolBlockRecord';
        id: any;
        content: Array<
          | {
              __typename?: 'GridTwocolBlockRecord';
              id: any;
              content: Array<
                | {
                    __typename?: 'ImageRecord';
                    id: any;
                    fullWidth?: any | null;
                    image?: {
                      __typename?: 'FileField';
                      alt?: string | null;
                      responsiveImage?: {
                        __typename?: 'ResponsiveImage';
                        aspectRatio: any;
                        base64?: string | null;
                        bgColor?: string | null;
                        height: any;
                        sizes: string;
                        src: string;
                        srcSet: string;
                        webpSrcSet: string;
                        width: any;
                      } | null;
                    } | null;
                    imageLoad?: {
                      __typename?: 'FileField';
                      alt?: string | null;
                      title?: string | null;
                      url: string;
                      blurUpThumb?: string | null;
                      focalPoint?: {
                        __typename?: 'focalPoint';
                        x: any;
                        y: any;
                      } | null;
                      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
                    } | null;
                  }
                | {
                    __typename?: 'MediaWithCaptionRecord';
                    id: any;
                    centerText?: any | null;
                    textOnImage?: any | null;
                    media?: {
                      __typename?: 'ImageRecord';
                      id: any;
                      fullWidth?: any | null;
                      image?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        responsiveImage?: {
                          __typename?: 'ResponsiveImage';
                          aspectRatio: any;
                          base64?: string | null;
                          bgColor?: string | null;
                          height: any;
                          sizes: string;
                          src: string;
                          srcSet: string;
                          webpSrcSet: string;
                          width: any;
                        } | null;
                      } | null;
                      imageLoad?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        title?: string | null;
                        url: string;
                        blurUpThumb?: string | null;
                        focalPoint?: {
                          __typename?: 'focalPoint';
                          x: any;
                          y: any;
                        } | null;
                        colors: Array<{
                          __typename?: 'ColorField';
                          hex: string;
                        }>;
                      } | null;
                    } | null;
                    caption?: {
                      __typename?: 'TextBlockRecord';
                      id: any;
                      smallHeader?: any | null;
                      header?: string | null;
                      text?: string | null;
                      introText?: string | null;
                      ctaButtons: Array<{
                        __typename?: 'CtaButtonRecord';
                        id: any;
                        text?: string | null;
                        url?: string | null;
                        variant?: string | null;
                      }>;
                    } | null;
                  }
                | {
                    __typename?: 'NewsListBlockRecord';
                    id: any;
                    title?: string | null;
                    standalone?: any | null;
                    largeTitle?: any | null;
                    itemsToShow?: any | null;
                  }
                | {
                    __typename?: 'ReportsListBlockRecord';
                    id: any;
                    title?: string | null;
                    standalone?: any | null;
                    largeTitle?: any | null;
                  }
                | {
                    __typename?: 'TextBlockRecord';
                    id: any;
                    smallHeader?: any | null;
                    header?: string | null;
                    text?: string | null;
                    introText?: string | null;
                    ctaButtons: Array<{
                      __typename?: 'CtaButtonRecord';
                      id: any;
                      text?: string | null;
                      url?: string | null;
                      variant?: string | null;
                    }>;
                  }
              >;
            }
          | {
              __typename?: 'ImageRecord';
              id: any;
              fullWidth?: any | null;
              image?: {
                __typename?: 'FileField';
                alt?: string | null;
                responsiveImage?: {
                  __typename?: 'ResponsiveImage';
                  aspectRatio: any;
                  base64?: string | null;
                  bgColor?: string | null;
                  height: any;
                  sizes: string;
                  src: string;
                  srcSet: string;
                  webpSrcSet: string;
                  width: any;
                } | null;
              } | null;
              imageLoad?: {
                __typename?: 'FileField';
                alt?: string | null;
                title?: string | null;
                url: string;
                blurUpThumb?: string | null;
                focalPoint?: {
                  __typename?: 'focalPoint';
                  x: any;
                  y: any;
                } | null;
                colors: Array<{ __typename?: 'ColorField'; hex: string }>;
              } | null;
            }
          | {
              __typename?: 'MediaWithCaptionRecord';
              id: any;
              centerText?: any | null;
              textOnImage?: any | null;
              media?: {
                __typename?: 'ImageRecord';
                id: any;
                fullWidth?: any | null;
                image?: {
                  __typename?: 'FileField';
                  alt?: string | null;
                  responsiveImage?: {
                    __typename?: 'ResponsiveImage';
                    aspectRatio: any;
                    base64?: string | null;
                    bgColor?: string | null;
                    height: any;
                    sizes: string;
                    src: string;
                    srcSet: string;
                    webpSrcSet: string;
                    width: any;
                  } | null;
                } | null;
                imageLoad?: {
                  __typename?: 'FileField';
                  alt?: string | null;
                  title?: string | null;
                  url: string;
                  blurUpThumb?: string | null;
                  focalPoint?: {
                    __typename?: 'focalPoint';
                    x: any;
                    y: any;
                  } | null;
                  colors: Array<{ __typename?: 'ColorField'; hex: string }>;
                } | null;
              } | null;
              caption?: {
                __typename?: 'TextBlockRecord';
                id: any;
                smallHeader?: any | null;
                header?: string | null;
                text?: string | null;
                introText?: string | null;
                ctaButtons: Array<{
                  __typename?: 'CtaButtonRecord';
                  id: any;
                  text?: string | null;
                  url?: string | null;
                  variant?: string | null;
                }>;
              } | null;
            }
          | {
              __typename?: 'TextBlockRecord';
              id: any;
              smallHeader?: any | null;
              header?: string | null;
              text?: string | null;
              introText?: string | null;
              ctaButtons: Array<{
                __typename?: 'CtaButtonRecord';
                id: any;
                text?: string | null;
                url?: string | null;
                variant?: string | null;
              }>;
            }
        >;
      }
    | {
        __typename?: 'GridTwocolBlockRecord';
        id: any;
        content: Array<
          | {
              __typename?: 'ImageRecord';
              id: any;
              fullWidth?: any | null;
              image?: {
                __typename?: 'FileField';
                alt?: string | null;
                responsiveImage?: {
                  __typename?: 'ResponsiveImage';
                  aspectRatio: any;
                  base64?: string | null;
                  bgColor?: string | null;
                  height: any;
                  sizes: string;
                  src: string;
                  srcSet: string;
                  webpSrcSet: string;
                  width: any;
                } | null;
              } | null;
              imageLoad?: {
                __typename?: 'FileField';
                alt?: string | null;
                title?: string | null;
                url: string;
                blurUpThumb?: string | null;
                focalPoint?: {
                  __typename?: 'focalPoint';
                  x: any;
                  y: any;
                } | null;
                colors: Array<{ __typename?: 'ColorField'; hex: string }>;
              } | null;
            }
          | {
              __typename?: 'MediaWithCaptionRecord';
              id: any;
              centerText?: any | null;
              textOnImage?: any | null;
              media?: {
                __typename?: 'ImageRecord';
                id: any;
                fullWidth?: any | null;
                image?: {
                  __typename?: 'FileField';
                  alt?: string | null;
                  responsiveImage?: {
                    __typename?: 'ResponsiveImage';
                    aspectRatio: any;
                    base64?: string | null;
                    bgColor?: string | null;
                    height: any;
                    sizes: string;
                    src: string;
                    srcSet: string;
                    webpSrcSet: string;
                    width: any;
                  } | null;
                } | null;
                imageLoad?: {
                  __typename?: 'FileField';
                  alt?: string | null;
                  title?: string | null;
                  url: string;
                  blurUpThumb?: string | null;
                  focalPoint?: {
                    __typename?: 'focalPoint';
                    x: any;
                    y: any;
                  } | null;
                  colors: Array<{ __typename?: 'ColorField'; hex: string }>;
                } | null;
              } | null;
              caption?: {
                __typename?: 'TextBlockRecord';
                id: any;
                smallHeader?: any | null;
                header?: string | null;
                text?: string | null;
                introText?: string | null;
                ctaButtons: Array<{
                  __typename?: 'CtaButtonRecord';
                  id: any;
                  text?: string | null;
                  url?: string | null;
                  variant?: string | null;
                }>;
              } | null;
            }
          | {
              __typename?: 'NewsListBlockRecord';
              id: any;
              title?: string | null;
              standalone?: any | null;
              largeTitle?: any | null;
              itemsToShow?: any | null;
            }
          | {
              __typename?: 'ReportsListBlockRecord';
              id: any;
              title?: string | null;
              standalone?: any | null;
              largeTitle?: any | null;
            }
          | {
              __typename?: 'TextBlockRecord';
              id: any;
              smallHeader?: any | null;
              header?: string | null;
              text?: string | null;
              introText?: string | null;
              ctaButtons: Array<{
                __typename?: 'CtaButtonRecord';
                id: any;
                text?: string | null;
                url?: string | null;
                variant?: string | null;
              }>;
            }
        >;
      }
  >;
};

type BrandsListPageContentArea_HeroBlockRecord_Fragment = {
  __typename?: 'HeroBlockRecord';
  id: any;
  title?: string | null;
  description?: string | null;
  ctaText?: string | null;
  ctaUrl?: string | null;
  fullWidth?: any | null;
  boxColor?: { __typename?: 'ColorField'; hex: string } | null;
  textColor?: { __typename?: 'ColorField'; hex: string } | null;
  image?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
  imageOverlay?: {
    __typename?: 'OverlayRecord';
    id: any;
    opacity?: any | null;
    color?: { __typename?: 'ColorField'; hex: string } | null;
  } | null;
  ctaButtons: Array<{
    __typename?: 'CtaButtonRecord';
    id: any;
    text?: string | null;
    url?: string | null;
    variant?: string | null;
  }>;
  video?: {
    __typename?: 'FileField';
    blurUpThumb?: string | null;
    title?: string | null;
    alt?: string | null;
    video?: {
      __typename?: 'UploadVideoField';
      muxPlaybackId: string;
      width: any;
      height: any;
    } | null;
  } | null;
};

type BrandsListPageContentArea_ImageRecord_Fragment = {
  __typename?: 'ImageRecord';
  id: any;
  fullWidth?: any | null;
  image?: {
    __typename?: 'FileField';
    alt?: string | null;
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  imageLoad?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
};

type BrandsListPageContentArea_NewsAndReportsListBlockRecord_Fragment = {
  __typename?: 'NewsAndReportsListBlockRecord';
  newsTitle?: string | null;
  reportsTitle?: string | null;
  newsImage?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
  news: Array<{
    __typename?: 'NewsPageRecord';
    id: any;
    title?: string | null;
    slug?: string | null;
    publishDate?: any | null;
    category?: string | null;
  }>;
  reportsImage?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
  reports: Array<{
    __typename?: 'ReportsListingRecord';
    id: any;
    title?: string | null;
    slug?: string | null;
    publishDate?: any | null;
    category?: string | null;
    pdf?: {
      __typename?: 'FileField';
      alt?: string | null;
      filename: string;
      format: string;
      size: any;
      title?: string | null;
      url: string;
      uploadId: any;
    } | null;
  }>;
};

type BrandsListPageContentArea_NewsListBlockRecord_Fragment = {
  __typename?: 'NewsListBlockRecord';
  id: any;
  title?: string | null;
  standalone?: any | null;
  largeTitle?: any | null;
  itemsToShow?: any | null;
};

type BrandsListPageContentArea_OfficesBlockRecord_Fragment = {
  __typename?: 'OfficesBlockRecord';
  id: any;
  offices: Array<{
    __typename?: 'OfficeRecord';
    id: any;
    name?: string | null;
    address?: string | null;
    zipCode?: string | null;
    city?: string | null;
    country?: string | null;
    email?: string | null;
    websiteUrl?: string | null;
    phoneNumber?: string | null;
  }>;
};

type BrandsListPageContentArea_PlugBlockRecord_Fragment = {
  __typename?: 'PlugBlockRecord';
  id: any;
  title?: string | null;
  description?: string | null;
  brands: Array<{
    __typename?: 'BrandPageRecord';
    id: any;
    brandName?: string | null;
    slug?: string | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      tags: Array<string>;
      title?: string | null;
      url: string;
      width?: any | null;
      height?: any | null;
      format: string;
      responsiveImage?: {
        __typename?: 'ResponsiveImage';
        aspectRatio: any;
        base64?: string | null;
        bgColor?: string | null;
        height: any;
        sizes: string;
        src: string;
        srcSet: string;
        webpSrcSet: string;
        width: any;
      } | null;
    } | null;
    imageLoad?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
  }>;
};

type BrandsListPageContentArea_ReportsListBlockRecord_Fragment = {
  __typename?: 'ReportsListBlockRecord';
  id: any;
  title?: string | null;
  standalone?: any | null;
  largeTitle?: any | null;
};

type BrandsListPageContentArea_SimpleTitleAndTextBlockRecord_Fragment = {
  __typename?: 'SimpleTitleAndTextBlockRecord';
  id: any;
  title?: string | null;
  topLabel?: string | null;
  description?: string | null;
};

type BrandsListPageContentArea_SliderBlockRecord_Fragment = {
  __typename?: 'SliderBlockRecord';
  title?: string | null;
  arrows?: any | null;
  slideAnimation?: any | null;
  delay?: any | null;
  dots?: any | null;
  heroes: Array<{
    __typename?: 'HeroBlockRecord';
    id: any;
    title?: string | null;
    description?: string | null;
    ctaText?: string | null;
    ctaUrl?: string | null;
    fullWidth?: any | null;
    boxColor?: { __typename?: 'ColorField'; hex: string } | null;
    textColor?: { __typename?: 'ColorField'; hex: string } | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
    imageOverlay?: {
      __typename?: 'OverlayRecord';
      id: any;
      opacity?: any | null;
      color?: { __typename?: 'ColorField'; hex: string } | null;
    } | null;
    ctaButtons: Array<{
      __typename?: 'CtaButtonRecord';
      id: any;
      text?: string | null;
      url?: string | null;
      variant?: string | null;
    }>;
    video?: {
      __typename?: 'FileField';
      blurUpThumb?: string | null;
      title?: string | null;
      alt?: string | null;
      video?: {
        __typename?: 'UploadVideoField';
        muxPlaybackId: string;
        width: any;
        height: any;
      } | null;
    } | null;
  }>;
};

type BrandsListPageContentArea_StatementBlockRecord_Fragment = {
  __typename?: 'StatementBlockRecord';
  id: any;
  text?: string | null;
  blackBackground?: any | null;
  header?: string | null;
  small?: any | null;
  linkText?: string | null;
  linkUrl?: string | null;
  imageMobile?: {
    __typename?: 'FileField';
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  imageTablet?: {
    __typename?: 'FileField';
    alt?: string | null;
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  imageDesktop?: {
    __typename?: 'FileField';
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  imageLoad?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
  imageOverlay?: {
    __typename?: 'OverlayRecord';
    id: any;
    opacity?: any | null;
    color?: { __typename?: 'ColorField'; hex: string } | null;
  } | null;
};

type BrandsListPageContentArea_SubheadingBlockRecord_Fragment = {
  __typename?: 'SubheadingBlockRecord';
  id: any;
  title?: string | null;
  text?: string | null;
  ctaButton?: {
    __typename?: 'CtaButtonRecord';
    id: any;
    text?: string | null;
    url?: string | null;
    variant?: string | null;
  } | null;
  backgroundColor?: { __typename?: 'ColorField'; hex: string } | null;
};

type BrandsListPageContentArea_SustainabilityReportsBlockRecord_Fragment = {
  __typename?: 'SustainabilityReportsBlockRecord';
  id: any;
  title?: string | null;
  reports: Array<{
    __typename?: 'FileField';
    alt?: string | null;
    filename: string;
    format: string;
    size: any;
    title?: string | null;
    url: string;
    uploadId: any;
  }>;
};

type BrandsListPageContentArea_TextBlockRecord_Fragment = {
  __typename?: 'TextBlockRecord';
  id: any;
  smallHeader?: any | null;
  header?: string | null;
  text?: string | null;
  introText?: string | null;
  ctaButtons: Array<{
    __typename?: 'CtaButtonRecord';
    id: any;
    text?: string | null;
    url?: string | null;
    variant?: string | null;
  }>;
};

type BrandsListPageContentArea_TwoColumnImageAndTextRecord_Fragment = {
  __typename?: 'TwoColumnImageAndTextRecord';
  id: any;
  text?: string | null;
  title?: string | null;
  reverse?: any | null;
  image?: {
    __typename?: 'FileField';
    alt?: string | null;
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  imageLoad?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
};

type BrandsListPageContentArea_TwoColumnTextIntroRecord_Fragment = {
  __typename?: 'TwoColumnTextIntroRecord';
  id: any;
  introText?: string | null;
  text?: string | null;
  header?: string | null;
};

type BrandsListPageContentArea_VideoRecord_Fragment = {
  __typename?: 'VideoRecord';
  id: any;
  autoplay?: any | null;
  video?: {
    __typename?: 'FileField';
    title?: string | null;
    video?: {
      __typename?: 'UploadVideoField';
      mp4Url?: string | null;
      streamingUrl: string;
      thumbnailUrl: string;
      mp4Low?: string | null;
    } | null;
  } | null;
  videoThumbnail?: {
    __typename?: 'FileField';
    alt?: string | null;
    tags: Array<string>;
    title?: string | null;
    url: string;
    width?: any | null;
    height?: any | null;
    format: string;
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  muxVideo?: {
    __typename?: 'FileField';
    blurUpThumb?: string | null;
    title?: string | null;
    alt?: string | null;
    video?: {
      __typename?: 'UploadVideoField';
      muxPlaybackId: string;
      width: any;
      height: any;
    } | null;
  } | null;
};

export type BrandsListPageContentAreaFragment =
  | BrandsListPageContentArea_ArticlesBlockRecord_Fragment
  | BrandsListPageContentArea_BrandsBlockRecord_Fragment
  | BrandsListPageContentArea_BulletListRecord_Fragment
  | BrandsListPageContentArea_DocumentLinkBlockRecord_Fragment
  | BrandsListPageContentArea_EmployeeRecord_Fragment
  | BrandsListPageContentArea_GridContainerBlockRecord_Fragment
  | BrandsListPageContentArea_HeroBlockRecord_Fragment
  | BrandsListPageContentArea_ImageRecord_Fragment
  | BrandsListPageContentArea_NewsAndReportsListBlockRecord_Fragment
  | BrandsListPageContentArea_NewsListBlockRecord_Fragment
  | BrandsListPageContentArea_OfficesBlockRecord_Fragment
  | BrandsListPageContentArea_PlugBlockRecord_Fragment
  | BrandsListPageContentArea_ReportsListBlockRecord_Fragment
  | BrandsListPageContentArea_SimpleTitleAndTextBlockRecord_Fragment
  | BrandsListPageContentArea_SliderBlockRecord_Fragment
  | BrandsListPageContentArea_StatementBlockRecord_Fragment
  | BrandsListPageContentArea_SubheadingBlockRecord_Fragment
  | BrandsListPageContentArea_SustainabilityReportsBlockRecord_Fragment
  | BrandsListPageContentArea_TextBlockRecord_Fragment
  | BrandsListPageContentArea_TwoColumnImageAndTextRecord_Fragment
  | BrandsListPageContentArea_TwoColumnTextIntroRecord_Fragment
  | BrandsListPageContentArea_VideoRecord_Fragment;

export type BrandsListPageContentFragment = {
  __typename?: 'BrandsListPageRecord';
  id: any;
  pageLocales: Array<SiteLocale>;
  seo?: {
    __typename?: 'SeoField';
    description?: string | null;
    title?: string | null;
    image?: {
      __typename?: 'FileField';
      url: string;
      alt?: string | null;
      title?: string | null;
    } | null;
  } | null;
  contentArea: Array<
    | {
        __typename?: 'ArticlesBlockRecord';
        id: any;
        title?: string | null;
        isJobArticles?: any | null;
        ctaText?: string | null;
        ctaUrl?: string | null;
        jobPages: Array<{
          __typename?: 'JobOpportunitiesPageRecord';
          id: any;
          slug?: string | null;
          title?: string | null;
          publishDate?: any | null;
          category?: string | null;
          country?: string | null;
          department?: string | null;
        }>;
        newsPages: Array<{
          __typename?: 'NewsPageRecord';
          id: any;
          slug?: string | null;
          title?: string | null;
          publishDate?: any | null;
          category?: string | null;
          country?: string | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
        }>;
        reportPages: Array<{
          __typename?: 'ReportsListingRecord';
          id: any;
          slug?: string | null;
          title?: string | null;
          publishDate?: any | null;
          category?: string | null;
          country?: string | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
          pdf?: {
            __typename?: 'FileField';
            alt?: string | null;
            filename: string;
            format: string;
            size: any;
            title?: string | null;
            url: string;
            uploadId: any;
          } | null;
        }>;
      }
    | {
        __typename?: 'BrandsBlockRecord';
        id: any;
        title?: string | null;
        introText?: string | null;
        hideLabels?: any | null;
        brands: Array<{
          __typename?: 'BrandPageRecord';
          id: any;
          brandName?: string | null;
          slug?: string | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            tags: Array<string>;
            title?: string | null;
            url: string;
            width?: any | null;
            height?: any | null;
            format: string;
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageLoad?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
        }>;
      }
    | {
        __typename?: 'BulletListRecord';
        id: any;
        bullets?: string | null;
        numberedList?: any | null;
        title?: string | null;
      }
    | {
        __typename?: 'DocumentLinkBlockRecord';
        id: any;
        documents: Array<{
          __typename?: 'FileField';
          alt?: string | null;
          filename: string;
          format: string;
          size: any;
          title?: string | null;
          url: string;
          uploadId: any;
        }>;
      }
    | {
        __typename?: 'EmployeeRecord';
        id: any;
        name?: string | null;
        title?: string | null;
        introText?: string | null;
        description?: string | null;
        image?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
      }
    | {
        __typename?: 'GridContainerBlockRecord';
        id: any;
        fullwidth?: any | null;
        gap?: any | null;
        backgroundColor?: { __typename?: 'ColorField'; hex: string } | null;
        textColor?: { __typename?: 'ColorField'; hex: string } | null;
        content: Array<
          | {
              __typename?: 'GridFourcolBlockRecord';
              id: any;
              content: Array<
                | {
                    __typename?: 'ImageRecord';
                    id: any;
                    fullWidth?: any | null;
                    image?: {
                      __typename?: 'FileField';
                      alt?: string | null;
                      responsiveImage?: {
                        __typename?: 'ResponsiveImage';
                        aspectRatio: any;
                        base64?: string | null;
                        bgColor?: string | null;
                        height: any;
                        sizes: string;
                        src: string;
                        srcSet: string;
                        webpSrcSet: string;
                        width: any;
                      } | null;
                    } | null;
                    imageLoad?: {
                      __typename?: 'FileField';
                      alt?: string | null;
                      title?: string | null;
                      url: string;
                      blurUpThumb?: string | null;
                      focalPoint?: {
                        __typename?: 'focalPoint';
                        x: any;
                        y: any;
                      } | null;
                      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
                    } | null;
                  }
                | {
                    __typename?: 'MediaWithCaptionRecord';
                    id: any;
                    centerText?: any | null;
                    textOnImage?: any | null;
                    media?: {
                      __typename?: 'ImageRecord';
                      id: any;
                      fullWidth?: any | null;
                      image?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        responsiveImage?: {
                          __typename?: 'ResponsiveImage';
                          aspectRatio: any;
                          base64?: string | null;
                          bgColor?: string | null;
                          height: any;
                          sizes: string;
                          src: string;
                          srcSet: string;
                          webpSrcSet: string;
                          width: any;
                        } | null;
                      } | null;
                      imageLoad?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        title?: string | null;
                        url: string;
                        blurUpThumb?: string | null;
                        focalPoint?: {
                          __typename?: 'focalPoint';
                          x: any;
                          y: any;
                        } | null;
                        colors: Array<{
                          __typename?: 'ColorField';
                          hex: string;
                        }>;
                      } | null;
                    } | null;
                    caption?: {
                      __typename?: 'TextBlockRecord';
                      id: any;
                      smallHeader?: any | null;
                      header?: string | null;
                      text?: string | null;
                      introText?: string | null;
                      ctaButtons: Array<{
                        __typename?: 'CtaButtonRecord';
                        id: any;
                        text?: string | null;
                        url?: string | null;
                        variant?: string | null;
                      }>;
                    } | null;
                  }
                | {
                    __typename?: 'TextBlockRecord';
                    id: any;
                    smallHeader?: any | null;
                    header?: string | null;
                    text?: string | null;
                    introText?: string | null;
                    ctaButtons: Array<{
                      __typename?: 'CtaButtonRecord';
                      id: any;
                      text?: string | null;
                      url?: string | null;
                      variant?: string | null;
                    }>;
                  }
              >;
            }
          | {
              __typename?: 'GridThreecolBlockRecord';
              id: any;
              content: Array<
                | {
                    __typename?: 'GridTwocolBlockRecord';
                    id: any;
                    content: Array<
                      | {
                          __typename?: 'ImageRecord';
                          id: any;
                          fullWidth?: any | null;
                          image?: {
                            __typename?: 'FileField';
                            alt?: string | null;
                            responsiveImage?: {
                              __typename?: 'ResponsiveImage';
                              aspectRatio: any;
                              base64?: string | null;
                              bgColor?: string | null;
                              height: any;
                              sizes: string;
                              src: string;
                              srcSet: string;
                              webpSrcSet: string;
                              width: any;
                            } | null;
                          } | null;
                          imageLoad?: {
                            __typename?: 'FileField';
                            alt?: string | null;
                            title?: string | null;
                            url: string;
                            blurUpThumb?: string | null;
                            focalPoint?: {
                              __typename?: 'focalPoint';
                              x: any;
                              y: any;
                            } | null;
                            colors: Array<{
                              __typename?: 'ColorField';
                              hex: string;
                            }>;
                          } | null;
                        }
                      | {
                          __typename?: 'MediaWithCaptionRecord';
                          id: any;
                          centerText?: any | null;
                          textOnImage?: any | null;
                          media?: {
                            __typename?: 'ImageRecord';
                            id: any;
                            fullWidth?: any | null;
                            image?: {
                              __typename?: 'FileField';
                              alt?: string | null;
                              responsiveImage?: {
                                __typename?: 'ResponsiveImage';
                                aspectRatio: any;
                                base64?: string | null;
                                bgColor?: string | null;
                                height: any;
                                sizes: string;
                                src: string;
                                srcSet: string;
                                webpSrcSet: string;
                                width: any;
                              } | null;
                            } | null;
                            imageLoad?: {
                              __typename?: 'FileField';
                              alt?: string | null;
                              title?: string | null;
                              url: string;
                              blurUpThumb?: string | null;
                              focalPoint?: {
                                __typename?: 'focalPoint';
                                x: any;
                                y: any;
                              } | null;
                              colors: Array<{
                                __typename?: 'ColorField';
                                hex: string;
                              }>;
                            } | null;
                          } | null;
                          caption?: {
                            __typename?: 'TextBlockRecord';
                            id: any;
                            smallHeader?: any | null;
                            header?: string | null;
                            text?: string | null;
                            introText?: string | null;
                            ctaButtons: Array<{
                              __typename?: 'CtaButtonRecord';
                              id: any;
                              text?: string | null;
                              url?: string | null;
                              variant?: string | null;
                            }>;
                          } | null;
                        }
                      | {
                          __typename?: 'NewsListBlockRecord';
                          id: any;
                          title?: string | null;
                          standalone?: any | null;
                          largeTitle?: any | null;
                          itemsToShow?: any | null;
                        }
                      | {
                          __typename?: 'ReportsListBlockRecord';
                          id: any;
                          title?: string | null;
                          standalone?: any | null;
                          largeTitle?: any | null;
                        }
                      | {
                          __typename?: 'TextBlockRecord';
                          id: any;
                          smallHeader?: any | null;
                          header?: string | null;
                          text?: string | null;
                          introText?: string | null;
                          ctaButtons: Array<{
                            __typename?: 'CtaButtonRecord';
                            id: any;
                            text?: string | null;
                            url?: string | null;
                            variant?: string | null;
                          }>;
                        }
                    >;
                  }
                | {
                    __typename?: 'ImageRecord';
                    id: any;
                    fullWidth?: any | null;
                    image?: {
                      __typename?: 'FileField';
                      alt?: string | null;
                      responsiveImage?: {
                        __typename?: 'ResponsiveImage';
                        aspectRatio: any;
                        base64?: string | null;
                        bgColor?: string | null;
                        height: any;
                        sizes: string;
                        src: string;
                        srcSet: string;
                        webpSrcSet: string;
                        width: any;
                      } | null;
                    } | null;
                    imageLoad?: {
                      __typename?: 'FileField';
                      alt?: string | null;
                      title?: string | null;
                      url: string;
                      blurUpThumb?: string | null;
                      focalPoint?: {
                        __typename?: 'focalPoint';
                        x: any;
                        y: any;
                      } | null;
                      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
                    } | null;
                  }
                | {
                    __typename?: 'MediaWithCaptionRecord';
                    id: any;
                    centerText?: any | null;
                    textOnImage?: any | null;
                    media?: {
                      __typename?: 'ImageRecord';
                      id: any;
                      fullWidth?: any | null;
                      image?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        responsiveImage?: {
                          __typename?: 'ResponsiveImage';
                          aspectRatio: any;
                          base64?: string | null;
                          bgColor?: string | null;
                          height: any;
                          sizes: string;
                          src: string;
                          srcSet: string;
                          webpSrcSet: string;
                          width: any;
                        } | null;
                      } | null;
                      imageLoad?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        title?: string | null;
                        url: string;
                        blurUpThumb?: string | null;
                        focalPoint?: {
                          __typename?: 'focalPoint';
                          x: any;
                          y: any;
                        } | null;
                        colors: Array<{
                          __typename?: 'ColorField';
                          hex: string;
                        }>;
                      } | null;
                    } | null;
                    caption?: {
                      __typename?: 'TextBlockRecord';
                      id: any;
                      smallHeader?: any | null;
                      header?: string | null;
                      text?: string | null;
                      introText?: string | null;
                      ctaButtons: Array<{
                        __typename?: 'CtaButtonRecord';
                        id: any;
                        text?: string | null;
                        url?: string | null;
                        variant?: string | null;
                      }>;
                    } | null;
                  }
                | {
                    __typename?: 'TextBlockRecord';
                    id: any;
                    smallHeader?: any | null;
                    header?: string | null;
                    text?: string | null;
                    introText?: string | null;
                    ctaButtons: Array<{
                      __typename?: 'CtaButtonRecord';
                      id: any;
                      text?: string | null;
                      url?: string | null;
                      variant?: string | null;
                    }>;
                  }
              >;
            }
          | {
              __typename?: 'GridTwocolBlockRecord';
              id: any;
              content: Array<
                | {
                    __typename?: 'ImageRecord';
                    id: any;
                    fullWidth?: any | null;
                    image?: {
                      __typename?: 'FileField';
                      alt?: string | null;
                      responsiveImage?: {
                        __typename?: 'ResponsiveImage';
                        aspectRatio: any;
                        base64?: string | null;
                        bgColor?: string | null;
                        height: any;
                        sizes: string;
                        src: string;
                        srcSet: string;
                        webpSrcSet: string;
                        width: any;
                      } | null;
                    } | null;
                    imageLoad?: {
                      __typename?: 'FileField';
                      alt?: string | null;
                      title?: string | null;
                      url: string;
                      blurUpThumb?: string | null;
                      focalPoint?: {
                        __typename?: 'focalPoint';
                        x: any;
                        y: any;
                      } | null;
                      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
                    } | null;
                  }
                | {
                    __typename?: 'MediaWithCaptionRecord';
                    id: any;
                    centerText?: any | null;
                    textOnImage?: any | null;
                    media?: {
                      __typename?: 'ImageRecord';
                      id: any;
                      fullWidth?: any | null;
                      image?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        responsiveImage?: {
                          __typename?: 'ResponsiveImage';
                          aspectRatio: any;
                          base64?: string | null;
                          bgColor?: string | null;
                          height: any;
                          sizes: string;
                          src: string;
                          srcSet: string;
                          webpSrcSet: string;
                          width: any;
                        } | null;
                      } | null;
                      imageLoad?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        title?: string | null;
                        url: string;
                        blurUpThumb?: string | null;
                        focalPoint?: {
                          __typename?: 'focalPoint';
                          x: any;
                          y: any;
                        } | null;
                        colors: Array<{
                          __typename?: 'ColorField';
                          hex: string;
                        }>;
                      } | null;
                    } | null;
                    caption?: {
                      __typename?: 'TextBlockRecord';
                      id: any;
                      smallHeader?: any | null;
                      header?: string | null;
                      text?: string | null;
                      introText?: string | null;
                      ctaButtons: Array<{
                        __typename?: 'CtaButtonRecord';
                        id: any;
                        text?: string | null;
                        url?: string | null;
                        variant?: string | null;
                      }>;
                    } | null;
                  }
                | {
                    __typename?: 'NewsListBlockRecord';
                    id: any;
                    title?: string | null;
                    standalone?: any | null;
                    largeTitle?: any | null;
                    itemsToShow?: any | null;
                  }
                | {
                    __typename?: 'ReportsListBlockRecord';
                    id: any;
                    title?: string | null;
                    standalone?: any | null;
                    largeTitle?: any | null;
                  }
                | {
                    __typename?: 'TextBlockRecord';
                    id: any;
                    smallHeader?: any | null;
                    header?: string | null;
                    text?: string | null;
                    introText?: string | null;
                    ctaButtons: Array<{
                      __typename?: 'CtaButtonRecord';
                      id: any;
                      text?: string | null;
                      url?: string | null;
                      variant?: string | null;
                    }>;
                  }
              >;
            }
        >;
      }
    | {
        __typename?: 'HeroBlockRecord';
        id: any;
        title?: string | null;
        description?: string | null;
        ctaText?: string | null;
        ctaUrl?: string | null;
        fullWidth?: any | null;
        boxColor?: { __typename?: 'ColorField'; hex: string } | null;
        textColor?: { __typename?: 'ColorField'; hex: string } | null;
        image?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
        imageOverlay?: {
          __typename?: 'OverlayRecord';
          id: any;
          opacity?: any | null;
          color?: { __typename?: 'ColorField'; hex: string } | null;
        } | null;
        ctaButtons: Array<{
          __typename?: 'CtaButtonRecord';
          id: any;
          text?: string | null;
          url?: string | null;
          variant?: string | null;
        }>;
        video?: {
          __typename?: 'FileField';
          blurUpThumb?: string | null;
          title?: string | null;
          alt?: string | null;
          video?: {
            __typename?: 'UploadVideoField';
            muxPlaybackId: string;
            width: any;
            height: any;
          } | null;
        } | null;
      }
    | {
        __typename?: 'ImageRecord';
        id: any;
        fullWidth?: any | null;
        image?: {
          __typename?: 'FileField';
          alt?: string | null;
          responsiveImage?: {
            __typename?: 'ResponsiveImage';
            aspectRatio: any;
            base64?: string | null;
            bgColor?: string | null;
            height: any;
            sizes: string;
            src: string;
            srcSet: string;
            webpSrcSet: string;
            width: any;
          } | null;
        } | null;
        imageLoad?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
      }
    | {
        __typename?: 'NewsAndReportsListBlockRecord';
        newsTitle?: string | null;
        reportsTitle?: string | null;
        newsImage?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
        news: Array<{
          __typename?: 'NewsPageRecord';
          id: any;
          title?: string | null;
          slug?: string | null;
          publishDate?: any | null;
          category?: string | null;
        }>;
        reportsImage?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
        reports: Array<{
          __typename?: 'ReportsListingRecord';
          id: any;
          title?: string | null;
          slug?: string | null;
          publishDate?: any | null;
          category?: string | null;
          pdf?: {
            __typename?: 'FileField';
            alt?: string | null;
            filename: string;
            format: string;
            size: any;
            title?: string | null;
            url: string;
            uploadId: any;
          } | null;
        }>;
      }
    | {
        __typename?: 'NewsListBlockRecord';
        id: any;
        title?: string | null;
        standalone?: any | null;
        largeTitle?: any | null;
        itemsToShow?: any | null;
      }
    | {
        __typename?: 'OfficesBlockRecord';
        id: any;
        offices: Array<{
          __typename?: 'OfficeRecord';
          id: any;
          name?: string | null;
          address?: string | null;
          zipCode?: string | null;
          city?: string | null;
          country?: string | null;
          email?: string | null;
          websiteUrl?: string | null;
          phoneNumber?: string | null;
        }>;
      }
    | {
        __typename?: 'PlugBlockRecord';
        id: any;
        title?: string | null;
        description?: string | null;
        brands: Array<{
          __typename?: 'BrandPageRecord';
          id: any;
          brandName?: string | null;
          slug?: string | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            tags: Array<string>;
            title?: string | null;
            url: string;
            width?: any | null;
            height?: any | null;
            format: string;
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageLoad?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
        }>;
      }
    | {
        __typename?: 'ReportsListBlockRecord';
        id: any;
        title?: string | null;
        standalone?: any | null;
        largeTitle?: any | null;
      }
    | {
        __typename?: 'SimpleTitleAndTextBlockRecord';
        id: any;
        title?: string | null;
        topLabel?: string | null;
        description?: string | null;
      }
    | {
        __typename?: 'SliderBlockRecord';
        title?: string | null;
        arrows?: any | null;
        slideAnimation?: any | null;
        delay?: any | null;
        dots?: any | null;
        heroes: Array<{
          __typename?: 'HeroBlockRecord';
          id: any;
          title?: string | null;
          description?: string | null;
          ctaText?: string | null;
          ctaUrl?: string | null;
          fullWidth?: any | null;
          boxColor?: { __typename?: 'ColorField'; hex: string } | null;
          textColor?: { __typename?: 'ColorField'; hex: string } | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
          imageOverlay?: {
            __typename?: 'OverlayRecord';
            id: any;
            opacity?: any | null;
            color?: { __typename?: 'ColorField'; hex: string } | null;
          } | null;
          ctaButtons: Array<{
            __typename?: 'CtaButtonRecord';
            id: any;
            text?: string | null;
            url?: string | null;
            variant?: string | null;
          }>;
          video?: {
            __typename?: 'FileField';
            blurUpThumb?: string | null;
            title?: string | null;
            alt?: string | null;
            video?: {
              __typename?: 'UploadVideoField';
              muxPlaybackId: string;
              width: any;
              height: any;
            } | null;
          } | null;
        }>;
      }
    | {
        __typename?: 'StatementBlockRecord';
        id: any;
        text?: string | null;
        blackBackground?: any | null;
        header?: string | null;
        small?: any | null;
        linkText?: string | null;
        linkUrl?: string | null;
        imageMobile?: {
          __typename?: 'FileField';
          responsiveImage?: {
            __typename?: 'ResponsiveImage';
            aspectRatio: any;
            base64?: string | null;
            bgColor?: string | null;
            height: any;
            sizes: string;
            src: string;
            srcSet: string;
            webpSrcSet: string;
            width: any;
          } | null;
        } | null;
        imageTablet?: {
          __typename?: 'FileField';
          alt?: string | null;
          responsiveImage?: {
            __typename?: 'ResponsiveImage';
            aspectRatio: any;
            base64?: string | null;
            bgColor?: string | null;
            height: any;
            sizes: string;
            src: string;
            srcSet: string;
            webpSrcSet: string;
            width: any;
          } | null;
        } | null;
        imageDesktop?: {
          __typename?: 'FileField';
          responsiveImage?: {
            __typename?: 'ResponsiveImage';
            aspectRatio: any;
            base64?: string | null;
            bgColor?: string | null;
            height: any;
            sizes: string;
            src: string;
            srcSet: string;
            webpSrcSet: string;
            width: any;
          } | null;
        } | null;
        imageLoad?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
        imageOverlay?: {
          __typename?: 'OverlayRecord';
          id: any;
          opacity?: any | null;
          color?: { __typename?: 'ColorField'; hex: string } | null;
        } | null;
      }
    | {
        __typename?: 'SubheadingBlockRecord';
        id: any;
        title?: string | null;
        text?: string | null;
        ctaButton?: {
          __typename?: 'CtaButtonRecord';
          id: any;
          text?: string | null;
          url?: string | null;
          variant?: string | null;
        } | null;
        backgroundColor?: { __typename?: 'ColorField'; hex: string } | null;
      }
    | {
        __typename?: 'SustainabilityReportsBlockRecord';
        id: any;
        title?: string | null;
        reports: Array<{
          __typename?: 'FileField';
          alt?: string | null;
          filename: string;
          format: string;
          size: any;
          title?: string | null;
          url: string;
          uploadId: any;
        }>;
      }
    | {
        __typename?: 'TextBlockRecord';
        id: any;
        smallHeader?: any | null;
        header?: string | null;
        text?: string | null;
        introText?: string | null;
        ctaButtons: Array<{
          __typename?: 'CtaButtonRecord';
          id: any;
          text?: string | null;
          url?: string | null;
          variant?: string | null;
        }>;
      }
    | {
        __typename?: 'TwoColumnImageAndTextRecord';
        id: any;
        text?: string | null;
        title?: string | null;
        reverse?: any | null;
        image?: {
          __typename?: 'FileField';
          alt?: string | null;
          responsiveImage?: {
            __typename?: 'ResponsiveImage';
            aspectRatio: any;
            base64?: string | null;
            bgColor?: string | null;
            height: any;
            sizes: string;
            src: string;
            srcSet: string;
            webpSrcSet: string;
            width: any;
          } | null;
        } | null;
        imageLoad?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
      }
    | {
        __typename?: 'TwoColumnTextIntroRecord';
        id: any;
        introText?: string | null;
        text?: string | null;
        header?: string | null;
      }
    | {
        __typename?: 'VideoRecord';
        id: any;
        autoplay?: any | null;
        video?: {
          __typename?: 'FileField';
          title?: string | null;
          video?: {
            __typename?: 'UploadVideoField';
            mp4Url?: string | null;
            streamingUrl: string;
            thumbnailUrl: string;
            mp4Low?: string | null;
          } | null;
        } | null;
        videoThumbnail?: {
          __typename?: 'FileField';
          alt?: string | null;
          tags: Array<string>;
          title?: string | null;
          url: string;
          width?: any | null;
          height?: any | null;
          format: string;
          responsiveImage?: {
            __typename?: 'ResponsiveImage';
            aspectRatio: any;
            base64?: string | null;
            bgColor?: string | null;
            height: any;
            sizes: string;
            src: string;
            srcSet: string;
            webpSrcSet: string;
            width: any;
          } | null;
        } | null;
        muxVideo?: {
          __typename?: 'FileField';
          blurUpThumb?: string | null;
          title?: string | null;
          alt?: string | null;
          video?: {
            __typename?: 'UploadVideoField';
            muxPlaybackId: string;
            width: any;
            height: any;
          } | null;
        } | null;
      }
  >;
};

type CampaignPageContentArea_ArticlesBlockRecord_Fragment = {
  __typename?: 'ArticlesBlockRecord';
  id: any;
  title?: string | null;
  isJobArticles?: any | null;
  ctaText?: string | null;
  ctaUrl?: string | null;
  jobPages: Array<{
    __typename?: 'JobOpportunitiesPageRecord';
    id: any;
    slug?: string | null;
    title?: string | null;
    publishDate?: any | null;
    category?: string | null;
    country?: string | null;
    department?: string | null;
  }>;
  newsPages: Array<{
    __typename?: 'NewsPageRecord';
    id: any;
    slug?: string | null;
    title?: string | null;
    publishDate?: any | null;
    category?: string | null;
    country?: string | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
  }>;
  reportPages: Array<{
    __typename?: 'ReportsListingRecord';
    id: any;
    slug?: string | null;
    title?: string | null;
    publishDate?: any | null;
    category?: string | null;
    country?: string | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
    pdf?: {
      __typename?: 'FileField';
      alt?: string | null;
      filename: string;
      format: string;
      size: any;
      title?: string | null;
      url: string;
      uploadId: any;
    } | null;
  }>;
};

type CampaignPageContentArea_BrandsBlockRecord_Fragment = {
  __typename?: 'BrandsBlockRecord';
  id: any;
  title?: string | null;
  introText?: string | null;
  hideLabels?: any | null;
  brands: Array<{
    __typename?: 'BrandPageRecord';
    id: any;
    brandName?: string | null;
    slug?: string | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      tags: Array<string>;
      title?: string | null;
      url: string;
      width?: any | null;
      height?: any | null;
      format: string;
      responsiveImage?: {
        __typename?: 'ResponsiveImage';
        aspectRatio: any;
        base64?: string | null;
        bgColor?: string | null;
        height: any;
        sizes: string;
        src: string;
        srcSet: string;
        webpSrcSet: string;
        width: any;
      } | null;
    } | null;
    imageLoad?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
  }>;
};

type CampaignPageContentArea_BulletListRecord_Fragment = {
  __typename?: 'BulletListRecord';
  id: any;
  bullets?: string | null;
  numberedList?: any | null;
  title?: string | null;
};

type CampaignPageContentArea_DocumentLinkBlockRecord_Fragment = {
  __typename?: 'DocumentLinkBlockRecord';
  id: any;
  documents: Array<{
    __typename?: 'FileField';
    alt?: string | null;
    filename: string;
    format: string;
    size: any;
    title?: string | null;
    url: string;
    uploadId: any;
  }>;
};

type CampaignPageContentArea_EmployeeRecord_Fragment = {
  __typename?: 'EmployeeRecord';
  id: any;
  name?: string | null;
  title?: string | null;
  introText?: string | null;
  description?: string | null;
  image?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
};

type CampaignPageContentArea_GridContainerBlockRecord_Fragment = {
  __typename?: 'GridContainerBlockRecord';
  id: any;
  fullwidth?: any | null;
  gap?: any | null;
  backgroundColor?: { __typename?: 'ColorField'; hex: string } | null;
  textColor?: { __typename?: 'ColorField'; hex: string } | null;
  content: Array<
    | {
        __typename?: 'GridFourcolBlockRecord';
        id: any;
        content: Array<
          | {
              __typename?: 'ImageRecord';
              id: any;
              fullWidth?: any | null;
              image?: {
                __typename?: 'FileField';
                alt?: string | null;
                responsiveImage?: {
                  __typename?: 'ResponsiveImage';
                  aspectRatio: any;
                  base64?: string | null;
                  bgColor?: string | null;
                  height: any;
                  sizes: string;
                  src: string;
                  srcSet: string;
                  webpSrcSet: string;
                  width: any;
                } | null;
              } | null;
              imageLoad?: {
                __typename?: 'FileField';
                alt?: string | null;
                title?: string | null;
                url: string;
                blurUpThumb?: string | null;
                focalPoint?: {
                  __typename?: 'focalPoint';
                  x: any;
                  y: any;
                } | null;
                colors: Array<{ __typename?: 'ColorField'; hex: string }>;
              } | null;
            }
          | {
              __typename?: 'MediaWithCaptionRecord';
              id: any;
              centerText?: any | null;
              textOnImage?: any | null;
              media?: {
                __typename?: 'ImageRecord';
                id: any;
                fullWidth?: any | null;
                image?: {
                  __typename?: 'FileField';
                  alt?: string | null;
                  responsiveImage?: {
                    __typename?: 'ResponsiveImage';
                    aspectRatio: any;
                    base64?: string | null;
                    bgColor?: string | null;
                    height: any;
                    sizes: string;
                    src: string;
                    srcSet: string;
                    webpSrcSet: string;
                    width: any;
                  } | null;
                } | null;
                imageLoad?: {
                  __typename?: 'FileField';
                  alt?: string | null;
                  title?: string | null;
                  url: string;
                  blurUpThumb?: string | null;
                  focalPoint?: {
                    __typename?: 'focalPoint';
                    x: any;
                    y: any;
                  } | null;
                  colors: Array<{ __typename?: 'ColorField'; hex: string }>;
                } | null;
              } | null;
              caption?: {
                __typename?: 'TextBlockRecord';
                id: any;
                smallHeader?: any | null;
                header?: string | null;
                text?: string | null;
                introText?: string | null;
                ctaButtons: Array<{
                  __typename?: 'CtaButtonRecord';
                  id: any;
                  text?: string | null;
                  url?: string | null;
                  variant?: string | null;
                }>;
              } | null;
            }
          | {
              __typename?: 'TextBlockRecord';
              id: any;
              smallHeader?: any | null;
              header?: string | null;
              text?: string | null;
              introText?: string | null;
              ctaButtons: Array<{
                __typename?: 'CtaButtonRecord';
                id: any;
                text?: string | null;
                url?: string | null;
                variant?: string | null;
              }>;
            }
        >;
      }
    | {
        __typename?: 'GridThreecolBlockRecord';
        id: any;
        content: Array<
          | {
              __typename?: 'GridTwocolBlockRecord';
              id: any;
              content: Array<
                | {
                    __typename?: 'ImageRecord';
                    id: any;
                    fullWidth?: any | null;
                    image?: {
                      __typename?: 'FileField';
                      alt?: string | null;
                      responsiveImage?: {
                        __typename?: 'ResponsiveImage';
                        aspectRatio: any;
                        base64?: string | null;
                        bgColor?: string | null;
                        height: any;
                        sizes: string;
                        src: string;
                        srcSet: string;
                        webpSrcSet: string;
                        width: any;
                      } | null;
                    } | null;
                    imageLoad?: {
                      __typename?: 'FileField';
                      alt?: string | null;
                      title?: string | null;
                      url: string;
                      blurUpThumb?: string | null;
                      focalPoint?: {
                        __typename?: 'focalPoint';
                        x: any;
                        y: any;
                      } | null;
                      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
                    } | null;
                  }
                | {
                    __typename?: 'MediaWithCaptionRecord';
                    id: any;
                    centerText?: any | null;
                    textOnImage?: any | null;
                    media?: {
                      __typename?: 'ImageRecord';
                      id: any;
                      fullWidth?: any | null;
                      image?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        responsiveImage?: {
                          __typename?: 'ResponsiveImage';
                          aspectRatio: any;
                          base64?: string | null;
                          bgColor?: string | null;
                          height: any;
                          sizes: string;
                          src: string;
                          srcSet: string;
                          webpSrcSet: string;
                          width: any;
                        } | null;
                      } | null;
                      imageLoad?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        title?: string | null;
                        url: string;
                        blurUpThumb?: string | null;
                        focalPoint?: {
                          __typename?: 'focalPoint';
                          x: any;
                          y: any;
                        } | null;
                        colors: Array<{
                          __typename?: 'ColorField';
                          hex: string;
                        }>;
                      } | null;
                    } | null;
                    caption?: {
                      __typename?: 'TextBlockRecord';
                      id: any;
                      smallHeader?: any | null;
                      header?: string | null;
                      text?: string | null;
                      introText?: string | null;
                      ctaButtons: Array<{
                        __typename?: 'CtaButtonRecord';
                        id: any;
                        text?: string | null;
                        url?: string | null;
                        variant?: string | null;
                      }>;
                    } | null;
                  }
                | {
                    __typename?: 'NewsListBlockRecord';
                    id: any;
                    title?: string | null;
                    standalone?: any | null;
                    largeTitle?: any | null;
                    itemsToShow?: any | null;
                  }
                | {
                    __typename?: 'ReportsListBlockRecord';
                    id: any;
                    title?: string | null;
                    standalone?: any | null;
                    largeTitle?: any | null;
                  }
                | {
                    __typename?: 'TextBlockRecord';
                    id: any;
                    smallHeader?: any | null;
                    header?: string | null;
                    text?: string | null;
                    introText?: string | null;
                    ctaButtons: Array<{
                      __typename?: 'CtaButtonRecord';
                      id: any;
                      text?: string | null;
                      url?: string | null;
                      variant?: string | null;
                    }>;
                  }
              >;
            }
          | {
              __typename?: 'ImageRecord';
              id: any;
              fullWidth?: any | null;
              image?: {
                __typename?: 'FileField';
                alt?: string | null;
                responsiveImage?: {
                  __typename?: 'ResponsiveImage';
                  aspectRatio: any;
                  base64?: string | null;
                  bgColor?: string | null;
                  height: any;
                  sizes: string;
                  src: string;
                  srcSet: string;
                  webpSrcSet: string;
                  width: any;
                } | null;
              } | null;
              imageLoad?: {
                __typename?: 'FileField';
                alt?: string | null;
                title?: string | null;
                url: string;
                blurUpThumb?: string | null;
                focalPoint?: {
                  __typename?: 'focalPoint';
                  x: any;
                  y: any;
                } | null;
                colors: Array<{ __typename?: 'ColorField'; hex: string }>;
              } | null;
            }
          | {
              __typename?: 'MediaWithCaptionRecord';
              id: any;
              centerText?: any | null;
              textOnImage?: any | null;
              media?: {
                __typename?: 'ImageRecord';
                id: any;
                fullWidth?: any | null;
                image?: {
                  __typename?: 'FileField';
                  alt?: string | null;
                  responsiveImage?: {
                    __typename?: 'ResponsiveImage';
                    aspectRatio: any;
                    base64?: string | null;
                    bgColor?: string | null;
                    height: any;
                    sizes: string;
                    src: string;
                    srcSet: string;
                    webpSrcSet: string;
                    width: any;
                  } | null;
                } | null;
                imageLoad?: {
                  __typename?: 'FileField';
                  alt?: string | null;
                  title?: string | null;
                  url: string;
                  blurUpThumb?: string | null;
                  focalPoint?: {
                    __typename?: 'focalPoint';
                    x: any;
                    y: any;
                  } | null;
                  colors: Array<{ __typename?: 'ColorField'; hex: string }>;
                } | null;
              } | null;
              caption?: {
                __typename?: 'TextBlockRecord';
                id: any;
                smallHeader?: any | null;
                header?: string | null;
                text?: string | null;
                introText?: string | null;
                ctaButtons: Array<{
                  __typename?: 'CtaButtonRecord';
                  id: any;
                  text?: string | null;
                  url?: string | null;
                  variant?: string | null;
                }>;
              } | null;
            }
          | {
              __typename?: 'TextBlockRecord';
              id: any;
              smallHeader?: any | null;
              header?: string | null;
              text?: string | null;
              introText?: string | null;
              ctaButtons: Array<{
                __typename?: 'CtaButtonRecord';
                id: any;
                text?: string | null;
                url?: string | null;
                variant?: string | null;
              }>;
            }
        >;
      }
    | {
        __typename?: 'GridTwocolBlockRecord';
        id: any;
        content: Array<
          | {
              __typename?: 'ImageRecord';
              id: any;
              fullWidth?: any | null;
              image?: {
                __typename?: 'FileField';
                alt?: string | null;
                responsiveImage?: {
                  __typename?: 'ResponsiveImage';
                  aspectRatio: any;
                  base64?: string | null;
                  bgColor?: string | null;
                  height: any;
                  sizes: string;
                  src: string;
                  srcSet: string;
                  webpSrcSet: string;
                  width: any;
                } | null;
              } | null;
              imageLoad?: {
                __typename?: 'FileField';
                alt?: string | null;
                title?: string | null;
                url: string;
                blurUpThumb?: string | null;
                focalPoint?: {
                  __typename?: 'focalPoint';
                  x: any;
                  y: any;
                } | null;
                colors: Array<{ __typename?: 'ColorField'; hex: string }>;
              } | null;
            }
          | {
              __typename?: 'MediaWithCaptionRecord';
              id: any;
              centerText?: any | null;
              textOnImage?: any | null;
              media?: {
                __typename?: 'ImageRecord';
                id: any;
                fullWidth?: any | null;
                image?: {
                  __typename?: 'FileField';
                  alt?: string | null;
                  responsiveImage?: {
                    __typename?: 'ResponsiveImage';
                    aspectRatio: any;
                    base64?: string | null;
                    bgColor?: string | null;
                    height: any;
                    sizes: string;
                    src: string;
                    srcSet: string;
                    webpSrcSet: string;
                    width: any;
                  } | null;
                } | null;
                imageLoad?: {
                  __typename?: 'FileField';
                  alt?: string | null;
                  title?: string | null;
                  url: string;
                  blurUpThumb?: string | null;
                  focalPoint?: {
                    __typename?: 'focalPoint';
                    x: any;
                    y: any;
                  } | null;
                  colors: Array<{ __typename?: 'ColorField'; hex: string }>;
                } | null;
              } | null;
              caption?: {
                __typename?: 'TextBlockRecord';
                id: any;
                smallHeader?: any | null;
                header?: string | null;
                text?: string | null;
                introText?: string | null;
                ctaButtons: Array<{
                  __typename?: 'CtaButtonRecord';
                  id: any;
                  text?: string | null;
                  url?: string | null;
                  variant?: string | null;
                }>;
              } | null;
            }
          | {
              __typename?: 'NewsListBlockRecord';
              id: any;
              title?: string | null;
              standalone?: any | null;
              largeTitle?: any | null;
              itemsToShow?: any | null;
            }
          | {
              __typename?: 'ReportsListBlockRecord';
              id: any;
              title?: string | null;
              standalone?: any | null;
              largeTitle?: any | null;
            }
          | {
              __typename?: 'TextBlockRecord';
              id: any;
              smallHeader?: any | null;
              header?: string | null;
              text?: string | null;
              introText?: string | null;
              ctaButtons: Array<{
                __typename?: 'CtaButtonRecord';
                id: any;
                text?: string | null;
                url?: string | null;
                variant?: string | null;
              }>;
            }
        >;
      }
  >;
};

type CampaignPageContentArea_HeroBlockRecord_Fragment = {
  __typename?: 'HeroBlockRecord';
  id: any;
  title?: string | null;
  description?: string | null;
  ctaText?: string | null;
  ctaUrl?: string | null;
  fullWidth?: any | null;
  boxColor?: { __typename?: 'ColorField'; hex: string } | null;
  textColor?: { __typename?: 'ColorField'; hex: string } | null;
  image?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
  imageOverlay?: {
    __typename?: 'OverlayRecord';
    id: any;
    opacity?: any | null;
    color?: { __typename?: 'ColorField'; hex: string } | null;
  } | null;
  ctaButtons: Array<{
    __typename?: 'CtaButtonRecord';
    id: any;
    text?: string | null;
    url?: string | null;
    variant?: string | null;
  }>;
  video?: {
    __typename?: 'FileField';
    blurUpThumb?: string | null;
    title?: string | null;
    alt?: string | null;
    video?: {
      __typename?: 'UploadVideoField';
      muxPlaybackId: string;
      width: any;
      height: any;
    } | null;
  } | null;
};

type CampaignPageContentArea_ImageRecord_Fragment = {
  __typename?: 'ImageRecord';
  id: any;
  fullWidth?: any | null;
  image?: {
    __typename?: 'FileField';
    alt?: string | null;
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  imageLoad?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
};

type CampaignPageContentArea_JobsListBlockRecord_Fragment = {
  __typename?: 'JobsListBlockRecord';
  id: any;
  title?: string | null;
};

type CampaignPageContentArea_NewsAndReportsListBlockRecord_Fragment = {
  __typename?: 'NewsAndReportsListBlockRecord';
  newsTitle?: string | null;
  reportsTitle?: string | null;
  newsImage?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
  news: Array<{
    __typename?: 'NewsPageRecord';
    id: any;
    title?: string | null;
    slug?: string | null;
    publishDate?: any | null;
    category?: string | null;
  }>;
  reportsImage?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
  reports: Array<{
    __typename?: 'ReportsListingRecord';
    id: any;
    title?: string | null;
    slug?: string | null;
    publishDate?: any | null;
    category?: string | null;
    pdf?: {
      __typename?: 'FileField';
      alt?: string | null;
      filename: string;
      format: string;
      size: any;
      title?: string | null;
      url: string;
      uploadId: any;
    } | null;
  }>;
};

type CampaignPageContentArea_NewsListBlockRecord_Fragment = {
  __typename?: 'NewsListBlockRecord';
  id: any;
  title?: string | null;
  standalone?: any | null;
  largeTitle?: any | null;
  itemsToShow?: any | null;
};

type CampaignPageContentArea_OfficesBlockRecord_Fragment = {
  __typename?: 'OfficesBlockRecord';
  id: any;
  offices: Array<{
    __typename?: 'OfficeRecord';
    id: any;
    name?: string | null;
    address?: string | null;
    zipCode?: string | null;
    city?: string | null;
    country?: string | null;
    email?: string | null;
    websiteUrl?: string | null;
    phoneNumber?: string | null;
  }>;
};

type CampaignPageContentArea_PlugBlockRecord_Fragment = {
  __typename?: 'PlugBlockRecord';
  id: any;
  title?: string | null;
  description?: string | null;
  brands: Array<{
    __typename?: 'BrandPageRecord';
    id: any;
    brandName?: string | null;
    slug?: string | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      tags: Array<string>;
      title?: string | null;
      url: string;
      width?: any | null;
      height?: any | null;
      format: string;
      responsiveImage?: {
        __typename?: 'ResponsiveImage';
        aspectRatio: any;
        base64?: string | null;
        bgColor?: string | null;
        height: any;
        sizes: string;
        src: string;
        srcSet: string;
        webpSrcSet: string;
        width: any;
      } | null;
    } | null;
    imageLoad?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
  }>;
};

type CampaignPageContentArea_SimpleTitleAndTextBlockRecord_Fragment = {
  __typename?: 'SimpleTitleAndTextBlockRecord';
  id: any;
  title?: string | null;
  topLabel?: string | null;
  description?: string | null;
};

type CampaignPageContentArea_SliderBlockRecord_Fragment = {
  __typename?: 'SliderBlockRecord';
  title?: string | null;
  arrows?: any | null;
  slideAnimation?: any | null;
  delay?: any | null;
  dots?: any | null;
  heroes: Array<{
    __typename?: 'HeroBlockRecord';
    id: any;
    title?: string | null;
    description?: string | null;
    ctaText?: string | null;
    ctaUrl?: string | null;
    fullWidth?: any | null;
    boxColor?: { __typename?: 'ColorField'; hex: string } | null;
    textColor?: { __typename?: 'ColorField'; hex: string } | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
    imageOverlay?: {
      __typename?: 'OverlayRecord';
      id: any;
      opacity?: any | null;
      color?: { __typename?: 'ColorField'; hex: string } | null;
    } | null;
    ctaButtons: Array<{
      __typename?: 'CtaButtonRecord';
      id: any;
      text?: string | null;
      url?: string | null;
      variant?: string | null;
    }>;
    video?: {
      __typename?: 'FileField';
      blurUpThumb?: string | null;
      title?: string | null;
      alt?: string | null;
      video?: {
        __typename?: 'UploadVideoField';
        muxPlaybackId: string;
        width: any;
        height: any;
      } | null;
    } | null;
  }>;
};

type CampaignPageContentArea_StatementBlockRecord_Fragment = {
  __typename?: 'StatementBlockRecord';
  id: any;
  text?: string | null;
  blackBackground?: any | null;
  header?: string | null;
  small?: any | null;
  linkText?: string | null;
  linkUrl?: string | null;
  imageMobile?: {
    __typename?: 'FileField';
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  imageTablet?: {
    __typename?: 'FileField';
    alt?: string | null;
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  imageDesktop?: {
    __typename?: 'FileField';
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  imageLoad?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
  imageOverlay?: {
    __typename?: 'OverlayRecord';
    id: any;
    opacity?: any | null;
    color?: { __typename?: 'ColorField'; hex: string } | null;
  } | null;
};

type CampaignPageContentArea_SubheadingBlockRecord_Fragment = {
  __typename?: 'SubheadingBlockRecord';
  id: any;
  title?: string | null;
  text?: string | null;
  ctaButton?: {
    __typename?: 'CtaButtonRecord';
    id: any;
    text?: string | null;
    url?: string | null;
    variant?: string | null;
  } | null;
  backgroundColor?: { __typename?: 'ColorField'; hex: string } | null;
};

type CampaignPageContentArea_SustainabilityReportsBlockRecord_Fragment = {
  __typename?: 'SustainabilityReportsBlockRecord';
  id: any;
  title?: string | null;
  reports: Array<{
    __typename?: 'FileField';
    alt?: string | null;
    filename: string;
    format: string;
    size: any;
    title?: string | null;
    url: string;
    uploadId: any;
  }>;
};

type CampaignPageContentArea_TextBlockRecord_Fragment = {
  __typename?: 'TextBlockRecord';
  id: any;
  smallHeader?: any | null;
  header?: string | null;
  text?: string | null;
  introText?: string | null;
  ctaButtons: Array<{
    __typename?: 'CtaButtonRecord';
    id: any;
    text?: string | null;
    url?: string | null;
    variant?: string | null;
  }>;
};

type CampaignPageContentArea_TwoColumnImageAndTextRecord_Fragment = {
  __typename?: 'TwoColumnImageAndTextRecord';
  id: any;
  text?: string | null;
  title?: string | null;
  reverse?: any | null;
  image?: {
    __typename?: 'FileField';
    alt?: string | null;
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  imageLoad?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
};

type CampaignPageContentArea_TwoColumnTextIntroRecord_Fragment = {
  __typename?: 'TwoColumnTextIntroRecord';
  id: any;
  introText?: string | null;
  text?: string | null;
  header?: string | null;
};

type CampaignPageContentArea_VideoRecord_Fragment = {
  __typename?: 'VideoRecord';
  id: any;
  autoplay?: any | null;
  video?: {
    __typename?: 'FileField';
    title?: string | null;
    video?: {
      __typename?: 'UploadVideoField';
      mp4Url?: string | null;
      streamingUrl: string;
      thumbnailUrl: string;
      mp4Low?: string | null;
    } | null;
  } | null;
  videoThumbnail?: {
    __typename?: 'FileField';
    alt?: string | null;
    tags: Array<string>;
    title?: string | null;
    url: string;
    width?: any | null;
    height?: any | null;
    format: string;
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  muxVideo?: {
    __typename?: 'FileField';
    blurUpThumb?: string | null;
    title?: string | null;
    alt?: string | null;
    video?: {
      __typename?: 'UploadVideoField';
      muxPlaybackId: string;
      width: any;
      height: any;
    } | null;
  } | null;
};

export type CampaignPageContentAreaFragment =
  | CampaignPageContentArea_ArticlesBlockRecord_Fragment
  | CampaignPageContentArea_BrandsBlockRecord_Fragment
  | CampaignPageContentArea_BulletListRecord_Fragment
  | CampaignPageContentArea_DocumentLinkBlockRecord_Fragment
  | CampaignPageContentArea_EmployeeRecord_Fragment
  | CampaignPageContentArea_GridContainerBlockRecord_Fragment
  | CampaignPageContentArea_HeroBlockRecord_Fragment
  | CampaignPageContentArea_ImageRecord_Fragment
  | CampaignPageContentArea_JobsListBlockRecord_Fragment
  | CampaignPageContentArea_NewsAndReportsListBlockRecord_Fragment
  | CampaignPageContentArea_NewsListBlockRecord_Fragment
  | CampaignPageContentArea_OfficesBlockRecord_Fragment
  | CampaignPageContentArea_PlugBlockRecord_Fragment
  | CampaignPageContentArea_SimpleTitleAndTextBlockRecord_Fragment
  | CampaignPageContentArea_SliderBlockRecord_Fragment
  | CampaignPageContentArea_StatementBlockRecord_Fragment
  | CampaignPageContentArea_SubheadingBlockRecord_Fragment
  | CampaignPageContentArea_SustainabilityReportsBlockRecord_Fragment
  | CampaignPageContentArea_TextBlockRecord_Fragment
  | CampaignPageContentArea_TwoColumnImageAndTextRecord_Fragment
  | CampaignPageContentArea_TwoColumnTextIntroRecord_Fragment
  | CampaignPageContentArea_VideoRecord_Fragment;

export type CampaignPageContentFragment = {
  __typename?: 'CampaignPageRecord';
  id: any;
  pageLocales: Array<SiteLocale>;
  seo?: {
    __typename?: 'SeoField';
    description?: string | null;
    title?: string | null;
    image?: {
      __typename?: 'FileField';
      url: string;
      alt?: string | null;
      title?: string | null;
    } | null;
  } | null;
  contentArea: Array<
    | {
        __typename?: 'ArticlesBlockRecord';
        id: any;
        title?: string | null;
        isJobArticles?: any | null;
        ctaText?: string | null;
        ctaUrl?: string | null;
        jobPages: Array<{
          __typename?: 'JobOpportunitiesPageRecord';
          id: any;
          slug?: string | null;
          title?: string | null;
          publishDate?: any | null;
          category?: string | null;
          country?: string | null;
          department?: string | null;
        }>;
        newsPages: Array<{
          __typename?: 'NewsPageRecord';
          id: any;
          slug?: string | null;
          title?: string | null;
          publishDate?: any | null;
          category?: string | null;
          country?: string | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
        }>;
        reportPages: Array<{
          __typename?: 'ReportsListingRecord';
          id: any;
          slug?: string | null;
          title?: string | null;
          publishDate?: any | null;
          category?: string | null;
          country?: string | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
          pdf?: {
            __typename?: 'FileField';
            alt?: string | null;
            filename: string;
            format: string;
            size: any;
            title?: string | null;
            url: string;
            uploadId: any;
          } | null;
        }>;
      }
    | {
        __typename?: 'BrandsBlockRecord';
        id: any;
        title?: string | null;
        introText?: string | null;
        hideLabels?: any | null;
        brands: Array<{
          __typename?: 'BrandPageRecord';
          id: any;
          brandName?: string | null;
          slug?: string | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            tags: Array<string>;
            title?: string | null;
            url: string;
            width?: any | null;
            height?: any | null;
            format: string;
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageLoad?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
        }>;
      }
    | {
        __typename?: 'BulletListRecord';
        id: any;
        bullets?: string | null;
        numberedList?: any | null;
        title?: string | null;
      }
    | {
        __typename?: 'DocumentLinkBlockRecord';
        id: any;
        documents: Array<{
          __typename?: 'FileField';
          alt?: string | null;
          filename: string;
          format: string;
          size: any;
          title?: string | null;
          url: string;
          uploadId: any;
        }>;
      }
    | {
        __typename?: 'EmployeeRecord';
        id: any;
        name?: string | null;
        title?: string | null;
        introText?: string | null;
        description?: string | null;
        image?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
      }
    | {
        __typename?: 'GridContainerBlockRecord';
        id: any;
        fullwidth?: any | null;
        gap?: any | null;
        backgroundColor?: { __typename?: 'ColorField'; hex: string } | null;
        textColor?: { __typename?: 'ColorField'; hex: string } | null;
        content: Array<
          | {
              __typename?: 'GridFourcolBlockRecord';
              id: any;
              content: Array<
                | {
                    __typename?: 'ImageRecord';
                    id: any;
                    fullWidth?: any | null;
                    image?: {
                      __typename?: 'FileField';
                      alt?: string | null;
                      responsiveImage?: {
                        __typename?: 'ResponsiveImage';
                        aspectRatio: any;
                        base64?: string | null;
                        bgColor?: string | null;
                        height: any;
                        sizes: string;
                        src: string;
                        srcSet: string;
                        webpSrcSet: string;
                        width: any;
                      } | null;
                    } | null;
                    imageLoad?: {
                      __typename?: 'FileField';
                      alt?: string | null;
                      title?: string | null;
                      url: string;
                      blurUpThumb?: string | null;
                      focalPoint?: {
                        __typename?: 'focalPoint';
                        x: any;
                        y: any;
                      } | null;
                      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
                    } | null;
                  }
                | {
                    __typename?: 'MediaWithCaptionRecord';
                    id: any;
                    centerText?: any | null;
                    textOnImage?: any | null;
                    media?: {
                      __typename?: 'ImageRecord';
                      id: any;
                      fullWidth?: any | null;
                      image?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        responsiveImage?: {
                          __typename?: 'ResponsiveImage';
                          aspectRatio: any;
                          base64?: string | null;
                          bgColor?: string | null;
                          height: any;
                          sizes: string;
                          src: string;
                          srcSet: string;
                          webpSrcSet: string;
                          width: any;
                        } | null;
                      } | null;
                      imageLoad?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        title?: string | null;
                        url: string;
                        blurUpThumb?: string | null;
                        focalPoint?: {
                          __typename?: 'focalPoint';
                          x: any;
                          y: any;
                        } | null;
                        colors: Array<{
                          __typename?: 'ColorField';
                          hex: string;
                        }>;
                      } | null;
                    } | null;
                    caption?: {
                      __typename?: 'TextBlockRecord';
                      id: any;
                      smallHeader?: any | null;
                      header?: string | null;
                      text?: string | null;
                      introText?: string | null;
                      ctaButtons: Array<{
                        __typename?: 'CtaButtonRecord';
                        id: any;
                        text?: string | null;
                        url?: string | null;
                        variant?: string | null;
                      }>;
                    } | null;
                  }
                | {
                    __typename?: 'TextBlockRecord';
                    id: any;
                    smallHeader?: any | null;
                    header?: string | null;
                    text?: string | null;
                    introText?: string | null;
                    ctaButtons: Array<{
                      __typename?: 'CtaButtonRecord';
                      id: any;
                      text?: string | null;
                      url?: string | null;
                      variant?: string | null;
                    }>;
                  }
              >;
            }
          | {
              __typename?: 'GridThreecolBlockRecord';
              id: any;
              content: Array<
                | {
                    __typename?: 'GridTwocolBlockRecord';
                    id: any;
                    content: Array<
                      | {
                          __typename?: 'ImageRecord';
                          id: any;
                          fullWidth?: any | null;
                          image?: {
                            __typename?: 'FileField';
                            alt?: string | null;
                            responsiveImage?: {
                              __typename?: 'ResponsiveImage';
                              aspectRatio: any;
                              base64?: string | null;
                              bgColor?: string | null;
                              height: any;
                              sizes: string;
                              src: string;
                              srcSet: string;
                              webpSrcSet: string;
                              width: any;
                            } | null;
                          } | null;
                          imageLoad?: {
                            __typename?: 'FileField';
                            alt?: string | null;
                            title?: string | null;
                            url: string;
                            blurUpThumb?: string | null;
                            focalPoint?: {
                              __typename?: 'focalPoint';
                              x: any;
                              y: any;
                            } | null;
                            colors: Array<{
                              __typename?: 'ColorField';
                              hex: string;
                            }>;
                          } | null;
                        }
                      | {
                          __typename?: 'MediaWithCaptionRecord';
                          id: any;
                          centerText?: any | null;
                          textOnImage?: any | null;
                          media?: {
                            __typename?: 'ImageRecord';
                            id: any;
                            fullWidth?: any | null;
                            image?: {
                              __typename?: 'FileField';
                              alt?: string | null;
                              responsiveImage?: {
                                __typename?: 'ResponsiveImage';
                                aspectRatio: any;
                                base64?: string | null;
                                bgColor?: string | null;
                                height: any;
                                sizes: string;
                                src: string;
                                srcSet: string;
                                webpSrcSet: string;
                                width: any;
                              } | null;
                            } | null;
                            imageLoad?: {
                              __typename?: 'FileField';
                              alt?: string | null;
                              title?: string | null;
                              url: string;
                              blurUpThumb?: string | null;
                              focalPoint?: {
                                __typename?: 'focalPoint';
                                x: any;
                                y: any;
                              } | null;
                              colors: Array<{
                                __typename?: 'ColorField';
                                hex: string;
                              }>;
                            } | null;
                          } | null;
                          caption?: {
                            __typename?: 'TextBlockRecord';
                            id: any;
                            smallHeader?: any | null;
                            header?: string | null;
                            text?: string | null;
                            introText?: string | null;
                            ctaButtons: Array<{
                              __typename?: 'CtaButtonRecord';
                              id: any;
                              text?: string | null;
                              url?: string | null;
                              variant?: string | null;
                            }>;
                          } | null;
                        }
                      | {
                          __typename?: 'NewsListBlockRecord';
                          id: any;
                          title?: string | null;
                          standalone?: any | null;
                          largeTitle?: any | null;
                          itemsToShow?: any | null;
                        }
                      | {
                          __typename?: 'ReportsListBlockRecord';
                          id: any;
                          title?: string | null;
                          standalone?: any | null;
                          largeTitle?: any | null;
                        }
                      | {
                          __typename?: 'TextBlockRecord';
                          id: any;
                          smallHeader?: any | null;
                          header?: string | null;
                          text?: string | null;
                          introText?: string | null;
                          ctaButtons: Array<{
                            __typename?: 'CtaButtonRecord';
                            id: any;
                            text?: string | null;
                            url?: string | null;
                            variant?: string | null;
                          }>;
                        }
                    >;
                  }
                | {
                    __typename?: 'ImageRecord';
                    id: any;
                    fullWidth?: any | null;
                    image?: {
                      __typename?: 'FileField';
                      alt?: string | null;
                      responsiveImage?: {
                        __typename?: 'ResponsiveImage';
                        aspectRatio: any;
                        base64?: string | null;
                        bgColor?: string | null;
                        height: any;
                        sizes: string;
                        src: string;
                        srcSet: string;
                        webpSrcSet: string;
                        width: any;
                      } | null;
                    } | null;
                    imageLoad?: {
                      __typename?: 'FileField';
                      alt?: string | null;
                      title?: string | null;
                      url: string;
                      blurUpThumb?: string | null;
                      focalPoint?: {
                        __typename?: 'focalPoint';
                        x: any;
                        y: any;
                      } | null;
                      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
                    } | null;
                  }
                | {
                    __typename?: 'MediaWithCaptionRecord';
                    id: any;
                    centerText?: any | null;
                    textOnImage?: any | null;
                    media?: {
                      __typename?: 'ImageRecord';
                      id: any;
                      fullWidth?: any | null;
                      image?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        responsiveImage?: {
                          __typename?: 'ResponsiveImage';
                          aspectRatio: any;
                          base64?: string | null;
                          bgColor?: string | null;
                          height: any;
                          sizes: string;
                          src: string;
                          srcSet: string;
                          webpSrcSet: string;
                          width: any;
                        } | null;
                      } | null;
                      imageLoad?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        title?: string | null;
                        url: string;
                        blurUpThumb?: string | null;
                        focalPoint?: {
                          __typename?: 'focalPoint';
                          x: any;
                          y: any;
                        } | null;
                        colors: Array<{
                          __typename?: 'ColorField';
                          hex: string;
                        }>;
                      } | null;
                    } | null;
                    caption?: {
                      __typename?: 'TextBlockRecord';
                      id: any;
                      smallHeader?: any | null;
                      header?: string | null;
                      text?: string | null;
                      introText?: string | null;
                      ctaButtons: Array<{
                        __typename?: 'CtaButtonRecord';
                        id: any;
                        text?: string | null;
                        url?: string | null;
                        variant?: string | null;
                      }>;
                    } | null;
                  }
                | {
                    __typename?: 'TextBlockRecord';
                    id: any;
                    smallHeader?: any | null;
                    header?: string | null;
                    text?: string | null;
                    introText?: string | null;
                    ctaButtons: Array<{
                      __typename?: 'CtaButtonRecord';
                      id: any;
                      text?: string | null;
                      url?: string | null;
                      variant?: string | null;
                    }>;
                  }
              >;
            }
          | {
              __typename?: 'GridTwocolBlockRecord';
              id: any;
              content: Array<
                | {
                    __typename?: 'ImageRecord';
                    id: any;
                    fullWidth?: any | null;
                    image?: {
                      __typename?: 'FileField';
                      alt?: string | null;
                      responsiveImage?: {
                        __typename?: 'ResponsiveImage';
                        aspectRatio: any;
                        base64?: string | null;
                        bgColor?: string | null;
                        height: any;
                        sizes: string;
                        src: string;
                        srcSet: string;
                        webpSrcSet: string;
                        width: any;
                      } | null;
                    } | null;
                    imageLoad?: {
                      __typename?: 'FileField';
                      alt?: string | null;
                      title?: string | null;
                      url: string;
                      blurUpThumb?: string | null;
                      focalPoint?: {
                        __typename?: 'focalPoint';
                        x: any;
                        y: any;
                      } | null;
                      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
                    } | null;
                  }
                | {
                    __typename?: 'MediaWithCaptionRecord';
                    id: any;
                    centerText?: any | null;
                    textOnImage?: any | null;
                    media?: {
                      __typename?: 'ImageRecord';
                      id: any;
                      fullWidth?: any | null;
                      image?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        responsiveImage?: {
                          __typename?: 'ResponsiveImage';
                          aspectRatio: any;
                          base64?: string | null;
                          bgColor?: string | null;
                          height: any;
                          sizes: string;
                          src: string;
                          srcSet: string;
                          webpSrcSet: string;
                          width: any;
                        } | null;
                      } | null;
                      imageLoad?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        title?: string | null;
                        url: string;
                        blurUpThumb?: string | null;
                        focalPoint?: {
                          __typename?: 'focalPoint';
                          x: any;
                          y: any;
                        } | null;
                        colors: Array<{
                          __typename?: 'ColorField';
                          hex: string;
                        }>;
                      } | null;
                    } | null;
                    caption?: {
                      __typename?: 'TextBlockRecord';
                      id: any;
                      smallHeader?: any | null;
                      header?: string | null;
                      text?: string | null;
                      introText?: string | null;
                      ctaButtons: Array<{
                        __typename?: 'CtaButtonRecord';
                        id: any;
                        text?: string | null;
                        url?: string | null;
                        variant?: string | null;
                      }>;
                    } | null;
                  }
                | {
                    __typename?: 'NewsListBlockRecord';
                    id: any;
                    title?: string | null;
                    standalone?: any | null;
                    largeTitle?: any | null;
                    itemsToShow?: any | null;
                  }
                | {
                    __typename?: 'ReportsListBlockRecord';
                    id: any;
                    title?: string | null;
                    standalone?: any | null;
                    largeTitle?: any | null;
                  }
                | {
                    __typename?: 'TextBlockRecord';
                    id: any;
                    smallHeader?: any | null;
                    header?: string | null;
                    text?: string | null;
                    introText?: string | null;
                    ctaButtons: Array<{
                      __typename?: 'CtaButtonRecord';
                      id: any;
                      text?: string | null;
                      url?: string | null;
                      variant?: string | null;
                    }>;
                  }
              >;
            }
        >;
      }
    | {
        __typename?: 'HeroBlockRecord';
        id: any;
        title?: string | null;
        description?: string | null;
        ctaText?: string | null;
        ctaUrl?: string | null;
        fullWidth?: any | null;
        boxColor?: { __typename?: 'ColorField'; hex: string } | null;
        textColor?: { __typename?: 'ColorField'; hex: string } | null;
        image?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
        imageOverlay?: {
          __typename?: 'OverlayRecord';
          id: any;
          opacity?: any | null;
          color?: { __typename?: 'ColorField'; hex: string } | null;
        } | null;
        ctaButtons: Array<{
          __typename?: 'CtaButtonRecord';
          id: any;
          text?: string | null;
          url?: string | null;
          variant?: string | null;
        }>;
        video?: {
          __typename?: 'FileField';
          blurUpThumb?: string | null;
          title?: string | null;
          alt?: string | null;
          video?: {
            __typename?: 'UploadVideoField';
            muxPlaybackId: string;
            width: any;
            height: any;
          } | null;
        } | null;
      }
    | {
        __typename?: 'ImageRecord';
        id: any;
        fullWidth?: any | null;
        image?: {
          __typename?: 'FileField';
          alt?: string | null;
          responsiveImage?: {
            __typename?: 'ResponsiveImage';
            aspectRatio: any;
            base64?: string | null;
            bgColor?: string | null;
            height: any;
            sizes: string;
            src: string;
            srcSet: string;
            webpSrcSet: string;
            width: any;
          } | null;
        } | null;
        imageLoad?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
      }
    | { __typename?: 'JobsListBlockRecord'; id: any; title?: string | null }
    | {
        __typename?: 'NewsAndReportsListBlockRecord';
        newsTitle?: string | null;
        reportsTitle?: string | null;
        newsImage?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
        news: Array<{
          __typename?: 'NewsPageRecord';
          id: any;
          title?: string | null;
          slug?: string | null;
          publishDate?: any | null;
          category?: string | null;
        }>;
        reportsImage?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
        reports: Array<{
          __typename?: 'ReportsListingRecord';
          id: any;
          title?: string | null;
          slug?: string | null;
          publishDate?: any | null;
          category?: string | null;
          pdf?: {
            __typename?: 'FileField';
            alt?: string | null;
            filename: string;
            format: string;
            size: any;
            title?: string | null;
            url: string;
            uploadId: any;
          } | null;
        }>;
      }
    | {
        __typename?: 'NewsListBlockRecord';
        id: any;
        title?: string | null;
        standalone?: any | null;
        largeTitle?: any | null;
        itemsToShow?: any | null;
      }
    | {
        __typename?: 'OfficesBlockRecord';
        id: any;
        offices: Array<{
          __typename?: 'OfficeRecord';
          id: any;
          name?: string | null;
          address?: string | null;
          zipCode?: string | null;
          city?: string | null;
          country?: string | null;
          email?: string | null;
          websiteUrl?: string | null;
          phoneNumber?: string | null;
        }>;
      }
    | {
        __typename?: 'PlugBlockRecord';
        id: any;
        title?: string | null;
        description?: string | null;
        brands: Array<{
          __typename?: 'BrandPageRecord';
          id: any;
          brandName?: string | null;
          slug?: string | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            tags: Array<string>;
            title?: string | null;
            url: string;
            width?: any | null;
            height?: any | null;
            format: string;
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageLoad?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
        }>;
      }
    | {
        __typename?: 'SimpleTitleAndTextBlockRecord';
        id: any;
        title?: string | null;
        topLabel?: string | null;
        description?: string | null;
      }
    | {
        __typename?: 'SliderBlockRecord';
        title?: string | null;
        arrows?: any | null;
        slideAnimation?: any | null;
        delay?: any | null;
        dots?: any | null;
        heroes: Array<{
          __typename?: 'HeroBlockRecord';
          id: any;
          title?: string | null;
          description?: string | null;
          ctaText?: string | null;
          ctaUrl?: string | null;
          fullWidth?: any | null;
          boxColor?: { __typename?: 'ColorField'; hex: string } | null;
          textColor?: { __typename?: 'ColorField'; hex: string } | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
          imageOverlay?: {
            __typename?: 'OverlayRecord';
            id: any;
            opacity?: any | null;
            color?: { __typename?: 'ColorField'; hex: string } | null;
          } | null;
          ctaButtons: Array<{
            __typename?: 'CtaButtonRecord';
            id: any;
            text?: string | null;
            url?: string | null;
            variant?: string | null;
          }>;
          video?: {
            __typename?: 'FileField';
            blurUpThumb?: string | null;
            title?: string | null;
            alt?: string | null;
            video?: {
              __typename?: 'UploadVideoField';
              muxPlaybackId: string;
              width: any;
              height: any;
            } | null;
          } | null;
        }>;
      }
    | {
        __typename?: 'StatementBlockRecord';
        id: any;
        text?: string | null;
        blackBackground?: any | null;
        header?: string | null;
        small?: any | null;
        linkText?: string | null;
        linkUrl?: string | null;
        imageMobile?: {
          __typename?: 'FileField';
          responsiveImage?: {
            __typename?: 'ResponsiveImage';
            aspectRatio: any;
            base64?: string | null;
            bgColor?: string | null;
            height: any;
            sizes: string;
            src: string;
            srcSet: string;
            webpSrcSet: string;
            width: any;
          } | null;
        } | null;
        imageTablet?: {
          __typename?: 'FileField';
          alt?: string | null;
          responsiveImage?: {
            __typename?: 'ResponsiveImage';
            aspectRatio: any;
            base64?: string | null;
            bgColor?: string | null;
            height: any;
            sizes: string;
            src: string;
            srcSet: string;
            webpSrcSet: string;
            width: any;
          } | null;
        } | null;
        imageDesktop?: {
          __typename?: 'FileField';
          responsiveImage?: {
            __typename?: 'ResponsiveImage';
            aspectRatio: any;
            base64?: string | null;
            bgColor?: string | null;
            height: any;
            sizes: string;
            src: string;
            srcSet: string;
            webpSrcSet: string;
            width: any;
          } | null;
        } | null;
        imageLoad?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
        imageOverlay?: {
          __typename?: 'OverlayRecord';
          id: any;
          opacity?: any | null;
          color?: { __typename?: 'ColorField'; hex: string } | null;
        } | null;
      }
    | {
        __typename?: 'SubheadingBlockRecord';
        id: any;
        title?: string | null;
        text?: string | null;
        ctaButton?: {
          __typename?: 'CtaButtonRecord';
          id: any;
          text?: string | null;
          url?: string | null;
          variant?: string | null;
        } | null;
        backgroundColor?: { __typename?: 'ColorField'; hex: string } | null;
      }
    | {
        __typename?: 'SustainabilityReportsBlockRecord';
        id: any;
        title?: string | null;
        reports: Array<{
          __typename?: 'FileField';
          alt?: string | null;
          filename: string;
          format: string;
          size: any;
          title?: string | null;
          url: string;
          uploadId: any;
        }>;
      }
    | {
        __typename?: 'TextBlockRecord';
        id: any;
        smallHeader?: any | null;
        header?: string | null;
        text?: string | null;
        introText?: string | null;
        ctaButtons: Array<{
          __typename?: 'CtaButtonRecord';
          id: any;
          text?: string | null;
          url?: string | null;
          variant?: string | null;
        }>;
      }
    | {
        __typename?: 'TwoColumnImageAndTextRecord';
        id: any;
        text?: string | null;
        title?: string | null;
        reverse?: any | null;
        image?: {
          __typename?: 'FileField';
          alt?: string | null;
          responsiveImage?: {
            __typename?: 'ResponsiveImage';
            aspectRatio: any;
            base64?: string | null;
            bgColor?: string | null;
            height: any;
            sizes: string;
            src: string;
            srcSet: string;
            webpSrcSet: string;
            width: any;
          } | null;
        } | null;
        imageLoad?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
      }
    | {
        __typename?: 'TwoColumnTextIntroRecord';
        id: any;
        introText?: string | null;
        text?: string | null;
        header?: string | null;
      }
    | {
        __typename?: 'VideoRecord';
        id: any;
        autoplay?: any | null;
        video?: {
          __typename?: 'FileField';
          title?: string | null;
          video?: {
            __typename?: 'UploadVideoField';
            mp4Url?: string | null;
            streamingUrl: string;
            thumbnailUrl: string;
            mp4Low?: string | null;
          } | null;
        } | null;
        videoThumbnail?: {
          __typename?: 'FileField';
          alt?: string | null;
          tags: Array<string>;
          title?: string | null;
          url: string;
          width?: any | null;
          height?: any | null;
          format: string;
          responsiveImage?: {
            __typename?: 'ResponsiveImage';
            aspectRatio: any;
            base64?: string | null;
            bgColor?: string | null;
            height: any;
            sizes: string;
            src: string;
            srcSet: string;
            webpSrcSet: string;
            width: any;
          } | null;
        } | null;
        muxVideo?: {
          __typename?: 'FileField';
          blurUpThumb?: string | null;
          title?: string | null;
          alt?: string | null;
          video?: {
            __typename?: 'UploadVideoField';
            muxPlaybackId: string;
            width: any;
            height: any;
          } | null;
        } | null;
      }
  >;
};

type ContactPageContentArea_ArticlesBlockRecord_Fragment = {
  __typename?: 'ArticlesBlockRecord';
  id: any;
  title?: string | null;
  isJobArticles?: any | null;
  ctaText?: string | null;
  ctaUrl?: string | null;
  jobPages: Array<{
    __typename?: 'JobOpportunitiesPageRecord';
    id: any;
    slug?: string | null;
    title?: string | null;
    publishDate?: any | null;
    category?: string | null;
    country?: string | null;
    department?: string | null;
  }>;
  newsPages: Array<{
    __typename?: 'NewsPageRecord';
    id: any;
    slug?: string | null;
    title?: string | null;
    publishDate?: any | null;
    category?: string | null;
    country?: string | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
  }>;
  reportPages: Array<{
    __typename?: 'ReportsListingRecord';
    id: any;
    slug?: string | null;
    title?: string | null;
    publishDate?: any | null;
    category?: string | null;
    country?: string | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
    pdf?: {
      __typename?: 'FileField';
      alt?: string | null;
      filename: string;
      format: string;
      size: any;
      title?: string | null;
      url: string;
      uploadId: any;
    } | null;
  }>;
};

type ContactPageContentArea_BrandsBlockRecord_Fragment = {
  __typename?: 'BrandsBlockRecord';
  id: any;
  title?: string | null;
  introText?: string | null;
  hideLabels?: any | null;
  brands: Array<{
    __typename?: 'BrandPageRecord';
    id: any;
    brandName?: string | null;
    slug?: string | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      tags: Array<string>;
      title?: string | null;
      url: string;
      width?: any | null;
      height?: any | null;
      format: string;
      responsiveImage?: {
        __typename?: 'ResponsiveImage';
        aspectRatio: any;
        base64?: string | null;
        bgColor?: string | null;
        height: any;
        sizes: string;
        src: string;
        srcSet: string;
        webpSrcSet: string;
        width: any;
      } | null;
    } | null;
    imageLoad?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
  }>;
};

type ContactPageContentArea_BulletListRecord_Fragment = {
  __typename?: 'BulletListRecord';
  id: any;
  bullets?: string | null;
  numberedList?: any | null;
  title?: string | null;
};

type ContactPageContentArea_DocumentLinkBlockRecord_Fragment = {
  __typename?: 'DocumentLinkBlockRecord';
  id: any;
  documents: Array<{
    __typename?: 'FileField';
    alt?: string | null;
    filename: string;
    format: string;
    size: any;
    title?: string | null;
    url: string;
    uploadId: any;
  }>;
};

type ContactPageContentArea_EmployeeRecord_Fragment = {
  __typename?: 'EmployeeRecord';
  id: any;
  name?: string | null;
  title?: string | null;
  introText?: string | null;
  description?: string | null;
  image?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
};

type ContactPageContentArea_GridContainerBlockRecord_Fragment = {
  __typename?: 'GridContainerBlockRecord';
  id: any;
  fullwidth?: any | null;
  gap?: any | null;
  backgroundColor?: { __typename?: 'ColorField'; hex: string } | null;
  textColor?: { __typename?: 'ColorField'; hex: string } | null;
  content: Array<
    | {
        __typename?: 'GridFourcolBlockRecord';
        id: any;
        content: Array<
          | {
              __typename?: 'ImageRecord';
              id: any;
              fullWidth?: any | null;
              image?: {
                __typename?: 'FileField';
                alt?: string | null;
                responsiveImage?: {
                  __typename?: 'ResponsiveImage';
                  aspectRatio: any;
                  base64?: string | null;
                  bgColor?: string | null;
                  height: any;
                  sizes: string;
                  src: string;
                  srcSet: string;
                  webpSrcSet: string;
                  width: any;
                } | null;
              } | null;
              imageLoad?: {
                __typename?: 'FileField';
                alt?: string | null;
                title?: string | null;
                url: string;
                blurUpThumb?: string | null;
                focalPoint?: {
                  __typename?: 'focalPoint';
                  x: any;
                  y: any;
                } | null;
                colors: Array<{ __typename?: 'ColorField'; hex: string }>;
              } | null;
            }
          | {
              __typename?: 'MediaWithCaptionRecord';
              id: any;
              centerText?: any | null;
              textOnImage?: any | null;
              media?: {
                __typename?: 'ImageRecord';
                id: any;
                fullWidth?: any | null;
                image?: {
                  __typename?: 'FileField';
                  alt?: string | null;
                  responsiveImage?: {
                    __typename?: 'ResponsiveImage';
                    aspectRatio: any;
                    base64?: string | null;
                    bgColor?: string | null;
                    height: any;
                    sizes: string;
                    src: string;
                    srcSet: string;
                    webpSrcSet: string;
                    width: any;
                  } | null;
                } | null;
                imageLoad?: {
                  __typename?: 'FileField';
                  alt?: string | null;
                  title?: string | null;
                  url: string;
                  blurUpThumb?: string | null;
                  focalPoint?: {
                    __typename?: 'focalPoint';
                    x: any;
                    y: any;
                  } | null;
                  colors: Array<{ __typename?: 'ColorField'; hex: string }>;
                } | null;
              } | null;
              caption?: {
                __typename?: 'TextBlockRecord';
                id: any;
                smallHeader?: any | null;
                header?: string | null;
                text?: string | null;
                introText?: string | null;
                ctaButtons: Array<{
                  __typename?: 'CtaButtonRecord';
                  id: any;
                  text?: string | null;
                  url?: string | null;
                  variant?: string | null;
                }>;
              } | null;
            }
          | {
              __typename?: 'TextBlockRecord';
              id: any;
              smallHeader?: any | null;
              header?: string | null;
              text?: string | null;
              introText?: string | null;
              ctaButtons: Array<{
                __typename?: 'CtaButtonRecord';
                id: any;
                text?: string | null;
                url?: string | null;
                variant?: string | null;
              }>;
            }
        >;
      }
    | {
        __typename?: 'GridThreecolBlockRecord';
        id: any;
        content: Array<
          | {
              __typename?: 'GridTwocolBlockRecord';
              id: any;
              content: Array<
                | {
                    __typename?: 'ImageRecord';
                    id: any;
                    fullWidth?: any | null;
                    image?: {
                      __typename?: 'FileField';
                      alt?: string | null;
                      responsiveImage?: {
                        __typename?: 'ResponsiveImage';
                        aspectRatio: any;
                        base64?: string | null;
                        bgColor?: string | null;
                        height: any;
                        sizes: string;
                        src: string;
                        srcSet: string;
                        webpSrcSet: string;
                        width: any;
                      } | null;
                    } | null;
                    imageLoad?: {
                      __typename?: 'FileField';
                      alt?: string | null;
                      title?: string | null;
                      url: string;
                      blurUpThumb?: string | null;
                      focalPoint?: {
                        __typename?: 'focalPoint';
                        x: any;
                        y: any;
                      } | null;
                      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
                    } | null;
                  }
                | {
                    __typename?: 'MediaWithCaptionRecord';
                    id: any;
                    centerText?: any | null;
                    textOnImage?: any | null;
                    media?: {
                      __typename?: 'ImageRecord';
                      id: any;
                      fullWidth?: any | null;
                      image?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        responsiveImage?: {
                          __typename?: 'ResponsiveImage';
                          aspectRatio: any;
                          base64?: string | null;
                          bgColor?: string | null;
                          height: any;
                          sizes: string;
                          src: string;
                          srcSet: string;
                          webpSrcSet: string;
                          width: any;
                        } | null;
                      } | null;
                      imageLoad?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        title?: string | null;
                        url: string;
                        blurUpThumb?: string | null;
                        focalPoint?: {
                          __typename?: 'focalPoint';
                          x: any;
                          y: any;
                        } | null;
                        colors: Array<{
                          __typename?: 'ColorField';
                          hex: string;
                        }>;
                      } | null;
                    } | null;
                    caption?: {
                      __typename?: 'TextBlockRecord';
                      id: any;
                      smallHeader?: any | null;
                      header?: string | null;
                      text?: string | null;
                      introText?: string | null;
                      ctaButtons: Array<{
                        __typename?: 'CtaButtonRecord';
                        id: any;
                        text?: string | null;
                        url?: string | null;
                        variant?: string | null;
                      }>;
                    } | null;
                  }
                | {
                    __typename?: 'NewsListBlockRecord';
                    id: any;
                    title?: string | null;
                    standalone?: any | null;
                    largeTitle?: any | null;
                    itemsToShow?: any | null;
                  }
                | {
                    __typename?: 'ReportsListBlockRecord';
                    id: any;
                    title?: string | null;
                    standalone?: any | null;
                    largeTitle?: any | null;
                  }
                | {
                    __typename?: 'TextBlockRecord';
                    id: any;
                    smallHeader?: any | null;
                    header?: string | null;
                    text?: string | null;
                    introText?: string | null;
                    ctaButtons: Array<{
                      __typename?: 'CtaButtonRecord';
                      id: any;
                      text?: string | null;
                      url?: string | null;
                      variant?: string | null;
                    }>;
                  }
              >;
            }
          | {
              __typename?: 'ImageRecord';
              id: any;
              fullWidth?: any | null;
              image?: {
                __typename?: 'FileField';
                alt?: string | null;
                responsiveImage?: {
                  __typename?: 'ResponsiveImage';
                  aspectRatio: any;
                  base64?: string | null;
                  bgColor?: string | null;
                  height: any;
                  sizes: string;
                  src: string;
                  srcSet: string;
                  webpSrcSet: string;
                  width: any;
                } | null;
              } | null;
              imageLoad?: {
                __typename?: 'FileField';
                alt?: string | null;
                title?: string | null;
                url: string;
                blurUpThumb?: string | null;
                focalPoint?: {
                  __typename?: 'focalPoint';
                  x: any;
                  y: any;
                } | null;
                colors: Array<{ __typename?: 'ColorField'; hex: string }>;
              } | null;
            }
          | {
              __typename?: 'MediaWithCaptionRecord';
              id: any;
              centerText?: any | null;
              textOnImage?: any | null;
              media?: {
                __typename?: 'ImageRecord';
                id: any;
                fullWidth?: any | null;
                image?: {
                  __typename?: 'FileField';
                  alt?: string | null;
                  responsiveImage?: {
                    __typename?: 'ResponsiveImage';
                    aspectRatio: any;
                    base64?: string | null;
                    bgColor?: string | null;
                    height: any;
                    sizes: string;
                    src: string;
                    srcSet: string;
                    webpSrcSet: string;
                    width: any;
                  } | null;
                } | null;
                imageLoad?: {
                  __typename?: 'FileField';
                  alt?: string | null;
                  title?: string | null;
                  url: string;
                  blurUpThumb?: string | null;
                  focalPoint?: {
                    __typename?: 'focalPoint';
                    x: any;
                    y: any;
                  } | null;
                  colors: Array<{ __typename?: 'ColorField'; hex: string }>;
                } | null;
              } | null;
              caption?: {
                __typename?: 'TextBlockRecord';
                id: any;
                smallHeader?: any | null;
                header?: string | null;
                text?: string | null;
                introText?: string | null;
                ctaButtons: Array<{
                  __typename?: 'CtaButtonRecord';
                  id: any;
                  text?: string | null;
                  url?: string | null;
                  variant?: string | null;
                }>;
              } | null;
            }
          | {
              __typename?: 'TextBlockRecord';
              id: any;
              smallHeader?: any | null;
              header?: string | null;
              text?: string | null;
              introText?: string | null;
              ctaButtons: Array<{
                __typename?: 'CtaButtonRecord';
                id: any;
                text?: string | null;
                url?: string | null;
                variant?: string | null;
              }>;
            }
        >;
      }
    | {
        __typename?: 'GridTwocolBlockRecord';
        id: any;
        content: Array<
          | {
              __typename?: 'ImageRecord';
              id: any;
              fullWidth?: any | null;
              image?: {
                __typename?: 'FileField';
                alt?: string | null;
                responsiveImage?: {
                  __typename?: 'ResponsiveImage';
                  aspectRatio: any;
                  base64?: string | null;
                  bgColor?: string | null;
                  height: any;
                  sizes: string;
                  src: string;
                  srcSet: string;
                  webpSrcSet: string;
                  width: any;
                } | null;
              } | null;
              imageLoad?: {
                __typename?: 'FileField';
                alt?: string | null;
                title?: string | null;
                url: string;
                blurUpThumb?: string | null;
                focalPoint?: {
                  __typename?: 'focalPoint';
                  x: any;
                  y: any;
                } | null;
                colors: Array<{ __typename?: 'ColorField'; hex: string }>;
              } | null;
            }
          | {
              __typename?: 'MediaWithCaptionRecord';
              id: any;
              centerText?: any | null;
              textOnImage?: any | null;
              media?: {
                __typename?: 'ImageRecord';
                id: any;
                fullWidth?: any | null;
                image?: {
                  __typename?: 'FileField';
                  alt?: string | null;
                  responsiveImage?: {
                    __typename?: 'ResponsiveImage';
                    aspectRatio: any;
                    base64?: string | null;
                    bgColor?: string | null;
                    height: any;
                    sizes: string;
                    src: string;
                    srcSet: string;
                    webpSrcSet: string;
                    width: any;
                  } | null;
                } | null;
                imageLoad?: {
                  __typename?: 'FileField';
                  alt?: string | null;
                  title?: string | null;
                  url: string;
                  blurUpThumb?: string | null;
                  focalPoint?: {
                    __typename?: 'focalPoint';
                    x: any;
                    y: any;
                  } | null;
                  colors: Array<{ __typename?: 'ColorField'; hex: string }>;
                } | null;
              } | null;
              caption?: {
                __typename?: 'TextBlockRecord';
                id: any;
                smallHeader?: any | null;
                header?: string | null;
                text?: string | null;
                introText?: string | null;
                ctaButtons: Array<{
                  __typename?: 'CtaButtonRecord';
                  id: any;
                  text?: string | null;
                  url?: string | null;
                  variant?: string | null;
                }>;
              } | null;
            }
          | {
              __typename?: 'NewsListBlockRecord';
              id: any;
              title?: string | null;
              standalone?: any | null;
              largeTitle?: any | null;
              itemsToShow?: any | null;
            }
          | {
              __typename?: 'ReportsListBlockRecord';
              id: any;
              title?: string | null;
              standalone?: any | null;
              largeTitle?: any | null;
            }
          | {
              __typename?: 'TextBlockRecord';
              id: any;
              smallHeader?: any | null;
              header?: string | null;
              text?: string | null;
              introText?: string | null;
              ctaButtons: Array<{
                __typename?: 'CtaButtonRecord';
                id: any;
                text?: string | null;
                url?: string | null;
                variant?: string | null;
              }>;
            }
        >;
      }
  >;
};

type ContactPageContentArea_HeroBlockRecord_Fragment = {
  __typename?: 'HeroBlockRecord';
  id: any;
  title?: string | null;
  description?: string | null;
  ctaText?: string | null;
  ctaUrl?: string | null;
  fullWidth?: any | null;
  boxColor?: { __typename?: 'ColorField'; hex: string } | null;
  textColor?: { __typename?: 'ColorField'; hex: string } | null;
  image?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
  imageOverlay?: {
    __typename?: 'OverlayRecord';
    id: any;
    opacity?: any | null;
    color?: { __typename?: 'ColorField'; hex: string } | null;
  } | null;
  ctaButtons: Array<{
    __typename?: 'CtaButtonRecord';
    id: any;
    text?: string | null;
    url?: string | null;
    variant?: string | null;
  }>;
  video?: {
    __typename?: 'FileField';
    blurUpThumb?: string | null;
    title?: string | null;
    alt?: string | null;
    video?: {
      __typename?: 'UploadVideoField';
      muxPlaybackId: string;
      width: any;
      height: any;
    } | null;
  } | null;
};

type ContactPageContentArea_ImageRecord_Fragment = {
  __typename?: 'ImageRecord';
  id: any;
  fullWidth?: any | null;
  image?: {
    __typename?: 'FileField';
    alt?: string | null;
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  imageLoad?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
};

type ContactPageContentArea_JobsListBlockRecord_Fragment = {
  __typename?: 'JobsListBlockRecord';
  id: any;
  title?: string | null;
};

type ContactPageContentArea_NewsAndReportsListBlockRecord_Fragment = {
  __typename?: 'NewsAndReportsListBlockRecord';
};

type ContactPageContentArea_NewsListBlockRecord_Fragment = {
  __typename?: 'NewsListBlockRecord';
  id: any;
  title?: string | null;
  standalone?: any | null;
  largeTitle?: any | null;
  itemsToShow?: any | null;
};

type ContactPageContentArea_OfficesBlockRecord_Fragment = {
  __typename?: 'OfficesBlockRecord';
  id: any;
  offices: Array<{
    __typename?: 'OfficeRecord';
    id: any;
    name?: string | null;
    address?: string | null;
    zipCode?: string | null;
    city?: string | null;
    country?: string | null;
    email?: string | null;
    websiteUrl?: string | null;
    phoneNumber?: string | null;
  }>;
};

type ContactPageContentArea_PlugBlockRecord_Fragment = {
  __typename?: 'PlugBlockRecord';
  id: any;
  title?: string | null;
  description?: string | null;
  brands: Array<{
    __typename?: 'BrandPageRecord';
    id: any;
    brandName?: string | null;
    slug?: string | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      tags: Array<string>;
      title?: string | null;
      url: string;
      width?: any | null;
      height?: any | null;
      format: string;
      responsiveImage?: {
        __typename?: 'ResponsiveImage';
        aspectRatio: any;
        base64?: string | null;
        bgColor?: string | null;
        height: any;
        sizes: string;
        src: string;
        srcSet: string;
        webpSrcSet: string;
        width: any;
      } | null;
    } | null;
    imageLoad?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
  }>;
};

type ContactPageContentArea_SimpleTitleAndTextBlockRecord_Fragment = {
  __typename?: 'SimpleTitleAndTextBlockRecord';
  id: any;
  title?: string | null;
  topLabel?: string | null;
  description?: string | null;
};

type ContactPageContentArea_SliderBlockRecord_Fragment = {
  __typename?: 'SliderBlockRecord';
  title?: string | null;
  arrows?: any | null;
  slideAnimation?: any | null;
  delay?: any | null;
  dots?: any | null;
  heroes: Array<{
    __typename?: 'HeroBlockRecord';
    id: any;
    title?: string | null;
    description?: string | null;
    ctaText?: string | null;
    ctaUrl?: string | null;
    fullWidth?: any | null;
    boxColor?: { __typename?: 'ColorField'; hex: string } | null;
    textColor?: { __typename?: 'ColorField'; hex: string } | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
    imageOverlay?: {
      __typename?: 'OverlayRecord';
      id: any;
      opacity?: any | null;
      color?: { __typename?: 'ColorField'; hex: string } | null;
    } | null;
    ctaButtons: Array<{
      __typename?: 'CtaButtonRecord';
      id: any;
      text?: string | null;
      url?: string | null;
      variant?: string | null;
    }>;
    video?: {
      __typename?: 'FileField';
      blurUpThumb?: string | null;
      title?: string | null;
      alt?: string | null;
      video?: {
        __typename?: 'UploadVideoField';
        muxPlaybackId: string;
        width: any;
        height: any;
      } | null;
    } | null;
  }>;
};

type ContactPageContentArea_StatementBlockRecord_Fragment = {
  __typename?: 'StatementBlockRecord';
  id: any;
  text?: string | null;
  blackBackground?: any | null;
  header?: string | null;
  small?: any | null;
  linkText?: string | null;
  linkUrl?: string | null;
  imageMobile?: {
    __typename?: 'FileField';
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  imageTablet?: {
    __typename?: 'FileField';
    alt?: string | null;
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  imageDesktop?: {
    __typename?: 'FileField';
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  imageLoad?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
  imageOverlay?: {
    __typename?: 'OverlayRecord';
    id: any;
    opacity?: any | null;
    color?: { __typename?: 'ColorField'; hex: string } | null;
  } | null;
};

type ContactPageContentArea_SubheadingBlockRecord_Fragment = {
  __typename?: 'SubheadingBlockRecord';
  id: any;
  title?: string | null;
  text?: string | null;
  ctaButton?: {
    __typename?: 'CtaButtonRecord';
    id: any;
    text?: string | null;
    url?: string | null;
    variant?: string | null;
  } | null;
  backgroundColor?: { __typename?: 'ColorField'; hex: string } | null;
};

type ContactPageContentArea_SustainabilityReportsBlockRecord_Fragment = {
  __typename?: 'SustainabilityReportsBlockRecord';
  id: any;
  title?: string | null;
  reports: Array<{
    __typename?: 'FileField';
    alt?: string | null;
    filename: string;
    format: string;
    size: any;
    title?: string | null;
    url: string;
    uploadId: any;
  }>;
};

type ContactPageContentArea_TextBlockRecord_Fragment = {
  __typename?: 'TextBlockRecord';
  id: any;
  smallHeader?: any | null;
  header?: string | null;
  text?: string | null;
  introText?: string | null;
  ctaButtons: Array<{
    __typename?: 'CtaButtonRecord';
    id: any;
    text?: string | null;
    url?: string | null;
    variant?: string | null;
  }>;
};

type ContactPageContentArea_TwoColumnImageAndTextRecord_Fragment = {
  __typename?: 'TwoColumnImageAndTextRecord';
  id: any;
  text?: string | null;
  title?: string | null;
  reverse?: any | null;
  image?: {
    __typename?: 'FileField';
    alt?: string | null;
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  imageLoad?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
};

type ContactPageContentArea_TwoColumnTextIntroRecord_Fragment = {
  __typename?: 'TwoColumnTextIntroRecord';
  id: any;
  introText?: string | null;
  text?: string | null;
  header?: string | null;
};

type ContactPageContentArea_VideoRecord_Fragment = {
  __typename?: 'VideoRecord';
  id: any;
  autoplay?: any | null;
  video?: {
    __typename?: 'FileField';
    title?: string | null;
    video?: {
      __typename?: 'UploadVideoField';
      mp4Url?: string | null;
      streamingUrl: string;
      thumbnailUrl: string;
      mp4Low?: string | null;
    } | null;
  } | null;
  videoThumbnail?: {
    __typename?: 'FileField';
    alt?: string | null;
    tags: Array<string>;
    title?: string | null;
    url: string;
    width?: any | null;
    height?: any | null;
    format: string;
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  muxVideo?: {
    __typename?: 'FileField';
    blurUpThumb?: string | null;
    title?: string | null;
    alt?: string | null;
    video?: {
      __typename?: 'UploadVideoField';
      muxPlaybackId: string;
      width: any;
      height: any;
    } | null;
  } | null;
};

export type ContactPageContentAreaFragment =
  | ContactPageContentArea_ArticlesBlockRecord_Fragment
  | ContactPageContentArea_BrandsBlockRecord_Fragment
  | ContactPageContentArea_BulletListRecord_Fragment
  | ContactPageContentArea_DocumentLinkBlockRecord_Fragment
  | ContactPageContentArea_EmployeeRecord_Fragment
  | ContactPageContentArea_GridContainerBlockRecord_Fragment
  | ContactPageContentArea_HeroBlockRecord_Fragment
  | ContactPageContentArea_ImageRecord_Fragment
  | ContactPageContentArea_JobsListBlockRecord_Fragment
  | ContactPageContentArea_NewsAndReportsListBlockRecord_Fragment
  | ContactPageContentArea_NewsListBlockRecord_Fragment
  | ContactPageContentArea_OfficesBlockRecord_Fragment
  | ContactPageContentArea_PlugBlockRecord_Fragment
  | ContactPageContentArea_SimpleTitleAndTextBlockRecord_Fragment
  | ContactPageContentArea_SliderBlockRecord_Fragment
  | ContactPageContentArea_StatementBlockRecord_Fragment
  | ContactPageContentArea_SubheadingBlockRecord_Fragment
  | ContactPageContentArea_SustainabilityReportsBlockRecord_Fragment
  | ContactPageContentArea_TextBlockRecord_Fragment
  | ContactPageContentArea_TwoColumnImageAndTextRecord_Fragment
  | ContactPageContentArea_TwoColumnTextIntroRecord_Fragment
  | ContactPageContentArea_VideoRecord_Fragment;

export type ContactPageContentFragment = {
  __typename?: 'ContactPageRecord';
  id: any;
  pageLocales: Array<SiteLocale>;
  seo?: {
    __typename?: 'SeoField';
    description?: string | null;
    title?: string | null;
    image?: {
      __typename?: 'FileField';
      url: string;
      alt?: string | null;
      title?: string | null;
    } | null;
  } | null;
  contentArea: Array<
    | {
        __typename?: 'ArticlesBlockRecord';
        id: any;
        title?: string | null;
        isJobArticles?: any | null;
        ctaText?: string | null;
        ctaUrl?: string | null;
        jobPages: Array<{
          __typename?: 'JobOpportunitiesPageRecord';
          id: any;
          slug?: string | null;
          title?: string | null;
          publishDate?: any | null;
          category?: string | null;
          country?: string | null;
          department?: string | null;
        }>;
        newsPages: Array<{
          __typename?: 'NewsPageRecord';
          id: any;
          slug?: string | null;
          title?: string | null;
          publishDate?: any | null;
          category?: string | null;
          country?: string | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
        }>;
        reportPages: Array<{
          __typename?: 'ReportsListingRecord';
          id: any;
          slug?: string | null;
          title?: string | null;
          publishDate?: any | null;
          category?: string | null;
          country?: string | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
          pdf?: {
            __typename?: 'FileField';
            alt?: string | null;
            filename: string;
            format: string;
            size: any;
            title?: string | null;
            url: string;
            uploadId: any;
          } | null;
        }>;
      }
    | {
        __typename?: 'BrandsBlockRecord';
        id: any;
        title?: string | null;
        introText?: string | null;
        hideLabels?: any | null;
        brands: Array<{
          __typename?: 'BrandPageRecord';
          id: any;
          brandName?: string | null;
          slug?: string | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            tags: Array<string>;
            title?: string | null;
            url: string;
            width?: any | null;
            height?: any | null;
            format: string;
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageLoad?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
        }>;
      }
    | {
        __typename?: 'BulletListRecord';
        id: any;
        bullets?: string | null;
        numberedList?: any | null;
        title?: string | null;
      }
    | {
        __typename?: 'DocumentLinkBlockRecord';
        id: any;
        documents: Array<{
          __typename?: 'FileField';
          alt?: string | null;
          filename: string;
          format: string;
          size: any;
          title?: string | null;
          url: string;
          uploadId: any;
        }>;
      }
    | {
        __typename?: 'EmployeeRecord';
        id: any;
        name?: string | null;
        title?: string | null;
        introText?: string | null;
        description?: string | null;
        image?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
      }
    | {
        __typename?: 'GridContainerBlockRecord';
        id: any;
        fullwidth?: any | null;
        gap?: any | null;
        backgroundColor?: { __typename?: 'ColorField'; hex: string } | null;
        textColor?: { __typename?: 'ColorField'; hex: string } | null;
        content: Array<
          | {
              __typename?: 'GridFourcolBlockRecord';
              id: any;
              content: Array<
                | {
                    __typename?: 'ImageRecord';
                    id: any;
                    fullWidth?: any | null;
                    image?: {
                      __typename?: 'FileField';
                      alt?: string | null;
                      responsiveImage?: {
                        __typename?: 'ResponsiveImage';
                        aspectRatio: any;
                        base64?: string | null;
                        bgColor?: string | null;
                        height: any;
                        sizes: string;
                        src: string;
                        srcSet: string;
                        webpSrcSet: string;
                        width: any;
                      } | null;
                    } | null;
                    imageLoad?: {
                      __typename?: 'FileField';
                      alt?: string | null;
                      title?: string | null;
                      url: string;
                      blurUpThumb?: string | null;
                      focalPoint?: {
                        __typename?: 'focalPoint';
                        x: any;
                        y: any;
                      } | null;
                      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
                    } | null;
                  }
                | {
                    __typename?: 'MediaWithCaptionRecord';
                    id: any;
                    centerText?: any | null;
                    textOnImage?: any | null;
                    media?: {
                      __typename?: 'ImageRecord';
                      id: any;
                      fullWidth?: any | null;
                      image?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        responsiveImage?: {
                          __typename?: 'ResponsiveImage';
                          aspectRatio: any;
                          base64?: string | null;
                          bgColor?: string | null;
                          height: any;
                          sizes: string;
                          src: string;
                          srcSet: string;
                          webpSrcSet: string;
                          width: any;
                        } | null;
                      } | null;
                      imageLoad?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        title?: string | null;
                        url: string;
                        blurUpThumb?: string | null;
                        focalPoint?: {
                          __typename?: 'focalPoint';
                          x: any;
                          y: any;
                        } | null;
                        colors: Array<{
                          __typename?: 'ColorField';
                          hex: string;
                        }>;
                      } | null;
                    } | null;
                    caption?: {
                      __typename?: 'TextBlockRecord';
                      id: any;
                      smallHeader?: any | null;
                      header?: string | null;
                      text?: string | null;
                      introText?: string | null;
                      ctaButtons: Array<{
                        __typename?: 'CtaButtonRecord';
                        id: any;
                        text?: string | null;
                        url?: string | null;
                        variant?: string | null;
                      }>;
                    } | null;
                  }
                | {
                    __typename?: 'TextBlockRecord';
                    id: any;
                    smallHeader?: any | null;
                    header?: string | null;
                    text?: string | null;
                    introText?: string | null;
                    ctaButtons: Array<{
                      __typename?: 'CtaButtonRecord';
                      id: any;
                      text?: string | null;
                      url?: string | null;
                      variant?: string | null;
                    }>;
                  }
              >;
            }
          | {
              __typename?: 'GridThreecolBlockRecord';
              id: any;
              content: Array<
                | {
                    __typename?: 'GridTwocolBlockRecord';
                    id: any;
                    content: Array<
                      | {
                          __typename?: 'ImageRecord';
                          id: any;
                          fullWidth?: any | null;
                          image?: {
                            __typename?: 'FileField';
                            alt?: string | null;
                            responsiveImage?: {
                              __typename?: 'ResponsiveImage';
                              aspectRatio: any;
                              base64?: string | null;
                              bgColor?: string | null;
                              height: any;
                              sizes: string;
                              src: string;
                              srcSet: string;
                              webpSrcSet: string;
                              width: any;
                            } | null;
                          } | null;
                          imageLoad?: {
                            __typename?: 'FileField';
                            alt?: string | null;
                            title?: string | null;
                            url: string;
                            blurUpThumb?: string | null;
                            focalPoint?: {
                              __typename?: 'focalPoint';
                              x: any;
                              y: any;
                            } | null;
                            colors: Array<{
                              __typename?: 'ColorField';
                              hex: string;
                            }>;
                          } | null;
                        }
                      | {
                          __typename?: 'MediaWithCaptionRecord';
                          id: any;
                          centerText?: any | null;
                          textOnImage?: any | null;
                          media?: {
                            __typename?: 'ImageRecord';
                            id: any;
                            fullWidth?: any | null;
                            image?: {
                              __typename?: 'FileField';
                              alt?: string | null;
                              responsiveImage?: {
                                __typename?: 'ResponsiveImage';
                                aspectRatio: any;
                                base64?: string | null;
                                bgColor?: string | null;
                                height: any;
                                sizes: string;
                                src: string;
                                srcSet: string;
                                webpSrcSet: string;
                                width: any;
                              } | null;
                            } | null;
                            imageLoad?: {
                              __typename?: 'FileField';
                              alt?: string | null;
                              title?: string | null;
                              url: string;
                              blurUpThumb?: string | null;
                              focalPoint?: {
                                __typename?: 'focalPoint';
                                x: any;
                                y: any;
                              } | null;
                              colors: Array<{
                                __typename?: 'ColorField';
                                hex: string;
                              }>;
                            } | null;
                          } | null;
                          caption?: {
                            __typename?: 'TextBlockRecord';
                            id: any;
                            smallHeader?: any | null;
                            header?: string | null;
                            text?: string | null;
                            introText?: string | null;
                            ctaButtons: Array<{
                              __typename?: 'CtaButtonRecord';
                              id: any;
                              text?: string | null;
                              url?: string | null;
                              variant?: string | null;
                            }>;
                          } | null;
                        }
                      | {
                          __typename?: 'NewsListBlockRecord';
                          id: any;
                          title?: string | null;
                          standalone?: any | null;
                          largeTitle?: any | null;
                          itemsToShow?: any | null;
                        }
                      | {
                          __typename?: 'ReportsListBlockRecord';
                          id: any;
                          title?: string | null;
                          standalone?: any | null;
                          largeTitle?: any | null;
                        }
                      | {
                          __typename?: 'TextBlockRecord';
                          id: any;
                          smallHeader?: any | null;
                          header?: string | null;
                          text?: string | null;
                          introText?: string | null;
                          ctaButtons: Array<{
                            __typename?: 'CtaButtonRecord';
                            id: any;
                            text?: string | null;
                            url?: string | null;
                            variant?: string | null;
                          }>;
                        }
                    >;
                  }
                | {
                    __typename?: 'ImageRecord';
                    id: any;
                    fullWidth?: any | null;
                    image?: {
                      __typename?: 'FileField';
                      alt?: string | null;
                      responsiveImage?: {
                        __typename?: 'ResponsiveImage';
                        aspectRatio: any;
                        base64?: string | null;
                        bgColor?: string | null;
                        height: any;
                        sizes: string;
                        src: string;
                        srcSet: string;
                        webpSrcSet: string;
                        width: any;
                      } | null;
                    } | null;
                    imageLoad?: {
                      __typename?: 'FileField';
                      alt?: string | null;
                      title?: string | null;
                      url: string;
                      blurUpThumb?: string | null;
                      focalPoint?: {
                        __typename?: 'focalPoint';
                        x: any;
                        y: any;
                      } | null;
                      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
                    } | null;
                  }
                | {
                    __typename?: 'MediaWithCaptionRecord';
                    id: any;
                    centerText?: any | null;
                    textOnImage?: any | null;
                    media?: {
                      __typename?: 'ImageRecord';
                      id: any;
                      fullWidth?: any | null;
                      image?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        responsiveImage?: {
                          __typename?: 'ResponsiveImage';
                          aspectRatio: any;
                          base64?: string | null;
                          bgColor?: string | null;
                          height: any;
                          sizes: string;
                          src: string;
                          srcSet: string;
                          webpSrcSet: string;
                          width: any;
                        } | null;
                      } | null;
                      imageLoad?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        title?: string | null;
                        url: string;
                        blurUpThumb?: string | null;
                        focalPoint?: {
                          __typename?: 'focalPoint';
                          x: any;
                          y: any;
                        } | null;
                        colors: Array<{
                          __typename?: 'ColorField';
                          hex: string;
                        }>;
                      } | null;
                    } | null;
                    caption?: {
                      __typename?: 'TextBlockRecord';
                      id: any;
                      smallHeader?: any | null;
                      header?: string | null;
                      text?: string | null;
                      introText?: string | null;
                      ctaButtons: Array<{
                        __typename?: 'CtaButtonRecord';
                        id: any;
                        text?: string | null;
                        url?: string | null;
                        variant?: string | null;
                      }>;
                    } | null;
                  }
                | {
                    __typename?: 'TextBlockRecord';
                    id: any;
                    smallHeader?: any | null;
                    header?: string | null;
                    text?: string | null;
                    introText?: string | null;
                    ctaButtons: Array<{
                      __typename?: 'CtaButtonRecord';
                      id: any;
                      text?: string | null;
                      url?: string | null;
                      variant?: string | null;
                    }>;
                  }
              >;
            }
          | {
              __typename?: 'GridTwocolBlockRecord';
              id: any;
              content: Array<
                | {
                    __typename?: 'ImageRecord';
                    id: any;
                    fullWidth?: any | null;
                    image?: {
                      __typename?: 'FileField';
                      alt?: string | null;
                      responsiveImage?: {
                        __typename?: 'ResponsiveImage';
                        aspectRatio: any;
                        base64?: string | null;
                        bgColor?: string | null;
                        height: any;
                        sizes: string;
                        src: string;
                        srcSet: string;
                        webpSrcSet: string;
                        width: any;
                      } | null;
                    } | null;
                    imageLoad?: {
                      __typename?: 'FileField';
                      alt?: string | null;
                      title?: string | null;
                      url: string;
                      blurUpThumb?: string | null;
                      focalPoint?: {
                        __typename?: 'focalPoint';
                        x: any;
                        y: any;
                      } | null;
                      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
                    } | null;
                  }
                | {
                    __typename?: 'MediaWithCaptionRecord';
                    id: any;
                    centerText?: any | null;
                    textOnImage?: any | null;
                    media?: {
                      __typename?: 'ImageRecord';
                      id: any;
                      fullWidth?: any | null;
                      image?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        responsiveImage?: {
                          __typename?: 'ResponsiveImage';
                          aspectRatio: any;
                          base64?: string | null;
                          bgColor?: string | null;
                          height: any;
                          sizes: string;
                          src: string;
                          srcSet: string;
                          webpSrcSet: string;
                          width: any;
                        } | null;
                      } | null;
                      imageLoad?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        title?: string | null;
                        url: string;
                        blurUpThumb?: string | null;
                        focalPoint?: {
                          __typename?: 'focalPoint';
                          x: any;
                          y: any;
                        } | null;
                        colors: Array<{
                          __typename?: 'ColorField';
                          hex: string;
                        }>;
                      } | null;
                    } | null;
                    caption?: {
                      __typename?: 'TextBlockRecord';
                      id: any;
                      smallHeader?: any | null;
                      header?: string | null;
                      text?: string | null;
                      introText?: string | null;
                      ctaButtons: Array<{
                        __typename?: 'CtaButtonRecord';
                        id: any;
                        text?: string | null;
                        url?: string | null;
                        variant?: string | null;
                      }>;
                    } | null;
                  }
                | {
                    __typename?: 'NewsListBlockRecord';
                    id: any;
                    title?: string | null;
                    standalone?: any | null;
                    largeTitle?: any | null;
                    itemsToShow?: any | null;
                  }
                | {
                    __typename?: 'ReportsListBlockRecord';
                    id: any;
                    title?: string | null;
                    standalone?: any | null;
                    largeTitle?: any | null;
                  }
                | {
                    __typename?: 'TextBlockRecord';
                    id: any;
                    smallHeader?: any | null;
                    header?: string | null;
                    text?: string | null;
                    introText?: string | null;
                    ctaButtons: Array<{
                      __typename?: 'CtaButtonRecord';
                      id: any;
                      text?: string | null;
                      url?: string | null;
                      variant?: string | null;
                    }>;
                  }
              >;
            }
        >;
      }
    | {
        __typename?: 'HeroBlockRecord';
        id: any;
        title?: string | null;
        description?: string | null;
        ctaText?: string | null;
        ctaUrl?: string | null;
        fullWidth?: any | null;
        boxColor?: { __typename?: 'ColorField'; hex: string } | null;
        textColor?: { __typename?: 'ColorField'; hex: string } | null;
        image?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
        imageOverlay?: {
          __typename?: 'OverlayRecord';
          id: any;
          opacity?: any | null;
          color?: { __typename?: 'ColorField'; hex: string } | null;
        } | null;
        ctaButtons: Array<{
          __typename?: 'CtaButtonRecord';
          id: any;
          text?: string | null;
          url?: string | null;
          variant?: string | null;
        }>;
        video?: {
          __typename?: 'FileField';
          blurUpThumb?: string | null;
          title?: string | null;
          alt?: string | null;
          video?: {
            __typename?: 'UploadVideoField';
            muxPlaybackId: string;
            width: any;
            height: any;
          } | null;
        } | null;
      }
    | {
        __typename?: 'ImageRecord';
        id: any;
        fullWidth?: any | null;
        image?: {
          __typename?: 'FileField';
          alt?: string | null;
          responsiveImage?: {
            __typename?: 'ResponsiveImage';
            aspectRatio: any;
            base64?: string | null;
            bgColor?: string | null;
            height: any;
            sizes: string;
            src: string;
            srcSet: string;
            webpSrcSet: string;
            width: any;
          } | null;
        } | null;
        imageLoad?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
      }
    | { __typename?: 'JobsListBlockRecord'; id: any; title?: string | null }
    | { __typename?: 'NewsAndReportsListBlockRecord' }
    | {
        __typename?: 'NewsListBlockRecord';
        id: any;
        title?: string | null;
        standalone?: any | null;
        largeTitle?: any | null;
        itemsToShow?: any | null;
      }
    | {
        __typename?: 'OfficesBlockRecord';
        id: any;
        offices: Array<{
          __typename?: 'OfficeRecord';
          id: any;
          name?: string | null;
          address?: string | null;
          zipCode?: string | null;
          city?: string | null;
          country?: string | null;
          email?: string | null;
          websiteUrl?: string | null;
          phoneNumber?: string | null;
        }>;
      }
    | {
        __typename?: 'PlugBlockRecord';
        id: any;
        title?: string | null;
        description?: string | null;
        brands: Array<{
          __typename?: 'BrandPageRecord';
          id: any;
          brandName?: string | null;
          slug?: string | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            tags: Array<string>;
            title?: string | null;
            url: string;
            width?: any | null;
            height?: any | null;
            format: string;
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageLoad?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
        }>;
      }
    | {
        __typename?: 'SimpleTitleAndTextBlockRecord';
        id: any;
        title?: string | null;
        topLabel?: string | null;
        description?: string | null;
      }
    | {
        __typename?: 'SliderBlockRecord';
        title?: string | null;
        arrows?: any | null;
        slideAnimation?: any | null;
        delay?: any | null;
        dots?: any | null;
        heroes: Array<{
          __typename?: 'HeroBlockRecord';
          id: any;
          title?: string | null;
          description?: string | null;
          ctaText?: string | null;
          ctaUrl?: string | null;
          fullWidth?: any | null;
          boxColor?: { __typename?: 'ColorField'; hex: string } | null;
          textColor?: { __typename?: 'ColorField'; hex: string } | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
          imageOverlay?: {
            __typename?: 'OverlayRecord';
            id: any;
            opacity?: any | null;
            color?: { __typename?: 'ColorField'; hex: string } | null;
          } | null;
          ctaButtons: Array<{
            __typename?: 'CtaButtonRecord';
            id: any;
            text?: string | null;
            url?: string | null;
            variant?: string | null;
          }>;
          video?: {
            __typename?: 'FileField';
            blurUpThumb?: string | null;
            title?: string | null;
            alt?: string | null;
            video?: {
              __typename?: 'UploadVideoField';
              muxPlaybackId: string;
              width: any;
              height: any;
            } | null;
          } | null;
        }>;
      }
    | {
        __typename?: 'StatementBlockRecord';
        id: any;
        text?: string | null;
        blackBackground?: any | null;
        header?: string | null;
        small?: any | null;
        linkText?: string | null;
        linkUrl?: string | null;
        imageMobile?: {
          __typename?: 'FileField';
          responsiveImage?: {
            __typename?: 'ResponsiveImage';
            aspectRatio: any;
            base64?: string | null;
            bgColor?: string | null;
            height: any;
            sizes: string;
            src: string;
            srcSet: string;
            webpSrcSet: string;
            width: any;
          } | null;
        } | null;
        imageTablet?: {
          __typename?: 'FileField';
          alt?: string | null;
          responsiveImage?: {
            __typename?: 'ResponsiveImage';
            aspectRatio: any;
            base64?: string | null;
            bgColor?: string | null;
            height: any;
            sizes: string;
            src: string;
            srcSet: string;
            webpSrcSet: string;
            width: any;
          } | null;
        } | null;
        imageDesktop?: {
          __typename?: 'FileField';
          responsiveImage?: {
            __typename?: 'ResponsiveImage';
            aspectRatio: any;
            base64?: string | null;
            bgColor?: string | null;
            height: any;
            sizes: string;
            src: string;
            srcSet: string;
            webpSrcSet: string;
            width: any;
          } | null;
        } | null;
        imageLoad?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
        imageOverlay?: {
          __typename?: 'OverlayRecord';
          id: any;
          opacity?: any | null;
          color?: { __typename?: 'ColorField'; hex: string } | null;
        } | null;
      }
    | {
        __typename?: 'SubheadingBlockRecord';
        id: any;
        title?: string | null;
        text?: string | null;
        ctaButton?: {
          __typename?: 'CtaButtonRecord';
          id: any;
          text?: string | null;
          url?: string | null;
          variant?: string | null;
        } | null;
        backgroundColor?: { __typename?: 'ColorField'; hex: string } | null;
      }
    | {
        __typename?: 'SustainabilityReportsBlockRecord';
        id: any;
        title?: string | null;
        reports: Array<{
          __typename?: 'FileField';
          alt?: string | null;
          filename: string;
          format: string;
          size: any;
          title?: string | null;
          url: string;
          uploadId: any;
        }>;
      }
    | {
        __typename?: 'TextBlockRecord';
        id: any;
        smallHeader?: any | null;
        header?: string | null;
        text?: string | null;
        introText?: string | null;
        ctaButtons: Array<{
          __typename?: 'CtaButtonRecord';
          id: any;
          text?: string | null;
          url?: string | null;
          variant?: string | null;
        }>;
      }
    | {
        __typename?: 'TwoColumnImageAndTextRecord';
        id: any;
        text?: string | null;
        title?: string | null;
        reverse?: any | null;
        image?: {
          __typename?: 'FileField';
          alt?: string | null;
          responsiveImage?: {
            __typename?: 'ResponsiveImage';
            aspectRatio: any;
            base64?: string | null;
            bgColor?: string | null;
            height: any;
            sizes: string;
            src: string;
            srcSet: string;
            webpSrcSet: string;
            width: any;
          } | null;
        } | null;
        imageLoad?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
      }
    | {
        __typename?: 'TwoColumnTextIntroRecord';
        id: any;
        introText?: string | null;
        text?: string | null;
        header?: string | null;
      }
    | {
        __typename?: 'VideoRecord';
        id: any;
        autoplay?: any | null;
        video?: {
          __typename?: 'FileField';
          title?: string | null;
          video?: {
            __typename?: 'UploadVideoField';
            mp4Url?: string | null;
            streamingUrl: string;
            thumbnailUrl: string;
            mp4Low?: string | null;
          } | null;
        } | null;
        videoThumbnail?: {
          __typename?: 'FileField';
          alt?: string | null;
          tags: Array<string>;
          title?: string | null;
          url: string;
          width?: any | null;
          height?: any | null;
          format: string;
          responsiveImage?: {
            __typename?: 'ResponsiveImage';
            aspectRatio: any;
            base64?: string | null;
            bgColor?: string | null;
            height: any;
            sizes: string;
            src: string;
            srcSet: string;
            webpSrcSet: string;
            width: any;
          } | null;
        } | null;
        muxVideo?: {
          __typename?: 'FileField';
          blurUpThumb?: string | null;
          title?: string | null;
          alt?: string | null;
          video?: {
            __typename?: 'UploadVideoField';
            muxPlaybackId: string;
            width: any;
            height: any;
          } | null;
        } | null;
      }
  >;
};

type JobOpportunitiesListPageContentArea_ArticlesBlockRecord_Fragment = {
  __typename?: 'ArticlesBlockRecord';
  id: any;
  title?: string | null;
  isJobArticles?: any | null;
  ctaText?: string | null;
  ctaUrl?: string | null;
  jobPages: Array<{
    __typename?: 'JobOpportunitiesPageRecord';
    id: any;
    slug?: string | null;
    title?: string | null;
    publishDate?: any | null;
    category?: string | null;
    country?: string | null;
    department?: string | null;
  }>;
  newsPages: Array<{
    __typename?: 'NewsPageRecord';
    id: any;
    slug?: string | null;
    title?: string | null;
    publishDate?: any | null;
    category?: string | null;
    country?: string | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
  }>;
  reportPages: Array<{
    __typename?: 'ReportsListingRecord';
    id: any;
    slug?: string | null;
    title?: string | null;
    publishDate?: any | null;
    category?: string | null;
    country?: string | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
    pdf?: {
      __typename?: 'FileField';
      alt?: string | null;
      filename: string;
      format: string;
      size: any;
      title?: string | null;
      url: string;
      uploadId: any;
    } | null;
  }>;
};

type JobOpportunitiesListPageContentArea_BrandsBlockRecord_Fragment = {
  __typename?: 'BrandsBlockRecord';
  id: any;
  title?: string | null;
  introText?: string | null;
  hideLabels?: any | null;
  brands: Array<{
    __typename?: 'BrandPageRecord';
    id: any;
    brandName?: string | null;
    slug?: string | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      tags: Array<string>;
      title?: string | null;
      url: string;
      width?: any | null;
      height?: any | null;
      format: string;
      responsiveImage?: {
        __typename?: 'ResponsiveImage';
        aspectRatio: any;
        base64?: string | null;
        bgColor?: string | null;
        height: any;
        sizes: string;
        src: string;
        srcSet: string;
        webpSrcSet: string;
        width: any;
      } | null;
    } | null;
    imageLoad?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
  }>;
};

type JobOpportunitiesListPageContentArea_BulletListRecord_Fragment = {
  __typename?: 'BulletListRecord';
  id: any;
  bullets?: string | null;
  numberedList?: any | null;
  title?: string | null;
};

type JobOpportunitiesListPageContentArea_DocumentLinkBlockRecord_Fragment = {
  __typename?: 'DocumentLinkBlockRecord';
  id: any;
  documents: Array<{
    __typename?: 'FileField';
    alt?: string | null;
    filename: string;
    format: string;
    size: any;
    title?: string | null;
    url: string;
    uploadId: any;
  }>;
};

type JobOpportunitiesListPageContentArea_EmployeeRecord_Fragment = {
  __typename?: 'EmployeeRecord';
  id: any;
  name?: string | null;
  title?: string | null;
  introText?: string | null;
  description?: string | null;
  image?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
};

type JobOpportunitiesListPageContentArea_HeroBlockRecord_Fragment = {
  __typename?: 'HeroBlockRecord';
  id: any;
  title?: string | null;
  description?: string | null;
  ctaText?: string | null;
  ctaUrl?: string | null;
  fullWidth?: any | null;
  boxColor?: { __typename?: 'ColorField'; hex: string } | null;
  textColor?: { __typename?: 'ColorField'; hex: string } | null;
  image?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
  imageOverlay?: {
    __typename?: 'OverlayRecord';
    id: any;
    opacity?: any | null;
    color?: { __typename?: 'ColorField'; hex: string } | null;
  } | null;
  ctaButtons: Array<{
    __typename?: 'CtaButtonRecord';
    id: any;
    text?: string | null;
    url?: string | null;
    variant?: string | null;
  }>;
  video?: {
    __typename?: 'FileField';
    blurUpThumb?: string | null;
    title?: string | null;
    alt?: string | null;
    video?: {
      __typename?: 'UploadVideoField';
      muxPlaybackId: string;
      width: any;
      height: any;
    } | null;
  } | null;
};

type JobOpportunitiesListPageContentArea_ImageRecord_Fragment = {
  __typename?: 'ImageRecord';
  id: any;
  fullWidth?: any | null;
  image?: {
    __typename?: 'FileField';
    alt?: string | null;
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  imageLoad?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
};

type JobOpportunitiesListPageContentArea_JobsListBlockRecord_Fragment = {
  __typename?: 'JobsListBlockRecord';
  id: any;
  title?: string | null;
};

type JobOpportunitiesListPageContentArea_NewsListBlockRecord_Fragment = {
  __typename?: 'NewsListBlockRecord';
  id: any;
  title?: string | null;
  standalone?: any | null;
  largeTitle?: any | null;
  itemsToShow?: any | null;
};

type JobOpportunitiesListPageContentArea_OfficesBlockRecord_Fragment = {
  __typename?: 'OfficesBlockRecord';
  id: any;
  offices: Array<{
    __typename?: 'OfficeRecord';
    id: any;
    name?: string | null;
    address?: string | null;
    zipCode?: string | null;
    city?: string | null;
    country?: string | null;
    email?: string | null;
    websiteUrl?: string | null;
    phoneNumber?: string | null;
  }>;
};

type JobOpportunitiesListPageContentArea_PlugBlockRecord_Fragment = {
  __typename?: 'PlugBlockRecord';
  id: any;
  title?: string | null;
  description?: string | null;
  brands: Array<{
    __typename?: 'BrandPageRecord';
    id: any;
    brandName?: string | null;
    slug?: string | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      tags: Array<string>;
      title?: string | null;
      url: string;
      width?: any | null;
      height?: any | null;
      format: string;
      responsiveImage?: {
        __typename?: 'ResponsiveImage';
        aspectRatio: any;
        base64?: string | null;
        bgColor?: string | null;
        height: any;
        sizes: string;
        src: string;
        srcSet: string;
        webpSrcSet: string;
        width: any;
      } | null;
    } | null;
    imageLoad?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
  }>;
};

type JobOpportunitiesListPageContentArea_SimpleTitleAndTextBlockRecord_Fragment =
  {
    __typename?: 'SimpleTitleAndTextBlockRecord';
    id: any;
    title?: string | null;
    topLabel?: string | null;
    description?: string | null;
  };

type JobOpportunitiesListPageContentArea_SliderBlockRecord_Fragment = {
  __typename?: 'SliderBlockRecord';
  title?: string | null;
  arrows?: any | null;
  slideAnimation?: any | null;
  delay?: any | null;
  dots?: any | null;
  heroes: Array<{
    __typename?: 'HeroBlockRecord';
    id: any;
    title?: string | null;
    description?: string | null;
    ctaText?: string | null;
    ctaUrl?: string | null;
    fullWidth?: any | null;
    boxColor?: { __typename?: 'ColorField'; hex: string } | null;
    textColor?: { __typename?: 'ColorField'; hex: string } | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
    imageOverlay?: {
      __typename?: 'OverlayRecord';
      id: any;
      opacity?: any | null;
      color?: { __typename?: 'ColorField'; hex: string } | null;
    } | null;
    ctaButtons: Array<{
      __typename?: 'CtaButtonRecord';
      id: any;
      text?: string | null;
      url?: string | null;
      variant?: string | null;
    }>;
    video?: {
      __typename?: 'FileField';
      blurUpThumb?: string | null;
      title?: string | null;
      alt?: string | null;
      video?: {
        __typename?: 'UploadVideoField';
        muxPlaybackId: string;
        width: any;
        height: any;
      } | null;
    } | null;
  }>;
};

type JobOpportunitiesListPageContentArea_StatementBlockRecord_Fragment = {
  __typename?: 'StatementBlockRecord';
  id: any;
  text?: string | null;
  blackBackground?: any | null;
  header?: string | null;
  small?: any | null;
  linkText?: string | null;
  linkUrl?: string | null;
  imageMobile?: {
    __typename?: 'FileField';
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  imageTablet?: {
    __typename?: 'FileField';
    alt?: string | null;
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  imageDesktop?: {
    __typename?: 'FileField';
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  imageLoad?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
  imageOverlay?: {
    __typename?: 'OverlayRecord';
    id: any;
    opacity?: any | null;
    color?: { __typename?: 'ColorField'; hex: string } | null;
  } | null;
};

type JobOpportunitiesListPageContentArea_TextBlockRecord_Fragment = {
  __typename?: 'TextBlockRecord';
  id: any;
  smallHeader?: any | null;
  header?: string | null;
  text?: string | null;
  introText?: string | null;
  ctaButtons: Array<{
    __typename?: 'CtaButtonRecord';
    id: any;
    text?: string | null;
    url?: string | null;
    variant?: string | null;
  }>;
};

type JobOpportunitiesListPageContentArea_TwoColumnImageAndTextRecord_Fragment =
  {
    __typename?: 'TwoColumnImageAndTextRecord';
    id: any;
    text?: string | null;
    title?: string | null;
    reverse?: any | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      responsiveImage?: {
        __typename?: 'ResponsiveImage';
        aspectRatio: any;
        base64?: string | null;
        bgColor?: string | null;
        height: any;
        sizes: string;
        src: string;
        srcSet: string;
        webpSrcSet: string;
        width: any;
      } | null;
    } | null;
    imageLoad?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
  };

type JobOpportunitiesListPageContentArea_TwoColumnTextIntroRecord_Fragment = {
  __typename?: 'TwoColumnTextIntroRecord';
  id: any;
  introText?: string | null;
  text?: string | null;
  header?: string | null;
};

type JobOpportunitiesListPageContentArea_VideoRecord_Fragment = {
  __typename?: 'VideoRecord';
  id: any;
  autoplay?: any | null;
  video?: {
    __typename?: 'FileField';
    title?: string | null;
    video?: {
      __typename?: 'UploadVideoField';
      mp4Url?: string | null;
      streamingUrl: string;
      thumbnailUrl: string;
      mp4Low?: string | null;
    } | null;
  } | null;
  videoThumbnail?: {
    __typename?: 'FileField';
    alt?: string | null;
    tags: Array<string>;
    title?: string | null;
    url: string;
    width?: any | null;
    height?: any | null;
    format: string;
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  muxVideo?: {
    __typename?: 'FileField';
    blurUpThumb?: string | null;
    title?: string | null;
    alt?: string | null;
    video?: {
      __typename?: 'UploadVideoField';
      muxPlaybackId: string;
      width: any;
      height: any;
    } | null;
  } | null;
};

export type JobOpportunitiesListPageContentAreaFragment =
  | JobOpportunitiesListPageContentArea_ArticlesBlockRecord_Fragment
  | JobOpportunitiesListPageContentArea_BrandsBlockRecord_Fragment
  | JobOpportunitiesListPageContentArea_BulletListRecord_Fragment
  | JobOpportunitiesListPageContentArea_DocumentLinkBlockRecord_Fragment
  | JobOpportunitiesListPageContentArea_EmployeeRecord_Fragment
  | JobOpportunitiesListPageContentArea_HeroBlockRecord_Fragment
  | JobOpportunitiesListPageContentArea_ImageRecord_Fragment
  | JobOpportunitiesListPageContentArea_JobsListBlockRecord_Fragment
  | JobOpportunitiesListPageContentArea_NewsListBlockRecord_Fragment
  | JobOpportunitiesListPageContentArea_OfficesBlockRecord_Fragment
  | JobOpportunitiesListPageContentArea_PlugBlockRecord_Fragment
  | JobOpportunitiesListPageContentArea_SimpleTitleAndTextBlockRecord_Fragment
  | JobOpportunitiesListPageContentArea_SliderBlockRecord_Fragment
  | JobOpportunitiesListPageContentArea_StatementBlockRecord_Fragment
  | JobOpportunitiesListPageContentArea_TextBlockRecord_Fragment
  | JobOpportunitiesListPageContentArea_TwoColumnImageAndTextRecord_Fragment
  | JobOpportunitiesListPageContentArea_TwoColumnTextIntroRecord_Fragment
  | JobOpportunitiesListPageContentArea_VideoRecord_Fragment;

export type JobOpportunitiesListPageContentFragment = {
  __typename?: 'JobOpportunitiesListPageRecord';
  id: any;
  pageLocales: Array<SiteLocale>;
  seo?: {
    __typename?: 'SeoField';
    description?: string | null;
    title?: string | null;
    image?: {
      __typename?: 'FileField';
      url: string;
      alt?: string | null;
      title?: string | null;
    } | null;
  } | null;
  contentArea: Array<
    | {
        __typename?: 'ArticlesBlockRecord';
        id: any;
        title?: string | null;
        isJobArticles?: any | null;
        ctaText?: string | null;
        ctaUrl?: string | null;
        jobPages: Array<{
          __typename?: 'JobOpportunitiesPageRecord';
          id: any;
          slug?: string | null;
          title?: string | null;
          publishDate?: any | null;
          category?: string | null;
          country?: string | null;
          department?: string | null;
        }>;
        newsPages: Array<{
          __typename?: 'NewsPageRecord';
          id: any;
          slug?: string | null;
          title?: string | null;
          publishDate?: any | null;
          category?: string | null;
          country?: string | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
        }>;
        reportPages: Array<{
          __typename?: 'ReportsListingRecord';
          id: any;
          slug?: string | null;
          title?: string | null;
          publishDate?: any | null;
          category?: string | null;
          country?: string | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
          pdf?: {
            __typename?: 'FileField';
            alt?: string | null;
            filename: string;
            format: string;
            size: any;
            title?: string | null;
            url: string;
            uploadId: any;
          } | null;
        }>;
      }
    | {
        __typename?: 'BrandsBlockRecord';
        id: any;
        title?: string | null;
        introText?: string | null;
        hideLabels?: any | null;
        brands: Array<{
          __typename?: 'BrandPageRecord';
          id: any;
          brandName?: string | null;
          slug?: string | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            tags: Array<string>;
            title?: string | null;
            url: string;
            width?: any | null;
            height?: any | null;
            format: string;
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageLoad?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
        }>;
      }
    | {
        __typename?: 'BulletListRecord';
        id: any;
        bullets?: string | null;
        numberedList?: any | null;
        title?: string | null;
      }
    | {
        __typename?: 'DocumentLinkBlockRecord';
        id: any;
        documents: Array<{
          __typename?: 'FileField';
          alt?: string | null;
          filename: string;
          format: string;
          size: any;
          title?: string | null;
          url: string;
          uploadId: any;
        }>;
      }
    | {
        __typename?: 'EmployeeRecord';
        id: any;
        name?: string | null;
        title?: string | null;
        introText?: string | null;
        description?: string | null;
        image?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
      }
    | {
        __typename?: 'HeroBlockRecord';
        id: any;
        title?: string | null;
        description?: string | null;
        ctaText?: string | null;
        ctaUrl?: string | null;
        fullWidth?: any | null;
        boxColor?: { __typename?: 'ColorField'; hex: string } | null;
        textColor?: { __typename?: 'ColorField'; hex: string } | null;
        image?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
        imageOverlay?: {
          __typename?: 'OverlayRecord';
          id: any;
          opacity?: any | null;
          color?: { __typename?: 'ColorField'; hex: string } | null;
        } | null;
        ctaButtons: Array<{
          __typename?: 'CtaButtonRecord';
          id: any;
          text?: string | null;
          url?: string | null;
          variant?: string | null;
        }>;
        video?: {
          __typename?: 'FileField';
          blurUpThumb?: string | null;
          title?: string | null;
          alt?: string | null;
          video?: {
            __typename?: 'UploadVideoField';
            muxPlaybackId: string;
            width: any;
            height: any;
          } | null;
        } | null;
      }
    | {
        __typename?: 'ImageRecord';
        id: any;
        fullWidth?: any | null;
        image?: {
          __typename?: 'FileField';
          alt?: string | null;
          responsiveImage?: {
            __typename?: 'ResponsiveImage';
            aspectRatio: any;
            base64?: string | null;
            bgColor?: string | null;
            height: any;
            sizes: string;
            src: string;
            srcSet: string;
            webpSrcSet: string;
            width: any;
          } | null;
        } | null;
        imageLoad?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
      }
    | { __typename?: 'JobsListBlockRecord'; id: any; title?: string | null }
    | {
        __typename?: 'NewsListBlockRecord';
        id: any;
        title?: string | null;
        standalone?: any | null;
        largeTitle?: any | null;
        itemsToShow?: any | null;
      }
    | {
        __typename?: 'OfficesBlockRecord';
        id: any;
        offices: Array<{
          __typename?: 'OfficeRecord';
          id: any;
          name?: string | null;
          address?: string | null;
          zipCode?: string | null;
          city?: string | null;
          country?: string | null;
          email?: string | null;
          websiteUrl?: string | null;
          phoneNumber?: string | null;
        }>;
      }
    | {
        __typename?: 'PlugBlockRecord';
        id: any;
        title?: string | null;
        description?: string | null;
        brands: Array<{
          __typename?: 'BrandPageRecord';
          id: any;
          brandName?: string | null;
          slug?: string | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            tags: Array<string>;
            title?: string | null;
            url: string;
            width?: any | null;
            height?: any | null;
            format: string;
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageLoad?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
        }>;
      }
    | {
        __typename?: 'SimpleTitleAndTextBlockRecord';
        id: any;
        title?: string | null;
        topLabel?: string | null;
        description?: string | null;
      }
    | {
        __typename?: 'SliderBlockRecord';
        title?: string | null;
        arrows?: any | null;
        slideAnimation?: any | null;
        delay?: any | null;
        dots?: any | null;
        heroes: Array<{
          __typename?: 'HeroBlockRecord';
          id: any;
          title?: string | null;
          description?: string | null;
          ctaText?: string | null;
          ctaUrl?: string | null;
          fullWidth?: any | null;
          boxColor?: { __typename?: 'ColorField'; hex: string } | null;
          textColor?: { __typename?: 'ColorField'; hex: string } | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
          imageOverlay?: {
            __typename?: 'OverlayRecord';
            id: any;
            opacity?: any | null;
            color?: { __typename?: 'ColorField'; hex: string } | null;
          } | null;
          ctaButtons: Array<{
            __typename?: 'CtaButtonRecord';
            id: any;
            text?: string | null;
            url?: string | null;
            variant?: string | null;
          }>;
          video?: {
            __typename?: 'FileField';
            blurUpThumb?: string | null;
            title?: string | null;
            alt?: string | null;
            video?: {
              __typename?: 'UploadVideoField';
              muxPlaybackId: string;
              width: any;
              height: any;
            } | null;
          } | null;
        }>;
      }
    | {
        __typename?: 'StatementBlockRecord';
        id: any;
        text?: string | null;
        blackBackground?: any | null;
        header?: string | null;
        small?: any | null;
        linkText?: string | null;
        linkUrl?: string | null;
        imageMobile?: {
          __typename?: 'FileField';
          responsiveImage?: {
            __typename?: 'ResponsiveImage';
            aspectRatio: any;
            base64?: string | null;
            bgColor?: string | null;
            height: any;
            sizes: string;
            src: string;
            srcSet: string;
            webpSrcSet: string;
            width: any;
          } | null;
        } | null;
        imageTablet?: {
          __typename?: 'FileField';
          alt?: string | null;
          responsiveImage?: {
            __typename?: 'ResponsiveImage';
            aspectRatio: any;
            base64?: string | null;
            bgColor?: string | null;
            height: any;
            sizes: string;
            src: string;
            srcSet: string;
            webpSrcSet: string;
            width: any;
          } | null;
        } | null;
        imageDesktop?: {
          __typename?: 'FileField';
          responsiveImage?: {
            __typename?: 'ResponsiveImage';
            aspectRatio: any;
            base64?: string | null;
            bgColor?: string | null;
            height: any;
            sizes: string;
            src: string;
            srcSet: string;
            webpSrcSet: string;
            width: any;
          } | null;
        } | null;
        imageLoad?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
        imageOverlay?: {
          __typename?: 'OverlayRecord';
          id: any;
          opacity?: any | null;
          color?: { __typename?: 'ColorField'; hex: string } | null;
        } | null;
      }
    | {
        __typename?: 'TextBlockRecord';
        id: any;
        smallHeader?: any | null;
        header?: string | null;
        text?: string | null;
        introText?: string | null;
        ctaButtons: Array<{
          __typename?: 'CtaButtonRecord';
          id: any;
          text?: string | null;
          url?: string | null;
          variant?: string | null;
        }>;
      }
    | {
        __typename?: 'TwoColumnImageAndTextRecord';
        id: any;
        text?: string | null;
        title?: string | null;
        reverse?: any | null;
        image?: {
          __typename?: 'FileField';
          alt?: string | null;
          responsiveImage?: {
            __typename?: 'ResponsiveImage';
            aspectRatio: any;
            base64?: string | null;
            bgColor?: string | null;
            height: any;
            sizes: string;
            src: string;
            srcSet: string;
            webpSrcSet: string;
            width: any;
          } | null;
        } | null;
        imageLoad?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
      }
    | {
        __typename?: 'TwoColumnTextIntroRecord';
        id: any;
        introText?: string | null;
        text?: string | null;
        header?: string | null;
      }
    | {
        __typename?: 'VideoRecord';
        id: any;
        autoplay?: any | null;
        video?: {
          __typename?: 'FileField';
          title?: string | null;
          video?: {
            __typename?: 'UploadVideoField';
            mp4Url?: string | null;
            streamingUrl: string;
            thumbnailUrl: string;
            mp4Low?: string | null;
          } | null;
        } | null;
        videoThumbnail?: {
          __typename?: 'FileField';
          alt?: string | null;
          tags: Array<string>;
          title?: string | null;
          url: string;
          width?: any | null;
          height?: any | null;
          format: string;
          responsiveImage?: {
            __typename?: 'ResponsiveImage';
            aspectRatio: any;
            base64?: string | null;
            bgColor?: string | null;
            height: any;
            sizes: string;
            src: string;
            srcSet: string;
            webpSrcSet: string;
            width: any;
          } | null;
        } | null;
        muxVideo?: {
          __typename?: 'FileField';
          blurUpThumb?: string | null;
          title?: string | null;
          alt?: string | null;
          video?: {
            __typename?: 'UploadVideoField';
            muxPlaybackId: string;
            width: any;
            height: any;
          } | null;
        } | null;
      }
  >;
};

type JobOpportunitiesPageContentArea_ArticlesBlockRecord_Fragment = {
  __typename?: 'ArticlesBlockRecord';
  id: any;
  title?: string | null;
  isJobArticles?: any | null;
  ctaText?: string | null;
  ctaUrl?: string | null;
  jobPages: Array<{
    __typename?: 'JobOpportunitiesPageRecord';
    id: any;
    slug?: string | null;
    title?: string | null;
    publishDate?: any | null;
    category?: string | null;
    country?: string | null;
    department?: string | null;
  }>;
  newsPages: Array<{
    __typename?: 'NewsPageRecord';
    id: any;
    slug?: string | null;
    title?: string | null;
    publishDate?: any | null;
    category?: string | null;
    country?: string | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
  }>;
  reportPages: Array<{
    __typename?: 'ReportsListingRecord';
    id: any;
    slug?: string | null;
    title?: string | null;
    publishDate?: any | null;
    category?: string | null;
    country?: string | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
    pdf?: {
      __typename?: 'FileField';
      alt?: string | null;
      filename: string;
      format: string;
      size: any;
      title?: string | null;
      url: string;
      uploadId: any;
    } | null;
  }>;
};

type JobOpportunitiesPageContentArea_BrandsBlockRecord_Fragment = {
  __typename?: 'BrandsBlockRecord';
  id: any;
  title?: string | null;
  introText?: string | null;
  hideLabels?: any | null;
  brands: Array<{
    __typename?: 'BrandPageRecord';
    id: any;
    brandName?: string | null;
    slug?: string | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      tags: Array<string>;
      title?: string | null;
      url: string;
      width?: any | null;
      height?: any | null;
      format: string;
      responsiveImage?: {
        __typename?: 'ResponsiveImage';
        aspectRatio: any;
        base64?: string | null;
        bgColor?: string | null;
        height: any;
        sizes: string;
        src: string;
        srcSet: string;
        webpSrcSet: string;
        width: any;
      } | null;
    } | null;
    imageLoad?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
  }>;
};

type JobOpportunitiesPageContentArea_BulletListRecord_Fragment = {
  __typename?: 'BulletListRecord';
  id: any;
  bullets?: string | null;
  numberedList?: any | null;
  title?: string | null;
};

type JobOpportunitiesPageContentArea_DocumentLinkBlockRecord_Fragment = {
  __typename?: 'DocumentLinkBlockRecord';
  id: any;
  documents: Array<{
    __typename?: 'FileField';
    alt?: string | null;
    filename: string;
    format: string;
    size: any;
    title?: string | null;
    url: string;
    uploadId: any;
  }>;
};

type JobOpportunitiesPageContentArea_EmployeeRecord_Fragment = {
  __typename?: 'EmployeeRecord';
  id: any;
  name?: string | null;
  title?: string | null;
  introText?: string | null;
  description?: string | null;
  image?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
};

type JobOpportunitiesPageContentArea_HeroBlockRecord_Fragment = {
  __typename?: 'HeroBlockRecord';
  id: any;
  title?: string | null;
  description?: string | null;
  ctaText?: string | null;
  ctaUrl?: string | null;
  fullWidth?: any | null;
  boxColor?: { __typename?: 'ColorField'; hex: string } | null;
  textColor?: { __typename?: 'ColorField'; hex: string } | null;
  image?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
  imageOverlay?: {
    __typename?: 'OverlayRecord';
    id: any;
    opacity?: any | null;
    color?: { __typename?: 'ColorField'; hex: string } | null;
  } | null;
  ctaButtons: Array<{
    __typename?: 'CtaButtonRecord';
    id: any;
    text?: string | null;
    url?: string | null;
    variant?: string | null;
  }>;
  video?: {
    __typename?: 'FileField';
    blurUpThumb?: string | null;
    title?: string | null;
    alt?: string | null;
    video?: {
      __typename?: 'UploadVideoField';
      muxPlaybackId: string;
      width: any;
      height: any;
    } | null;
  } | null;
};

type JobOpportunitiesPageContentArea_ImageRecord_Fragment = {
  __typename?: 'ImageRecord';
  id: any;
  fullWidth?: any | null;
  image?: {
    __typename?: 'FileField';
    alt?: string | null;
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  imageLoad?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
};

type JobOpportunitiesPageContentArea_JobsListBlockRecord_Fragment = {
  __typename?: 'JobsListBlockRecord';
  id: any;
  title?: string | null;
};

type JobOpportunitiesPageContentArea_NewsListBlockRecord_Fragment = {
  __typename?: 'NewsListBlockRecord';
  id: any;
  title?: string | null;
  standalone?: any | null;
  largeTitle?: any | null;
  itemsToShow?: any | null;
};

type JobOpportunitiesPageContentArea_OfficesBlockRecord_Fragment = {
  __typename?: 'OfficesBlockRecord';
  id: any;
  offices: Array<{
    __typename?: 'OfficeRecord';
    id: any;
    name?: string | null;
    address?: string | null;
    zipCode?: string | null;
    city?: string | null;
    country?: string | null;
    email?: string | null;
    websiteUrl?: string | null;
    phoneNumber?: string | null;
  }>;
};

type JobOpportunitiesPageContentArea_PlugBlockRecord_Fragment = {
  __typename?: 'PlugBlockRecord';
  id: any;
  title?: string | null;
  description?: string | null;
  brands: Array<{
    __typename?: 'BrandPageRecord';
    id: any;
    brandName?: string | null;
    slug?: string | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      tags: Array<string>;
      title?: string | null;
      url: string;
      width?: any | null;
      height?: any | null;
      format: string;
      responsiveImage?: {
        __typename?: 'ResponsiveImage';
        aspectRatio: any;
        base64?: string | null;
        bgColor?: string | null;
        height: any;
        sizes: string;
        src: string;
        srcSet: string;
        webpSrcSet: string;
        width: any;
      } | null;
    } | null;
    imageLoad?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
  }>;
};

type JobOpportunitiesPageContentArea_SimpleTitleAndTextBlockRecord_Fragment = {
  __typename?: 'SimpleTitleAndTextBlockRecord';
  id: any;
  title?: string | null;
  topLabel?: string | null;
  description?: string | null;
};

type JobOpportunitiesPageContentArea_SliderBlockRecord_Fragment = {
  __typename?: 'SliderBlockRecord';
  title?: string | null;
  arrows?: any | null;
  slideAnimation?: any | null;
  delay?: any | null;
  dots?: any | null;
  heroes: Array<{
    __typename?: 'HeroBlockRecord';
    id: any;
    title?: string | null;
    description?: string | null;
    ctaText?: string | null;
    ctaUrl?: string | null;
    fullWidth?: any | null;
    boxColor?: { __typename?: 'ColorField'; hex: string } | null;
    textColor?: { __typename?: 'ColorField'; hex: string } | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
    imageOverlay?: {
      __typename?: 'OverlayRecord';
      id: any;
      opacity?: any | null;
      color?: { __typename?: 'ColorField'; hex: string } | null;
    } | null;
    ctaButtons: Array<{
      __typename?: 'CtaButtonRecord';
      id: any;
      text?: string | null;
      url?: string | null;
      variant?: string | null;
    }>;
    video?: {
      __typename?: 'FileField';
      blurUpThumb?: string | null;
      title?: string | null;
      alt?: string | null;
      video?: {
        __typename?: 'UploadVideoField';
        muxPlaybackId: string;
        width: any;
        height: any;
      } | null;
    } | null;
  }>;
};

type JobOpportunitiesPageContentArea_StatementBlockRecord_Fragment = {
  __typename?: 'StatementBlockRecord';
  id: any;
  text?: string | null;
  blackBackground?: any | null;
  header?: string | null;
  small?: any | null;
  linkText?: string | null;
  linkUrl?: string | null;
  imageMobile?: {
    __typename?: 'FileField';
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  imageTablet?: {
    __typename?: 'FileField';
    alt?: string | null;
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  imageDesktop?: {
    __typename?: 'FileField';
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  imageLoad?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
  imageOverlay?: {
    __typename?: 'OverlayRecord';
    id: any;
    opacity?: any | null;
    color?: { __typename?: 'ColorField'; hex: string } | null;
  } | null;
};

type JobOpportunitiesPageContentArea_TextBlockRecord_Fragment = {
  __typename?: 'TextBlockRecord';
  id: any;
  smallHeader?: any | null;
  header?: string | null;
  text?: string | null;
  introText?: string | null;
  ctaButtons: Array<{
    __typename?: 'CtaButtonRecord';
    id: any;
    text?: string | null;
    url?: string | null;
    variant?: string | null;
  }>;
};

type JobOpportunitiesPageContentArea_TwoColumnImageAndTextRecord_Fragment = {
  __typename?: 'TwoColumnImageAndTextRecord';
  id: any;
  text?: string | null;
  title?: string | null;
  reverse?: any | null;
  image?: {
    __typename?: 'FileField';
    alt?: string | null;
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  imageLoad?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
};

type JobOpportunitiesPageContentArea_TwoColumnTextIntroRecord_Fragment = {
  __typename?: 'TwoColumnTextIntroRecord';
  id: any;
  introText?: string | null;
  text?: string | null;
  header?: string | null;
};

type JobOpportunitiesPageContentArea_VideoRecord_Fragment = {
  __typename?: 'VideoRecord';
  id: any;
  autoplay?: any | null;
  video?: {
    __typename?: 'FileField';
    title?: string | null;
    video?: {
      __typename?: 'UploadVideoField';
      mp4Url?: string | null;
      streamingUrl: string;
      thumbnailUrl: string;
      mp4Low?: string | null;
    } | null;
  } | null;
  videoThumbnail?: {
    __typename?: 'FileField';
    alt?: string | null;
    tags: Array<string>;
    title?: string | null;
    url: string;
    width?: any | null;
    height?: any | null;
    format: string;
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  muxVideo?: {
    __typename?: 'FileField';
    blurUpThumb?: string | null;
    title?: string | null;
    alt?: string | null;
    video?: {
      __typename?: 'UploadVideoField';
      muxPlaybackId: string;
      width: any;
      height: any;
    } | null;
  } | null;
};

export type JobOpportunitiesPageContentAreaFragment =
  | JobOpportunitiesPageContentArea_ArticlesBlockRecord_Fragment
  | JobOpportunitiesPageContentArea_BrandsBlockRecord_Fragment
  | JobOpportunitiesPageContentArea_BulletListRecord_Fragment
  | JobOpportunitiesPageContentArea_DocumentLinkBlockRecord_Fragment
  | JobOpportunitiesPageContentArea_EmployeeRecord_Fragment
  | JobOpportunitiesPageContentArea_HeroBlockRecord_Fragment
  | JobOpportunitiesPageContentArea_ImageRecord_Fragment
  | JobOpportunitiesPageContentArea_JobsListBlockRecord_Fragment
  | JobOpportunitiesPageContentArea_NewsListBlockRecord_Fragment
  | JobOpportunitiesPageContentArea_OfficesBlockRecord_Fragment
  | JobOpportunitiesPageContentArea_PlugBlockRecord_Fragment
  | JobOpportunitiesPageContentArea_SimpleTitleAndTextBlockRecord_Fragment
  | JobOpportunitiesPageContentArea_SliderBlockRecord_Fragment
  | JobOpportunitiesPageContentArea_StatementBlockRecord_Fragment
  | JobOpportunitiesPageContentArea_TextBlockRecord_Fragment
  | JobOpportunitiesPageContentArea_TwoColumnImageAndTextRecord_Fragment
  | JobOpportunitiesPageContentArea_TwoColumnTextIntroRecord_Fragment
  | JobOpportunitiesPageContentArea_VideoRecord_Fragment;

export type JobOpportunitiesPageContentFragment = {
  __typename?: 'JobOpportunitiesPageRecord';
  id: any;
  title?: string | null;
  slug?: string | null;
  publishDate?: any | null;
  category?: string | null;
  applicationDeadline?: any | null;
  pageLocales: Array<SiteLocale>;
  seo?: {
    __typename?: 'SeoField';
    description?: string | null;
    title?: string | null;
    image?: {
      __typename?: 'FileField';
      url: string;
      alt?: string | null;
      title?: string | null;
    } | null;
  } | null;
  contentArea: Array<
    | {
        __typename?: 'ArticlesBlockRecord';
        id: any;
        title?: string | null;
        isJobArticles?: any | null;
        ctaText?: string | null;
        ctaUrl?: string | null;
        jobPages: Array<{
          __typename?: 'JobOpportunitiesPageRecord';
          id: any;
          slug?: string | null;
          title?: string | null;
          publishDate?: any | null;
          category?: string | null;
          country?: string | null;
          department?: string | null;
        }>;
        newsPages: Array<{
          __typename?: 'NewsPageRecord';
          id: any;
          slug?: string | null;
          title?: string | null;
          publishDate?: any | null;
          category?: string | null;
          country?: string | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
        }>;
        reportPages: Array<{
          __typename?: 'ReportsListingRecord';
          id: any;
          slug?: string | null;
          title?: string | null;
          publishDate?: any | null;
          category?: string | null;
          country?: string | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
          pdf?: {
            __typename?: 'FileField';
            alt?: string | null;
            filename: string;
            format: string;
            size: any;
            title?: string | null;
            url: string;
            uploadId: any;
          } | null;
        }>;
      }
    | {
        __typename?: 'BrandsBlockRecord';
        id: any;
        title?: string | null;
        introText?: string | null;
        hideLabels?: any | null;
        brands: Array<{
          __typename?: 'BrandPageRecord';
          id: any;
          brandName?: string | null;
          slug?: string | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            tags: Array<string>;
            title?: string | null;
            url: string;
            width?: any | null;
            height?: any | null;
            format: string;
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageLoad?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
        }>;
      }
    | {
        __typename?: 'BulletListRecord';
        id: any;
        bullets?: string | null;
        numberedList?: any | null;
        title?: string | null;
      }
    | {
        __typename?: 'DocumentLinkBlockRecord';
        id: any;
        documents: Array<{
          __typename?: 'FileField';
          alt?: string | null;
          filename: string;
          format: string;
          size: any;
          title?: string | null;
          url: string;
          uploadId: any;
        }>;
      }
    | {
        __typename?: 'EmployeeRecord';
        id: any;
        name?: string | null;
        title?: string | null;
        introText?: string | null;
        description?: string | null;
        image?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
      }
    | {
        __typename?: 'HeroBlockRecord';
        id: any;
        title?: string | null;
        description?: string | null;
        ctaText?: string | null;
        ctaUrl?: string | null;
        fullWidth?: any | null;
        boxColor?: { __typename?: 'ColorField'; hex: string } | null;
        textColor?: { __typename?: 'ColorField'; hex: string } | null;
        image?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
        imageOverlay?: {
          __typename?: 'OverlayRecord';
          id: any;
          opacity?: any | null;
          color?: { __typename?: 'ColorField'; hex: string } | null;
        } | null;
        ctaButtons: Array<{
          __typename?: 'CtaButtonRecord';
          id: any;
          text?: string | null;
          url?: string | null;
          variant?: string | null;
        }>;
        video?: {
          __typename?: 'FileField';
          blurUpThumb?: string | null;
          title?: string | null;
          alt?: string | null;
          video?: {
            __typename?: 'UploadVideoField';
            muxPlaybackId: string;
            width: any;
            height: any;
          } | null;
        } | null;
      }
    | {
        __typename?: 'ImageRecord';
        id: any;
        fullWidth?: any | null;
        image?: {
          __typename?: 'FileField';
          alt?: string | null;
          responsiveImage?: {
            __typename?: 'ResponsiveImage';
            aspectRatio: any;
            base64?: string | null;
            bgColor?: string | null;
            height: any;
            sizes: string;
            src: string;
            srcSet: string;
            webpSrcSet: string;
            width: any;
          } | null;
        } | null;
        imageLoad?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
      }
    | { __typename?: 'JobsListBlockRecord'; id: any; title?: string | null }
    | {
        __typename?: 'NewsListBlockRecord';
        id: any;
        title?: string | null;
        standalone?: any | null;
        largeTitle?: any | null;
        itemsToShow?: any | null;
      }
    | {
        __typename?: 'OfficesBlockRecord';
        id: any;
        offices: Array<{
          __typename?: 'OfficeRecord';
          id: any;
          name?: string | null;
          address?: string | null;
          zipCode?: string | null;
          city?: string | null;
          country?: string | null;
          email?: string | null;
          websiteUrl?: string | null;
          phoneNumber?: string | null;
        }>;
      }
    | {
        __typename?: 'PlugBlockRecord';
        id: any;
        title?: string | null;
        description?: string | null;
        brands: Array<{
          __typename?: 'BrandPageRecord';
          id: any;
          brandName?: string | null;
          slug?: string | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            tags: Array<string>;
            title?: string | null;
            url: string;
            width?: any | null;
            height?: any | null;
            format: string;
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageLoad?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
        }>;
      }
    | {
        __typename?: 'SimpleTitleAndTextBlockRecord';
        id: any;
        title?: string | null;
        topLabel?: string | null;
        description?: string | null;
      }
    | {
        __typename?: 'SliderBlockRecord';
        title?: string | null;
        arrows?: any | null;
        slideAnimation?: any | null;
        delay?: any | null;
        dots?: any | null;
        heroes: Array<{
          __typename?: 'HeroBlockRecord';
          id: any;
          title?: string | null;
          description?: string | null;
          ctaText?: string | null;
          ctaUrl?: string | null;
          fullWidth?: any | null;
          boxColor?: { __typename?: 'ColorField'; hex: string } | null;
          textColor?: { __typename?: 'ColorField'; hex: string } | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
          imageOverlay?: {
            __typename?: 'OverlayRecord';
            id: any;
            opacity?: any | null;
            color?: { __typename?: 'ColorField'; hex: string } | null;
          } | null;
          ctaButtons: Array<{
            __typename?: 'CtaButtonRecord';
            id: any;
            text?: string | null;
            url?: string | null;
            variant?: string | null;
          }>;
          video?: {
            __typename?: 'FileField';
            blurUpThumb?: string | null;
            title?: string | null;
            alt?: string | null;
            video?: {
              __typename?: 'UploadVideoField';
              muxPlaybackId: string;
              width: any;
              height: any;
            } | null;
          } | null;
        }>;
      }
    | {
        __typename?: 'StatementBlockRecord';
        id: any;
        text?: string | null;
        blackBackground?: any | null;
        header?: string | null;
        small?: any | null;
        linkText?: string | null;
        linkUrl?: string | null;
        imageMobile?: {
          __typename?: 'FileField';
          responsiveImage?: {
            __typename?: 'ResponsiveImage';
            aspectRatio: any;
            base64?: string | null;
            bgColor?: string | null;
            height: any;
            sizes: string;
            src: string;
            srcSet: string;
            webpSrcSet: string;
            width: any;
          } | null;
        } | null;
        imageTablet?: {
          __typename?: 'FileField';
          alt?: string | null;
          responsiveImage?: {
            __typename?: 'ResponsiveImage';
            aspectRatio: any;
            base64?: string | null;
            bgColor?: string | null;
            height: any;
            sizes: string;
            src: string;
            srcSet: string;
            webpSrcSet: string;
            width: any;
          } | null;
        } | null;
        imageDesktop?: {
          __typename?: 'FileField';
          responsiveImage?: {
            __typename?: 'ResponsiveImage';
            aspectRatio: any;
            base64?: string | null;
            bgColor?: string | null;
            height: any;
            sizes: string;
            src: string;
            srcSet: string;
            webpSrcSet: string;
            width: any;
          } | null;
        } | null;
        imageLoad?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
        imageOverlay?: {
          __typename?: 'OverlayRecord';
          id: any;
          opacity?: any | null;
          color?: { __typename?: 'ColorField'; hex: string } | null;
        } | null;
      }
    | {
        __typename?: 'TextBlockRecord';
        id: any;
        smallHeader?: any | null;
        header?: string | null;
        text?: string | null;
        introText?: string | null;
        ctaButtons: Array<{
          __typename?: 'CtaButtonRecord';
          id: any;
          text?: string | null;
          url?: string | null;
          variant?: string | null;
        }>;
      }
    | {
        __typename?: 'TwoColumnImageAndTextRecord';
        id: any;
        text?: string | null;
        title?: string | null;
        reverse?: any | null;
        image?: {
          __typename?: 'FileField';
          alt?: string | null;
          responsiveImage?: {
            __typename?: 'ResponsiveImage';
            aspectRatio: any;
            base64?: string | null;
            bgColor?: string | null;
            height: any;
            sizes: string;
            src: string;
            srcSet: string;
            webpSrcSet: string;
            width: any;
          } | null;
        } | null;
        imageLoad?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
      }
    | {
        __typename?: 'TwoColumnTextIntroRecord';
        id: any;
        introText?: string | null;
        text?: string | null;
        header?: string | null;
      }
    | {
        __typename?: 'VideoRecord';
        id: any;
        autoplay?: any | null;
        video?: {
          __typename?: 'FileField';
          title?: string | null;
          video?: {
            __typename?: 'UploadVideoField';
            mp4Url?: string | null;
            streamingUrl: string;
            thumbnailUrl: string;
            mp4Low?: string | null;
          } | null;
        } | null;
        videoThumbnail?: {
          __typename?: 'FileField';
          alt?: string | null;
          tags: Array<string>;
          title?: string | null;
          url: string;
          width?: any | null;
          height?: any | null;
          format: string;
          responsiveImage?: {
            __typename?: 'ResponsiveImage';
            aspectRatio: any;
            base64?: string | null;
            bgColor?: string | null;
            height: any;
            sizes: string;
            src: string;
            srcSet: string;
            webpSrcSet: string;
            width: any;
          } | null;
        } | null;
        muxVideo?: {
          __typename?: 'FileField';
          blurUpThumb?: string | null;
          title?: string | null;
          alt?: string | null;
          video?: {
            __typename?: 'UploadVideoField';
            muxPlaybackId: string;
            width: any;
            height: any;
          } | null;
        } | null;
      }
  >;
};

type LandingPageContentArea_ArticlesBlockRecord_Fragment = {
  __typename?: 'ArticlesBlockRecord';
  id: any;
  title?: string | null;
  isJobArticles?: any | null;
  ctaText?: string | null;
  ctaUrl?: string | null;
  jobPages: Array<{
    __typename?: 'JobOpportunitiesPageRecord';
    id: any;
    slug?: string | null;
    title?: string | null;
    publishDate?: any | null;
    category?: string | null;
    country?: string | null;
    department?: string | null;
  }>;
  newsPages: Array<{
    __typename?: 'NewsPageRecord';
    id: any;
    slug?: string | null;
    title?: string | null;
    publishDate?: any | null;
    category?: string | null;
    country?: string | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
  }>;
  reportPages: Array<{
    __typename?: 'ReportsListingRecord';
    id: any;
    slug?: string | null;
    title?: string | null;
    publishDate?: any | null;
    category?: string | null;
    country?: string | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
    pdf?: {
      __typename?: 'FileField';
      alt?: string | null;
      filename: string;
      format: string;
      size: any;
      title?: string | null;
      url: string;
      uploadId: any;
    } | null;
  }>;
};

type LandingPageContentArea_BrandsBlockRecord_Fragment = {
  __typename?: 'BrandsBlockRecord';
  id: any;
  title?: string | null;
  introText?: string | null;
  hideLabels?: any | null;
  brands: Array<{
    __typename?: 'BrandPageRecord';
    id: any;
    brandName?: string | null;
    slug?: string | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      tags: Array<string>;
      title?: string | null;
      url: string;
      width?: any | null;
      height?: any | null;
      format: string;
      responsiveImage?: {
        __typename?: 'ResponsiveImage';
        aspectRatio: any;
        base64?: string | null;
        bgColor?: string | null;
        height: any;
        sizes: string;
        src: string;
        srcSet: string;
        webpSrcSet: string;
        width: any;
      } | null;
    } | null;
    imageLoad?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
  }>;
};

type LandingPageContentArea_BulletListRecord_Fragment = {
  __typename?: 'BulletListRecord';
  id: any;
  bullets?: string | null;
  numberedList?: any | null;
  title?: string | null;
};

type LandingPageContentArea_DocumentLinkBlockRecord_Fragment = {
  __typename?: 'DocumentLinkBlockRecord';
  id: any;
  documents: Array<{
    __typename?: 'FileField';
    alt?: string | null;
    filename: string;
    format: string;
    size: any;
    title?: string | null;
    url: string;
    uploadId: any;
  }>;
};

type LandingPageContentArea_EmployeeRecord_Fragment = {
  __typename?: 'EmployeeRecord';
  id: any;
  name?: string | null;
  title?: string | null;
  introText?: string | null;
  description?: string | null;
  image?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
};

type LandingPageContentArea_GridContainerBlockRecord_Fragment = {
  __typename?: 'GridContainerBlockRecord';
  id: any;
  fullwidth?: any | null;
  gap?: any | null;
  backgroundColor?: { __typename?: 'ColorField'; hex: string } | null;
  textColor?: { __typename?: 'ColorField'; hex: string } | null;
  content: Array<
    | {
        __typename?: 'GridFourcolBlockRecord';
        id: any;
        content: Array<
          | {
              __typename?: 'ImageRecord';
              id: any;
              fullWidth?: any | null;
              image?: {
                __typename?: 'FileField';
                alt?: string | null;
                responsiveImage?: {
                  __typename?: 'ResponsiveImage';
                  aspectRatio: any;
                  base64?: string | null;
                  bgColor?: string | null;
                  height: any;
                  sizes: string;
                  src: string;
                  srcSet: string;
                  webpSrcSet: string;
                  width: any;
                } | null;
              } | null;
              imageLoad?: {
                __typename?: 'FileField';
                alt?: string | null;
                title?: string | null;
                url: string;
                blurUpThumb?: string | null;
                focalPoint?: {
                  __typename?: 'focalPoint';
                  x: any;
                  y: any;
                } | null;
                colors: Array<{ __typename?: 'ColorField'; hex: string }>;
              } | null;
            }
          | {
              __typename?: 'MediaWithCaptionRecord';
              id: any;
              centerText?: any | null;
              textOnImage?: any | null;
              media?: {
                __typename?: 'ImageRecord';
                id: any;
                fullWidth?: any | null;
                image?: {
                  __typename?: 'FileField';
                  alt?: string | null;
                  responsiveImage?: {
                    __typename?: 'ResponsiveImage';
                    aspectRatio: any;
                    base64?: string | null;
                    bgColor?: string | null;
                    height: any;
                    sizes: string;
                    src: string;
                    srcSet: string;
                    webpSrcSet: string;
                    width: any;
                  } | null;
                } | null;
                imageLoad?: {
                  __typename?: 'FileField';
                  alt?: string | null;
                  title?: string | null;
                  url: string;
                  blurUpThumb?: string | null;
                  focalPoint?: {
                    __typename?: 'focalPoint';
                    x: any;
                    y: any;
                  } | null;
                  colors: Array<{ __typename?: 'ColorField'; hex: string }>;
                } | null;
              } | null;
              caption?: {
                __typename?: 'TextBlockRecord';
                id: any;
                smallHeader?: any | null;
                header?: string | null;
                text?: string | null;
                introText?: string | null;
                ctaButtons: Array<{
                  __typename?: 'CtaButtonRecord';
                  id: any;
                  text?: string | null;
                  url?: string | null;
                  variant?: string | null;
                }>;
              } | null;
            }
          | {
              __typename?: 'TextBlockRecord';
              id: any;
              smallHeader?: any | null;
              header?: string | null;
              text?: string | null;
              introText?: string | null;
              ctaButtons: Array<{
                __typename?: 'CtaButtonRecord';
                id: any;
                text?: string | null;
                url?: string | null;
                variant?: string | null;
              }>;
            }
        >;
      }
    | {
        __typename?: 'GridThreecolBlockRecord';
        id: any;
        content: Array<
          | {
              __typename?: 'GridTwocolBlockRecord';
              id: any;
              content: Array<
                | {
                    __typename?: 'ImageRecord';
                    id: any;
                    fullWidth?: any | null;
                    image?: {
                      __typename?: 'FileField';
                      alt?: string | null;
                      responsiveImage?: {
                        __typename?: 'ResponsiveImage';
                        aspectRatio: any;
                        base64?: string | null;
                        bgColor?: string | null;
                        height: any;
                        sizes: string;
                        src: string;
                        srcSet: string;
                        webpSrcSet: string;
                        width: any;
                      } | null;
                    } | null;
                    imageLoad?: {
                      __typename?: 'FileField';
                      alt?: string | null;
                      title?: string | null;
                      url: string;
                      blurUpThumb?: string | null;
                      focalPoint?: {
                        __typename?: 'focalPoint';
                        x: any;
                        y: any;
                      } | null;
                      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
                    } | null;
                  }
                | {
                    __typename?: 'MediaWithCaptionRecord';
                    id: any;
                    centerText?: any | null;
                    textOnImage?: any | null;
                    media?: {
                      __typename?: 'ImageRecord';
                      id: any;
                      fullWidth?: any | null;
                      image?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        responsiveImage?: {
                          __typename?: 'ResponsiveImage';
                          aspectRatio: any;
                          base64?: string | null;
                          bgColor?: string | null;
                          height: any;
                          sizes: string;
                          src: string;
                          srcSet: string;
                          webpSrcSet: string;
                          width: any;
                        } | null;
                      } | null;
                      imageLoad?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        title?: string | null;
                        url: string;
                        blurUpThumb?: string | null;
                        focalPoint?: {
                          __typename?: 'focalPoint';
                          x: any;
                          y: any;
                        } | null;
                        colors: Array<{
                          __typename?: 'ColorField';
                          hex: string;
                        }>;
                      } | null;
                    } | null;
                    caption?: {
                      __typename?: 'TextBlockRecord';
                      id: any;
                      smallHeader?: any | null;
                      header?: string | null;
                      text?: string | null;
                      introText?: string | null;
                      ctaButtons: Array<{
                        __typename?: 'CtaButtonRecord';
                        id: any;
                        text?: string | null;
                        url?: string | null;
                        variant?: string | null;
                      }>;
                    } | null;
                  }
                | {
                    __typename?: 'NewsListBlockRecord';
                    id: any;
                    title?: string | null;
                    standalone?: any | null;
                    largeTitle?: any | null;
                    itemsToShow?: any | null;
                  }
                | {
                    __typename?: 'ReportsListBlockRecord';
                    id: any;
                    title?: string | null;
                    standalone?: any | null;
                    largeTitle?: any | null;
                  }
                | {
                    __typename?: 'TextBlockRecord';
                    id: any;
                    smallHeader?: any | null;
                    header?: string | null;
                    text?: string | null;
                    introText?: string | null;
                    ctaButtons: Array<{
                      __typename?: 'CtaButtonRecord';
                      id: any;
                      text?: string | null;
                      url?: string | null;
                      variant?: string | null;
                    }>;
                  }
              >;
            }
          | {
              __typename?: 'ImageRecord';
              id: any;
              fullWidth?: any | null;
              image?: {
                __typename?: 'FileField';
                alt?: string | null;
                responsiveImage?: {
                  __typename?: 'ResponsiveImage';
                  aspectRatio: any;
                  base64?: string | null;
                  bgColor?: string | null;
                  height: any;
                  sizes: string;
                  src: string;
                  srcSet: string;
                  webpSrcSet: string;
                  width: any;
                } | null;
              } | null;
              imageLoad?: {
                __typename?: 'FileField';
                alt?: string | null;
                title?: string | null;
                url: string;
                blurUpThumb?: string | null;
                focalPoint?: {
                  __typename?: 'focalPoint';
                  x: any;
                  y: any;
                } | null;
                colors: Array<{ __typename?: 'ColorField'; hex: string }>;
              } | null;
            }
          | {
              __typename?: 'MediaWithCaptionRecord';
              id: any;
              centerText?: any | null;
              textOnImage?: any | null;
              media?: {
                __typename?: 'ImageRecord';
                id: any;
                fullWidth?: any | null;
                image?: {
                  __typename?: 'FileField';
                  alt?: string | null;
                  responsiveImage?: {
                    __typename?: 'ResponsiveImage';
                    aspectRatio: any;
                    base64?: string | null;
                    bgColor?: string | null;
                    height: any;
                    sizes: string;
                    src: string;
                    srcSet: string;
                    webpSrcSet: string;
                    width: any;
                  } | null;
                } | null;
                imageLoad?: {
                  __typename?: 'FileField';
                  alt?: string | null;
                  title?: string | null;
                  url: string;
                  blurUpThumb?: string | null;
                  focalPoint?: {
                    __typename?: 'focalPoint';
                    x: any;
                    y: any;
                  } | null;
                  colors: Array<{ __typename?: 'ColorField'; hex: string }>;
                } | null;
              } | null;
              caption?: {
                __typename?: 'TextBlockRecord';
                id: any;
                smallHeader?: any | null;
                header?: string | null;
                text?: string | null;
                introText?: string | null;
                ctaButtons: Array<{
                  __typename?: 'CtaButtonRecord';
                  id: any;
                  text?: string | null;
                  url?: string | null;
                  variant?: string | null;
                }>;
              } | null;
            }
          | {
              __typename?: 'TextBlockRecord';
              id: any;
              smallHeader?: any | null;
              header?: string | null;
              text?: string | null;
              introText?: string | null;
              ctaButtons: Array<{
                __typename?: 'CtaButtonRecord';
                id: any;
                text?: string | null;
                url?: string | null;
                variant?: string | null;
              }>;
            }
        >;
      }
    | {
        __typename?: 'GridTwocolBlockRecord';
        id: any;
        content: Array<
          | {
              __typename?: 'ImageRecord';
              id: any;
              fullWidth?: any | null;
              image?: {
                __typename?: 'FileField';
                alt?: string | null;
                responsiveImage?: {
                  __typename?: 'ResponsiveImage';
                  aspectRatio: any;
                  base64?: string | null;
                  bgColor?: string | null;
                  height: any;
                  sizes: string;
                  src: string;
                  srcSet: string;
                  webpSrcSet: string;
                  width: any;
                } | null;
              } | null;
              imageLoad?: {
                __typename?: 'FileField';
                alt?: string | null;
                title?: string | null;
                url: string;
                blurUpThumb?: string | null;
                focalPoint?: {
                  __typename?: 'focalPoint';
                  x: any;
                  y: any;
                } | null;
                colors: Array<{ __typename?: 'ColorField'; hex: string }>;
              } | null;
            }
          | {
              __typename?: 'MediaWithCaptionRecord';
              id: any;
              centerText?: any | null;
              textOnImage?: any | null;
              media?: {
                __typename?: 'ImageRecord';
                id: any;
                fullWidth?: any | null;
                image?: {
                  __typename?: 'FileField';
                  alt?: string | null;
                  responsiveImage?: {
                    __typename?: 'ResponsiveImage';
                    aspectRatio: any;
                    base64?: string | null;
                    bgColor?: string | null;
                    height: any;
                    sizes: string;
                    src: string;
                    srcSet: string;
                    webpSrcSet: string;
                    width: any;
                  } | null;
                } | null;
                imageLoad?: {
                  __typename?: 'FileField';
                  alt?: string | null;
                  title?: string | null;
                  url: string;
                  blurUpThumb?: string | null;
                  focalPoint?: {
                    __typename?: 'focalPoint';
                    x: any;
                    y: any;
                  } | null;
                  colors: Array<{ __typename?: 'ColorField'; hex: string }>;
                } | null;
              } | null;
              caption?: {
                __typename?: 'TextBlockRecord';
                id: any;
                smallHeader?: any | null;
                header?: string | null;
                text?: string | null;
                introText?: string | null;
                ctaButtons: Array<{
                  __typename?: 'CtaButtonRecord';
                  id: any;
                  text?: string | null;
                  url?: string | null;
                  variant?: string | null;
                }>;
              } | null;
            }
          | {
              __typename?: 'NewsListBlockRecord';
              id: any;
              title?: string | null;
              standalone?: any | null;
              largeTitle?: any | null;
              itemsToShow?: any | null;
            }
          | {
              __typename?: 'ReportsListBlockRecord';
              id: any;
              title?: string | null;
              standalone?: any | null;
              largeTitle?: any | null;
            }
          | {
              __typename?: 'TextBlockRecord';
              id: any;
              smallHeader?: any | null;
              header?: string | null;
              text?: string | null;
              introText?: string | null;
              ctaButtons: Array<{
                __typename?: 'CtaButtonRecord';
                id: any;
                text?: string | null;
                url?: string | null;
                variant?: string | null;
              }>;
            }
        >;
      }
  >;
};

type LandingPageContentArea_HeroBlockRecord_Fragment = {
  __typename?: 'HeroBlockRecord';
  id: any;
  title?: string | null;
  description?: string | null;
  ctaText?: string | null;
  ctaUrl?: string | null;
  fullWidth?: any | null;
  boxColor?: { __typename?: 'ColorField'; hex: string } | null;
  textColor?: { __typename?: 'ColorField'; hex: string } | null;
  image?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
  imageOverlay?: {
    __typename?: 'OverlayRecord';
    id: any;
    opacity?: any | null;
    color?: { __typename?: 'ColorField'; hex: string } | null;
  } | null;
  ctaButtons: Array<{
    __typename?: 'CtaButtonRecord';
    id: any;
    text?: string | null;
    url?: string | null;
    variant?: string | null;
  }>;
  video?: {
    __typename?: 'FileField';
    blurUpThumb?: string | null;
    title?: string | null;
    alt?: string | null;
    video?: {
      __typename?: 'UploadVideoField';
      muxPlaybackId: string;
      width: any;
      height: any;
    } | null;
  } | null;
};

type LandingPageContentArea_ImageRecord_Fragment = {
  __typename?: 'ImageRecord';
  id: any;
  fullWidth?: any | null;
  image?: {
    __typename?: 'FileField';
    alt?: string | null;
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  imageLoad?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
};

type LandingPageContentArea_JobsListBlockRecord_Fragment = {
  __typename?: 'JobsListBlockRecord';
  id: any;
  title?: string | null;
};

type LandingPageContentArea_NewsAndReportsListBlockRecord_Fragment = {
  __typename?: 'NewsAndReportsListBlockRecord';
  newsTitle?: string | null;
  reportsTitle?: string | null;
  newsImage?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
  news: Array<{
    __typename?: 'NewsPageRecord';
    id: any;
    title?: string | null;
    slug?: string | null;
    publishDate?: any | null;
    category?: string | null;
  }>;
  reportsImage?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
  reports: Array<{
    __typename?: 'ReportsListingRecord';
    id: any;
    title?: string | null;
    slug?: string | null;
    publishDate?: any | null;
    category?: string | null;
    pdf?: {
      __typename?: 'FileField';
      alt?: string | null;
      filename: string;
      format: string;
      size: any;
      title?: string | null;
      url: string;
      uploadId: any;
    } | null;
  }>;
};

type LandingPageContentArea_NewsListBlockRecord_Fragment = {
  __typename?: 'NewsListBlockRecord';
  id: any;
  title?: string | null;
  standalone?: any | null;
  largeTitle?: any | null;
  itemsToShow?: any | null;
};

type LandingPageContentArea_OfficesBlockRecord_Fragment = {
  __typename?: 'OfficesBlockRecord';
  id: any;
  offices: Array<{
    __typename?: 'OfficeRecord';
    id: any;
    name?: string | null;
    address?: string | null;
    zipCode?: string | null;
    city?: string | null;
    country?: string | null;
    email?: string | null;
    websiteUrl?: string | null;
    phoneNumber?: string | null;
  }>;
};

type LandingPageContentArea_PlugBlockRecord_Fragment = {
  __typename?: 'PlugBlockRecord';
  id: any;
  title?: string | null;
  description?: string | null;
  brands: Array<{
    __typename?: 'BrandPageRecord';
    id: any;
    brandName?: string | null;
    slug?: string | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      tags: Array<string>;
      title?: string | null;
      url: string;
      width?: any | null;
      height?: any | null;
      format: string;
      responsiveImage?: {
        __typename?: 'ResponsiveImage';
        aspectRatio: any;
        base64?: string | null;
        bgColor?: string | null;
        height: any;
        sizes: string;
        src: string;
        srcSet: string;
        webpSrcSet: string;
        width: any;
      } | null;
    } | null;
    imageLoad?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
  }>;
};

type LandingPageContentArea_SimpleTitleAndTextBlockRecord_Fragment = {
  __typename?: 'SimpleTitleAndTextBlockRecord';
  id: any;
  title?: string | null;
  topLabel?: string | null;
  description?: string | null;
};

type LandingPageContentArea_SliderBlockRecord_Fragment = {
  __typename?: 'SliderBlockRecord';
  title?: string | null;
  arrows?: any | null;
  slideAnimation?: any | null;
  delay?: any | null;
  dots?: any | null;
  heroes: Array<{
    __typename?: 'HeroBlockRecord';
    id: any;
    title?: string | null;
    description?: string | null;
    ctaText?: string | null;
    ctaUrl?: string | null;
    fullWidth?: any | null;
    boxColor?: { __typename?: 'ColorField'; hex: string } | null;
    textColor?: { __typename?: 'ColorField'; hex: string } | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
    imageOverlay?: {
      __typename?: 'OverlayRecord';
      id: any;
      opacity?: any | null;
      color?: { __typename?: 'ColorField'; hex: string } | null;
    } | null;
    ctaButtons: Array<{
      __typename?: 'CtaButtonRecord';
      id: any;
      text?: string | null;
      url?: string | null;
      variant?: string | null;
    }>;
    video?: {
      __typename?: 'FileField';
      blurUpThumb?: string | null;
      title?: string | null;
      alt?: string | null;
      video?: {
        __typename?: 'UploadVideoField';
        muxPlaybackId: string;
        width: any;
        height: any;
      } | null;
    } | null;
  }>;
};

type LandingPageContentArea_StatementBlockRecord_Fragment = {
  __typename?: 'StatementBlockRecord';
  id: any;
  text?: string | null;
  blackBackground?: any | null;
  header?: string | null;
  small?: any | null;
  linkText?: string | null;
  linkUrl?: string | null;
  imageMobile?: {
    __typename?: 'FileField';
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  imageTablet?: {
    __typename?: 'FileField';
    alt?: string | null;
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  imageDesktop?: {
    __typename?: 'FileField';
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  imageLoad?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
  imageOverlay?: {
    __typename?: 'OverlayRecord';
    id: any;
    opacity?: any | null;
    color?: { __typename?: 'ColorField'; hex: string } | null;
  } | null;
};

type LandingPageContentArea_SubheadingBlockRecord_Fragment = {
  __typename?: 'SubheadingBlockRecord';
  id: any;
  title?: string | null;
  text?: string | null;
  ctaButton?: {
    __typename?: 'CtaButtonRecord';
    id: any;
    text?: string | null;
    url?: string | null;
    variant?: string | null;
  } | null;
  backgroundColor?: { __typename?: 'ColorField'; hex: string } | null;
};

type LandingPageContentArea_SustainabilityReportsBlockRecord_Fragment = {
  __typename?: 'SustainabilityReportsBlockRecord';
  id: any;
  title?: string | null;
  reports: Array<{
    __typename?: 'FileField';
    alt?: string | null;
    filename: string;
    format: string;
    size: any;
    title?: string | null;
    url: string;
    uploadId: any;
  }>;
};

type LandingPageContentArea_TextBlockRecord_Fragment = {
  __typename?: 'TextBlockRecord';
  id: any;
  smallHeader?: any | null;
  header?: string | null;
  text?: string | null;
  introText?: string | null;
  ctaButtons: Array<{
    __typename?: 'CtaButtonRecord';
    id: any;
    text?: string | null;
    url?: string | null;
    variant?: string | null;
  }>;
};

type LandingPageContentArea_TwoColumnImageAndTextRecord_Fragment = {
  __typename?: 'TwoColumnImageAndTextRecord';
  id: any;
  text?: string | null;
  title?: string | null;
  reverse?: any | null;
  image?: {
    __typename?: 'FileField';
    alt?: string | null;
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  imageLoad?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
};

type LandingPageContentArea_TwoColumnTextIntroRecord_Fragment = {
  __typename?: 'TwoColumnTextIntroRecord';
  id: any;
  introText?: string | null;
  text?: string | null;
  header?: string | null;
};

type LandingPageContentArea_VideoRecord_Fragment = {
  __typename?: 'VideoRecord';
  id: any;
  autoplay?: any | null;
  video?: {
    __typename?: 'FileField';
    title?: string | null;
    video?: {
      __typename?: 'UploadVideoField';
      mp4Url?: string | null;
      streamingUrl: string;
      thumbnailUrl: string;
      mp4Low?: string | null;
    } | null;
  } | null;
  videoThumbnail?: {
    __typename?: 'FileField';
    alt?: string | null;
    tags: Array<string>;
    title?: string | null;
    url: string;
    width?: any | null;
    height?: any | null;
    format: string;
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  muxVideo?: {
    __typename?: 'FileField';
    blurUpThumb?: string | null;
    title?: string | null;
    alt?: string | null;
    video?: {
      __typename?: 'UploadVideoField';
      muxPlaybackId: string;
      width: any;
      height: any;
    } | null;
  } | null;
};

export type LandingPageContentAreaFragment =
  | LandingPageContentArea_ArticlesBlockRecord_Fragment
  | LandingPageContentArea_BrandsBlockRecord_Fragment
  | LandingPageContentArea_BulletListRecord_Fragment
  | LandingPageContentArea_DocumentLinkBlockRecord_Fragment
  | LandingPageContentArea_EmployeeRecord_Fragment
  | LandingPageContentArea_GridContainerBlockRecord_Fragment
  | LandingPageContentArea_HeroBlockRecord_Fragment
  | LandingPageContentArea_ImageRecord_Fragment
  | LandingPageContentArea_JobsListBlockRecord_Fragment
  | LandingPageContentArea_NewsAndReportsListBlockRecord_Fragment
  | LandingPageContentArea_NewsListBlockRecord_Fragment
  | LandingPageContentArea_OfficesBlockRecord_Fragment
  | LandingPageContentArea_PlugBlockRecord_Fragment
  | LandingPageContentArea_SimpleTitleAndTextBlockRecord_Fragment
  | LandingPageContentArea_SliderBlockRecord_Fragment
  | LandingPageContentArea_StatementBlockRecord_Fragment
  | LandingPageContentArea_SubheadingBlockRecord_Fragment
  | LandingPageContentArea_SustainabilityReportsBlockRecord_Fragment
  | LandingPageContentArea_TextBlockRecord_Fragment
  | LandingPageContentArea_TwoColumnImageAndTextRecord_Fragment
  | LandingPageContentArea_TwoColumnTextIntroRecord_Fragment
  | LandingPageContentArea_VideoRecord_Fragment;

export type LandingPageContentFragment = {
  __typename?: 'LandingPageRecord';
  id: any;
  pageLocales: Array<SiteLocale>;
  seo?: {
    __typename?: 'SeoField';
    description?: string | null;
    title?: string | null;
    image?: {
      __typename?: 'FileField';
      url: string;
      alt?: string | null;
      title?: string | null;
    } | null;
  } | null;
  contentArea: Array<
    | {
        __typename?: 'ArticlesBlockRecord';
        id: any;
        title?: string | null;
        isJobArticles?: any | null;
        ctaText?: string | null;
        ctaUrl?: string | null;
        jobPages: Array<{
          __typename?: 'JobOpportunitiesPageRecord';
          id: any;
          slug?: string | null;
          title?: string | null;
          publishDate?: any | null;
          category?: string | null;
          country?: string | null;
          department?: string | null;
        }>;
        newsPages: Array<{
          __typename?: 'NewsPageRecord';
          id: any;
          slug?: string | null;
          title?: string | null;
          publishDate?: any | null;
          category?: string | null;
          country?: string | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
        }>;
        reportPages: Array<{
          __typename?: 'ReportsListingRecord';
          id: any;
          slug?: string | null;
          title?: string | null;
          publishDate?: any | null;
          category?: string | null;
          country?: string | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
          pdf?: {
            __typename?: 'FileField';
            alt?: string | null;
            filename: string;
            format: string;
            size: any;
            title?: string | null;
            url: string;
            uploadId: any;
          } | null;
        }>;
      }
    | {
        __typename?: 'BrandsBlockRecord';
        id: any;
        title?: string | null;
        introText?: string | null;
        hideLabels?: any | null;
        brands: Array<{
          __typename?: 'BrandPageRecord';
          id: any;
          brandName?: string | null;
          slug?: string | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            tags: Array<string>;
            title?: string | null;
            url: string;
            width?: any | null;
            height?: any | null;
            format: string;
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageLoad?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
        }>;
      }
    | {
        __typename?: 'BulletListRecord';
        id: any;
        bullets?: string | null;
        numberedList?: any | null;
        title?: string | null;
      }
    | {
        __typename?: 'DocumentLinkBlockRecord';
        id: any;
        documents: Array<{
          __typename?: 'FileField';
          alt?: string | null;
          filename: string;
          format: string;
          size: any;
          title?: string | null;
          url: string;
          uploadId: any;
        }>;
      }
    | {
        __typename?: 'EmployeeRecord';
        id: any;
        name?: string | null;
        title?: string | null;
        introText?: string | null;
        description?: string | null;
        image?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
      }
    | {
        __typename?: 'GridContainerBlockRecord';
        id: any;
        fullwidth?: any | null;
        gap?: any | null;
        backgroundColor?: { __typename?: 'ColorField'; hex: string } | null;
        textColor?: { __typename?: 'ColorField'; hex: string } | null;
        content: Array<
          | {
              __typename?: 'GridFourcolBlockRecord';
              id: any;
              content: Array<
                | {
                    __typename?: 'ImageRecord';
                    id: any;
                    fullWidth?: any | null;
                    image?: {
                      __typename?: 'FileField';
                      alt?: string | null;
                      responsiveImage?: {
                        __typename?: 'ResponsiveImage';
                        aspectRatio: any;
                        base64?: string | null;
                        bgColor?: string | null;
                        height: any;
                        sizes: string;
                        src: string;
                        srcSet: string;
                        webpSrcSet: string;
                        width: any;
                      } | null;
                    } | null;
                    imageLoad?: {
                      __typename?: 'FileField';
                      alt?: string | null;
                      title?: string | null;
                      url: string;
                      blurUpThumb?: string | null;
                      focalPoint?: {
                        __typename?: 'focalPoint';
                        x: any;
                        y: any;
                      } | null;
                      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
                    } | null;
                  }
                | {
                    __typename?: 'MediaWithCaptionRecord';
                    id: any;
                    centerText?: any | null;
                    textOnImage?: any | null;
                    media?: {
                      __typename?: 'ImageRecord';
                      id: any;
                      fullWidth?: any | null;
                      image?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        responsiveImage?: {
                          __typename?: 'ResponsiveImage';
                          aspectRatio: any;
                          base64?: string | null;
                          bgColor?: string | null;
                          height: any;
                          sizes: string;
                          src: string;
                          srcSet: string;
                          webpSrcSet: string;
                          width: any;
                        } | null;
                      } | null;
                      imageLoad?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        title?: string | null;
                        url: string;
                        blurUpThumb?: string | null;
                        focalPoint?: {
                          __typename?: 'focalPoint';
                          x: any;
                          y: any;
                        } | null;
                        colors: Array<{
                          __typename?: 'ColorField';
                          hex: string;
                        }>;
                      } | null;
                    } | null;
                    caption?: {
                      __typename?: 'TextBlockRecord';
                      id: any;
                      smallHeader?: any | null;
                      header?: string | null;
                      text?: string | null;
                      introText?: string | null;
                      ctaButtons: Array<{
                        __typename?: 'CtaButtonRecord';
                        id: any;
                        text?: string | null;
                        url?: string | null;
                        variant?: string | null;
                      }>;
                    } | null;
                  }
                | {
                    __typename?: 'TextBlockRecord';
                    id: any;
                    smallHeader?: any | null;
                    header?: string | null;
                    text?: string | null;
                    introText?: string | null;
                    ctaButtons: Array<{
                      __typename?: 'CtaButtonRecord';
                      id: any;
                      text?: string | null;
                      url?: string | null;
                      variant?: string | null;
                    }>;
                  }
              >;
            }
          | {
              __typename?: 'GridThreecolBlockRecord';
              id: any;
              content: Array<
                | {
                    __typename?: 'GridTwocolBlockRecord';
                    id: any;
                    content: Array<
                      | {
                          __typename?: 'ImageRecord';
                          id: any;
                          fullWidth?: any | null;
                          image?: {
                            __typename?: 'FileField';
                            alt?: string | null;
                            responsiveImage?: {
                              __typename?: 'ResponsiveImage';
                              aspectRatio: any;
                              base64?: string | null;
                              bgColor?: string | null;
                              height: any;
                              sizes: string;
                              src: string;
                              srcSet: string;
                              webpSrcSet: string;
                              width: any;
                            } | null;
                          } | null;
                          imageLoad?: {
                            __typename?: 'FileField';
                            alt?: string | null;
                            title?: string | null;
                            url: string;
                            blurUpThumb?: string | null;
                            focalPoint?: {
                              __typename?: 'focalPoint';
                              x: any;
                              y: any;
                            } | null;
                            colors: Array<{
                              __typename?: 'ColorField';
                              hex: string;
                            }>;
                          } | null;
                        }
                      | {
                          __typename?: 'MediaWithCaptionRecord';
                          id: any;
                          centerText?: any | null;
                          textOnImage?: any | null;
                          media?: {
                            __typename?: 'ImageRecord';
                            id: any;
                            fullWidth?: any | null;
                            image?: {
                              __typename?: 'FileField';
                              alt?: string | null;
                              responsiveImage?: {
                                __typename?: 'ResponsiveImage';
                                aspectRatio: any;
                                base64?: string | null;
                                bgColor?: string | null;
                                height: any;
                                sizes: string;
                                src: string;
                                srcSet: string;
                                webpSrcSet: string;
                                width: any;
                              } | null;
                            } | null;
                            imageLoad?: {
                              __typename?: 'FileField';
                              alt?: string | null;
                              title?: string | null;
                              url: string;
                              blurUpThumb?: string | null;
                              focalPoint?: {
                                __typename?: 'focalPoint';
                                x: any;
                                y: any;
                              } | null;
                              colors: Array<{
                                __typename?: 'ColorField';
                                hex: string;
                              }>;
                            } | null;
                          } | null;
                          caption?: {
                            __typename?: 'TextBlockRecord';
                            id: any;
                            smallHeader?: any | null;
                            header?: string | null;
                            text?: string | null;
                            introText?: string | null;
                            ctaButtons: Array<{
                              __typename?: 'CtaButtonRecord';
                              id: any;
                              text?: string | null;
                              url?: string | null;
                              variant?: string | null;
                            }>;
                          } | null;
                        }
                      | {
                          __typename?: 'NewsListBlockRecord';
                          id: any;
                          title?: string | null;
                          standalone?: any | null;
                          largeTitle?: any | null;
                          itemsToShow?: any | null;
                        }
                      | {
                          __typename?: 'ReportsListBlockRecord';
                          id: any;
                          title?: string | null;
                          standalone?: any | null;
                          largeTitle?: any | null;
                        }
                      | {
                          __typename?: 'TextBlockRecord';
                          id: any;
                          smallHeader?: any | null;
                          header?: string | null;
                          text?: string | null;
                          introText?: string | null;
                          ctaButtons: Array<{
                            __typename?: 'CtaButtonRecord';
                            id: any;
                            text?: string | null;
                            url?: string | null;
                            variant?: string | null;
                          }>;
                        }
                    >;
                  }
                | {
                    __typename?: 'ImageRecord';
                    id: any;
                    fullWidth?: any | null;
                    image?: {
                      __typename?: 'FileField';
                      alt?: string | null;
                      responsiveImage?: {
                        __typename?: 'ResponsiveImage';
                        aspectRatio: any;
                        base64?: string | null;
                        bgColor?: string | null;
                        height: any;
                        sizes: string;
                        src: string;
                        srcSet: string;
                        webpSrcSet: string;
                        width: any;
                      } | null;
                    } | null;
                    imageLoad?: {
                      __typename?: 'FileField';
                      alt?: string | null;
                      title?: string | null;
                      url: string;
                      blurUpThumb?: string | null;
                      focalPoint?: {
                        __typename?: 'focalPoint';
                        x: any;
                        y: any;
                      } | null;
                      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
                    } | null;
                  }
                | {
                    __typename?: 'MediaWithCaptionRecord';
                    id: any;
                    centerText?: any | null;
                    textOnImage?: any | null;
                    media?: {
                      __typename?: 'ImageRecord';
                      id: any;
                      fullWidth?: any | null;
                      image?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        responsiveImage?: {
                          __typename?: 'ResponsiveImage';
                          aspectRatio: any;
                          base64?: string | null;
                          bgColor?: string | null;
                          height: any;
                          sizes: string;
                          src: string;
                          srcSet: string;
                          webpSrcSet: string;
                          width: any;
                        } | null;
                      } | null;
                      imageLoad?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        title?: string | null;
                        url: string;
                        blurUpThumb?: string | null;
                        focalPoint?: {
                          __typename?: 'focalPoint';
                          x: any;
                          y: any;
                        } | null;
                        colors: Array<{
                          __typename?: 'ColorField';
                          hex: string;
                        }>;
                      } | null;
                    } | null;
                    caption?: {
                      __typename?: 'TextBlockRecord';
                      id: any;
                      smallHeader?: any | null;
                      header?: string | null;
                      text?: string | null;
                      introText?: string | null;
                      ctaButtons: Array<{
                        __typename?: 'CtaButtonRecord';
                        id: any;
                        text?: string | null;
                        url?: string | null;
                        variant?: string | null;
                      }>;
                    } | null;
                  }
                | {
                    __typename?: 'TextBlockRecord';
                    id: any;
                    smallHeader?: any | null;
                    header?: string | null;
                    text?: string | null;
                    introText?: string | null;
                    ctaButtons: Array<{
                      __typename?: 'CtaButtonRecord';
                      id: any;
                      text?: string | null;
                      url?: string | null;
                      variant?: string | null;
                    }>;
                  }
              >;
            }
          | {
              __typename?: 'GridTwocolBlockRecord';
              id: any;
              content: Array<
                | {
                    __typename?: 'ImageRecord';
                    id: any;
                    fullWidth?: any | null;
                    image?: {
                      __typename?: 'FileField';
                      alt?: string | null;
                      responsiveImage?: {
                        __typename?: 'ResponsiveImage';
                        aspectRatio: any;
                        base64?: string | null;
                        bgColor?: string | null;
                        height: any;
                        sizes: string;
                        src: string;
                        srcSet: string;
                        webpSrcSet: string;
                        width: any;
                      } | null;
                    } | null;
                    imageLoad?: {
                      __typename?: 'FileField';
                      alt?: string | null;
                      title?: string | null;
                      url: string;
                      blurUpThumb?: string | null;
                      focalPoint?: {
                        __typename?: 'focalPoint';
                        x: any;
                        y: any;
                      } | null;
                      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
                    } | null;
                  }
                | {
                    __typename?: 'MediaWithCaptionRecord';
                    id: any;
                    centerText?: any | null;
                    textOnImage?: any | null;
                    media?: {
                      __typename?: 'ImageRecord';
                      id: any;
                      fullWidth?: any | null;
                      image?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        responsiveImage?: {
                          __typename?: 'ResponsiveImage';
                          aspectRatio: any;
                          base64?: string | null;
                          bgColor?: string | null;
                          height: any;
                          sizes: string;
                          src: string;
                          srcSet: string;
                          webpSrcSet: string;
                          width: any;
                        } | null;
                      } | null;
                      imageLoad?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        title?: string | null;
                        url: string;
                        blurUpThumb?: string | null;
                        focalPoint?: {
                          __typename?: 'focalPoint';
                          x: any;
                          y: any;
                        } | null;
                        colors: Array<{
                          __typename?: 'ColorField';
                          hex: string;
                        }>;
                      } | null;
                    } | null;
                    caption?: {
                      __typename?: 'TextBlockRecord';
                      id: any;
                      smallHeader?: any | null;
                      header?: string | null;
                      text?: string | null;
                      introText?: string | null;
                      ctaButtons: Array<{
                        __typename?: 'CtaButtonRecord';
                        id: any;
                        text?: string | null;
                        url?: string | null;
                        variant?: string | null;
                      }>;
                    } | null;
                  }
                | {
                    __typename?: 'NewsListBlockRecord';
                    id: any;
                    title?: string | null;
                    standalone?: any | null;
                    largeTitle?: any | null;
                    itemsToShow?: any | null;
                  }
                | {
                    __typename?: 'ReportsListBlockRecord';
                    id: any;
                    title?: string | null;
                    standalone?: any | null;
                    largeTitle?: any | null;
                  }
                | {
                    __typename?: 'TextBlockRecord';
                    id: any;
                    smallHeader?: any | null;
                    header?: string | null;
                    text?: string | null;
                    introText?: string | null;
                    ctaButtons: Array<{
                      __typename?: 'CtaButtonRecord';
                      id: any;
                      text?: string | null;
                      url?: string | null;
                      variant?: string | null;
                    }>;
                  }
              >;
            }
        >;
      }
    | {
        __typename?: 'HeroBlockRecord';
        id: any;
        title?: string | null;
        description?: string | null;
        ctaText?: string | null;
        ctaUrl?: string | null;
        fullWidth?: any | null;
        boxColor?: { __typename?: 'ColorField'; hex: string } | null;
        textColor?: { __typename?: 'ColorField'; hex: string } | null;
        image?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
        imageOverlay?: {
          __typename?: 'OverlayRecord';
          id: any;
          opacity?: any | null;
          color?: { __typename?: 'ColorField'; hex: string } | null;
        } | null;
        ctaButtons: Array<{
          __typename?: 'CtaButtonRecord';
          id: any;
          text?: string | null;
          url?: string | null;
          variant?: string | null;
        }>;
        video?: {
          __typename?: 'FileField';
          blurUpThumb?: string | null;
          title?: string | null;
          alt?: string | null;
          video?: {
            __typename?: 'UploadVideoField';
            muxPlaybackId: string;
            width: any;
            height: any;
          } | null;
        } | null;
      }
    | {
        __typename?: 'ImageRecord';
        id: any;
        fullWidth?: any | null;
        image?: {
          __typename?: 'FileField';
          alt?: string | null;
          responsiveImage?: {
            __typename?: 'ResponsiveImage';
            aspectRatio: any;
            base64?: string | null;
            bgColor?: string | null;
            height: any;
            sizes: string;
            src: string;
            srcSet: string;
            webpSrcSet: string;
            width: any;
          } | null;
        } | null;
        imageLoad?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
      }
    | { __typename?: 'JobsListBlockRecord'; id: any; title?: string | null }
    | {
        __typename?: 'NewsAndReportsListBlockRecord';
        newsTitle?: string | null;
        reportsTitle?: string | null;
        newsImage?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
        news: Array<{
          __typename?: 'NewsPageRecord';
          id: any;
          title?: string | null;
          slug?: string | null;
          publishDate?: any | null;
          category?: string | null;
        }>;
        reportsImage?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
        reports: Array<{
          __typename?: 'ReportsListingRecord';
          id: any;
          title?: string | null;
          slug?: string | null;
          publishDate?: any | null;
          category?: string | null;
          pdf?: {
            __typename?: 'FileField';
            alt?: string | null;
            filename: string;
            format: string;
            size: any;
            title?: string | null;
            url: string;
            uploadId: any;
          } | null;
        }>;
      }
    | {
        __typename?: 'NewsListBlockRecord';
        id: any;
        title?: string | null;
        standalone?: any | null;
        largeTitle?: any | null;
        itemsToShow?: any | null;
      }
    | {
        __typename?: 'OfficesBlockRecord';
        id: any;
        offices: Array<{
          __typename?: 'OfficeRecord';
          id: any;
          name?: string | null;
          address?: string | null;
          zipCode?: string | null;
          city?: string | null;
          country?: string | null;
          email?: string | null;
          websiteUrl?: string | null;
          phoneNumber?: string | null;
        }>;
      }
    | {
        __typename?: 'PlugBlockRecord';
        id: any;
        title?: string | null;
        description?: string | null;
        brands: Array<{
          __typename?: 'BrandPageRecord';
          id: any;
          brandName?: string | null;
          slug?: string | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            tags: Array<string>;
            title?: string | null;
            url: string;
            width?: any | null;
            height?: any | null;
            format: string;
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageLoad?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
        }>;
      }
    | {
        __typename?: 'SimpleTitleAndTextBlockRecord';
        id: any;
        title?: string | null;
        topLabel?: string | null;
        description?: string | null;
      }
    | {
        __typename?: 'SliderBlockRecord';
        title?: string | null;
        arrows?: any | null;
        slideAnimation?: any | null;
        delay?: any | null;
        dots?: any | null;
        heroes: Array<{
          __typename?: 'HeroBlockRecord';
          id: any;
          title?: string | null;
          description?: string | null;
          ctaText?: string | null;
          ctaUrl?: string | null;
          fullWidth?: any | null;
          boxColor?: { __typename?: 'ColorField'; hex: string } | null;
          textColor?: { __typename?: 'ColorField'; hex: string } | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
          imageOverlay?: {
            __typename?: 'OverlayRecord';
            id: any;
            opacity?: any | null;
            color?: { __typename?: 'ColorField'; hex: string } | null;
          } | null;
          ctaButtons: Array<{
            __typename?: 'CtaButtonRecord';
            id: any;
            text?: string | null;
            url?: string | null;
            variant?: string | null;
          }>;
          video?: {
            __typename?: 'FileField';
            blurUpThumb?: string | null;
            title?: string | null;
            alt?: string | null;
            video?: {
              __typename?: 'UploadVideoField';
              muxPlaybackId: string;
              width: any;
              height: any;
            } | null;
          } | null;
        }>;
      }
    | {
        __typename?: 'StatementBlockRecord';
        id: any;
        text?: string | null;
        blackBackground?: any | null;
        header?: string | null;
        small?: any | null;
        linkText?: string | null;
        linkUrl?: string | null;
        imageMobile?: {
          __typename?: 'FileField';
          responsiveImage?: {
            __typename?: 'ResponsiveImage';
            aspectRatio: any;
            base64?: string | null;
            bgColor?: string | null;
            height: any;
            sizes: string;
            src: string;
            srcSet: string;
            webpSrcSet: string;
            width: any;
          } | null;
        } | null;
        imageTablet?: {
          __typename?: 'FileField';
          alt?: string | null;
          responsiveImage?: {
            __typename?: 'ResponsiveImage';
            aspectRatio: any;
            base64?: string | null;
            bgColor?: string | null;
            height: any;
            sizes: string;
            src: string;
            srcSet: string;
            webpSrcSet: string;
            width: any;
          } | null;
        } | null;
        imageDesktop?: {
          __typename?: 'FileField';
          responsiveImage?: {
            __typename?: 'ResponsiveImage';
            aspectRatio: any;
            base64?: string | null;
            bgColor?: string | null;
            height: any;
            sizes: string;
            src: string;
            srcSet: string;
            webpSrcSet: string;
            width: any;
          } | null;
        } | null;
        imageLoad?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
        imageOverlay?: {
          __typename?: 'OverlayRecord';
          id: any;
          opacity?: any | null;
          color?: { __typename?: 'ColorField'; hex: string } | null;
        } | null;
      }
    | {
        __typename?: 'SubheadingBlockRecord';
        id: any;
        title?: string | null;
        text?: string | null;
        ctaButton?: {
          __typename?: 'CtaButtonRecord';
          id: any;
          text?: string | null;
          url?: string | null;
          variant?: string | null;
        } | null;
        backgroundColor?: { __typename?: 'ColorField'; hex: string } | null;
      }
    | {
        __typename?: 'SustainabilityReportsBlockRecord';
        id: any;
        title?: string | null;
        reports: Array<{
          __typename?: 'FileField';
          alt?: string | null;
          filename: string;
          format: string;
          size: any;
          title?: string | null;
          url: string;
          uploadId: any;
        }>;
      }
    | {
        __typename?: 'TextBlockRecord';
        id: any;
        smallHeader?: any | null;
        header?: string | null;
        text?: string | null;
        introText?: string | null;
        ctaButtons: Array<{
          __typename?: 'CtaButtonRecord';
          id: any;
          text?: string | null;
          url?: string | null;
          variant?: string | null;
        }>;
      }
    | {
        __typename?: 'TwoColumnImageAndTextRecord';
        id: any;
        text?: string | null;
        title?: string | null;
        reverse?: any | null;
        image?: {
          __typename?: 'FileField';
          alt?: string | null;
          responsiveImage?: {
            __typename?: 'ResponsiveImage';
            aspectRatio: any;
            base64?: string | null;
            bgColor?: string | null;
            height: any;
            sizes: string;
            src: string;
            srcSet: string;
            webpSrcSet: string;
            width: any;
          } | null;
        } | null;
        imageLoad?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
      }
    | {
        __typename?: 'TwoColumnTextIntroRecord';
        id: any;
        introText?: string | null;
        text?: string | null;
        header?: string | null;
      }
    | {
        __typename?: 'VideoRecord';
        id: any;
        autoplay?: any | null;
        video?: {
          __typename?: 'FileField';
          title?: string | null;
          video?: {
            __typename?: 'UploadVideoField';
            mp4Url?: string | null;
            streamingUrl: string;
            thumbnailUrl: string;
            mp4Low?: string | null;
          } | null;
        } | null;
        videoThumbnail?: {
          __typename?: 'FileField';
          alt?: string | null;
          tags: Array<string>;
          title?: string | null;
          url: string;
          width?: any | null;
          height?: any | null;
          format: string;
          responsiveImage?: {
            __typename?: 'ResponsiveImage';
            aspectRatio: any;
            base64?: string | null;
            bgColor?: string | null;
            height: any;
            sizes: string;
            src: string;
            srcSet: string;
            webpSrcSet: string;
            width: any;
          } | null;
        } | null;
        muxVideo?: {
          __typename?: 'FileField';
          blurUpThumb?: string | null;
          title?: string | null;
          alt?: string | null;
          video?: {
            __typename?: 'UploadVideoField';
            muxPlaybackId: string;
            width: any;
            height: any;
          } | null;
        } | null;
      }
  >;
};

type NewsListPageContentArea_ArticlesBlockRecord_Fragment = {
  __typename?: 'ArticlesBlockRecord';
  id: any;
  title?: string | null;
  isJobArticles?: any | null;
  ctaText?: string | null;
  ctaUrl?: string | null;
  jobPages: Array<{
    __typename?: 'JobOpportunitiesPageRecord';
    id: any;
    slug?: string | null;
    title?: string | null;
    publishDate?: any | null;
    category?: string | null;
    country?: string | null;
    department?: string | null;
  }>;
  newsPages: Array<{
    __typename?: 'NewsPageRecord';
    id: any;
    slug?: string | null;
    title?: string | null;
    publishDate?: any | null;
    category?: string | null;
    country?: string | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
  }>;
  reportPages: Array<{
    __typename?: 'ReportsListingRecord';
    id: any;
    slug?: string | null;
    title?: string | null;
    publishDate?: any | null;
    category?: string | null;
    country?: string | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
    pdf?: {
      __typename?: 'FileField';
      alt?: string | null;
      filename: string;
      format: string;
      size: any;
      title?: string | null;
      url: string;
      uploadId: any;
    } | null;
  }>;
};

type NewsListPageContentArea_BrandsBlockRecord_Fragment = {
  __typename?: 'BrandsBlockRecord';
  id: any;
  title?: string | null;
  introText?: string | null;
  hideLabels?: any | null;
  brands: Array<{
    __typename?: 'BrandPageRecord';
    id: any;
    brandName?: string | null;
    slug?: string | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      tags: Array<string>;
      title?: string | null;
      url: string;
      width?: any | null;
      height?: any | null;
      format: string;
      responsiveImage?: {
        __typename?: 'ResponsiveImage';
        aspectRatio: any;
        base64?: string | null;
        bgColor?: string | null;
        height: any;
        sizes: string;
        src: string;
        srcSet: string;
        webpSrcSet: string;
        width: any;
      } | null;
    } | null;
    imageLoad?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
  }>;
};

type NewsListPageContentArea_BulletListRecord_Fragment = {
  __typename?: 'BulletListRecord';
  id: any;
  bullets?: string | null;
  numberedList?: any | null;
  title?: string | null;
};

type NewsListPageContentArea_DocumentLinkBlockRecord_Fragment = {
  __typename?: 'DocumentLinkBlockRecord';
  id: any;
  documents: Array<{
    __typename?: 'FileField';
    alt?: string | null;
    filename: string;
    format: string;
    size: any;
    title?: string | null;
    url: string;
    uploadId: any;
  }>;
};

type NewsListPageContentArea_EmployeeRecord_Fragment = {
  __typename?: 'EmployeeRecord';
  id: any;
  name?: string | null;
  title?: string | null;
  introText?: string | null;
  description?: string | null;
  image?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
};

type NewsListPageContentArea_HeroBlockRecord_Fragment = {
  __typename?: 'HeroBlockRecord';
  id: any;
  title?: string | null;
  description?: string | null;
  ctaText?: string | null;
  ctaUrl?: string | null;
  fullWidth?: any | null;
  boxColor?: { __typename?: 'ColorField'; hex: string } | null;
  textColor?: { __typename?: 'ColorField'; hex: string } | null;
  image?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
  imageOverlay?: {
    __typename?: 'OverlayRecord';
    id: any;
    opacity?: any | null;
    color?: { __typename?: 'ColorField'; hex: string } | null;
  } | null;
  ctaButtons: Array<{
    __typename?: 'CtaButtonRecord';
    id: any;
    text?: string | null;
    url?: string | null;
    variant?: string | null;
  }>;
  video?: {
    __typename?: 'FileField';
    blurUpThumb?: string | null;
    title?: string | null;
    alt?: string | null;
    video?: {
      __typename?: 'UploadVideoField';
      muxPlaybackId: string;
      width: any;
      height: any;
    } | null;
  } | null;
};

type NewsListPageContentArea_ImageRecord_Fragment = {
  __typename?: 'ImageRecord';
  id: any;
  fullWidth?: any | null;
  image?: {
    __typename?: 'FileField';
    alt?: string | null;
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  imageLoad?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
};

type NewsListPageContentArea_JobsListBlockRecord_Fragment = {
  __typename?: 'JobsListBlockRecord';
  id: any;
  title?: string | null;
};

type NewsListPageContentArea_NewsAndReportsListBlockRecord_Fragment = {
  __typename?: 'NewsAndReportsListBlockRecord';
  newsTitle?: string | null;
  reportsTitle?: string | null;
  newsImage?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
  news: Array<{
    __typename?: 'NewsPageRecord';
    id: any;
    title?: string | null;
    slug?: string | null;
    publishDate?: any | null;
    category?: string | null;
  }>;
  reportsImage?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
  reports: Array<{
    __typename?: 'ReportsListingRecord';
    id: any;
    title?: string | null;
    slug?: string | null;
    publishDate?: any | null;
    category?: string | null;
    pdf?: {
      __typename?: 'FileField';
      alt?: string | null;
      filename: string;
      format: string;
      size: any;
      title?: string | null;
      url: string;
      uploadId: any;
    } | null;
  }>;
};

type NewsListPageContentArea_NewsListBlockRecord_Fragment = {
  __typename?: 'NewsListBlockRecord';
  id: any;
  title?: string | null;
  standalone?: any | null;
  largeTitle?: any | null;
  itemsToShow?: any | null;
};

type NewsListPageContentArea_OfficesBlockRecord_Fragment = {
  __typename?: 'OfficesBlockRecord';
  id: any;
  offices: Array<{
    __typename?: 'OfficeRecord';
    id: any;
    name?: string | null;
    address?: string | null;
    zipCode?: string | null;
    city?: string | null;
    country?: string | null;
    email?: string | null;
    websiteUrl?: string | null;
    phoneNumber?: string | null;
  }>;
};

type NewsListPageContentArea_PlugBlockRecord_Fragment = {
  __typename?: 'PlugBlockRecord';
  id: any;
  title?: string | null;
  description?: string | null;
  brands: Array<{
    __typename?: 'BrandPageRecord';
    id: any;
    brandName?: string | null;
    slug?: string | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      tags: Array<string>;
      title?: string | null;
      url: string;
      width?: any | null;
      height?: any | null;
      format: string;
      responsiveImage?: {
        __typename?: 'ResponsiveImage';
        aspectRatio: any;
        base64?: string | null;
        bgColor?: string | null;
        height: any;
        sizes: string;
        src: string;
        srcSet: string;
        webpSrcSet: string;
        width: any;
      } | null;
    } | null;
    imageLoad?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
  }>;
};

type NewsListPageContentArea_SimpleTitleAndTextBlockRecord_Fragment = {
  __typename?: 'SimpleTitleAndTextBlockRecord';
  id: any;
  title?: string | null;
  topLabel?: string | null;
  description?: string | null;
};

type NewsListPageContentArea_SliderBlockRecord_Fragment = {
  __typename?: 'SliderBlockRecord';
  title?: string | null;
  arrows?: any | null;
  slideAnimation?: any | null;
  delay?: any | null;
  dots?: any | null;
  heroes: Array<{
    __typename?: 'HeroBlockRecord';
    id: any;
    title?: string | null;
    description?: string | null;
    ctaText?: string | null;
    ctaUrl?: string | null;
    fullWidth?: any | null;
    boxColor?: { __typename?: 'ColorField'; hex: string } | null;
    textColor?: { __typename?: 'ColorField'; hex: string } | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
    imageOverlay?: {
      __typename?: 'OverlayRecord';
      id: any;
      opacity?: any | null;
      color?: { __typename?: 'ColorField'; hex: string } | null;
    } | null;
    ctaButtons: Array<{
      __typename?: 'CtaButtonRecord';
      id: any;
      text?: string | null;
      url?: string | null;
      variant?: string | null;
    }>;
    video?: {
      __typename?: 'FileField';
      blurUpThumb?: string | null;
      title?: string | null;
      alt?: string | null;
      video?: {
        __typename?: 'UploadVideoField';
        muxPlaybackId: string;
        width: any;
        height: any;
      } | null;
    } | null;
  }>;
};

type NewsListPageContentArea_StatementBlockRecord_Fragment = {
  __typename?: 'StatementBlockRecord';
  id: any;
  text?: string | null;
  blackBackground?: any | null;
  header?: string | null;
  small?: any | null;
  linkText?: string | null;
  linkUrl?: string | null;
  imageMobile?: {
    __typename?: 'FileField';
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  imageTablet?: {
    __typename?: 'FileField';
    alt?: string | null;
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  imageDesktop?: {
    __typename?: 'FileField';
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  imageLoad?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
  imageOverlay?: {
    __typename?: 'OverlayRecord';
    id: any;
    opacity?: any | null;
    color?: { __typename?: 'ColorField'; hex: string } | null;
  } | null;
};

type NewsListPageContentArea_TextBlockRecord_Fragment = {
  __typename?: 'TextBlockRecord';
  id: any;
  smallHeader?: any | null;
  header?: string | null;
  text?: string | null;
  introText?: string | null;
  ctaButtons: Array<{
    __typename?: 'CtaButtonRecord';
    id: any;
    text?: string | null;
    url?: string | null;
    variant?: string | null;
  }>;
};

type NewsListPageContentArea_TwoColumnImageAndTextRecord_Fragment = {
  __typename?: 'TwoColumnImageAndTextRecord';
  id: any;
  text?: string | null;
  title?: string | null;
  reverse?: any | null;
  image?: {
    __typename?: 'FileField';
    alt?: string | null;
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  imageLoad?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
};

type NewsListPageContentArea_TwoColumnTextIntroRecord_Fragment = {
  __typename?: 'TwoColumnTextIntroRecord';
  id: any;
  introText?: string | null;
  text?: string | null;
  header?: string | null;
};

type NewsListPageContentArea_VideoRecord_Fragment = {
  __typename?: 'VideoRecord';
  id: any;
  autoplay?: any | null;
  video?: {
    __typename?: 'FileField';
    title?: string | null;
    video?: {
      __typename?: 'UploadVideoField';
      mp4Url?: string | null;
      streamingUrl: string;
      thumbnailUrl: string;
      mp4Low?: string | null;
    } | null;
  } | null;
  videoThumbnail?: {
    __typename?: 'FileField';
    alt?: string | null;
    tags: Array<string>;
    title?: string | null;
    url: string;
    width?: any | null;
    height?: any | null;
    format: string;
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  muxVideo?: {
    __typename?: 'FileField';
    blurUpThumb?: string | null;
    title?: string | null;
    alt?: string | null;
    video?: {
      __typename?: 'UploadVideoField';
      muxPlaybackId: string;
      width: any;
      height: any;
    } | null;
  } | null;
};

export type NewsListPageContentAreaFragment =
  | NewsListPageContentArea_ArticlesBlockRecord_Fragment
  | NewsListPageContentArea_BrandsBlockRecord_Fragment
  | NewsListPageContentArea_BulletListRecord_Fragment
  | NewsListPageContentArea_DocumentLinkBlockRecord_Fragment
  | NewsListPageContentArea_EmployeeRecord_Fragment
  | NewsListPageContentArea_HeroBlockRecord_Fragment
  | NewsListPageContentArea_ImageRecord_Fragment
  | NewsListPageContentArea_JobsListBlockRecord_Fragment
  | NewsListPageContentArea_NewsAndReportsListBlockRecord_Fragment
  | NewsListPageContentArea_NewsListBlockRecord_Fragment
  | NewsListPageContentArea_OfficesBlockRecord_Fragment
  | NewsListPageContentArea_PlugBlockRecord_Fragment
  | NewsListPageContentArea_SimpleTitleAndTextBlockRecord_Fragment
  | NewsListPageContentArea_SliderBlockRecord_Fragment
  | NewsListPageContentArea_StatementBlockRecord_Fragment
  | NewsListPageContentArea_TextBlockRecord_Fragment
  | NewsListPageContentArea_TwoColumnImageAndTextRecord_Fragment
  | NewsListPageContentArea_TwoColumnTextIntroRecord_Fragment
  | NewsListPageContentArea_VideoRecord_Fragment;

export type NewsListPageContentFragment = {
  __typename?: 'NewsListPageRecord';
  id: any;
  pageLocales: Array<SiteLocale>;
  seo?: {
    __typename?: 'SeoField';
    description?: string | null;
    title?: string | null;
    image?: {
      __typename?: 'FileField';
      url: string;
      alt?: string | null;
      title?: string | null;
    } | null;
  } | null;
  contentArea: Array<
    | {
        __typename?: 'ArticlesBlockRecord';
        id: any;
        title?: string | null;
        isJobArticles?: any | null;
        ctaText?: string | null;
        ctaUrl?: string | null;
        jobPages: Array<{
          __typename?: 'JobOpportunitiesPageRecord';
          id: any;
          slug?: string | null;
          title?: string | null;
          publishDate?: any | null;
          category?: string | null;
          country?: string | null;
          department?: string | null;
        }>;
        newsPages: Array<{
          __typename?: 'NewsPageRecord';
          id: any;
          slug?: string | null;
          title?: string | null;
          publishDate?: any | null;
          category?: string | null;
          country?: string | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
        }>;
        reportPages: Array<{
          __typename?: 'ReportsListingRecord';
          id: any;
          slug?: string | null;
          title?: string | null;
          publishDate?: any | null;
          category?: string | null;
          country?: string | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
          pdf?: {
            __typename?: 'FileField';
            alt?: string | null;
            filename: string;
            format: string;
            size: any;
            title?: string | null;
            url: string;
            uploadId: any;
          } | null;
        }>;
      }
    | {
        __typename?: 'BrandsBlockRecord';
        id: any;
        title?: string | null;
        introText?: string | null;
        hideLabels?: any | null;
        brands: Array<{
          __typename?: 'BrandPageRecord';
          id: any;
          brandName?: string | null;
          slug?: string | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            tags: Array<string>;
            title?: string | null;
            url: string;
            width?: any | null;
            height?: any | null;
            format: string;
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageLoad?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
        }>;
      }
    | {
        __typename?: 'BulletListRecord';
        id: any;
        bullets?: string | null;
        numberedList?: any | null;
        title?: string | null;
      }
    | {
        __typename?: 'DocumentLinkBlockRecord';
        id: any;
        documents: Array<{
          __typename?: 'FileField';
          alt?: string | null;
          filename: string;
          format: string;
          size: any;
          title?: string | null;
          url: string;
          uploadId: any;
        }>;
      }
    | {
        __typename?: 'EmployeeRecord';
        id: any;
        name?: string | null;
        title?: string | null;
        introText?: string | null;
        description?: string | null;
        image?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
      }
    | {
        __typename?: 'HeroBlockRecord';
        id: any;
        title?: string | null;
        description?: string | null;
        ctaText?: string | null;
        ctaUrl?: string | null;
        fullWidth?: any | null;
        boxColor?: { __typename?: 'ColorField'; hex: string } | null;
        textColor?: { __typename?: 'ColorField'; hex: string } | null;
        image?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
        imageOverlay?: {
          __typename?: 'OverlayRecord';
          id: any;
          opacity?: any | null;
          color?: { __typename?: 'ColorField'; hex: string } | null;
        } | null;
        ctaButtons: Array<{
          __typename?: 'CtaButtonRecord';
          id: any;
          text?: string | null;
          url?: string | null;
          variant?: string | null;
        }>;
        video?: {
          __typename?: 'FileField';
          blurUpThumb?: string | null;
          title?: string | null;
          alt?: string | null;
          video?: {
            __typename?: 'UploadVideoField';
            muxPlaybackId: string;
            width: any;
            height: any;
          } | null;
        } | null;
      }
    | {
        __typename?: 'ImageRecord';
        id: any;
        fullWidth?: any | null;
        image?: {
          __typename?: 'FileField';
          alt?: string | null;
          responsiveImage?: {
            __typename?: 'ResponsiveImage';
            aspectRatio: any;
            base64?: string | null;
            bgColor?: string | null;
            height: any;
            sizes: string;
            src: string;
            srcSet: string;
            webpSrcSet: string;
            width: any;
          } | null;
        } | null;
        imageLoad?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
      }
    | { __typename?: 'JobsListBlockRecord'; id: any; title?: string | null }
    | {
        __typename?: 'NewsAndReportsListBlockRecord';
        newsTitle?: string | null;
        reportsTitle?: string | null;
        newsImage?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
        news: Array<{
          __typename?: 'NewsPageRecord';
          id: any;
          title?: string | null;
          slug?: string | null;
          publishDate?: any | null;
          category?: string | null;
        }>;
        reportsImage?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
        reports: Array<{
          __typename?: 'ReportsListingRecord';
          id: any;
          title?: string | null;
          slug?: string | null;
          publishDate?: any | null;
          category?: string | null;
          pdf?: {
            __typename?: 'FileField';
            alt?: string | null;
            filename: string;
            format: string;
            size: any;
            title?: string | null;
            url: string;
            uploadId: any;
          } | null;
        }>;
      }
    | {
        __typename?: 'NewsListBlockRecord';
        id: any;
        title?: string | null;
        standalone?: any | null;
        largeTitle?: any | null;
        itemsToShow?: any | null;
      }
    | {
        __typename?: 'OfficesBlockRecord';
        id: any;
        offices: Array<{
          __typename?: 'OfficeRecord';
          id: any;
          name?: string | null;
          address?: string | null;
          zipCode?: string | null;
          city?: string | null;
          country?: string | null;
          email?: string | null;
          websiteUrl?: string | null;
          phoneNumber?: string | null;
        }>;
      }
    | {
        __typename?: 'PlugBlockRecord';
        id: any;
        title?: string | null;
        description?: string | null;
        brands: Array<{
          __typename?: 'BrandPageRecord';
          id: any;
          brandName?: string | null;
          slug?: string | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            tags: Array<string>;
            title?: string | null;
            url: string;
            width?: any | null;
            height?: any | null;
            format: string;
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageLoad?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
        }>;
      }
    | {
        __typename?: 'SimpleTitleAndTextBlockRecord';
        id: any;
        title?: string | null;
        topLabel?: string | null;
        description?: string | null;
      }
    | {
        __typename?: 'SliderBlockRecord';
        title?: string | null;
        arrows?: any | null;
        slideAnimation?: any | null;
        delay?: any | null;
        dots?: any | null;
        heroes: Array<{
          __typename?: 'HeroBlockRecord';
          id: any;
          title?: string | null;
          description?: string | null;
          ctaText?: string | null;
          ctaUrl?: string | null;
          fullWidth?: any | null;
          boxColor?: { __typename?: 'ColorField'; hex: string } | null;
          textColor?: { __typename?: 'ColorField'; hex: string } | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
          imageOverlay?: {
            __typename?: 'OverlayRecord';
            id: any;
            opacity?: any | null;
            color?: { __typename?: 'ColorField'; hex: string } | null;
          } | null;
          ctaButtons: Array<{
            __typename?: 'CtaButtonRecord';
            id: any;
            text?: string | null;
            url?: string | null;
            variant?: string | null;
          }>;
          video?: {
            __typename?: 'FileField';
            blurUpThumb?: string | null;
            title?: string | null;
            alt?: string | null;
            video?: {
              __typename?: 'UploadVideoField';
              muxPlaybackId: string;
              width: any;
              height: any;
            } | null;
          } | null;
        }>;
      }
    | {
        __typename?: 'StatementBlockRecord';
        id: any;
        text?: string | null;
        blackBackground?: any | null;
        header?: string | null;
        small?: any | null;
        linkText?: string | null;
        linkUrl?: string | null;
        imageMobile?: {
          __typename?: 'FileField';
          responsiveImage?: {
            __typename?: 'ResponsiveImage';
            aspectRatio: any;
            base64?: string | null;
            bgColor?: string | null;
            height: any;
            sizes: string;
            src: string;
            srcSet: string;
            webpSrcSet: string;
            width: any;
          } | null;
        } | null;
        imageTablet?: {
          __typename?: 'FileField';
          alt?: string | null;
          responsiveImage?: {
            __typename?: 'ResponsiveImage';
            aspectRatio: any;
            base64?: string | null;
            bgColor?: string | null;
            height: any;
            sizes: string;
            src: string;
            srcSet: string;
            webpSrcSet: string;
            width: any;
          } | null;
        } | null;
        imageDesktop?: {
          __typename?: 'FileField';
          responsiveImage?: {
            __typename?: 'ResponsiveImage';
            aspectRatio: any;
            base64?: string | null;
            bgColor?: string | null;
            height: any;
            sizes: string;
            src: string;
            srcSet: string;
            webpSrcSet: string;
            width: any;
          } | null;
        } | null;
        imageLoad?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
        imageOverlay?: {
          __typename?: 'OverlayRecord';
          id: any;
          opacity?: any | null;
          color?: { __typename?: 'ColorField'; hex: string } | null;
        } | null;
      }
    | {
        __typename?: 'TextBlockRecord';
        id: any;
        smallHeader?: any | null;
        header?: string | null;
        text?: string | null;
        introText?: string | null;
        ctaButtons: Array<{
          __typename?: 'CtaButtonRecord';
          id: any;
          text?: string | null;
          url?: string | null;
          variant?: string | null;
        }>;
      }
    | {
        __typename?: 'TwoColumnImageAndTextRecord';
        id: any;
        text?: string | null;
        title?: string | null;
        reverse?: any | null;
        image?: {
          __typename?: 'FileField';
          alt?: string | null;
          responsiveImage?: {
            __typename?: 'ResponsiveImage';
            aspectRatio: any;
            base64?: string | null;
            bgColor?: string | null;
            height: any;
            sizes: string;
            src: string;
            srcSet: string;
            webpSrcSet: string;
            width: any;
          } | null;
        } | null;
        imageLoad?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
      }
    | {
        __typename?: 'TwoColumnTextIntroRecord';
        id: any;
        introText?: string | null;
        text?: string | null;
        header?: string | null;
      }
    | {
        __typename?: 'VideoRecord';
        id: any;
        autoplay?: any | null;
        video?: {
          __typename?: 'FileField';
          title?: string | null;
          video?: {
            __typename?: 'UploadVideoField';
            mp4Url?: string | null;
            streamingUrl: string;
            thumbnailUrl: string;
            mp4Low?: string | null;
          } | null;
        } | null;
        videoThumbnail?: {
          __typename?: 'FileField';
          alt?: string | null;
          tags: Array<string>;
          title?: string | null;
          url: string;
          width?: any | null;
          height?: any | null;
          format: string;
          responsiveImage?: {
            __typename?: 'ResponsiveImage';
            aspectRatio: any;
            base64?: string | null;
            bgColor?: string | null;
            height: any;
            sizes: string;
            src: string;
            srcSet: string;
            webpSrcSet: string;
            width: any;
          } | null;
        } | null;
        muxVideo?: {
          __typename?: 'FileField';
          blurUpThumb?: string | null;
          title?: string | null;
          alt?: string | null;
          video?: {
            __typename?: 'UploadVideoField';
            muxPlaybackId: string;
            width: any;
            height: any;
          } | null;
        } | null;
      }
  >;
};

type NewsPageContentArea_ArticlesBlockRecord_Fragment = {
  __typename?: 'ArticlesBlockRecord';
  id: any;
  title?: string | null;
  isJobArticles?: any | null;
  ctaText?: string | null;
  ctaUrl?: string | null;
  jobPages: Array<{
    __typename?: 'JobOpportunitiesPageRecord';
    id: any;
    slug?: string | null;
    title?: string | null;
    publishDate?: any | null;
    category?: string | null;
    country?: string | null;
    department?: string | null;
  }>;
  newsPages: Array<{
    __typename?: 'NewsPageRecord';
    id: any;
    slug?: string | null;
    title?: string | null;
    publishDate?: any | null;
    category?: string | null;
    country?: string | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
  }>;
  reportPages: Array<{
    __typename?: 'ReportsListingRecord';
    id: any;
    slug?: string | null;
    title?: string | null;
    publishDate?: any | null;
    category?: string | null;
    country?: string | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
    pdf?: {
      __typename?: 'FileField';
      alt?: string | null;
      filename: string;
      format: string;
      size: any;
      title?: string | null;
      url: string;
      uploadId: any;
    } | null;
  }>;
};

type NewsPageContentArea_BrandsBlockRecord_Fragment = {
  __typename?: 'BrandsBlockRecord';
  id: any;
  title?: string | null;
  introText?: string | null;
  hideLabels?: any | null;
  brands: Array<{
    __typename?: 'BrandPageRecord';
    id: any;
    brandName?: string | null;
    slug?: string | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      tags: Array<string>;
      title?: string | null;
      url: string;
      width?: any | null;
      height?: any | null;
      format: string;
      responsiveImage?: {
        __typename?: 'ResponsiveImage';
        aspectRatio: any;
        base64?: string | null;
        bgColor?: string | null;
        height: any;
        sizes: string;
        src: string;
        srcSet: string;
        webpSrcSet: string;
        width: any;
      } | null;
    } | null;
    imageLoad?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
  }>;
};

type NewsPageContentArea_BulletListRecord_Fragment = {
  __typename?: 'BulletListRecord';
  id: any;
  bullets?: string | null;
  numberedList?: any | null;
  title?: string | null;
};

type NewsPageContentArea_DocumentLinkBlockRecord_Fragment = {
  __typename?: 'DocumentLinkBlockRecord';
  id: any;
  documents: Array<{
    __typename?: 'FileField';
    alt?: string | null;
    filename: string;
    format: string;
    size: any;
    title?: string | null;
    url: string;
    uploadId: any;
  }>;
};

type NewsPageContentArea_EmployeeRecord_Fragment = {
  __typename?: 'EmployeeRecord';
  id: any;
  name?: string | null;
  title?: string | null;
  introText?: string | null;
  description?: string | null;
  image?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
};

type NewsPageContentArea_HeroBlockRecord_Fragment = {
  __typename?: 'HeroBlockRecord';
  id: any;
  title?: string | null;
  description?: string | null;
  ctaText?: string | null;
  ctaUrl?: string | null;
  fullWidth?: any | null;
  boxColor?: { __typename?: 'ColorField'; hex: string } | null;
  textColor?: { __typename?: 'ColorField'; hex: string } | null;
  image?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
  imageOverlay?: {
    __typename?: 'OverlayRecord';
    id: any;
    opacity?: any | null;
    color?: { __typename?: 'ColorField'; hex: string } | null;
  } | null;
  ctaButtons: Array<{
    __typename?: 'CtaButtonRecord';
    id: any;
    text?: string | null;
    url?: string | null;
    variant?: string | null;
  }>;
  video?: {
    __typename?: 'FileField';
    blurUpThumb?: string | null;
    title?: string | null;
    alt?: string | null;
    video?: {
      __typename?: 'UploadVideoField';
      muxPlaybackId: string;
      width: any;
      height: any;
    } | null;
  } | null;
};

type NewsPageContentArea_ImageRecord_Fragment = {
  __typename?: 'ImageRecord';
  id: any;
  fullWidth?: any | null;
  image?: {
    __typename?: 'FileField';
    alt?: string | null;
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  imageLoad?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
};

type NewsPageContentArea_JobsListBlockRecord_Fragment = {
  __typename?: 'JobsListBlockRecord';
  id: any;
  title?: string | null;
};

type NewsPageContentArea_NewsAndReportsListBlockRecord_Fragment = {
  __typename?: 'NewsAndReportsListBlockRecord';
  newsTitle?: string | null;
  reportsTitle?: string | null;
  newsImage?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
  news: Array<{
    __typename?: 'NewsPageRecord';
    id: any;
    title?: string | null;
    slug?: string | null;
    publishDate?: any | null;
    category?: string | null;
  }>;
  reportsImage?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
  reports: Array<{
    __typename?: 'ReportsListingRecord';
    id: any;
    title?: string | null;
    slug?: string | null;
    publishDate?: any | null;
    category?: string | null;
    pdf?: {
      __typename?: 'FileField';
      alt?: string | null;
      filename: string;
      format: string;
      size: any;
      title?: string | null;
      url: string;
      uploadId: any;
    } | null;
  }>;
};

type NewsPageContentArea_NewsListBlockRecord_Fragment = {
  __typename?: 'NewsListBlockRecord';
  id: any;
  title?: string | null;
  standalone?: any | null;
  largeTitle?: any | null;
  itemsToShow?: any | null;
};

type NewsPageContentArea_OfficesBlockRecord_Fragment = {
  __typename?: 'OfficesBlockRecord';
  id: any;
  offices: Array<{
    __typename?: 'OfficeRecord';
    id: any;
    name?: string | null;
    address?: string | null;
    zipCode?: string | null;
    city?: string | null;
    country?: string | null;
    email?: string | null;
    websiteUrl?: string | null;
    phoneNumber?: string | null;
  }>;
};

type NewsPageContentArea_PlugBlockRecord_Fragment = {
  __typename?: 'PlugBlockRecord';
  id: any;
  title?: string | null;
  description?: string | null;
  brands: Array<{
    __typename?: 'BrandPageRecord';
    id: any;
    brandName?: string | null;
    slug?: string | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      tags: Array<string>;
      title?: string | null;
      url: string;
      width?: any | null;
      height?: any | null;
      format: string;
      responsiveImage?: {
        __typename?: 'ResponsiveImage';
        aspectRatio: any;
        base64?: string | null;
        bgColor?: string | null;
        height: any;
        sizes: string;
        src: string;
        srcSet: string;
        webpSrcSet: string;
        width: any;
      } | null;
    } | null;
    imageLoad?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
  }>;
};

type NewsPageContentArea_SimpleTitleAndTextBlockRecord_Fragment = {
  __typename?: 'SimpleTitleAndTextBlockRecord';
  id: any;
  title?: string | null;
  topLabel?: string | null;
  description?: string | null;
};

type NewsPageContentArea_SliderBlockRecord_Fragment = {
  __typename?: 'SliderBlockRecord';
  title?: string | null;
  arrows?: any | null;
  slideAnimation?: any | null;
  delay?: any | null;
  dots?: any | null;
  heroes: Array<{
    __typename?: 'HeroBlockRecord';
    id: any;
    title?: string | null;
    description?: string | null;
    ctaText?: string | null;
    ctaUrl?: string | null;
    fullWidth?: any | null;
    boxColor?: { __typename?: 'ColorField'; hex: string } | null;
    textColor?: { __typename?: 'ColorField'; hex: string } | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
    imageOverlay?: {
      __typename?: 'OverlayRecord';
      id: any;
      opacity?: any | null;
      color?: { __typename?: 'ColorField'; hex: string } | null;
    } | null;
    ctaButtons: Array<{
      __typename?: 'CtaButtonRecord';
      id: any;
      text?: string | null;
      url?: string | null;
      variant?: string | null;
    }>;
    video?: {
      __typename?: 'FileField';
      blurUpThumb?: string | null;
      title?: string | null;
      alt?: string | null;
      video?: {
        __typename?: 'UploadVideoField';
        muxPlaybackId: string;
        width: any;
        height: any;
      } | null;
    } | null;
  }>;
};

type NewsPageContentArea_StatementBlockRecord_Fragment = {
  __typename?: 'StatementBlockRecord';
  id: any;
  text?: string | null;
  blackBackground?: any | null;
  header?: string | null;
  small?: any | null;
  linkText?: string | null;
  linkUrl?: string | null;
  imageMobile?: {
    __typename?: 'FileField';
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  imageTablet?: {
    __typename?: 'FileField';
    alt?: string | null;
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  imageDesktop?: {
    __typename?: 'FileField';
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  imageLoad?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
  imageOverlay?: {
    __typename?: 'OverlayRecord';
    id: any;
    opacity?: any | null;
    color?: { __typename?: 'ColorField'; hex: string } | null;
  } | null;
};

type NewsPageContentArea_TextBlockRecord_Fragment = {
  __typename?: 'TextBlockRecord';
  id: any;
  smallHeader?: any | null;
  header?: string | null;
  text?: string | null;
  introText?: string | null;
  ctaButtons: Array<{
    __typename?: 'CtaButtonRecord';
    id: any;
    text?: string | null;
    url?: string | null;
    variant?: string | null;
  }>;
};

type NewsPageContentArea_TwoColumnImageAndTextRecord_Fragment = {
  __typename?: 'TwoColumnImageAndTextRecord';
  id: any;
  text?: string | null;
  title?: string | null;
  reverse?: any | null;
  image?: {
    __typename?: 'FileField';
    alt?: string | null;
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  imageLoad?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
};

type NewsPageContentArea_TwoColumnTextIntroRecord_Fragment = {
  __typename?: 'TwoColumnTextIntroRecord';
  id: any;
  introText?: string | null;
  text?: string | null;
  header?: string | null;
};

type NewsPageContentArea_VideoRecord_Fragment = {
  __typename?: 'VideoRecord';
  id: any;
  autoplay?: any | null;
  video?: {
    __typename?: 'FileField';
    title?: string | null;
    video?: {
      __typename?: 'UploadVideoField';
      mp4Url?: string | null;
      streamingUrl: string;
      thumbnailUrl: string;
      mp4Low?: string | null;
    } | null;
  } | null;
  videoThumbnail?: {
    __typename?: 'FileField';
    alt?: string | null;
    tags: Array<string>;
    title?: string | null;
    url: string;
    width?: any | null;
    height?: any | null;
    format: string;
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  muxVideo?: {
    __typename?: 'FileField';
    blurUpThumb?: string | null;
    title?: string | null;
    alt?: string | null;
    video?: {
      __typename?: 'UploadVideoField';
      muxPlaybackId: string;
      width: any;
      height: any;
    } | null;
  } | null;
};

export type NewsPageContentAreaFragment =
  | NewsPageContentArea_ArticlesBlockRecord_Fragment
  | NewsPageContentArea_BrandsBlockRecord_Fragment
  | NewsPageContentArea_BulletListRecord_Fragment
  | NewsPageContentArea_DocumentLinkBlockRecord_Fragment
  | NewsPageContentArea_EmployeeRecord_Fragment
  | NewsPageContentArea_HeroBlockRecord_Fragment
  | NewsPageContentArea_ImageRecord_Fragment
  | NewsPageContentArea_JobsListBlockRecord_Fragment
  | NewsPageContentArea_NewsAndReportsListBlockRecord_Fragment
  | NewsPageContentArea_NewsListBlockRecord_Fragment
  | NewsPageContentArea_OfficesBlockRecord_Fragment
  | NewsPageContentArea_PlugBlockRecord_Fragment
  | NewsPageContentArea_SimpleTitleAndTextBlockRecord_Fragment
  | NewsPageContentArea_SliderBlockRecord_Fragment
  | NewsPageContentArea_StatementBlockRecord_Fragment
  | NewsPageContentArea_TextBlockRecord_Fragment
  | NewsPageContentArea_TwoColumnImageAndTextRecord_Fragment
  | NewsPageContentArea_TwoColumnTextIntroRecord_Fragment
  | NewsPageContentArea_VideoRecord_Fragment;

export type NewsPageContentFragment = {
  __typename?: 'NewsPageRecord';
  id: any;
  title?: string | null;
  slug?: string | null;
  publishDate?: any | null;
  category?: string | null;
  pageLocales: Array<SiteLocale>;
  image?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
  contentArea: Array<
    | {
        __typename?: 'ArticlesBlockRecord';
        id: any;
        title?: string | null;
        isJobArticles?: any | null;
        ctaText?: string | null;
        ctaUrl?: string | null;
        jobPages: Array<{
          __typename?: 'JobOpportunitiesPageRecord';
          id: any;
          slug?: string | null;
          title?: string | null;
          publishDate?: any | null;
          category?: string | null;
          country?: string | null;
          department?: string | null;
        }>;
        newsPages: Array<{
          __typename?: 'NewsPageRecord';
          id: any;
          slug?: string | null;
          title?: string | null;
          publishDate?: any | null;
          category?: string | null;
          country?: string | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
        }>;
        reportPages: Array<{
          __typename?: 'ReportsListingRecord';
          id: any;
          slug?: string | null;
          title?: string | null;
          publishDate?: any | null;
          category?: string | null;
          country?: string | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
          pdf?: {
            __typename?: 'FileField';
            alt?: string | null;
            filename: string;
            format: string;
            size: any;
            title?: string | null;
            url: string;
            uploadId: any;
          } | null;
        }>;
      }
    | {
        __typename?: 'BrandsBlockRecord';
        id: any;
        title?: string | null;
        introText?: string | null;
        hideLabels?: any | null;
        brands: Array<{
          __typename?: 'BrandPageRecord';
          id: any;
          brandName?: string | null;
          slug?: string | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            tags: Array<string>;
            title?: string | null;
            url: string;
            width?: any | null;
            height?: any | null;
            format: string;
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageLoad?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
        }>;
      }
    | {
        __typename?: 'BulletListRecord';
        id: any;
        bullets?: string | null;
        numberedList?: any | null;
        title?: string | null;
      }
    | {
        __typename?: 'DocumentLinkBlockRecord';
        id: any;
        documents: Array<{
          __typename?: 'FileField';
          alt?: string | null;
          filename: string;
          format: string;
          size: any;
          title?: string | null;
          url: string;
          uploadId: any;
        }>;
      }
    | {
        __typename?: 'EmployeeRecord';
        id: any;
        name?: string | null;
        title?: string | null;
        introText?: string | null;
        description?: string | null;
        image?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
      }
    | {
        __typename?: 'HeroBlockRecord';
        id: any;
        title?: string | null;
        description?: string | null;
        ctaText?: string | null;
        ctaUrl?: string | null;
        fullWidth?: any | null;
        boxColor?: { __typename?: 'ColorField'; hex: string } | null;
        textColor?: { __typename?: 'ColorField'; hex: string } | null;
        image?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
        imageOverlay?: {
          __typename?: 'OverlayRecord';
          id: any;
          opacity?: any | null;
          color?: { __typename?: 'ColorField'; hex: string } | null;
        } | null;
        ctaButtons: Array<{
          __typename?: 'CtaButtonRecord';
          id: any;
          text?: string | null;
          url?: string | null;
          variant?: string | null;
        }>;
        video?: {
          __typename?: 'FileField';
          blurUpThumb?: string | null;
          title?: string | null;
          alt?: string | null;
          video?: {
            __typename?: 'UploadVideoField';
            muxPlaybackId: string;
            width: any;
            height: any;
          } | null;
        } | null;
      }
    | {
        __typename?: 'ImageRecord';
        id: any;
        fullWidth?: any | null;
        image?: {
          __typename?: 'FileField';
          alt?: string | null;
          responsiveImage?: {
            __typename?: 'ResponsiveImage';
            aspectRatio: any;
            base64?: string | null;
            bgColor?: string | null;
            height: any;
            sizes: string;
            src: string;
            srcSet: string;
            webpSrcSet: string;
            width: any;
          } | null;
        } | null;
        imageLoad?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
      }
    | { __typename?: 'JobsListBlockRecord'; id: any; title?: string | null }
    | {
        __typename?: 'NewsAndReportsListBlockRecord';
        newsTitle?: string | null;
        reportsTitle?: string | null;
        newsImage?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
        news: Array<{
          __typename?: 'NewsPageRecord';
          id: any;
          title?: string | null;
          slug?: string | null;
          publishDate?: any | null;
          category?: string | null;
        }>;
        reportsImage?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
        reports: Array<{
          __typename?: 'ReportsListingRecord';
          id: any;
          title?: string | null;
          slug?: string | null;
          publishDate?: any | null;
          category?: string | null;
          pdf?: {
            __typename?: 'FileField';
            alt?: string | null;
            filename: string;
            format: string;
            size: any;
            title?: string | null;
            url: string;
            uploadId: any;
          } | null;
        }>;
      }
    | {
        __typename?: 'NewsListBlockRecord';
        id: any;
        title?: string | null;
        standalone?: any | null;
        largeTitle?: any | null;
        itemsToShow?: any | null;
      }
    | {
        __typename?: 'OfficesBlockRecord';
        id: any;
        offices: Array<{
          __typename?: 'OfficeRecord';
          id: any;
          name?: string | null;
          address?: string | null;
          zipCode?: string | null;
          city?: string | null;
          country?: string | null;
          email?: string | null;
          websiteUrl?: string | null;
          phoneNumber?: string | null;
        }>;
      }
    | {
        __typename?: 'PlugBlockRecord';
        id: any;
        title?: string | null;
        description?: string | null;
        brands: Array<{
          __typename?: 'BrandPageRecord';
          id: any;
          brandName?: string | null;
          slug?: string | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            tags: Array<string>;
            title?: string | null;
            url: string;
            width?: any | null;
            height?: any | null;
            format: string;
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageLoad?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
        }>;
      }
    | {
        __typename?: 'SimpleTitleAndTextBlockRecord';
        id: any;
        title?: string | null;
        topLabel?: string | null;
        description?: string | null;
      }
    | {
        __typename?: 'SliderBlockRecord';
        title?: string | null;
        arrows?: any | null;
        slideAnimation?: any | null;
        delay?: any | null;
        dots?: any | null;
        heroes: Array<{
          __typename?: 'HeroBlockRecord';
          id: any;
          title?: string | null;
          description?: string | null;
          ctaText?: string | null;
          ctaUrl?: string | null;
          fullWidth?: any | null;
          boxColor?: { __typename?: 'ColorField'; hex: string } | null;
          textColor?: { __typename?: 'ColorField'; hex: string } | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
          imageOverlay?: {
            __typename?: 'OverlayRecord';
            id: any;
            opacity?: any | null;
            color?: { __typename?: 'ColorField'; hex: string } | null;
          } | null;
          ctaButtons: Array<{
            __typename?: 'CtaButtonRecord';
            id: any;
            text?: string | null;
            url?: string | null;
            variant?: string | null;
          }>;
          video?: {
            __typename?: 'FileField';
            blurUpThumb?: string | null;
            title?: string | null;
            alt?: string | null;
            video?: {
              __typename?: 'UploadVideoField';
              muxPlaybackId: string;
              width: any;
              height: any;
            } | null;
          } | null;
        }>;
      }
    | {
        __typename?: 'StatementBlockRecord';
        id: any;
        text?: string | null;
        blackBackground?: any | null;
        header?: string | null;
        small?: any | null;
        linkText?: string | null;
        linkUrl?: string | null;
        imageMobile?: {
          __typename?: 'FileField';
          responsiveImage?: {
            __typename?: 'ResponsiveImage';
            aspectRatio: any;
            base64?: string | null;
            bgColor?: string | null;
            height: any;
            sizes: string;
            src: string;
            srcSet: string;
            webpSrcSet: string;
            width: any;
          } | null;
        } | null;
        imageTablet?: {
          __typename?: 'FileField';
          alt?: string | null;
          responsiveImage?: {
            __typename?: 'ResponsiveImage';
            aspectRatio: any;
            base64?: string | null;
            bgColor?: string | null;
            height: any;
            sizes: string;
            src: string;
            srcSet: string;
            webpSrcSet: string;
            width: any;
          } | null;
        } | null;
        imageDesktop?: {
          __typename?: 'FileField';
          responsiveImage?: {
            __typename?: 'ResponsiveImage';
            aspectRatio: any;
            base64?: string | null;
            bgColor?: string | null;
            height: any;
            sizes: string;
            src: string;
            srcSet: string;
            webpSrcSet: string;
            width: any;
          } | null;
        } | null;
        imageLoad?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
        imageOverlay?: {
          __typename?: 'OverlayRecord';
          id: any;
          opacity?: any | null;
          color?: { __typename?: 'ColorField'; hex: string } | null;
        } | null;
      }
    | {
        __typename?: 'TextBlockRecord';
        id: any;
        smallHeader?: any | null;
        header?: string | null;
        text?: string | null;
        introText?: string | null;
        ctaButtons: Array<{
          __typename?: 'CtaButtonRecord';
          id: any;
          text?: string | null;
          url?: string | null;
          variant?: string | null;
        }>;
      }
    | {
        __typename?: 'TwoColumnImageAndTextRecord';
        id: any;
        text?: string | null;
        title?: string | null;
        reverse?: any | null;
        image?: {
          __typename?: 'FileField';
          alt?: string | null;
          responsiveImage?: {
            __typename?: 'ResponsiveImage';
            aspectRatio: any;
            base64?: string | null;
            bgColor?: string | null;
            height: any;
            sizes: string;
            src: string;
            srcSet: string;
            webpSrcSet: string;
            width: any;
          } | null;
        } | null;
        imageLoad?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
      }
    | {
        __typename?: 'TwoColumnTextIntroRecord';
        id: any;
        introText?: string | null;
        text?: string | null;
        header?: string | null;
      }
    | {
        __typename?: 'VideoRecord';
        id: any;
        autoplay?: any | null;
        video?: {
          __typename?: 'FileField';
          title?: string | null;
          video?: {
            __typename?: 'UploadVideoField';
            mp4Url?: string | null;
            streamingUrl: string;
            thumbnailUrl: string;
            mp4Low?: string | null;
          } | null;
        } | null;
        videoThumbnail?: {
          __typename?: 'FileField';
          alt?: string | null;
          tags: Array<string>;
          title?: string | null;
          url: string;
          width?: any | null;
          height?: any | null;
          format: string;
          responsiveImage?: {
            __typename?: 'ResponsiveImage';
            aspectRatio: any;
            base64?: string | null;
            bgColor?: string | null;
            height: any;
            sizes: string;
            src: string;
            srcSet: string;
            webpSrcSet: string;
            width: any;
          } | null;
        } | null;
        muxVideo?: {
          __typename?: 'FileField';
          blurUpThumb?: string | null;
          title?: string | null;
          alt?: string | null;
          video?: {
            __typename?: 'UploadVideoField';
            muxPlaybackId: string;
            width: any;
            height: any;
          } | null;
        } | null;
      }
  >;
  seo?: {
    __typename?: 'SeoField';
    description?: string | null;
    title?: string | null;
    image?: {
      __typename?: 'FileField';
      url: string;
      alt?: string | null;
      title?: string | null;
    } | null;
  } | null;
};

export type PageNotFoundContentFragment = {
  __typename?: 'PageNotFoundRecord';
  description?: string | null;
  header?: string | null;
  backToHomeScreenButton?: string | null;
};

type ReportsListPageContentArea_ArticlesBlockRecord_Fragment = {
  __typename?: 'ArticlesBlockRecord';
  id: any;
  title?: string | null;
  isJobArticles?: any | null;
  ctaText?: string | null;
  ctaUrl?: string | null;
  jobPages: Array<{
    __typename?: 'JobOpportunitiesPageRecord';
    id: any;
    slug?: string | null;
    title?: string | null;
    publishDate?: any | null;
    category?: string | null;
    country?: string | null;
    department?: string | null;
  }>;
  newsPages: Array<{
    __typename?: 'NewsPageRecord';
    id: any;
    slug?: string | null;
    title?: string | null;
    publishDate?: any | null;
    category?: string | null;
    country?: string | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
  }>;
  reportPages: Array<{
    __typename?: 'ReportsListingRecord';
    id: any;
    slug?: string | null;
    title?: string | null;
    publishDate?: any | null;
    category?: string | null;
    country?: string | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
    pdf?: {
      __typename?: 'FileField';
      alt?: string | null;
      filename: string;
      format: string;
      size: any;
      title?: string | null;
      url: string;
      uploadId: any;
    } | null;
  }>;
};

type ReportsListPageContentArea_BrandsBlockRecord_Fragment = {
  __typename?: 'BrandsBlockRecord';
  id: any;
  title?: string | null;
  introText?: string | null;
  hideLabels?: any | null;
  brands: Array<{
    __typename?: 'BrandPageRecord';
    id: any;
    brandName?: string | null;
    slug?: string | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      tags: Array<string>;
      title?: string | null;
      url: string;
      width?: any | null;
      height?: any | null;
      format: string;
      responsiveImage?: {
        __typename?: 'ResponsiveImage';
        aspectRatio: any;
        base64?: string | null;
        bgColor?: string | null;
        height: any;
        sizes: string;
        src: string;
        srcSet: string;
        webpSrcSet: string;
        width: any;
      } | null;
    } | null;
    imageLoad?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
  }>;
};

type ReportsListPageContentArea_BulletListRecord_Fragment = {
  __typename?: 'BulletListRecord';
  id: any;
  bullets?: string | null;
  numberedList?: any | null;
  title?: string | null;
};

type ReportsListPageContentArea_DocumentLinkBlockRecord_Fragment = {
  __typename?: 'DocumentLinkBlockRecord';
  id: any;
  documents: Array<{
    __typename?: 'FileField';
    alt?: string | null;
    filename: string;
    format: string;
    size: any;
    title?: string | null;
    url: string;
    uploadId: any;
  }>;
};

type ReportsListPageContentArea_EmployeeRecord_Fragment = {
  __typename?: 'EmployeeRecord';
  id: any;
  name?: string | null;
  title?: string | null;
  introText?: string | null;
  description?: string | null;
  image?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
};

type ReportsListPageContentArea_HeroBlockRecord_Fragment = {
  __typename?: 'HeroBlockRecord';
  id: any;
  title?: string | null;
  description?: string | null;
  ctaText?: string | null;
  ctaUrl?: string | null;
  fullWidth?: any | null;
  boxColor?: { __typename?: 'ColorField'; hex: string } | null;
  textColor?: { __typename?: 'ColorField'; hex: string } | null;
  image?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
  imageOverlay?: {
    __typename?: 'OverlayRecord';
    id: any;
    opacity?: any | null;
    color?: { __typename?: 'ColorField'; hex: string } | null;
  } | null;
  ctaButtons: Array<{
    __typename?: 'CtaButtonRecord';
    id: any;
    text?: string | null;
    url?: string | null;
    variant?: string | null;
  }>;
  video?: {
    __typename?: 'FileField';
    blurUpThumb?: string | null;
    title?: string | null;
    alt?: string | null;
    video?: {
      __typename?: 'UploadVideoField';
      muxPlaybackId: string;
      width: any;
      height: any;
    } | null;
  } | null;
};

type ReportsListPageContentArea_ImageRecord_Fragment = {
  __typename?: 'ImageRecord';
  id: any;
  fullWidth?: any | null;
  image?: {
    __typename?: 'FileField';
    alt?: string | null;
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  imageLoad?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
};

type ReportsListPageContentArea_JobsListBlockRecord_Fragment = {
  __typename?: 'JobsListBlockRecord';
  id: any;
  title?: string | null;
};

type ReportsListPageContentArea_NewsAndReportsListBlockRecord_Fragment = {
  __typename?: 'NewsAndReportsListBlockRecord';
  newsTitle?: string | null;
  reportsTitle?: string | null;
  newsImage?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
  news: Array<{
    __typename?: 'NewsPageRecord';
    id: any;
    title?: string | null;
    slug?: string | null;
    publishDate?: any | null;
    category?: string | null;
  }>;
  reportsImage?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
  reports: Array<{
    __typename?: 'ReportsListingRecord';
    id: any;
    title?: string | null;
    slug?: string | null;
    publishDate?: any | null;
    category?: string | null;
    pdf?: {
      __typename?: 'FileField';
      alt?: string | null;
      filename: string;
      format: string;
      size: any;
      title?: string | null;
      url: string;
      uploadId: any;
    } | null;
  }>;
};

type ReportsListPageContentArea_NewsListBlockRecord_Fragment = {
  __typename?: 'NewsListBlockRecord';
  id: any;
  title?: string | null;
  standalone?: any | null;
  largeTitle?: any | null;
  itemsToShow?: any | null;
};

type ReportsListPageContentArea_OfficesBlockRecord_Fragment = {
  __typename?: 'OfficesBlockRecord';
  id: any;
  offices: Array<{
    __typename?: 'OfficeRecord';
    id: any;
    name?: string | null;
    address?: string | null;
    zipCode?: string | null;
    city?: string | null;
    country?: string | null;
    email?: string | null;
    websiteUrl?: string | null;
    phoneNumber?: string | null;
  }>;
};

type ReportsListPageContentArea_PlugBlockRecord_Fragment = {
  __typename?: 'PlugBlockRecord';
  id: any;
  title?: string | null;
  description?: string | null;
  brands: Array<{
    __typename?: 'BrandPageRecord';
    id: any;
    brandName?: string | null;
    slug?: string | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      tags: Array<string>;
      title?: string | null;
      url: string;
      width?: any | null;
      height?: any | null;
      format: string;
      responsiveImage?: {
        __typename?: 'ResponsiveImage';
        aspectRatio: any;
        base64?: string | null;
        bgColor?: string | null;
        height: any;
        sizes: string;
        src: string;
        srcSet: string;
        webpSrcSet: string;
        width: any;
      } | null;
    } | null;
    imageLoad?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
  }>;
};

type ReportsListPageContentArea_ReportsListBlockRecord_Fragment = {
  __typename?: 'ReportsListBlockRecord';
  id: any;
  title?: string | null;
  standalone?: any | null;
  largeTitle?: any | null;
};

type ReportsListPageContentArea_SimpleTitleAndTextBlockRecord_Fragment = {
  __typename?: 'SimpleTitleAndTextBlockRecord';
  id: any;
  title?: string | null;
  topLabel?: string | null;
  description?: string | null;
};

type ReportsListPageContentArea_SliderBlockRecord_Fragment = {
  __typename?: 'SliderBlockRecord';
  title?: string | null;
  arrows?: any | null;
  slideAnimation?: any | null;
  delay?: any | null;
  dots?: any | null;
  heroes: Array<{
    __typename?: 'HeroBlockRecord';
    id: any;
    title?: string | null;
    description?: string | null;
    ctaText?: string | null;
    ctaUrl?: string | null;
    fullWidth?: any | null;
    boxColor?: { __typename?: 'ColorField'; hex: string } | null;
    textColor?: { __typename?: 'ColorField'; hex: string } | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
    imageOverlay?: {
      __typename?: 'OverlayRecord';
      id: any;
      opacity?: any | null;
      color?: { __typename?: 'ColorField'; hex: string } | null;
    } | null;
    ctaButtons: Array<{
      __typename?: 'CtaButtonRecord';
      id: any;
      text?: string | null;
      url?: string | null;
      variant?: string | null;
    }>;
    video?: {
      __typename?: 'FileField';
      blurUpThumb?: string | null;
      title?: string | null;
      alt?: string | null;
      video?: {
        __typename?: 'UploadVideoField';
        muxPlaybackId: string;
        width: any;
        height: any;
      } | null;
    } | null;
  }>;
};

type ReportsListPageContentArea_StatementBlockRecord_Fragment = {
  __typename?: 'StatementBlockRecord';
  id: any;
  text?: string | null;
  blackBackground?: any | null;
  header?: string | null;
  small?: any | null;
  linkText?: string | null;
  linkUrl?: string | null;
  imageMobile?: {
    __typename?: 'FileField';
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  imageTablet?: {
    __typename?: 'FileField';
    alt?: string | null;
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  imageDesktop?: {
    __typename?: 'FileField';
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  imageLoad?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
  imageOverlay?: {
    __typename?: 'OverlayRecord';
    id: any;
    opacity?: any | null;
    color?: { __typename?: 'ColorField'; hex: string } | null;
  } | null;
};

type ReportsListPageContentArea_TextBlockRecord_Fragment = {
  __typename?: 'TextBlockRecord';
  id: any;
  smallHeader?: any | null;
  header?: string | null;
  text?: string | null;
  introText?: string | null;
  ctaButtons: Array<{
    __typename?: 'CtaButtonRecord';
    id: any;
    text?: string | null;
    url?: string | null;
    variant?: string | null;
  }>;
};

type ReportsListPageContentArea_TwoColumnImageAndTextRecord_Fragment = {
  __typename?: 'TwoColumnImageAndTextRecord';
  id: any;
  text?: string | null;
  title?: string | null;
  reverse?: any | null;
  image?: {
    __typename?: 'FileField';
    alt?: string | null;
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  imageLoad?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
};

type ReportsListPageContentArea_TwoColumnTextIntroRecord_Fragment = {
  __typename?: 'TwoColumnTextIntroRecord';
  id: any;
  introText?: string | null;
  text?: string | null;
  header?: string | null;
};

type ReportsListPageContentArea_VideoRecord_Fragment = {
  __typename?: 'VideoRecord';
  id: any;
  autoplay?: any | null;
  video?: {
    __typename?: 'FileField';
    title?: string | null;
    video?: {
      __typename?: 'UploadVideoField';
      mp4Url?: string | null;
      streamingUrl: string;
      thumbnailUrl: string;
      mp4Low?: string | null;
    } | null;
  } | null;
  videoThumbnail?: {
    __typename?: 'FileField';
    alt?: string | null;
    tags: Array<string>;
    title?: string | null;
    url: string;
    width?: any | null;
    height?: any | null;
    format: string;
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  muxVideo?: {
    __typename?: 'FileField';
    blurUpThumb?: string | null;
    title?: string | null;
    alt?: string | null;
    video?: {
      __typename?: 'UploadVideoField';
      muxPlaybackId: string;
      width: any;
      height: any;
    } | null;
  } | null;
};

export type ReportsListPageContentAreaFragment =
  | ReportsListPageContentArea_ArticlesBlockRecord_Fragment
  | ReportsListPageContentArea_BrandsBlockRecord_Fragment
  | ReportsListPageContentArea_BulletListRecord_Fragment
  | ReportsListPageContentArea_DocumentLinkBlockRecord_Fragment
  | ReportsListPageContentArea_EmployeeRecord_Fragment
  | ReportsListPageContentArea_HeroBlockRecord_Fragment
  | ReportsListPageContentArea_ImageRecord_Fragment
  | ReportsListPageContentArea_JobsListBlockRecord_Fragment
  | ReportsListPageContentArea_NewsAndReportsListBlockRecord_Fragment
  | ReportsListPageContentArea_NewsListBlockRecord_Fragment
  | ReportsListPageContentArea_OfficesBlockRecord_Fragment
  | ReportsListPageContentArea_PlugBlockRecord_Fragment
  | ReportsListPageContentArea_ReportsListBlockRecord_Fragment
  | ReportsListPageContentArea_SimpleTitleAndTextBlockRecord_Fragment
  | ReportsListPageContentArea_SliderBlockRecord_Fragment
  | ReportsListPageContentArea_StatementBlockRecord_Fragment
  | ReportsListPageContentArea_TextBlockRecord_Fragment
  | ReportsListPageContentArea_TwoColumnImageAndTextRecord_Fragment
  | ReportsListPageContentArea_TwoColumnTextIntroRecord_Fragment
  | ReportsListPageContentArea_VideoRecord_Fragment;

export type ReportsListPageContentFragment = {
  __typename?: 'ReportsListPageRecord';
  id: any;
  pageLocales: Array<SiteLocale>;
  seo?: {
    __typename?: 'SeoField';
    description?: string | null;
    title?: string | null;
    image?: {
      __typename?: 'FileField';
      url: string;
      alt?: string | null;
      title?: string | null;
    } | null;
  } | null;
  contentArea: Array<
    | {
        __typename?: 'ArticlesBlockRecord';
        id: any;
        title?: string | null;
        isJobArticles?: any | null;
        ctaText?: string | null;
        ctaUrl?: string | null;
        jobPages: Array<{
          __typename?: 'JobOpportunitiesPageRecord';
          id: any;
          slug?: string | null;
          title?: string | null;
          publishDate?: any | null;
          category?: string | null;
          country?: string | null;
          department?: string | null;
        }>;
        newsPages: Array<{
          __typename?: 'NewsPageRecord';
          id: any;
          slug?: string | null;
          title?: string | null;
          publishDate?: any | null;
          category?: string | null;
          country?: string | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
        }>;
        reportPages: Array<{
          __typename?: 'ReportsListingRecord';
          id: any;
          slug?: string | null;
          title?: string | null;
          publishDate?: any | null;
          category?: string | null;
          country?: string | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
          pdf?: {
            __typename?: 'FileField';
            alt?: string | null;
            filename: string;
            format: string;
            size: any;
            title?: string | null;
            url: string;
            uploadId: any;
          } | null;
        }>;
      }
    | {
        __typename?: 'BrandsBlockRecord';
        id: any;
        title?: string | null;
        introText?: string | null;
        hideLabels?: any | null;
        brands: Array<{
          __typename?: 'BrandPageRecord';
          id: any;
          brandName?: string | null;
          slug?: string | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            tags: Array<string>;
            title?: string | null;
            url: string;
            width?: any | null;
            height?: any | null;
            format: string;
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageLoad?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
        }>;
      }
    | {
        __typename?: 'BulletListRecord';
        id: any;
        bullets?: string | null;
        numberedList?: any | null;
        title?: string | null;
      }
    | {
        __typename?: 'DocumentLinkBlockRecord';
        id: any;
        documents: Array<{
          __typename?: 'FileField';
          alt?: string | null;
          filename: string;
          format: string;
          size: any;
          title?: string | null;
          url: string;
          uploadId: any;
        }>;
      }
    | {
        __typename?: 'EmployeeRecord';
        id: any;
        name?: string | null;
        title?: string | null;
        introText?: string | null;
        description?: string | null;
        image?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
      }
    | {
        __typename?: 'HeroBlockRecord';
        id: any;
        title?: string | null;
        description?: string | null;
        ctaText?: string | null;
        ctaUrl?: string | null;
        fullWidth?: any | null;
        boxColor?: { __typename?: 'ColorField'; hex: string } | null;
        textColor?: { __typename?: 'ColorField'; hex: string } | null;
        image?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
        imageOverlay?: {
          __typename?: 'OverlayRecord';
          id: any;
          opacity?: any | null;
          color?: { __typename?: 'ColorField'; hex: string } | null;
        } | null;
        ctaButtons: Array<{
          __typename?: 'CtaButtonRecord';
          id: any;
          text?: string | null;
          url?: string | null;
          variant?: string | null;
        }>;
        video?: {
          __typename?: 'FileField';
          blurUpThumb?: string | null;
          title?: string | null;
          alt?: string | null;
          video?: {
            __typename?: 'UploadVideoField';
            muxPlaybackId: string;
            width: any;
            height: any;
          } | null;
        } | null;
      }
    | {
        __typename?: 'ImageRecord';
        id: any;
        fullWidth?: any | null;
        image?: {
          __typename?: 'FileField';
          alt?: string | null;
          responsiveImage?: {
            __typename?: 'ResponsiveImage';
            aspectRatio: any;
            base64?: string | null;
            bgColor?: string | null;
            height: any;
            sizes: string;
            src: string;
            srcSet: string;
            webpSrcSet: string;
            width: any;
          } | null;
        } | null;
        imageLoad?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
      }
    | { __typename?: 'JobsListBlockRecord'; id: any; title?: string | null }
    | {
        __typename?: 'NewsAndReportsListBlockRecord';
        newsTitle?: string | null;
        reportsTitle?: string | null;
        newsImage?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
        news: Array<{
          __typename?: 'NewsPageRecord';
          id: any;
          title?: string | null;
          slug?: string | null;
          publishDate?: any | null;
          category?: string | null;
        }>;
        reportsImage?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
        reports: Array<{
          __typename?: 'ReportsListingRecord';
          id: any;
          title?: string | null;
          slug?: string | null;
          publishDate?: any | null;
          category?: string | null;
          pdf?: {
            __typename?: 'FileField';
            alt?: string | null;
            filename: string;
            format: string;
            size: any;
            title?: string | null;
            url: string;
            uploadId: any;
          } | null;
        }>;
      }
    | {
        __typename?: 'NewsListBlockRecord';
        id: any;
        title?: string | null;
        standalone?: any | null;
        largeTitle?: any | null;
        itemsToShow?: any | null;
      }
    | {
        __typename?: 'OfficesBlockRecord';
        id: any;
        offices: Array<{
          __typename?: 'OfficeRecord';
          id: any;
          name?: string | null;
          address?: string | null;
          zipCode?: string | null;
          city?: string | null;
          country?: string | null;
          email?: string | null;
          websiteUrl?: string | null;
          phoneNumber?: string | null;
        }>;
      }
    | {
        __typename?: 'PlugBlockRecord';
        id: any;
        title?: string | null;
        description?: string | null;
        brands: Array<{
          __typename?: 'BrandPageRecord';
          id: any;
          brandName?: string | null;
          slug?: string | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            tags: Array<string>;
            title?: string | null;
            url: string;
            width?: any | null;
            height?: any | null;
            format: string;
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageLoad?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
        }>;
      }
    | {
        __typename?: 'ReportsListBlockRecord';
        id: any;
        title?: string | null;
        standalone?: any | null;
        largeTitle?: any | null;
      }
    | {
        __typename?: 'SimpleTitleAndTextBlockRecord';
        id: any;
        title?: string | null;
        topLabel?: string | null;
        description?: string | null;
      }
    | {
        __typename?: 'SliderBlockRecord';
        title?: string | null;
        arrows?: any | null;
        slideAnimation?: any | null;
        delay?: any | null;
        dots?: any | null;
        heroes: Array<{
          __typename?: 'HeroBlockRecord';
          id: any;
          title?: string | null;
          description?: string | null;
          ctaText?: string | null;
          ctaUrl?: string | null;
          fullWidth?: any | null;
          boxColor?: { __typename?: 'ColorField'; hex: string } | null;
          textColor?: { __typename?: 'ColorField'; hex: string } | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
          imageOverlay?: {
            __typename?: 'OverlayRecord';
            id: any;
            opacity?: any | null;
            color?: { __typename?: 'ColorField'; hex: string } | null;
          } | null;
          ctaButtons: Array<{
            __typename?: 'CtaButtonRecord';
            id: any;
            text?: string | null;
            url?: string | null;
            variant?: string | null;
          }>;
          video?: {
            __typename?: 'FileField';
            blurUpThumb?: string | null;
            title?: string | null;
            alt?: string | null;
            video?: {
              __typename?: 'UploadVideoField';
              muxPlaybackId: string;
              width: any;
              height: any;
            } | null;
          } | null;
        }>;
      }
    | {
        __typename?: 'StatementBlockRecord';
        id: any;
        text?: string | null;
        blackBackground?: any | null;
        header?: string | null;
        small?: any | null;
        linkText?: string | null;
        linkUrl?: string | null;
        imageMobile?: {
          __typename?: 'FileField';
          responsiveImage?: {
            __typename?: 'ResponsiveImage';
            aspectRatio: any;
            base64?: string | null;
            bgColor?: string | null;
            height: any;
            sizes: string;
            src: string;
            srcSet: string;
            webpSrcSet: string;
            width: any;
          } | null;
        } | null;
        imageTablet?: {
          __typename?: 'FileField';
          alt?: string | null;
          responsiveImage?: {
            __typename?: 'ResponsiveImage';
            aspectRatio: any;
            base64?: string | null;
            bgColor?: string | null;
            height: any;
            sizes: string;
            src: string;
            srcSet: string;
            webpSrcSet: string;
            width: any;
          } | null;
        } | null;
        imageDesktop?: {
          __typename?: 'FileField';
          responsiveImage?: {
            __typename?: 'ResponsiveImage';
            aspectRatio: any;
            base64?: string | null;
            bgColor?: string | null;
            height: any;
            sizes: string;
            src: string;
            srcSet: string;
            webpSrcSet: string;
            width: any;
          } | null;
        } | null;
        imageLoad?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
        imageOverlay?: {
          __typename?: 'OverlayRecord';
          id: any;
          opacity?: any | null;
          color?: { __typename?: 'ColorField'; hex: string } | null;
        } | null;
      }
    | {
        __typename?: 'TextBlockRecord';
        id: any;
        smallHeader?: any | null;
        header?: string | null;
        text?: string | null;
        introText?: string | null;
        ctaButtons: Array<{
          __typename?: 'CtaButtonRecord';
          id: any;
          text?: string | null;
          url?: string | null;
          variant?: string | null;
        }>;
      }
    | {
        __typename?: 'TwoColumnImageAndTextRecord';
        id: any;
        text?: string | null;
        title?: string | null;
        reverse?: any | null;
        image?: {
          __typename?: 'FileField';
          alt?: string | null;
          responsiveImage?: {
            __typename?: 'ResponsiveImage';
            aspectRatio: any;
            base64?: string | null;
            bgColor?: string | null;
            height: any;
            sizes: string;
            src: string;
            srcSet: string;
            webpSrcSet: string;
            width: any;
          } | null;
        } | null;
        imageLoad?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
      }
    | {
        __typename?: 'TwoColumnTextIntroRecord';
        id: any;
        introText?: string | null;
        text?: string | null;
        header?: string | null;
      }
    | {
        __typename?: 'VideoRecord';
        id: any;
        autoplay?: any | null;
        video?: {
          __typename?: 'FileField';
          title?: string | null;
          video?: {
            __typename?: 'UploadVideoField';
            mp4Url?: string | null;
            streamingUrl: string;
            thumbnailUrl: string;
            mp4Low?: string | null;
          } | null;
        } | null;
        videoThumbnail?: {
          __typename?: 'FileField';
          alt?: string | null;
          tags: Array<string>;
          title?: string | null;
          url: string;
          width?: any | null;
          height?: any | null;
          format: string;
          responsiveImage?: {
            __typename?: 'ResponsiveImage';
            aspectRatio: any;
            base64?: string | null;
            bgColor?: string | null;
            height: any;
            sizes: string;
            src: string;
            srcSet: string;
            webpSrcSet: string;
            width: any;
          } | null;
        } | null;
        muxVideo?: {
          __typename?: 'FileField';
          blurUpThumb?: string | null;
          title?: string | null;
          alt?: string | null;
          video?: {
            __typename?: 'UploadVideoField';
            muxPlaybackId: string;
            width: any;
            height: any;
          } | null;
        } | null;
      }
  >;
};

type ReportsListingContentArea_ArticlesBlockRecord_Fragment = {
  __typename?: 'ArticlesBlockRecord';
  id: any;
  title?: string | null;
  isJobArticles?: any | null;
  ctaText?: string | null;
  ctaUrl?: string | null;
  jobPages: Array<{
    __typename?: 'JobOpportunitiesPageRecord';
    id: any;
    slug?: string | null;
    title?: string | null;
    publishDate?: any | null;
    category?: string | null;
    country?: string | null;
    department?: string | null;
  }>;
  newsPages: Array<{
    __typename?: 'NewsPageRecord';
    id: any;
    slug?: string | null;
    title?: string | null;
    publishDate?: any | null;
    category?: string | null;
    country?: string | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
  }>;
  reportPages: Array<{
    __typename?: 'ReportsListingRecord';
    id: any;
    slug?: string | null;
    title?: string | null;
    publishDate?: any | null;
    category?: string | null;
    country?: string | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
    pdf?: {
      __typename?: 'FileField';
      alt?: string | null;
      filename: string;
      format: string;
      size: any;
      title?: string | null;
      url: string;
      uploadId: any;
    } | null;
  }>;
};

type ReportsListingContentArea_BrandsBlockRecord_Fragment = {
  __typename?: 'BrandsBlockRecord';
  id: any;
  title?: string | null;
  introText?: string | null;
  hideLabels?: any | null;
  brands: Array<{
    __typename?: 'BrandPageRecord';
    id: any;
    brandName?: string | null;
    slug?: string | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      tags: Array<string>;
      title?: string | null;
      url: string;
      width?: any | null;
      height?: any | null;
      format: string;
      responsiveImage?: {
        __typename?: 'ResponsiveImage';
        aspectRatio: any;
        base64?: string | null;
        bgColor?: string | null;
        height: any;
        sizes: string;
        src: string;
        srcSet: string;
        webpSrcSet: string;
        width: any;
      } | null;
    } | null;
    imageLoad?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
  }>;
};

type ReportsListingContentArea_BulletListRecord_Fragment = {
  __typename?: 'BulletListRecord';
  id: any;
  bullets?: string | null;
  numberedList?: any | null;
  title?: string | null;
};

type ReportsListingContentArea_DocumentLinkBlockRecord_Fragment = {
  __typename?: 'DocumentLinkBlockRecord';
  id: any;
  documents: Array<{
    __typename?: 'FileField';
    alt?: string | null;
    filename: string;
    format: string;
    size: any;
    title?: string | null;
    url: string;
    uploadId: any;
  }>;
};

type ReportsListingContentArea_EmployeeRecord_Fragment = {
  __typename?: 'EmployeeRecord';
  id: any;
  name?: string | null;
  title?: string | null;
  introText?: string | null;
  description?: string | null;
  image?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
};

type ReportsListingContentArea_HeroBlockRecord_Fragment = {
  __typename?: 'HeroBlockRecord';
  id: any;
  title?: string | null;
  description?: string | null;
  ctaText?: string | null;
  ctaUrl?: string | null;
  fullWidth?: any | null;
  boxColor?: { __typename?: 'ColorField'; hex: string } | null;
  textColor?: { __typename?: 'ColorField'; hex: string } | null;
  image?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
  imageOverlay?: {
    __typename?: 'OverlayRecord';
    id: any;
    opacity?: any | null;
    color?: { __typename?: 'ColorField'; hex: string } | null;
  } | null;
  ctaButtons: Array<{
    __typename?: 'CtaButtonRecord';
    id: any;
    text?: string | null;
    url?: string | null;
    variant?: string | null;
  }>;
  video?: {
    __typename?: 'FileField';
    blurUpThumb?: string | null;
    title?: string | null;
    alt?: string | null;
    video?: {
      __typename?: 'UploadVideoField';
      muxPlaybackId: string;
      width: any;
      height: any;
    } | null;
  } | null;
};

type ReportsListingContentArea_ImageRecord_Fragment = {
  __typename?: 'ImageRecord';
  id: any;
  fullWidth?: any | null;
  image?: {
    __typename?: 'FileField';
    alt?: string | null;
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  imageLoad?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
};

type ReportsListingContentArea_JobsListBlockRecord_Fragment = {
  __typename?: 'JobsListBlockRecord';
  id: any;
  title?: string | null;
};

type ReportsListingContentArea_NewsAndReportsListBlockRecord_Fragment = {
  __typename?: 'NewsAndReportsListBlockRecord';
};

type ReportsListingContentArea_NewsListBlockRecord_Fragment = {
  __typename?: 'NewsListBlockRecord';
  id: any;
  title?: string | null;
  standalone?: any | null;
  largeTitle?: any | null;
  itemsToShow?: any | null;
};

type ReportsListingContentArea_OfficesBlockRecord_Fragment = {
  __typename?: 'OfficesBlockRecord';
  id: any;
  offices: Array<{
    __typename?: 'OfficeRecord';
    id: any;
    name?: string | null;
    address?: string | null;
    zipCode?: string | null;
    city?: string | null;
    country?: string | null;
    email?: string | null;
    websiteUrl?: string | null;
    phoneNumber?: string | null;
  }>;
};

type ReportsListingContentArea_PlugBlockRecord_Fragment = {
  __typename?: 'PlugBlockRecord';
  id: any;
  title?: string | null;
  description?: string | null;
  brands: Array<{
    __typename?: 'BrandPageRecord';
    id: any;
    brandName?: string | null;
    slug?: string | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      tags: Array<string>;
      title?: string | null;
      url: string;
      width?: any | null;
      height?: any | null;
      format: string;
      responsiveImage?: {
        __typename?: 'ResponsiveImage';
        aspectRatio: any;
        base64?: string | null;
        bgColor?: string | null;
        height: any;
        sizes: string;
        src: string;
        srcSet: string;
        webpSrcSet: string;
        width: any;
      } | null;
    } | null;
    imageLoad?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
  }>;
};

type ReportsListingContentArea_ReportsListBlockRecord_Fragment = {
  __typename?: 'ReportsListBlockRecord';
  id: any;
  title?: string | null;
  standalone?: any | null;
  largeTitle?: any | null;
};

type ReportsListingContentArea_SimpleTitleAndTextBlockRecord_Fragment = {
  __typename?: 'SimpleTitleAndTextBlockRecord';
  id: any;
  title?: string | null;
  topLabel?: string | null;
  description?: string | null;
};

type ReportsListingContentArea_SliderBlockRecord_Fragment = {
  __typename?: 'SliderBlockRecord';
  title?: string | null;
  arrows?: any | null;
  slideAnimation?: any | null;
  delay?: any | null;
  dots?: any | null;
  heroes: Array<{
    __typename?: 'HeroBlockRecord';
    id: any;
    title?: string | null;
    description?: string | null;
    ctaText?: string | null;
    ctaUrl?: string | null;
    fullWidth?: any | null;
    boxColor?: { __typename?: 'ColorField'; hex: string } | null;
    textColor?: { __typename?: 'ColorField'; hex: string } | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
    imageOverlay?: {
      __typename?: 'OverlayRecord';
      id: any;
      opacity?: any | null;
      color?: { __typename?: 'ColorField'; hex: string } | null;
    } | null;
    ctaButtons: Array<{
      __typename?: 'CtaButtonRecord';
      id: any;
      text?: string | null;
      url?: string | null;
      variant?: string | null;
    }>;
    video?: {
      __typename?: 'FileField';
      blurUpThumb?: string | null;
      title?: string | null;
      alt?: string | null;
      video?: {
        __typename?: 'UploadVideoField';
        muxPlaybackId: string;
        width: any;
        height: any;
      } | null;
    } | null;
  }>;
};

type ReportsListingContentArea_StatementBlockRecord_Fragment = {
  __typename?: 'StatementBlockRecord';
  id: any;
  text?: string | null;
  blackBackground?: any | null;
  header?: string | null;
  small?: any | null;
  linkText?: string | null;
  linkUrl?: string | null;
  imageMobile?: {
    __typename?: 'FileField';
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  imageTablet?: {
    __typename?: 'FileField';
    alt?: string | null;
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  imageDesktop?: {
    __typename?: 'FileField';
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  imageLoad?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
  imageOverlay?: {
    __typename?: 'OverlayRecord';
    id: any;
    opacity?: any | null;
    color?: { __typename?: 'ColorField'; hex: string } | null;
  } | null;
};

type ReportsListingContentArea_TextBlockRecord_Fragment = {
  __typename?: 'TextBlockRecord';
  id: any;
  smallHeader?: any | null;
  header?: string | null;
  text?: string | null;
  introText?: string | null;
  ctaButtons: Array<{
    __typename?: 'CtaButtonRecord';
    id: any;
    text?: string | null;
    url?: string | null;
    variant?: string | null;
  }>;
};

type ReportsListingContentArea_TwoColumnImageAndTextRecord_Fragment = {
  __typename?: 'TwoColumnImageAndTextRecord';
  id: any;
  text?: string | null;
  title?: string | null;
  reverse?: any | null;
  image?: {
    __typename?: 'FileField';
    alt?: string | null;
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  imageLoad?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
};

type ReportsListingContentArea_TwoColumnTextIntroRecord_Fragment = {
  __typename?: 'TwoColumnTextIntroRecord';
  id: any;
  introText?: string | null;
  text?: string | null;
  header?: string | null;
};

type ReportsListingContentArea_VideoRecord_Fragment = {
  __typename?: 'VideoRecord';
  id: any;
  autoplay?: any | null;
  video?: {
    __typename?: 'FileField';
    title?: string | null;
    video?: {
      __typename?: 'UploadVideoField';
      mp4Url?: string | null;
      streamingUrl: string;
      thumbnailUrl: string;
      mp4Low?: string | null;
    } | null;
  } | null;
  videoThumbnail?: {
    __typename?: 'FileField';
    alt?: string | null;
    tags: Array<string>;
    title?: string | null;
    url: string;
    width?: any | null;
    height?: any | null;
    format: string;
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  muxVideo?: {
    __typename?: 'FileField';
    blurUpThumb?: string | null;
    title?: string | null;
    alt?: string | null;
    video?: {
      __typename?: 'UploadVideoField';
      muxPlaybackId: string;
      width: any;
      height: any;
    } | null;
  } | null;
};

export type ReportsListingContentAreaFragment =
  | ReportsListingContentArea_ArticlesBlockRecord_Fragment
  | ReportsListingContentArea_BrandsBlockRecord_Fragment
  | ReportsListingContentArea_BulletListRecord_Fragment
  | ReportsListingContentArea_DocumentLinkBlockRecord_Fragment
  | ReportsListingContentArea_EmployeeRecord_Fragment
  | ReportsListingContentArea_HeroBlockRecord_Fragment
  | ReportsListingContentArea_ImageRecord_Fragment
  | ReportsListingContentArea_JobsListBlockRecord_Fragment
  | ReportsListingContentArea_NewsAndReportsListBlockRecord_Fragment
  | ReportsListingContentArea_NewsListBlockRecord_Fragment
  | ReportsListingContentArea_OfficesBlockRecord_Fragment
  | ReportsListingContentArea_PlugBlockRecord_Fragment
  | ReportsListingContentArea_ReportsListBlockRecord_Fragment
  | ReportsListingContentArea_SimpleTitleAndTextBlockRecord_Fragment
  | ReportsListingContentArea_SliderBlockRecord_Fragment
  | ReportsListingContentArea_StatementBlockRecord_Fragment
  | ReportsListingContentArea_TextBlockRecord_Fragment
  | ReportsListingContentArea_TwoColumnImageAndTextRecord_Fragment
  | ReportsListingContentArea_TwoColumnTextIntroRecord_Fragment
  | ReportsListingContentArea_VideoRecord_Fragment;

export type ReportsListingContentFragment = {
  __typename?: 'ReportsListingRecord';
  id: any;
  title?: string | null;
  slug?: string | null;
  publishDate?: any | null;
  category?: string | null;
  pageLocales: Array<SiteLocale>;
  image?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
  pdf?: {
    __typename?: 'FileField';
    alt?: string | null;
    filename: string;
    format: string;
    size: any;
    title?: string | null;
    url: string;
    uploadId: any;
  } | null;
  seo?: {
    __typename?: 'SeoField';
    description?: string | null;
    title?: string | null;
    image?: {
      __typename?: 'FileField';
      url: string;
      alt?: string | null;
      title?: string | null;
    } | null;
  } | null;
};

type SustainabilityIndexPageContentArea_ArticlesBlockRecord_Fragment = {
  __typename?: 'ArticlesBlockRecord';
  id: any;
  title?: string | null;
  isJobArticles?: any | null;
  ctaText?: string | null;
  ctaUrl?: string | null;
  jobPages: Array<{
    __typename?: 'JobOpportunitiesPageRecord';
    id: any;
    slug?: string | null;
    title?: string | null;
    publishDate?: any | null;
    category?: string | null;
    country?: string | null;
    department?: string | null;
  }>;
  newsPages: Array<{
    __typename?: 'NewsPageRecord';
    id: any;
    slug?: string | null;
    title?: string | null;
    publishDate?: any | null;
    category?: string | null;
    country?: string | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
  }>;
  reportPages: Array<{
    __typename?: 'ReportsListingRecord';
    id: any;
    slug?: string | null;
    title?: string | null;
    publishDate?: any | null;
    category?: string | null;
    country?: string | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
    pdf?: {
      __typename?: 'FileField';
      alt?: string | null;
      filename: string;
      format: string;
      size: any;
      title?: string | null;
      url: string;
      uploadId: any;
    } | null;
  }>;
};

type SustainabilityIndexPageContentArea_BrandsBlockRecord_Fragment = {
  __typename?: 'BrandsBlockRecord';
  id: any;
  title?: string | null;
  introText?: string | null;
  hideLabels?: any | null;
  brands: Array<{
    __typename?: 'BrandPageRecord';
    id: any;
    brandName?: string | null;
    slug?: string | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      tags: Array<string>;
      title?: string | null;
      url: string;
      width?: any | null;
      height?: any | null;
      format: string;
      responsiveImage?: {
        __typename?: 'ResponsiveImage';
        aspectRatio: any;
        base64?: string | null;
        bgColor?: string | null;
        height: any;
        sizes: string;
        src: string;
        srcSet: string;
        webpSrcSet: string;
        width: any;
      } | null;
    } | null;
    imageLoad?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
  }>;
};

type SustainabilityIndexPageContentArea_BulletListRecord_Fragment = {
  __typename?: 'BulletListRecord';
  id: any;
  bullets?: string | null;
  numberedList?: any | null;
  title?: string | null;
};

type SustainabilityIndexPageContentArea_DocumentLinkBlockRecord_Fragment = {
  __typename?: 'DocumentLinkBlockRecord';
  id: any;
  documents: Array<{
    __typename?: 'FileField';
    alt?: string | null;
    filename: string;
    format: string;
    size: any;
    title?: string | null;
    url: string;
    uploadId: any;
  }>;
};

type SustainabilityIndexPageContentArea_EmployeeRecord_Fragment = {
  __typename?: 'EmployeeRecord';
  id: any;
  name?: string | null;
  title?: string | null;
  introText?: string | null;
  description?: string | null;
  image?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
};

type SustainabilityIndexPageContentArea_GridContainerBlockRecord_Fragment = {
  __typename?: 'GridContainerBlockRecord';
  id: any;
  fullwidth?: any | null;
  gap?: any | null;
  backgroundColor?: { __typename?: 'ColorField'; hex: string } | null;
  textColor?: { __typename?: 'ColorField'; hex: string } | null;
  content: Array<
    | {
        __typename?: 'GridFourcolBlockRecord';
        id: any;
        content: Array<
          | {
              __typename?: 'ImageRecord';
              id: any;
              fullWidth?: any | null;
              image?: {
                __typename?: 'FileField';
                alt?: string | null;
                responsiveImage?: {
                  __typename?: 'ResponsiveImage';
                  aspectRatio: any;
                  base64?: string | null;
                  bgColor?: string | null;
                  height: any;
                  sizes: string;
                  src: string;
                  srcSet: string;
                  webpSrcSet: string;
                  width: any;
                } | null;
              } | null;
              imageLoad?: {
                __typename?: 'FileField';
                alt?: string | null;
                title?: string | null;
                url: string;
                blurUpThumb?: string | null;
                focalPoint?: {
                  __typename?: 'focalPoint';
                  x: any;
                  y: any;
                } | null;
                colors: Array<{ __typename?: 'ColorField'; hex: string }>;
              } | null;
            }
          | {
              __typename?: 'MediaWithCaptionRecord';
              id: any;
              centerText?: any | null;
              textOnImage?: any | null;
              media?: {
                __typename?: 'ImageRecord';
                id: any;
                fullWidth?: any | null;
                image?: {
                  __typename?: 'FileField';
                  alt?: string | null;
                  responsiveImage?: {
                    __typename?: 'ResponsiveImage';
                    aspectRatio: any;
                    base64?: string | null;
                    bgColor?: string | null;
                    height: any;
                    sizes: string;
                    src: string;
                    srcSet: string;
                    webpSrcSet: string;
                    width: any;
                  } | null;
                } | null;
                imageLoad?: {
                  __typename?: 'FileField';
                  alt?: string | null;
                  title?: string | null;
                  url: string;
                  blurUpThumb?: string | null;
                  focalPoint?: {
                    __typename?: 'focalPoint';
                    x: any;
                    y: any;
                  } | null;
                  colors: Array<{ __typename?: 'ColorField'; hex: string }>;
                } | null;
              } | null;
              caption?: {
                __typename?: 'TextBlockRecord';
                id: any;
                smallHeader?: any | null;
                header?: string | null;
                text?: string | null;
                introText?: string | null;
                ctaButtons: Array<{
                  __typename?: 'CtaButtonRecord';
                  id: any;
                  text?: string | null;
                  url?: string | null;
                  variant?: string | null;
                }>;
              } | null;
            }
          | {
              __typename?: 'TextBlockRecord';
              id: any;
              smallHeader?: any | null;
              header?: string | null;
              text?: string | null;
              introText?: string | null;
              ctaButtons: Array<{
                __typename?: 'CtaButtonRecord';
                id: any;
                text?: string | null;
                url?: string | null;
                variant?: string | null;
              }>;
            }
        >;
      }
    | {
        __typename?: 'GridThreecolBlockRecord';
        id: any;
        content: Array<
          | {
              __typename?: 'GridTwocolBlockRecord';
              id: any;
              content: Array<
                | {
                    __typename?: 'ImageRecord';
                    id: any;
                    fullWidth?: any | null;
                    image?: {
                      __typename?: 'FileField';
                      alt?: string | null;
                      responsiveImage?: {
                        __typename?: 'ResponsiveImage';
                        aspectRatio: any;
                        base64?: string | null;
                        bgColor?: string | null;
                        height: any;
                        sizes: string;
                        src: string;
                        srcSet: string;
                        webpSrcSet: string;
                        width: any;
                      } | null;
                    } | null;
                    imageLoad?: {
                      __typename?: 'FileField';
                      alt?: string | null;
                      title?: string | null;
                      url: string;
                      blurUpThumb?: string | null;
                      focalPoint?: {
                        __typename?: 'focalPoint';
                        x: any;
                        y: any;
                      } | null;
                      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
                    } | null;
                  }
                | {
                    __typename?: 'MediaWithCaptionRecord';
                    id: any;
                    centerText?: any | null;
                    textOnImage?: any | null;
                    media?: {
                      __typename?: 'ImageRecord';
                      id: any;
                      fullWidth?: any | null;
                      image?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        responsiveImage?: {
                          __typename?: 'ResponsiveImage';
                          aspectRatio: any;
                          base64?: string | null;
                          bgColor?: string | null;
                          height: any;
                          sizes: string;
                          src: string;
                          srcSet: string;
                          webpSrcSet: string;
                          width: any;
                        } | null;
                      } | null;
                      imageLoad?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        title?: string | null;
                        url: string;
                        blurUpThumb?: string | null;
                        focalPoint?: {
                          __typename?: 'focalPoint';
                          x: any;
                          y: any;
                        } | null;
                        colors: Array<{
                          __typename?: 'ColorField';
                          hex: string;
                        }>;
                      } | null;
                    } | null;
                    caption?: {
                      __typename?: 'TextBlockRecord';
                      id: any;
                      smallHeader?: any | null;
                      header?: string | null;
                      text?: string | null;
                      introText?: string | null;
                      ctaButtons: Array<{
                        __typename?: 'CtaButtonRecord';
                        id: any;
                        text?: string | null;
                        url?: string | null;
                        variant?: string | null;
                      }>;
                    } | null;
                  }
                | {
                    __typename?: 'NewsListBlockRecord';
                    id: any;
                    title?: string | null;
                    standalone?: any | null;
                    largeTitle?: any | null;
                    itemsToShow?: any | null;
                  }
                | {
                    __typename?: 'ReportsListBlockRecord';
                    id: any;
                    title?: string | null;
                    standalone?: any | null;
                    largeTitle?: any | null;
                  }
                | {
                    __typename?: 'TextBlockRecord';
                    id: any;
                    smallHeader?: any | null;
                    header?: string | null;
                    text?: string | null;
                    introText?: string | null;
                    ctaButtons: Array<{
                      __typename?: 'CtaButtonRecord';
                      id: any;
                      text?: string | null;
                      url?: string | null;
                      variant?: string | null;
                    }>;
                  }
              >;
            }
          | {
              __typename?: 'ImageRecord';
              id: any;
              fullWidth?: any | null;
              image?: {
                __typename?: 'FileField';
                alt?: string | null;
                responsiveImage?: {
                  __typename?: 'ResponsiveImage';
                  aspectRatio: any;
                  base64?: string | null;
                  bgColor?: string | null;
                  height: any;
                  sizes: string;
                  src: string;
                  srcSet: string;
                  webpSrcSet: string;
                  width: any;
                } | null;
              } | null;
              imageLoad?: {
                __typename?: 'FileField';
                alt?: string | null;
                title?: string | null;
                url: string;
                blurUpThumb?: string | null;
                focalPoint?: {
                  __typename?: 'focalPoint';
                  x: any;
                  y: any;
                } | null;
                colors: Array<{ __typename?: 'ColorField'; hex: string }>;
              } | null;
            }
          | {
              __typename?: 'MediaWithCaptionRecord';
              id: any;
              centerText?: any | null;
              textOnImage?: any | null;
              media?: {
                __typename?: 'ImageRecord';
                id: any;
                fullWidth?: any | null;
                image?: {
                  __typename?: 'FileField';
                  alt?: string | null;
                  responsiveImage?: {
                    __typename?: 'ResponsiveImage';
                    aspectRatio: any;
                    base64?: string | null;
                    bgColor?: string | null;
                    height: any;
                    sizes: string;
                    src: string;
                    srcSet: string;
                    webpSrcSet: string;
                    width: any;
                  } | null;
                } | null;
                imageLoad?: {
                  __typename?: 'FileField';
                  alt?: string | null;
                  title?: string | null;
                  url: string;
                  blurUpThumb?: string | null;
                  focalPoint?: {
                    __typename?: 'focalPoint';
                    x: any;
                    y: any;
                  } | null;
                  colors: Array<{ __typename?: 'ColorField'; hex: string }>;
                } | null;
              } | null;
              caption?: {
                __typename?: 'TextBlockRecord';
                id: any;
                smallHeader?: any | null;
                header?: string | null;
                text?: string | null;
                introText?: string | null;
                ctaButtons: Array<{
                  __typename?: 'CtaButtonRecord';
                  id: any;
                  text?: string | null;
                  url?: string | null;
                  variant?: string | null;
                }>;
              } | null;
            }
          | {
              __typename?: 'TextBlockRecord';
              id: any;
              smallHeader?: any | null;
              header?: string | null;
              text?: string | null;
              introText?: string | null;
              ctaButtons: Array<{
                __typename?: 'CtaButtonRecord';
                id: any;
                text?: string | null;
                url?: string | null;
                variant?: string | null;
              }>;
            }
        >;
      }
    | {
        __typename?: 'GridTwocolBlockRecord';
        id: any;
        content: Array<
          | {
              __typename?: 'ImageRecord';
              id: any;
              fullWidth?: any | null;
              image?: {
                __typename?: 'FileField';
                alt?: string | null;
                responsiveImage?: {
                  __typename?: 'ResponsiveImage';
                  aspectRatio: any;
                  base64?: string | null;
                  bgColor?: string | null;
                  height: any;
                  sizes: string;
                  src: string;
                  srcSet: string;
                  webpSrcSet: string;
                  width: any;
                } | null;
              } | null;
              imageLoad?: {
                __typename?: 'FileField';
                alt?: string | null;
                title?: string | null;
                url: string;
                blurUpThumb?: string | null;
                focalPoint?: {
                  __typename?: 'focalPoint';
                  x: any;
                  y: any;
                } | null;
                colors: Array<{ __typename?: 'ColorField'; hex: string }>;
              } | null;
            }
          | {
              __typename?: 'MediaWithCaptionRecord';
              id: any;
              centerText?: any | null;
              textOnImage?: any | null;
              media?: {
                __typename?: 'ImageRecord';
                id: any;
                fullWidth?: any | null;
                image?: {
                  __typename?: 'FileField';
                  alt?: string | null;
                  responsiveImage?: {
                    __typename?: 'ResponsiveImage';
                    aspectRatio: any;
                    base64?: string | null;
                    bgColor?: string | null;
                    height: any;
                    sizes: string;
                    src: string;
                    srcSet: string;
                    webpSrcSet: string;
                    width: any;
                  } | null;
                } | null;
                imageLoad?: {
                  __typename?: 'FileField';
                  alt?: string | null;
                  title?: string | null;
                  url: string;
                  blurUpThumb?: string | null;
                  focalPoint?: {
                    __typename?: 'focalPoint';
                    x: any;
                    y: any;
                  } | null;
                  colors: Array<{ __typename?: 'ColorField'; hex: string }>;
                } | null;
              } | null;
              caption?: {
                __typename?: 'TextBlockRecord';
                id: any;
                smallHeader?: any | null;
                header?: string | null;
                text?: string | null;
                introText?: string | null;
                ctaButtons: Array<{
                  __typename?: 'CtaButtonRecord';
                  id: any;
                  text?: string | null;
                  url?: string | null;
                  variant?: string | null;
                }>;
              } | null;
            }
          | {
              __typename?: 'NewsListBlockRecord';
              id: any;
              title?: string | null;
              standalone?: any | null;
              largeTitle?: any | null;
              itemsToShow?: any | null;
            }
          | {
              __typename?: 'ReportsListBlockRecord';
              id: any;
              title?: string | null;
              standalone?: any | null;
              largeTitle?: any | null;
            }
          | {
              __typename?: 'TextBlockRecord';
              id: any;
              smallHeader?: any | null;
              header?: string | null;
              text?: string | null;
              introText?: string | null;
              ctaButtons: Array<{
                __typename?: 'CtaButtonRecord';
                id: any;
                text?: string | null;
                url?: string | null;
                variant?: string | null;
              }>;
            }
        >;
      }
  >;
};

type SustainabilityIndexPageContentArea_HeroBlockRecord_Fragment = {
  __typename?: 'HeroBlockRecord';
  id: any;
  title?: string | null;
  description?: string | null;
  ctaText?: string | null;
  ctaUrl?: string | null;
  fullWidth?: any | null;
  boxColor?: { __typename?: 'ColorField'; hex: string } | null;
  textColor?: { __typename?: 'ColorField'; hex: string } | null;
  image?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
  imageOverlay?: {
    __typename?: 'OverlayRecord';
    id: any;
    opacity?: any | null;
    color?: { __typename?: 'ColorField'; hex: string } | null;
  } | null;
  ctaButtons: Array<{
    __typename?: 'CtaButtonRecord';
    id: any;
    text?: string | null;
    url?: string | null;
    variant?: string | null;
  }>;
  video?: {
    __typename?: 'FileField';
    blurUpThumb?: string | null;
    title?: string | null;
    alt?: string | null;
    video?: {
      __typename?: 'UploadVideoField';
      muxPlaybackId: string;
      width: any;
      height: any;
    } | null;
  } | null;
};

type SustainabilityIndexPageContentArea_ImageRecord_Fragment = {
  __typename?: 'ImageRecord';
  id: any;
  fullWidth?: any | null;
  image?: {
    __typename?: 'FileField';
    alt?: string | null;
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  imageLoad?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
};

type SustainabilityIndexPageContentArea_NewsAndReportsListBlockRecord_Fragment =
  {
    __typename?: 'NewsAndReportsListBlockRecord';
    newsTitle?: string | null;
    reportsTitle?: string | null;
    newsImage?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
    news: Array<{
      __typename?: 'NewsPageRecord';
      id: any;
      title?: string | null;
      slug?: string | null;
      publishDate?: any | null;
      category?: string | null;
    }>;
    reportsImage?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
    reports: Array<{
      __typename?: 'ReportsListingRecord';
      id: any;
      title?: string | null;
      slug?: string | null;
      publishDate?: any | null;
      category?: string | null;
      pdf?: {
        __typename?: 'FileField';
        alt?: string | null;
        filename: string;
        format: string;
        size: any;
        title?: string | null;
        url: string;
        uploadId: any;
      } | null;
    }>;
  };

type SustainabilityIndexPageContentArea_NewsListBlockRecord_Fragment = {
  __typename?: 'NewsListBlockRecord';
  id: any;
  title?: string | null;
  standalone?: any | null;
  largeTitle?: any | null;
  itemsToShow?: any | null;
};

type SustainabilityIndexPageContentArea_OfficesBlockRecord_Fragment = {
  __typename?: 'OfficesBlockRecord';
  id: any;
  offices: Array<{
    __typename?: 'OfficeRecord';
    id: any;
    name?: string | null;
    address?: string | null;
    zipCode?: string | null;
    city?: string | null;
    country?: string | null;
    email?: string | null;
    websiteUrl?: string | null;
    phoneNumber?: string | null;
  }>;
};

type SustainabilityIndexPageContentArea_PageNavigationBlockRecord_Fragment = {
  __typename?: 'PageNavigationBlockRecord';
  id: any;
  label?: string | null;
  links: Array<{
    __typename?: 'LinkRecord';
    id: any;
    title?: string | null;
    url?: string | null;
  }>;
};

type SustainabilityIndexPageContentArea_PlugBlockRecord_Fragment = {
  __typename?: 'PlugBlockRecord';
  id: any;
  title?: string | null;
  description?: string | null;
  brands: Array<{
    __typename?: 'BrandPageRecord';
    id: any;
    brandName?: string | null;
    slug?: string | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      tags: Array<string>;
      title?: string | null;
      url: string;
      width?: any | null;
      height?: any | null;
      format: string;
      responsiveImage?: {
        __typename?: 'ResponsiveImage';
        aspectRatio: any;
        base64?: string | null;
        bgColor?: string | null;
        height: any;
        sizes: string;
        src: string;
        srcSet: string;
        webpSrcSet: string;
        width: any;
      } | null;
    } | null;
    imageLoad?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
  }>;
};

type SustainabilityIndexPageContentArea_ReportsListBlockRecord_Fragment = {
  __typename?: 'ReportsListBlockRecord';
  id: any;
  title?: string | null;
  standalone?: any | null;
  largeTitle?: any | null;
};

type SustainabilityIndexPageContentArea_SimpleTitleAndTextBlockRecord_Fragment =
  {
    __typename?: 'SimpleTitleAndTextBlockRecord';
    id: any;
    title?: string | null;
    topLabel?: string | null;
    description?: string | null;
  };

type SustainabilityIndexPageContentArea_SliderBlockRecord_Fragment = {
  __typename?: 'SliderBlockRecord';
  title?: string | null;
  arrows?: any | null;
  slideAnimation?: any | null;
  delay?: any | null;
  dots?: any | null;
  heroes: Array<{
    __typename?: 'HeroBlockRecord';
    id: any;
    title?: string | null;
    description?: string | null;
    ctaText?: string | null;
    ctaUrl?: string | null;
    fullWidth?: any | null;
    boxColor?: { __typename?: 'ColorField'; hex: string } | null;
    textColor?: { __typename?: 'ColorField'; hex: string } | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
    imageOverlay?: {
      __typename?: 'OverlayRecord';
      id: any;
      opacity?: any | null;
      color?: { __typename?: 'ColorField'; hex: string } | null;
    } | null;
    ctaButtons: Array<{
      __typename?: 'CtaButtonRecord';
      id: any;
      text?: string | null;
      url?: string | null;
      variant?: string | null;
    }>;
    video?: {
      __typename?: 'FileField';
      blurUpThumb?: string | null;
      title?: string | null;
      alt?: string | null;
      video?: {
        __typename?: 'UploadVideoField';
        muxPlaybackId: string;
        width: any;
        height: any;
      } | null;
    } | null;
  }>;
};

type SustainabilityIndexPageContentArea_StatementBlockRecord_Fragment = {
  __typename?: 'StatementBlockRecord';
  id: any;
  text?: string | null;
  blackBackground?: any | null;
  header?: string | null;
  small?: any | null;
  linkText?: string | null;
  linkUrl?: string | null;
  imageMobile?: {
    __typename?: 'FileField';
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  imageTablet?: {
    __typename?: 'FileField';
    alt?: string | null;
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  imageDesktop?: {
    __typename?: 'FileField';
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  imageLoad?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
  imageOverlay?: {
    __typename?: 'OverlayRecord';
    id: any;
    opacity?: any | null;
    color?: { __typename?: 'ColorField'; hex: string } | null;
  } | null;
};

type SustainabilityIndexPageContentArea_SubheadingBlockRecord_Fragment = {
  __typename?: 'SubheadingBlockRecord';
  id: any;
  title?: string | null;
  text?: string | null;
  ctaButton?: {
    __typename?: 'CtaButtonRecord';
    id: any;
    text?: string | null;
    url?: string | null;
    variant?: string | null;
  } | null;
  backgroundColor?: { __typename?: 'ColorField'; hex: string } | null;
};

type SustainabilityIndexPageContentArea_SustainabilityReportsBlockRecord_Fragment =
  {
    __typename?: 'SustainabilityReportsBlockRecord';
    id: any;
    title?: string | null;
    reports: Array<{
      __typename?: 'FileField';
      alt?: string | null;
      filename: string;
      format: string;
      size: any;
      title?: string | null;
      url: string;
      uploadId: any;
    }>;
  };

type SustainabilityIndexPageContentArea_TextBlockRecord_Fragment = {
  __typename?: 'TextBlockRecord';
  id: any;
  smallHeader?: any | null;
  header?: string | null;
  text?: string | null;
  introText?: string | null;
  ctaButtons: Array<{
    __typename?: 'CtaButtonRecord';
    id: any;
    text?: string | null;
    url?: string | null;
    variant?: string | null;
  }>;
};

type SustainabilityIndexPageContentArea_TwoColumnImageAndTextRecord_Fragment = {
  __typename?: 'TwoColumnImageAndTextRecord';
  id: any;
  text?: string | null;
  title?: string | null;
  reverse?: any | null;
  image?: {
    __typename?: 'FileField';
    alt?: string | null;
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  imageLoad?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
};

type SustainabilityIndexPageContentArea_TwoColumnTextIntroRecord_Fragment = {
  __typename?: 'TwoColumnTextIntroRecord';
  id: any;
  introText?: string | null;
  text?: string | null;
  header?: string | null;
};

type SustainabilityIndexPageContentArea_VideoRecord_Fragment = {
  __typename?: 'VideoRecord';
  id: any;
  autoplay?: any | null;
  video?: {
    __typename?: 'FileField';
    title?: string | null;
    video?: {
      __typename?: 'UploadVideoField';
      mp4Url?: string | null;
      streamingUrl: string;
      thumbnailUrl: string;
      mp4Low?: string | null;
    } | null;
  } | null;
  videoThumbnail?: {
    __typename?: 'FileField';
    alt?: string | null;
    tags: Array<string>;
    title?: string | null;
    url: string;
    width?: any | null;
    height?: any | null;
    format: string;
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  muxVideo?: {
    __typename?: 'FileField';
    blurUpThumb?: string | null;
    title?: string | null;
    alt?: string | null;
    video?: {
      __typename?: 'UploadVideoField';
      muxPlaybackId: string;
      width: any;
      height: any;
    } | null;
  } | null;
};

export type SustainabilityIndexPageContentAreaFragment =
  | SustainabilityIndexPageContentArea_ArticlesBlockRecord_Fragment
  | SustainabilityIndexPageContentArea_BrandsBlockRecord_Fragment
  | SustainabilityIndexPageContentArea_BulletListRecord_Fragment
  | SustainabilityIndexPageContentArea_DocumentLinkBlockRecord_Fragment
  | SustainabilityIndexPageContentArea_EmployeeRecord_Fragment
  | SustainabilityIndexPageContentArea_GridContainerBlockRecord_Fragment
  | SustainabilityIndexPageContentArea_HeroBlockRecord_Fragment
  | SustainabilityIndexPageContentArea_ImageRecord_Fragment
  | SustainabilityIndexPageContentArea_NewsAndReportsListBlockRecord_Fragment
  | SustainabilityIndexPageContentArea_NewsListBlockRecord_Fragment
  | SustainabilityIndexPageContentArea_OfficesBlockRecord_Fragment
  | SustainabilityIndexPageContentArea_PageNavigationBlockRecord_Fragment
  | SustainabilityIndexPageContentArea_PlugBlockRecord_Fragment
  | SustainabilityIndexPageContentArea_ReportsListBlockRecord_Fragment
  | SustainabilityIndexPageContentArea_SimpleTitleAndTextBlockRecord_Fragment
  | SustainabilityIndexPageContentArea_SliderBlockRecord_Fragment
  | SustainabilityIndexPageContentArea_StatementBlockRecord_Fragment
  | SustainabilityIndexPageContentArea_SubheadingBlockRecord_Fragment
  | SustainabilityIndexPageContentArea_SustainabilityReportsBlockRecord_Fragment
  | SustainabilityIndexPageContentArea_TextBlockRecord_Fragment
  | SustainabilityIndexPageContentArea_TwoColumnImageAndTextRecord_Fragment
  | SustainabilityIndexPageContentArea_TwoColumnTextIntroRecord_Fragment
  | SustainabilityIndexPageContentArea_VideoRecord_Fragment;

export type SustainabilityIndexPageContentFragment = {
  __typename?: 'SustainabilityIndexPageRecord';
  id: any;
  pageLocales: Array<SiteLocale>;
  seo?: {
    __typename?: 'SeoField';
    description?: string | null;
    title?: string | null;
    image?: {
      __typename?: 'FileField';
      url: string;
      alt?: string | null;
      title?: string | null;
    } | null;
  } | null;
  contentArea: Array<
    | {
        __typename?: 'ArticlesBlockRecord';
        id: any;
        title?: string | null;
        isJobArticles?: any | null;
        ctaText?: string | null;
        ctaUrl?: string | null;
        jobPages: Array<{
          __typename?: 'JobOpportunitiesPageRecord';
          id: any;
          slug?: string | null;
          title?: string | null;
          publishDate?: any | null;
          category?: string | null;
          country?: string | null;
          department?: string | null;
        }>;
        newsPages: Array<{
          __typename?: 'NewsPageRecord';
          id: any;
          slug?: string | null;
          title?: string | null;
          publishDate?: any | null;
          category?: string | null;
          country?: string | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
        }>;
        reportPages: Array<{
          __typename?: 'ReportsListingRecord';
          id: any;
          slug?: string | null;
          title?: string | null;
          publishDate?: any | null;
          category?: string | null;
          country?: string | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
          pdf?: {
            __typename?: 'FileField';
            alt?: string | null;
            filename: string;
            format: string;
            size: any;
            title?: string | null;
            url: string;
            uploadId: any;
          } | null;
        }>;
      }
    | {
        __typename?: 'BrandsBlockRecord';
        id: any;
        title?: string | null;
        introText?: string | null;
        hideLabels?: any | null;
        brands: Array<{
          __typename?: 'BrandPageRecord';
          id: any;
          brandName?: string | null;
          slug?: string | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            tags: Array<string>;
            title?: string | null;
            url: string;
            width?: any | null;
            height?: any | null;
            format: string;
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageLoad?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
        }>;
      }
    | {
        __typename?: 'BulletListRecord';
        id: any;
        bullets?: string | null;
        numberedList?: any | null;
        title?: string | null;
      }
    | {
        __typename?: 'DocumentLinkBlockRecord';
        id: any;
        documents: Array<{
          __typename?: 'FileField';
          alt?: string | null;
          filename: string;
          format: string;
          size: any;
          title?: string | null;
          url: string;
          uploadId: any;
        }>;
      }
    | {
        __typename?: 'EmployeeRecord';
        id: any;
        name?: string | null;
        title?: string | null;
        introText?: string | null;
        description?: string | null;
        image?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
      }
    | {
        __typename?: 'GridContainerBlockRecord';
        id: any;
        fullwidth?: any | null;
        gap?: any | null;
        backgroundColor?: { __typename?: 'ColorField'; hex: string } | null;
        textColor?: { __typename?: 'ColorField'; hex: string } | null;
        content: Array<
          | {
              __typename?: 'GridFourcolBlockRecord';
              id: any;
              content: Array<
                | {
                    __typename?: 'ImageRecord';
                    id: any;
                    fullWidth?: any | null;
                    image?: {
                      __typename?: 'FileField';
                      alt?: string | null;
                      responsiveImage?: {
                        __typename?: 'ResponsiveImage';
                        aspectRatio: any;
                        base64?: string | null;
                        bgColor?: string | null;
                        height: any;
                        sizes: string;
                        src: string;
                        srcSet: string;
                        webpSrcSet: string;
                        width: any;
                      } | null;
                    } | null;
                    imageLoad?: {
                      __typename?: 'FileField';
                      alt?: string | null;
                      title?: string | null;
                      url: string;
                      blurUpThumb?: string | null;
                      focalPoint?: {
                        __typename?: 'focalPoint';
                        x: any;
                        y: any;
                      } | null;
                      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
                    } | null;
                  }
                | {
                    __typename?: 'MediaWithCaptionRecord';
                    id: any;
                    centerText?: any | null;
                    textOnImage?: any | null;
                    media?: {
                      __typename?: 'ImageRecord';
                      id: any;
                      fullWidth?: any | null;
                      image?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        responsiveImage?: {
                          __typename?: 'ResponsiveImage';
                          aspectRatio: any;
                          base64?: string | null;
                          bgColor?: string | null;
                          height: any;
                          sizes: string;
                          src: string;
                          srcSet: string;
                          webpSrcSet: string;
                          width: any;
                        } | null;
                      } | null;
                      imageLoad?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        title?: string | null;
                        url: string;
                        blurUpThumb?: string | null;
                        focalPoint?: {
                          __typename?: 'focalPoint';
                          x: any;
                          y: any;
                        } | null;
                        colors: Array<{
                          __typename?: 'ColorField';
                          hex: string;
                        }>;
                      } | null;
                    } | null;
                    caption?: {
                      __typename?: 'TextBlockRecord';
                      id: any;
                      smallHeader?: any | null;
                      header?: string | null;
                      text?: string | null;
                      introText?: string | null;
                      ctaButtons: Array<{
                        __typename?: 'CtaButtonRecord';
                        id: any;
                        text?: string | null;
                        url?: string | null;
                        variant?: string | null;
                      }>;
                    } | null;
                  }
                | {
                    __typename?: 'TextBlockRecord';
                    id: any;
                    smallHeader?: any | null;
                    header?: string | null;
                    text?: string | null;
                    introText?: string | null;
                    ctaButtons: Array<{
                      __typename?: 'CtaButtonRecord';
                      id: any;
                      text?: string | null;
                      url?: string | null;
                      variant?: string | null;
                    }>;
                  }
              >;
            }
          | {
              __typename?: 'GridThreecolBlockRecord';
              id: any;
              content: Array<
                | {
                    __typename?: 'GridTwocolBlockRecord';
                    id: any;
                    content: Array<
                      | {
                          __typename?: 'ImageRecord';
                          id: any;
                          fullWidth?: any | null;
                          image?: {
                            __typename?: 'FileField';
                            alt?: string | null;
                            responsiveImage?: {
                              __typename?: 'ResponsiveImage';
                              aspectRatio: any;
                              base64?: string | null;
                              bgColor?: string | null;
                              height: any;
                              sizes: string;
                              src: string;
                              srcSet: string;
                              webpSrcSet: string;
                              width: any;
                            } | null;
                          } | null;
                          imageLoad?: {
                            __typename?: 'FileField';
                            alt?: string | null;
                            title?: string | null;
                            url: string;
                            blurUpThumb?: string | null;
                            focalPoint?: {
                              __typename?: 'focalPoint';
                              x: any;
                              y: any;
                            } | null;
                            colors: Array<{
                              __typename?: 'ColorField';
                              hex: string;
                            }>;
                          } | null;
                        }
                      | {
                          __typename?: 'MediaWithCaptionRecord';
                          id: any;
                          centerText?: any | null;
                          textOnImage?: any | null;
                          media?: {
                            __typename?: 'ImageRecord';
                            id: any;
                            fullWidth?: any | null;
                            image?: {
                              __typename?: 'FileField';
                              alt?: string | null;
                              responsiveImage?: {
                                __typename?: 'ResponsiveImage';
                                aspectRatio: any;
                                base64?: string | null;
                                bgColor?: string | null;
                                height: any;
                                sizes: string;
                                src: string;
                                srcSet: string;
                                webpSrcSet: string;
                                width: any;
                              } | null;
                            } | null;
                            imageLoad?: {
                              __typename?: 'FileField';
                              alt?: string | null;
                              title?: string | null;
                              url: string;
                              blurUpThumb?: string | null;
                              focalPoint?: {
                                __typename?: 'focalPoint';
                                x: any;
                                y: any;
                              } | null;
                              colors: Array<{
                                __typename?: 'ColorField';
                                hex: string;
                              }>;
                            } | null;
                          } | null;
                          caption?: {
                            __typename?: 'TextBlockRecord';
                            id: any;
                            smallHeader?: any | null;
                            header?: string | null;
                            text?: string | null;
                            introText?: string | null;
                            ctaButtons: Array<{
                              __typename?: 'CtaButtonRecord';
                              id: any;
                              text?: string | null;
                              url?: string | null;
                              variant?: string | null;
                            }>;
                          } | null;
                        }
                      | {
                          __typename?: 'NewsListBlockRecord';
                          id: any;
                          title?: string | null;
                          standalone?: any | null;
                          largeTitle?: any | null;
                          itemsToShow?: any | null;
                        }
                      | {
                          __typename?: 'ReportsListBlockRecord';
                          id: any;
                          title?: string | null;
                          standalone?: any | null;
                          largeTitle?: any | null;
                        }
                      | {
                          __typename?: 'TextBlockRecord';
                          id: any;
                          smallHeader?: any | null;
                          header?: string | null;
                          text?: string | null;
                          introText?: string | null;
                          ctaButtons: Array<{
                            __typename?: 'CtaButtonRecord';
                            id: any;
                            text?: string | null;
                            url?: string | null;
                            variant?: string | null;
                          }>;
                        }
                    >;
                  }
                | {
                    __typename?: 'ImageRecord';
                    id: any;
                    fullWidth?: any | null;
                    image?: {
                      __typename?: 'FileField';
                      alt?: string | null;
                      responsiveImage?: {
                        __typename?: 'ResponsiveImage';
                        aspectRatio: any;
                        base64?: string | null;
                        bgColor?: string | null;
                        height: any;
                        sizes: string;
                        src: string;
                        srcSet: string;
                        webpSrcSet: string;
                        width: any;
                      } | null;
                    } | null;
                    imageLoad?: {
                      __typename?: 'FileField';
                      alt?: string | null;
                      title?: string | null;
                      url: string;
                      blurUpThumb?: string | null;
                      focalPoint?: {
                        __typename?: 'focalPoint';
                        x: any;
                        y: any;
                      } | null;
                      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
                    } | null;
                  }
                | {
                    __typename?: 'MediaWithCaptionRecord';
                    id: any;
                    centerText?: any | null;
                    textOnImage?: any | null;
                    media?: {
                      __typename?: 'ImageRecord';
                      id: any;
                      fullWidth?: any | null;
                      image?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        responsiveImage?: {
                          __typename?: 'ResponsiveImage';
                          aspectRatio: any;
                          base64?: string | null;
                          bgColor?: string | null;
                          height: any;
                          sizes: string;
                          src: string;
                          srcSet: string;
                          webpSrcSet: string;
                          width: any;
                        } | null;
                      } | null;
                      imageLoad?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        title?: string | null;
                        url: string;
                        blurUpThumb?: string | null;
                        focalPoint?: {
                          __typename?: 'focalPoint';
                          x: any;
                          y: any;
                        } | null;
                        colors: Array<{
                          __typename?: 'ColorField';
                          hex: string;
                        }>;
                      } | null;
                    } | null;
                    caption?: {
                      __typename?: 'TextBlockRecord';
                      id: any;
                      smallHeader?: any | null;
                      header?: string | null;
                      text?: string | null;
                      introText?: string | null;
                      ctaButtons: Array<{
                        __typename?: 'CtaButtonRecord';
                        id: any;
                        text?: string | null;
                        url?: string | null;
                        variant?: string | null;
                      }>;
                    } | null;
                  }
                | {
                    __typename?: 'TextBlockRecord';
                    id: any;
                    smallHeader?: any | null;
                    header?: string | null;
                    text?: string | null;
                    introText?: string | null;
                    ctaButtons: Array<{
                      __typename?: 'CtaButtonRecord';
                      id: any;
                      text?: string | null;
                      url?: string | null;
                      variant?: string | null;
                    }>;
                  }
              >;
            }
          | {
              __typename?: 'GridTwocolBlockRecord';
              id: any;
              content: Array<
                | {
                    __typename?: 'ImageRecord';
                    id: any;
                    fullWidth?: any | null;
                    image?: {
                      __typename?: 'FileField';
                      alt?: string | null;
                      responsiveImage?: {
                        __typename?: 'ResponsiveImage';
                        aspectRatio: any;
                        base64?: string | null;
                        bgColor?: string | null;
                        height: any;
                        sizes: string;
                        src: string;
                        srcSet: string;
                        webpSrcSet: string;
                        width: any;
                      } | null;
                    } | null;
                    imageLoad?: {
                      __typename?: 'FileField';
                      alt?: string | null;
                      title?: string | null;
                      url: string;
                      blurUpThumb?: string | null;
                      focalPoint?: {
                        __typename?: 'focalPoint';
                        x: any;
                        y: any;
                      } | null;
                      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
                    } | null;
                  }
                | {
                    __typename?: 'MediaWithCaptionRecord';
                    id: any;
                    centerText?: any | null;
                    textOnImage?: any | null;
                    media?: {
                      __typename?: 'ImageRecord';
                      id: any;
                      fullWidth?: any | null;
                      image?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        responsiveImage?: {
                          __typename?: 'ResponsiveImage';
                          aspectRatio: any;
                          base64?: string | null;
                          bgColor?: string | null;
                          height: any;
                          sizes: string;
                          src: string;
                          srcSet: string;
                          webpSrcSet: string;
                          width: any;
                        } | null;
                      } | null;
                      imageLoad?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        title?: string | null;
                        url: string;
                        blurUpThumb?: string | null;
                        focalPoint?: {
                          __typename?: 'focalPoint';
                          x: any;
                          y: any;
                        } | null;
                        colors: Array<{
                          __typename?: 'ColorField';
                          hex: string;
                        }>;
                      } | null;
                    } | null;
                    caption?: {
                      __typename?: 'TextBlockRecord';
                      id: any;
                      smallHeader?: any | null;
                      header?: string | null;
                      text?: string | null;
                      introText?: string | null;
                      ctaButtons: Array<{
                        __typename?: 'CtaButtonRecord';
                        id: any;
                        text?: string | null;
                        url?: string | null;
                        variant?: string | null;
                      }>;
                    } | null;
                  }
                | {
                    __typename?: 'NewsListBlockRecord';
                    id: any;
                    title?: string | null;
                    standalone?: any | null;
                    largeTitle?: any | null;
                    itemsToShow?: any | null;
                  }
                | {
                    __typename?: 'ReportsListBlockRecord';
                    id: any;
                    title?: string | null;
                    standalone?: any | null;
                    largeTitle?: any | null;
                  }
                | {
                    __typename?: 'TextBlockRecord';
                    id: any;
                    smallHeader?: any | null;
                    header?: string | null;
                    text?: string | null;
                    introText?: string | null;
                    ctaButtons: Array<{
                      __typename?: 'CtaButtonRecord';
                      id: any;
                      text?: string | null;
                      url?: string | null;
                      variant?: string | null;
                    }>;
                  }
              >;
            }
        >;
      }
    | {
        __typename?: 'HeroBlockRecord';
        id: any;
        title?: string | null;
        description?: string | null;
        ctaText?: string | null;
        ctaUrl?: string | null;
        fullWidth?: any | null;
        boxColor?: { __typename?: 'ColorField'; hex: string } | null;
        textColor?: { __typename?: 'ColorField'; hex: string } | null;
        image?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
        imageOverlay?: {
          __typename?: 'OverlayRecord';
          id: any;
          opacity?: any | null;
          color?: { __typename?: 'ColorField'; hex: string } | null;
        } | null;
        ctaButtons: Array<{
          __typename?: 'CtaButtonRecord';
          id: any;
          text?: string | null;
          url?: string | null;
          variant?: string | null;
        }>;
        video?: {
          __typename?: 'FileField';
          blurUpThumb?: string | null;
          title?: string | null;
          alt?: string | null;
          video?: {
            __typename?: 'UploadVideoField';
            muxPlaybackId: string;
            width: any;
            height: any;
          } | null;
        } | null;
      }
    | {
        __typename?: 'ImageRecord';
        id: any;
        fullWidth?: any | null;
        image?: {
          __typename?: 'FileField';
          alt?: string | null;
          responsiveImage?: {
            __typename?: 'ResponsiveImage';
            aspectRatio: any;
            base64?: string | null;
            bgColor?: string | null;
            height: any;
            sizes: string;
            src: string;
            srcSet: string;
            webpSrcSet: string;
            width: any;
          } | null;
        } | null;
        imageLoad?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
      }
    | {
        __typename?: 'NewsAndReportsListBlockRecord';
        newsTitle?: string | null;
        reportsTitle?: string | null;
        newsImage?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
        news: Array<{
          __typename?: 'NewsPageRecord';
          id: any;
          title?: string | null;
          slug?: string | null;
          publishDate?: any | null;
          category?: string | null;
        }>;
        reportsImage?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
        reports: Array<{
          __typename?: 'ReportsListingRecord';
          id: any;
          title?: string | null;
          slug?: string | null;
          publishDate?: any | null;
          category?: string | null;
          pdf?: {
            __typename?: 'FileField';
            alt?: string | null;
            filename: string;
            format: string;
            size: any;
            title?: string | null;
            url: string;
            uploadId: any;
          } | null;
        }>;
      }
    | {
        __typename?: 'NewsListBlockRecord';
        id: any;
        title?: string | null;
        standalone?: any | null;
        largeTitle?: any | null;
        itemsToShow?: any | null;
      }
    | {
        __typename?: 'OfficesBlockRecord';
        id: any;
        offices: Array<{
          __typename?: 'OfficeRecord';
          id: any;
          name?: string | null;
          address?: string | null;
          zipCode?: string | null;
          city?: string | null;
          country?: string | null;
          email?: string | null;
          websiteUrl?: string | null;
          phoneNumber?: string | null;
        }>;
      }
    | {
        __typename?: 'PageNavigationBlockRecord';
        id: any;
        label?: string | null;
        links: Array<{
          __typename?: 'LinkRecord';
          id: any;
          title?: string | null;
          url?: string | null;
        }>;
      }
    | {
        __typename?: 'PlugBlockRecord';
        id: any;
        title?: string | null;
        description?: string | null;
        brands: Array<{
          __typename?: 'BrandPageRecord';
          id: any;
          brandName?: string | null;
          slug?: string | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            tags: Array<string>;
            title?: string | null;
            url: string;
            width?: any | null;
            height?: any | null;
            format: string;
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageLoad?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
        }>;
      }
    | {
        __typename?: 'ReportsListBlockRecord';
        id: any;
        title?: string | null;
        standalone?: any | null;
        largeTitle?: any | null;
      }
    | {
        __typename?: 'SimpleTitleAndTextBlockRecord';
        id: any;
        title?: string | null;
        topLabel?: string | null;
        description?: string | null;
      }
    | {
        __typename?: 'SliderBlockRecord';
        title?: string | null;
        arrows?: any | null;
        slideAnimation?: any | null;
        delay?: any | null;
        dots?: any | null;
        heroes: Array<{
          __typename?: 'HeroBlockRecord';
          id: any;
          title?: string | null;
          description?: string | null;
          ctaText?: string | null;
          ctaUrl?: string | null;
          fullWidth?: any | null;
          boxColor?: { __typename?: 'ColorField'; hex: string } | null;
          textColor?: { __typename?: 'ColorField'; hex: string } | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
          imageOverlay?: {
            __typename?: 'OverlayRecord';
            id: any;
            opacity?: any | null;
            color?: { __typename?: 'ColorField'; hex: string } | null;
          } | null;
          ctaButtons: Array<{
            __typename?: 'CtaButtonRecord';
            id: any;
            text?: string | null;
            url?: string | null;
            variant?: string | null;
          }>;
          video?: {
            __typename?: 'FileField';
            blurUpThumb?: string | null;
            title?: string | null;
            alt?: string | null;
            video?: {
              __typename?: 'UploadVideoField';
              muxPlaybackId: string;
              width: any;
              height: any;
            } | null;
          } | null;
        }>;
      }
    | {
        __typename?: 'StatementBlockRecord';
        id: any;
        text?: string | null;
        blackBackground?: any | null;
        header?: string | null;
        small?: any | null;
        linkText?: string | null;
        linkUrl?: string | null;
        imageMobile?: {
          __typename?: 'FileField';
          responsiveImage?: {
            __typename?: 'ResponsiveImage';
            aspectRatio: any;
            base64?: string | null;
            bgColor?: string | null;
            height: any;
            sizes: string;
            src: string;
            srcSet: string;
            webpSrcSet: string;
            width: any;
          } | null;
        } | null;
        imageTablet?: {
          __typename?: 'FileField';
          alt?: string | null;
          responsiveImage?: {
            __typename?: 'ResponsiveImage';
            aspectRatio: any;
            base64?: string | null;
            bgColor?: string | null;
            height: any;
            sizes: string;
            src: string;
            srcSet: string;
            webpSrcSet: string;
            width: any;
          } | null;
        } | null;
        imageDesktop?: {
          __typename?: 'FileField';
          responsiveImage?: {
            __typename?: 'ResponsiveImage';
            aspectRatio: any;
            base64?: string | null;
            bgColor?: string | null;
            height: any;
            sizes: string;
            src: string;
            srcSet: string;
            webpSrcSet: string;
            width: any;
          } | null;
        } | null;
        imageLoad?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
        imageOverlay?: {
          __typename?: 'OverlayRecord';
          id: any;
          opacity?: any | null;
          color?: { __typename?: 'ColorField'; hex: string } | null;
        } | null;
      }
    | {
        __typename?: 'SubheadingBlockRecord';
        id: any;
        title?: string | null;
        text?: string | null;
        ctaButton?: {
          __typename?: 'CtaButtonRecord';
          id: any;
          text?: string | null;
          url?: string | null;
          variant?: string | null;
        } | null;
        backgroundColor?: { __typename?: 'ColorField'; hex: string } | null;
      }
    | {
        __typename?: 'SustainabilityReportsBlockRecord';
        id: any;
        title?: string | null;
        reports: Array<{
          __typename?: 'FileField';
          alt?: string | null;
          filename: string;
          format: string;
          size: any;
          title?: string | null;
          url: string;
          uploadId: any;
        }>;
      }
    | {
        __typename?: 'TextBlockRecord';
        id: any;
        smallHeader?: any | null;
        header?: string | null;
        text?: string | null;
        introText?: string | null;
        ctaButtons: Array<{
          __typename?: 'CtaButtonRecord';
          id: any;
          text?: string | null;
          url?: string | null;
          variant?: string | null;
        }>;
      }
    | {
        __typename?: 'TwoColumnImageAndTextRecord';
        id: any;
        text?: string | null;
        title?: string | null;
        reverse?: any | null;
        image?: {
          __typename?: 'FileField';
          alt?: string | null;
          responsiveImage?: {
            __typename?: 'ResponsiveImage';
            aspectRatio: any;
            base64?: string | null;
            bgColor?: string | null;
            height: any;
            sizes: string;
            src: string;
            srcSet: string;
            webpSrcSet: string;
            width: any;
          } | null;
        } | null;
        imageLoad?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
      }
    | {
        __typename?: 'TwoColumnTextIntroRecord';
        id: any;
        introText?: string | null;
        text?: string | null;
        header?: string | null;
      }
    | {
        __typename?: 'VideoRecord';
        id: any;
        autoplay?: any | null;
        video?: {
          __typename?: 'FileField';
          title?: string | null;
          video?: {
            __typename?: 'UploadVideoField';
            mp4Url?: string | null;
            streamingUrl: string;
            thumbnailUrl: string;
            mp4Low?: string | null;
          } | null;
        } | null;
        videoThumbnail?: {
          __typename?: 'FileField';
          alt?: string | null;
          tags: Array<string>;
          title?: string | null;
          url: string;
          width?: any | null;
          height?: any | null;
          format: string;
          responsiveImage?: {
            __typename?: 'ResponsiveImage';
            aspectRatio: any;
            base64?: string | null;
            bgColor?: string | null;
            height: any;
            sizes: string;
            src: string;
            srcSet: string;
            webpSrcSet: string;
            width: any;
          } | null;
        } | null;
        muxVideo?: {
          __typename?: 'FileField';
          blurUpThumb?: string | null;
          title?: string | null;
          alt?: string | null;
          video?: {
            __typename?: 'UploadVideoField';
            muxPlaybackId: string;
            width: any;
            height: any;
          } | null;
        } | null;
      }
  >;
};

type SustainabilityPageContentArea_ArticlesBlockRecord_Fragment = {
  __typename?: 'ArticlesBlockRecord';
  id: any;
  title?: string | null;
  isJobArticles?: any | null;
  ctaText?: string | null;
  ctaUrl?: string | null;
  jobPages: Array<{
    __typename?: 'JobOpportunitiesPageRecord';
    id: any;
    slug?: string | null;
    title?: string | null;
    publishDate?: any | null;
    category?: string | null;
    country?: string | null;
    department?: string | null;
  }>;
  newsPages: Array<{
    __typename?: 'NewsPageRecord';
    id: any;
    slug?: string | null;
    title?: string | null;
    publishDate?: any | null;
    category?: string | null;
    country?: string | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
  }>;
  reportPages: Array<{
    __typename?: 'ReportsListingRecord';
    id: any;
    slug?: string | null;
    title?: string | null;
    publishDate?: any | null;
    category?: string | null;
    country?: string | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
    pdf?: {
      __typename?: 'FileField';
      alt?: string | null;
      filename: string;
      format: string;
      size: any;
      title?: string | null;
      url: string;
      uploadId: any;
    } | null;
  }>;
};

type SustainabilityPageContentArea_BrandsBlockRecord_Fragment = {
  __typename?: 'BrandsBlockRecord';
  id: any;
  title?: string | null;
  introText?: string | null;
  hideLabels?: any | null;
  brands: Array<{
    __typename?: 'BrandPageRecord';
    id: any;
    brandName?: string | null;
    slug?: string | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      tags: Array<string>;
      title?: string | null;
      url: string;
      width?: any | null;
      height?: any | null;
      format: string;
      responsiveImage?: {
        __typename?: 'ResponsiveImage';
        aspectRatio: any;
        base64?: string | null;
        bgColor?: string | null;
        height: any;
        sizes: string;
        src: string;
        srcSet: string;
        webpSrcSet: string;
        width: any;
      } | null;
    } | null;
    imageLoad?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
  }>;
};

type SustainabilityPageContentArea_BulletListRecord_Fragment = {
  __typename?: 'BulletListRecord';
  id: any;
  bullets?: string | null;
  numberedList?: any | null;
  title?: string | null;
};

type SustainabilityPageContentArea_DocumentLinkBlockRecord_Fragment = {
  __typename?: 'DocumentLinkBlockRecord';
  id: any;
  documents: Array<{
    __typename?: 'FileField';
    alt?: string | null;
    filename: string;
    format: string;
    size: any;
    title?: string | null;
    url: string;
    uploadId: any;
  }>;
};

type SustainabilityPageContentArea_EmployeeRecord_Fragment = {
  __typename?: 'EmployeeRecord';
  id: any;
  name?: string | null;
  title?: string | null;
  introText?: string | null;
  description?: string | null;
  image?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
};

type SustainabilityPageContentArea_GridContainerBlockRecord_Fragment = {
  __typename?: 'GridContainerBlockRecord';
  id: any;
  fullwidth?: any | null;
  gap?: any | null;
  backgroundColor?: { __typename?: 'ColorField'; hex: string } | null;
  textColor?: { __typename?: 'ColorField'; hex: string } | null;
  content: Array<
    | {
        __typename?: 'GridFourcolBlockRecord';
        id: any;
        content: Array<
          | {
              __typename?: 'ImageRecord';
              id: any;
              fullWidth?: any | null;
              image?: {
                __typename?: 'FileField';
                alt?: string | null;
                responsiveImage?: {
                  __typename?: 'ResponsiveImage';
                  aspectRatio: any;
                  base64?: string | null;
                  bgColor?: string | null;
                  height: any;
                  sizes: string;
                  src: string;
                  srcSet: string;
                  webpSrcSet: string;
                  width: any;
                } | null;
              } | null;
              imageLoad?: {
                __typename?: 'FileField';
                alt?: string | null;
                title?: string | null;
                url: string;
                blurUpThumb?: string | null;
                focalPoint?: {
                  __typename?: 'focalPoint';
                  x: any;
                  y: any;
                } | null;
                colors: Array<{ __typename?: 'ColorField'; hex: string }>;
              } | null;
            }
          | {
              __typename?: 'MediaWithCaptionRecord';
              id: any;
              centerText?: any | null;
              textOnImage?: any | null;
              media?: {
                __typename?: 'ImageRecord';
                id: any;
                fullWidth?: any | null;
                image?: {
                  __typename?: 'FileField';
                  alt?: string | null;
                  responsiveImage?: {
                    __typename?: 'ResponsiveImage';
                    aspectRatio: any;
                    base64?: string | null;
                    bgColor?: string | null;
                    height: any;
                    sizes: string;
                    src: string;
                    srcSet: string;
                    webpSrcSet: string;
                    width: any;
                  } | null;
                } | null;
                imageLoad?: {
                  __typename?: 'FileField';
                  alt?: string | null;
                  title?: string | null;
                  url: string;
                  blurUpThumb?: string | null;
                  focalPoint?: {
                    __typename?: 'focalPoint';
                    x: any;
                    y: any;
                  } | null;
                  colors: Array<{ __typename?: 'ColorField'; hex: string }>;
                } | null;
              } | null;
              caption?: {
                __typename?: 'TextBlockRecord';
                id: any;
                smallHeader?: any | null;
                header?: string | null;
                text?: string | null;
                introText?: string | null;
                ctaButtons: Array<{
                  __typename?: 'CtaButtonRecord';
                  id: any;
                  text?: string | null;
                  url?: string | null;
                  variant?: string | null;
                }>;
              } | null;
            }
          | {
              __typename?: 'TextBlockRecord';
              id: any;
              smallHeader?: any | null;
              header?: string | null;
              text?: string | null;
              introText?: string | null;
              ctaButtons: Array<{
                __typename?: 'CtaButtonRecord';
                id: any;
                text?: string | null;
                url?: string | null;
                variant?: string | null;
              }>;
            }
        >;
      }
    | {
        __typename?: 'GridThreecolBlockRecord';
        id: any;
        content: Array<
          | {
              __typename?: 'GridTwocolBlockRecord';
              id: any;
              content: Array<
                | {
                    __typename?: 'ImageRecord';
                    id: any;
                    fullWidth?: any | null;
                    image?: {
                      __typename?: 'FileField';
                      alt?: string | null;
                      responsiveImage?: {
                        __typename?: 'ResponsiveImage';
                        aspectRatio: any;
                        base64?: string | null;
                        bgColor?: string | null;
                        height: any;
                        sizes: string;
                        src: string;
                        srcSet: string;
                        webpSrcSet: string;
                        width: any;
                      } | null;
                    } | null;
                    imageLoad?: {
                      __typename?: 'FileField';
                      alt?: string | null;
                      title?: string | null;
                      url: string;
                      blurUpThumb?: string | null;
                      focalPoint?: {
                        __typename?: 'focalPoint';
                        x: any;
                        y: any;
                      } | null;
                      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
                    } | null;
                  }
                | {
                    __typename?: 'MediaWithCaptionRecord';
                    id: any;
                    centerText?: any | null;
                    textOnImage?: any | null;
                    media?: {
                      __typename?: 'ImageRecord';
                      id: any;
                      fullWidth?: any | null;
                      image?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        responsiveImage?: {
                          __typename?: 'ResponsiveImage';
                          aspectRatio: any;
                          base64?: string | null;
                          bgColor?: string | null;
                          height: any;
                          sizes: string;
                          src: string;
                          srcSet: string;
                          webpSrcSet: string;
                          width: any;
                        } | null;
                      } | null;
                      imageLoad?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        title?: string | null;
                        url: string;
                        blurUpThumb?: string | null;
                        focalPoint?: {
                          __typename?: 'focalPoint';
                          x: any;
                          y: any;
                        } | null;
                        colors: Array<{
                          __typename?: 'ColorField';
                          hex: string;
                        }>;
                      } | null;
                    } | null;
                    caption?: {
                      __typename?: 'TextBlockRecord';
                      id: any;
                      smallHeader?: any | null;
                      header?: string | null;
                      text?: string | null;
                      introText?: string | null;
                      ctaButtons: Array<{
                        __typename?: 'CtaButtonRecord';
                        id: any;
                        text?: string | null;
                        url?: string | null;
                        variant?: string | null;
                      }>;
                    } | null;
                  }
                | {
                    __typename?: 'NewsListBlockRecord';
                    id: any;
                    title?: string | null;
                    standalone?: any | null;
                    largeTitle?: any | null;
                    itemsToShow?: any | null;
                  }
                | {
                    __typename?: 'ReportsListBlockRecord';
                    id: any;
                    title?: string | null;
                    standalone?: any | null;
                    largeTitle?: any | null;
                  }
                | {
                    __typename?: 'TextBlockRecord';
                    id: any;
                    smallHeader?: any | null;
                    header?: string | null;
                    text?: string | null;
                    introText?: string | null;
                    ctaButtons: Array<{
                      __typename?: 'CtaButtonRecord';
                      id: any;
                      text?: string | null;
                      url?: string | null;
                      variant?: string | null;
                    }>;
                  }
              >;
            }
          | {
              __typename?: 'ImageRecord';
              id: any;
              fullWidth?: any | null;
              image?: {
                __typename?: 'FileField';
                alt?: string | null;
                responsiveImage?: {
                  __typename?: 'ResponsiveImage';
                  aspectRatio: any;
                  base64?: string | null;
                  bgColor?: string | null;
                  height: any;
                  sizes: string;
                  src: string;
                  srcSet: string;
                  webpSrcSet: string;
                  width: any;
                } | null;
              } | null;
              imageLoad?: {
                __typename?: 'FileField';
                alt?: string | null;
                title?: string | null;
                url: string;
                blurUpThumb?: string | null;
                focalPoint?: {
                  __typename?: 'focalPoint';
                  x: any;
                  y: any;
                } | null;
                colors: Array<{ __typename?: 'ColorField'; hex: string }>;
              } | null;
            }
          | {
              __typename?: 'MediaWithCaptionRecord';
              id: any;
              centerText?: any | null;
              textOnImage?: any | null;
              media?: {
                __typename?: 'ImageRecord';
                id: any;
                fullWidth?: any | null;
                image?: {
                  __typename?: 'FileField';
                  alt?: string | null;
                  responsiveImage?: {
                    __typename?: 'ResponsiveImage';
                    aspectRatio: any;
                    base64?: string | null;
                    bgColor?: string | null;
                    height: any;
                    sizes: string;
                    src: string;
                    srcSet: string;
                    webpSrcSet: string;
                    width: any;
                  } | null;
                } | null;
                imageLoad?: {
                  __typename?: 'FileField';
                  alt?: string | null;
                  title?: string | null;
                  url: string;
                  blurUpThumb?: string | null;
                  focalPoint?: {
                    __typename?: 'focalPoint';
                    x: any;
                    y: any;
                  } | null;
                  colors: Array<{ __typename?: 'ColorField'; hex: string }>;
                } | null;
              } | null;
              caption?: {
                __typename?: 'TextBlockRecord';
                id: any;
                smallHeader?: any | null;
                header?: string | null;
                text?: string | null;
                introText?: string | null;
                ctaButtons: Array<{
                  __typename?: 'CtaButtonRecord';
                  id: any;
                  text?: string | null;
                  url?: string | null;
                  variant?: string | null;
                }>;
              } | null;
            }
          | {
              __typename?: 'TextBlockRecord';
              id: any;
              smallHeader?: any | null;
              header?: string | null;
              text?: string | null;
              introText?: string | null;
              ctaButtons: Array<{
                __typename?: 'CtaButtonRecord';
                id: any;
                text?: string | null;
                url?: string | null;
                variant?: string | null;
              }>;
            }
        >;
      }
    | {
        __typename?: 'GridTwocolBlockRecord';
        id: any;
        content: Array<
          | {
              __typename?: 'ImageRecord';
              id: any;
              fullWidth?: any | null;
              image?: {
                __typename?: 'FileField';
                alt?: string | null;
                responsiveImage?: {
                  __typename?: 'ResponsiveImage';
                  aspectRatio: any;
                  base64?: string | null;
                  bgColor?: string | null;
                  height: any;
                  sizes: string;
                  src: string;
                  srcSet: string;
                  webpSrcSet: string;
                  width: any;
                } | null;
              } | null;
              imageLoad?: {
                __typename?: 'FileField';
                alt?: string | null;
                title?: string | null;
                url: string;
                blurUpThumb?: string | null;
                focalPoint?: {
                  __typename?: 'focalPoint';
                  x: any;
                  y: any;
                } | null;
                colors: Array<{ __typename?: 'ColorField'; hex: string }>;
              } | null;
            }
          | {
              __typename?: 'MediaWithCaptionRecord';
              id: any;
              centerText?: any | null;
              textOnImage?: any | null;
              media?: {
                __typename?: 'ImageRecord';
                id: any;
                fullWidth?: any | null;
                image?: {
                  __typename?: 'FileField';
                  alt?: string | null;
                  responsiveImage?: {
                    __typename?: 'ResponsiveImage';
                    aspectRatio: any;
                    base64?: string | null;
                    bgColor?: string | null;
                    height: any;
                    sizes: string;
                    src: string;
                    srcSet: string;
                    webpSrcSet: string;
                    width: any;
                  } | null;
                } | null;
                imageLoad?: {
                  __typename?: 'FileField';
                  alt?: string | null;
                  title?: string | null;
                  url: string;
                  blurUpThumb?: string | null;
                  focalPoint?: {
                    __typename?: 'focalPoint';
                    x: any;
                    y: any;
                  } | null;
                  colors: Array<{ __typename?: 'ColorField'; hex: string }>;
                } | null;
              } | null;
              caption?: {
                __typename?: 'TextBlockRecord';
                id: any;
                smallHeader?: any | null;
                header?: string | null;
                text?: string | null;
                introText?: string | null;
                ctaButtons: Array<{
                  __typename?: 'CtaButtonRecord';
                  id: any;
                  text?: string | null;
                  url?: string | null;
                  variant?: string | null;
                }>;
              } | null;
            }
          | {
              __typename?: 'NewsListBlockRecord';
              id: any;
              title?: string | null;
              standalone?: any | null;
              largeTitle?: any | null;
              itemsToShow?: any | null;
            }
          | {
              __typename?: 'ReportsListBlockRecord';
              id: any;
              title?: string | null;
              standalone?: any | null;
              largeTitle?: any | null;
            }
          | {
              __typename?: 'TextBlockRecord';
              id: any;
              smallHeader?: any | null;
              header?: string | null;
              text?: string | null;
              introText?: string | null;
              ctaButtons: Array<{
                __typename?: 'CtaButtonRecord';
                id: any;
                text?: string | null;
                url?: string | null;
                variant?: string | null;
              }>;
            }
        >;
      }
  >;
};

type SustainabilityPageContentArea_HeroBlockRecord_Fragment = {
  __typename?: 'HeroBlockRecord';
  id: any;
  title?: string | null;
  description?: string | null;
  ctaText?: string | null;
  ctaUrl?: string | null;
  fullWidth?: any | null;
  boxColor?: { __typename?: 'ColorField'; hex: string } | null;
  textColor?: { __typename?: 'ColorField'; hex: string } | null;
  image?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
  imageOverlay?: {
    __typename?: 'OverlayRecord';
    id: any;
    opacity?: any | null;
    color?: { __typename?: 'ColorField'; hex: string } | null;
  } | null;
  ctaButtons: Array<{
    __typename?: 'CtaButtonRecord';
    id: any;
    text?: string | null;
    url?: string | null;
    variant?: string | null;
  }>;
  video?: {
    __typename?: 'FileField';
    blurUpThumb?: string | null;
    title?: string | null;
    alt?: string | null;
    video?: {
      __typename?: 'UploadVideoField';
      muxPlaybackId: string;
      width: any;
      height: any;
    } | null;
  } | null;
};

type SustainabilityPageContentArea_ImageRecord_Fragment = {
  __typename?: 'ImageRecord';
  id: any;
  fullWidth?: any | null;
  image?: {
    __typename?: 'FileField';
    alt?: string | null;
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  imageLoad?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
};

type SustainabilityPageContentArea_JobsListBlockRecord_Fragment = {
  __typename?: 'JobsListBlockRecord';
  id: any;
  title?: string | null;
};

type SustainabilityPageContentArea_NewsAndReportsListBlockRecord_Fragment = {
  __typename?: 'NewsAndReportsListBlockRecord';
  newsTitle?: string | null;
  reportsTitle?: string | null;
  newsImage?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
  news: Array<{
    __typename?: 'NewsPageRecord';
    id: any;
    title?: string | null;
    slug?: string | null;
    publishDate?: any | null;
    category?: string | null;
  }>;
  reportsImage?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
  reports: Array<{
    __typename?: 'ReportsListingRecord';
    id: any;
    title?: string | null;
    slug?: string | null;
    publishDate?: any | null;
    category?: string | null;
    pdf?: {
      __typename?: 'FileField';
      alt?: string | null;
      filename: string;
      format: string;
      size: any;
      title?: string | null;
      url: string;
      uploadId: any;
    } | null;
  }>;
};

type SustainabilityPageContentArea_NewsListBlockRecord_Fragment = {
  __typename?: 'NewsListBlockRecord';
  id: any;
  title?: string | null;
  standalone?: any | null;
  largeTitle?: any | null;
  itemsToShow?: any | null;
};

type SustainabilityPageContentArea_OfficesBlockRecord_Fragment = {
  __typename?: 'OfficesBlockRecord';
  id: any;
  offices: Array<{
    __typename?: 'OfficeRecord';
    id: any;
    name?: string | null;
    address?: string | null;
    zipCode?: string | null;
    city?: string | null;
    country?: string | null;
    email?: string | null;
    websiteUrl?: string | null;
    phoneNumber?: string | null;
  }>;
};

type SustainabilityPageContentArea_PageNavigationBlockRecord_Fragment = {
  __typename?: 'PageNavigationBlockRecord';
  id: any;
  label?: string | null;
  links: Array<{
    __typename?: 'LinkRecord';
    id: any;
    title?: string | null;
    url?: string | null;
  }>;
};

type SustainabilityPageContentArea_PlugBlockRecord_Fragment = {
  __typename?: 'PlugBlockRecord';
  id: any;
  title?: string | null;
  description?: string | null;
  brands: Array<{
    __typename?: 'BrandPageRecord';
    id: any;
    brandName?: string | null;
    slug?: string | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      tags: Array<string>;
      title?: string | null;
      url: string;
      width?: any | null;
      height?: any | null;
      format: string;
      responsiveImage?: {
        __typename?: 'ResponsiveImage';
        aspectRatio: any;
        base64?: string | null;
        bgColor?: string | null;
        height: any;
        sizes: string;
        src: string;
        srcSet: string;
        webpSrcSet: string;
        width: any;
      } | null;
    } | null;
    imageLoad?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
  }>;
};

type SustainabilityPageContentArea_SimpleTitleAndTextBlockRecord_Fragment = {
  __typename?: 'SimpleTitleAndTextBlockRecord';
  id: any;
  title?: string | null;
  topLabel?: string | null;
  description?: string | null;
};

type SustainabilityPageContentArea_SliderBlockRecord_Fragment = {
  __typename?: 'SliderBlockRecord';
  title?: string | null;
  arrows?: any | null;
  slideAnimation?: any | null;
  delay?: any | null;
  dots?: any | null;
  heroes: Array<{
    __typename?: 'HeroBlockRecord';
    id: any;
    title?: string | null;
    description?: string | null;
    ctaText?: string | null;
    ctaUrl?: string | null;
    fullWidth?: any | null;
    boxColor?: { __typename?: 'ColorField'; hex: string } | null;
    textColor?: { __typename?: 'ColorField'; hex: string } | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
    imageOverlay?: {
      __typename?: 'OverlayRecord';
      id: any;
      opacity?: any | null;
      color?: { __typename?: 'ColorField'; hex: string } | null;
    } | null;
    ctaButtons: Array<{
      __typename?: 'CtaButtonRecord';
      id: any;
      text?: string | null;
      url?: string | null;
      variant?: string | null;
    }>;
    video?: {
      __typename?: 'FileField';
      blurUpThumb?: string | null;
      title?: string | null;
      alt?: string | null;
      video?: {
        __typename?: 'UploadVideoField';
        muxPlaybackId: string;
        width: any;
        height: any;
      } | null;
    } | null;
  }>;
};

type SustainabilityPageContentArea_StatementBlockRecord_Fragment = {
  __typename?: 'StatementBlockRecord';
  id: any;
  text?: string | null;
  blackBackground?: any | null;
  header?: string | null;
  small?: any | null;
  linkText?: string | null;
  linkUrl?: string | null;
  imageMobile?: {
    __typename?: 'FileField';
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  imageTablet?: {
    __typename?: 'FileField';
    alt?: string | null;
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  imageDesktop?: {
    __typename?: 'FileField';
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  imageLoad?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
  imageOverlay?: {
    __typename?: 'OverlayRecord';
    id: any;
    opacity?: any | null;
    color?: { __typename?: 'ColorField'; hex: string } | null;
  } | null;
};

type SustainabilityPageContentArea_SubheadingBlockRecord_Fragment = {
  __typename?: 'SubheadingBlockRecord';
  id: any;
  title?: string | null;
  text?: string | null;
  ctaButton?: {
    __typename?: 'CtaButtonRecord';
    id: any;
    text?: string | null;
    url?: string | null;
    variant?: string | null;
  } | null;
  backgroundColor?: { __typename?: 'ColorField'; hex: string } | null;
};

type SustainabilityPageContentArea_SustainabilityReportsBlockRecord_Fragment = {
  __typename?: 'SustainabilityReportsBlockRecord';
  id: any;
  title?: string | null;
  reports: Array<{
    __typename?: 'FileField';
    alt?: string | null;
    filename: string;
    format: string;
    size: any;
    title?: string | null;
    url: string;
    uploadId: any;
  }>;
};

type SustainabilityPageContentArea_TextBlockRecord_Fragment = {
  __typename?: 'TextBlockRecord';
  id: any;
  smallHeader?: any | null;
  header?: string | null;
  text?: string | null;
  introText?: string | null;
  ctaButtons: Array<{
    __typename?: 'CtaButtonRecord';
    id: any;
    text?: string | null;
    url?: string | null;
    variant?: string | null;
  }>;
};

type SustainabilityPageContentArea_TwoColumnImageAndTextRecord_Fragment = {
  __typename?: 'TwoColumnImageAndTextRecord';
  id: any;
  text?: string | null;
  title?: string | null;
  reverse?: any | null;
  image?: {
    __typename?: 'FileField';
    alt?: string | null;
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  imageLoad?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
};

type SustainabilityPageContentArea_TwoColumnTextIntroRecord_Fragment = {
  __typename?: 'TwoColumnTextIntroRecord';
  id: any;
  introText?: string | null;
  text?: string | null;
  header?: string | null;
};

type SustainabilityPageContentArea_VideoRecord_Fragment = {
  __typename?: 'VideoRecord';
  id: any;
  autoplay?: any | null;
  video?: {
    __typename?: 'FileField';
    title?: string | null;
    video?: {
      __typename?: 'UploadVideoField';
      mp4Url?: string | null;
      streamingUrl: string;
      thumbnailUrl: string;
      mp4Low?: string | null;
    } | null;
  } | null;
  videoThumbnail?: {
    __typename?: 'FileField';
    alt?: string | null;
    tags: Array<string>;
    title?: string | null;
    url: string;
    width?: any | null;
    height?: any | null;
    format: string;
    responsiveImage?: {
      __typename?: 'ResponsiveImage';
      aspectRatio: any;
      base64?: string | null;
      bgColor?: string | null;
      height: any;
      sizes: string;
      src: string;
      srcSet: string;
      webpSrcSet: string;
      width: any;
    } | null;
  } | null;
  muxVideo?: {
    __typename?: 'FileField';
    blurUpThumb?: string | null;
    title?: string | null;
    alt?: string | null;
    video?: {
      __typename?: 'UploadVideoField';
      muxPlaybackId: string;
      width: any;
      height: any;
    } | null;
  } | null;
};

export type SustainabilityPageContentAreaFragment =
  | SustainabilityPageContentArea_ArticlesBlockRecord_Fragment
  | SustainabilityPageContentArea_BrandsBlockRecord_Fragment
  | SustainabilityPageContentArea_BulletListRecord_Fragment
  | SustainabilityPageContentArea_DocumentLinkBlockRecord_Fragment
  | SustainabilityPageContentArea_EmployeeRecord_Fragment
  | SustainabilityPageContentArea_GridContainerBlockRecord_Fragment
  | SustainabilityPageContentArea_HeroBlockRecord_Fragment
  | SustainabilityPageContentArea_ImageRecord_Fragment
  | SustainabilityPageContentArea_JobsListBlockRecord_Fragment
  | SustainabilityPageContentArea_NewsAndReportsListBlockRecord_Fragment
  | SustainabilityPageContentArea_NewsListBlockRecord_Fragment
  | SustainabilityPageContentArea_OfficesBlockRecord_Fragment
  | SustainabilityPageContentArea_PageNavigationBlockRecord_Fragment
  | SustainabilityPageContentArea_PlugBlockRecord_Fragment
  | SustainabilityPageContentArea_SimpleTitleAndTextBlockRecord_Fragment
  | SustainabilityPageContentArea_SliderBlockRecord_Fragment
  | SustainabilityPageContentArea_StatementBlockRecord_Fragment
  | SustainabilityPageContentArea_SubheadingBlockRecord_Fragment
  | SustainabilityPageContentArea_SustainabilityReportsBlockRecord_Fragment
  | SustainabilityPageContentArea_TextBlockRecord_Fragment
  | SustainabilityPageContentArea_TwoColumnImageAndTextRecord_Fragment
  | SustainabilityPageContentArea_TwoColumnTextIntroRecord_Fragment
  | SustainabilityPageContentArea_VideoRecord_Fragment;

export type SustainabilityPageContentFragment = {
  __typename?: 'SustainabilityPageRecord';
  id: any;
  pageLocales: Array<SiteLocale>;
  seo?: {
    __typename?: 'SeoField';
    description?: string | null;
    title?: string | null;
    image?: {
      __typename?: 'FileField';
      url: string;
      alt?: string | null;
      title?: string | null;
    } | null;
  } | null;
  contentArea: Array<
    | {
        __typename?: 'ArticlesBlockRecord';
        id: any;
        title?: string | null;
        isJobArticles?: any | null;
        ctaText?: string | null;
        ctaUrl?: string | null;
        jobPages: Array<{
          __typename?: 'JobOpportunitiesPageRecord';
          id: any;
          slug?: string | null;
          title?: string | null;
          publishDate?: any | null;
          category?: string | null;
          country?: string | null;
          department?: string | null;
        }>;
        newsPages: Array<{
          __typename?: 'NewsPageRecord';
          id: any;
          slug?: string | null;
          title?: string | null;
          publishDate?: any | null;
          category?: string | null;
          country?: string | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
        }>;
        reportPages: Array<{
          __typename?: 'ReportsListingRecord';
          id: any;
          slug?: string | null;
          title?: string | null;
          publishDate?: any | null;
          category?: string | null;
          country?: string | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
          pdf?: {
            __typename?: 'FileField';
            alt?: string | null;
            filename: string;
            format: string;
            size: any;
            title?: string | null;
            url: string;
            uploadId: any;
          } | null;
        }>;
      }
    | {
        __typename?: 'BrandsBlockRecord';
        id: any;
        title?: string | null;
        introText?: string | null;
        hideLabels?: any | null;
        brands: Array<{
          __typename?: 'BrandPageRecord';
          id: any;
          brandName?: string | null;
          slug?: string | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            tags: Array<string>;
            title?: string | null;
            url: string;
            width?: any | null;
            height?: any | null;
            format: string;
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageLoad?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
        }>;
      }
    | {
        __typename?: 'BulletListRecord';
        id: any;
        bullets?: string | null;
        numberedList?: any | null;
        title?: string | null;
      }
    | {
        __typename?: 'DocumentLinkBlockRecord';
        id: any;
        documents: Array<{
          __typename?: 'FileField';
          alt?: string | null;
          filename: string;
          format: string;
          size: any;
          title?: string | null;
          url: string;
          uploadId: any;
        }>;
      }
    | {
        __typename?: 'EmployeeRecord';
        id: any;
        name?: string | null;
        title?: string | null;
        introText?: string | null;
        description?: string | null;
        image?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
      }
    | {
        __typename?: 'GridContainerBlockRecord';
        id: any;
        fullwidth?: any | null;
        gap?: any | null;
        backgroundColor?: { __typename?: 'ColorField'; hex: string } | null;
        textColor?: { __typename?: 'ColorField'; hex: string } | null;
        content: Array<
          | {
              __typename?: 'GridFourcolBlockRecord';
              id: any;
              content: Array<
                | {
                    __typename?: 'ImageRecord';
                    id: any;
                    fullWidth?: any | null;
                    image?: {
                      __typename?: 'FileField';
                      alt?: string | null;
                      responsiveImage?: {
                        __typename?: 'ResponsiveImage';
                        aspectRatio: any;
                        base64?: string | null;
                        bgColor?: string | null;
                        height: any;
                        sizes: string;
                        src: string;
                        srcSet: string;
                        webpSrcSet: string;
                        width: any;
                      } | null;
                    } | null;
                    imageLoad?: {
                      __typename?: 'FileField';
                      alt?: string | null;
                      title?: string | null;
                      url: string;
                      blurUpThumb?: string | null;
                      focalPoint?: {
                        __typename?: 'focalPoint';
                        x: any;
                        y: any;
                      } | null;
                      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
                    } | null;
                  }
                | {
                    __typename?: 'MediaWithCaptionRecord';
                    id: any;
                    centerText?: any | null;
                    textOnImage?: any | null;
                    media?: {
                      __typename?: 'ImageRecord';
                      id: any;
                      fullWidth?: any | null;
                      image?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        responsiveImage?: {
                          __typename?: 'ResponsiveImage';
                          aspectRatio: any;
                          base64?: string | null;
                          bgColor?: string | null;
                          height: any;
                          sizes: string;
                          src: string;
                          srcSet: string;
                          webpSrcSet: string;
                          width: any;
                        } | null;
                      } | null;
                      imageLoad?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        title?: string | null;
                        url: string;
                        blurUpThumb?: string | null;
                        focalPoint?: {
                          __typename?: 'focalPoint';
                          x: any;
                          y: any;
                        } | null;
                        colors: Array<{
                          __typename?: 'ColorField';
                          hex: string;
                        }>;
                      } | null;
                    } | null;
                    caption?: {
                      __typename?: 'TextBlockRecord';
                      id: any;
                      smallHeader?: any | null;
                      header?: string | null;
                      text?: string | null;
                      introText?: string | null;
                      ctaButtons: Array<{
                        __typename?: 'CtaButtonRecord';
                        id: any;
                        text?: string | null;
                        url?: string | null;
                        variant?: string | null;
                      }>;
                    } | null;
                  }
                | {
                    __typename?: 'TextBlockRecord';
                    id: any;
                    smallHeader?: any | null;
                    header?: string | null;
                    text?: string | null;
                    introText?: string | null;
                    ctaButtons: Array<{
                      __typename?: 'CtaButtonRecord';
                      id: any;
                      text?: string | null;
                      url?: string | null;
                      variant?: string | null;
                    }>;
                  }
              >;
            }
          | {
              __typename?: 'GridThreecolBlockRecord';
              id: any;
              content: Array<
                | {
                    __typename?: 'GridTwocolBlockRecord';
                    id: any;
                    content: Array<
                      | {
                          __typename?: 'ImageRecord';
                          id: any;
                          fullWidth?: any | null;
                          image?: {
                            __typename?: 'FileField';
                            alt?: string | null;
                            responsiveImage?: {
                              __typename?: 'ResponsiveImage';
                              aspectRatio: any;
                              base64?: string | null;
                              bgColor?: string | null;
                              height: any;
                              sizes: string;
                              src: string;
                              srcSet: string;
                              webpSrcSet: string;
                              width: any;
                            } | null;
                          } | null;
                          imageLoad?: {
                            __typename?: 'FileField';
                            alt?: string | null;
                            title?: string | null;
                            url: string;
                            blurUpThumb?: string | null;
                            focalPoint?: {
                              __typename?: 'focalPoint';
                              x: any;
                              y: any;
                            } | null;
                            colors: Array<{
                              __typename?: 'ColorField';
                              hex: string;
                            }>;
                          } | null;
                        }
                      | {
                          __typename?: 'MediaWithCaptionRecord';
                          id: any;
                          centerText?: any | null;
                          textOnImage?: any | null;
                          media?: {
                            __typename?: 'ImageRecord';
                            id: any;
                            fullWidth?: any | null;
                            image?: {
                              __typename?: 'FileField';
                              alt?: string | null;
                              responsiveImage?: {
                                __typename?: 'ResponsiveImage';
                                aspectRatio: any;
                                base64?: string | null;
                                bgColor?: string | null;
                                height: any;
                                sizes: string;
                                src: string;
                                srcSet: string;
                                webpSrcSet: string;
                                width: any;
                              } | null;
                            } | null;
                            imageLoad?: {
                              __typename?: 'FileField';
                              alt?: string | null;
                              title?: string | null;
                              url: string;
                              blurUpThumb?: string | null;
                              focalPoint?: {
                                __typename?: 'focalPoint';
                                x: any;
                                y: any;
                              } | null;
                              colors: Array<{
                                __typename?: 'ColorField';
                                hex: string;
                              }>;
                            } | null;
                          } | null;
                          caption?: {
                            __typename?: 'TextBlockRecord';
                            id: any;
                            smallHeader?: any | null;
                            header?: string | null;
                            text?: string | null;
                            introText?: string | null;
                            ctaButtons: Array<{
                              __typename?: 'CtaButtonRecord';
                              id: any;
                              text?: string | null;
                              url?: string | null;
                              variant?: string | null;
                            }>;
                          } | null;
                        }
                      | {
                          __typename?: 'NewsListBlockRecord';
                          id: any;
                          title?: string | null;
                          standalone?: any | null;
                          largeTitle?: any | null;
                          itemsToShow?: any | null;
                        }
                      | {
                          __typename?: 'ReportsListBlockRecord';
                          id: any;
                          title?: string | null;
                          standalone?: any | null;
                          largeTitle?: any | null;
                        }
                      | {
                          __typename?: 'TextBlockRecord';
                          id: any;
                          smallHeader?: any | null;
                          header?: string | null;
                          text?: string | null;
                          introText?: string | null;
                          ctaButtons: Array<{
                            __typename?: 'CtaButtonRecord';
                            id: any;
                            text?: string | null;
                            url?: string | null;
                            variant?: string | null;
                          }>;
                        }
                    >;
                  }
                | {
                    __typename?: 'ImageRecord';
                    id: any;
                    fullWidth?: any | null;
                    image?: {
                      __typename?: 'FileField';
                      alt?: string | null;
                      responsiveImage?: {
                        __typename?: 'ResponsiveImage';
                        aspectRatio: any;
                        base64?: string | null;
                        bgColor?: string | null;
                        height: any;
                        sizes: string;
                        src: string;
                        srcSet: string;
                        webpSrcSet: string;
                        width: any;
                      } | null;
                    } | null;
                    imageLoad?: {
                      __typename?: 'FileField';
                      alt?: string | null;
                      title?: string | null;
                      url: string;
                      blurUpThumb?: string | null;
                      focalPoint?: {
                        __typename?: 'focalPoint';
                        x: any;
                        y: any;
                      } | null;
                      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
                    } | null;
                  }
                | {
                    __typename?: 'MediaWithCaptionRecord';
                    id: any;
                    centerText?: any | null;
                    textOnImage?: any | null;
                    media?: {
                      __typename?: 'ImageRecord';
                      id: any;
                      fullWidth?: any | null;
                      image?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        responsiveImage?: {
                          __typename?: 'ResponsiveImage';
                          aspectRatio: any;
                          base64?: string | null;
                          bgColor?: string | null;
                          height: any;
                          sizes: string;
                          src: string;
                          srcSet: string;
                          webpSrcSet: string;
                          width: any;
                        } | null;
                      } | null;
                      imageLoad?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        title?: string | null;
                        url: string;
                        blurUpThumb?: string | null;
                        focalPoint?: {
                          __typename?: 'focalPoint';
                          x: any;
                          y: any;
                        } | null;
                        colors: Array<{
                          __typename?: 'ColorField';
                          hex: string;
                        }>;
                      } | null;
                    } | null;
                    caption?: {
                      __typename?: 'TextBlockRecord';
                      id: any;
                      smallHeader?: any | null;
                      header?: string | null;
                      text?: string | null;
                      introText?: string | null;
                      ctaButtons: Array<{
                        __typename?: 'CtaButtonRecord';
                        id: any;
                        text?: string | null;
                        url?: string | null;
                        variant?: string | null;
                      }>;
                    } | null;
                  }
                | {
                    __typename?: 'TextBlockRecord';
                    id: any;
                    smallHeader?: any | null;
                    header?: string | null;
                    text?: string | null;
                    introText?: string | null;
                    ctaButtons: Array<{
                      __typename?: 'CtaButtonRecord';
                      id: any;
                      text?: string | null;
                      url?: string | null;
                      variant?: string | null;
                    }>;
                  }
              >;
            }
          | {
              __typename?: 'GridTwocolBlockRecord';
              id: any;
              content: Array<
                | {
                    __typename?: 'ImageRecord';
                    id: any;
                    fullWidth?: any | null;
                    image?: {
                      __typename?: 'FileField';
                      alt?: string | null;
                      responsiveImage?: {
                        __typename?: 'ResponsiveImage';
                        aspectRatio: any;
                        base64?: string | null;
                        bgColor?: string | null;
                        height: any;
                        sizes: string;
                        src: string;
                        srcSet: string;
                        webpSrcSet: string;
                        width: any;
                      } | null;
                    } | null;
                    imageLoad?: {
                      __typename?: 'FileField';
                      alt?: string | null;
                      title?: string | null;
                      url: string;
                      blurUpThumb?: string | null;
                      focalPoint?: {
                        __typename?: 'focalPoint';
                        x: any;
                        y: any;
                      } | null;
                      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
                    } | null;
                  }
                | {
                    __typename?: 'MediaWithCaptionRecord';
                    id: any;
                    centerText?: any | null;
                    textOnImage?: any | null;
                    media?: {
                      __typename?: 'ImageRecord';
                      id: any;
                      fullWidth?: any | null;
                      image?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        responsiveImage?: {
                          __typename?: 'ResponsiveImage';
                          aspectRatio: any;
                          base64?: string | null;
                          bgColor?: string | null;
                          height: any;
                          sizes: string;
                          src: string;
                          srcSet: string;
                          webpSrcSet: string;
                          width: any;
                        } | null;
                      } | null;
                      imageLoad?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        title?: string | null;
                        url: string;
                        blurUpThumb?: string | null;
                        focalPoint?: {
                          __typename?: 'focalPoint';
                          x: any;
                          y: any;
                        } | null;
                        colors: Array<{
                          __typename?: 'ColorField';
                          hex: string;
                        }>;
                      } | null;
                    } | null;
                    caption?: {
                      __typename?: 'TextBlockRecord';
                      id: any;
                      smallHeader?: any | null;
                      header?: string | null;
                      text?: string | null;
                      introText?: string | null;
                      ctaButtons: Array<{
                        __typename?: 'CtaButtonRecord';
                        id: any;
                        text?: string | null;
                        url?: string | null;
                        variant?: string | null;
                      }>;
                    } | null;
                  }
                | {
                    __typename?: 'NewsListBlockRecord';
                    id: any;
                    title?: string | null;
                    standalone?: any | null;
                    largeTitle?: any | null;
                    itemsToShow?: any | null;
                  }
                | {
                    __typename?: 'ReportsListBlockRecord';
                    id: any;
                    title?: string | null;
                    standalone?: any | null;
                    largeTitle?: any | null;
                  }
                | {
                    __typename?: 'TextBlockRecord';
                    id: any;
                    smallHeader?: any | null;
                    header?: string | null;
                    text?: string | null;
                    introText?: string | null;
                    ctaButtons: Array<{
                      __typename?: 'CtaButtonRecord';
                      id: any;
                      text?: string | null;
                      url?: string | null;
                      variant?: string | null;
                    }>;
                  }
              >;
            }
        >;
      }
    | {
        __typename?: 'HeroBlockRecord';
        id: any;
        title?: string | null;
        description?: string | null;
        ctaText?: string | null;
        ctaUrl?: string | null;
        fullWidth?: any | null;
        boxColor?: { __typename?: 'ColorField'; hex: string } | null;
        textColor?: { __typename?: 'ColorField'; hex: string } | null;
        image?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
        imageOverlay?: {
          __typename?: 'OverlayRecord';
          id: any;
          opacity?: any | null;
          color?: { __typename?: 'ColorField'; hex: string } | null;
        } | null;
        ctaButtons: Array<{
          __typename?: 'CtaButtonRecord';
          id: any;
          text?: string | null;
          url?: string | null;
          variant?: string | null;
        }>;
        video?: {
          __typename?: 'FileField';
          blurUpThumb?: string | null;
          title?: string | null;
          alt?: string | null;
          video?: {
            __typename?: 'UploadVideoField';
            muxPlaybackId: string;
            width: any;
            height: any;
          } | null;
        } | null;
      }
    | {
        __typename?: 'ImageRecord';
        id: any;
        fullWidth?: any | null;
        image?: {
          __typename?: 'FileField';
          alt?: string | null;
          responsiveImage?: {
            __typename?: 'ResponsiveImage';
            aspectRatio: any;
            base64?: string | null;
            bgColor?: string | null;
            height: any;
            sizes: string;
            src: string;
            srcSet: string;
            webpSrcSet: string;
            width: any;
          } | null;
        } | null;
        imageLoad?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
      }
    | { __typename?: 'JobsListBlockRecord'; id: any; title?: string | null }
    | {
        __typename?: 'NewsAndReportsListBlockRecord';
        newsTitle?: string | null;
        reportsTitle?: string | null;
        newsImage?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
        news: Array<{
          __typename?: 'NewsPageRecord';
          id: any;
          title?: string | null;
          slug?: string | null;
          publishDate?: any | null;
          category?: string | null;
        }>;
        reportsImage?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
        reports: Array<{
          __typename?: 'ReportsListingRecord';
          id: any;
          title?: string | null;
          slug?: string | null;
          publishDate?: any | null;
          category?: string | null;
          pdf?: {
            __typename?: 'FileField';
            alt?: string | null;
            filename: string;
            format: string;
            size: any;
            title?: string | null;
            url: string;
            uploadId: any;
          } | null;
        }>;
      }
    | {
        __typename?: 'NewsListBlockRecord';
        id: any;
        title?: string | null;
        standalone?: any | null;
        largeTitle?: any | null;
        itemsToShow?: any | null;
      }
    | {
        __typename?: 'OfficesBlockRecord';
        id: any;
        offices: Array<{
          __typename?: 'OfficeRecord';
          id: any;
          name?: string | null;
          address?: string | null;
          zipCode?: string | null;
          city?: string | null;
          country?: string | null;
          email?: string | null;
          websiteUrl?: string | null;
          phoneNumber?: string | null;
        }>;
      }
    | {
        __typename?: 'PageNavigationBlockRecord';
        id: any;
        label?: string | null;
        links: Array<{
          __typename?: 'LinkRecord';
          id: any;
          title?: string | null;
          url?: string | null;
        }>;
      }
    | {
        __typename?: 'PlugBlockRecord';
        id: any;
        title?: string | null;
        description?: string | null;
        brands: Array<{
          __typename?: 'BrandPageRecord';
          id: any;
          brandName?: string | null;
          slug?: string | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            tags: Array<string>;
            title?: string | null;
            url: string;
            width?: any | null;
            height?: any | null;
            format: string;
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageLoad?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
        }>;
      }
    | {
        __typename?: 'SimpleTitleAndTextBlockRecord';
        id: any;
        title?: string | null;
        topLabel?: string | null;
        description?: string | null;
      }
    | {
        __typename?: 'SliderBlockRecord';
        title?: string | null;
        arrows?: any | null;
        slideAnimation?: any | null;
        delay?: any | null;
        dots?: any | null;
        heroes: Array<{
          __typename?: 'HeroBlockRecord';
          id: any;
          title?: string | null;
          description?: string | null;
          ctaText?: string | null;
          ctaUrl?: string | null;
          fullWidth?: any | null;
          boxColor?: { __typename?: 'ColorField'; hex: string } | null;
          textColor?: { __typename?: 'ColorField'; hex: string } | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
          imageOverlay?: {
            __typename?: 'OverlayRecord';
            id: any;
            opacity?: any | null;
            color?: { __typename?: 'ColorField'; hex: string } | null;
          } | null;
          ctaButtons: Array<{
            __typename?: 'CtaButtonRecord';
            id: any;
            text?: string | null;
            url?: string | null;
            variant?: string | null;
          }>;
          video?: {
            __typename?: 'FileField';
            blurUpThumb?: string | null;
            title?: string | null;
            alt?: string | null;
            video?: {
              __typename?: 'UploadVideoField';
              muxPlaybackId: string;
              width: any;
              height: any;
            } | null;
          } | null;
        }>;
      }
    | {
        __typename?: 'StatementBlockRecord';
        id: any;
        text?: string | null;
        blackBackground?: any | null;
        header?: string | null;
        small?: any | null;
        linkText?: string | null;
        linkUrl?: string | null;
        imageMobile?: {
          __typename?: 'FileField';
          responsiveImage?: {
            __typename?: 'ResponsiveImage';
            aspectRatio: any;
            base64?: string | null;
            bgColor?: string | null;
            height: any;
            sizes: string;
            src: string;
            srcSet: string;
            webpSrcSet: string;
            width: any;
          } | null;
        } | null;
        imageTablet?: {
          __typename?: 'FileField';
          alt?: string | null;
          responsiveImage?: {
            __typename?: 'ResponsiveImage';
            aspectRatio: any;
            base64?: string | null;
            bgColor?: string | null;
            height: any;
            sizes: string;
            src: string;
            srcSet: string;
            webpSrcSet: string;
            width: any;
          } | null;
        } | null;
        imageDesktop?: {
          __typename?: 'FileField';
          responsiveImage?: {
            __typename?: 'ResponsiveImage';
            aspectRatio: any;
            base64?: string | null;
            bgColor?: string | null;
            height: any;
            sizes: string;
            src: string;
            srcSet: string;
            webpSrcSet: string;
            width: any;
          } | null;
        } | null;
        imageLoad?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
        imageOverlay?: {
          __typename?: 'OverlayRecord';
          id: any;
          opacity?: any | null;
          color?: { __typename?: 'ColorField'; hex: string } | null;
        } | null;
      }
    | {
        __typename?: 'SubheadingBlockRecord';
        id: any;
        title?: string | null;
        text?: string | null;
        ctaButton?: {
          __typename?: 'CtaButtonRecord';
          id: any;
          text?: string | null;
          url?: string | null;
          variant?: string | null;
        } | null;
        backgroundColor?: { __typename?: 'ColorField'; hex: string } | null;
      }
    | {
        __typename?: 'SustainabilityReportsBlockRecord';
        id: any;
        title?: string | null;
        reports: Array<{
          __typename?: 'FileField';
          alt?: string | null;
          filename: string;
          format: string;
          size: any;
          title?: string | null;
          url: string;
          uploadId: any;
        }>;
      }
    | {
        __typename?: 'TextBlockRecord';
        id: any;
        smallHeader?: any | null;
        header?: string | null;
        text?: string | null;
        introText?: string | null;
        ctaButtons: Array<{
          __typename?: 'CtaButtonRecord';
          id: any;
          text?: string | null;
          url?: string | null;
          variant?: string | null;
        }>;
      }
    | {
        __typename?: 'TwoColumnImageAndTextRecord';
        id: any;
        text?: string | null;
        title?: string | null;
        reverse?: any | null;
        image?: {
          __typename?: 'FileField';
          alt?: string | null;
          responsiveImage?: {
            __typename?: 'ResponsiveImage';
            aspectRatio: any;
            base64?: string | null;
            bgColor?: string | null;
            height: any;
            sizes: string;
            src: string;
            srcSet: string;
            webpSrcSet: string;
            width: any;
          } | null;
        } | null;
        imageLoad?: {
          __typename?: 'FileField';
          alt?: string | null;
          title?: string | null;
          url: string;
          blurUpThumb?: string | null;
          focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
          colors: Array<{ __typename?: 'ColorField'; hex: string }>;
        } | null;
      }
    | {
        __typename?: 'TwoColumnTextIntroRecord';
        id: any;
        introText?: string | null;
        text?: string | null;
        header?: string | null;
      }
    | {
        __typename?: 'VideoRecord';
        id: any;
        autoplay?: any | null;
        video?: {
          __typename?: 'FileField';
          title?: string | null;
          video?: {
            __typename?: 'UploadVideoField';
            mp4Url?: string | null;
            streamingUrl: string;
            thumbnailUrl: string;
            mp4Low?: string | null;
          } | null;
        } | null;
        videoThumbnail?: {
          __typename?: 'FileField';
          alt?: string | null;
          tags: Array<string>;
          title?: string | null;
          url: string;
          width?: any | null;
          height?: any | null;
          format: string;
          responsiveImage?: {
            __typename?: 'ResponsiveImage';
            aspectRatio: any;
            base64?: string | null;
            bgColor?: string | null;
            height: any;
            sizes: string;
            src: string;
            srcSet: string;
            webpSrcSet: string;
            width: any;
          } | null;
        } | null;
        muxVideo?: {
          __typename?: 'FileField';
          blurUpThumb?: string | null;
          title?: string | null;
          alt?: string | null;
          video?: {
            __typename?: 'UploadVideoField';
            muxPlaybackId: string;
            width: any;
            height: any;
          } | null;
        } | null;
      }
  >;
};

export type ReportsPageListingFragment = {
  __typename?: 'ReportsListingRecord';
  id: any;
  slug?: string | null;
  title?: string | null;
  publishDate?: any | null;
  category?: string | null;
  country?: string | null;
  image?: {
    __typename?: 'FileField';
    alt?: string | null;
    title?: string | null;
    url: string;
    blurUpThumb?: string | null;
    focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
    colors: Array<{ __typename?: 'ColorField'; hex: string }>;
  } | null;
  pdf?: {
    __typename?: 'FileField';
    alt?: string | null;
    filename: string;
    format: string;
    size: any;
    title?: string | null;
    url: string;
    uploadId: any;
  } | null;
};

export type SeoFragment = {
  __typename?: 'SeoField';
  description?: string | null;
  title?: string | null;
  image?: {
    __typename?: 'FileField';
    url: string;
    alt?: string | null;
    title?: string | null;
  } | null;
};

export type SiteLocaleFragment = {
  __typename?: 'SiteLocaleRecord';
  enabled?: any | null;
};

export type SubMenuItemFragment = {
  __typename?: 'ItemRecord';
  title?: string | null;
  pageLink?:
    | { __typename?: 'AboutUsPageRecord'; slug?: string | null }
    | { __typename?: 'BrandPageRecord'; slug?: string | null }
    | { __typename?: 'SustainabilityPageRecord'; slug?: string | null }
    | null;
};

export type AboutUsPageQueryVariables = Exact<{
  locale?: InputMaybe<SiteLocale>;
  slug: Scalars['String']['input'];
}>;

export type AboutUsPageQuery = {
  __typename?: 'Query';
  aboutUsPage?: {
    __typename?: 'AboutUsPageRecord';
    id: any;
    pageLocales: Array<SiteLocale>;
    seo?: {
      __typename?: 'SeoField';
      description?: string | null;
      title?: string | null;
      image?: {
        __typename?: 'FileField';
        url: string;
        alt?: string | null;
        title?: string | null;
      } | null;
    } | null;
    contentArea: Array<
      | {
          __typename?: 'ArticlesBlockRecord';
          id: any;
          title?: string | null;
          isJobArticles?: any | null;
          ctaText?: string | null;
          ctaUrl?: string | null;
          jobPages: Array<{
            __typename?: 'JobOpportunitiesPageRecord';
            id: any;
            slug?: string | null;
            title?: string | null;
            publishDate?: any | null;
            category?: string | null;
            country?: string | null;
            department?: string | null;
          }>;
          newsPages: Array<{
            __typename?: 'NewsPageRecord';
            id: any;
            slug?: string | null;
            title?: string | null;
            publishDate?: any | null;
            category?: string | null;
            country?: string | null;
            image?: {
              __typename?: 'FileField';
              alt?: string | null;
              title?: string | null;
              url: string;
              blurUpThumb?: string | null;
              focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
              colors: Array<{ __typename?: 'ColorField'; hex: string }>;
            } | null;
          }>;
          reportPages: Array<{
            __typename?: 'ReportsListingRecord';
            id: any;
            slug?: string | null;
            title?: string | null;
            publishDate?: any | null;
            category?: string | null;
            country?: string | null;
            image?: {
              __typename?: 'FileField';
              alt?: string | null;
              title?: string | null;
              url: string;
              blurUpThumb?: string | null;
              focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
              colors: Array<{ __typename?: 'ColorField'; hex: string }>;
            } | null;
            pdf?: {
              __typename?: 'FileField';
              alt?: string | null;
              filename: string;
              format: string;
              size: any;
              title?: string | null;
              url: string;
              uploadId: any;
            } | null;
          }>;
        }
      | {
          __typename?: 'BrandsBlockRecord';
          id: any;
          title?: string | null;
          introText?: string | null;
          hideLabels?: any | null;
          brands: Array<{
            __typename?: 'BrandPageRecord';
            id: any;
            brandName?: string | null;
            slug?: string | null;
            image?: {
              __typename?: 'FileField';
              alt?: string | null;
              tags: Array<string>;
              title?: string | null;
              url: string;
              width?: any | null;
              height?: any | null;
              format: string;
              responsiveImage?: {
                __typename?: 'ResponsiveImage';
                aspectRatio: any;
                base64?: string | null;
                bgColor?: string | null;
                height: any;
                sizes: string;
                src: string;
                srcSet: string;
                webpSrcSet: string;
                width: any;
              } | null;
            } | null;
            imageLoad?: {
              __typename?: 'FileField';
              alt?: string | null;
              title?: string | null;
              url: string;
              blurUpThumb?: string | null;
              focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
              colors: Array<{ __typename?: 'ColorField'; hex: string }>;
            } | null;
          }>;
        }
      | {
          __typename?: 'BulletListRecord';
          id: any;
          bullets?: string | null;
          numberedList?: any | null;
          title?: string | null;
        }
      | {
          __typename?: 'DocumentLinkBlockRecord';
          id: any;
          documents: Array<{
            __typename?: 'FileField';
            alt?: string | null;
            filename: string;
            format: string;
            size: any;
            title?: string | null;
            url: string;
            uploadId: any;
          }>;
        }
      | {
          __typename?: 'EmployeeRecord';
          id: any;
          name?: string | null;
          title?: string | null;
          introText?: string | null;
          description?: string | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
        }
      | {
          __typename?: 'GridContainerBlockRecord';
          id: any;
          fullwidth?: any | null;
          gap?: any | null;
          backgroundColor?: { __typename?: 'ColorField'; hex: string } | null;
          textColor?: { __typename?: 'ColorField'; hex: string } | null;
          content: Array<
            | {
                __typename?: 'GridFourcolBlockRecord';
                id: any;
                content: Array<
                  | {
                      __typename?: 'ImageRecord';
                      id: any;
                      fullWidth?: any | null;
                      image?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        responsiveImage?: {
                          __typename?: 'ResponsiveImage';
                          aspectRatio: any;
                          base64?: string | null;
                          bgColor?: string | null;
                          height: any;
                          sizes: string;
                          src: string;
                          srcSet: string;
                          webpSrcSet: string;
                          width: any;
                        } | null;
                      } | null;
                      imageLoad?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        title?: string | null;
                        url: string;
                        blurUpThumb?: string | null;
                        focalPoint?: {
                          __typename?: 'focalPoint';
                          x: any;
                          y: any;
                        } | null;
                        colors: Array<{
                          __typename?: 'ColorField';
                          hex: string;
                        }>;
                      } | null;
                    }
                  | {
                      __typename?: 'MediaWithCaptionRecord';
                      id: any;
                      centerText?: any | null;
                      textOnImage?: any | null;
                      media?: {
                        __typename?: 'ImageRecord';
                        id: any;
                        fullWidth?: any | null;
                        image?: {
                          __typename?: 'FileField';
                          alt?: string | null;
                          responsiveImage?: {
                            __typename?: 'ResponsiveImage';
                            aspectRatio: any;
                            base64?: string | null;
                            bgColor?: string | null;
                            height: any;
                            sizes: string;
                            src: string;
                            srcSet: string;
                            webpSrcSet: string;
                            width: any;
                          } | null;
                        } | null;
                        imageLoad?: {
                          __typename?: 'FileField';
                          alt?: string | null;
                          title?: string | null;
                          url: string;
                          blurUpThumb?: string | null;
                          focalPoint?: {
                            __typename?: 'focalPoint';
                            x: any;
                            y: any;
                          } | null;
                          colors: Array<{
                            __typename?: 'ColorField';
                            hex: string;
                          }>;
                        } | null;
                      } | null;
                      caption?: {
                        __typename?: 'TextBlockRecord';
                        id: any;
                        smallHeader?: any | null;
                        header?: string | null;
                        text?: string | null;
                        introText?: string | null;
                        ctaButtons: Array<{
                          __typename?: 'CtaButtonRecord';
                          id: any;
                          text?: string | null;
                          url?: string | null;
                          variant?: string | null;
                        }>;
                      } | null;
                    }
                  | {
                      __typename?: 'TextBlockRecord';
                      id: any;
                      smallHeader?: any | null;
                      header?: string | null;
                      text?: string | null;
                      introText?: string | null;
                      ctaButtons: Array<{
                        __typename?: 'CtaButtonRecord';
                        id: any;
                        text?: string | null;
                        url?: string | null;
                        variant?: string | null;
                      }>;
                    }
                >;
              }
            | {
                __typename?: 'GridThreecolBlockRecord';
                id: any;
                content: Array<
                  | {
                      __typename?: 'GridTwocolBlockRecord';
                      id: any;
                      content: Array<
                        | {
                            __typename?: 'ImageRecord';
                            id: any;
                            fullWidth?: any | null;
                            image?: {
                              __typename?: 'FileField';
                              alt?: string | null;
                              responsiveImage?: {
                                __typename?: 'ResponsiveImage';
                                aspectRatio: any;
                                base64?: string | null;
                                bgColor?: string | null;
                                height: any;
                                sizes: string;
                                src: string;
                                srcSet: string;
                                webpSrcSet: string;
                                width: any;
                              } | null;
                            } | null;
                            imageLoad?: {
                              __typename?: 'FileField';
                              alt?: string | null;
                              title?: string | null;
                              url: string;
                              blurUpThumb?: string | null;
                              focalPoint?: {
                                __typename?: 'focalPoint';
                                x: any;
                                y: any;
                              } | null;
                              colors: Array<{
                                __typename?: 'ColorField';
                                hex: string;
                              }>;
                            } | null;
                          }
                        | {
                            __typename?: 'MediaWithCaptionRecord';
                            id: any;
                            centerText?: any | null;
                            textOnImage?: any | null;
                            media?: {
                              __typename?: 'ImageRecord';
                              id: any;
                              fullWidth?: any | null;
                              image?: {
                                __typename?: 'FileField';
                                alt?: string | null;
                                responsiveImage?: {
                                  __typename?: 'ResponsiveImage';
                                  aspectRatio: any;
                                  base64?: string | null;
                                  bgColor?: string | null;
                                  height: any;
                                  sizes: string;
                                  src: string;
                                  srcSet: string;
                                  webpSrcSet: string;
                                  width: any;
                                } | null;
                              } | null;
                              imageLoad?: {
                                __typename?: 'FileField';
                                alt?: string | null;
                                title?: string | null;
                                url: string;
                                blurUpThumb?: string | null;
                                focalPoint?: {
                                  __typename?: 'focalPoint';
                                  x: any;
                                  y: any;
                                } | null;
                                colors: Array<{
                                  __typename?: 'ColorField';
                                  hex: string;
                                }>;
                              } | null;
                            } | null;
                            caption?: {
                              __typename?: 'TextBlockRecord';
                              id: any;
                              smallHeader?: any | null;
                              header?: string | null;
                              text?: string | null;
                              introText?: string | null;
                              ctaButtons: Array<{
                                __typename?: 'CtaButtonRecord';
                                id: any;
                                text?: string | null;
                                url?: string | null;
                                variant?: string | null;
                              }>;
                            } | null;
                          }
                        | {
                            __typename?: 'NewsListBlockRecord';
                            id: any;
                            title?: string | null;
                            standalone?: any | null;
                            largeTitle?: any | null;
                            itemsToShow?: any | null;
                          }
                        | {
                            __typename?: 'ReportsListBlockRecord';
                            id: any;
                            title?: string | null;
                            standalone?: any | null;
                            largeTitle?: any | null;
                          }
                        | {
                            __typename?: 'TextBlockRecord';
                            id: any;
                            smallHeader?: any | null;
                            header?: string | null;
                            text?: string | null;
                            introText?: string | null;
                            ctaButtons: Array<{
                              __typename?: 'CtaButtonRecord';
                              id: any;
                              text?: string | null;
                              url?: string | null;
                              variant?: string | null;
                            }>;
                          }
                      >;
                    }
                  | {
                      __typename?: 'ImageRecord';
                      id: any;
                      fullWidth?: any | null;
                      image?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        responsiveImage?: {
                          __typename?: 'ResponsiveImage';
                          aspectRatio: any;
                          base64?: string | null;
                          bgColor?: string | null;
                          height: any;
                          sizes: string;
                          src: string;
                          srcSet: string;
                          webpSrcSet: string;
                          width: any;
                        } | null;
                      } | null;
                      imageLoad?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        title?: string | null;
                        url: string;
                        blurUpThumb?: string | null;
                        focalPoint?: {
                          __typename?: 'focalPoint';
                          x: any;
                          y: any;
                        } | null;
                        colors: Array<{
                          __typename?: 'ColorField';
                          hex: string;
                        }>;
                      } | null;
                    }
                  | {
                      __typename?: 'MediaWithCaptionRecord';
                      id: any;
                      centerText?: any | null;
                      textOnImage?: any | null;
                      media?: {
                        __typename?: 'ImageRecord';
                        id: any;
                        fullWidth?: any | null;
                        image?: {
                          __typename?: 'FileField';
                          alt?: string | null;
                          responsiveImage?: {
                            __typename?: 'ResponsiveImage';
                            aspectRatio: any;
                            base64?: string | null;
                            bgColor?: string | null;
                            height: any;
                            sizes: string;
                            src: string;
                            srcSet: string;
                            webpSrcSet: string;
                            width: any;
                          } | null;
                        } | null;
                        imageLoad?: {
                          __typename?: 'FileField';
                          alt?: string | null;
                          title?: string | null;
                          url: string;
                          blurUpThumb?: string | null;
                          focalPoint?: {
                            __typename?: 'focalPoint';
                            x: any;
                            y: any;
                          } | null;
                          colors: Array<{
                            __typename?: 'ColorField';
                            hex: string;
                          }>;
                        } | null;
                      } | null;
                      caption?: {
                        __typename?: 'TextBlockRecord';
                        id: any;
                        smallHeader?: any | null;
                        header?: string | null;
                        text?: string | null;
                        introText?: string | null;
                        ctaButtons: Array<{
                          __typename?: 'CtaButtonRecord';
                          id: any;
                          text?: string | null;
                          url?: string | null;
                          variant?: string | null;
                        }>;
                      } | null;
                    }
                  | {
                      __typename?: 'TextBlockRecord';
                      id: any;
                      smallHeader?: any | null;
                      header?: string | null;
                      text?: string | null;
                      introText?: string | null;
                      ctaButtons: Array<{
                        __typename?: 'CtaButtonRecord';
                        id: any;
                        text?: string | null;
                        url?: string | null;
                        variant?: string | null;
                      }>;
                    }
                >;
              }
            | {
                __typename?: 'GridTwocolBlockRecord';
                id: any;
                content: Array<
                  | {
                      __typename?: 'ImageRecord';
                      id: any;
                      fullWidth?: any | null;
                      image?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        responsiveImage?: {
                          __typename?: 'ResponsiveImage';
                          aspectRatio: any;
                          base64?: string | null;
                          bgColor?: string | null;
                          height: any;
                          sizes: string;
                          src: string;
                          srcSet: string;
                          webpSrcSet: string;
                          width: any;
                        } | null;
                      } | null;
                      imageLoad?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        title?: string | null;
                        url: string;
                        blurUpThumb?: string | null;
                        focalPoint?: {
                          __typename?: 'focalPoint';
                          x: any;
                          y: any;
                        } | null;
                        colors: Array<{
                          __typename?: 'ColorField';
                          hex: string;
                        }>;
                      } | null;
                    }
                  | {
                      __typename?: 'MediaWithCaptionRecord';
                      id: any;
                      centerText?: any | null;
                      textOnImage?: any | null;
                      media?: {
                        __typename?: 'ImageRecord';
                        id: any;
                        fullWidth?: any | null;
                        image?: {
                          __typename?: 'FileField';
                          alt?: string | null;
                          responsiveImage?: {
                            __typename?: 'ResponsiveImage';
                            aspectRatio: any;
                            base64?: string | null;
                            bgColor?: string | null;
                            height: any;
                            sizes: string;
                            src: string;
                            srcSet: string;
                            webpSrcSet: string;
                            width: any;
                          } | null;
                        } | null;
                        imageLoad?: {
                          __typename?: 'FileField';
                          alt?: string | null;
                          title?: string | null;
                          url: string;
                          blurUpThumb?: string | null;
                          focalPoint?: {
                            __typename?: 'focalPoint';
                            x: any;
                            y: any;
                          } | null;
                          colors: Array<{
                            __typename?: 'ColorField';
                            hex: string;
                          }>;
                        } | null;
                      } | null;
                      caption?: {
                        __typename?: 'TextBlockRecord';
                        id: any;
                        smallHeader?: any | null;
                        header?: string | null;
                        text?: string | null;
                        introText?: string | null;
                        ctaButtons: Array<{
                          __typename?: 'CtaButtonRecord';
                          id: any;
                          text?: string | null;
                          url?: string | null;
                          variant?: string | null;
                        }>;
                      } | null;
                    }
                  | {
                      __typename?: 'NewsListBlockRecord';
                      id: any;
                      title?: string | null;
                      standalone?: any | null;
                      largeTitle?: any | null;
                      itemsToShow?: any | null;
                    }
                  | {
                      __typename?: 'ReportsListBlockRecord';
                      id: any;
                      title?: string | null;
                      standalone?: any | null;
                      largeTitle?: any | null;
                    }
                  | {
                      __typename?: 'TextBlockRecord';
                      id: any;
                      smallHeader?: any | null;
                      header?: string | null;
                      text?: string | null;
                      introText?: string | null;
                      ctaButtons: Array<{
                        __typename?: 'CtaButtonRecord';
                        id: any;
                        text?: string | null;
                        url?: string | null;
                        variant?: string | null;
                      }>;
                    }
                >;
              }
          >;
        }
      | {
          __typename?: 'HeroBlockRecord';
          id: any;
          title?: string | null;
          description?: string | null;
          ctaText?: string | null;
          ctaUrl?: string | null;
          fullWidth?: any | null;
          boxColor?: { __typename?: 'ColorField'; hex: string } | null;
          textColor?: { __typename?: 'ColorField'; hex: string } | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
          imageOverlay?: {
            __typename?: 'OverlayRecord';
            id: any;
            opacity?: any | null;
            color?: { __typename?: 'ColorField'; hex: string } | null;
          } | null;
          ctaButtons: Array<{
            __typename?: 'CtaButtonRecord';
            id: any;
            text?: string | null;
            url?: string | null;
            variant?: string | null;
          }>;
          video?: {
            __typename?: 'FileField';
            blurUpThumb?: string | null;
            title?: string | null;
            alt?: string | null;
            video?: {
              __typename?: 'UploadVideoField';
              muxPlaybackId: string;
              width: any;
              height: any;
            } | null;
          } | null;
        }
      | {
          __typename?: 'ImageRecord';
          id: any;
          fullWidth?: any | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageLoad?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
        }
      | { __typename?: 'JobsListBlockRecord'; id: any; title?: string | null }
      | {
          __typename?: 'NewsAndReportsListBlockRecord';
          newsTitle?: string | null;
          reportsTitle?: string | null;
          newsImage?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
          news: Array<{
            __typename?: 'NewsPageRecord';
            id: any;
            title?: string | null;
            slug?: string | null;
            publishDate?: any | null;
            category?: string | null;
          }>;
          reportsImage?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
          reports: Array<{
            __typename?: 'ReportsListingRecord';
            id: any;
            title?: string | null;
            slug?: string | null;
            publishDate?: any | null;
            category?: string | null;
            pdf?: {
              __typename?: 'FileField';
              alt?: string | null;
              filename: string;
              format: string;
              size: any;
              title?: string | null;
              url: string;
              uploadId: any;
            } | null;
          }>;
        }
      | {
          __typename?: 'NewsListBlockRecord';
          id: any;
          title?: string | null;
          standalone?: any | null;
          largeTitle?: any | null;
          itemsToShow?: any | null;
        }
      | {
          __typename?: 'OfficesBlockRecord';
          id: any;
          offices: Array<{
            __typename?: 'OfficeRecord';
            id: any;
            name?: string | null;
            address?: string | null;
            zipCode?: string | null;
            city?: string | null;
            country?: string | null;
            email?: string | null;
            websiteUrl?: string | null;
            phoneNumber?: string | null;
          }>;
        }
      | {
          __typename?: 'PlugBlockRecord';
          id: any;
          title?: string | null;
          description?: string | null;
          brands: Array<{
            __typename?: 'BrandPageRecord';
            id: any;
            brandName?: string | null;
            slug?: string | null;
            image?: {
              __typename?: 'FileField';
              alt?: string | null;
              tags: Array<string>;
              title?: string | null;
              url: string;
              width?: any | null;
              height?: any | null;
              format: string;
              responsiveImage?: {
                __typename?: 'ResponsiveImage';
                aspectRatio: any;
                base64?: string | null;
                bgColor?: string | null;
                height: any;
                sizes: string;
                src: string;
                srcSet: string;
                webpSrcSet: string;
                width: any;
              } | null;
            } | null;
            imageLoad?: {
              __typename?: 'FileField';
              alt?: string | null;
              title?: string | null;
              url: string;
              blurUpThumb?: string | null;
              focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
              colors: Array<{ __typename?: 'ColorField'; hex: string }>;
            } | null;
          }>;
        }
      | {
          __typename?: 'SimpleTitleAndTextBlockRecord';
          id: any;
          title?: string | null;
          topLabel?: string | null;
          description?: string | null;
        }
      | {
          __typename?: 'SliderBlockRecord';
          title?: string | null;
          arrows?: any | null;
          slideAnimation?: any | null;
          delay?: any | null;
          dots?: any | null;
          heroes: Array<{
            __typename?: 'HeroBlockRecord';
            id: any;
            title?: string | null;
            description?: string | null;
            ctaText?: string | null;
            ctaUrl?: string | null;
            fullWidth?: any | null;
            boxColor?: { __typename?: 'ColorField'; hex: string } | null;
            textColor?: { __typename?: 'ColorField'; hex: string } | null;
            image?: {
              __typename?: 'FileField';
              alt?: string | null;
              title?: string | null;
              url: string;
              blurUpThumb?: string | null;
              focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
              colors: Array<{ __typename?: 'ColorField'; hex: string }>;
            } | null;
            imageOverlay?: {
              __typename?: 'OverlayRecord';
              id: any;
              opacity?: any | null;
              color?: { __typename?: 'ColorField'; hex: string } | null;
            } | null;
            ctaButtons: Array<{
              __typename?: 'CtaButtonRecord';
              id: any;
              text?: string | null;
              url?: string | null;
              variant?: string | null;
            }>;
            video?: {
              __typename?: 'FileField';
              blurUpThumb?: string | null;
              title?: string | null;
              alt?: string | null;
              video?: {
                __typename?: 'UploadVideoField';
                muxPlaybackId: string;
                width: any;
                height: any;
              } | null;
            } | null;
          }>;
        }
      | {
          __typename?: 'StatementBlockRecord';
          id: any;
          text?: string | null;
          blackBackground?: any | null;
          header?: string | null;
          small?: any | null;
          linkText?: string | null;
          linkUrl?: string | null;
          imageMobile?: {
            __typename?: 'FileField';
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageTablet?: {
            __typename?: 'FileField';
            alt?: string | null;
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageDesktop?: {
            __typename?: 'FileField';
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageLoad?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
          imageOverlay?: {
            __typename?: 'OverlayRecord';
            id: any;
            opacity?: any | null;
            color?: { __typename?: 'ColorField'; hex: string } | null;
          } | null;
        }
      | {
          __typename?: 'SubheadingBlockRecord';
          id: any;
          title?: string | null;
          text?: string | null;
          ctaButton?: {
            __typename?: 'CtaButtonRecord';
            id: any;
            text?: string | null;
            url?: string | null;
            variant?: string | null;
          } | null;
          backgroundColor?: { __typename?: 'ColorField'; hex: string } | null;
        }
      | {
          __typename?: 'SustainabilityReportsBlockRecord';
          id: any;
          title?: string | null;
          reports: Array<{
            __typename?: 'FileField';
            alt?: string | null;
            filename: string;
            format: string;
            size: any;
            title?: string | null;
            url: string;
            uploadId: any;
          }>;
        }
      | {
          __typename?: 'TextBlockRecord';
          id: any;
          smallHeader?: any | null;
          header?: string | null;
          text?: string | null;
          introText?: string | null;
          ctaButtons: Array<{
            __typename?: 'CtaButtonRecord';
            id: any;
            text?: string | null;
            url?: string | null;
            variant?: string | null;
          }>;
        }
      | {
          __typename?: 'TwoColumnImageAndTextRecord';
          id: any;
          text?: string | null;
          title?: string | null;
          reverse?: any | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageLoad?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
        }
      | {
          __typename?: 'TwoColumnTextIntroRecord';
          id: any;
          introText?: string | null;
          text?: string | null;
          header?: string | null;
        }
      | {
          __typename?: 'VideoRecord';
          id: any;
          autoplay?: any | null;
          video?: {
            __typename?: 'FileField';
            title?: string | null;
            video?: {
              __typename?: 'UploadVideoField';
              mp4Url?: string | null;
              streamingUrl: string;
              thumbnailUrl: string;
              mp4Low?: string | null;
            } | null;
          } | null;
          videoThumbnail?: {
            __typename?: 'FileField';
            alt?: string | null;
            tags: Array<string>;
            title?: string | null;
            url: string;
            width?: any | null;
            height?: any | null;
            format: string;
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          muxVideo?: {
            __typename?: 'FileField';
            blurUpThumb?: string | null;
            title?: string | null;
            alt?: string | null;
            video?: {
              __typename?: 'UploadVideoField';
              muxPlaybackId: string;
              width: any;
              height: any;
            } | null;
          } | null;
        }
    >;
  } | null;
  globalContent?: {
    __typename?: 'GlobalRecord';
    changeLanguage?: string | null;
    closeLabel?: string | null;
    deadline?: string | null;
    errorMessage?: string | null;
    loading?: string | null;
    loadMoreNews?: string | null;
    localWebLabel?: string | null;
    menu?: string | null;
    moreNewsCta?: string | null;
    moreNewsHeader?: string | null;
    partnerPortalLabel?: string | null;
    partnerPortalUrl?: string | null;
    play?: string | null;
    shopLinkTitle?: string | null;
    shopLinkUrl?: string | null;
    showMoreJobsLabel?: string | null;
    viewOnMapLabel?: string | null;
    nextLabel?: string | null;
    previousLabel?: string | null;
    sliderNavigationLabel?: string | null;
    moreReportsCta?: string | null;
    loadMoreReports?: string | null;
    clearIconLabel?: string | null;
    searchIconLabel?: string | null;
    searchBoxPlaceholder?: string | null;
    viewAllButtonLabel?: string | null;
    searchResultsPageTitle?: string | null;
    firstPageLabel?: string | null;
    previousPageLabel?: string | null;
    nextPageLabel?: string | null;
    lastPageLabel?: string | null;
    goToPageLabel?: string | null;
    searchResultCount?: string | null;
    noSearchResults?: string | null;
    navigationLogo?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      responsiveImage?: {
        __typename?: 'ResponsiveImage';
        aspectRatio: any;
        base64?: string | null;
        bgColor?: string | null;
        height: any;
        sizes: string;
        src: string;
        srcSet: string;
        webpSrcSet: string;
        width: any;
      } | null;
    } | null;
    languages: Array<{
      __typename?: 'LanguageRecord';
      name?: string | null;
      url?: string | null;
      flag?: string | null;
      symbol?: {
        __typename?: 'FileField';
        alt?: string | null;
        tags: Array<string>;
        title?: string | null;
        url: string;
        width?: any | null;
        height?: any | null;
        format: string;
      } | null;
    }>;
  } | null;
  featureToggle?: {
    __typename?: 'FeatureToggleRecord';
    landingPageContentArea?: any | null;
    newsPageContentArea?: any | null;
  } | null;
  menu?: {
    __typename?: 'MenuRecord';
    menuItems: Array<{
      __typename?: 'MenuItemRecord';
      id: any;
      title?: string | null;
      url?: string | null;
      submenu?: {
        __typename?: 'SubmenuRecord';
        title?: string | null;
        menuItems: Array<{
          __typename?: 'ItemRecord';
          title?: string | null;
          pageLink?:
            | { __typename?: 'AboutUsPageRecord'; slug?: string | null }
            | { __typename?: 'BrandPageRecord'; slug?: string | null }
            | { __typename?: 'SustainabilityPageRecord'; slug?: string | null }
            | null;
        }>;
      } | null;
    }>;
  } | null;
  footer?: {
    __typename?: 'FooterRecord';
    bottomIntro?: string | null;
    cookieSettings?: string | null;
    introText?: string | null;
    moreInfoText?: string | null;
    partnerLogin?: string | null;
    selectCountryLabel?: string | null;
    socialMediaLabel?: string | null;
    useNewFooter?: any | null;
    footerLogo?: {
      __typename?: 'FileField';
      alt?: string | null;
      tags: Array<string>;
      title?: string | null;
      url: string;
      width?: any | null;
      height?: any | null;
      format: string;
    } | null;
    hultaforsBrands: Array<{
      __typename?: 'LinkRecord';
      id: any;
      title?: string | null;
      url?: string | null;
    }>;
    menu: Array<{
      __typename?: 'LinkRecord';
      id: any;
      title?: string | null;
      url?: string | null;
    }>;
    menuItems: Array<{
      __typename?: 'FooterMenuItemRecord';
      heading?: string | null;
      includeCookieToggle?: any | null;
      links: Array<{
        __typename?: 'LinkRecord';
        url?: string | null;
        title?: string | null;
      }>;
    }>;
    socialMediaMenu: Array<{
      __typename?: 'IconLinkRecord';
      url?: string | null;
      icon?: {
        __typename?: 'FileField';
        alt?: string | null;
        tags: Array<string>;
        title?: string | null;
        url: string;
        width?: any | null;
        height?: any | null;
        format: string;
      } | null;
    }>;
  } | null;
};

export type AllJobsQueryVariables = Exact<{
  locale?: InputMaybe<SiteLocale>;
  pageSize?: InputMaybe<Scalars['IntType']['input']>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
}>;

export type AllJobsQuery = {
  __typename?: 'Query';
  items: Array<{
    __typename?: 'JobOpportunitiesPageRecord';
    id: any;
    slug?: string | null;
    title?: string | null;
    publishDate?: any | null;
    category?: string | null;
    country?: string | null;
    department?: string | null;
  }>;
  meta: { __typename?: 'CollectionMetadata'; count: any };
};

export type AllNewsPagesQueryVariables = Exact<{
  locale?: InputMaybe<SiteLocale>;
  pageSize?: InputMaybe<Scalars['IntType']['input']>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
}>;

export type AllNewsPagesQuery = {
  __typename?: 'Query';
  items: Array<{
    __typename?: 'NewsPageRecord';
    id: any;
    slug?: string | null;
    title?: string | null;
    publishDate?: any | null;
    category?: string | null;
    country?: string | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
  }>;
  meta: { __typename?: 'CollectionMetadata'; count: any };
};

export type AllReportsListingsQueryVariables = Exact<{
  locale?: InputMaybe<SiteLocale>;
  pageSize?: InputMaybe<Scalars['IntType']['input']>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
}>;

export type AllReportsListingsQuery = {
  __typename?: 'Query';
  items: Array<{
    __typename?: 'ReportsListingRecord';
    id: any;
    slug?: string | null;
    title?: string | null;
    publishDate?: any | null;
    category?: string | null;
    country?: string | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
    pdf?: {
      __typename?: 'FileField';
      alt?: string | null;
      filename: string;
      format: string;
      size: any;
      title?: string | null;
      url: string;
      uploadId: any;
    } | null;
  }>;
  meta: { __typename?: 'CollectionMetadata'; count: any };
};

export type BrandPageQueryVariables = Exact<{
  locale?: InputMaybe<SiteLocale>;
  slug: Scalars['String']['input'];
}>;

export type BrandPageQuery = {
  __typename?: 'Query';
  brandPage?: {
    __typename?: 'BrandPageRecord';
    heroTitle?: string | null;
    linkToWebsite?: string | null;
    linkToWebsiteText?: string | null;
    brandName?: string | null;
    description?: string | null;
    slug?: string | null;
    pageLocales: Array<SiteLocale>;
    heroImage?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
    seo?: {
      __typename?: 'SeoField';
      description?: string | null;
      title?: string | null;
      image?: {
        __typename?: 'FileField';
        url: string;
        alt?: string | null;
        title?: string | null;
      } | null;
    } | null;
    logo?: {
      __typename?: 'FileField';
      alt?: string | null;
      responsiveImage?: {
        __typename?: 'ResponsiveImage';
        width: any;
        height: any;
        aspectRatio: any;
        base64?: string | null;
        bgColor?: string | null;
        sizes: string;
        src: string;
        srcSet: string;
        webpSrcSet: string;
      } | null;
    } | null;
  } | null;
  globalContent?: {
    __typename?: 'GlobalRecord';
    changeLanguage?: string | null;
    closeLabel?: string | null;
    deadline?: string | null;
    errorMessage?: string | null;
    loading?: string | null;
    loadMoreNews?: string | null;
    localWebLabel?: string | null;
    menu?: string | null;
    moreNewsCta?: string | null;
    moreNewsHeader?: string | null;
    partnerPortalLabel?: string | null;
    partnerPortalUrl?: string | null;
    play?: string | null;
    shopLinkTitle?: string | null;
    shopLinkUrl?: string | null;
    showMoreJobsLabel?: string | null;
    viewOnMapLabel?: string | null;
    nextLabel?: string | null;
    previousLabel?: string | null;
    sliderNavigationLabel?: string | null;
    moreReportsCta?: string | null;
    loadMoreReports?: string | null;
    clearIconLabel?: string | null;
    searchIconLabel?: string | null;
    searchBoxPlaceholder?: string | null;
    viewAllButtonLabel?: string | null;
    searchResultsPageTitle?: string | null;
    firstPageLabel?: string | null;
    previousPageLabel?: string | null;
    nextPageLabel?: string | null;
    lastPageLabel?: string | null;
    goToPageLabel?: string | null;
    searchResultCount?: string | null;
    noSearchResults?: string | null;
    navigationLogo?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      responsiveImage?: {
        __typename?: 'ResponsiveImage';
        aspectRatio: any;
        base64?: string | null;
        bgColor?: string | null;
        height: any;
        sizes: string;
        src: string;
        srcSet: string;
        webpSrcSet: string;
        width: any;
      } | null;
    } | null;
    languages: Array<{
      __typename?: 'LanguageRecord';
      name?: string | null;
      url?: string | null;
      flag?: string | null;
      symbol?: {
        __typename?: 'FileField';
        alt?: string | null;
        tags: Array<string>;
        title?: string | null;
        url: string;
        width?: any | null;
        height?: any | null;
        format: string;
      } | null;
    }>;
  } | null;
  featureToggle?: {
    __typename?: 'FeatureToggleRecord';
    landingPageContentArea?: any | null;
    newsPageContentArea?: any | null;
  } | null;
  menu?: {
    __typename?: 'MenuRecord';
    menuItems: Array<{
      __typename?: 'MenuItemRecord';
      id: any;
      title?: string | null;
      url?: string | null;
      submenu?: {
        __typename?: 'SubmenuRecord';
        title?: string | null;
        menuItems: Array<{
          __typename?: 'ItemRecord';
          title?: string | null;
          pageLink?:
            | { __typename?: 'AboutUsPageRecord'; slug?: string | null }
            | { __typename?: 'BrandPageRecord'; slug?: string | null }
            | { __typename?: 'SustainabilityPageRecord'; slug?: string | null }
            | null;
        }>;
      } | null;
    }>;
  } | null;
  footer?: {
    __typename?: 'FooterRecord';
    bottomIntro?: string | null;
    cookieSettings?: string | null;
    introText?: string | null;
    moreInfoText?: string | null;
    partnerLogin?: string | null;
    selectCountryLabel?: string | null;
    socialMediaLabel?: string | null;
    useNewFooter?: any | null;
    footerLogo?: {
      __typename?: 'FileField';
      alt?: string | null;
      tags: Array<string>;
      title?: string | null;
      url: string;
      width?: any | null;
      height?: any | null;
      format: string;
    } | null;
    hultaforsBrands: Array<{
      __typename?: 'LinkRecord';
      id: any;
      title?: string | null;
      url?: string | null;
    }>;
    menu: Array<{
      __typename?: 'LinkRecord';
      id: any;
      title?: string | null;
      url?: string | null;
    }>;
    menuItems: Array<{
      __typename?: 'FooterMenuItemRecord';
      heading?: string | null;
      includeCookieToggle?: any | null;
      links: Array<{
        __typename?: 'LinkRecord';
        url?: string | null;
        title?: string | null;
      }>;
    }>;
    socialMediaMenu: Array<{
      __typename?: 'IconLinkRecord';
      url?: string | null;
      icon?: {
        __typename?: 'FileField';
        alt?: string | null;
        tags: Array<string>;
        title?: string | null;
        url: string;
        width?: any | null;
        height?: any | null;
        format: string;
      } | null;
    }>;
  } | null;
};

export type BrandsListPageQueryVariables = Exact<{
  locale?: InputMaybe<SiteLocale>;
}>;

export type BrandsListPageQuery = {
  __typename?: 'Query';
  brandsListPage?: {
    __typename?: 'BrandsListPageRecord';
    id: any;
    pageLocales: Array<SiteLocale>;
    seo?: {
      __typename?: 'SeoField';
      description?: string | null;
      title?: string | null;
      image?: {
        __typename?: 'FileField';
        url: string;
        alt?: string | null;
        title?: string | null;
      } | null;
    } | null;
    contentArea: Array<
      | {
          __typename?: 'ArticlesBlockRecord';
          id: any;
          title?: string | null;
          isJobArticles?: any | null;
          ctaText?: string | null;
          ctaUrl?: string | null;
          jobPages: Array<{
            __typename?: 'JobOpportunitiesPageRecord';
            id: any;
            slug?: string | null;
            title?: string | null;
            publishDate?: any | null;
            category?: string | null;
            country?: string | null;
            department?: string | null;
          }>;
          newsPages: Array<{
            __typename?: 'NewsPageRecord';
            id: any;
            slug?: string | null;
            title?: string | null;
            publishDate?: any | null;
            category?: string | null;
            country?: string | null;
            image?: {
              __typename?: 'FileField';
              alt?: string | null;
              title?: string | null;
              url: string;
              blurUpThumb?: string | null;
              focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
              colors: Array<{ __typename?: 'ColorField'; hex: string }>;
            } | null;
          }>;
          reportPages: Array<{
            __typename?: 'ReportsListingRecord';
            id: any;
            slug?: string | null;
            title?: string | null;
            publishDate?: any | null;
            category?: string | null;
            country?: string | null;
            image?: {
              __typename?: 'FileField';
              alt?: string | null;
              title?: string | null;
              url: string;
              blurUpThumb?: string | null;
              focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
              colors: Array<{ __typename?: 'ColorField'; hex: string }>;
            } | null;
            pdf?: {
              __typename?: 'FileField';
              alt?: string | null;
              filename: string;
              format: string;
              size: any;
              title?: string | null;
              url: string;
              uploadId: any;
            } | null;
          }>;
        }
      | {
          __typename?: 'BrandsBlockRecord';
          id: any;
          title?: string | null;
          introText?: string | null;
          hideLabels?: any | null;
          brands: Array<{
            __typename?: 'BrandPageRecord';
            id: any;
            brandName?: string | null;
            slug?: string | null;
            image?: {
              __typename?: 'FileField';
              alt?: string | null;
              tags: Array<string>;
              title?: string | null;
              url: string;
              width?: any | null;
              height?: any | null;
              format: string;
              responsiveImage?: {
                __typename?: 'ResponsiveImage';
                aspectRatio: any;
                base64?: string | null;
                bgColor?: string | null;
                height: any;
                sizes: string;
                src: string;
                srcSet: string;
                webpSrcSet: string;
                width: any;
              } | null;
            } | null;
            imageLoad?: {
              __typename?: 'FileField';
              alt?: string | null;
              title?: string | null;
              url: string;
              blurUpThumb?: string | null;
              focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
              colors: Array<{ __typename?: 'ColorField'; hex: string }>;
            } | null;
          }>;
        }
      | {
          __typename?: 'BulletListRecord';
          id: any;
          bullets?: string | null;
          numberedList?: any | null;
          title?: string | null;
        }
      | {
          __typename?: 'DocumentLinkBlockRecord';
          id: any;
          documents: Array<{
            __typename?: 'FileField';
            alt?: string | null;
            filename: string;
            format: string;
            size: any;
            title?: string | null;
            url: string;
            uploadId: any;
          }>;
        }
      | {
          __typename?: 'EmployeeRecord';
          id: any;
          name?: string | null;
          title?: string | null;
          introText?: string | null;
          description?: string | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
        }
      | {
          __typename?: 'GridContainerBlockRecord';
          id: any;
          fullwidth?: any | null;
          gap?: any | null;
          backgroundColor?: { __typename?: 'ColorField'; hex: string } | null;
          textColor?: { __typename?: 'ColorField'; hex: string } | null;
          content: Array<
            | {
                __typename?: 'GridFourcolBlockRecord';
                id: any;
                content: Array<
                  | {
                      __typename?: 'ImageRecord';
                      id: any;
                      fullWidth?: any | null;
                      image?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        responsiveImage?: {
                          __typename?: 'ResponsiveImage';
                          aspectRatio: any;
                          base64?: string | null;
                          bgColor?: string | null;
                          height: any;
                          sizes: string;
                          src: string;
                          srcSet: string;
                          webpSrcSet: string;
                          width: any;
                        } | null;
                      } | null;
                      imageLoad?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        title?: string | null;
                        url: string;
                        blurUpThumb?: string | null;
                        focalPoint?: {
                          __typename?: 'focalPoint';
                          x: any;
                          y: any;
                        } | null;
                        colors: Array<{
                          __typename?: 'ColorField';
                          hex: string;
                        }>;
                      } | null;
                    }
                  | {
                      __typename?: 'MediaWithCaptionRecord';
                      id: any;
                      centerText?: any | null;
                      textOnImage?: any | null;
                      media?: {
                        __typename?: 'ImageRecord';
                        id: any;
                        fullWidth?: any | null;
                        image?: {
                          __typename?: 'FileField';
                          alt?: string | null;
                          responsiveImage?: {
                            __typename?: 'ResponsiveImage';
                            aspectRatio: any;
                            base64?: string | null;
                            bgColor?: string | null;
                            height: any;
                            sizes: string;
                            src: string;
                            srcSet: string;
                            webpSrcSet: string;
                            width: any;
                          } | null;
                        } | null;
                        imageLoad?: {
                          __typename?: 'FileField';
                          alt?: string | null;
                          title?: string | null;
                          url: string;
                          blurUpThumb?: string | null;
                          focalPoint?: {
                            __typename?: 'focalPoint';
                            x: any;
                            y: any;
                          } | null;
                          colors: Array<{
                            __typename?: 'ColorField';
                            hex: string;
                          }>;
                        } | null;
                      } | null;
                      caption?: {
                        __typename?: 'TextBlockRecord';
                        id: any;
                        smallHeader?: any | null;
                        header?: string | null;
                        text?: string | null;
                        introText?: string | null;
                        ctaButtons: Array<{
                          __typename?: 'CtaButtonRecord';
                          id: any;
                          text?: string | null;
                          url?: string | null;
                          variant?: string | null;
                        }>;
                      } | null;
                    }
                  | {
                      __typename?: 'TextBlockRecord';
                      id: any;
                      smallHeader?: any | null;
                      header?: string | null;
                      text?: string | null;
                      introText?: string | null;
                      ctaButtons: Array<{
                        __typename?: 'CtaButtonRecord';
                        id: any;
                        text?: string | null;
                        url?: string | null;
                        variant?: string | null;
                      }>;
                    }
                >;
              }
            | {
                __typename?: 'GridThreecolBlockRecord';
                id: any;
                content: Array<
                  | {
                      __typename?: 'GridTwocolBlockRecord';
                      id: any;
                      content: Array<
                        | {
                            __typename?: 'ImageRecord';
                            id: any;
                            fullWidth?: any | null;
                            image?: {
                              __typename?: 'FileField';
                              alt?: string | null;
                              responsiveImage?: {
                                __typename?: 'ResponsiveImage';
                                aspectRatio: any;
                                base64?: string | null;
                                bgColor?: string | null;
                                height: any;
                                sizes: string;
                                src: string;
                                srcSet: string;
                                webpSrcSet: string;
                                width: any;
                              } | null;
                            } | null;
                            imageLoad?: {
                              __typename?: 'FileField';
                              alt?: string | null;
                              title?: string | null;
                              url: string;
                              blurUpThumb?: string | null;
                              focalPoint?: {
                                __typename?: 'focalPoint';
                                x: any;
                                y: any;
                              } | null;
                              colors: Array<{
                                __typename?: 'ColorField';
                                hex: string;
                              }>;
                            } | null;
                          }
                        | {
                            __typename?: 'MediaWithCaptionRecord';
                            id: any;
                            centerText?: any | null;
                            textOnImage?: any | null;
                            media?: {
                              __typename?: 'ImageRecord';
                              id: any;
                              fullWidth?: any | null;
                              image?: {
                                __typename?: 'FileField';
                                alt?: string | null;
                                responsiveImage?: {
                                  __typename?: 'ResponsiveImage';
                                  aspectRatio: any;
                                  base64?: string | null;
                                  bgColor?: string | null;
                                  height: any;
                                  sizes: string;
                                  src: string;
                                  srcSet: string;
                                  webpSrcSet: string;
                                  width: any;
                                } | null;
                              } | null;
                              imageLoad?: {
                                __typename?: 'FileField';
                                alt?: string | null;
                                title?: string | null;
                                url: string;
                                blurUpThumb?: string | null;
                                focalPoint?: {
                                  __typename?: 'focalPoint';
                                  x: any;
                                  y: any;
                                } | null;
                                colors: Array<{
                                  __typename?: 'ColorField';
                                  hex: string;
                                }>;
                              } | null;
                            } | null;
                            caption?: {
                              __typename?: 'TextBlockRecord';
                              id: any;
                              smallHeader?: any | null;
                              header?: string | null;
                              text?: string | null;
                              introText?: string | null;
                              ctaButtons: Array<{
                                __typename?: 'CtaButtonRecord';
                                id: any;
                                text?: string | null;
                                url?: string | null;
                                variant?: string | null;
                              }>;
                            } | null;
                          }
                        | {
                            __typename?: 'NewsListBlockRecord';
                            id: any;
                            title?: string | null;
                            standalone?: any | null;
                            largeTitle?: any | null;
                            itemsToShow?: any | null;
                          }
                        | {
                            __typename?: 'ReportsListBlockRecord';
                            id: any;
                            title?: string | null;
                            standalone?: any | null;
                            largeTitle?: any | null;
                          }
                        | {
                            __typename?: 'TextBlockRecord';
                            id: any;
                            smallHeader?: any | null;
                            header?: string | null;
                            text?: string | null;
                            introText?: string | null;
                            ctaButtons: Array<{
                              __typename?: 'CtaButtonRecord';
                              id: any;
                              text?: string | null;
                              url?: string | null;
                              variant?: string | null;
                            }>;
                          }
                      >;
                    }
                  | {
                      __typename?: 'ImageRecord';
                      id: any;
                      fullWidth?: any | null;
                      image?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        responsiveImage?: {
                          __typename?: 'ResponsiveImage';
                          aspectRatio: any;
                          base64?: string | null;
                          bgColor?: string | null;
                          height: any;
                          sizes: string;
                          src: string;
                          srcSet: string;
                          webpSrcSet: string;
                          width: any;
                        } | null;
                      } | null;
                      imageLoad?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        title?: string | null;
                        url: string;
                        blurUpThumb?: string | null;
                        focalPoint?: {
                          __typename?: 'focalPoint';
                          x: any;
                          y: any;
                        } | null;
                        colors: Array<{
                          __typename?: 'ColorField';
                          hex: string;
                        }>;
                      } | null;
                    }
                  | {
                      __typename?: 'MediaWithCaptionRecord';
                      id: any;
                      centerText?: any | null;
                      textOnImage?: any | null;
                      media?: {
                        __typename?: 'ImageRecord';
                        id: any;
                        fullWidth?: any | null;
                        image?: {
                          __typename?: 'FileField';
                          alt?: string | null;
                          responsiveImage?: {
                            __typename?: 'ResponsiveImage';
                            aspectRatio: any;
                            base64?: string | null;
                            bgColor?: string | null;
                            height: any;
                            sizes: string;
                            src: string;
                            srcSet: string;
                            webpSrcSet: string;
                            width: any;
                          } | null;
                        } | null;
                        imageLoad?: {
                          __typename?: 'FileField';
                          alt?: string | null;
                          title?: string | null;
                          url: string;
                          blurUpThumb?: string | null;
                          focalPoint?: {
                            __typename?: 'focalPoint';
                            x: any;
                            y: any;
                          } | null;
                          colors: Array<{
                            __typename?: 'ColorField';
                            hex: string;
                          }>;
                        } | null;
                      } | null;
                      caption?: {
                        __typename?: 'TextBlockRecord';
                        id: any;
                        smallHeader?: any | null;
                        header?: string | null;
                        text?: string | null;
                        introText?: string | null;
                        ctaButtons: Array<{
                          __typename?: 'CtaButtonRecord';
                          id: any;
                          text?: string | null;
                          url?: string | null;
                          variant?: string | null;
                        }>;
                      } | null;
                    }
                  | {
                      __typename?: 'TextBlockRecord';
                      id: any;
                      smallHeader?: any | null;
                      header?: string | null;
                      text?: string | null;
                      introText?: string | null;
                      ctaButtons: Array<{
                        __typename?: 'CtaButtonRecord';
                        id: any;
                        text?: string | null;
                        url?: string | null;
                        variant?: string | null;
                      }>;
                    }
                >;
              }
            | {
                __typename?: 'GridTwocolBlockRecord';
                id: any;
                content: Array<
                  | {
                      __typename?: 'ImageRecord';
                      id: any;
                      fullWidth?: any | null;
                      image?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        responsiveImage?: {
                          __typename?: 'ResponsiveImage';
                          aspectRatio: any;
                          base64?: string | null;
                          bgColor?: string | null;
                          height: any;
                          sizes: string;
                          src: string;
                          srcSet: string;
                          webpSrcSet: string;
                          width: any;
                        } | null;
                      } | null;
                      imageLoad?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        title?: string | null;
                        url: string;
                        blurUpThumb?: string | null;
                        focalPoint?: {
                          __typename?: 'focalPoint';
                          x: any;
                          y: any;
                        } | null;
                        colors: Array<{
                          __typename?: 'ColorField';
                          hex: string;
                        }>;
                      } | null;
                    }
                  | {
                      __typename?: 'MediaWithCaptionRecord';
                      id: any;
                      centerText?: any | null;
                      textOnImage?: any | null;
                      media?: {
                        __typename?: 'ImageRecord';
                        id: any;
                        fullWidth?: any | null;
                        image?: {
                          __typename?: 'FileField';
                          alt?: string | null;
                          responsiveImage?: {
                            __typename?: 'ResponsiveImage';
                            aspectRatio: any;
                            base64?: string | null;
                            bgColor?: string | null;
                            height: any;
                            sizes: string;
                            src: string;
                            srcSet: string;
                            webpSrcSet: string;
                            width: any;
                          } | null;
                        } | null;
                        imageLoad?: {
                          __typename?: 'FileField';
                          alt?: string | null;
                          title?: string | null;
                          url: string;
                          blurUpThumb?: string | null;
                          focalPoint?: {
                            __typename?: 'focalPoint';
                            x: any;
                            y: any;
                          } | null;
                          colors: Array<{
                            __typename?: 'ColorField';
                            hex: string;
                          }>;
                        } | null;
                      } | null;
                      caption?: {
                        __typename?: 'TextBlockRecord';
                        id: any;
                        smallHeader?: any | null;
                        header?: string | null;
                        text?: string | null;
                        introText?: string | null;
                        ctaButtons: Array<{
                          __typename?: 'CtaButtonRecord';
                          id: any;
                          text?: string | null;
                          url?: string | null;
                          variant?: string | null;
                        }>;
                      } | null;
                    }
                  | {
                      __typename?: 'NewsListBlockRecord';
                      id: any;
                      title?: string | null;
                      standalone?: any | null;
                      largeTitle?: any | null;
                      itemsToShow?: any | null;
                    }
                  | {
                      __typename?: 'ReportsListBlockRecord';
                      id: any;
                      title?: string | null;
                      standalone?: any | null;
                      largeTitle?: any | null;
                    }
                  | {
                      __typename?: 'TextBlockRecord';
                      id: any;
                      smallHeader?: any | null;
                      header?: string | null;
                      text?: string | null;
                      introText?: string | null;
                      ctaButtons: Array<{
                        __typename?: 'CtaButtonRecord';
                        id: any;
                        text?: string | null;
                        url?: string | null;
                        variant?: string | null;
                      }>;
                    }
                >;
              }
          >;
        }
      | {
          __typename?: 'HeroBlockRecord';
          id: any;
          title?: string | null;
          description?: string | null;
          ctaText?: string | null;
          ctaUrl?: string | null;
          fullWidth?: any | null;
          boxColor?: { __typename?: 'ColorField'; hex: string } | null;
          textColor?: { __typename?: 'ColorField'; hex: string } | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
          imageOverlay?: {
            __typename?: 'OverlayRecord';
            id: any;
            opacity?: any | null;
            color?: { __typename?: 'ColorField'; hex: string } | null;
          } | null;
          ctaButtons: Array<{
            __typename?: 'CtaButtonRecord';
            id: any;
            text?: string | null;
            url?: string | null;
            variant?: string | null;
          }>;
          video?: {
            __typename?: 'FileField';
            blurUpThumb?: string | null;
            title?: string | null;
            alt?: string | null;
            video?: {
              __typename?: 'UploadVideoField';
              muxPlaybackId: string;
              width: any;
              height: any;
            } | null;
          } | null;
        }
      | {
          __typename?: 'ImageRecord';
          id: any;
          fullWidth?: any | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageLoad?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
        }
      | {
          __typename?: 'NewsAndReportsListBlockRecord';
          newsTitle?: string | null;
          reportsTitle?: string | null;
          newsImage?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
          news: Array<{
            __typename?: 'NewsPageRecord';
            id: any;
            title?: string | null;
            slug?: string | null;
            publishDate?: any | null;
            category?: string | null;
          }>;
          reportsImage?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
          reports: Array<{
            __typename?: 'ReportsListingRecord';
            id: any;
            title?: string | null;
            slug?: string | null;
            publishDate?: any | null;
            category?: string | null;
            pdf?: {
              __typename?: 'FileField';
              alt?: string | null;
              filename: string;
              format: string;
              size: any;
              title?: string | null;
              url: string;
              uploadId: any;
            } | null;
          }>;
        }
      | {
          __typename?: 'NewsListBlockRecord';
          id: any;
          title?: string | null;
          standalone?: any | null;
          largeTitle?: any | null;
          itemsToShow?: any | null;
        }
      | {
          __typename?: 'OfficesBlockRecord';
          id: any;
          offices: Array<{
            __typename?: 'OfficeRecord';
            id: any;
            name?: string | null;
            address?: string | null;
            zipCode?: string | null;
            city?: string | null;
            country?: string | null;
            email?: string | null;
            websiteUrl?: string | null;
            phoneNumber?: string | null;
          }>;
        }
      | {
          __typename?: 'PlugBlockRecord';
          id: any;
          title?: string | null;
          description?: string | null;
          brands: Array<{
            __typename?: 'BrandPageRecord';
            id: any;
            brandName?: string | null;
            slug?: string | null;
            image?: {
              __typename?: 'FileField';
              alt?: string | null;
              tags: Array<string>;
              title?: string | null;
              url: string;
              width?: any | null;
              height?: any | null;
              format: string;
              responsiveImage?: {
                __typename?: 'ResponsiveImage';
                aspectRatio: any;
                base64?: string | null;
                bgColor?: string | null;
                height: any;
                sizes: string;
                src: string;
                srcSet: string;
                webpSrcSet: string;
                width: any;
              } | null;
            } | null;
            imageLoad?: {
              __typename?: 'FileField';
              alt?: string | null;
              title?: string | null;
              url: string;
              blurUpThumb?: string | null;
              focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
              colors: Array<{ __typename?: 'ColorField'; hex: string }>;
            } | null;
          }>;
        }
      | {
          __typename?: 'ReportsListBlockRecord';
          id: any;
          title?: string | null;
          standalone?: any | null;
          largeTitle?: any | null;
        }
      | {
          __typename?: 'SimpleTitleAndTextBlockRecord';
          id: any;
          title?: string | null;
          topLabel?: string | null;
          description?: string | null;
        }
      | {
          __typename?: 'SliderBlockRecord';
          title?: string | null;
          arrows?: any | null;
          slideAnimation?: any | null;
          delay?: any | null;
          dots?: any | null;
          heroes: Array<{
            __typename?: 'HeroBlockRecord';
            id: any;
            title?: string | null;
            description?: string | null;
            ctaText?: string | null;
            ctaUrl?: string | null;
            fullWidth?: any | null;
            boxColor?: { __typename?: 'ColorField'; hex: string } | null;
            textColor?: { __typename?: 'ColorField'; hex: string } | null;
            image?: {
              __typename?: 'FileField';
              alt?: string | null;
              title?: string | null;
              url: string;
              blurUpThumb?: string | null;
              focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
              colors: Array<{ __typename?: 'ColorField'; hex: string }>;
            } | null;
            imageOverlay?: {
              __typename?: 'OverlayRecord';
              id: any;
              opacity?: any | null;
              color?: { __typename?: 'ColorField'; hex: string } | null;
            } | null;
            ctaButtons: Array<{
              __typename?: 'CtaButtonRecord';
              id: any;
              text?: string | null;
              url?: string | null;
              variant?: string | null;
            }>;
            video?: {
              __typename?: 'FileField';
              blurUpThumb?: string | null;
              title?: string | null;
              alt?: string | null;
              video?: {
                __typename?: 'UploadVideoField';
                muxPlaybackId: string;
                width: any;
                height: any;
              } | null;
            } | null;
          }>;
        }
      | {
          __typename?: 'StatementBlockRecord';
          id: any;
          text?: string | null;
          blackBackground?: any | null;
          header?: string | null;
          small?: any | null;
          linkText?: string | null;
          linkUrl?: string | null;
          imageMobile?: {
            __typename?: 'FileField';
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageTablet?: {
            __typename?: 'FileField';
            alt?: string | null;
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageDesktop?: {
            __typename?: 'FileField';
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageLoad?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
          imageOverlay?: {
            __typename?: 'OverlayRecord';
            id: any;
            opacity?: any | null;
            color?: { __typename?: 'ColorField'; hex: string } | null;
          } | null;
        }
      | {
          __typename?: 'SubheadingBlockRecord';
          id: any;
          title?: string | null;
          text?: string | null;
          ctaButton?: {
            __typename?: 'CtaButtonRecord';
            id: any;
            text?: string | null;
            url?: string | null;
            variant?: string | null;
          } | null;
          backgroundColor?: { __typename?: 'ColorField'; hex: string } | null;
        }
      | {
          __typename?: 'SustainabilityReportsBlockRecord';
          id: any;
          title?: string | null;
          reports: Array<{
            __typename?: 'FileField';
            alt?: string | null;
            filename: string;
            format: string;
            size: any;
            title?: string | null;
            url: string;
            uploadId: any;
          }>;
        }
      | {
          __typename?: 'TextBlockRecord';
          id: any;
          smallHeader?: any | null;
          header?: string | null;
          text?: string | null;
          introText?: string | null;
          ctaButtons: Array<{
            __typename?: 'CtaButtonRecord';
            id: any;
            text?: string | null;
            url?: string | null;
            variant?: string | null;
          }>;
        }
      | {
          __typename?: 'TwoColumnImageAndTextRecord';
          id: any;
          text?: string | null;
          title?: string | null;
          reverse?: any | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageLoad?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
        }
      | {
          __typename?: 'TwoColumnTextIntroRecord';
          id: any;
          introText?: string | null;
          text?: string | null;
          header?: string | null;
        }
      | {
          __typename?: 'VideoRecord';
          id: any;
          autoplay?: any | null;
          video?: {
            __typename?: 'FileField';
            title?: string | null;
            video?: {
              __typename?: 'UploadVideoField';
              mp4Url?: string | null;
              streamingUrl: string;
              thumbnailUrl: string;
              mp4Low?: string | null;
            } | null;
          } | null;
          videoThumbnail?: {
            __typename?: 'FileField';
            alt?: string | null;
            tags: Array<string>;
            title?: string | null;
            url: string;
            width?: any | null;
            height?: any | null;
            format: string;
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          muxVideo?: {
            __typename?: 'FileField';
            blurUpThumb?: string | null;
            title?: string | null;
            alt?: string | null;
            video?: {
              __typename?: 'UploadVideoField';
              muxPlaybackId: string;
              width: any;
              height: any;
            } | null;
          } | null;
        }
    >;
  } | null;
  globalContent?: {
    __typename?: 'GlobalRecord';
    changeLanguage?: string | null;
    closeLabel?: string | null;
    deadline?: string | null;
    errorMessage?: string | null;
    loading?: string | null;
    loadMoreNews?: string | null;
    localWebLabel?: string | null;
    menu?: string | null;
    moreNewsCta?: string | null;
    moreNewsHeader?: string | null;
    partnerPortalLabel?: string | null;
    partnerPortalUrl?: string | null;
    play?: string | null;
    shopLinkTitle?: string | null;
    shopLinkUrl?: string | null;
    showMoreJobsLabel?: string | null;
    viewOnMapLabel?: string | null;
    nextLabel?: string | null;
    previousLabel?: string | null;
    sliderNavigationLabel?: string | null;
    moreReportsCta?: string | null;
    loadMoreReports?: string | null;
    clearIconLabel?: string | null;
    searchIconLabel?: string | null;
    searchBoxPlaceholder?: string | null;
    viewAllButtonLabel?: string | null;
    searchResultsPageTitle?: string | null;
    firstPageLabel?: string | null;
    previousPageLabel?: string | null;
    nextPageLabel?: string | null;
    lastPageLabel?: string | null;
    goToPageLabel?: string | null;
    searchResultCount?: string | null;
    noSearchResults?: string | null;
    navigationLogo?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      responsiveImage?: {
        __typename?: 'ResponsiveImage';
        aspectRatio: any;
        base64?: string | null;
        bgColor?: string | null;
        height: any;
        sizes: string;
        src: string;
        srcSet: string;
        webpSrcSet: string;
        width: any;
      } | null;
    } | null;
    languages: Array<{
      __typename?: 'LanguageRecord';
      name?: string | null;
      url?: string | null;
      flag?: string | null;
      symbol?: {
        __typename?: 'FileField';
        alt?: string | null;
        tags: Array<string>;
        title?: string | null;
        url: string;
        width?: any | null;
        height?: any | null;
        format: string;
      } | null;
    }>;
  } | null;
  featureToggle?: {
    __typename?: 'FeatureToggleRecord';
    landingPageContentArea?: any | null;
    newsPageContentArea?: any | null;
  } | null;
  menu?: {
    __typename?: 'MenuRecord';
    menuItems: Array<{
      __typename?: 'MenuItemRecord';
      id: any;
      title?: string | null;
      url?: string | null;
      submenu?: {
        __typename?: 'SubmenuRecord';
        title?: string | null;
        menuItems: Array<{
          __typename?: 'ItemRecord';
          title?: string | null;
          pageLink?:
            | { __typename?: 'AboutUsPageRecord'; slug?: string | null }
            | { __typename?: 'BrandPageRecord'; slug?: string | null }
            | { __typename?: 'SustainabilityPageRecord'; slug?: string | null }
            | null;
        }>;
      } | null;
    }>;
  } | null;
  footer?: {
    __typename?: 'FooterRecord';
    bottomIntro?: string | null;
    cookieSettings?: string | null;
    introText?: string | null;
    moreInfoText?: string | null;
    partnerLogin?: string | null;
    selectCountryLabel?: string | null;
    socialMediaLabel?: string | null;
    useNewFooter?: any | null;
    footerLogo?: {
      __typename?: 'FileField';
      alt?: string | null;
      tags: Array<string>;
      title?: string | null;
      url: string;
      width?: any | null;
      height?: any | null;
      format: string;
    } | null;
    hultaforsBrands: Array<{
      __typename?: 'LinkRecord';
      id: any;
      title?: string | null;
      url?: string | null;
    }>;
    menu: Array<{
      __typename?: 'LinkRecord';
      id: any;
      title?: string | null;
      url?: string | null;
    }>;
    menuItems: Array<{
      __typename?: 'FooterMenuItemRecord';
      heading?: string | null;
      includeCookieToggle?: any | null;
      links: Array<{
        __typename?: 'LinkRecord';
        url?: string | null;
        title?: string | null;
      }>;
    }>;
    socialMediaMenu: Array<{
      __typename?: 'IconLinkRecord';
      url?: string | null;
      icon?: {
        __typename?: 'FileField';
        alt?: string | null;
        tags: Array<string>;
        title?: string | null;
        url: string;
        width?: any | null;
        height?: any | null;
        format: string;
      } | null;
    }>;
  } | null;
};

export type CampaignPageQueryVariables = Exact<{
  locale?: InputMaybe<SiteLocale>;
  slug: Scalars['String']['input'];
}>;

export type CampaignPageQuery = {
  __typename?: 'Query';
  campaignPage?: {
    __typename?: 'CampaignPageRecord';
    id: any;
    pageLocales: Array<SiteLocale>;
    seo?: {
      __typename?: 'SeoField';
      description?: string | null;
      title?: string | null;
      image?: {
        __typename?: 'FileField';
        url: string;
        alt?: string | null;
        title?: string | null;
      } | null;
    } | null;
    contentArea: Array<
      | {
          __typename?: 'ArticlesBlockRecord';
          id: any;
          title?: string | null;
          isJobArticles?: any | null;
          ctaText?: string | null;
          ctaUrl?: string | null;
          jobPages: Array<{
            __typename?: 'JobOpportunitiesPageRecord';
            id: any;
            slug?: string | null;
            title?: string | null;
            publishDate?: any | null;
            category?: string | null;
            country?: string | null;
            department?: string | null;
          }>;
          newsPages: Array<{
            __typename?: 'NewsPageRecord';
            id: any;
            slug?: string | null;
            title?: string | null;
            publishDate?: any | null;
            category?: string | null;
            country?: string | null;
            image?: {
              __typename?: 'FileField';
              alt?: string | null;
              title?: string | null;
              url: string;
              blurUpThumb?: string | null;
              focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
              colors: Array<{ __typename?: 'ColorField'; hex: string }>;
            } | null;
          }>;
          reportPages: Array<{
            __typename?: 'ReportsListingRecord';
            id: any;
            slug?: string | null;
            title?: string | null;
            publishDate?: any | null;
            category?: string | null;
            country?: string | null;
            image?: {
              __typename?: 'FileField';
              alt?: string | null;
              title?: string | null;
              url: string;
              blurUpThumb?: string | null;
              focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
              colors: Array<{ __typename?: 'ColorField'; hex: string }>;
            } | null;
            pdf?: {
              __typename?: 'FileField';
              alt?: string | null;
              filename: string;
              format: string;
              size: any;
              title?: string | null;
              url: string;
              uploadId: any;
            } | null;
          }>;
        }
      | {
          __typename?: 'BrandsBlockRecord';
          id: any;
          title?: string | null;
          introText?: string | null;
          hideLabels?: any | null;
          brands: Array<{
            __typename?: 'BrandPageRecord';
            id: any;
            brandName?: string | null;
            slug?: string | null;
            image?: {
              __typename?: 'FileField';
              alt?: string | null;
              tags: Array<string>;
              title?: string | null;
              url: string;
              width?: any | null;
              height?: any | null;
              format: string;
              responsiveImage?: {
                __typename?: 'ResponsiveImage';
                aspectRatio: any;
                base64?: string | null;
                bgColor?: string | null;
                height: any;
                sizes: string;
                src: string;
                srcSet: string;
                webpSrcSet: string;
                width: any;
              } | null;
            } | null;
            imageLoad?: {
              __typename?: 'FileField';
              alt?: string | null;
              title?: string | null;
              url: string;
              blurUpThumb?: string | null;
              focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
              colors: Array<{ __typename?: 'ColorField'; hex: string }>;
            } | null;
          }>;
        }
      | {
          __typename?: 'BulletListRecord';
          id: any;
          bullets?: string | null;
          numberedList?: any | null;
          title?: string | null;
        }
      | {
          __typename?: 'DocumentLinkBlockRecord';
          id: any;
          documents: Array<{
            __typename?: 'FileField';
            alt?: string | null;
            filename: string;
            format: string;
            size: any;
            title?: string | null;
            url: string;
            uploadId: any;
          }>;
        }
      | {
          __typename?: 'EmployeeRecord';
          id: any;
          name?: string | null;
          title?: string | null;
          introText?: string | null;
          description?: string | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
        }
      | {
          __typename?: 'GridContainerBlockRecord';
          id: any;
          fullwidth?: any | null;
          gap?: any | null;
          backgroundColor?: { __typename?: 'ColorField'; hex: string } | null;
          textColor?: { __typename?: 'ColorField'; hex: string } | null;
          content: Array<
            | {
                __typename?: 'GridFourcolBlockRecord';
                id: any;
                content: Array<
                  | {
                      __typename?: 'ImageRecord';
                      id: any;
                      fullWidth?: any | null;
                      image?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        responsiveImage?: {
                          __typename?: 'ResponsiveImage';
                          aspectRatio: any;
                          base64?: string | null;
                          bgColor?: string | null;
                          height: any;
                          sizes: string;
                          src: string;
                          srcSet: string;
                          webpSrcSet: string;
                          width: any;
                        } | null;
                      } | null;
                      imageLoad?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        title?: string | null;
                        url: string;
                        blurUpThumb?: string | null;
                        focalPoint?: {
                          __typename?: 'focalPoint';
                          x: any;
                          y: any;
                        } | null;
                        colors: Array<{
                          __typename?: 'ColorField';
                          hex: string;
                        }>;
                      } | null;
                    }
                  | {
                      __typename?: 'MediaWithCaptionRecord';
                      id: any;
                      centerText?: any | null;
                      textOnImage?: any | null;
                      media?: {
                        __typename?: 'ImageRecord';
                        id: any;
                        fullWidth?: any | null;
                        image?: {
                          __typename?: 'FileField';
                          alt?: string | null;
                          responsiveImage?: {
                            __typename?: 'ResponsiveImage';
                            aspectRatio: any;
                            base64?: string | null;
                            bgColor?: string | null;
                            height: any;
                            sizes: string;
                            src: string;
                            srcSet: string;
                            webpSrcSet: string;
                            width: any;
                          } | null;
                        } | null;
                        imageLoad?: {
                          __typename?: 'FileField';
                          alt?: string | null;
                          title?: string | null;
                          url: string;
                          blurUpThumb?: string | null;
                          focalPoint?: {
                            __typename?: 'focalPoint';
                            x: any;
                            y: any;
                          } | null;
                          colors: Array<{
                            __typename?: 'ColorField';
                            hex: string;
                          }>;
                        } | null;
                      } | null;
                      caption?: {
                        __typename?: 'TextBlockRecord';
                        id: any;
                        smallHeader?: any | null;
                        header?: string | null;
                        text?: string | null;
                        introText?: string | null;
                        ctaButtons: Array<{
                          __typename?: 'CtaButtonRecord';
                          id: any;
                          text?: string | null;
                          url?: string | null;
                          variant?: string | null;
                        }>;
                      } | null;
                    }
                  | {
                      __typename?: 'TextBlockRecord';
                      id: any;
                      smallHeader?: any | null;
                      header?: string | null;
                      text?: string | null;
                      introText?: string | null;
                      ctaButtons: Array<{
                        __typename?: 'CtaButtonRecord';
                        id: any;
                        text?: string | null;
                        url?: string | null;
                        variant?: string | null;
                      }>;
                    }
                >;
              }
            | {
                __typename?: 'GridThreecolBlockRecord';
                id: any;
                content: Array<
                  | {
                      __typename?: 'GridTwocolBlockRecord';
                      id: any;
                      content: Array<
                        | {
                            __typename?: 'ImageRecord';
                            id: any;
                            fullWidth?: any | null;
                            image?: {
                              __typename?: 'FileField';
                              alt?: string | null;
                              responsiveImage?: {
                                __typename?: 'ResponsiveImage';
                                aspectRatio: any;
                                base64?: string | null;
                                bgColor?: string | null;
                                height: any;
                                sizes: string;
                                src: string;
                                srcSet: string;
                                webpSrcSet: string;
                                width: any;
                              } | null;
                            } | null;
                            imageLoad?: {
                              __typename?: 'FileField';
                              alt?: string | null;
                              title?: string | null;
                              url: string;
                              blurUpThumb?: string | null;
                              focalPoint?: {
                                __typename?: 'focalPoint';
                                x: any;
                                y: any;
                              } | null;
                              colors: Array<{
                                __typename?: 'ColorField';
                                hex: string;
                              }>;
                            } | null;
                          }
                        | {
                            __typename?: 'MediaWithCaptionRecord';
                            id: any;
                            centerText?: any | null;
                            textOnImage?: any | null;
                            media?: {
                              __typename?: 'ImageRecord';
                              id: any;
                              fullWidth?: any | null;
                              image?: {
                                __typename?: 'FileField';
                                alt?: string | null;
                                responsiveImage?: {
                                  __typename?: 'ResponsiveImage';
                                  aspectRatio: any;
                                  base64?: string | null;
                                  bgColor?: string | null;
                                  height: any;
                                  sizes: string;
                                  src: string;
                                  srcSet: string;
                                  webpSrcSet: string;
                                  width: any;
                                } | null;
                              } | null;
                              imageLoad?: {
                                __typename?: 'FileField';
                                alt?: string | null;
                                title?: string | null;
                                url: string;
                                blurUpThumb?: string | null;
                                focalPoint?: {
                                  __typename?: 'focalPoint';
                                  x: any;
                                  y: any;
                                } | null;
                                colors: Array<{
                                  __typename?: 'ColorField';
                                  hex: string;
                                }>;
                              } | null;
                            } | null;
                            caption?: {
                              __typename?: 'TextBlockRecord';
                              id: any;
                              smallHeader?: any | null;
                              header?: string | null;
                              text?: string | null;
                              introText?: string | null;
                              ctaButtons: Array<{
                                __typename?: 'CtaButtonRecord';
                                id: any;
                                text?: string | null;
                                url?: string | null;
                                variant?: string | null;
                              }>;
                            } | null;
                          }
                        | {
                            __typename?: 'NewsListBlockRecord';
                            id: any;
                            title?: string | null;
                            standalone?: any | null;
                            largeTitle?: any | null;
                            itemsToShow?: any | null;
                          }
                        | {
                            __typename?: 'ReportsListBlockRecord';
                            id: any;
                            title?: string | null;
                            standalone?: any | null;
                            largeTitle?: any | null;
                          }
                        | {
                            __typename?: 'TextBlockRecord';
                            id: any;
                            smallHeader?: any | null;
                            header?: string | null;
                            text?: string | null;
                            introText?: string | null;
                            ctaButtons: Array<{
                              __typename?: 'CtaButtonRecord';
                              id: any;
                              text?: string | null;
                              url?: string | null;
                              variant?: string | null;
                            }>;
                          }
                      >;
                    }
                  | {
                      __typename?: 'ImageRecord';
                      id: any;
                      fullWidth?: any | null;
                      image?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        responsiveImage?: {
                          __typename?: 'ResponsiveImage';
                          aspectRatio: any;
                          base64?: string | null;
                          bgColor?: string | null;
                          height: any;
                          sizes: string;
                          src: string;
                          srcSet: string;
                          webpSrcSet: string;
                          width: any;
                        } | null;
                      } | null;
                      imageLoad?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        title?: string | null;
                        url: string;
                        blurUpThumb?: string | null;
                        focalPoint?: {
                          __typename?: 'focalPoint';
                          x: any;
                          y: any;
                        } | null;
                        colors: Array<{
                          __typename?: 'ColorField';
                          hex: string;
                        }>;
                      } | null;
                    }
                  | {
                      __typename?: 'MediaWithCaptionRecord';
                      id: any;
                      centerText?: any | null;
                      textOnImage?: any | null;
                      media?: {
                        __typename?: 'ImageRecord';
                        id: any;
                        fullWidth?: any | null;
                        image?: {
                          __typename?: 'FileField';
                          alt?: string | null;
                          responsiveImage?: {
                            __typename?: 'ResponsiveImage';
                            aspectRatio: any;
                            base64?: string | null;
                            bgColor?: string | null;
                            height: any;
                            sizes: string;
                            src: string;
                            srcSet: string;
                            webpSrcSet: string;
                            width: any;
                          } | null;
                        } | null;
                        imageLoad?: {
                          __typename?: 'FileField';
                          alt?: string | null;
                          title?: string | null;
                          url: string;
                          blurUpThumb?: string | null;
                          focalPoint?: {
                            __typename?: 'focalPoint';
                            x: any;
                            y: any;
                          } | null;
                          colors: Array<{
                            __typename?: 'ColorField';
                            hex: string;
                          }>;
                        } | null;
                      } | null;
                      caption?: {
                        __typename?: 'TextBlockRecord';
                        id: any;
                        smallHeader?: any | null;
                        header?: string | null;
                        text?: string | null;
                        introText?: string | null;
                        ctaButtons: Array<{
                          __typename?: 'CtaButtonRecord';
                          id: any;
                          text?: string | null;
                          url?: string | null;
                          variant?: string | null;
                        }>;
                      } | null;
                    }
                  | {
                      __typename?: 'TextBlockRecord';
                      id: any;
                      smallHeader?: any | null;
                      header?: string | null;
                      text?: string | null;
                      introText?: string | null;
                      ctaButtons: Array<{
                        __typename?: 'CtaButtonRecord';
                        id: any;
                        text?: string | null;
                        url?: string | null;
                        variant?: string | null;
                      }>;
                    }
                >;
              }
            | {
                __typename?: 'GridTwocolBlockRecord';
                id: any;
                content: Array<
                  | {
                      __typename?: 'ImageRecord';
                      id: any;
                      fullWidth?: any | null;
                      image?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        responsiveImage?: {
                          __typename?: 'ResponsiveImage';
                          aspectRatio: any;
                          base64?: string | null;
                          bgColor?: string | null;
                          height: any;
                          sizes: string;
                          src: string;
                          srcSet: string;
                          webpSrcSet: string;
                          width: any;
                        } | null;
                      } | null;
                      imageLoad?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        title?: string | null;
                        url: string;
                        blurUpThumb?: string | null;
                        focalPoint?: {
                          __typename?: 'focalPoint';
                          x: any;
                          y: any;
                        } | null;
                        colors: Array<{
                          __typename?: 'ColorField';
                          hex: string;
                        }>;
                      } | null;
                    }
                  | {
                      __typename?: 'MediaWithCaptionRecord';
                      id: any;
                      centerText?: any | null;
                      textOnImage?: any | null;
                      media?: {
                        __typename?: 'ImageRecord';
                        id: any;
                        fullWidth?: any | null;
                        image?: {
                          __typename?: 'FileField';
                          alt?: string | null;
                          responsiveImage?: {
                            __typename?: 'ResponsiveImage';
                            aspectRatio: any;
                            base64?: string | null;
                            bgColor?: string | null;
                            height: any;
                            sizes: string;
                            src: string;
                            srcSet: string;
                            webpSrcSet: string;
                            width: any;
                          } | null;
                        } | null;
                        imageLoad?: {
                          __typename?: 'FileField';
                          alt?: string | null;
                          title?: string | null;
                          url: string;
                          blurUpThumb?: string | null;
                          focalPoint?: {
                            __typename?: 'focalPoint';
                            x: any;
                            y: any;
                          } | null;
                          colors: Array<{
                            __typename?: 'ColorField';
                            hex: string;
                          }>;
                        } | null;
                      } | null;
                      caption?: {
                        __typename?: 'TextBlockRecord';
                        id: any;
                        smallHeader?: any | null;
                        header?: string | null;
                        text?: string | null;
                        introText?: string | null;
                        ctaButtons: Array<{
                          __typename?: 'CtaButtonRecord';
                          id: any;
                          text?: string | null;
                          url?: string | null;
                          variant?: string | null;
                        }>;
                      } | null;
                    }
                  | {
                      __typename?: 'NewsListBlockRecord';
                      id: any;
                      title?: string | null;
                      standalone?: any | null;
                      largeTitle?: any | null;
                      itemsToShow?: any | null;
                    }
                  | {
                      __typename?: 'ReportsListBlockRecord';
                      id: any;
                      title?: string | null;
                      standalone?: any | null;
                      largeTitle?: any | null;
                    }
                  | {
                      __typename?: 'TextBlockRecord';
                      id: any;
                      smallHeader?: any | null;
                      header?: string | null;
                      text?: string | null;
                      introText?: string | null;
                      ctaButtons: Array<{
                        __typename?: 'CtaButtonRecord';
                        id: any;
                        text?: string | null;
                        url?: string | null;
                        variant?: string | null;
                      }>;
                    }
                >;
              }
          >;
        }
      | {
          __typename?: 'HeroBlockRecord';
          id: any;
          title?: string | null;
          description?: string | null;
          ctaText?: string | null;
          ctaUrl?: string | null;
          fullWidth?: any | null;
          boxColor?: { __typename?: 'ColorField'; hex: string } | null;
          textColor?: { __typename?: 'ColorField'; hex: string } | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
          imageOverlay?: {
            __typename?: 'OverlayRecord';
            id: any;
            opacity?: any | null;
            color?: { __typename?: 'ColorField'; hex: string } | null;
          } | null;
          ctaButtons: Array<{
            __typename?: 'CtaButtonRecord';
            id: any;
            text?: string | null;
            url?: string | null;
            variant?: string | null;
          }>;
          video?: {
            __typename?: 'FileField';
            blurUpThumb?: string | null;
            title?: string | null;
            alt?: string | null;
            video?: {
              __typename?: 'UploadVideoField';
              muxPlaybackId: string;
              width: any;
              height: any;
            } | null;
          } | null;
        }
      | {
          __typename?: 'ImageRecord';
          id: any;
          fullWidth?: any | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageLoad?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
        }
      | { __typename?: 'JobsListBlockRecord'; id: any; title?: string | null }
      | {
          __typename?: 'NewsAndReportsListBlockRecord';
          newsTitle?: string | null;
          reportsTitle?: string | null;
          newsImage?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
          news: Array<{
            __typename?: 'NewsPageRecord';
            id: any;
            title?: string | null;
            slug?: string | null;
            publishDate?: any | null;
            category?: string | null;
          }>;
          reportsImage?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
          reports: Array<{
            __typename?: 'ReportsListingRecord';
            id: any;
            title?: string | null;
            slug?: string | null;
            publishDate?: any | null;
            category?: string | null;
            pdf?: {
              __typename?: 'FileField';
              alt?: string | null;
              filename: string;
              format: string;
              size: any;
              title?: string | null;
              url: string;
              uploadId: any;
            } | null;
          }>;
        }
      | {
          __typename?: 'NewsListBlockRecord';
          id: any;
          title?: string | null;
          standalone?: any | null;
          largeTitle?: any | null;
          itemsToShow?: any | null;
        }
      | {
          __typename?: 'OfficesBlockRecord';
          id: any;
          offices: Array<{
            __typename?: 'OfficeRecord';
            id: any;
            name?: string | null;
            address?: string | null;
            zipCode?: string | null;
            city?: string | null;
            country?: string | null;
            email?: string | null;
            websiteUrl?: string | null;
            phoneNumber?: string | null;
          }>;
        }
      | {
          __typename?: 'PlugBlockRecord';
          id: any;
          title?: string | null;
          description?: string | null;
          brands: Array<{
            __typename?: 'BrandPageRecord';
            id: any;
            brandName?: string | null;
            slug?: string | null;
            image?: {
              __typename?: 'FileField';
              alt?: string | null;
              tags: Array<string>;
              title?: string | null;
              url: string;
              width?: any | null;
              height?: any | null;
              format: string;
              responsiveImage?: {
                __typename?: 'ResponsiveImage';
                aspectRatio: any;
                base64?: string | null;
                bgColor?: string | null;
                height: any;
                sizes: string;
                src: string;
                srcSet: string;
                webpSrcSet: string;
                width: any;
              } | null;
            } | null;
            imageLoad?: {
              __typename?: 'FileField';
              alt?: string | null;
              title?: string | null;
              url: string;
              blurUpThumb?: string | null;
              focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
              colors: Array<{ __typename?: 'ColorField'; hex: string }>;
            } | null;
          }>;
        }
      | {
          __typename?: 'SimpleTitleAndTextBlockRecord';
          id: any;
          title?: string | null;
          topLabel?: string | null;
          description?: string | null;
        }
      | {
          __typename?: 'SliderBlockRecord';
          title?: string | null;
          arrows?: any | null;
          slideAnimation?: any | null;
          delay?: any | null;
          dots?: any | null;
          heroes: Array<{
            __typename?: 'HeroBlockRecord';
            id: any;
            title?: string | null;
            description?: string | null;
            ctaText?: string | null;
            ctaUrl?: string | null;
            fullWidth?: any | null;
            boxColor?: { __typename?: 'ColorField'; hex: string } | null;
            textColor?: { __typename?: 'ColorField'; hex: string } | null;
            image?: {
              __typename?: 'FileField';
              alt?: string | null;
              title?: string | null;
              url: string;
              blurUpThumb?: string | null;
              focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
              colors: Array<{ __typename?: 'ColorField'; hex: string }>;
            } | null;
            imageOverlay?: {
              __typename?: 'OverlayRecord';
              id: any;
              opacity?: any | null;
              color?: { __typename?: 'ColorField'; hex: string } | null;
            } | null;
            ctaButtons: Array<{
              __typename?: 'CtaButtonRecord';
              id: any;
              text?: string | null;
              url?: string | null;
              variant?: string | null;
            }>;
            video?: {
              __typename?: 'FileField';
              blurUpThumb?: string | null;
              title?: string | null;
              alt?: string | null;
              video?: {
                __typename?: 'UploadVideoField';
                muxPlaybackId: string;
                width: any;
                height: any;
              } | null;
            } | null;
          }>;
        }
      | {
          __typename?: 'StatementBlockRecord';
          id: any;
          text?: string | null;
          blackBackground?: any | null;
          header?: string | null;
          small?: any | null;
          linkText?: string | null;
          linkUrl?: string | null;
          imageMobile?: {
            __typename?: 'FileField';
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageTablet?: {
            __typename?: 'FileField';
            alt?: string | null;
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageDesktop?: {
            __typename?: 'FileField';
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageLoad?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
          imageOverlay?: {
            __typename?: 'OverlayRecord';
            id: any;
            opacity?: any | null;
            color?: { __typename?: 'ColorField'; hex: string } | null;
          } | null;
        }
      | {
          __typename?: 'SubheadingBlockRecord';
          id: any;
          title?: string | null;
          text?: string | null;
          ctaButton?: {
            __typename?: 'CtaButtonRecord';
            id: any;
            text?: string | null;
            url?: string | null;
            variant?: string | null;
          } | null;
          backgroundColor?: { __typename?: 'ColorField'; hex: string } | null;
        }
      | {
          __typename?: 'SustainabilityReportsBlockRecord';
          id: any;
          title?: string | null;
          reports: Array<{
            __typename?: 'FileField';
            alt?: string | null;
            filename: string;
            format: string;
            size: any;
            title?: string | null;
            url: string;
            uploadId: any;
          }>;
        }
      | {
          __typename?: 'TextBlockRecord';
          id: any;
          smallHeader?: any | null;
          header?: string | null;
          text?: string | null;
          introText?: string | null;
          ctaButtons: Array<{
            __typename?: 'CtaButtonRecord';
            id: any;
            text?: string | null;
            url?: string | null;
            variant?: string | null;
          }>;
        }
      | {
          __typename?: 'TwoColumnImageAndTextRecord';
          id: any;
          text?: string | null;
          title?: string | null;
          reverse?: any | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageLoad?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
        }
      | {
          __typename?: 'TwoColumnTextIntroRecord';
          id: any;
          introText?: string | null;
          text?: string | null;
          header?: string | null;
        }
      | {
          __typename?: 'VideoRecord';
          id: any;
          autoplay?: any | null;
          video?: {
            __typename?: 'FileField';
            title?: string | null;
            video?: {
              __typename?: 'UploadVideoField';
              mp4Url?: string | null;
              streamingUrl: string;
              thumbnailUrl: string;
              mp4Low?: string | null;
            } | null;
          } | null;
          videoThumbnail?: {
            __typename?: 'FileField';
            alt?: string | null;
            tags: Array<string>;
            title?: string | null;
            url: string;
            width?: any | null;
            height?: any | null;
            format: string;
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          muxVideo?: {
            __typename?: 'FileField';
            blurUpThumb?: string | null;
            title?: string | null;
            alt?: string | null;
            video?: {
              __typename?: 'UploadVideoField';
              muxPlaybackId: string;
              width: any;
              height: any;
            } | null;
          } | null;
        }
    >;
  } | null;
  globalContent?: {
    __typename?: 'GlobalRecord';
    changeLanguage?: string | null;
    closeLabel?: string | null;
    deadline?: string | null;
    errorMessage?: string | null;
    loading?: string | null;
    loadMoreNews?: string | null;
    localWebLabel?: string | null;
    menu?: string | null;
    moreNewsCta?: string | null;
    moreNewsHeader?: string | null;
    partnerPortalLabel?: string | null;
    partnerPortalUrl?: string | null;
    play?: string | null;
    shopLinkTitle?: string | null;
    shopLinkUrl?: string | null;
    showMoreJobsLabel?: string | null;
    viewOnMapLabel?: string | null;
    nextLabel?: string | null;
    previousLabel?: string | null;
    sliderNavigationLabel?: string | null;
    moreReportsCta?: string | null;
    loadMoreReports?: string | null;
    clearIconLabel?: string | null;
    searchIconLabel?: string | null;
    searchBoxPlaceholder?: string | null;
    viewAllButtonLabel?: string | null;
    searchResultsPageTitle?: string | null;
    firstPageLabel?: string | null;
    previousPageLabel?: string | null;
    nextPageLabel?: string | null;
    lastPageLabel?: string | null;
    goToPageLabel?: string | null;
    searchResultCount?: string | null;
    noSearchResults?: string | null;
    navigationLogo?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      responsiveImage?: {
        __typename?: 'ResponsiveImage';
        aspectRatio: any;
        base64?: string | null;
        bgColor?: string | null;
        height: any;
        sizes: string;
        src: string;
        srcSet: string;
        webpSrcSet: string;
        width: any;
      } | null;
    } | null;
    languages: Array<{
      __typename?: 'LanguageRecord';
      name?: string | null;
      url?: string | null;
      flag?: string | null;
      symbol?: {
        __typename?: 'FileField';
        alt?: string | null;
        tags: Array<string>;
        title?: string | null;
        url: string;
        width?: any | null;
        height?: any | null;
        format: string;
      } | null;
    }>;
  } | null;
  featureToggle?: {
    __typename?: 'FeatureToggleRecord';
    landingPageContentArea?: any | null;
    newsPageContentArea?: any | null;
  } | null;
  menu?: {
    __typename?: 'MenuRecord';
    menuItems: Array<{
      __typename?: 'MenuItemRecord';
      id: any;
      title?: string | null;
      url?: string | null;
      submenu?: {
        __typename?: 'SubmenuRecord';
        title?: string | null;
        menuItems: Array<{
          __typename?: 'ItemRecord';
          title?: string | null;
          pageLink?:
            | { __typename?: 'AboutUsPageRecord'; slug?: string | null }
            | { __typename?: 'BrandPageRecord'; slug?: string | null }
            | { __typename?: 'SustainabilityPageRecord'; slug?: string | null }
            | null;
        }>;
      } | null;
    }>;
  } | null;
  footer?: {
    __typename?: 'FooterRecord';
    bottomIntro?: string | null;
    cookieSettings?: string | null;
    introText?: string | null;
    moreInfoText?: string | null;
    partnerLogin?: string | null;
    selectCountryLabel?: string | null;
    socialMediaLabel?: string | null;
    useNewFooter?: any | null;
    footerLogo?: {
      __typename?: 'FileField';
      alt?: string | null;
      tags: Array<string>;
      title?: string | null;
      url: string;
      width?: any | null;
      height?: any | null;
      format: string;
    } | null;
    hultaforsBrands: Array<{
      __typename?: 'LinkRecord';
      id: any;
      title?: string | null;
      url?: string | null;
    }>;
    menu: Array<{
      __typename?: 'LinkRecord';
      id: any;
      title?: string | null;
      url?: string | null;
    }>;
    menuItems: Array<{
      __typename?: 'FooterMenuItemRecord';
      heading?: string | null;
      includeCookieToggle?: any | null;
      links: Array<{
        __typename?: 'LinkRecord';
        url?: string | null;
        title?: string | null;
      }>;
    }>;
    socialMediaMenu: Array<{
      __typename?: 'IconLinkRecord';
      url?: string | null;
      icon?: {
        __typename?: 'FileField';
        alt?: string | null;
        tags: Array<string>;
        title?: string | null;
        url: string;
        width?: any | null;
        height?: any | null;
        format: string;
      } | null;
    }>;
  } | null;
};

export type ContactPageQueryVariables = Exact<{
  locale?: InputMaybe<SiteLocale>;
}>;

export type ContactPageQuery = {
  __typename?: 'Query';
  contactPage?: {
    __typename?: 'ContactPageRecord';
    id: any;
    pageLocales: Array<SiteLocale>;
    seo?: {
      __typename?: 'SeoField';
      description?: string | null;
      title?: string | null;
      image?: {
        __typename?: 'FileField';
        url: string;
        alt?: string | null;
        title?: string | null;
      } | null;
    } | null;
    contentArea: Array<
      | {
          __typename?: 'ArticlesBlockRecord';
          id: any;
          title?: string | null;
          isJobArticles?: any | null;
          ctaText?: string | null;
          ctaUrl?: string | null;
          jobPages: Array<{
            __typename?: 'JobOpportunitiesPageRecord';
            id: any;
            slug?: string | null;
            title?: string | null;
            publishDate?: any | null;
            category?: string | null;
            country?: string | null;
            department?: string | null;
          }>;
          newsPages: Array<{
            __typename?: 'NewsPageRecord';
            id: any;
            slug?: string | null;
            title?: string | null;
            publishDate?: any | null;
            category?: string | null;
            country?: string | null;
            image?: {
              __typename?: 'FileField';
              alt?: string | null;
              title?: string | null;
              url: string;
              blurUpThumb?: string | null;
              focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
              colors: Array<{ __typename?: 'ColorField'; hex: string }>;
            } | null;
          }>;
          reportPages: Array<{
            __typename?: 'ReportsListingRecord';
            id: any;
            slug?: string | null;
            title?: string | null;
            publishDate?: any | null;
            category?: string | null;
            country?: string | null;
            image?: {
              __typename?: 'FileField';
              alt?: string | null;
              title?: string | null;
              url: string;
              blurUpThumb?: string | null;
              focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
              colors: Array<{ __typename?: 'ColorField'; hex: string }>;
            } | null;
            pdf?: {
              __typename?: 'FileField';
              alt?: string | null;
              filename: string;
              format: string;
              size: any;
              title?: string | null;
              url: string;
              uploadId: any;
            } | null;
          }>;
        }
      | {
          __typename?: 'BrandsBlockRecord';
          id: any;
          title?: string | null;
          introText?: string | null;
          hideLabels?: any | null;
          brands: Array<{
            __typename?: 'BrandPageRecord';
            id: any;
            brandName?: string | null;
            slug?: string | null;
            image?: {
              __typename?: 'FileField';
              alt?: string | null;
              tags: Array<string>;
              title?: string | null;
              url: string;
              width?: any | null;
              height?: any | null;
              format: string;
              responsiveImage?: {
                __typename?: 'ResponsiveImage';
                aspectRatio: any;
                base64?: string | null;
                bgColor?: string | null;
                height: any;
                sizes: string;
                src: string;
                srcSet: string;
                webpSrcSet: string;
                width: any;
              } | null;
            } | null;
            imageLoad?: {
              __typename?: 'FileField';
              alt?: string | null;
              title?: string | null;
              url: string;
              blurUpThumb?: string | null;
              focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
              colors: Array<{ __typename?: 'ColorField'; hex: string }>;
            } | null;
          }>;
        }
      | {
          __typename?: 'BulletListRecord';
          id: any;
          bullets?: string | null;
          numberedList?: any | null;
          title?: string | null;
        }
      | {
          __typename?: 'DocumentLinkBlockRecord';
          id: any;
          documents: Array<{
            __typename?: 'FileField';
            alt?: string | null;
            filename: string;
            format: string;
            size: any;
            title?: string | null;
            url: string;
            uploadId: any;
          }>;
        }
      | {
          __typename?: 'EmployeeRecord';
          id: any;
          name?: string | null;
          title?: string | null;
          introText?: string | null;
          description?: string | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
        }
      | {
          __typename?: 'GridContainerBlockRecord';
          id: any;
          fullwidth?: any | null;
          gap?: any | null;
          backgroundColor?: { __typename?: 'ColorField'; hex: string } | null;
          textColor?: { __typename?: 'ColorField'; hex: string } | null;
          content: Array<
            | {
                __typename?: 'GridFourcolBlockRecord';
                id: any;
                content: Array<
                  | {
                      __typename?: 'ImageRecord';
                      id: any;
                      fullWidth?: any | null;
                      image?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        responsiveImage?: {
                          __typename?: 'ResponsiveImage';
                          aspectRatio: any;
                          base64?: string | null;
                          bgColor?: string | null;
                          height: any;
                          sizes: string;
                          src: string;
                          srcSet: string;
                          webpSrcSet: string;
                          width: any;
                        } | null;
                      } | null;
                      imageLoad?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        title?: string | null;
                        url: string;
                        blurUpThumb?: string | null;
                        focalPoint?: {
                          __typename?: 'focalPoint';
                          x: any;
                          y: any;
                        } | null;
                        colors: Array<{
                          __typename?: 'ColorField';
                          hex: string;
                        }>;
                      } | null;
                    }
                  | {
                      __typename?: 'MediaWithCaptionRecord';
                      id: any;
                      centerText?: any | null;
                      textOnImage?: any | null;
                      media?: {
                        __typename?: 'ImageRecord';
                        id: any;
                        fullWidth?: any | null;
                        image?: {
                          __typename?: 'FileField';
                          alt?: string | null;
                          responsiveImage?: {
                            __typename?: 'ResponsiveImage';
                            aspectRatio: any;
                            base64?: string | null;
                            bgColor?: string | null;
                            height: any;
                            sizes: string;
                            src: string;
                            srcSet: string;
                            webpSrcSet: string;
                            width: any;
                          } | null;
                        } | null;
                        imageLoad?: {
                          __typename?: 'FileField';
                          alt?: string | null;
                          title?: string | null;
                          url: string;
                          blurUpThumb?: string | null;
                          focalPoint?: {
                            __typename?: 'focalPoint';
                            x: any;
                            y: any;
                          } | null;
                          colors: Array<{
                            __typename?: 'ColorField';
                            hex: string;
                          }>;
                        } | null;
                      } | null;
                      caption?: {
                        __typename?: 'TextBlockRecord';
                        id: any;
                        smallHeader?: any | null;
                        header?: string | null;
                        text?: string | null;
                        introText?: string | null;
                        ctaButtons: Array<{
                          __typename?: 'CtaButtonRecord';
                          id: any;
                          text?: string | null;
                          url?: string | null;
                          variant?: string | null;
                        }>;
                      } | null;
                    }
                  | {
                      __typename?: 'TextBlockRecord';
                      id: any;
                      smallHeader?: any | null;
                      header?: string | null;
                      text?: string | null;
                      introText?: string | null;
                      ctaButtons: Array<{
                        __typename?: 'CtaButtonRecord';
                        id: any;
                        text?: string | null;
                        url?: string | null;
                        variant?: string | null;
                      }>;
                    }
                >;
              }
            | {
                __typename?: 'GridThreecolBlockRecord';
                id: any;
                content: Array<
                  | {
                      __typename?: 'GridTwocolBlockRecord';
                      id: any;
                      content: Array<
                        | {
                            __typename?: 'ImageRecord';
                            id: any;
                            fullWidth?: any | null;
                            image?: {
                              __typename?: 'FileField';
                              alt?: string | null;
                              responsiveImage?: {
                                __typename?: 'ResponsiveImage';
                                aspectRatio: any;
                                base64?: string | null;
                                bgColor?: string | null;
                                height: any;
                                sizes: string;
                                src: string;
                                srcSet: string;
                                webpSrcSet: string;
                                width: any;
                              } | null;
                            } | null;
                            imageLoad?: {
                              __typename?: 'FileField';
                              alt?: string | null;
                              title?: string | null;
                              url: string;
                              blurUpThumb?: string | null;
                              focalPoint?: {
                                __typename?: 'focalPoint';
                                x: any;
                                y: any;
                              } | null;
                              colors: Array<{
                                __typename?: 'ColorField';
                                hex: string;
                              }>;
                            } | null;
                          }
                        | {
                            __typename?: 'MediaWithCaptionRecord';
                            id: any;
                            centerText?: any | null;
                            textOnImage?: any | null;
                            media?: {
                              __typename?: 'ImageRecord';
                              id: any;
                              fullWidth?: any | null;
                              image?: {
                                __typename?: 'FileField';
                                alt?: string | null;
                                responsiveImage?: {
                                  __typename?: 'ResponsiveImage';
                                  aspectRatio: any;
                                  base64?: string | null;
                                  bgColor?: string | null;
                                  height: any;
                                  sizes: string;
                                  src: string;
                                  srcSet: string;
                                  webpSrcSet: string;
                                  width: any;
                                } | null;
                              } | null;
                              imageLoad?: {
                                __typename?: 'FileField';
                                alt?: string | null;
                                title?: string | null;
                                url: string;
                                blurUpThumb?: string | null;
                                focalPoint?: {
                                  __typename?: 'focalPoint';
                                  x: any;
                                  y: any;
                                } | null;
                                colors: Array<{
                                  __typename?: 'ColorField';
                                  hex: string;
                                }>;
                              } | null;
                            } | null;
                            caption?: {
                              __typename?: 'TextBlockRecord';
                              id: any;
                              smallHeader?: any | null;
                              header?: string | null;
                              text?: string | null;
                              introText?: string | null;
                              ctaButtons: Array<{
                                __typename?: 'CtaButtonRecord';
                                id: any;
                                text?: string | null;
                                url?: string | null;
                                variant?: string | null;
                              }>;
                            } | null;
                          }
                        | {
                            __typename?: 'NewsListBlockRecord';
                            id: any;
                            title?: string | null;
                            standalone?: any | null;
                            largeTitle?: any | null;
                            itemsToShow?: any | null;
                          }
                        | {
                            __typename?: 'ReportsListBlockRecord';
                            id: any;
                            title?: string | null;
                            standalone?: any | null;
                            largeTitle?: any | null;
                          }
                        | {
                            __typename?: 'TextBlockRecord';
                            id: any;
                            smallHeader?: any | null;
                            header?: string | null;
                            text?: string | null;
                            introText?: string | null;
                            ctaButtons: Array<{
                              __typename?: 'CtaButtonRecord';
                              id: any;
                              text?: string | null;
                              url?: string | null;
                              variant?: string | null;
                            }>;
                          }
                      >;
                    }
                  | {
                      __typename?: 'ImageRecord';
                      id: any;
                      fullWidth?: any | null;
                      image?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        responsiveImage?: {
                          __typename?: 'ResponsiveImage';
                          aspectRatio: any;
                          base64?: string | null;
                          bgColor?: string | null;
                          height: any;
                          sizes: string;
                          src: string;
                          srcSet: string;
                          webpSrcSet: string;
                          width: any;
                        } | null;
                      } | null;
                      imageLoad?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        title?: string | null;
                        url: string;
                        blurUpThumb?: string | null;
                        focalPoint?: {
                          __typename?: 'focalPoint';
                          x: any;
                          y: any;
                        } | null;
                        colors: Array<{
                          __typename?: 'ColorField';
                          hex: string;
                        }>;
                      } | null;
                    }
                  | {
                      __typename?: 'MediaWithCaptionRecord';
                      id: any;
                      centerText?: any | null;
                      textOnImage?: any | null;
                      media?: {
                        __typename?: 'ImageRecord';
                        id: any;
                        fullWidth?: any | null;
                        image?: {
                          __typename?: 'FileField';
                          alt?: string | null;
                          responsiveImage?: {
                            __typename?: 'ResponsiveImage';
                            aspectRatio: any;
                            base64?: string | null;
                            bgColor?: string | null;
                            height: any;
                            sizes: string;
                            src: string;
                            srcSet: string;
                            webpSrcSet: string;
                            width: any;
                          } | null;
                        } | null;
                        imageLoad?: {
                          __typename?: 'FileField';
                          alt?: string | null;
                          title?: string | null;
                          url: string;
                          blurUpThumb?: string | null;
                          focalPoint?: {
                            __typename?: 'focalPoint';
                            x: any;
                            y: any;
                          } | null;
                          colors: Array<{
                            __typename?: 'ColorField';
                            hex: string;
                          }>;
                        } | null;
                      } | null;
                      caption?: {
                        __typename?: 'TextBlockRecord';
                        id: any;
                        smallHeader?: any | null;
                        header?: string | null;
                        text?: string | null;
                        introText?: string | null;
                        ctaButtons: Array<{
                          __typename?: 'CtaButtonRecord';
                          id: any;
                          text?: string | null;
                          url?: string | null;
                          variant?: string | null;
                        }>;
                      } | null;
                    }
                  | {
                      __typename?: 'TextBlockRecord';
                      id: any;
                      smallHeader?: any | null;
                      header?: string | null;
                      text?: string | null;
                      introText?: string | null;
                      ctaButtons: Array<{
                        __typename?: 'CtaButtonRecord';
                        id: any;
                        text?: string | null;
                        url?: string | null;
                        variant?: string | null;
                      }>;
                    }
                >;
              }
            | {
                __typename?: 'GridTwocolBlockRecord';
                id: any;
                content: Array<
                  | {
                      __typename?: 'ImageRecord';
                      id: any;
                      fullWidth?: any | null;
                      image?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        responsiveImage?: {
                          __typename?: 'ResponsiveImage';
                          aspectRatio: any;
                          base64?: string | null;
                          bgColor?: string | null;
                          height: any;
                          sizes: string;
                          src: string;
                          srcSet: string;
                          webpSrcSet: string;
                          width: any;
                        } | null;
                      } | null;
                      imageLoad?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        title?: string | null;
                        url: string;
                        blurUpThumb?: string | null;
                        focalPoint?: {
                          __typename?: 'focalPoint';
                          x: any;
                          y: any;
                        } | null;
                        colors: Array<{
                          __typename?: 'ColorField';
                          hex: string;
                        }>;
                      } | null;
                    }
                  | {
                      __typename?: 'MediaWithCaptionRecord';
                      id: any;
                      centerText?: any | null;
                      textOnImage?: any | null;
                      media?: {
                        __typename?: 'ImageRecord';
                        id: any;
                        fullWidth?: any | null;
                        image?: {
                          __typename?: 'FileField';
                          alt?: string | null;
                          responsiveImage?: {
                            __typename?: 'ResponsiveImage';
                            aspectRatio: any;
                            base64?: string | null;
                            bgColor?: string | null;
                            height: any;
                            sizes: string;
                            src: string;
                            srcSet: string;
                            webpSrcSet: string;
                            width: any;
                          } | null;
                        } | null;
                        imageLoad?: {
                          __typename?: 'FileField';
                          alt?: string | null;
                          title?: string | null;
                          url: string;
                          blurUpThumb?: string | null;
                          focalPoint?: {
                            __typename?: 'focalPoint';
                            x: any;
                            y: any;
                          } | null;
                          colors: Array<{
                            __typename?: 'ColorField';
                            hex: string;
                          }>;
                        } | null;
                      } | null;
                      caption?: {
                        __typename?: 'TextBlockRecord';
                        id: any;
                        smallHeader?: any | null;
                        header?: string | null;
                        text?: string | null;
                        introText?: string | null;
                        ctaButtons: Array<{
                          __typename?: 'CtaButtonRecord';
                          id: any;
                          text?: string | null;
                          url?: string | null;
                          variant?: string | null;
                        }>;
                      } | null;
                    }
                  | {
                      __typename?: 'NewsListBlockRecord';
                      id: any;
                      title?: string | null;
                      standalone?: any | null;
                      largeTitle?: any | null;
                      itemsToShow?: any | null;
                    }
                  | {
                      __typename?: 'ReportsListBlockRecord';
                      id: any;
                      title?: string | null;
                      standalone?: any | null;
                      largeTitle?: any | null;
                    }
                  | {
                      __typename?: 'TextBlockRecord';
                      id: any;
                      smallHeader?: any | null;
                      header?: string | null;
                      text?: string | null;
                      introText?: string | null;
                      ctaButtons: Array<{
                        __typename?: 'CtaButtonRecord';
                        id: any;
                        text?: string | null;
                        url?: string | null;
                        variant?: string | null;
                      }>;
                    }
                >;
              }
          >;
        }
      | {
          __typename?: 'HeroBlockRecord';
          id: any;
          title?: string | null;
          description?: string | null;
          ctaText?: string | null;
          ctaUrl?: string | null;
          fullWidth?: any | null;
          boxColor?: { __typename?: 'ColorField'; hex: string } | null;
          textColor?: { __typename?: 'ColorField'; hex: string } | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
          imageOverlay?: {
            __typename?: 'OverlayRecord';
            id: any;
            opacity?: any | null;
            color?: { __typename?: 'ColorField'; hex: string } | null;
          } | null;
          ctaButtons: Array<{
            __typename?: 'CtaButtonRecord';
            id: any;
            text?: string | null;
            url?: string | null;
            variant?: string | null;
          }>;
          video?: {
            __typename?: 'FileField';
            blurUpThumb?: string | null;
            title?: string | null;
            alt?: string | null;
            video?: {
              __typename?: 'UploadVideoField';
              muxPlaybackId: string;
              width: any;
              height: any;
            } | null;
          } | null;
        }
      | {
          __typename?: 'ImageRecord';
          id: any;
          fullWidth?: any | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageLoad?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
        }
      | { __typename?: 'JobsListBlockRecord'; id: any; title?: string | null }
      | { __typename?: 'NewsAndReportsListBlockRecord' }
      | {
          __typename?: 'NewsListBlockRecord';
          id: any;
          title?: string | null;
          standalone?: any | null;
          largeTitle?: any | null;
          itemsToShow?: any | null;
        }
      | {
          __typename?: 'OfficesBlockRecord';
          id: any;
          offices: Array<{
            __typename?: 'OfficeRecord';
            id: any;
            name?: string | null;
            address?: string | null;
            zipCode?: string | null;
            city?: string | null;
            country?: string | null;
            email?: string | null;
            websiteUrl?: string | null;
            phoneNumber?: string | null;
          }>;
        }
      | {
          __typename?: 'PlugBlockRecord';
          id: any;
          title?: string | null;
          description?: string | null;
          brands: Array<{
            __typename?: 'BrandPageRecord';
            id: any;
            brandName?: string | null;
            slug?: string | null;
            image?: {
              __typename?: 'FileField';
              alt?: string | null;
              tags: Array<string>;
              title?: string | null;
              url: string;
              width?: any | null;
              height?: any | null;
              format: string;
              responsiveImage?: {
                __typename?: 'ResponsiveImage';
                aspectRatio: any;
                base64?: string | null;
                bgColor?: string | null;
                height: any;
                sizes: string;
                src: string;
                srcSet: string;
                webpSrcSet: string;
                width: any;
              } | null;
            } | null;
            imageLoad?: {
              __typename?: 'FileField';
              alt?: string | null;
              title?: string | null;
              url: string;
              blurUpThumb?: string | null;
              focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
              colors: Array<{ __typename?: 'ColorField'; hex: string }>;
            } | null;
          }>;
        }
      | {
          __typename?: 'SimpleTitleAndTextBlockRecord';
          id: any;
          title?: string | null;
          topLabel?: string | null;
          description?: string | null;
        }
      | {
          __typename?: 'SliderBlockRecord';
          title?: string | null;
          arrows?: any | null;
          slideAnimation?: any | null;
          delay?: any | null;
          dots?: any | null;
          heroes: Array<{
            __typename?: 'HeroBlockRecord';
            id: any;
            title?: string | null;
            description?: string | null;
            ctaText?: string | null;
            ctaUrl?: string | null;
            fullWidth?: any | null;
            boxColor?: { __typename?: 'ColorField'; hex: string } | null;
            textColor?: { __typename?: 'ColorField'; hex: string } | null;
            image?: {
              __typename?: 'FileField';
              alt?: string | null;
              title?: string | null;
              url: string;
              blurUpThumb?: string | null;
              focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
              colors: Array<{ __typename?: 'ColorField'; hex: string }>;
            } | null;
            imageOverlay?: {
              __typename?: 'OverlayRecord';
              id: any;
              opacity?: any | null;
              color?: { __typename?: 'ColorField'; hex: string } | null;
            } | null;
            ctaButtons: Array<{
              __typename?: 'CtaButtonRecord';
              id: any;
              text?: string | null;
              url?: string | null;
              variant?: string | null;
            }>;
            video?: {
              __typename?: 'FileField';
              blurUpThumb?: string | null;
              title?: string | null;
              alt?: string | null;
              video?: {
                __typename?: 'UploadVideoField';
                muxPlaybackId: string;
                width: any;
                height: any;
              } | null;
            } | null;
          }>;
        }
      | {
          __typename?: 'StatementBlockRecord';
          id: any;
          text?: string | null;
          blackBackground?: any | null;
          header?: string | null;
          small?: any | null;
          linkText?: string | null;
          linkUrl?: string | null;
          imageMobile?: {
            __typename?: 'FileField';
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageTablet?: {
            __typename?: 'FileField';
            alt?: string | null;
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageDesktop?: {
            __typename?: 'FileField';
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageLoad?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
          imageOverlay?: {
            __typename?: 'OverlayRecord';
            id: any;
            opacity?: any | null;
            color?: { __typename?: 'ColorField'; hex: string } | null;
          } | null;
        }
      | {
          __typename?: 'SubheadingBlockRecord';
          id: any;
          title?: string | null;
          text?: string | null;
          ctaButton?: {
            __typename?: 'CtaButtonRecord';
            id: any;
            text?: string | null;
            url?: string | null;
            variant?: string | null;
          } | null;
          backgroundColor?: { __typename?: 'ColorField'; hex: string } | null;
        }
      | {
          __typename?: 'SustainabilityReportsBlockRecord';
          id: any;
          title?: string | null;
          reports: Array<{
            __typename?: 'FileField';
            alt?: string | null;
            filename: string;
            format: string;
            size: any;
            title?: string | null;
            url: string;
            uploadId: any;
          }>;
        }
      | {
          __typename?: 'TextBlockRecord';
          id: any;
          smallHeader?: any | null;
          header?: string | null;
          text?: string | null;
          introText?: string | null;
          ctaButtons: Array<{
            __typename?: 'CtaButtonRecord';
            id: any;
            text?: string | null;
            url?: string | null;
            variant?: string | null;
          }>;
        }
      | {
          __typename?: 'TwoColumnImageAndTextRecord';
          id: any;
          text?: string | null;
          title?: string | null;
          reverse?: any | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageLoad?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
        }
      | {
          __typename?: 'TwoColumnTextIntroRecord';
          id: any;
          introText?: string | null;
          text?: string | null;
          header?: string | null;
        }
      | {
          __typename?: 'VideoRecord';
          id: any;
          autoplay?: any | null;
          video?: {
            __typename?: 'FileField';
            title?: string | null;
            video?: {
              __typename?: 'UploadVideoField';
              mp4Url?: string | null;
              streamingUrl: string;
              thumbnailUrl: string;
              mp4Low?: string | null;
            } | null;
          } | null;
          videoThumbnail?: {
            __typename?: 'FileField';
            alt?: string | null;
            tags: Array<string>;
            title?: string | null;
            url: string;
            width?: any | null;
            height?: any | null;
            format: string;
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          muxVideo?: {
            __typename?: 'FileField';
            blurUpThumb?: string | null;
            title?: string | null;
            alt?: string | null;
            video?: {
              __typename?: 'UploadVideoField';
              muxPlaybackId: string;
              width: any;
              height: any;
            } | null;
          } | null;
        }
    >;
  } | null;
  globalContent?: {
    __typename?: 'GlobalRecord';
    changeLanguage?: string | null;
    closeLabel?: string | null;
    deadline?: string | null;
    errorMessage?: string | null;
    loading?: string | null;
    loadMoreNews?: string | null;
    localWebLabel?: string | null;
    menu?: string | null;
    moreNewsCta?: string | null;
    moreNewsHeader?: string | null;
    partnerPortalLabel?: string | null;
    partnerPortalUrl?: string | null;
    play?: string | null;
    shopLinkTitle?: string | null;
    shopLinkUrl?: string | null;
    showMoreJobsLabel?: string | null;
    viewOnMapLabel?: string | null;
    nextLabel?: string | null;
    previousLabel?: string | null;
    sliderNavigationLabel?: string | null;
    moreReportsCta?: string | null;
    loadMoreReports?: string | null;
    clearIconLabel?: string | null;
    searchIconLabel?: string | null;
    searchBoxPlaceholder?: string | null;
    viewAllButtonLabel?: string | null;
    searchResultsPageTitle?: string | null;
    firstPageLabel?: string | null;
    previousPageLabel?: string | null;
    nextPageLabel?: string | null;
    lastPageLabel?: string | null;
    goToPageLabel?: string | null;
    searchResultCount?: string | null;
    noSearchResults?: string | null;
    navigationLogo?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      responsiveImage?: {
        __typename?: 'ResponsiveImage';
        aspectRatio: any;
        base64?: string | null;
        bgColor?: string | null;
        height: any;
        sizes: string;
        src: string;
        srcSet: string;
        webpSrcSet: string;
        width: any;
      } | null;
    } | null;
    languages: Array<{
      __typename?: 'LanguageRecord';
      name?: string | null;
      url?: string | null;
      flag?: string | null;
      symbol?: {
        __typename?: 'FileField';
        alt?: string | null;
        tags: Array<string>;
        title?: string | null;
        url: string;
        width?: any | null;
        height?: any | null;
        format: string;
      } | null;
    }>;
  } | null;
  featureToggle?: {
    __typename?: 'FeatureToggleRecord';
    landingPageContentArea?: any | null;
    newsPageContentArea?: any | null;
  } | null;
  menu?: {
    __typename?: 'MenuRecord';
    menuItems: Array<{
      __typename?: 'MenuItemRecord';
      id: any;
      title?: string | null;
      url?: string | null;
      submenu?: {
        __typename?: 'SubmenuRecord';
        title?: string | null;
        menuItems: Array<{
          __typename?: 'ItemRecord';
          title?: string | null;
          pageLink?:
            | { __typename?: 'AboutUsPageRecord'; slug?: string | null }
            | { __typename?: 'BrandPageRecord'; slug?: string | null }
            | { __typename?: 'SustainabilityPageRecord'; slug?: string | null }
            | null;
        }>;
      } | null;
    }>;
  } | null;
  footer?: {
    __typename?: 'FooterRecord';
    bottomIntro?: string | null;
    cookieSettings?: string | null;
    introText?: string | null;
    moreInfoText?: string | null;
    partnerLogin?: string | null;
    selectCountryLabel?: string | null;
    socialMediaLabel?: string | null;
    useNewFooter?: any | null;
    footerLogo?: {
      __typename?: 'FileField';
      alt?: string | null;
      tags: Array<string>;
      title?: string | null;
      url: string;
      width?: any | null;
      height?: any | null;
      format: string;
    } | null;
    hultaforsBrands: Array<{
      __typename?: 'LinkRecord';
      id: any;
      title?: string | null;
      url?: string | null;
    }>;
    menu: Array<{
      __typename?: 'LinkRecord';
      id: any;
      title?: string | null;
      url?: string | null;
    }>;
    menuItems: Array<{
      __typename?: 'FooterMenuItemRecord';
      heading?: string | null;
      includeCookieToggle?: any | null;
      links: Array<{
        __typename?: 'LinkRecord';
        url?: string | null;
        title?: string | null;
      }>;
    }>;
    socialMediaMenu: Array<{
      __typename?: 'IconLinkRecord';
      url?: string | null;
      icon?: {
        __typename?: 'FileField';
        alt?: string | null;
        tags: Array<string>;
        title?: string | null;
        url: string;
        width?: any | null;
        height?: any | null;
        format: string;
      } | null;
    }>;
  } | null;
};

export type JobOpportunitiesListPageQueryVariables = Exact<{
  locale?: InputMaybe<SiteLocale>;
}>;

export type JobOpportunitiesListPageQuery = {
  __typename?: 'Query';
  jobOpportunitiesListPage?: {
    __typename?: 'JobOpportunitiesListPageRecord';
    id: any;
    pageLocales: Array<SiteLocale>;
    seo?: {
      __typename?: 'SeoField';
      description?: string | null;
      title?: string | null;
      image?: {
        __typename?: 'FileField';
        url: string;
        alt?: string | null;
        title?: string | null;
      } | null;
    } | null;
    contentArea: Array<
      | {
          __typename?: 'ArticlesBlockRecord';
          id: any;
          title?: string | null;
          isJobArticles?: any | null;
          ctaText?: string | null;
          ctaUrl?: string | null;
          jobPages: Array<{
            __typename?: 'JobOpportunitiesPageRecord';
            id: any;
            slug?: string | null;
            title?: string | null;
            publishDate?: any | null;
            category?: string | null;
            country?: string | null;
            department?: string | null;
          }>;
          newsPages: Array<{
            __typename?: 'NewsPageRecord';
            id: any;
            slug?: string | null;
            title?: string | null;
            publishDate?: any | null;
            category?: string | null;
            country?: string | null;
            image?: {
              __typename?: 'FileField';
              alt?: string | null;
              title?: string | null;
              url: string;
              blurUpThumb?: string | null;
              focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
              colors: Array<{ __typename?: 'ColorField'; hex: string }>;
            } | null;
          }>;
          reportPages: Array<{
            __typename?: 'ReportsListingRecord';
            id: any;
            slug?: string | null;
            title?: string | null;
            publishDate?: any | null;
            category?: string | null;
            country?: string | null;
            image?: {
              __typename?: 'FileField';
              alt?: string | null;
              title?: string | null;
              url: string;
              blurUpThumb?: string | null;
              focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
              colors: Array<{ __typename?: 'ColorField'; hex: string }>;
            } | null;
            pdf?: {
              __typename?: 'FileField';
              alt?: string | null;
              filename: string;
              format: string;
              size: any;
              title?: string | null;
              url: string;
              uploadId: any;
            } | null;
          }>;
        }
      | {
          __typename?: 'BrandsBlockRecord';
          id: any;
          title?: string | null;
          introText?: string | null;
          hideLabels?: any | null;
          brands: Array<{
            __typename?: 'BrandPageRecord';
            id: any;
            brandName?: string | null;
            slug?: string | null;
            image?: {
              __typename?: 'FileField';
              alt?: string | null;
              tags: Array<string>;
              title?: string | null;
              url: string;
              width?: any | null;
              height?: any | null;
              format: string;
              responsiveImage?: {
                __typename?: 'ResponsiveImage';
                aspectRatio: any;
                base64?: string | null;
                bgColor?: string | null;
                height: any;
                sizes: string;
                src: string;
                srcSet: string;
                webpSrcSet: string;
                width: any;
              } | null;
            } | null;
            imageLoad?: {
              __typename?: 'FileField';
              alt?: string | null;
              title?: string | null;
              url: string;
              blurUpThumb?: string | null;
              focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
              colors: Array<{ __typename?: 'ColorField'; hex: string }>;
            } | null;
          }>;
        }
      | {
          __typename?: 'BulletListRecord';
          id: any;
          bullets?: string | null;
          numberedList?: any | null;
          title?: string | null;
        }
      | {
          __typename?: 'DocumentLinkBlockRecord';
          id: any;
          documents: Array<{
            __typename?: 'FileField';
            alt?: string | null;
            filename: string;
            format: string;
            size: any;
            title?: string | null;
            url: string;
            uploadId: any;
          }>;
        }
      | {
          __typename?: 'EmployeeRecord';
          id: any;
          name?: string | null;
          title?: string | null;
          introText?: string | null;
          description?: string | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
        }
      | {
          __typename?: 'HeroBlockRecord';
          id: any;
          title?: string | null;
          description?: string | null;
          ctaText?: string | null;
          ctaUrl?: string | null;
          fullWidth?: any | null;
          boxColor?: { __typename?: 'ColorField'; hex: string } | null;
          textColor?: { __typename?: 'ColorField'; hex: string } | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
          imageOverlay?: {
            __typename?: 'OverlayRecord';
            id: any;
            opacity?: any | null;
            color?: { __typename?: 'ColorField'; hex: string } | null;
          } | null;
          ctaButtons: Array<{
            __typename?: 'CtaButtonRecord';
            id: any;
            text?: string | null;
            url?: string | null;
            variant?: string | null;
          }>;
          video?: {
            __typename?: 'FileField';
            blurUpThumb?: string | null;
            title?: string | null;
            alt?: string | null;
            video?: {
              __typename?: 'UploadVideoField';
              muxPlaybackId: string;
              width: any;
              height: any;
            } | null;
          } | null;
        }
      | {
          __typename?: 'ImageRecord';
          id: any;
          fullWidth?: any | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageLoad?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
        }
      | { __typename?: 'JobsListBlockRecord'; id: any; title?: string | null }
      | {
          __typename?: 'NewsListBlockRecord';
          id: any;
          title?: string | null;
          standalone?: any | null;
          largeTitle?: any | null;
          itemsToShow?: any | null;
        }
      | {
          __typename?: 'OfficesBlockRecord';
          id: any;
          offices: Array<{
            __typename?: 'OfficeRecord';
            id: any;
            name?: string | null;
            address?: string | null;
            zipCode?: string | null;
            city?: string | null;
            country?: string | null;
            email?: string | null;
            websiteUrl?: string | null;
            phoneNumber?: string | null;
          }>;
        }
      | {
          __typename?: 'PlugBlockRecord';
          id: any;
          title?: string | null;
          description?: string | null;
          brands: Array<{
            __typename?: 'BrandPageRecord';
            id: any;
            brandName?: string | null;
            slug?: string | null;
            image?: {
              __typename?: 'FileField';
              alt?: string | null;
              tags: Array<string>;
              title?: string | null;
              url: string;
              width?: any | null;
              height?: any | null;
              format: string;
              responsiveImage?: {
                __typename?: 'ResponsiveImage';
                aspectRatio: any;
                base64?: string | null;
                bgColor?: string | null;
                height: any;
                sizes: string;
                src: string;
                srcSet: string;
                webpSrcSet: string;
                width: any;
              } | null;
            } | null;
            imageLoad?: {
              __typename?: 'FileField';
              alt?: string | null;
              title?: string | null;
              url: string;
              blurUpThumb?: string | null;
              focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
              colors: Array<{ __typename?: 'ColorField'; hex: string }>;
            } | null;
          }>;
        }
      | {
          __typename?: 'SimpleTitleAndTextBlockRecord';
          id: any;
          title?: string | null;
          topLabel?: string | null;
          description?: string | null;
        }
      | {
          __typename?: 'SliderBlockRecord';
          title?: string | null;
          arrows?: any | null;
          slideAnimation?: any | null;
          delay?: any | null;
          dots?: any | null;
          heroes: Array<{
            __typename?: 'HeroBlockRecord';
            id: any;
            title?: string | null;
            description?: string | null;
            ctaText?: string | null;
            ctaUrl?: string | null;
            fullWidth?: any | null;
            boxColor?: { __typename?: 'ColorField'; hex: string } | null;
            textColor?: { __typename?: 'ColorField'; hex: string } | null;
            image?: {
              __typename?: 'FileField';
              alt?: string | null;
              title?: string | null;
              url: string;
              blurUpThumb?: string | null;
              focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
              colors: Array<{ __typename?: 'ColorField'; hex: string }>;
            } | null;
            imageOverlay?: {
              __typename?: 'OverlayRecord';
              id: any;
              opacity?: any | null;
              color?: { __typename?: 'ColorField'; hex: string } | null;
            } | null;
            ctaButtons: Array<{
              __typename?: 'CtaButtonRecord';
              id: any;
              text?: string | null;
              url?: string | null;
              variant?: string | null;
            }>;
            video?: {
              __typename?: 'FileField';
              blurUpThumb?: string | null;
              title?: string | null;
              alt?: string | null;
              video?: {
                __typename?: 'UploadVideoField';
                muxPlaybackId: string;
                width: any;
                height: any;
              } | null;
            } | null;
          }>;
        }
      | {
          __typename?: 'StatementBlockRecord';
          id: any;
          text?: string | null;
          blackBackground?: any | null;
          header?: string | null;
          small?: any | null;
          linkText?: string | null;
          linkUrl?: string | null;
          imageMobile?: {
            __typename?: 'FileField';
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageTablet?: {
            __typename?: 'FileField';
            alt?: string | null;
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageDesktop?: {
            __typename?: 'FileField';
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageLoad?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
          imageOverlay?: {
            __typename?: 'OverlayRecord';
            id: any;
            opacity?: any | null;
            color?: { __typename?: 'ColorField'; hex: string } | null;
          } | null;
        }
      | {
          __typename?: 'TextBlockRecord';
          id: any;
          smallHeader?: any | null;
          header?: string | null;
          text?: string | null;
          introText?: string | null;
          ctaButtons: Array<{
            __typename?: 'CtaButtonRecord';
            id: any;
            text?: string | null;
            url?: string | null;
            variant?: string | null;
          }>;
        }
      | {
          __typename?: 'TwoColumnImageAndTextRecord';
          id: any;
          text?: string | null;
          title?: string | null;
          reverse?: any | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageLoad?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
        }
      | {
          __typename?: 'TwoColumnTextIntroRecord';
          id: any;
          introText?: string | null;
          text?: string | null;
          header?: string | null;
        }
      | {
          __typename?: 'VideoRecord';
          id: any;
          autoplay?: any | null;
          video?: {
            __typename?: 'FileField';
            title?: string | null;
            video?: {
              __typename?: 'UploadVideoField';
              mp4Url?: string | null;
              streamingUrl: string;
              thumbnailUrl: string;
              mp4Low?: string | null;
            } | null;
          } | null;
          videoThumbnail?: {
            __typename?: 'FileField';
            alt?: string | null;
            tags: Array<string>;
            title?: string | null;
            url: string;
            width?: any | null;
            height?: any | null;
            format: string;
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          muxVideo?: {
            __typename?: 'FileField';
            blurUpThumb?: string | null;
            title?: string | null;
            alt?: string | null;
            video?: {
              __typename?: 'UploadVideoField';
              muxPlaybackId: string;
              width: any;
              height: any;
            } | null;
          } | null;
        }
    >;
  } | null;
  globalContent?: {
    __typename?: 'GlobalRecord';
    changeLanguage?: string | null;
    closeLabel?: string | null;
    deadline?: string | null;
    errorMessage?: string | null;
    loading?: string | null;
    loadMoreNews?: string | null;
    localWebLabel?: string | null;
    menu?: string | null;
    moreNewsCta?: string | null;
    moreNewsHeader?: string | null;
    partnerPortalLabel?: string | null;
    partnerPortalUrl?: string | null;
    play?: string | null;
    shopLinkTitle?: string | null;
    shopLinkUrl?: string | null;
    showMoreJobsLabel?: string | null;
    viewOnMapLabel?: string | null;
    nextLabel?: string | null;
    previousLabel?: string | null;
    sliderNavigationLabel?: string | null;
    moreReportsCta?: string | null;
    loadMoreReports?: string | null;
    clearIconLabel?: string | null;
    searchIconLabel?: string | null;
    searchBoxPlaceholder?: string | null;
    viewAllButtonLabel?: string | null;
    searchResultsPageTitle?: string | null;
    firstPageLabel?: string | null;
    previousPageLabel?: string | null;
    nextPageLabel?: string | null;
    lastPageLabel?: string | null;
    goToPageLabel?: string | null;
    searchResultCount?: string | null;
    noSearchResults?: string | null;
    navigationLogo?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      responsiveImage?: {
        __typename?: 'ResponsiveImage';
        aspectRatio: any;
        base64?: string | null;
        bgColor?: string | null;
        height: any;
        sizes: string;
        src: string;
        srcSet: string;
        webpSrcSet: string;
        width: any;
      } | null;
    } | null;
    languages: Array<{
      __typename?: 'LanguageRecord';
      name?: string | null;
      url?: string | null;
      flag?: string | null;
      symbol?: {
        __typename?: 'FileField';
        alt?: string | null;
        tags: Array<string>;
        title?: string | null;
        url: string;
        width?: any | null;
        height?: any | null;
        format: string;
      } | null;
    }>;
  } | null;
  featureToggle?: {
    __typename?: 'FeatureToggleRecord';
    landingPageContentArea?: any | null;
    newsPageContentArea?: any | null;
  } | null;
  menu?: {
    __typename?: 'MenuRecord';
    menuItems: Array<{
      __typename?: 'MenuItemRecord';
      id: any;
      title?: string | null;
      url?: string | null;
      submenu?: {
        __typename?: 'SubmenuRecord';
        title?: string | null;
        menuItems: Array<{
          __typename?: 'ItemRecord';
          title?: string | null;
          pageLink?:
            | { __typename?: 'AboutUsPageRecord'; slug?: string | null }
            | { __typename?: 'BrandPageRecord'; slug?: string | null }
            | { __typename?: 'SustainabilityPageRecord'; slug?: string | null }
            | null;
        }>;
      } | null;
    }>;
  } | null;
  footer?: {
    __typename?: 'FooterRecord';
    bottomIntro?: string | null;
    cookieSettings?: string | null;
    introText?: string | null;
    moreInfoText?: string | null;
    partnerLogin?: string | null;
    selectCountryLabel?: string | null;
    socialMediaLabel?: string | null;
    useNewFooter?: any | null;
    footerLogo?: {
      __typename?: 'FileField';
      alt?: string | null;
      tags: Array<string>;
      title?: string | null;
      url: string;
      width?: any | null;
      height?: any | null;
      format: string;
    } | null;
    hultaforsBrands: Array<{
      __typename?: 'LinkRecord';
      id: any;
      title?: string | null;
      url?: string | null;
    }>;
    menu: Array<{
      __typename?: 'LinkRecord';
      id: any;
      title?: string | null;
      url?: string | null;
    }>;
    menuItems: Array<{
      __typename?: 'FooterMenuItemRecord';
      heading?: string | null;
      includeCookieToggle?: any | null;
      links: Array<{
        __typename?: 'LinkRecord';
        url?: string | null;
        title?: string | null;
      }>;
    }>;
    socialMediaMenu: Array<{
      __typename?: 'IconLinkRecord';
      url?: string | null;
      icon?: {
        __typename?: 'FileField';
        alt?: string | null;
        tags: Array<string>;
        title?: string | null;
        url: string;
        width?: any | null;
        height?: any | null;
        format: string;
      } | null;
    }>;
  } | null;
};

export type JobOpportunitiesPageQueryVariables = Exact<{
  locale?: InputMaybe<SiteLocale>;
  slug: Scalars['String']['input'];
}>;

export type JobOpportunitiesPageQuery = {
  __typename?: 'Query';
  jobOpportunitiesPage?: {
    __typename?: 'JobOpportunitiesPageRecord';
    id: any;
    title?: string | null;
    slug?: string | null;
    publishDate?: any | null;
    category?: string | null;
    applicationDeadline?: any | null;
    pageLocales: Array<SiteLocale>;
    seo?: {
      __typename?: 'SeoField';
      description?: string | null;
      title?: string | null;
      image?: {
        __typename?: 'FileField';
        url: string;
        alt?: string | null;
        title?: string | null;
      } | null;
    } | null;
    contentArea: Array<
      | {
          __typename?: 'ArticlesBlockRecord';
          id: any;
          title?: string | null;
          isJobArticles?: any | null;
          ctaText?: string | null;
          ctaUrl?: string | null;
          jobPages: Array<{
            __typename?: 'JobOpportunitiesPageRecord';
            id: any;
            slug?: string | null;
            title?: string | null;
            publishDate?: any | null;
            category?: string | null;
            country?: string | null;
            department?: string | null;
          }>;
          newsPages: Array<{
            __typename?: 'NewsPageRecord';
            id: any;
            slug?: string | null;
            title?: string | null;
            publishDate?: any | null;
            category?: string | null;
            country?: string | null;
            image?: {
              __typename?: 'FileField';
              alt?: string | null;
              title?: string | null;
              url: string;
              blurUpThumb?: string | null;
              focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
              colors: Array<{ __typename?: 'ColorField'; hex: string }>;
            } | null;
          }>;
          reportPages: Array<{
            __typename?: 'ReportsListingRecord';
            id: any;
            slug?: string | null;
            title?: string | null;
            publishDate?: any | null;
            category?: string | null;
            country?: string | null;
            image?: {
              __typename?: 'FileField';
              alt?: string | null;
              title?: string | null;
              url: string;
              blurUpThumb?: string | null;
              focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
              colors: Array<{ __typename?: 'ColorField'; hex: string }>;
            } | null;
            pdf?: {
              __typename?: 'FileField';
              alt?: string | null;
              filename: string;
              format: string;
              size: any;
              title?: string | null;
              url: string;
              uploadId: any;
            } | null;
          }>;
        }
      | {
          __typename?: 'BrandsBlockRecord';
          id: any;
          title?: string | null;
          introText?: string | null;
          hideLabels?: any | null;
          brands: Array<{
            __typename?: 'BrandPageRecord';
            id: any;
            brandName?: string | null;
            slug?: string | null;
            image?: {
              __typename?: 'FileField';
              alt?: string | null;
              tags: Array<string>;
              title?: string | null;
              url: string;
              width?: any | null;
              height?: any | null;
              format: string;
              responsiveImage?: {
                __typename?: 'ResponsiveImage';
                aspectRatio: any;
                base64?: string | null;
                bgColor?: string | null;
                height: any;
                sizes: string;
                src: string;
                srcSet: string;
                webpSrcSet: string;
                width: any;
              } | null;
            } | null;
            imageLoad?: {
              __typename?: 'FileField';
              alt?: string | null;
              title?: string | null;
              url: string;
              blurUpThumb?: string | null;
              focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
              colors: Array<{ __typename?: 'ColorField'; hex: string }>;
            } | null;
          }>;
        }
      | {
          __typename?: 'BulletListRecord';
          id: any;
          bullets?: string | null;
          numberedList?: any | null;
          title?: string | null;
        }
      | {
          __typename?: 'DocumentLinkBlockRecord';
          id: any;
          documents: Array<{
            __typename?: 'FileField';
            alt?: string | null;
            filename: string;
            format: string;
            size: any;
            title?: string | null;
            url: string;
            uploadId: any;
          }>;
        }
      | {
          __typename?: 'EmployeeRecord';
          id: any;
          name?: string | null;
          title?: string | null;
          introText?: string | null;
          description?: string | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
        }
      | {
          __typename?: 'HeroBlockRecord';
          id: any;
          title?: string | null;
          description?: string | null;
          ctaText?: string | null;
          ctaUrl?: string | null;
          fullWidth?: any | null;
          boxColor?: { __typename?: 'ColorField'; hex: string } | null;
          textColor?: { __typename?: 'ColorField'; hex: string } | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
          imageOverlay?: {
            __typename?: 'OverlayRecord';
            id: any;
            opacity?: any | null;
            color?: { __typename?: 'ColorField'; hex: string } | null;
          } | null;
          ctaButtons: Array<{
            __typename?: 'CtaButtonRecord';
            id: any;
            text?: string | null;
            url?: string | null;
            variant?: string | null;
          }>;
          video?: {
            __typename?: 'FileField';
            blurUpThumb?: string | null;
            title?: string | null;
            alt?: string | null;
            video?: {
              __typename?: 'UploadVideoField';
              muxPlaybackId: string;
              width: any;
              height: any;
            } | null;
          } | null;
        }
      | {
          __typename?: 'ImageRecord';
          id: any;
          fullWidth?: any | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageLoad?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
        }
      | { __typename?: 'JobsListBlockRecord'; id: any; title?: string | null }
      | {
          __typename?: 'NewsListBlockRecord';
          id: any;
          title?: string | null;
          standalone?: any | null;
          largeTitle?: any | null;
          itemsToShow?: any | null;
        }
      | {
          __typename?: 'OfficesBlockRecord';
          id: any;
          offices: Array<{
            __typename?: 'OfficeRecord';
            id: any;
            name?: string | null;
            address?: string | null;
            zipCode?: string | null;
            city?: string | null;
            country?: string | null;
            email?: string | null;
            websiteUrl?: string | null;
            phoneNumber?: string | null;
          }>;
        }
      | {
          __typename?: 'PlugBlockRecord';
          id: any;
          title?: string | null;
          description?: string | null;
          brands: Array<{
            __typename?: 'BrandPageRecord';
            id: any;
            brandName?: string | null;
            slug?: string | null;
            image?: {
              __typename?: 'FileField';
              alt?: string | null;
              tags: Array<string>;
              title?: string | null;
              url: string;
              width?: any | null;
              height?: any | null;
              format: string;
              responsiveImage?: {
                __typename?: 'ResponsiveImage';
                aspectRatio: any;
                base64?: string | null;
                bgColor?: string | null;
                height: any;
                sizes: string;
                src: string;
                srcSet: string;
                webpSrcSet: string;
                width: any;
              } | null;
            } | null;
            imageLoad?: {
              __typename?: 'FileField';
              alt?: string | null;
              title?: string | null;
              url: string;
              blurUpThumb?: string | null;
              focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
              colors: Array<{ __typename?: 'ColorField'; hex: string }>;
            } | null;
          }>;
        }
      | {
          __typename?: 'SimpleTitleAndTextBlockRecord';
          id: any;
          title?: string | null;
          topLabel?: string | null;
          description?: string | null;
        }
      | {
          __typename?: 'SliderBlockRecord';
          title?: string | null;
          arrows?: any | null;
          slideAnimation?: any | null;
          delay?: any | null;
          dots?: any | null;
          heroes: Array<{
            __typename?: 'HeroBlockRecord';
            id: any;
            title?: string | null;
            description?: string | null;
            ctaText?: string | null;
            ctaUrl?: string | null;
            fullWidth?: any | null;
            boxColor?: { __typename?: 'ColorField'; hex: string } | null;
            textColor?: { __typename?: 'ColorField'; hex: string } | null;
            image?: {
              __typename?: 'FileField';
              alt?: string | null;
              title?: string | null;
              url: string;
              blurUpThumb?: string | null;
              focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
              colors: Array<{ __typename?: 'ColorField'; hex: string }>;
            } | null;
            imageOverlay?: {
              __typename?: 'OverlayRecord';
              id: any;
              opacity?: any | null;
              color?: { __typename?: 'ColorField'; hex: string } | null;
            } | null;
            ctaButtons: Array<{
              __typename?: 'CtaButtonRecord';
              id: any;
              text?: string | null;
              url?: string | null;
              variant?: string | null;
            }>;
            video?: {
              __typename?: 'FileField';
              blurUpThumb?: string | null;
              title?: string | null;
              alt?: string | null;
              video?: {
                __typename?: 'UploadVideoField';
                muxPlaybackId: string;
                width: any;
                height: any;
              } | null;
            } | null;
          }>;
        }
      | {
          __typename?: 'StatementBlockRecord';
          id: any;
          text?: string | null;
          blackBackground?: any | null;
          header?: string | null;
          small?: any | null;
          linkText?: string | null;
          linkUrl?: string | null;
          imageMobile?: {
            __typename?: 'FileField';
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageTablet?: {
            __typename?: 'FileField';
            alt?: string | null;
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageDesktop?: {
            __typename?: 'FileField';
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageLoad?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
          imageOverlay?: {
            __typename?: 'OverlayRecord';
            id: any;
            opacity?: any | null;
            color?: { __typename?: 'ColorField'; hex: string } | null;
          } | null;
        }
      | {
          __typename?: 'TextBlockRecord';
          id: any;
          smallHeader?: any | null;
          header?: string | null;
          text?: string | null;
          introText?: string | null;
          ctaButtons: Array<{
            __typename?: 'CtaButtonRecord';
            id: any;
            text?: string | null;
            url?: string | null;
            variant?: string | null;
          }>;
        }
      | {
          __typename?: 'TwoColumnImageAndTextRecord';
          id: any;
          text?: string | null;
          title?: string | null;
          reverse?: any | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageLoad?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
        }
      | {
          __typename?: 'TwoColumnTextIntroRecord';
          id: any;
          introText?: string | null;
          text?: string | null;
          header?: string | null;
        }
      | {
          __typename?: 'VideoRecord';
          id: any;
          autoplay?: any | null;
          video?: {
            __typename?: 'FileField';
            title?: string | null;
            video?: {
              __typename?: 'UploadVideoField';
              mp4Url?: string | null;
              streamingUrl: string;
              thumbnailUrl: string;
              mp4Low?: string | null;
            } | null;
          } | null;
          videoThumbnail?: {
            __typename?: 'FileField';
            alt?: string | null;
            tags: Array<string>;
            title?: string | null;
            url: string;
            width?: any | null;
            height?: any | null;
            format: string;
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          muxVideo?: {
            __typename?: 'FileField';
            blurUpThumb?: string | null;
            title?: string | null;
            alt?: string | null;
            video?: {
              __typename?: 'UploadVideoField';
              muxPlaybackId: string;
              width: any;
              height: any;
            } | null;
          } | null;
        }
    >;
  } | null;
  globalContent?: {
    __typename?: 'GlobalRecord';
    changeLanguage?: string | null;
    closeLabel?: string | null;
    deadline?: string | null;
    errorMessage?: string | null;
    loading?: string | null;
    loadMoreNews?: string | null;
    localWebLabel?: string | null;
    menu?: string | null;
    moreNewsCta?: string | null;
    moreNewsHeader?: string | null;
    partnerPortalLabel?: string | null;
    partnerPortalUrl?: string | null;
    play?: string | null;
    shopLinkTitle?: string | null;
    shopLinkUrl?: string | null;
    showMoreJobsLabel?: string | null;
    viewOnMapLabel?: string | null;
    nextLabel?: string | null;
    previousLabel?: string | null;
    sliderNavigationLabel?: string | null;
    moreReportsCta?: string | null;
    loadMoreReports?: string | null;
    clearIconLabel?: string | null;
    searchIconLabel?: string | null;
    searchBoxPlaceholder?: string | null;
    viewAllButtonLabel?: string | null;
    searchResultsPageTitle?: string | null;
    firstPageLabel?: string | null;
    previousPageLabel?: string | null;
    nextPageLabel?: string | null;
    lastPageLabel?: string | null;
    goToPageLabel?: string | null;
    searchResultCount?: string | null;
    noSearchResults?: string | null;
    navigationLogo?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      responsiveImage?: {
        __typename?: 'ResponsiveImage';
        aspectRatio: any;
        base64?: string | null;
        bgColor?: string | null;
        height: any;
        sizes: string;
        src: string;
        srcSet: string;
        webpSrcSet: string;
        width: any;
      } | null;
    } | null;
    languages: Array<{
      __typename?: 'LanguageRecord';
      name?: string | null;
      url?: string | null;
      flag?: string | null;
      symbol?: {
        __typename?: 'FileField';
        alt?: string | null;
        tags: Array<string>;
        title?: string | null;
        url: string;
        width?: any | null;
        height?: any | null;
        format: string;
      } | null;
    }>;
  } | null;
  featureToggle?: {
    __typename?: 'FeatureToggleRecord';
    landingPageContentArea?: any | null;
    newsPageContentArea?: any | null;
  } | null;
  menu?: {
    __typename?: 'MenuRecord';
    menuItems: Array<{
      __typename?: 'MenuItemRecord';
      id: any;
      title?: string | null;
      url?: string | null;
      submenu?: {
        __typename?: 'SubmenuRecord';
        title?: string | null;
        menuItems: Array<{
          __typename?: 'ItemRecord';
          title?: string | null;
          pageLink?:
            | { __typename?: 'AboutUsPageRecord'; slug?: string | null }
            | { __typename?: 'BrandPageRecord'; slug?: string | null }
            | { __typename?: 'SustainabilityPageRecord'; slug?: string | null }
            | null;
        }>;
      } | null;
    }>;
  } | null;
  footer?: {
    __typename?: 'FooterRecord';
    bottomIntro?: string | null;
    cookieSettings?: string | null;
    introText?: string | null;
    moreInfoText?: string | null;
    partnerLogin?: string | null;
    selectCountryLabel?: string | null;
    socialMediaLabel?: string | null;
    useNewFooter?: any | null;
    footerLogo?: {
      __typename?: 'FileField';
      alt?: string | null;
      tags: Array<string>;
      title?: string | null;
      url: string;
      width?: any | null;
      height?: any | null;
      format: string;
    } | null;
    hultaforsBrands: Array<{
      __typename?: 'LinkRecord';
      id: any;
      title?: string | null;
      url?: string | null;
    }>;
    menu: Array<{
      __typename?: 'LinkRecord';
      id: any;
      title?: string | null;
      url?: string | null;
    }>;
    menuItems: Array<{
      __typename?: 'FooterMenuItemRecord';
      heading?: string | null;
      includeCookieToggle?: any | null;
      links: Array<{
        __typename?: 'LinkRecord';
        url?: string | null;
        title?: string | null;
      }>;
    }>;
    socialMediaMenu: Array<{
      __typename?: 'IconLinkRecord';
      url?: string | null;
      icon?: {
        __typename?: 'FileField';
        alt?: string | null;
        tags: Array<string>;
        title?: string | null;
        url: string;
        width?: any | null;
        height?: any | null;
        format: string;
      } | null;
    }>;
  } | null;
};

export type LandingPageQueryVariables = Exact<{
  locale?: InputMaybe<SiteLocale>;
}>;

export type LandingPageQuery = {
  __typename?: 'Query';
  landingPage?: {
    __typename?: 'LandingPageRecord';
    id: any;
    pageLocales: Array<SiteLocale>;
    seo?: {
      __typename?: 'SeoField';
      description?: string | null;
      title?: string | null;
      image?: {
        __typename?: 'FileField';
        url: string;
        alt?: string | null;
        title?: string | null;
      } | null;
    } | null;
    contentArea: Array<
      | {
          __typename?: 'ArticlesBlockRecord';
          id: any;
          title?: string | null;
          isJobArticles?: any | null;
          ctaText?: string | null;
          ctaUrl?: string | null;
          jobPages: Array<{
            __typename?: 'JobOpportunitiesPageRecord';
            id: any;
            slug?: string | null;
            title?: string | null;
            publishDate?: any | null;
            category?: string | null;
            country?: string | null;
            department?: string | null;
          }>;
          newsPages: Array<{
            __typename?: 'NewsPageRecord';
            id: any;
            slug?: string | null;
            title?: string | null;
            publishDate?: any | null;
            category?: string | null;
            country?: string | null;
            image?: {
              __typename?: 'FileField';
              alt?: string | null;
              title?: string | null;
              url: string;
              blurUpThumb?: string | null;
              focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
              colors: Array<{ __typename?: 'ColorField'; hex: string }>;
            } | null;
          }>;
          reportPages: Array<{
            __typename?: 'ReportsListingRecord';
            id: any;
            slug?: string | null;
            title?: string | null;
            publishDate?: any | null;
            category?: string | null;
            country?: string | null;
            image?: {
              __typename?: 'FileField';
              alt?: string | null;
              title?: string | null;
              url: string;
              blurUpThumb?: string | null;
              focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
              colors: Array<{ __typename?: 'ColorField'; hex: string }>;
            } | null;
            pdf?: {
              __typename?: 'FileField';
              alt?: string | null;
              filename: string;
              format: string;
              size: any;
              title?: string | null;
              url: string;
              uploadId: any;
            } | null;
          }>;
        }
      | {
          __typename?: 'BrandsBlockRecord';
          id: any;
          title?: string | null;
          introText?: string | null;
          hideLabels?: any | null;
          brands: Array<{
            __typename?: 'BrandPageRecord';
            id: any;
            brandName?: string | null;
            slug?: string | null;
            image?: {
              __typename?: 'FileField';
              alt?: string | null;
              tags: Array<string>;
              title?: string | null;
              url: string;
              width?: any | null;
              height?: any | null;
              format: string;
              responsiveImage?: {
                __typename?: 'ResponsiveImage';
                aspectRatio: any;
                base64?: string | null;
                bgColor?: string | null;
                height: any;
                sizes: string;
                src: string;
                srcSet: string;
                webpSrcSet: string;
                width: any;
              } | null;
            } | null;
            imageLoad?: {
              __typename?: 'FileField';
              alt?: string | null;
              title?: string | null;
              url: string;
              blurUpThumb?: string | null;
              focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
              colors: Array<{ __typename?: 'ColorField'; hex: string }>;
            } | null;
          }>;
        }
      | {
          __typename?: 'BulletListRecord';
          id: any;
          bullets?: string | null;
          numberedList?: any | null;
          title?: string | null;
        }
      | {
          __typename?: 'DocumentLinkBlockRecord';
          id: any;
          documents: Array<{
            __typename?: 'FileField';
            alt?: string | null;
            filename: string;
            format: string;
            size: any;
            title?: string | null;
            url: string;
            uploadId: any;
          }>;
        }
      | {
          __typename?: 'EmployeeRecord';
          id: any;
          name?: string | null;
          title?: string | null;
          introText?: string | null;
          description?: string | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
        }
      | {
          __typename?: 'GridContainerBlockRecord';
          id: any;
          fullwidth?: any | null;
          gap?: any | null;
          backgroundColor?: { __typename?: 'ColorField'; hex: string } | null;
          textColor?: { __typename?: 'ColorField'; hex: string } | null;
          content: Array<
            | {
                __typename?: 'GridFourcolBlockRecord';
                id: any;
                content: Array<
                  | {
                      __typename?: 'ImageRecord';
                      id: any;
                      fullWidth?: any | null;
                      image?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        responsiveImage?: {
                          __typename?: 'ResponsiveImage';
                          aspectRatio: any;
                          base64?: string | null;
                          bgColor?: string | null;
                          height: any;
                          sizes: string;
                          src: string;
                          srcSet: string;
                          webpSrcSet: string;
                          width: any;
                        } | null;
                      } | null;
                      imageLoad?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        title?: string | null;
                        url: string;
                        blurUpThumb?: string | null;
                        focalPoint?: {
                          __typename?: 'focalPoint';
                          x: any;
                          y: any;
                        } | null;
                        colors: Array<{
                          __typename?: 'ColorField';
                          hex: string;
                        }>;
                      } | null;
                    }
                  | {
                      __typename?: 'MediaWithCaptionRecord';
                      id: any;
                      centerText?: any | null;
                      textOnImage?: any | null;
                      media?: {
                        __typename?: 'ImageRecord';
                        id: any;
                        fullWidth?: any | null;
                        image?: {
                          __typename?: 'FileField';
                          alt?: string | null;
                          responsiveImage?: {
                            __typename?: 'ResponsiveImage';
                            aspectRatio: any;
                            base64?: string | null;
                            bgColor?: string | null;
                            height: any;
                            sizes: string;
                            src: string;
                            srcSet: string;
                            webpSrcSet: string;
                            width: any;
                          } | null;
                        } | null;
                        imageLoad?: {
                          __typename?: 'FileField';
                          alt?: string | null;
                          title?: string | null;
                          url: string;
                          blurUpThumb?: string | null;
                          focalPoint?: {
                            __typename?: 'focalPoint';
                            x: any;
                            y: any;
                          } | null;
                          colors: Array<{
                            __typename?: 'ColorField';
                            hex: string;
                          }>;
                        } | null;
                      } | null;
                      caption?: {
                        __typename?: 'TextBlockRecord';
                        id: any;
                        smallHeader?: any | null;
                        header?: string | null;
                        text?: string | null;
                        introText?: string | null;
                        ctaButtons: Array<{
                          __typename?: 'CtaButtonRecord';
                          id: any;
                          text?: string | null;
                          url?: string | null;
                          variant?: string | null;
                        }>;
                      } | null;
                    }
                  | {
                      __typename?: 'TextBlockRecord';
                      id: any;
                      smallHeader?: any | null;
                      header?: string | null;
                      text?: string | null;
                      introText?: string | null;
                      ctaButtons: Array<{
                        __typename?: 'CtaButtonRecord';
                        id: any;
                        text?: string | null;
                        url?: string | null;
                        variant?: string | null;
                      }>;
                    }
                >;
              }
            | {
                __typename?: 'GridThreecolBlockRecord';
                id: any;
                content: Array<
                  | {
                      __typename?: 'GridTwocolBlockRecord';
                      id: any;
                      content: Array<
                        | {
                            __typename?: 'ImageRecord';
                            id: any;
                            fullWidth?: any | null;
                            image?: {
                              __typename?: 'FileField';
                              alt?: string | null;
                              responsiveImage?: {
                                __typename?: 'ResponsiveImage';
                                aspectRatio: any;
                                base64?: string | null;
                                bgColor?: string | null;
                                height: any;
                                sizes: string;
                                src: string;
                                srcSet: string;
                                webpSrcSet: string;
                                width: any;
                              } | null;
                            } | null;
                            imageLoad?: {
                              __typename?: 'FileField';
                              alt?: string | null;
                              title?: string | null;
                              url: string;
                              blurUpThumb?: string | null;
                              focalPoint?: {
                                __typename?: 'focalPoint';
                                x: any;
                                y: any;
                              } | null;
                              colors: Array<{
                                __typename?: 'ColorField';
                                hex: string;
                              }>;
                            } | null;
                          }
                        | {
                            __typename?: 'MediaWithCaptionRecord';
                            id: any;
                            centerText?: any | null;
                            textOnImage?: any | null;
                            media?: {
                              __typename?: 'ImageRecord';
                              id: any;
                              fullWidth?: any | null;
                              image?: {
                                __typename?: 'FileField';
                                alt?: string | null;
                                responsiveImage?: {
                                  __typename?: 'ResponsiveImage';
                                  aspectRatio: any;
                                  base64?: string | null;
                                  bgColor?: string | null;
                                  height: any;
                                  sizes: string;
                                  src: string;
                                  srcSet: string;
                                  webpSrcSet: string;
                                  width: any;
                                } | null;
                              } | null;
                              imageLoad?: {
                                __typename?: 'FileField';
                                alt?: string | null;
                                title?: string | null;
                                url: string;
                                blurUpThumb?: string | null;
                                focalPoint?: {
                                  __typename?: 'focalPoint';
                                  x: any;
                                  y: any;
                                } | null;
                                colors: Array<{
                                  __typename?: 'ColorField';
                                  hex: string;
                                }>;
                              } | null;
                            } | null;
                            caption?: {
                              __typename?: 'TextBlockRecord';
                              id: any;
                              smallHeader?: any | null;
                              header?: string | null;
                              text?: string | null;
                              introText?: string | null;
                              ctaButtons: Array<{
                                __typename?: 'CtaButtonRecord';
                                id: any;
                                text?: string | null;
                                url?: string | null;
                                variant?: string | null;
                              }>;
                            } | null;
                          }
                        | {
                            __typename?: 'NewsListBlockRecord';
                            id: any;
                            title?: string | null;
                            standalone?: any | null;
                            largeTitle?: any | null;
                            itemsToShow?: any | null;
                          }
                        | {
                            __typename?: 'ReportsListBlockRecord';
                            id: any;
                            title?: string | null;
                            standalone?: any | null;
                            largeTitle?: any | null;
                          }
                        | {
                            __typename?: 'TextBlockRecord';
                            id: any;
                            smallHeader?: any | null;
                            header?: string | null;
                            text?: string | null;
                            introText?: string | null;
                            ctaButtons: Array<{
                              __typename?: 'CtaButtonRecord';
                              id: any;
                              text?: string | null;
                              url?: string | null;
                              variant?: string | null;
                            }>;
                          }
                      >;
                    }
                  | {
                      __typename?: 'ImageRecord';
                      id: any;
                      fullWidth?: any | null;
                      image?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        responsiveImage?: {
                          __typename?: 'ResponsiveImage';
                          aspectRatio: any;
                          base64?: string | null;
                          bgColor?: string | null;
                          height: any;
                          sizes: string;
                          src: string;
                          srcSet: string;
                          webpSrcSet: string;
                          width: any;
                        } | null;
                      } | null;
                      imageLoad?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        title?: string | null;
                        url: string;
                        blurUpThumb?: string | null;
                        focalPoint?: {
                          __typename?: 'focalPoint';
                          x: any;
                          y: any;
                        } | null;
                        colors: Array<{
                          __typename?: 'ColorField';
                          hex: string;
                        }>;
                      } | null;
                    }
                  | {
                      __typename?: 'MediaWithCaptionRecord';
                      id: any;
                      centerText?: any | null;
                      textOnImage?: any | null;
                      media?: {
                        __typename?: 'ImageRecord';
                        id: any;
                        fullWidth?: any | null;
                        image?: {
                          __typename?: 'FileField';
                          alt?: string | null;
                          responsiveImage?: {
                            __typename?: 'ResponsiveImage';
                            aspectRatio: any;
                            base64?: string | null;
                            bgColor?: string | null;
                            height: any;
                            sizes: string;
                            src: string;
                            srcSet: string;
                            webpSrcSet: string;
                            width: any;
                          } | null;
                        } | null;
                        imageLoad?: {
                          __typename?: 'FileField';
                          alt?: string | null;
                          title?: string | null;
                          url: string;
                          blurUpThumb?: string | null;
                          focalPoint?: {
                            __typename?: 'focalPoint';
                            x: any;
                            y: any;
                          } | null;
                          colors: Array<{
                            __typename?: 'ColorField';
                            hex: string;
                          }>;
                        } | null;
                      } | null;
                      caption?: {
                        __typename?: 'TextBlockRecord';
                        id: any;
                        smallHeader?: any | null;
                        header?: string | null;
                        text?: string | null;
                        introText?: string | null;
                        ctaButtons: Array<{
                          __typename?: 'CtaButtonRecord';
                          id: any;
                          text?: string | null;
                          url?: string | null;
                          variant?: string | null;
                        }>;
                      } | null;
                    }
                  | {
                      __typename?: 'TextBlockRecord';
                      id: any;
                      smallHeader?: any | null;
                      header?: string | null;
                      text?: string | null;
                      introText?: string | null;
                      ctaButtons: Array<{
                        __typename?: 'CtaButtonRecord';
                        id: any;
                        text?: string | null;
                        url?: string | null;
                        variant?: string | null;
                      }>;
                    }
                >;
              }
            | {
                __typename?: 'GridTwocolBlockRecord';
                id: any;
                content: Array<
                  | {
                      __typename?: 'ImageRecord';
                      id: any;
                      fullWidth?: any | null;
                      image?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        responsiveImage?: {
                          __typename?: 'ResponsiveImage';
                          aspectRatio: any;
                          base64?: string | null;
                          bgColor?: string | null;
                          height: any;
                          sizes: string;
                          src: string;
                          srcSet: string;
                          webpSrcSet: string;
                          width: any;
                        } | null;
                      } | null;
                      imageLoad?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        title?: string | null;
                        url: string;
                        blurUpThumb?: string | null;
                        focalPoint?: {
                          __typename?: 'focalPoint';
                          x: any;
                          y: any;
                        } | null;
                        colors: Array<{
                          __typename?: 'ColorField';
                          hex: string;
                        }>;
                      } | null;
                    }
                  | {
                      __typename?: 'MediaWithCaptionRecord';
                      id: any;
                      centerText?: any | null;
                      textOnImage?: any | null;
                      media?: {
                        __typename?: 'ImageRecord';
                        id: any;
                        fullWidth?: any | null;
                        image?: {
                          __typename?: 'FileField';
                          alt?: string | null;
                          responsiveImage?: {
                            __typename?: 'ResponsiveImage';
                            aspectRatio: any;
                            base64?: string | null;
                            bgColor?: string | null;
                            height: any;
                            sizes: string;
                            src: string;
                            srcSet: string;
                            webpSrcSet: string;
                            width: any;
                          } | null;
                        } | null;
                        imageLoad?: {
                          __typename?: 'FileField';
                          alt?: string | null;
                          title?: string | null;
                          url: string;
                          blurUpThumb?: string | null;
                          focalPoint?: {
                            __typename?: 'focalPoint';
                            x: any;
                            y: any;
                          } | null;
                          colors: Array<{
                            __typename?: 'ColorField';
                            hex: string;
                          }>;
                        } | null;
                      } | null;
                      caption?: {
                        __typename?: 'TextBlockRecord';
                        id: any;
                        smallHeader?: any | null;
                        header?: string | null;
                        text?: string | null;
                        introText?: string | null;
                        ctaButtons: Array<{
                          __typename?: 'CtaButtonRecord';
                          id: any;
                          text?: string | null;
                          url?: string | null;
                          variant?: string | null;
                        }>;
                      } | null;
                    }
                  | {
                      __typename?: 'NewsListBlockRecord';
                      id: any;
                      title?: string | null;
                      standalone?: any | null;
                      largeTitle?: any | null;
                      itemsToShow?: any | null;
                    }
                  | {
                      __typename?: 'ReportsListBlockRecord';
                      id: any;
                      title?: string | null;
                      standalone?: any | null;
                      largeTitle?: any | null;
                    }
                  | {
                      __typename?: 'TextBlockRecord';
                      id: any;
                      smallHeader?: any | null;
                      header?: string | null;
                      text?: string | null;
                      introText?: string | null;
                      ctaButtons: Array<{
                        __typename?: 'CtaButtonRecord';
                        id: any;
                        text?: string | null;
                        url?: string | null;
                        variant?: string | null;
                      }>;
                    }
                >;
              }
          >;
        }
      | {
          __typename?: 'HeroBlockRecord';
          id: any;
          title?: string | null;
          description?: string | null;
          ctaText?: string | null;
          ctaUrl?: string | null;
          fullWidth?: any | null;
          boxColor?: { __typename?: 'ColorField'; hex: string } | null;
          textColor?: { __typename?: 'ColorField'; hex: string } | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
          imageOverlay?: {
            __typename?: 'OverlayRecord';
            id: any;
            opacity?: any | null;
            color?: { __typename?: 'ColorField'; hex: string } | null;
          } | null;
          ctaButtons: Array<{
            __typename?: 'CtaButtonRecord';
            id: any;
            text?: string | null;
            url?: string | null;
            variant?: string | null;
          }>;
          video?: {
            __typename?: 'FileField';
            blurUpThumb?: string | null;
            title?: string | null;
            alt?: string | null;
            video?: {
              __typename?: 'UploadVideoField';
              muxPlaybackId: string;
              width: any;
              height: any;
            } | null;
          } | null;
        }
      | {
          __typename?: 'ImageRecord';
          id: any;
          fullWidth?: any | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageLoad?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
        }
      | { __typename?: 'JobsListBlockRecord'; id: any; title?: string | null }
      | {
          __typename?: 'NewsAndReportsListBlockRecord';
          newsTitle?: string | null;
          reportsTitle?: string | null;
          newsImage?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
          news: Array<{
            __typename?: 'NewsPageRecord';
            id: any;
            title?: string | null;
            slug?: string | null;
            publishDate?: any | null;
            category?: string | null;
          }>;
          reportsImage?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
          reports: Array<{
            __typename?: 'ReportsListingRecord';
            id: any;
            title?: string | null;
            slug?: string | null;
            publishDate?: any | null;
            category?: string | null;
            pdf?: {
              __typename?: 'FileField';
              alt?: string | null;
              filename: string;
              format: string;
              size: any;
              title?: string | null;
              url: string;
              uploadId: any;
            } | null;
          }>;
        }
      | {
          __typename?: 'NewsListBlockRecord';
          id: any;
          title?: string | null;
          standalone?: any | null;
          largeTitle?: any | null;
          itemsToShow?: any | null;
        }
      | {
          __typename?: 'OfficesBlockRecord';
          id: any;
          offices: Array<{
            __typename?: 'OfficeRecord';
            id: any;
            name?: string | null;
            address?: string | null;
            zipCode?: string | null;
            city?: string | null;
            country?: string | null;
            email?: string | null;
            websiteUrl?: string | null;
            phoneNumber?: string | null;
          }>;
        }
      | {
          __typename?: 'PlugBlockRecord';
          id: any;
          title?: string | null;
          description?: string | null;
          brands: Array<{
            __typename?: 'BrandPageRecord';
            id: any;
            brandName?: string | null;
            slug?: string | null;
            image?: {
              __typename?: 'FileField';
              alt?: string | null;
              tags: Array<string>;
              title?: string | null;
              url: string;
              width?: any | null;
              height?: any | null;
              format: string;
              responsiveImage?: {
                __typename?: 'ResponsiveImage';
                aspectRatio: any;
                base64?: string | null;
                bgColor?: string | null;
                height: any;
                sizes: string;
                src: string;
                srcSet: string;
                webpSrcSet: string;
                width: any;
              } | null;
            } | null;
            imageLoad?: {
              __typename?: 'FileField';
              alt?: string | null;
              title?: string | null;
              url: string;
              blurUpThumb?: string | null;
              focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
              colors: Array<{ __typename?: 'ColorField'; hex: string }>;
            } | null;
          }>;
        }
      | {
          __typename?: 'SimpleTitleAndTextBlockRecord';
          id: any;
          title?: string | null;
          topLabel?: string | null;
          description?: string | null;
        }
      | {
          __typename?: 'SliderBlockRecord';
          title?: string | null;
          arrows?: any | null;
          slideAnimation?: any | null;
          delay?: any | null;
          dots?: any | null;
          heroes: Array<{
            __typename?: 'HeroBlockRecord';
            id: any;
            title?: string | null;
            description?: string | null;
            ctaText?: string | null;
            ctaUrl?: string | null;
            fullWidth?: any | null;
            boxColor?: { __typename?: 'ColorField'; hex: string } | null;
            textColor?: { __typename?: 'ColorField'; hex: string } | null;
            image?: {
              __typename?: 'FileField';
              alt?: string | null;
              title?: string | null;
              url: string;
              blurUpThumb?: string | null;
              focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
              colors: Array<{ __typename?: 'ColorField'; hex: string }>;
            } | null;
            imageOverlay?: {
              __typename?: 'OverlayRecord';
              id: any;
              opacity?: any | null;
              color?: { __typename?: 'ColorField'; hex: string } | null;
            } | null;
            ctaButtons: Array<{
              __typename?: 'CtaButtonRecord';
              id: any;
              text?: string | null;
              url?: string | null;
              variant?: string | null;
            }>;
            video?: {
              __typename?: 'FileField';
              blurUpThumb?: string | null;
              title?: string | null;
              alt?: string | null;
              video?: {
                __typename?: 'UploadVideoField';
                muxPlaybackId: string;
                width: any;
                height: any;
              } | null;
            } | null;
          }>;
        }
      | {
          __typename?: 'StatementBlockRecord';
          id: any;
          text?: string | null;
          blackBackground?: any | null;
          header?: string | null;
          small?: any | null;
          linkText?: string | null;
          linkUrl?: string | null;
          imageMobile?: {
            __typename?: 'FileField';
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageTablet?: {
            __typename?: 'FileField';
            alt?: string | null;
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageDesktop?: {
            __typename?: 'FileField';
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageLoad?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
          imageOverlay?: {
            __typename?: 'OverlayRecord';
            id: any;
            opacity?: any | null;
            color?: { __typename?: 'ColorField'; hex: string } | null;
          } | null;
        }
      | {
          __typename?: 'SubheadingBlockRecord';
          id: any;
          title?: string | null;
          text?: string | null;
          ctaButton?: {
            __typename?: 'CtaButtonRecord';
            id: any;
            text?: string | null;
            url?: string | null;
            variant?: string | null;
          } | null;
          backgroundColor?: { __typename?: 'ColorField'; hex: string } | null;
        }
      | {
          __typename?: 'SustainabilityReportsBlockRecord';
          id: any;
          title?: string | null;
          reports: Array<{
            __typename?: 'FileField';
            alt?: string | null;
            filename: string;
            format: string;
            size: any;
            title?: string | null;
            url: string;
            uploadId: any;
          }>;
        }
      | {
          __typename?: 'TextBlockRecord';
          id: any;
          smallHeader?: any | null;
          header?: string | null;
          text?: string | null;
          introText?: string | null;
          ctaButtons: Array<{
            __typename?: 'CtaButtonRecord';
            id: any;
            text?: string | null;
            url?: string | null;
            variant?: string | null;
          }>;
        }
      | {
          __typename?: 'TwoColumnImageAndTextRecord';
          id: any;
          text?: string | null;
          title?: string | null;
          reverse?: any | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageLoad?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
        }
      | {
          __typename?: 'TwoColumnTextIntroRecord';
          id: any;
          introText?: string | null;
          text?: string | null;
          header?: string | null;
        }
      | {
          __typename?: 'VideoRecord';
          id: any;
          autoplay?: any | null;
          video?: {
            __typename?: 'FileField';
            title?: string | null;
            video?: {
              __typename?: 'UploadVideoField';
              mp4Url?: string | null;
              streamingUrl: string;
              thumbnailUrl: string;
              mp4Low?: string | null;
            } | null;
          } | null;
          videoThumbnail?: {
            __typename?: 'FileField';
            alt?: string | null;
            tags: Array<string>;
            title?: string | null;
            url: string;
            width?: any | null;
            height?: any | null;
            format: string;
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          muxVideo?: {
            __typename?: 'FileField';
            blurUpThumb?: string | null;
            title?: string | null;
            alt?: string | null;
            video?: {
              __typename?: 'UploadVideoField';
              muxPlaybackId: string;
              width: any;
              height: any;
            } | null;
          } | null;
        }
    >;
  } | null;
  globalContent?: {
    __typename?: 'GlobalRecord';
    changeLanguage?: string | null;
    closeLabel?: string | null;
    deadline?: string | null;
    errorMessage?: string | null;
    loading?: string | null;
    loadMoreNews?: string | null;
    localWebLabel?: string | null;
    menu?: string | null;
    moreNewsCta?: string | null;
    moreNewsHeader?: string | null;
    partnerPortalLabel?: string | null;
    partnerPortalUrl?: string | null;
    play?: string | null;
    shopLinkTitle?: string | null;
    shopLinkUrl?: string | null;
    showMoreJobsLabel?: string | null;
    viewOnMapLabel?: string | null;
    nextLabel?: string | null;
    previousLabel?: string | null;
    sliderNavigationLabel?: string | null;
    moreReportsCta?: string | null;
    loadMoreReports?: string | null;
    clearIconLabel?: string | null;
    searchIconLabel?: string | null;
    searchBoxPlaceholder?: string | null;
    viewAllButtonLabel?: string | null;
    searchResultsPageTitle?: string | null;
    firstPageLabel?: string | null;
    previousPageLabel?: string | null;
    nextPageLabel?: string | null;
    lastPageLabel?: string | null;
    goToPageLabel?: string | null;
    searchResultCount?: string | null;
    noSearchResults?: string | null;
    navigationLogo?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      responsiveImage?: {
        __typename?: 'ResponsiveImage';
        aspectRatio: any;
        base64?: string | null;
        bgColor?: string | null;
        height: any;
        sizes: string;
        src: string;
        srcSet: string;
        webpSrcSet: string;
        width: any;
      } | null;
    } | null;
    languages: Array<{
      __typename?: 'LanguageRecord';
      name?: string | null;
      url?: string | null;
      flag?: string | null;
      symbol?: {
        __typename?: 'FileField';
        alt?: string | null;
        tags: Array<string>;
        title?: string | null;
        url: string;
        width?: any | null;
        height?: any | null;
        format: string;
      } | null;
    }>;
  } | null;
  featureToggle?: {
    __typename?: 'FeatureToggleRecord';
    landingPageContentArea?: any | null;
    newsPageContentArea?: any | null;
  } | null;
  menu?: {
    __typename?: 'MenuRecord';
    menuItems: Array<{
      __typename?: 'MenuItemRecord';
      id: any;
      title?: string | null;
      url?: string | null;
      submenu?: {
        __typename?: 'SubmenuRecord';
        title?: string | null;
        menuItems: Array<{
          __typename?: 'ItemRecord';
          title?: string | null;
          pageLink?:
            | { __typename?: 'AboutUsPageRecord'; slug?: string | null }
            | { __typename?: 'BrandPageRecord'; slug?: string | null }
            | { __typename?: 'SustainabilityPageRecord'; slug?: string | null }
            | null;
        }>;
      } | null;
    }>;
  } | null;
  footer?: {
    __typename?: 'FooterRecord';
    bottomIntro?: string | null;
    cookieSettings?: string | null;
    introText?: string | null;
    moreInfoText?: string | null;
    partnerLogin?: string | null;
    selectCountryLabel?: string | null;
    socialMediaLabel?: string | null;
    useNewFooter?: any | null;
    footerLogo?: {
      __typename?: 'FileField';
      alt?: string | null;
      tags: Array<string>;
      title?: string | null;
      url: string;
      width?: any | null;
      height?: any | null;
      format: string;
    } | null;
    hultaforsBrands: Array<{
      __typename?: 'LinkRecord';
      id: any;
      title?: string | null;
      url?: string | null;
    }>;
    menu: Array<{
      __typename?: 'LinkRecord';
      id: any;
      title?: string | null;
      url?: string | null;
    }>;
    menuItems: Array<{
      __typename?: 'FooterMenuItemRecord';
      heading?: string | null;
      includeCookieToggle?: any | null;
      links: Array<{
        __typename?: 'LinkRecord';
        url?: string | null;
        title?: string | null;
      }>;
    }>;
    socialMediaMenu: Array<{
      __typename?: 'IconLinkRecord';
      url?: string | null;
      icon?: {
        __typename?: 'FileField';
        alt?: string | null;
        tags: Array<string>;
        title?: string | null;
        url: string;
        width?: any | null;
        height?: any | null;
        format: string;
      } | null;
    }>;
  } | null;
};

export type NewsListPageQueryVariables = Exact<{
  locale?: InputMaybe<SiteLocale>;
}>;

export type NewsListPageQuery = {
  __typename?: 'Query';
  newsListPage?: {
    __typename?: 'NewsListPageRecord';
    id: any;
    pageLocales: Array<SiteLocale>;
    seo?: {
      __typename?: 'SeoField';
      description?: string | null;
      title?: string | null;
      image?: {
        __typename?: 'FileField';
        url: string;
        alt?: string | null;
        title?: string | null;
      } | null;
    } | null;
    contentArea: Array<
      | {
          __typename?: 'ArticlesBlockRecord';
          id: any;
          title?: string | null;
          isJobArticles?: any | null;
          ctaText?: string | null;
          ctaUrl?: string | null;
          jobPages: Array<{
            __typename?: 'JobOpportunitiesPageRecord';
            id: any;
            slug?: string | null;
            title?: string | null;
            publishDate?: any | null;
            category?: string | null;
            country?: string | null;
            department?: string | null;
          }>;
          newsPages: Array<{
            __typename?: 'NewsPageRecord';
            id: any;
            slug?: string | null;
            title?: string | null;
            publishDate?: any | null;
            category?: string | null;
            country?: string | null;
            image?: {
              __typename?: 'FileField';
              alt?: string | null;
              title?: string | null;
              url: string;
              blurUpThumb?: string | null;
              focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
              colors: Array<{ __typename?: 'ColorField'; hex: string }>;
            } | null;
          }>;
          reportPages: Array<{
            __typename?: 'ReportsListingRecord';
            id: any;
            slug?: string | null;
            title?: string | null;
            publishDate?: any | null;
            category?: string | null;
            country?: string | null;
            image?: {
              __typename?: 'FileField';
              alt?: string | null;
              title?: string | null;
              url: string;
              blurUpThumb?: string | null;
              focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
              colors: Array<{ __typename?: 'ColorField'; hex: string }>;
            } | null;
            pdf?: {
              __typename?: 'FileField';
              alt?: string | null;
              filename: string;
              format: string;
              size: any;
              title?: string | null;
              url: string;
              uploadId: any;
            } | null;
          }>;
        }
      | {
          __typename?: 'BrandsBlockRecord';
          id: any;
          title?: string | null;
          introText?: string | null;
          hideLabels?: any | null;
          brands: Array<{
            __typename?: 'BrandPageRecord';
            id: any;
            brandName?: string | null;
            slug?: string | null;
            image?: {
              __typename?: 'FileField';
              alt?: string | null;
              tags: Array<string>;
              title?: string | null;
              url: string;
              width?: any | null;
              height?: any | null;
              format: string;
              responsiveImage?: {
                __typename?: 'ResponsiveImage';
                aspectRatio: any;
                base64?: string | null;
                bgColor?: string | null;
                height: any;
                sizes: string;
                src: string;
                srcSet: string;
                webpSrcSet: string;
                width: any;
              } | null;
            } | null;
            imageLoad?: {
              __typename?: 'FileField';
              alt?: string | null;
              title?: string | null;
              url: string;
              blurUpThumb?: string | null;
              focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
              colors: Array<{ __typename?: 'ColorField'; hex: string }>;
            } | null;
          }>;
        }
      | {
          __typename?: 'BulletListRecord';
          id: any;
          bullets?: string | null;
          numberedList?: any | null;
          title?: string | null;
        }
      | {
          __typename?: 'DocumentLinkBlockRecord';
          id: any;
          documents: Array<{
            __typename?: 'FileField';
            alt?: string | null;
            filename: string;
            format: string;
            size: any;
            title?: string | null;
            url: string;
            uploadId: any;
          }>;
        }
      | {
          __typename?: 'EmployeeRecord';
          id: any;
          name?: string | null;
          title?: string | null;
          introText?: string | null;
          description?: string | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
        }
      | {
          __typename?: 'HeroBlockRecord';
          id: any;
          title?: string | null;
          description?: string | null;
          ctaText?: string | null;
          ctaUrl?: string | null;
          fullWidth?: any | null;
          boxColor?: { __typename?: 'ColorField'; hex: string } | null;
          textColor?: { __typename?: 'ColorField'; hex: string } | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
          imageOverlay?: {
            __typename?: 'OverlayRecord';
            id: any;
            opacity?: any | null;
            color?: { __typename?: 'ColorField'; hex: string } | null;
          } | null;
          ctaButtons: Array<{
            __typename?: 'CtaButtonRecord';
            id: any;
            text?: string | null;
            url?: string | null;
            variant?: string | null;
          }>;
          video?: {
            __typename?: 'FileField';
            blurUpThumb?: string | null;
            title?: string | null;
            alt?: string | null;
            video?: {
              __typename?: 'UploadVideoField';
              muxPlaybackId: string;
              width: any;
              height: any;
            } | null;
          } | null;
        }
      | {
          __typename?: 'ImageRecord';
          id: any;
          fullWidth?: any | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageLoad?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
        }
      | { __typename?: 'JobsListBlockRecord'; id: any; title?: string | null }
      | {
          __typename?: 'NewsAndReportsListBlockRecord';
          newsTitle?: string | null;
          reportsTitle?: string | null;
          newsImage?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
          news: Array<{
            __typename?: 'NewsPageRecord';
            id: any;
            title?: string | null;
            slug?: string | null;
            publishDate?: any | null;
            category?: string | null;
          }>;
          reportsImage?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
          reports: Array<{
            __typename?: 'ReportsListingRecord';
            id: any;
            title?: string | null;
            slug?: string | null;
            publishDate?: any | null;
            category?: string | null;
            pdf?: {
              __typename?: 'FileField';
              alt?: string | null;
              filename: string;
              format: string;
              size: any;
              title?: string | null;
              url: string;
              uploadId: any;
            } | null;
          }>;
        }
      | {
          __typename?: 'NewsListBlockRecord';
          id: any;
          title?: string | null;
          standalone?: any | null;
          largeTitle?: any | null;
          itemsToShow?: any | null;
        }
      | {
          __typename?: 'OfficesBlockRecord';
          id: any;
          offices: Array<{
            __typename?: 'OfficeRecord';
            id: any;
            name?: string | null;
            address?: string | null;
            zipCode?: string | null;
            city?: string | null;
            country?: string | null;
            email?: string | null;
            websiteUrl?: string | null;
            phoneNumber?: string | null;
          }>;
        }
      | {
          __typename?: 'PlugBlockRecord';
          id: any;
          title?: string | null;
          description?: string | null;
          brands: Array<{
            __typename?: 'BrandPageRecord';
            id: any;
            brandName?: string | null;
            slug?: string | null;
            image?: {
              __typename?: 'FileField';
              alt?: string | null;
              tags: Array<string>;
              title?: string | null;
              url: string;
              width?: any | null;
              height?: any | null;
              format: string;
              responsiveImage?: {
                __typename?: 'ResponsiveImage';
                aspectRatio: any;
                base64?: string | null;
                bgColor?: string | null;
                height: any;
                sizes: string;
                src: string;
                srcSet: string;
                webpSrcSet: string;
                width: any;
              } | null;
            } | null;
            imageLoad?: {
              __typename?: 'FileField';
              alt?: string | null;
              title?: string | null;
              url: string;
              blurUpThumb?: string | null;
              focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
              colors: Array<{ __typename?: 'ColorField'; hex: string }>;
            } | null;
          }>;
        }
      | {
          __typename?: 'SimpleTitleAndTextBlockRecord';
          id: any;
          title?: string | null;
          topLabel?: string | null;
          description?: string | null;
        }
      | {
          __typename?: 'SliderBlockRecord';
          title?: string | null;
          arrows?: any | null;
          slideAnimation?: any | null;
          delay?: any | null;
          dots?: any | null;
          heroes: Array<{
            __typename?: 'HeroBlockRecord';
            id: any;
            title?: string | null;
            description?: string | null;
            ctaText?: string | null;
            ctaUrl?: string | null;
            fullWidth?: any | null;
            boxColor?: { __typename?: 'ColorField'; hex: string } | null;
            textColor?: { __typename?: 'ColorField'; hex: string } | null;
            image?: {
              __typename?: 'FileField';
              alt?: string | null;
              title?: string | null;
              url: string;
              blurUpThumb?: string | null;
              focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
              colors: Array<{ __typename?: 'ColorField'; hex: string }>;
            } | null;
            imageOverlay?: {
              __typename?: 'OverlayRecord';
              id: any;
              opacity?: any | null;
              color?: { __typename?: 'ColorField'; hex: string } | null;
            } | null;
            ctaButtons: Array<{
              __typename?: 'CtaButtonRecord';
              id: any;
              text?: string | null;
              url?: string | null;
              variant?: string | null;
            }>;
            video?: {
              __typename?: 'FileField';
              blurUpThumb?: string | null;
              title?: string | null;
              alt?: string | null;
              video?: {
                __typename?: 'UploadVideoField';
                muxPlaybackId: string;
                width: any;
                height: any;
              } | null;
            } | null;
          }>;
        }
      | {
          __typename?: 'StatementBlockRecord';
          id: any;
          text?: string | null;
          blackBackground?: any | null;
          header?: string | null;
          small?: any | null;
          linkText?: string | null;
          linkUrl?: string | null;
          imageMobile?: {
            __typename?: 'FileField';
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageTablet?: {
            __typename?: 'FileField';
            alt?: string | null;
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageDesktop?: {
            __typename?: 'FileField';
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageLoad?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
          imageOverlay?: {
            __typename?: 'OverlayRecord';
            id: any;
            opacity?: any | null;
            color?: { __typename?: 'ColorField'; hex: string } | null;
          } | null;
        }
      | {
          __typename?: 'TextBlockRecord';
          id: any;
          smallHeader?: any | null;
          header?: string | null;
          text?: string | null;
          introText?: string | null;
          ctaButtons: Array<{
            __typename?: 'CtaButtonRecord';
            id: any;
            text?: string | null;
            url?: string | null;
            variant?: string | null;
          }>;
        }
      | {
          __typename?: 'TwoColumnImageAndTextRecord';
          id: any;
          text?: string | null;
          title?: string | null;
          reverse?: any | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageLoad?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
        }
      | {
          __typename?: 'TwoColumnTextIntroRecord';
          id: any;
          introText?: string | null;
          text?: string | null;
          header?: string | null;
        }
      | {
          __typename?: 'VideoRecord';
          id: any;
          autoplay?: any | null;
          video?: {
            __typename?: 'FileField';
            title?: string | null;
            video?: {
              __typename?: 'UploadVideoField';
              mp4Url?: string | null;
              streamingUrl: string;
              thumbnailUrl: string;
              mp4Low?: string | null;
            } | null;
          } | null;
          videoThumbnail?: {
            __typename?: 'FileField';
            alt?: string | null;
            tags: Array<string>;
            title?: string | null;
            url: string;
            width?: any | null;
            height?: any | null;
            format: string;
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          muxVideo?: {
            __typename?: 'FileField';
            blurUpThumb?: string | null;
            title?: string | null;
            alt?: string | null;
            video?: {
              __typename?: 'UploadVideoField';
              muxPlaybackId: string;
              width: any;
              height: any;
            } | null;
          } | null;
        }
    >;
  } | null;
  globalContent?: {
    __typename?: 'GlobalRecord';
    changeLanguage?: string | null;
    closeLabel?: string | null;
    deadline?: string | null;
    errorMessage?: string | null;
    loading?: string | null;
    loadMoreNews?: string | null;
    localWebLabel?: string | null;
    menu?: string | null;
    moreNewsCta?: string | null;
    moreNewsHeader?: string | null;
    partnerPortalLabel?: string | null;
    partnerPortalUrl?: string | null;
    play?: string | null;
    shopLinkTitle?: string | null;
    shopLinkUrl?: string | null;
    showMoreJobsLabel?: string | null;
    viewOnMapLabel?: string | null;
    nextLabel?: string | null;
    previousLabel?: string | null;
    sliderNavigationLabel?: string | null;
    moreReportsCta?: string | null;
    loadMoreReports?: string | null;
    clearIconLabel?: string | null;
    searchIconLabel?: string | null;
    searchBoxPlaceholder?: string | null;
    viewAllButtonLabel?: string | null;
    searchResultsPageTitle?: string | null;
    firstPageLabel?: string | null;
    previousPageLabel?: string | null;
    nextPageLabel?: string | null;
    lastPageLabel?: string | null;
    goToPageLabel?: string | null;
    searchResultCount?: string | null;
    noSearchResults?: string | null;
    navigationLogo?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      responsiveImage?: {
        __typename?: 'ResponsiveImage';
        aspectRatio: any;
        base64?: string | null;
        bgColor?: string | null;
        height: any;
        sizes: string;
        src: string;
        srcSet: string;
        webpSrcSet: string;
        width: any;
      } | null;
    } | null;
    languages: Array<{
      __typename?: 'LanguageRecord';
      name?: string | null;
      url?: string | null;
      flag?: string | null;
      symbol?: {
        __typename?: 'FileField';
        alt?: string | null;
        tags: Array<string>;
        title?: string | null;
        url: string;
        width?: any | null;
        height?: any | null;
        format: string;
      } | null;
    }>;
  } | null;
  featureToggle?: {
    __typename?: 'FeatureToggleRecord';
    landingPageContentArea?: any | null;
    newsPageContentArea?: any | null;
  } | null;
  menu?: {
    __typename?: 'MenuRecord';
    menuItems: Array<{
      __typename?: 'MenuItemRecord';
      id: any;
      title?: string | null;
      url?: string | null;
      submenu?: {
        __typename?: 'SubmenuRecord';
        title?: string | null;
        menuItems: Array<{
          __typename?: 'ItemRecord';
          title?: string | null;
          pageLink?:
            | { __typename?: 'AboutUsPageRecord'; slug?: string | null }
            | { __typename?: 'BrandPageRecord'; slug?: string | null }
            | { __typename?: 'SustainabilityPageRecord'; slug?: string | null }
            | null;
        }>;
      } | null;
    }>;
  } | null;
  footer?: {
    __typename?: 'FooterRecord';
    bottomIntro?: string | null;
    cookieSettings?: string | null;
    introText?: string | null;
    moreInfoText?: string | null;
    partnerLogin?: string | null;
    selectCountryLabel?: string | null;
    socialMediaLabel?: string | null;
    useNewFooter?: any | null;
    footerLogo?: {
      __typename?: 'FileField';
      alt?: string | null;
      tags: Array<string>;
      title?: string | null;
      url: string;
      width?: any | null;
      height?: any | null;
      format: string;
    } | null;
    hultaforsBrands: Array<{
      __typename?: 'LinkRecord';
      id: any;
      title?: string | null;
      url?: string | null;
    }>;
    menu: Array<{
      __typename?: 'LinkRecord';
      id: any;
      title?: string | null;
      url?: string | null;
    }>;
    menuItems: Array<{
      __typename?: 'FooterMenuItemRecord';
      heading?: string | null;
      includeCookieToggle?: any | null;
      links: Array<{
        __typename?: 'LinkRecord';
        url?: string | null;
        title?: string | null;
      }>;
    }>;
    socialMediaMenu: Array<{
      __typename?: 'IconLinkRecord';
      url?: string | null;
      icon?: {
        __typename?: 'FileField';
        alt?: string | null;
        tags: Array<string>;
        title?: string | null;
        url: string;
        width?: any | null;
        height?: any | null;
        format: string;
      } | null;
    }>;
  } | null;
};

export type NewsPageQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  locale?: InputMaybe<SiteLocale>;
  numberOfRelated?: InputMaybe<Scalars['IntType']['input']>;
}>;

export type NewsPageQuery = {
  __typename?: 'Query';
  newsPage?: {
    __typename?: 'NewsPageRecord';
    id: any;
    title?: string | null;
    slug?: string | null;
    publishDate?: any | null;
    category?: string | null;
    pageLocales: Array<SiteLocale>;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
    contentArea: Array<
      | {
          __typename?: 'ArticlesBlockRecord';
          id: any;
          title?: string | null;
          isJobArticles?: any | null;
          ctaText?: string | null;
          ctaUrl?: string | null;
          jobPages: Array<{
            __typename?: 'JobOpportunitiesPageRecord';
            id: any;
            slug?: string | null;
            title?: string | null;
            publishDate?: any | null;
            category?: string | null;
            country?: string | null;
            department?: string | null;
          }>;
          newsPages: Array<{
            __typename?: 'NewsPageRecord';
            id: any;
            slug?: string | null;
            title?: string | null;
            publishDate?: any | null;
            category?: string | null;
            country?: string | null;
            image?: {
              __typename?: 'FileField';
              alt?: string | null;
              title?: string | null;
              url: string;
              blurUpThumb?: string | null;
              focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
              colors: Array<{ __typename?: 'ColorField'; hex: string }>;
            } | null;
          }>;
          reportPages: Array<{
            __typename?: 'ReportsListingRecord';
            id: any;
            slug?: string | null;
            title?: string | null;
            publishDate?: any | null;
            category?: string | null;
            country?: string | null;
            image?: {
              __typename?: 'FileField';
              alt?: string | null;
              title?: string | null;
              url: string;
              blurUpThumb?: string | null;
              focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
              colors: Array<{ __typename?: 'ColorField'; hex: string }>;
            } | null;
            pdf?: {
              __typename?: 'FileField';
              alt?: string | null;
              filename: string;
              format: string;
              size: any;
              title?: string | null;
              url: string;
              uploadId: any;
            } | null;
          }>;
        }
      | {
          __typename?: 'BrandsBlockRecord';
          id: any;
          title?: string | null;
          introText?: string | null;
          hideLabels?: any | null;
          brands: Array<{
            __typename?: 'BrandPageRecord';
            id: any;
            brandName?: string | null;
            slug?: string | null;
            image?: {
              __typename?: 'FileField';
              alt?: string | null;
              tags: Array<string>;
              title?: string | null;
              url: string;
              width?: any | null;
              height?: any | null;
              format: string;
              responsiveImage?: {
                __typename?: 'ResponsiveImage';
                aspectRatio: any;
                base64?: string | null;
                bgColor?: string | null;
                height: any;
                sizes: string;
                src: string;
                srcSet: string;
                webpSrcSet: string;
                width: any;
              } | null;
            } | null;
            imageLoad?: {
              __typename?: 'FileField';
              alt?: string | null;
              title?: string | null;
              url: string;
              blurUpThumb?: string | null;
              focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
              colors: Array<{ __typename?: 'ColorField'; hex: string }>;
            } | null;
          }>;
        }
      | {
          __typename?: 'BulletListRecord';
          id: any;
          bullets?: string | null;
          numberedList?: any | null;
          title?: string | null;
        }
      | {
          __typename?: 'DocumentLinkBlockRecord';
          id: any;
          documents: Array<{
            __typename?: 'FileField';
            alt?: string | null;
            filename: string;
            format: string;
            size: any;
            title?: string | null;
            url: string;
            uploadId: any;
          }>;
        }
      | {
          __typename?: 'EmployeeRecord';
          id: any;
          name?: string | null;
          title?: string | null;
          introText?: string | null;
          description?: string | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
        }
      | {
          __typename?: 'HeroBlockRecord';
          id: any;
          title?: string | null;
          description?: string | null;
          ctaText?: string | null;
          ctaUrl?: string | null;
          fullWidth?: any | null;
          boxColor?: { __typename?: 'ColorField'; hex: string } | null;
          textColor?: { __typename?: 'ColorField'; hex: string } | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
          imageOverlay?: {
            __typename?: 'OverlayRecord';
            id: any;
            opacity?: any | null;
            color?: { __typename?: 'ColorField'; hex: string } | null;
          } | null;
          ctaButtons: Array<{
            __typename?: 'CtaButtonRecord';
            id: any;
            text?: string | null;
            url?: string | null;
            variant?: string | null;
          }>;
          video?: {
            __typename?: 'FileField';
            blurUpThumb?: string | null;
            title?: string | null;
            alt?: string | null;
            video?: {
              __typename?: 'UploadVideoField';
              muxPlaybackId: string;
              width: any;
              height: any;
            } | null;
          } | null;
        }
      | {
          __typename?: 'ImageRecord';
          id: any;
          fullWidth?: any | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageLoad?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
        }
      | { __typename?: 'JobsListBlockRecord'; id: any; title?: string | null }
      | {
          __typename?: 'NewsAndReportsListBlockRecord';
          newsTitle?: string | null;
          reportsTitle?: string | null;
          newsImage?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
          news: Array<{
            __typename?: 'NewsPageRecord';
            id: any;
            title?: string | null;
            slug?: string | null;
            publishDate?: any | null;
            category?: string | null;
          }>;
          reportsImage?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
          reports: Array<{
            __typename?: 'ReportsListingRecord';
            id: any;
            title?: string | null;
            slug?: string | null;
            publishDate?: any | null;
            category?: string | null;
            pdf?: {
              __typename?: 'FileField';
              alt?: string | null;
              filename: string;
              format: string;
              size: any;
              title?: string | null;
              url: string;
              uploadId: any;
            } | null;
          }>;
        }
      | {
          __typename?: 'NewsListBlockRecord';
          id: any;
          title?: string | null;
          standalone?: any | null;
          largeTitle?: any | null;
          itemsToShow?: any | null;
        }
      | {
          __typename?: 'OfficesBlockRecord';
          id: any;
          offices: Array<{
            __typename?: 'OfficeRecord';
            id: any;
            name?: string | null;
            address?: string | null;
            zipCode?: string | null;
            city?: string | null;
            country?: string | null;
            email?: string | null;
            websiteUrl?: string | null;
            phoneNumber?: string | null;
          }>;
        }
      | {
          __typename?: 'PlugBlockRecord';
          id: any;
          title?: string | null;
          description?: string | null;
          brands: Array<{
            __typename?: 'BrandPageRecord';
            id: any;
            brandName?: string | null;
            slug?: string | null;
            image?: {
              __typename?: 'FileField';
              alt?: string | null;
              tags: Array<string>;
              title?: string | null;
              url: string;
              width?: any | null;
              height?: any | null;
              format: string;
              responsiveImage?: {
                __typename?: 'ResponsiveImage';
                aspectRatio: any;
                base64?: string | null;
                bgColor?: string | null;
                height: any;
                sizes: string;
                src: string;
                srcSet: string;
                webpSrcSet: string;
                width: any;
              } | null;
            } | null;
            imageLoad?: {
              __typename?: 'FileField';
              alt?: string | null;
              title?: string | null;
              url: string;
              blurUpThumb?: string | null;
              focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
              colors: Array<{ __typename?: 'ColorField'; hex: string }>;
            } | null;
          }>;
        }
      | {
          __typename?: 'SimpleTitleAndTextBlockRecord';
          id: any;
          title?: string | null;
          topLabel?: string | null;
          description?: string | null;
        }
      | {
          __typename?: 'SliderBlockRecord';
          title?: string | null;
          arrows?: any | null;
          slideAnimation?: any | null;
          delay?: any | null;
          dots?: any | null;
          heroes: Array<{
            __typename?: 'HeroBlockRecord';
            id: any;
            title?: string | null;
            description?: string | null;
            ctaText?: string | null;
            ctaUrl?: string | null;
            fullWidth?: any | null;
            boxColor?: { __typename?: 'ColorField'; hex: string } | null;
            textColor?: { __typename?: 'ColorField'; hex: string } | null;
            image?: {
              __typename?: 'FileField';
              alt?: string | null;
              title?: string | null;
              url: string;
              blurUpThumb?: string | null;
              focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
              colors: Array<{ __typename?: 'ColorField'; hex: string }>;
            } | null;
            imageOverlay?: {
              __typename?: 'OverlayRecord';
              id: any;
              opacity?: any | null;
              color?: { __typename?: 'ColorField'; hex: string } | null;
            } | null;
            ctaButtons: Array<{
              __typename?: 'CtaButtonRecord';
              id: any;
              text?: string | null;
              url?: string | null;
              variant?: string | null;
            }>;
            video?: {
              __typename?: 'FileField';
              blurUpThumb?: string | null;
              title?: string | null;
              alt?: string | null;
              video?: {
                __typename?: 'UploadVideoField';
                muxPlaybackId: string;
                width: any;
                height: any;
              } | null;
            } | null;
          }>;
        }
      | {
          __typename?: 'StatementBlockRecord';
          id: any;
          text?: string | null;
          blackBackground?: any | null;
          header?: string | null;
          small?: any | null;
          linkText?: string | null;
          linkUrl?: string | null;
          imageMobile?: {
            __typename?: 'FileField';
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageTablet?: {
            __typename?: 'FileField';
            alt?: string | null;
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageDesktop?: {
            __typename?: 'FileField';
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageLoad?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
          imageOverlay?: {
            __typename?: 'OverlayRecord';
            id: any;
            opacity?: any | null;
            color?: { __typename?: 'ColorField'; hex: string } | null;
          } | null;
        }
      | {
          __typename?: 'TextBlockRecord';
          id: any;
          smallHeader?: any | null;
          header?: string | null;
          text?: string | null;
          introText?: string | null;
          ctaButtons: Array<{
            __typename?: 'CtaButtonRecord';
            id: any;
            text?: string | null;
            url?: string | null;
            variant?: string | null;
          }>;
        }
      | {
          __typename?: 'TwoColumnImageAndTextRecord';
          id: any;
          text?: string | null;
          title?: string | null;
          reverse?: any | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageLoad?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
        }
      | {
          __typename?: 'TwoColumnTextIntroRecord';
          id: any;
          introText?: string | null;
          text?: string | null;
          header?: string | null;
        }
      | {
          __typename?: 'VideoRecord';
          id: any;
          autoplay?: any | null;
          video?: {
            __typename?: 'FileField';
            title?: string | null;
            video?: {
              __typename?: 'UploadVideoField';
              mp4Url?: string | null;
              streamingUrl: string;
              thumbnailUrl: string;
              mp4Low?: string | null;
            } | null;
          } | null;
          videoThumbnail?: {
            __typename?: 'FileField';
            alt?: string | null;
            tags: Array<string>;
            title?: string | null;
            url: string;
            width?: any | null;
            height?: any | null;
            format: string;
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          muxVideo?: {
            __typename?: 'FileField';
            blurUpThumb?: string | null;
            title?: string | null;
            alt?: string | null;
            video?: {
              __typename?: 'UploadVideoField';
              muxPlaybackId: string;
              width: any;
              height: any;
            } | null;
          } | null;
        }
    >;
    seo?: {
      __typename?: 'SeoField';
      description?: string | null;
      title?: string | null;
      image?: {
        __typename?: 'FileField';
        url: string;
        alt?: string | null;
        title?: string | null;
      } | null;
    } | null;
  } | null;
  allNewsPages: Array<{
    __typename?: 'NewsPageRecord';
    id: any;
    slug?: string | null;
    title?: string | null;
    publishDate?: any | null;
    category?: string | null;
    country?: string | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
  }>;
  _allNewsPagesMeta: { __typename?: 'CollectionMetadata'; count: any };
  globalContent?: {
    __typename?: 'GlobalRecord';
    changeLanguage?: string | null;
    closeLabel?: string | null;
    deadline?: string | null;
    errorMessage?: string | null;
    loading?: string | null;
    loadMoreNews?: string | null;
    localWebLabel?: string | null;
    menu?: string | null;
    moreNewsCta?: string | null;
    moreNewsHeader?: string | null;
    partnerPortalLabel?: string | null;
    partnerPortalUrl?: string | null;
    play?: string | null;
    shopLinkTitle?: string | null;
    shopLinkUrl?: string | null;
    showMoreJobsLabel?: string | null;
    viewOnMapLabel?: string | null;
    nextLabel?: string | null;
    previousLabel?: string | null;
    sliderNavigationLabel?: string | null;
    moreReportsCta?: string | null;
    loadMoreReports?: string | null;
    clearIconLabel?: string | null;
    searchIconLabel?: string | null;
    searchBoxPlaceholder?: string | null;
    viewAllButtonLabel?: string | null;
    searchResultsPageTitle?: string | null;
    firstPageLabel?: string | null;
    previousPageLabel?: string | null;
    nextPageLabel?: string | null;
    lastPageLabel?: string | null;
    goToPageLabel?: string | null;
    searchResultCount?: string | null;
    noSearchResults?: string | null;
    navigationLogo?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      responsiveImage?: {
        __typename?: 'ResponsiveImage';
        aspectRatio: any;
        base64?: string | null;
        bgColor?: string | null;
        height: any;
        sizes: string;
        src: string;
        srcSet: string;
        webpSrcSet: string;
        width: any;
      } | null;
    } | null;
    languages: Array<{
      __typename?: 'LanguageRecord';
      name?: string | null;
      url?: string | null;
      flag?: string | null;
      symbol?: {
        __typename?: 'FileField';
        alt?: string | null;
        tags: Array<string>;
        title?: string | null;
        url: string;
        width?: any | null;
        height?: any | null;
        format: string;
      } | null;
    }>;
  } | null;
  featureToggle?: {
    __typename?: 'FeatureToggleRecord';
    landingPageContentArea?: any | null;
    newsPageContentArea?: any | null;
  } | null;
  menu?: {
    __typename?: 'MenuRecord';
    menuItems: Array<{
      __typename?: 'MenuItemRecord';
      id: any;
      title?: string | null;
      url?: string | null;
      submenu?: {
        __typename?: 'SubmenuRecord';
        title?: string | null;
        menuItems: Array<{
          __typename?: 'ItemRecord';
          title?: string | null;
          pageLink?:
            | { __typename?: 'AboutUsPageRecord'; slug?: string | null }
            | { __typename?: 'BrandPageRecord'; slug?: string | null }
            | { __typename?: 'SustainabilityPageRecord'; slug?: string | null }
            | null;
        }>;
      } | null;
    }>;
  } | null;
  footer?: {
    __typename?: 'FooterRecord';
    bottomIntro?: string | null;
    cookieSettings?: string | null;
    introText?: string | null;
    moreInfoText?: string | null;
    partnerLogin?: string | null;
    selectCountryLabel?: string | null;
    socialMediaLabel?: string | null;
    useNewFooter?: any | null;
    footerLogo?: {
      __typename?: 'FileField';
      alt?: string | null;
      tags: Array<string>;
      title?: string | null;
      url: string;
      width?: any | null;
      height?: any | null;
      format: string;
    } | null;
    hultaforsBrands: Array<{
      __typename?: 'LinkRecord';
      id: any;
      title?: string | null;
      url?: string | null;
    }>;
    menu: Array<{
      __typename?: 'LinkRecord';
      id: any;
      title?: string | null;
      url?: string | null;
    }>;
    menuItems: Array<{
      __typename?: 'FooterMenuItemRecord';
      heading?: string | null;
      includeCookieToggle?: any | null;
      links: Array<{
        __typename?: 'LinkRecord';
        url?: string | null;
        title?: string | null;
      }>;
    }>;
    socialMediaMenu: Array<{
      __typename?: 'IconLinkRecord';
      url?: string | null;
      icon?: {
        __typename?: 'FileField';
        alt?: string | null;
        tags: Array<string>;
        title?: string | null;
        url: string;
        width?: any | null;
        height?: any | null;
        format: string;
      } | null;
    }>;
  } | null;
};

export type PageNotFoundQueryVariables = Exact<{
  locale?: InputMaybe<SiteLocale>;
}>;

export type PageNotFoundQuery = {
  __typename?: 'Query';
  pageNotFound?: {
    __typename?: 'PageNotFoundRecord';
    description?: string | null;
    header?: string | null;
    backToHomeScreenButton?: string | null;
  } | null;
  globalContent?: {
    __typename?: 'GlobalRecord';
    changeLanguage?: string | null;
    closeLabel?: string | null;
    deadline?: string | null;
    errorMessage?: string | null;
    loading?: string | null;
    loadMoreNews?: string | null;
    localWebLabel?: string | null;
    menu?: string | null;
    moreNewsCta?: string | null;
    moreNewsHeader?: string | null;
    partnerPortalLabel?: string | null;
    partnerPortalUrl?: string | null;
    play?: string | null;
    shopLinkTitle?: string | null;
    shopLinkUrl?: string | null;
    showMoreJobsLabel?: string | null;
    viewOnMapLabel?: string | null;
    nextLabel?: string | null;
    previousLabel?: string | null;
    sliderNavigationLabel?: string | null;
    moreReportsCta?: string | null;
    loadMoreReports?: string | null;
    clearIconLabel?: string | null;
    searchIconLabel?: string | null;
    searchBoxPlaceholder?: string | null;
    viewAllButtonLabel?: string | null;
    searchResultsPageTitle?: string | null;
    firstPageLabel?: string | null;
    previousPageLabel?: string | null;
    nextPageLabel?: string | null;
    lastPageLabel?: string | null;
    goToPageLabel?: string | null;
    searchResultCount?: string | null;
    noSearchResults?: string | null;
    navigationLogo?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      responsiveImage?: {
        __typename?: 'ResponsiveImage';
        aspectRatio: any;
        base64?: string | null;
        bgColor?: string | null;
        height: any;
        sizes: string;
        src: string;
        srcSet: string;
        webpSrcSet: string;
        width: any;
      } | null;
    } | null;
    languages: Array<{
      __typename?: 'LanguageRecord';
      name?: string | null;
      url?: string | null;
      flag?: string | null;
      symbol?: {
        __typename?: 'FileField';
        alt?: string | null;
        tags: Array<string>;
        title?: string | null;
        url: string;
        width?: any | null;
        height?: any | null;
        format: string;
      } | null;
    }>;
  } | null;
  featureToggle?: {
    __typename?: 'FeatureToggleRecord';
    landingPageContentArea?: any | null;
    newsPageContentArea?: any | null;
  } | null;
  menu?: {
    __typename?: 'MenuRecord';
    menuItems: Array<{
      __typename?: 'MenuItemRecord';
      id: any;
      title?: string | null;
      url?: string | null;
      submenu?: {
        __typename?: 'SubmenuRecord';
        title?: string | null;
        menuItems: Array<{
          __typename?: 'ItemRecord';
          title?: string | null;
          pageLink?:
            | { __typename?: 'AboutUsPageRecord'; slug?: string | null }
            | { __typename?: 'BrandPageRecord'; slug?: string | null }
            | { __typename?: 'SustainabilityPageRecord'; slug?: string | null }
            | null;
        }>;
      } | null;
    }>;
  } | null;
  footer?: {
    __typename?: 'FooterRecord';
    bottomIntro?: string | null;
    cookieSettings?: string | null;
    introText?: string | null;
    moreInfoText?: string | null;
    partnerLogin?: string | null;
    selectCountryLabel?: string | null;
    socialMediaLabel?: string | null;
    useNewFooter?: any | null;
    footerLogo?: {
      __typename?: 'FileField';
      alt?: string | null;
      tags: Array<string>;
      title?: string | null;
      url: string;
      width?: any | null;
      height?: any | null;
      format: string;
    } | null;
    hultaforsBrands: Array<{
      __typename?: 'LinkRecord';
      id: any;
      title?: string | null;
      url?: string | null;
    }>;
    menu: Array<{
      __typename?: 'LinkRecord';
      id: any;
      title?: string | null;
      url?: string | null;
    }>;
    menuItems: Array<{
      __typename?: 'FooterMenuItemRecord';
      heading?: string | null;
      includeCookieToggle?: any | null;
      links: Array<{
        __typename?: 'LinkRecord';
        url?: string | null;
        title?: string | null;
      }>;
    }>;
    socialMediaMenu: Array<{
      __typename?: 'IconLinkRecord';
      url?: string | null;
      icon?: {
        __typename?: 'FileField';
        alt?: string | null;
        tags: Array<string>;
        title?: string | null;
        url: string;
        width?: any | null;
        height?: any | null;
        format: string;
      } | null;
    }>;
  } | null;
};

export type ReportsListPageQueryVariables = Exact<{
  locale?: InputMaybe<SiteLocale>;
}>;

export type ReportsListPageQuery = {
  __typename?: 'Query';
  reportsListPage?: {
    __typename?: 'ReportsListPageRecord';
    id: any;
    pageLocales: Array<SiteLocale>;
    seo?: {
      __typename?: 'SeoField';
      description?: string | null;
      title?: string | null;
      image?: {
        __typename?: 'FileField';
        url: string;
        alt?: string | null;
        title?: string | null;
      } | null;
    } | null;
    contentArea: Array<
      | {
          __typename?: 'ArticlesBlockRecord';
          id: any;
          title?: string | null;
          isJobArticles?: any | null;
          ctaText?: string | null;
          ctaUrl?: string | null;
          jobPages: Array<{
            __typename?: 'JobOpportunitiesPageRecord';
            id: any;
            slug?: string | null;
            title?: string | null;
            publishDate?: any | null;
            category?: string | null;
            country?: string | null;
            department?: string | null;
          }>;
          newsPages: Array<{
            __typename?: 'NewsPageRecord';
            id: any;
            slug?: string | null;
            title?: string | null;
            publishDate?: any | null;
            category?: string | null;
            country?: string | null;
            image?: {
              __typename?: 'FileField';
              alt?: string | null;
              title?: string | null;
              url: string;
              blurUpThumb?: string | null;
              focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
              colors: Array<{ __typename?: 'ColorField'; hex: string }>;
            } | null;
          }>;
          reportPages: Array<{
            __typename?: 'ReportsListingRecord';
            id: any;
            slug?: string | null;
            title?: string | null;
            publishDate?: any | null;
            category?: string | null;
            country?: string | null;
            image?: {
              __typename?: 'FileField';
              alt?: string | null;
              title?: string | null;
              url: string;
              blurUpThumb?: string | null;
              focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
              colors: Array<{ __typename?: 'ColorField'; hex: string }>;
            } | null;
            pdf?: {
              __typename?: 'FileField';
              alt?: string | null;
              filename: string;
              format: string;
              size: any;
              title?: string | null;
              url: string;
              uploadId: any;
            } | null;
          }>;
        }
      | {
          __typename?: 'BrandsBlockRecord';
          id: any;
          title?: string | null;
          introText?: string | null;
          hideLabels?: any | null;
          brands: Array<{
            __typename?: 'BrandPageRecord';
            id: any;
            brandName?: string | null;
            slug?: string | null;
            image?: {
              __typename?: 'FileField';
              alt?: string | null;
              tags: Array<string>;
              title?: string | null;
              url: string;
              width?: any | null;
              height?: any | null;
              format: string;
              responsiveImage?: {
                __typename?: 'ResponsiveImage';
                aspectRatio: any;
                base64?: string | null;
                bgColor?: string | null;
                height: any;
                sizes: string;
                src: string;
                srcSet: string;
                webpSrcSet: string;
                width: any;
              } | null;
            } | null;
            imageLoad?: {
              __typename?: 'FileField';
              alt?: string | null;
              title?: string | null;
              url: string;
              blurUpThumb?: string | null;
              focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
              colors: Array<{ __typename?: 'ColorField'; hex: string }>;
            } | null;
          }>;
        }
      | {
          __typename?: 'BulletListRecord';
          id: any;
          bullets?: string | null;
          numberedList?: any | null;
          title?: string | null;
        }
      | {
          __typename?: 'DocumentLinkBlockRecord';
          id: any;
          documents: Array<{
            __typename?: 'FileField';
            alt?: string | null;
            filename: string;
            format: string;
            size: any;
            title?: string | null;
            url: string;
            uploadId: any;
          }>;
        }
      | {
          __typename?: 'EmployeeRecord';
          id: any;
          name?: string | null;
          title?: string | null;
          introText?: string | null;
          description?: string | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
        }
      | {
          __typename?: 'HeroBlockRecord';
          id: any;
          title?: string | null;
          description?: string | null;
          ctaText?: string | null;
          ctaUrl?: string | null;
          fullWidth?: any | null;
          boxColor?: { __typename?: 'ColorField'; hex: string } | null;
          textColor?: { __typename?: 'ColorField'; hex: string } | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
          imageOverlay?: {
            __typename?: 'OverlayRecord';
            id: any;
            opacity?: any | null;
            color?: { __typename?: 'ColorField'; hex: string } | null;
          } | null;
          ctaButtons: Array<{
            __typename?: 'CtaButtonRecord';
            id: any;
            text?: string | null;
            url?: string | null;
            variant?: string | null;
          }>;
          video?: {
            __typename?: 'FileField';
            blurUpThumb?: string | null;
            title?: string | null;
            alt?: string | null;
            video?: {
              __typename?: 'UploadVideoField';
              muxPlaybackId: string;
              width: any;
              height: any;
            } | null;
          } | null;
        }
      | {
          __typename?: 'ImageRecord';
          id: any;
          fullWidth?: any | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageLoad?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
        }
      | { __typename?: 'JobsListBlockRecord'; id: any; title?: string | null }
      | {
          __typename?: 'NewsAndReportsListBlockRecord';
          newsTitle?: string | null;
          reportsTitle?: string | null;
          newsImage?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
          news: Array<{
            __typename?: 'NewsPageRecord';
            id: any;
            title?: string | null;
            slug?: string | null;
            publishDate?: any | null;
            category?: string | null;
          }>;
          reportsImage?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
          reports: Array<{
            __typename?: 'ReportsListingRecord';
            id: any;
            title?: string | null;
            slug?: string | null;
            publishDate?: any | null;
            category?: string | null;
            pdf?: {
              __typename?: 'FileField';
              alt?: string | null;
              filename: string;
              format: string;
              size: any;
              title?: string | null;
              url: string;
              uploadId: any;
            } | null;
          }>;
        }
      | {
          __typename?: 'NewsListBlockRecord';
          id: any;
          title?: string | null;
          standalone?: any | null;
          largeTitle?: any | null;
          itemsToShow?: any | null;
        }
      | {
          __typename?: 'OfficesBlockRecord';
          id: any;
          offices: Array<{
            __typename?: 'OfficeRecord';
            id: any;
            name?: string | null;
            address?: string | null;
            zipCode?: string | null;
            city?: string | null;
            country?: string | null;
            email?: string | null;
            websiteUrl?: string | null;
            phoneNumber?: string | null;
          }>;
        }
      | {
          __typename?: 'PlugBlockRecord';
          id: any;
          title?: string | null;
          description?: string | null;
          brands: Array<{
            __typename?: 'BrandPageRecord';
            id: any;
            brandName?: string | null;
            slug?: string | null;
            image?: {
              __typename?: 'FileField';
              alt?: string | null;
              tags: Array<string>;
              title?: string | null;
              url: string;
              width?: any | null;
              height?: any | null;
              format: string;
              responsiveImage?: {
                __typename?: 'ResponsiveImage';
                aspectRatio: any;
                base64?: string | null;
                bgColor?: string | null;
                height: any;
                sizes: string;
                src: string;
                srcSet: string;
                webpSrcSet: string;
                width: any;
              } | null;
            } | null;
            imageLoad?: {
              __typename?: 'FileField';
              alt?: string | null;
              title?: string | null;
              url: string;
              blurUpThumb?: string | null;
              focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
              colors: Array<{ __typename?: 'ColorField'; hex: string }>;
            } | null;
          }>;
        }
      | {
          __typename?: 'ReportsListBlockRecord';
          id: any;
          title?: string | null;
          standalone?: any | null;
          largeTitle?: any | null;
        }
      | {
          __typename?: 'SimpleTitleAndTextBlockRecord';
          id: any;
          title?: string | null;
          topLabel?: string | null;
          description?: string | null;
        }
      | {
          __typename?: 'SliderBlockRecord';
          title?: string | null;
          arrows?: any | null;
          slideAnimation?: any | null;
          delay?: any | null;
          dots?: any | null;
          heroes: Array<{
            __typename?: 'HeroBlockRecord';
            id: any;
            title?: string | null;
            description?: string | null;
            ctaText?: string | null;
            ctaUrl?: string | null;
            fullWidth?: any | null;
            boxColor?: { __typename?: 'ColorField'; hex: string } | null;
            textColor?: { __typename?: 'ColorField'; hex: string } | null;
            image?: {
              __typename?: 'FileField';
              alt?: string | null;
              title?: string | null;
              url: string;
              blurUpThumb?: string | null;
              focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
              colors: Array<{ __typename?: 'ColorField'; hex: string }>;
            } | null;
            imageOverlay?: {
              __typename?: 'OverlayRecord';
              id: any;
              opacity?: any | null;
              color?: { __typename?: 'ColorField'; hex: string } | null;
            } | null;
            ctaButtons: Array<{
              __typename?: 'CtaButtonRecord';
              id: any;
              text?: string | null;
              url?: string | null;
              variant?: string | null;
            }>;
            video?: {
              __typename?: 'FileField';
              blurUpThumb?: string | null;
              title?: string | null;
              alt?: string | null;
              video?: {
                __typename?: 'UploadVideoField';
                muxPlaybackId: string;
                width: any;
                height: any;
              } | null;
            } | null;
          }>;
        }
      | {
          __typename?: 'StatementBlockRecord';
          id: any;
          text?: string | null;
          blackBackground?: any | null;
          header?: string | null;
          small?: any | null;
          linkText?: string | null;
          linkUrl?: string | null;
          imageMobile?: {
            __typename?: 'FileField';
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageTablet?: {
            __typename?: 'FileField';
            alt?: string | null;
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageDesktop?: {
            __typename?: 'FileField';
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageLoad?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
          imageOverlay?: {
            __typename?: 'OverlayRecord';
            id: any;
            opacity?: any | null;
            color?: { __typename?: 'ColorField'; hex: string } | null;
          } | null;
        }
      | {
          __typename?: 'TextBlockRecord';
          id: any;
          smallHeader?: any | null;
          header?: string | null;
          text?: string | null;
          introText?: string | null;
          ctaButtons: Array<{
            __typename?: 'CtaButtonRecord';
            id: any;
            text?: string | null;
            url?: string | null;
            variant?: string | null;
          }>;
        }
      | {
          __typename?: 'TwoColumnImageAndTextRecord';
          id: any;
          text?: string | null;
          title?: string | null;
          reverse?: any | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageLoad?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
        }
      | {
          __typename?: 'TwoColumnTextIntroRecord';
          id: any;
          introText?: string | null;
          text?: string | null;
          header?: string | null;
        }
      | {
          __typename?: 'VideoRecord';
          id: any;
          autoplay?: any | null;
          video?: {
            __typename?: 'FileField';
            title?: string | null;
            video?: {
              __typename?: 'UploadVideoField';
              mp4Url?: string | null;
              streamingUrl: string;
              thumbnailUrl: string;
              mp4Low?: string | null;
            } | null;
          } | null;
          videoThumbnail?: {
            __typename?: 'FileField';
            alt?: string | null;
            tags: Array<string>;
            title?: string | null;
            url: string;
            width?: any | null;
            height?: any | null;
            format: string;
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          muxVideo?: {
            __typename?: 'FileField';
            blurUpThumb?: string | null;
            title?: string | null;
            alt?: string | null;
            video?: {
              __typename?: 'UploadVideoField';
              muxPlaybackId: string;
              width: any;
              height: any;
            } | null;
          } | null;
        }
    >;
  } | null;
  globalContent?: {
    __typename?: 'GlobalRecord';
    changeLanguage?: string | null;
    closeLabel?: string | null;
    deadline?: string | null;
    errorMessage?: string | null;
    loading?: string | null;
    loadMoreNews?: string | null;
    localWebLabel?: string | null;
    menu?: string | null;
    moreNewsCta?: string | null;
    moreNewsHeader?: string | null;
    partnerPortalLabel?: string | null;
    partnerPortalUrl?: string | null;
    play?: string | null;
    shopLinkTitle?: string | null;
    shopLinkUrl?: string | null;
    showMoreJobsLabel?: string | null;
    viewOnMapLabel?: string | null;
    nextLabel?: string | null;
    previousLabel?: string | null;
    sliderNavigationLabel?: string | null;
    moreReportsCta?: string | null;
    loadMoreReports?: string | null;
    clearIconLabel?: string | null;
    searchIconLabel?: string | null;
    searchBoxPlaceholder?: string | null;
    viewAllButtonLabel?: string | null;
    searchResultsPageTitle?: string | null;
    firstPageLabel?: string | null;
    previousPageLabel?: string | null;
    nextPageLabel?: string | null;
    lastPageLabel?: string | null;
    goToPageLabel?: string | null;
    searchResultCount?: string | null;
    noSearchResults?: string | null;
    navigationLogo?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      responsiveImage?: {
        __typename?: 'ResponsiveImage';
        aspectRatio: any;
        base64?: string | null;
        bgColor?: string | null;
        height: any;
        sizes: string;
        src: string;
        srcSet: string;
        webpSrcSet: string;
        width: any;
      } | null;
    } | null;
    languages: Array<{
      __typename?: 'LanguageRecord';
      name?: string | null;
      url?: string | null;
      flag?: string | null;
      symbol?: {
        __typename?: 'FileField';
        alt?: string | null;
        tags: Array<string>;
        title?: string | null;
        url: string;
        width?: any | null;
        height?: any | null;
        format: string;
      } | null;
    }>;
  } | null;
  featureToggle?: {
    __typename?: 'FeatureToggleRecord';
    landingPageContentArea?: any | null;
    newsPageContentArea?: any | null;
  } | null;
  menu?: {
    __typename?: 'MenuRecord';
    menuItems: Array<{
      __typename?: 'MenuItemRecord';
      id: any;
      title?: string | null;
      url?: string | null;
      submenu?: {
        __typename?: 'SubmenuRecord';
        title?: string | null;
        menuItems: Array<{
          __typename?: 'ItemRecord';
          title?: string | null;
          pageLink?:
            | { __typename?: 'AboutUsPageRecord'; slug?: string | null }
            | { __typename?: 'BrandPageRecord'; slug?: string | null }
            | { __typename?: 'SustainabilityPageRecord'; slug?: string | null }
            | null;
        }>;
      } | null;
    }>;
  } | null;
  footer?: {
    __typename?: 'FooterRecord';
    bottomIntro?: string | null;
    cookieSettings?: string | null;
    introText?: string | null;
    moreInfoText?: string | null;
    partnerLogin?: string | null;
    selectCountryLabel?: string | null;
    socialMediaLabel?: string | null;
    useNewFooter?: any | null;
    footerLogo?: {
      __typename?: 'FileField';
      alt?: string | null;
      tags: Array<string>;
      title?: string | null;
      url: string;
      width?: any | null;
      height?: any | null;
      format: string;
    } | null;
    hultaforsBrands: Array<{
      __typename?: 'LinkRecord';
      id: any;
      title?: string | null;
      url?: string | null;
    }>;
    menu: Array<{
      __typename?: 'LinkRecord';
      id: any;
      title?: string | null;
      url?: string | null;
    }>;
    menuItems: Array<{
      __typename?: 'FooterMenuItemRecord';
      heading?: string | null;
      includeCookieToggle?: any | null;
      links: Array<{
        __typename?: 'LinkRecord';
        url?: string | null;
        title?: string | null;
      }>;
    }>;
    socialMediaMenu: Array<{
      __typename?: 'IconLinkRecord';
      url?: string | null;
      icon?: {
        __typename?: 'FileField';
        alt?: string | null;
        tags: Array<string>;
        title?: string | null;
        url: string;
        width?: any | null;
        height?: any | null;
        format: string;
      } | null;
    }>;
  } | null;
};

export type ReportsListingQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  locale?: InputMaybe<SiteLocale>;
  numberOfRelated?: InputMaybe<Scalars['IntType']['input']>;
}>;

export type ReportsListingQuery = {
  __typename?: 'Query';
  reportsListing?: {
    __typename?: 'ReportsListingRecord';
    id: any;
    title?: string | null;
    slug?: string | null;
    publishDate?: any | null;
    category?: string | null;
    pageLocales: Array<SiteLocale>;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
    pdf?: {
      __typename?: 'FileField';
      alt?: string | null;
      filename: string;
      format: string;
      size: any;
      title?: string | null;
      url: string;
      uploadId: any;
    } | null;
    seo?: {
      __typename?: 'SeoField';
      description?: string | null;
      title?: string | null;
      image?: {
        __typename?: 'FileField';
        url: string;
        alt?: string | null;
        title?: string | null;
      } | null;
    } | null;
  } | null;
  allReportsListings: Array<{
    __typename?: 'ReportsListingRecord';
    id: any;
    slug?: string | null;
    title?: string | null;
    publishDate?: any | null;
    category?: string | null;
    country?: string | null;
    image?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      blurUpThumb?: string | null;
      focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
      colors: Array<{ __typename?: 'ColorField'; hex: string }>;
    } | null;
    pdf?: {
      __typename?: 'FileField';
      alt?: string | null;
      filename: string;
      format: string;
      size: any;
      title?: string | null;
      url: string;
      uploadId: any;
    } | null;
  }>;
  _allReportsListingsMeta: { __typename?: 'CollectionMetadata'; count: any };
  globalContent?: {
    __typename?: 'GlobalRecord';
    changeLanguage?: string | null;
    closeLabel?: string | null;
    deadline?: string | null;
    errorMessage?: string | null;
    loading?: string | null;
    loadMoreNews?: string | null;
    localWebLabel?: string | null;
    menu?: string | null;
    moreNewsCta?: string | null;
    moreNewsHeader?: string | null;
    partnerPortalLabel?: string | null;
    partnerPortalUrl?: string | null;
    play?: string | null;
    shopLinkTitle?: string | null;
    shopLinkUrl?: string | null;
    showMoreJobsLabel?: string | null;
    viewOnMapLabel?: string | null;
    nextLabel?: string | null;
    previousLabel?: string | null;
    sliderNavigationLabel?: string | null;
    moreReportsCta?: string | null;
    loadMoreReports?: string | null;
    clearIconLabel?: string | null;
    searchIconLabel?: string | null;
    searchBoxPlaceholder?: string | null;
    viewAllButtonLabel?: string | null;
    searchResultsPageTitle?: string | null;
    firstPageLabel?: string | null;
    previousPageLabel?: string | null;
    nextPageLabel?: string | null;
    lastPageLabel?: string | null;
    goToPageLabel?: string | null;
    searchResultCount?: string | null;
    noSearchResults?: string | null;
    navigationLogo?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      responsiveImage?: {
        __typename?: 'ResponsiveImage';
        aspectRatio: any;
        base64?: string | null;
        bgColor?: string | null;
        height: any;
        sizes: string;
        src: string;
        srcSet: string;
        webpSrcSet: string;
        width: any;
      } | null;
    } | null;
    languages: Array<{
      __typename?: 'LanguageRecord';
      name?: string | null;
      url?: string | null;
      flag?: string | null;
      symbol?: {
        __typename?: 'FileField';
        alt?: string | null;
        tags: Array<string>;
        title?: string | null;
        url: string;
        width?: any | null;
        height?: any | null;
        format: string;
      } | null;
    }>;
  } | null;
  featureToggle?: {
    __typename?: 'FeatureToggleRecord';
    landingPageContentArea?: any | null;
    newsPageContentArea?: any | null;
  } | null;
  menu?: {
    __typename?: 'MenuRecord';
    menuItems: Array<{
      __typename?: 'MenuItemRecord';
      id: any;
      title?: string | null;
      url?: string | null;
      submenu?: {
        __typename?: 'SubmenuRecord';
        title?: string | null;
        menuItems: Array<{
          __typename?: 'ItemRecord';
          title?: string | null;
          pageLink?:
            | { __typename?: 'AboutUsPageRecord'; slug?: string | null }
            | { __typename?: 'BrandPageRecord'; slug?: string | null }
            | { __typename?: 'SustainabilityPageRecord'; slug?: string | null }
            | null;
        }>;
      } | null;
    }>;
  } | null;
  footer?: {
    __typename?: 'FooterRecord';
    bottomIntro?: string | null;
    cookieSettings?: string | null;
    introText?: string | null;
    moreInfoText?: string | null;
    partnerLogin?: string | null;
    selectCountryLabel?: string | null;
    socialMediaLabel?: string | null;
    useNewFooter?: any | null;
    footerLogo?: {
      __typename?: 'FileField';
      alt?: string | null;
      tags: Array<string>;
      title?: string | null;
      url: string;
      width?: any | null;
      height?: any | null;
      format: string;
    } | null;
    hultaforsBrands: Array<{
      __typename?: 'LinkRecord';
      id: any;
      title?: string | null;
      url?: string | null;
    }>;
    menu: Array<{
      __typename?: 'LinkRecord';
      id: any;
      title?: string | null;
      url?: string | null;
    }>;
    menuItems: Array<{
      __typename?: 'FooterMenuItemRecord';
      heading?: string | null;
      includeCookieToggle?: any | null;
      links: Array<{
        __typename?: 'LinkRecord';
        url?: string | null;
        title?: string | null;
      }>;
    }>;
    socialMediaMenu: Array<{
      __typename?: 'IconLinkRecord';
      url?: string | null;
      icon?: {
        __typename?: 'FileField';
        alt?: string | null;
        tags: Array<string>;
        title?: string | null;
        url: string;
        width?: any | null;
        height?: any | null;
        format: string;
      } | null;
    }>;
  } | null;
};

export type SiteLocaleQueryVariables = Exact<{
  locale?: InputMaybe<SiteLocale>;
}>;

export type SiteLocaleQuery = {
  __typename?: 'Query';
  siteLocale?: { __typename?: 'SiteLocaleRecord'; enabled?: any | null } | null;
};

export type SitemapQueryVariables = Exact<{
  locale?: InputMaybe<SiteLocale>;
}>;

export type SitemapQuery = {
  __typename?: 'Query';
  landingPage?: { __typename?: 'LandingPageRecord'; _updatedAt: any } | null;
  contactPage?: { __typename?: 'ContactPageRecord'; _updatedAt: any } | null;
  office?: { __typename?: 'OfficeRecord'; _updatedAt: any } | null;
  newsListPage?: { __typename?: 'NewsListPageRecord'; _updatedAt: any } | null;
  newsPage?: { __typename?: 'NewsPageRecord'; _updatedAt: any } | null;
  jobOpportunitiesListPage?: {
    __typename?: 'JobOpportunitiesListPageRecord';
    _updatedAt: any;
  } | null;
  jobOpportunitiesPage?: {
    __typename?: 'JobOpportunitiesPageRecord';
    _updatedAt: any;
  } | null;
  allNewsPages: Array<{
    __typename?: 'NewsPageRecord';
    slug?: string | null;
    _updatedAt: any;
  }>;
  allReportsListings: Array<{
    __typename?: 'ReportsListingRecord';
    slug?: string | null;
    _updatedAt: any;
  }>;
  allJobOpportunitiesPages: Array<{
    __typename?: 'JobOpportunitiesPageRecord';
    slug?: string | null;
    _updatedAt: any;
  }>;
  allBrandPages: Array<{
    __typename?: 'BrandPageRecord';
    slug?: string | null;
    _updatedAt: any;
  }>;
  allAboutUsPages: Array<{
    __typename?: 'AboutUsPageRecord';
    slug?: string | null;
    _updatedAt: any;
  }>;
  allSustainabilityPages: Array<{
    __typename?: 'SustainabilityPageRecord';
    slug?: string | null;
    _updatedAt: any;
  }>;
};

export type StaticPathsAllAboutUsPagesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type StaticPathsAllAboutUsPagesQuery = {
  __typename?: 'Query';
  allAboutUsPages: Array<{
    __typename?: 'AboutUsPageRecord';
    slug?: string | null;
    _locales: Array<SiteLocale>;
  }>;
};

export type StaticPathsAllBrandPagesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type StaticPathsAllBrandPagesQuery = {
  __typename?: 'Query';
  allBrandPages: Array<{
    __typename?: 'BrandPageRecord';
    slug?: string | null;
    _locales: Array<SiteLocale>;
  }>;
};

export type StaticPathsAllCampaignPagesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type StaticPathsAllCampaignPagesQuery = {
  __typename?: 'Query';
  allCampaignPages: Array<{
    __typename?: 'CampaignPageRecord';
    slug?: string | null;
    _locales: Array<SiteLocale>;
  }>;
};

export type StaticPathsAllJobOpportunitiesPagesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type StaticPathsAllJobOpportunitiesPagesQuery = {
  __typename?: 'Query';
  allJobOpportunitiesPages: Array<{
    __typename?: 'JobOpportunitiesPageRecord';
    slug?: string | null;
    _locales: Array<SiteLocale>;
  }>;
};

export type StaticPathsAllNewsPagesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type StaticPathsAllNewsPagesQuery = {
  __typename?: 'Query';
  allNewsPages: Array<{
    __typename?: 'NewsPageRecord';
    slug?: string | null;
    _locales: Array<SiteLocale>;
  }>;
};

export type StaticPathsAllReportsListingsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type StaticPathsAllReportsListingsQuery = {
  __typename?: 'Query';
  allReportsListings: Array<{
    __typename?: 'ReportsListingRecord';
    slug?: string | null;
    _locales: Array<SiteLocale>;
  }>;
};

export type StaticPathsAllSustainabilityPagesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type StaticPathsAllSustainabilityPagesQuery = {
  __typename?: 'Query';
  allSustainabilityPages: Array<{
    __typename?: 'SustainabilityPageRecord';
    slug?: string | null;
    _locales: Array<SiteLocale>;
  }>;
};

export type SustainabilityIndexPageQueryVariables = Exact<{
  locale?: InputMaybe<SiteLocale>;
}>;

export type SustainabilityIndexPageQuery = {
  __typename?: 'Query';
  sustainabilityIndexPage?: {
    __typename?: 'SustainabilityIndexPageRecord';
    id: any;
    pageLocales: Array<SiteLocale>;
    seo?: {
      __typename?: 'SeoField';
      description?: string | null;
      title?: string | null;
      image?: {
        __typename?: 'FileField';
        url: string;
        alt?: string | null;
        title?: string | null;
      } | null;
    } | null;
    contentArea: Array<
      | {
          __typename?: 'ArticlesBlockRecord';
          id: any;
          title?: string | null;
          isJobArticles?: any | null;
          ctaText?: string | null;
          ctaUrl?: string | null;
          jobPages: Array<{
            __typename?: 'JobOpportunitiesPageRecord';
            id: any;
            slug?: string | null;
            title?: string | null;
            publishDate?: any | null;
            category?: string | null;
            country?: string | null;
            department?: string | null;
          }>;
          newsPages: Array<{
            __typename?: 'NewsPageRecord';
            id: any;
            slug?: string | null;
            title?: string | null;
            publishDate?: any | null;
            category?: string | null;
            country?: string | null;
            image?: {
              __typename?: 'FileField';
              alt?: string | null;
              title?: string | null;
              url: string;
              blurUpThumb?: string | null;
              focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
              colors: Array<{ __typename?: 'ColorField'; hex: string }>;
            } | null;
          }>;
          reportPages: Array<{
            __typename?: 'ReportsListingRecord';
            id: any;
            slug?: string | null;
            title?: string | null;
            publishDate?: any | null;
            category?: string | null;
            country?: string | null;
            image?: {
              __typename?: 'FileField';
              alt?: string | null;
              title?: string | null;
              url: string;
              blurUpThumb?: string | null;
              focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
              colors: Array<{ __typename?: 'ColorField'; hex: string }>;
            } | null;
            pdf?: {
              __typename?: 'FileField';
              alt?: string | null;
              filename: string;
              format: string;
              size: any;
              title?: string | null;
              url: string;
              uploadId: any;
            } | null;
          }>;
        }
      | {
          __typename?: 'BrandsBlockRecord';
          id: any;
          title?: string | null;
          introText?: string | null;
          hideLabels?: any | null;
          brands: Array<{
            __typename?: 'BrandPageRecord';
            id: any;
            brandName?: string | null;
            slug?: string | null;
            image?: {
              __typename?: 'FileField';
              alt?: string | null;
              tags: Array<string>;
              title?: string | null;
              url: string;
              width?: any | null;
              height?: any | null;
              format: string;
              responsiveImage?: {
                __typename?: 'ResponsiveImage';
                aspectRatio: any;
                base64?: string | null;
                bgColor?: string | null;
                height: any;
                sizes: string;
                src: string;
                srcSet: string;
                webpSrcSet: string;
                width: any;
              } | null;
            } | null;
            imageLoad?: {
              __typename?: 'FileField';
              alt?: string | null;
              title?: string | null;
              url: string;
              blurUpThumb?: string | null;
              focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
              colors: Array<{ __typename?: 'ColorField'; hex: string }>;
            } | null;
          }>;
        }
      | {
          __typename?: 'BulletListRecord';
          id: any;
          bullets?: string | null;
          numberedList?: any | null;
          title?: string | null;
        }
      | {
          __typename?: 'DocumentLinkBlockRecord';
          id: any;
          documents: Array<{
            __typename?: 'FileField';
            alt?: string | null;
            filename: string;
            format: string;
            size: any;
            title?: string | null;
            url: string;
            uploadId: any;
          }>;
        }
      | {
          __typename?: 'EmployeeRecord';
          id: any;
          name?: string | null;
          title?: string | null;
          introText?: string | null;
          description?: string | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
        }
      | {
          __typename?: 'GridContainerBlockRecord';
          id: any;
          fullwidth?: any | null;
          gap?: any | null;
          backgroundColor?: { __typename?: 'ColorField'; hex: string } | null;
          textColor?: { __typename?: 'ColorField'; hex: string } | null;
          content: Array<
            | {
                __typename?: 'GridFourcolBlockRecord';
                id: any;
                content: Array<
                  | {
                      __typename?: 'ImageRecord';
                      id: any;
                      fullWidth?: any | null;
                      image?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        responsiveImage?: {
                          __typename?: 'ResponsiveImage';
                          aspectRatio: any;
                          base64?: string | null;
                          bgColor?: string | null;
                          height: any;
                          sizes: string;
                          src: string;
                          srcSet: string;
                          webpSrcSet: string;
                          width: any;
                        } | null;
                      } | null;
                      imageLoad?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        title?: string | null;
                        url: string;
                        blurUpThumb?: string | null;
                        focalPoint?: {
                          __typename?: 'focalPoint';
                          x: any;
                          y: any;
                        } | null;
                        colors: Array<{
                          __typename?: 'ColorField';
                          hex: string;
                        }>;
                      } | null;
                    }
                  | {
                      __typename?: 'MediaWithCaptionRecord';
                      id: any;
                      centerText?: any | null;
                      textOnImage?: any | null;
                      media?: {
                        __typename?: 'ImageRecord';
                        id: any;
                        fullWidth?: any | null;
                        image?: {
                          __typename?: 'FileField';
                          alt?: string | null;
                          responsiveImage?: {
                            __typename?: 'ResponsiveImage';
                            aspectRatio: any;
                            base64?: string | null;
                            bgColor?: string | null;
                            height: any;
                            sizes: string;
                            src: string;
                            srcSet: string;
                            webpSrcSet: string;
                            width: any;
                          } | null;
                        } | null;
                        imageLoad?: {
                          __typename?: 'FileField';
                          alt?: string | null;
                          title?: string | null;
                          url: string;
                          blurUpThumb?: string | null;
                          focalPoint?: {
                            __typename?: 'focalPoint';
                            x: any;
                            y: any;
                          } | null;
                          colors: Array<{
                            __typename?: 'ColorField';
                            hex: string;
                          }>;
                        } | null;
                      } | null;
                      caption?: {
                        __typename?: 'TextBlockRecord';
                        id: any;
                        smallHeader?: any | null;
                        header?: string | null;
                        text?: string | null;
                        introText?: string | null;
                        ctaButtons: Array<{
                          __typename?: 'CtaButtonRecord';
                          id: any;
                          text?: string | null;
                          url?: string | null;
                          variant?: string | null;
                        }>;
                      } | null;
                    }
                  | {
                      __typename?: 'TextBlockRecord';
                      id: any;
                      smallHeader?: any | null;
                      header?: string | null;
                      text?: string | null;
                      introText?: string | null;
                      ctaButtons: Array<{
                        __typename?: 'CtaButtonRecord';
                        id: any;
                        text?: string | null;
                        url?: string | null;
                        variant?: string | null;
                      }>;
                    }
                >;
              }
            | {
                __typename?: 'GridThreecolBlockRecord';
                id: any;
                content: Array<
                  | {
                      __typename?: 'GridTwocolBlockRecord';
                      id: any;
                      content: Array<
                        | {
                            __typename?: 'ImageRecord';
                            id: any;
                            fullWidth?: any | null;
                            image?: {
                              __typename?: 'FileField';
                              alt?: string | null;
                              responsiveImage?: {
                                __typename?: 'ResponsiveImage';
                                aspectRatio: any;
                                base64?: string | null;
                                bgColor?: string | null;
                                height: any;
                                sizes: string;
                                src: string;
                                srcSet: string;
                                webpSrcSet: string;
                                width: any;
                              } | null;
                            } | null;
                            imageLoad?: {
                              __typename?: 'FileField';
                              alt?: string | null;
                              title?: string | null;
                              url: string;
                              blurUpThumb?: string | null;
                              focalPoint?: {
                                __typename?: 'focalPoint';
                                x: any;
                                y: any;
                              } | null;
                              colors: Array<{
                                __typename?: 'ColorField';
                                hex: string;
                              }>;
                            } | null;
                          }
                        | {
                            __typename?: 'MediaWithCaptionRecord';
                            id: any;
                            centerText?: any | null;
                            textOnImage?: any | null;
                            media?: {
                              __typename?: 'ImageRecord';
                              id: any;
                              fullWidth?: any | null;
                              image?: {
                                __typename?: 'FileField';
                                alt?: string | null;
                                responsiveImage?: {
                                  __typename?: 'ResponsiveImage';
                                  aspectRatio: any;
                                  base64?: string | null;
                                  bgColor?: string | null;
                                  height: any;
                                  sizes: string;
                                  src: string;
                                  srcSet: string;
                                  webpSrcSet: string;
                                  width: any;
                                } | null;
                              } | null;
                              imageLoad?: {
                                __typename?: 'FileField';
                                alt?: string | null;
                                title?: string | null;
                                url: string;
                                blurUpThumb?: string | null;
                                focalPoint?: {
                                  __typename?: 'focalPoint';
                                  x: any;
                                  y: any;
                                } | null;
                                colors: Array<{
                                  __typename?: 'ColorField';
                                  hex: string;
                                }>;
                              } | null;
                            } | null;
                            caption?: {
                              __typename?: 'TextBlockRecord';
                              id: any;
                              smallHeader?: any | null;
                              header?: string | null;
                              text?: string | null;
                              introText?: string | null;
                              ctaButtons: Array<{
                                __typename?: 'CtaButtonRecord';
                                id: any;
                                text?: string | null;
                                url?: string | null;
                                variant?: string | null;
                              }>;
                            } | null;
                          }
                        | {
                            __typename?: 'NewsListBlockRecord';
                            id: any;
                            title?: string | null;
                            standalone?: any | null;
                            largeTitle?: any | null;
                            itemsToShow?: any | null;
                          }
                        | {
                            __typename?: 'ReportsListBlockRecord';
                            id: any;
                            title?: string | null;
                            standalone?: any | null;
                            largeTitle?: any | null;
                          }
                        | {
                            __typename?: 'TextBlockRecord';
                            id: any;
                            smallHeader?: any | null;
                            header?: string | null;
                            text?: string | null;
                            introText?: string | null;
                            ctaButtons: Array<{
                              __typename?: 'CtaButtonRecord';
                              id: any;
                              text?: string | null;
                              url?: string | null;
                              variant?: string | null;
                            }>;
                          }
                      >;
                    }
                  | {
                      __typename?: 'ImageRecord';
                      id: any;
                      fullWidth?: any | null;
                      image?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        responsiveImage?: {
                          __typename?: 'ResponsiveImage';
                          aspectRatio: any;
                          base64?: string | null;
                          bgColor?: string | null;
                          height: any;
                          sizes: string;
                          src: string;
                          srcSet: string;
                          webpSrcSet: string;
                          width: any;
                        } | null;
                      } | null;
                      imageLoad?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        title?: string | null;
                        url: string;
                        blurUpThumb?: string | null;
                        focalPoint?: {
                          __typename?: 'focalPoint';
                          x: any;
                          y: any;
                        } | null;
                        colors: Array<{
                          __typename?: 'ColorField';
                          hex: string;
                        }>;
                      } | null;
                    }
                  | {
                      __typename?: 'MediaWithCaptionRecord';
                      id: any;
                      centerText?: any | null;
                      textOnImage?: any | null;
                      media?: {
                        __typename?: 'ImageRecord';
                        id: any;
                        fullWidth?: any | null;
                        image?: {
                          __typename?: 'FileField';
                          alt?: string | null;
                          responsiveImage?: {
                            __typename?: 'ResponsiveImage';
                            aspectRatio: any;
                            base64?: string | null;
                            bgColor?: string | null;
                            height: any;
                            sizes: string;
                            src: string;
                            srcSet: string;
                            webpSrcSet: string;
                            width: any;
                          } | null;
                        } | null;
                        imageLoad?: {
                          __typename?: 'FileField';
                          alt?: string | null;
                          title?: string | null;
                          url: string;
                          blurUpThumb?: string | null;
                          focalPoint?: {
                            __typename?: 'focalPoint';
                            x: any;
                            y: any;
                          } | null;
                          colors: Array<{
                            __typename?: 'ColorField';
                            hex: string;
                          }>;
                        } | null;
                      } | null;
                      caption?: {
                        __typename?: 'TextBlockRecord';
                        id: any;
                        smallHeader?: any | null;
                        header?: string | null;
                        text?: string | null;
                        introText?: string | null;
                        ctaButtons: Array<{
                          __typename?: 'CtaButtonRecord';
                          id: any;
                          text?: string | null;
                          url?: string | null;
                          variant?: string | null;
                        }>;
                      } | null;
                    }
                  | {
                      __typename?: 'TextBlockRecord';
                      id: any;
                      smallHeader?: any | null;
                      header?: string | null;
                      text?: string | null;
                      introText?: string | null;
                      ctaButtons: Array<{
                        __typename?: 'CtaButtonRecord';
                        id: any;
                        text?: string | null;
                        url?: string | null;
                        variant?: string | null;
                      }>;
                    }
                >;
              }
            | {
                __typename?: 'GridTwocolBlockRecord';
                id: any;
                content: Array<
                  | {
                      __typename?: 'ImageRecord';
                      id: any;
                      fullWidth?: any | null;
                      image?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        responsiveImage?: {
                          __typename?: 'ResponsiveImage';
                          aspectRatio: any;
                          base64?: string | null;
                          bgColor?: string | null;
                          height: any;
                          sizes: string;
                          src: string;
                          srcSet: string;
                          webpSrcSet: string;
                          width: any;
                        } | null;
                      } | null;
                      imageLoad?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        title?: string | null;
                        url: string;
                        blurUpThumb?: string | null;
                        focalPoint?: {
                          __typename?: 'focalPoint';
                          x: any;
                          y: any;
                        } | null;
                        colors: Array<{
                          __typename?: 'ColorField';
                          hex: string;
                        }>;
                      } | null;
                    }
                  | {
                      __typename?: 'MediaWithCaptionRecord';
                      id: any;
                      centerText?: any | null;
                      textOnImage?: any | null;
                      media?: {
                        __typename?: 'ImageRecord';
                        id: any;
                        fullWidth?: any | null;
                        image?: {
                          __typename?: 'FileField';
                          alt?: string | null;
                          responsiveImage?: {
                            __typename?: 'ResponsiveImage';
                            aspectRatio: any;
                            base64?: string | null;
                            bgColor?: string | null;
                            height: any;
                            sizes: string;
                            src: string;
                            srcSet: string;
                            webpSrcSet: string;
                            width: any;
                          } | null;
                        } | null;
                        imageLoad?: {
                          __typename?: 'FileField';
                          alt?: string | null;
                          title?: string | null;
                          url: string;
                          blurUpThumb?: string | null;
                          focalPoint?: {
                            __typename?: 'focalPoint';
                            x: any;
                            y: any;
                          } | null;
                          colors: Array<{
                            __typename?: 'ColorField';
                            hex: string;
                          }>;
                        } | null;
                      } | null;
                      caption?: {
                        __typename?: 'TextBlockRecord';
                        id: any;
                        smallHeader?: any | null;
                        header?: string | null;
                        text?: string | null;
                        introText?: string | null;
                        ctaButtons: Array<{
                          __typename?: 'CtaButtonRecord';
                          id: any;
                          text?: string | null;
                          url?: string | null;
                          variant?: string | null;
                        }>;
                      } | null;
                    }
                  | {
                      __typename?: 'NewsListBlockRecord';
                      id: any;
                      title?: string | null;
                      standalone?: any | null;
                      largeTitle?: any | null;
                      itemsToShow?: any | null;
                    }
                  | {
                      __typename?: 'ReportsListBlockRecord';
                      id: any;
                      title?: string | null;
                      standalone?: any | null;
                      largeTitle?: any | null;
                    }
                  | {
                      __typename?: 'TextBlockRecord';
                      id: any;
                      smallHeader?: any | null;
                      header?: string | null;
                      text?: string | null;
                      introText?: string | null;
                      ctaButtons: Array<{
                        __typename?: 'CtaButtonRecord';
                        id: any;
                        text?: string | null;
                        url?: string | null;
                        variant?: string | null;
                      }>;
                    }
                >;
              }
          >;
        }
      | {
          __typename?: 'HeroBlockRecord';
          id: any;
          title?: string | null;
          description?: string | null;
          ctaText?: string | null;
          ctaUrl?: string | null;
          fullWidth?: any | null;
          boxColor?: { __typename?: 'ColorField'; hex: string } | null;
          textColor?: { __typename?: 'ColorField'; hex: string } | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
          imageOverlay?: {
            __typename?: 'OverlayRecord';
            id: any;
            opacity?: any | null;
            color?: { __typename?: 'ColorField'; hex: string } | null;
          } | null;
          ctaButtons: Array<{
            __typename?: 'CtaButtonRecord';
            id: any;
            text?: string | null;
            url?: string | null;
            variant?: string | null;
          }>;
          video?: {
            __typename?: 'FileField';
            blurUpThumb?: string | null;
            title?: string | null;
            alt?: string | null;
            video?: {
              __typename?: 'UploadVideoField';
              muxPlaybackId: string;
              width: any;
              height: any;
            } | null;
          } | null;
        }
      | {
          __typename?: 'ImageRecord';
          id: any;
          fullWidth?: any | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageLoad?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
        }
      | {
          __typename?: 'NewsAndReportsListBlockRecord';
          newsTitle?: string | null;
          reportsTitle?: string | null;
          newsImage?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
          news: Array<{
            __typename?: 'NewsPageRecord';
            id: any;
            title?: string | null;
            slug?: string | null;
            publishDate?: any | null;
            category?: string | null;
          }>;
          reportsImage?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
          reports: Array<{
            __typename?: 'ReportsListingRecord';
            id: any;
            title?: string | null;
            slug?: string | null;
            publishDate?: any | null;
            category?: string | null;
            pdf?: {
              __typename?: 'FileField';
              alt?: string | null;
              filename: string;
              format: string;
              size: any;
              title?: string | null;
              url: string;
              uploadId: any;
            } | null;
          }>;
        }
      | {
          __typename?: 'NewsListBlockRecord';
          id: any;
          title?: string | null;
          standalone?: any | null;
          largeTitle?: any | null;
          itemsToShow?: any | null;
        }
      | {
          __typename?: 'OfficesBlockRecord';
          id: any;
          offices: Array<{
            __typename?: 'OfficeRecord';
            id: any;
            name?: string | null;
            address?: string | null;
            zipCode?: string | null;
            city?: string | null;
            country?: string | null;
            email?: string | null;
            websiteUrl?: string | null;
            phoneNumber?: string | null;
          }>;
        }
      | {
          __typename?: 'PageNavigationBlockRecord';
          id: any;
          label?: string | null;
          links: Array<{
            __typename?: 'LinkRecord';
            id: any;
            title?: string | null;
            url?: string | null;
          }>;
        }
      | {
          __typename?: 'PlugBlockRecord';
          id: any;
          title?: string | null;
          description?: string | null;
          brands: Array<{
            __typename?: 'BrandPageRecord';
            id: any;
            brandName?: string | null;
            slug?: string | null;
            image?: {
              __typename?: 'FileField';
              alt?: string | null;
              tags: Array<string>;
              title?: string | null;
              url: string;
              width?: any | null;
              height?: any | null;
              format: string;
              responsiveImage?: {
                __typename?: 'ResponsiveImage';
                aspectRatio: any;
                base64?: string | null;
                bgColor?: string | null;
                height: any;
                sizes: string;
                src: string;
                srcSet: string;
                webpSrcSet: string;
                width: any;
              } | null;
            } | null;
            imageLoad?: {
              __typename?: 'FileField';
              alt?: string | null;
              title?: string | null;
              url: string;
              blurUpThumb?: string | null;
              focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
              colors: Array<{ __typename?: 'ColorField'; hex: string }>;
            } | null;
          }>;
        }
      | {
          __typename?: 'ReportsListBlockRecord';
          id: any;
          title?: string | null;
          standalone?: any | null;
          largeTitle?: any | null;
        }
      | {
          __typename?: 'SimpleTitleAndTextBlockRecord';
          id: any;
          title?: string | null;
          topLabel?: string | null;
          description?: string | null;
        }
      | {
          __typename?: 'SliderBlockRecord';
          title?: string | null;
          arrows?: any | null;
          slideAnimation?: any | null;
          delay?: any | null;
          dots?: any | null;
          heroes: Array<{
            __typename?: 'HeroBlockRecord';
            id: any;
            title?: string | null;
            description?: string | null;
            ctaText?: string | null;
            ctaUrl?: string | null;
            fullWidth?: any | null;
            boxColor?: { __typename?: 'ColorField'; hex: string } | null;
            textColor?: { __typename?: 'ColorField'; hex: string } | null;
            image?: {
              __typename?: 'FileField';
              alt?: string | null;
              title?: string | null;
              url: string;
              blurUpThumb?: string | null;
              focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
              colors: Array<{ __typename?: 'ColorField'; hex: string }>;
            } | null;
            imageOverlay?: {
              __typename?: 'OverlayRecord';
              id: any;
              opacity?: any | null;
              color?: { __typename?: 'ColorField'; hex: string } | null;
            } | null;
            ctaButtons: Array<{
              __typename?: 'CtaButtonRecord';
              id: any;
              text?: string | null;
              url?: string | null;
              variant?: string | null;
            }>;
            video?: {
              __typename?: 'FileField';
              blurUpThumb?: string | null;
              title?: string | null;
              alt?: string | null;
              video?: {
                __typename?: 'UploadVideoField';
                muxPlaybackId: string;
                width: any;
                height: any;
              } | null;
            } | null;
          }>;
        }
      | {
          __typename?: 'StatementBlockRecord';
          id: any;
          text?: string | null;
          blackBackground?: any | null;
          header?: string | null;
          small?: any | null;
          linkText?: string | null;
          linkUrl?: string | null;
          imageMobile?: {
            __typename?: 'FileField';
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageTablet?: {
            __typename?: 'FileField';
            alt?: string | null;
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageDesktop?: {
            __typename?: 'FileField';
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageLoad?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
          imageOverlay?: {
            __typename?: 'OverlayRecord';
            id: any;
            opacity?: any | null;
            color?: { __typename?: 'ColorField'; hex: string } | null;
          } | null;
        }
      | {
          __typename?: 'SubheadingBlockRecord';
          id: any;
          title?: string | null;
          text?: string | null;
          ctaButton?: {
            __typename?: 'CtaButtonRecord';
            id: any;
            text?: string | null;
            url?: string | null;
            variant?: string | null;
          } | null;
          backgroundColor?: { __typename?: 'ColorField'; hex: string } | null;
        }
      | {
          __typename?: 'SustainabilityReportsBlockRecord';
          id: any;
          title?: string | null;
          reports: Array<{
            __typename?: 'FileField';
            alt?: string | null;
            filename: string;
            format: string;
            size: any;
            title?: string | null;
            url: string;
            uploadId: any;
          }>;
        }
      | {
          __typename?: 'TextBlockRecord';
          id: any;
          smallHeader?: any | null;
          header?: string | null;
          text?: string | null;
          introText?: string | null;
          ctaButtons: Array<{
            __typename?: 'CtaButtonRecord';
            id: any;
            text?: string | null;
            url?: string | null;
            variant?: string | null;
          }>;
        }
      | {
          __typename?: 'TwoColumnImageAndTextRecord';
          id: any;
          text?: string | null;
          title?: string | null;
          reverse?: any | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageLoad?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
        }
      | {
          __typename?: 'TwoColumnTextIntroRecord';
          id: any;
          introText?: string | null;
          text?: string | null;
          header?: string | null;
        }
      | {
          __typename?: 'VideoRecord';
          id: any;
          autoplay?: any | null;
          video?: {
            __typename?: 'FileField';
            title?: string | null;
            video?: {
              __typename?: 'UploadVideoField';
              mp4Url?: string | null;
              streamingUrl: string;
              thumbnailUrl: string;
              mp4Low?: string | null;
            } | null;
          } | null;
          videoThumbnail?: {
            __typename?: 'FileField';
            alt?: string | null;
            tags: Array<string>;
            title?: string | null;
            url: string;
            width?: any | null;
            height?: any | null;
            format: string;
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          muxVideo?: {
            __typename?: 'FileField';
            blurUpThumb?: string | null;
            title?: string | null;
            alt?: string | null;
            video?: {
              __typename?: 'UploadVideoField';
              muxPlaybackId: string;
              width: any;
              height: any;
            } | null;
          } | null;
        }
    >;
  } | null;
  globalContent?: {
    __typename?: 'GlobalRecord';
    changeLanguage?: string | null;
    closeLabel?: string | null;
    deadline?: string | null;
    errorMessage?: string | null;
    loading?: string | null;
    loadMoreNews?: string | null;
    localWebLabel?: string | null;
    menu?: string | null;
    moreNewsCta?: string | null;
    moreNewsHeader?: string | null;
    partnerPortalLabel?: string | null;
    partnerPortalUrl?: string | null;
    play?: string | null;
    shopLinkTitle?: string | null;
    shopLinkUrl?: string | null;
    showMoreJobsLabel?: string | null;
    viewOnMapLabel?: string | null;
    nextLabel?: string | null;
    previousLabel?: string | null;
    sliderNavigationLabel?: string | null;
    moreReportsCta?: string | null;
    loadMoreReports?: string | null;
    clearIconLabel?: string | null;
    searchIconLabel?: string | null;
    searchBoxPlaceholder?: string | null;
    viewAllButtonLabel?: string | null;
    searchResultsPageTitle?: string | null;
    firstPageLabel?: string | null;
    previousPageLabel?: string | null;
    nextPageLabel?: string | null;
    lastPageLabel?: string | null;
    goToPageLabel?: string | null;
    searchResultCount?: string | null;
    noSearchResults?: string | null;
    navigationLogo?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      responsiveImage?: {
        __typename?: 'ResponsiveImage';
        aspectRatio: any;
        base64?: string | null;
        bgColor?: string | null;
        height: any;
        sizes: string;
        src: string;
        srcSet: string;
        webpSrcSet: string;
        width: any;
      } | null;
    } | null;
    languages: Array<{
      __typename?: 'LanguageRecord';
      name?: string | null;
      url?: string | null;
      flag?: string | null;
      symbol?: {
        __typename?: 'FileField';
        alt?: string | null;
        tags: Array<string>;
        title?: string | null;
        url: string;
        width?: any | null;
        height?: any | null;
        format: string;
      } | null;
    }>;
  } | null;
  featureToggle?: {
    __typename?: 'FeatureToggleRecord';
    landingPageContentArea?: any | null;
    newsPageContentArea?: any | null;
  } | null;
  menu?: {
    __typename?: 'MenuRecord';
    menuItems: Array<{
      __typename?: 'MenuItemRecord';
      id: any;
      title?: string | null;
      url?: string | null;
      submenu?: {
        __typename?: 'SubmenuRecord';
        title?: string | null;
        menuItems: Array<{
          __typename?: 'ItemRecord';
          title?: string | null;
          pageLink?:
            | { __typename?: 'AboutUsPageRecord'; slug?: string | null }
            | { __typename?: 'BrandPageRecord'; slug?: string | null }
            | { __typename?: 'SustainabilityPageRecord'; slug?: string | null }
            | null;
        }>;
      } | null;
    }>;
  } | null;
  footer?: {
    __typename?: 'FooterRecord';
    bottomIntro?: string | null;
    cookieSettings?: string | null;
    introText?: string | null;
    moreInfoText?: string | null;
    partnerLogin?: string | null;
    selectCountryLabel?: string | null;
    socialMediaLabel?: string | null;
    useNewFooter?: any | null;
    footerLogo?: {
      __typename?: 'FileField';
      alt?: string | null;
      tags: Array<string>;
      title?: string | null;
      url: string;
      width?: any | null;
      height?: any | null;
      format: string;
    } | null;
    hultaforsBrands: Array<{
      __typename?: 'LinkRecord';
      id: any;
      title?: string | null;
      url?: string | null;
    }>;
    menu: Array<{
      __typename?: 'LinkRecord';
      id: any;
      title?: string | null;
      url?: string | null;
    }>;
    menuItems: Array<{
      __typename?: 'FooterMenuItemRecord';
      heading?: string | null;
      includeCookieToggle?: any | null;
      links: Array<{
        __typename?: 'LinkRecord';
        url?: string | null;
        title?: string | null;
      }>;
    }>;
    socialMediaMenu: Array<{
      __typename?: 'IconLinkRecord';
      url?: string | null;
      icon?: {
        __typename?: 'FileField';
        alt?: string | null;
        tags: Array<string>;
        title?: string | null;
        url: string;
        width?: any | null;
        height?: any | null;
        format: string;
      } | null;
    }>;
  } | null;
};

export type SustainabilityPageQueryVariables = Exact<{
  locale?: InputMaybe<SiteLocale>;
  slug: Scalars['String']['input'];
}>;

export type SustainabilityPageQuery = {
  __typename?: 'Query';
  sustainabilityPage?: {
    __typename?: 'SustainabilityPageRecord';
    id: any;
    pageLocales: Array<SiteLocale>;
    seo?: {
      __typename?: 'SeoField';
      description?: string | null;
      title?: string | null;
      image?: {
        __typename?: 'FileField';
        url: string;
        alt?: string | null;
        title?: string | null;
      } | null;
    } | null;
    contentArea: Array<
      | {
          __typename?: 'ArticlesBlockRecord';
          id: any;
          title?: string | null;
          isJobArticles?: any | null;
          ctaText?: string | null;
          ctaUrl?: string | null;
          jobPages: Array<{
            __typename?: 'JobOpportunitiesPageRecord';
            id: any;
            slug?: string | null;
            title?: string | null;
            publishDate?: any | null;
            category?: string | null;
            country?: string | null;
            department?: string | null;
          }>;
          newsPages: Array<{
            __typename?: 'NewsPageRecord';
            id: any;
            slug?: string | null;
            title?: string | null;
            publishDate?: any | null;
            category?: string | null;
            country?: string | null;
            image?: {
              __typename?: 'FileField';
              alt?: string | null;
              title?: string | null;
              url: string;
              blurUpThumb?: string | null;
              focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
              colors: Array<{ __typename?: 'ColorField'; hex: string }>;
            } | null;
          }>;
          reportPages: Array<{
            __typename?: 'ReportsListingRecord';
            id: any;
            slug?: string | null;
            title?: string | null;
            publishDate?: any | null;
            category?: string | null;
            country?: string | null;
            image?: {
              __typename?: 'FileField';
              alt?: string | null;
              title?: string | null;
              url: string;
              blurUpThumb?: string | null;
              focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
              colors: Array<{ __typename?: 'ColorField'; hex: string }>;
            } | null;
            pdf?: {
              __typename?: 'FileField';
              alt?: string | null;
              filename: string;
              format: string;
              size: any;
              title?: string | null;
              url: string;
              uploadId: any;
            } | null;
          }>;
        }
      | {
          __typename?: 'BrandsBlockRecord';
          id: any;
          title?: string | null;
          introText?: string | null;
          hideLabels?: any | null;
          brands: Array<{
            __typename?: 'BrandPageRecord';
            id: any;
            brandName?: string | null;
            slug?: string | null;
            image?: {
              __typename?: 'FileField';
              alt?: string | null;
              tags: Array<string>;
              title?: string | null;
              url: string;
              width?: any | null;
              height?: any | null;
              format: string;
              responsiveImage?: {
                __typename?: 'ResponsiveImage';
                aspectRatio: any;
                base64?: string | null;
                bgColor?: string | null;
                height: any;
                sizes: string;
                src: string;
                srcSet: string;
                webpSrcSet: string;
                width: any;
              } | null;
            } | null;
            imageLoad?: {
              __typename?: 'FileField';
              alt?: string | null;
              title?: string | null;
              url: string;
              blurUpThumb?: string | null;
              focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
              colors: Array<{ __typename?: 'ColorField'; hex: string }>;
            } | null;
          }>;
        }
      | {
          __typename?: 'BulletListRecord';
          id: any;
          bullets?: string | null;
          numberedList?: any | null;
          title?: string | null;
        }
      | {
          __typename?: 'DocumentLinkBlockRecord';
          id: any;
          documents: Array<{
            __typename?: 'FileField';
            alt?: string | null;
            filename: string;
            format: string;
            size: any;
            title?: string | null;
            url: string;
            uploadId: any;
          }>;
        }
      | {
          __typename?: 'EmployeeRecord';
          id: any;
          name?: string | null;
          title?: string | null;
          introText?: string | null;
          description?: string | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
        }
      | {
          __typename?: 'GridContainerBlockRecord';
          id: any;
          fullwidth?: any | null;
          gap?: any | null;
          backgroundColor?: { __typename?: 'ColorField'; hex: string } | null;
          textColor?: { __typename?: 'ColorField'; hex: string } | null;
          content: Array<
            | {
                __typename?: 'GridFourcolBlockRecord';
                id: any;
                content: Array<
                  | {
                      __typename?: 'ImageRecord';
                      id: any;
                      fullWidth?: any | null;
                      image?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        responsiveImage?: {
                          __typename?: 'ResponsiveImage';
                          aspectRatio: any;
                          base64?: string | null;
                          bgColor?: string | null;
                          height: any;
                          sizes: string;
                          src: string;
                          srcSet: string;
                          webpSrcSet: string;
                          width: any;
                        } | null;
                      } | null;
                      imageLoad?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        title?: string | null;
                        url: string;
                        blurUpThumb?: string | null;
                        focalPoint?: {
                          __typename?: 'focalPoint';
                          x: any;
                          y: any;
                        } | null;
                        colors: Array<{
                          __typename?: 'ColorField';
                          hex: string;
                        }>;
                      } | null;
                    }
                  | {
                      __typename?: 'MediaWithCaptionRecord';
                      id: any;
                      centerText?: any | null;
                      textOnImage?: any | null;
                      media?: {
                        __typename?: 'ImageRecord';
                        id: any;
                        fullWidth?: any | null;
                        image?: {
                          __typename?: 'FileField';
                          alt?: string | null;
                          responsiveImage?: {
                            __typename?: 'ResponsiveImage';
                            aspectRatio: any;
                            base64?: string | null;
                            bgColor?: string | null;
                            height: any;
                            sizes: string;
                            src: string;
                            srcSet: string;
                            webpSrcSet: string;
                            width: any;
                          } | null;
                        } | null;
                        imageLoad?: {
                          __typename?: 'FileField';
                          alt?: string | null;
                          title?: string | null;
                          url: string;
                          blurUpThumb?: string | null;
                          focalPoint?: {
                            __typename?: 'focalPoint';
                            x: any;
                            y: any;
                          } | null;
                          colors: Array<{
                            __typename?: 'ColorField';
                            hex: string;
                          }>;
                        } | null;
                      } | null;
                      caption?: {
                        __typename?: 'TextBlockRecord';
                        id: any;
                        smallHeader?: any | null;
                        header?: string | null;
                        text?: string | null;
                        introText?: string | null;
                        ctaButtons: Array<{
                          __typename?: 'CtaButtonRecord';
                          id: any;
                          text?: string | null;
                          url?: string | null;
                          variant?: string | null;
                        }>;
                      } | null;
                    }
                  | {
                      __typename?: 'TextBlockRecord';
                      id: any;
                      smallHeader?: any | null;
                      header?: string | null;
                      text?: string | null;
                      introText?: string | null;
                      ctaButtons: Array<{
                        __typename?: 'CtaButtonRecord';
                        id: any;
                        text?: string | null;
                        url?: string | null;
                        variant?: string | null;
                      }>;
                    }
                >;
              }
            | {
                __typename?: 'GridThreecolBlockRecord';
                id: any;
                content: Array<
                  | {
                      __typename?: 'GridTwocolBlockRecord';
                      id: any;
                      content: Array<
                        | {
                            __typename?: 'ImageRecord';
                            id: any;
                            fullWidth?: any | null;
                            image?: {
                              __typename?: 'FileField';
                              alt?: string | null;
                              responsiveImage?: {
                                __typename?: 'ResponsiveImage';
                                aspectRatio: any;
                                base64?: string | null;
                                bgColor?: string | null;
                                height: any;
                                sizes: string;
                                src: string;
                                srcSet: string;
                                webpSrcSet: string;
                                width: any;
                              } | null;
                            } | null;
                            imageLoad?: {
                              __typename?: 'FileField';
                              alt?: string | null;
                              title?: string | null;
                              url: string;
                              blurUpThumb?: string | null;
                              focalPoint?: {
                                __typename?: 'focalPoint';
                                x: any;
                                y: any;
                              } | null;
                              colors: Array<{
                                __typename?: 'ColorField';
                                hex: string;
                              }>;
                            } | null;
                          }
                        | {
                            __typename?: 'MediaWithCaptionRecord';
                            id: any;
                            centerText?: any | null;
                            textOnImage?: any | null;
                            media?: {
                              __typename?: 'ImageRecord';
                              id: any;
                              fullWidth?: any | null;
                              image?: {
                                __typename?: 'FileField';
                                alt?: string | null;
                                responsiveImage?: {
                                  __typename?: 'ResponsiveImage';
                                  aspectRatio: any;
                                  base64?: string | null;
                                  bgColor?: string | null;
                                  height: any;
                                  sizes: string;
                                  src: string;
                                  srcSet: string;
                                  webpSrcSet: string;
                                  width: any;
                                } | null;
                              } | null;
                              imageLoad?: {
                                __typename?: 'FileField';
                                alt?: string | null;
                                title?: string | null;
                                url: string;
                                blurUpThumb?: string | null;
                                focalPoint?: {
                                  __typename?: 'focalPoint';
                                  x: any;
                                  y: any;
                                } | null;
                                colors: Array<{
                                  __typename?: 'ColorField';
                                  hex: string;
                                }>;
                              } | null;
                            } | null;
                            caption?: {
                              __typename?: 'TextBlockRecord';
                              id: any;
                              smallHeader?: any | null;
                              header?: string | null;
                              text?: string | null;
                              introText?: string | null;
                              ctaButtons: Array<{
                                __typename?: 'CtaButtonRecord';
                                id: any;
                                text?: string | null;
                                url?: string | null;
                                variant?: string | null;
                              }>;
                            } | null;
                          }
                        | {
                            __typename?: 'NewsListBlockRecord';
                            id: any;
                            title?: string | null;
                            standalone?: any | null;
                            largeTitle?: any | null;
                            itemsToShow?: any | null;
                          }
                        | {
                            __typename?: 'ReportsListBlockRecord';
                            id: any;
                            title?: string | null;
                            standalone?: any | null;
                            largeTitle?: any | null;
                          }
                        | {
                            __typename?: 'TextBlockRecord';
                            id: any;
                            smallHeader?: any | null;
                            header?: string | null;
                            text?: string | null;
                            introText?: string | null;
                            ctaButtons: Array<{
                              __typename?: 'CtaButtonRecord';
                              id: any;
                              text?: string | null;
                              url?: string | null;
                              variant?: string | null;
                            }>;
                          }
                      >;
                    }
                  | {
                      __typename?: 'ImageRecord';
                      id: any;
                      fullWidth?: any | null;
                      image?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        responsiveImage?: {
                          __typename?: 'ResponsiveImage';
                          aspectRatio: any;
                          base64?: string | null;
                          bgColor?: string | null;
                          height: any;
                          sizes: string;
                          src: string;
                          srcSet: string;
                          webpSrcSet: string;
                          width: any;
                        } | null;
                      } | null;
                      imageLoad?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        title?: string | null;
                        url: string;
                        blurUpThumb?: string | null;
                        focalPoint?: {
                          __typename?: 'focalPoint';
                          x: any;
                          y: any;
                        } | null;
                        colors: Array<{
                          __typename?: 'ColorField';
                          hex: string;
                        }>;
                      } | null;
                    }
                  | {
                      __typename?: 'MediaWithCaptionRecord';
                      id: any;
                      centerText?: any | null;
                      textOnImage?: any | null;
                      media?: {
                        __typename?: 'ImageRecord';
                        id: any;
                        fullWidth?: any | null;
                        image?: {
                          __typename?: 'FileField';
                          alt?: string | null;
                          responsiveImage?: {
                            __typename?: 'ResponsiveImage';
                            aspectRatio: any;
                            base64?: string | null;
                            bgColor?: string | null;
                            height: any;
                            sizes: string;
                            src: string;
                            srcSet: string;
                            webpSrcSet: string;
                            width: any;
                          } | null;
                        } | null;
                        imageLoad?: {
                          __typename?: 'FileField';
                          alt?: string | null;
                          title?: string | null;
                          url: string;
                          blurUpThumb?: string | null;
                          focalPoint?: {
                            __typename?: 'focalPoint';
                            x: any;
                            y: any;
                          } | null;
                          colors: Array<{
                            __typename?: 'ColorField';
                            hex: string;
                          }>;
                        } | null;
                      } | null;
                      caption?: {
                        __typename?: 'TextBlockRecord';
                        id: any;
                        smallHeader?: any | null;
                        header?: string | null;
                        text?: string | null;
                        introText?: string | null;
                        ctaButtons: Array<{
                          __typename?: 'CtaButtonRecord';
                          id: any;
                          text?: string | null;
                          url?: string | null;
                          variant?: string | null;
                        }>;
                      } | null;
                    }
                  | {
                      __typename?: 'TextBlockRecord';
                      id: any;
                      smallHeader?: any | null;
                      header?: string | null;
                      text?: string | null;
                      introText?: string | null;
                      ctaButtons: Array<{
                        __typename?: 'CtaButtonRecord';
                        id: any;
                        text?: string | null;
                        url?: string | null;
                        variant?: string | null;
                      }>;
                    }
                >;
              }
            | {
                __typename?: 'GridTwocolBlockRecord';
                id: any;
                content: Array<
                  | {
                      __typename?: 'ImageRecord';
                      id: any;
                      fullWidth?: any | null;
                      image?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        responsiveImage?: {
                          __typename?: 'ResponsiveImage';
                          aspectRatio: any;
                          base64?: string | null;
                          bgColor?: string | null;
                          height: any;
                          sizes: string;
                          src: string;
                          srcSet: string;
                          webpSrcSet: string;
                          width: any;
                        } | null;
                      } | null;
                      imageLoad?: {
                        __typename?: 'FileField';
                        alt?: string | null;
                        title?: string | null;
                        url: string;
                        blurUpThumb?: string | null;
                        focalPoint?: {
                          __typename?: 'focalPoint';
                          x: any;
                          y: any;
                        } | null;
                        colors: Array<{
                          __typename?: 'ColorField';
                          hex: string;
                        }>;
                      } | null;
                    }
                  | {
                      __typename?: 'MediaWithCaptionRecord';
                      id: any;
                      centerText?: any | null;
                      textOnImage?: any | null;
                      media?: {
                        __typename?: 'ImageRecord';
                        id: any;
                        fullWidth?: any | null;
                        image?: {
                          __typename?: 'FileField';
                          alt?: string | null;
                          responsiveImage?: {
                            __typename?: 'ResponsiveImage';
                            aspectRatio: any;
                            base64?: string | null;
                            bgColor?: string | null;
                            height: any;
                            sizes: string;
                            src: string;
                            srcSet: string;
                            webpSrcSet: string;
                            width: any;
                          } | null;
                        } | null;
                        imageLoad?: {
                          __typename?: 'FileField';
                          alt?: string | null;
                          title?: string | null;
                          url: string;
                          blurUpThumb?: string | null;
                          focalPoint?: {
                            __typename?: 'focalPoint';
                            x: any;
                            y: any;
                          } | null;
                          colors: Array<{
                            __typename?: 'ColorField';
                            hex: string;
                          }>;
                        } | null;
                      } | null;
                      caption?: {
                        __typename?: 'TextBlockRecord';
                        id: any;
                        smallHeader?: any | null;
                        header?: string | null;
                        text?: string | null;
                        introText?: string | null;
                        ctaButtons: Array<{
                          __typename?: 'CtaButtonRecord';
                          id: any;
                          text?: string | null;
                          url?: string | null;
                          variant?: string | null;
                        }>;
                      } | null;
                    }
                  | {
                      __typename?: 'NewsListBlockRecord';
                      id: any;
                      title?: string | null;
                      standalone?: any | null;
                      largeTitle?: any | null;
                      itemsToShow?: any | null;
                    }
                  | {
                      __typename?: 'ReportsListBlockRecord';
                      id: any;
                      title?: string | null;
                      standalone?: any | null;
                      largeTitle?: any | null;
                    }
                  | {
                      __typename?: 'TextBlockRecord';
                      id: any;
                      smallHeader?: any | null;
                      header?: string | null;
                      text?: string | null;
                      introText?: string | null;
                      ctaButtons: Array<{
                        __typename?: 'CtaButtonRecord';
                        id: any;
                        text?: string | null;
                        url?: string | null;
                        variant?: string | null;
                      }>;
                    }
                >;
              }
          >;
        }
      | {
          __typename?: 'HeroBlockRecord';
          id: any;
          title?: string | null;
          description?: string | null;
          ctaText?: string | null;
          ctaUrl?: string | null;
          fullWidth?: any | null;
          boxColor?: { __typename?: 'ColorField'; hex: string } | null;
          textColor?: { __typename?: 'ColorField'; hex: string } | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
          imageOverlay?: {
            __typename?: 'OverlayRecord';
            id: any;
            opacity?: any | null;
            color?: { __typename?: 'ColorField'; hex: string } | null;
          } | null;
          ctaButtons: Array<{
            __typename?: 'CtaButtonRecord';
            id: any;
            text?: string | null;
            url?: string | null;
            variant?: string | null;
          }>;
          video?: {
            __typename?: 'FileField';
            blurUpThumb?: string | null;
            title?: string | null;
            alt?: string | null;
            video?: {
              __typename?: 'UploadVideoField';
              muxPlaybackId: string;
              width: any;
              height: any;
            } | null;
          } | null;
        }
      | {
          __typename?: 'ImageRecord';
          id: any;
          fullWidth?: any | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageLoad?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
        }
      | { __typename?: 'JobsListBlockRecord'; id: any; title?: string | null }
      | {
          __typename?: 'NewsAndReportsListBlockRecord';
          newsTitle?: string | null;
          reportsTitle?: string | null;
          newsImage?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
          news: Array<{
            __typename?: 'NewsPageRecord';
            id: any;
            title?: string | null;
            slug?: string | null;
            publishDate?: any | null;
            category?: string | null;
          }>;
          reportsImage?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
          reports: Array<{
            __typename?: 'ReportsListingRecord';
            id: any;
            title?: string | null;
            slug?: string | null;
            publishDate?: any | null;
            category?: string | null;
            pdf?: {
              __typename?: 'FileField';
              alt?: string | null;
              filename: string;
              format: string;
              size: any;
              title?: string | null;
              url: string;
              uploadId: any;
            } | null;
          }>;
        }
      | {
          __typename?: 'NewsListBlockRecord';
          id: any;
          title?: string | null;
          standalone?: any | null;
          largeTitle?: any | null;
          itemsToShow?: any | null;
        }
      | {
          __typename?: 'OfficesBlockRecord';
          id: any;
          offices: Array<{
            __typename?: 'OfficeRecord';
            id: any;
            name?: string | null;
            address?: string | null;
            zipCode?: string | null;
            city?: string | null;
            country?: string | null;
            email?: string | null;
            websiteUrl?: string | null;
            phoneNumber?: string | null;
          }>;
        }
      | {
          __typename?: 'PageNavigationBlockRecord';
          id: any;
          label?: string | null;
          links: Array<{
            __typename?: 'LinkRecord';
            id: any;
            title?: string | null;
            url?: string | null;
          }>;
        }
      | {
          __typename?: 'PlugBlockRecord';
          id: any;
          title?: string | null;
          description?: string | null;
          brands: Array<{
            __typename?: 'BrandPageRecord';
            id: any;
            brandName?: string | null;
            slug?: string | null;
            image?: {
              __typename?: 'FileField';
              alt?: string | null;
              tags: Array<string>;
              title?: string | null;
              url: string;
              width?: any | null;
              height?: any | null;
              format: string;
              responsiveImage?: {
                __typename?: 'ResponsiveImage';
                aspectRatio: any;
                base64?: string | null;
                bgColor?: string | null;
                height: any;
                sizes: string;
                src: string;
                srcSet: string;
                webpSrcSet: string;
                width: any;
              } | null;
            } | null;
            imageLoad?: {
              __typename?: 'FileField';
              alt?: string | null;
              title?: string | null;
              url: string;
              blurUpThumb?: string | null;
              focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
              colors: Array<{ __typename?: 'ColorField'; hex: string }>;
            } | null;
          }>;
        }
      | {
          __typename?: 'SimpleTitleAndTextBlockRecord';
          id: any;
          title?: string | null;
          topLabel?: string | null;
          description?: string | null;
        }
      | {
          __typename?: 'SliderBlockRecord';
          title?: string | null;
          arrows?: any | null;
          slideAnimation?: any | null;
          delay?: any | null;
          dots?: any | null;
          heroes: Array<{
            __typename?: 'HeroBlockRecord';
            id: any;
            title?: string | null;
            description?: string | null;
            ctaText?: string | null;
            ctaUrl?: string | null;
            fullWidth?: any | null;
            boxColor?: { __typename?: 'ColorField'; hex: string } | null;
            textColor?: { __typename?: 'ColorField'; hex: string } | null;
            image?: {
              __typename?: 'FileField';
              alt?: string | null;
              title?: string | null;
              url: string;
              blurUpThumb?: string | null;
              focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
              colors: Array<{ __typename?: 'ColorField'; hex: string }>;
            } | null;
            imageOverlay?: {
              __typename?: 'OverlayRecord';
              id: any;
              opacity?: any | null;
              color?: { __typename?: 'ColorField'; hex: string } | null;
            } | null;
            ctaButtons: Array<{
              __typename?: 'CtaButtonRecord';
              id: any;
              text?: string | null;
              url?: string | null;
              variant?: string | null;
            }>;
            video?: {
              __typename?: 'FileField';
              blurUpThumb?: string | null;
              title?: string | null;
              alt?: string | null;
              video?: {
                __typename?: 'UploadVideoField';
                muxPlaybackId: string;
                width: any;
                height: any;
              } | null;
            } | null;
          }>;
        }
      | {
          __typename?: 'StatementBlockRecord';
          id: any;
          text?: string | null;
          blackBackground?: any | null;
          header?: string | null;
          small?: any | null;
          linkText?: string | null;
          linkUrl?: string | null;
          imageMobile?: {
            __typename?: 'FileField';
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageTablet?: {
            __typename?: 'FileField';
            alt?: string | null;
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageDesktop?: {
            __typename?: 'FileField';
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageLoad?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
          imageOverlay?: {
            __typename?: 'OverlayRecord';
            id: any;
            opacity?: any | null;
            color?: { __typename?: 'ColorField'; hex: string } | null;
          } | null;
        }
      | {
          __typename?: 'SubheadingBlockRecord';
          id: any;
          title?: string | null;
          text?: string | null;
          ctaButton?: {
            __typename?: 'CtaButtonRecord';
            id: any;
            text?: string | null;
            url?: string | null;
            variant?: string | null;
          } | null;
          backgroundColor?: { __typename?: 'ColorField'; hex: string } | null;
        }
      | {
          __typename?: 'SustainabilityReportsBlockRecord';
          id: any;
          title?: string | null;
          reports: Array<{
            __typename?: 'FileField';
            alt?: string | null;
            filename: string;
            format: string;
            size: any;
            title?: string | null;
            url: string;
            uploadId: any;
          }>;
        }
      | {
          __typename?: 'TextBlockRecord';
          id: any;
          smallHeader?: any | null;
          header?: string | null;
          text?: string | null;
          introText?: string | null;
          ctaButtons: Array<{
            __typename?: 'CtaButtonRecord';
            id: any;
            text?: string | null;
            url?: string | null;
            variant?: string | null;
          }>;
        }
      | {
          __typename?: 'TwoColumnImageAndTextRecord';
          id: any;
          text?: string | null;
          title?: string | null;
          reverse?: any | null;
          image?: {
            __typename?: 'FileField';
            alt?: string | null;
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          imageLoad?: {
            __typename?: 'FileField';
            alt?: string | null;
            title?: string | null;
            url: string;
            blurUpThumb?: string | null;
            focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
            colors: Array<{ __typename?: 'ColorField'; hex: string }>;
          } | null;
        }
      | {
          __typename?: 'TwoColumnTextIntroRecord';
          id: any;
          introText?: string | null;
          text?: string | null;
          header?: string | null;
        }
      | {
          __typename?: 'VideoRecord';
          id: any;
          autoplay?: any | null;
          video?: {
            __typename?: 'FileField';
            title?: string | null;
            video?: {
              __typename?: 'UploadVideoField';
              mp4Url?: string | null;
              streamingUrl: string;
              thumbnailUrl: string;
              mp4Low?: string | null;
            } | null;
          } | null;
          videoThumbnail?: {
            __typename?: 'FileField';
            alt?: string | null;
            tags: Array<string>;
            title?: string | null;
            url: string;
            width?: any | null;
            height?: any | null;
            format: string;
            responsiveImage?: {
              __typename?: 'ResponsiveImage';
              aspectRatio: any;
              base64?: string | null;
              bgColor?: string | null;
              height: any;
              sizes: string;
              src: string;
              srcSet: string;
              webpSrcSet: string;
              width: any;
            } | null;
          } | null;
          muxVideo?: {
            __typename?: 'FileField';
            blurUpThumb?: string | null;
            title?: string | null;
            alt?: string | null;
            video?: {
              __typename?: 'UploadVideoField';
              muxPlaybackId: string;
              width: any;
              height: any;
            } | null;
          } | null;
        }
    >;
  } | null;
  globalContent?: {
    __typename?: 'GlobalRecord';
    changeLanguage?: string | null;
    closeLabel?: string | null;
    deadline?: string | null;
    errorMessage?: string | null;
    loading?: string | null;
    loadMoreNews?: string | null;
    localWebLabel?: string | null;
    menu?: string | null;
    moreNewsCta?: string | null;
    moreNewsHeader?: string | null;
    partnerPortalLabel?: string | null;
    partnerPortalUrl?: string | null;
    play?: string | null;
    shopLinkTitle?: string | null;
    shopLinkUrl?: string | null;
    showMoreJobsLabel?: string | null;
    viewOnMapLabel?: string | null;
    nextLabel?: string | null;
    previousLabel?: string | null;
    sliderNavigationLabel?: string | null;
    moreReportsCta?: string | null;
    loadMoreReports?: string | null;
    clearIconLabel?: string | null;
    searchIconLabel?: string | null;
    searchBoxPlaceholder?: string | null;
    viewAllButtonLabel?: string | null;
    searchResultsPageTitle?: string | null;
    firstPageLabel?: string | null;
    previousPageLabel?: string | null;
    nextPageLabel?: string | null;
    lastPageLabel?: string | null;
    goToPageLabel?: string | null;
    searchResultCount?: string | null;
    noSearchResults?: string | null;
    navigationLogo?: {
      __typename?: 'FileField';
      alt?: string | null;
      title?: string | null;
      url: string;
      responsiveImage?: {
        __typename?: 'ResponsiveImage';
        aspectRatio: any;
        base64?: string | null;
        bgColor?: string | null;
        height: any;
        sizes: string;
        src: string;
        srcSet: string;
        webpSrcSet: string;
        width: any;
      } | null;
    } | null;
    languages: Array<{
      __typename?: 'LanguageRecord';
      name?: string | null;
      url?: string | null;
      flag?: string | null;
      symbol?: {
        __typename?: 'FileField';
        alt?: string | null;
        tags: Array<string>;
        title?: string | null;
        url: string;
        width?: any | null;
        height?: any | null;
        format: string;
      } | null;
    }>;
  } | null;
  featureToggle?: {
    __typename?: 'FeatureToggleRecord';
    landingPageContentArea?: any | null;
    newsPageContentArea?: any | null;
  } | null;
  menu?: {
    __typename?: 'MenuRecord';
    menuItems: Array<{
      __typename?: 'MenuItemRecord';
      id: any;
      title?: string | null;
      url?: string | null;
      submenu?: {
        __typename?: 'SubmenuRecord';
        title?: string | null;
        menuItems: Array<{
          __typename?: 'ItemRecord';
          title?: string | null;
          pageLink?:
            | { __typename?: 'AboutUsPageRecord'; slug?: string | null }
            | { __typename?: 'BrandPageRecord'; slug?: string | null }
            | { __typename?: 'SustainabilityPageRecord'; slug?: string | null }
            | null;
        }>;
      } | null;
    }>;
  } | null;
  footer?: {
    __typename?: 'FooterRecord';
    bottomIntro?: string | null;
    cookieSettings?: string | null;
    introText?: string | null;
    moreInfoText?: string | null;
    partnerLogin?: string | null;
    selectCountryLabel?: string | null;
    socialMediaLabel?: string | null;
    useNewFooter?: any | null;
    footerLogo?: {
      __typename?: 'FileField';
      alt?: string | null;
      tags: Array<string>;
      title?: string | null;
      url: string;
      width?: any | null;
      height?: any | null;
      format: string;
    } | null;
    hultaforsBrands: Array<{
      __typename?: 'LinkRecord';
      id: any;
      title?: string | null;
      url?: string | null;
    }>;
    menu: Array<{
      __typename?: 'LinkRecord';
      id: any;
      title?: string | null;
      url?: string | null;
    }>;
    menuItems: Array<{
      __typename?: 'FooterMenuItemRecord';
      heading?: string | null;
      includeCookieToggle?: any | null;
      links: Array<{
        __typename?: 'LinkRecord';
        url?: string | null;
        title?: string | null;
      }>;
    }>;
    socialMediaMenu: Array<{
      __typename?: 'IconLinkRecord';
      url?: string | null;
      icon?: {
        __typename?: 'FileField';
        alt?: string | null;
        tags: Array<string>;
        title?: string | null;
        url: string;
        width?: any | null;
        height?: any | null;
        format: string;
      } | null;
    }>;
  } | null;
};

export type FileLinkFragment = {
  __typename?: 'FileField';
  alt?: string | null;
  filename: string;
  format: string;
  size: any;
  title?: string | null;
  url: string;
  uploadId: any;
};

export type FocalPointFragment = { __typename?: 'focalPoint'; x: any; y: any };

export type HexFragment = { __typename?: 'ColorField'; hex: string };

export type ImageBasicFragment = {
  __typename?: 'FileField';
  alt?: string | null;
  tags: Array<string>;
  title?: string | null;
  url: string;
  width?: any | null;
  height?: any | null;
  format: string;
};

export type ImageDynamicFragment = {
  __typename?: 'FileField';
  alt?: string | null;
  tags: Array<string>;
  title?: string | null;
  url: string;
  width?: any | null;
  height?: any | null;
  format: string;
  responsiveImage?: {
    __typename?: 'ResponsiveImage';
    aspectRatio: any;
    base64?: string | null;
    bgColor?: string | null;
    height: any;
    sizes: string;
    src: string;
    srcSet: string;
    webpSrcSet: string;
    width: any;
  } | null;
};

export type ImageFourByThreeFragment = {
  __typename?: 'FileField';
  alt?: string | null;
  tags: Array<string>;
  title?: string | null;
  url: string;
  width?: any | null;
  height?: any | null;
  format: string;
  responsiveImage?: {
    __typename?: 'ResponsiveImage';
    aspectRatio: any;
    base64?: string | null;
    bgColor?: string | null;
    height: any;
    sizes: string;
    src: string;
    srcSet: string;
    webpSrcSet: string;
    width: any;
  } | null;
};

export type ImageLoadFragment = {
  __typename?: 'FileField';
  alt?: string | null;
  title?: string | null;
  url: string;
  blurUpThumb?: string | null;
  focalPoint?: { __typename?: 'focalPoint'; x: any; y: any } | null;
  colors: Array<{ __typename?: 'ColorField'; hex: string }>;
};

export type ImageSixteenByNineFragment = {
  __typename?: 'FileField';
  alt?: string | null;
  tags: Array<string>;
  title?: string | null;
  url: string;
  width?: any | null;
  height?: any | null;
  format: string;
  responsiveImage?: {
    __typename?: 'ResponsiveImage';
    aspectRatio: any;
    base64?: string | null;
    bgColor?: string | null;
    height: any;
    sizes: string;
    src: string;
    srcSet: string;
    webpSrcSet: string;
    width: any;
  } | null;
};

export type ImageSquareFragment = {
  __typename?: 'FileField';
  alt?: string | null;
  tags: Array<string>;
  title?: string | null;
  url: string;
  width?: any | null;
  height?: any | null;
  format: string;
  responsiveImage?: {
    __typename?: 'ResponsiveImage';
    aspectRatio: any;
    base64?: string | null;
    bgColor?: string | null;
    height: any;
    sizes: string;
    src: string;
    srcSet: string;
    webpSrcSet: string;
    width: any;
  } | null;
};

export type ImageThirtyTwoByNineFragment = {
  __typename?: 'FileField';
  alt?: string | null;
  tags: Array<string>;
  title?: string | null;
  url: string;
  width?: any | null;
  height?: any | null;
  format: string;
  responsiveImage?: {
    __typename?: 'ResponsiveImage';
    aspectRatio: any;
    base64?: string | null;
    bgColor?: string | null;
    height: any;
    sizes: string;
    src: string;
    srcSet: string;
    webpSrcSet: string;
    width: any;
  } | null;
};

export type ImageThreeByFourFragment = {
  __typename?: 'FileField';
  alt?: string | null;
  tags: Array<string>;
  title?: string | null;
  url: string;
  width?: any | null;
  height?: any | null;
  format: string;
  responsiveImage?: {
    __typename?: 'ResponsiveImage';
    aspectRatio: any;
    base64?: string | null;
    bgColor?: string | null;
    height: any;
    sizes: string;
    src: string;
    srcSet: string;
    webpSrcSet: string;
    width: any;
  } | null;
};

export type ImageThreeByTwoFragment = {
  __typename?: 'FileField';
  alt?: string | null;
  tags: Array<string>;
  title?: string | null;
  url: string;
  width?: any | null;
  height?: any | null;
  format: string;
  responsiveImage?: {
    __typename?: 'ResponsiveImage';
    aspectRatio: any;
    base64?: string | null;
    bgColor?: string | null;
    height: any;
    sizes: string;
    src: string;
    srcSet: string;
    webpSrcSet: string;
    width: any;
  } | null;
};

export type ImageTwelveByFiveFragment = {
  __typename?: 'FileField';
  alt?: string | null;
  tags: Array<string>;
  title?: string | null;
  url: string;
  width?: any | null;
  height?: any | null;
  format: string;
  responsiveImage?: {
    __typename?: 'ResponsiveImage';
    aspectRatio: any;
    base64?: string | null;
    bgColor?: string | null;
    height: any;
    sizes: string;
    src: string;
    srcSet: string;
    webpSrcSet: string;
    width: any;
  } | null;
};

export type ImageTwentyOneByNineFragment = {
  __typename?: 'FileField';
  alt?: string | null;
  tags: Array<string>;
  title?: string | null;
  url: string;
  width?: any | null;
  height?: any | null;
  format: string;
  responsiveImage?: {
    __typename?: 'ResponsiveImage';
    aspectRatio: any;
    base64?: string | null;
    bgColor?: string | null;
    height: any;
    sizes: string;
    src: string;
    srcSet: string;
    webpSrcSet: string;
    width: any;
  } | null;
};

export type ImageTwoByThreeFragment = {
  __typename?: 'FileField';
  alt?: string | null;
  tags: Array<string>;
  title?: string | null;
  url: string;
  width?: any | null;
  height?: any | null;
  format: string;
  responsiveImage?: {
    __typename?: 'ResponsiveImage';
    aspectRatio: any;
    base64?: string | null;
    bgColor?: string | null;
    height: any;
    sizes: string;
    src: string;
    srcSet: string;
    webpSrcSet: string;
    width: any;
  } | null;
};

export type ImageFragment = {
  __typename?: 'FileField';
  alt?: string | null;
  title?: string | null;
  url: string;
  responsiveImage?: {
    __typename?: 'ResponsiveImage';
    aspectRatio: any;
    base64?: string | null;
    bgColor?: string | null;
    height: any;
    sizes: string;
    src: string;
    srcSet: string;
    webpSrcSet: string;
    width: any;
  } | null;
};

export type MuxVideoFragment = {
  __typename?: 'FileField';
  blurUpThumb?: string | null;
  title?: string | null;
  alt?: string | null;
  video?: {
    __typename?: 'UploadVideoField';
    muxPlaybackId: string;
    width: any;
    height: any;
  } | null;
};

type RecordMeta_AboutUsPageRecord_Fragment = {
  __typename?: 'AboutUsPageRecord';
  _updatedAt: any;
};

type RecordMeta_ArticlesBlockRecord_Fragment = {
  __typename?: 'ArticlesBlockRecord';
  _updatedAt: any;
};

type RecordMeta_BrandPageRecord_Fragment = {
  __typename?: 'BrandPageRecord';
  _updatedAt: any;
};

type RecordMeta_BrandsBlockRecord_Fragment = {
  __typename?: 'BrandsBlockRecord';
  _updatedAt: any;
};

type RecordMeta_BrandsListPageRecord_Fragment = {
  __typename?: 'BrandsListPageRecord';
  _updatedAt: any;
};

type RecordMeta_BulletListRecord_Fragment = {
  __typename?: 'BulletListRecord';
  _updatedAt: any;
};

type RecordMeta_CampaignPageRecord_Fragment = {
  __typename?: 'CampaignPageRecord';
  _updatedAt: any;
};

type RecordMeta_ConsentBoxRecord_Fragment = {
  __typename?: 'ConsentBoxRecord';
  _updatedAt: any;
};

type RecordMeta_ContactPageRecord_Fragment = {
  __typename?: 'ContactPageRecord';
  _updatedAt: any;
};

type RecordMeta_CtaButtonRecord_Fragment = {
  __typename?: 'CtaButtonRecord';
  _updatedAt: any;
};

type RecordMeta_DocumentLinkBlockRecord_Fragment = {
  __typename?: 'DocumentLinkBlockRecord';
  _updatedAt: any;
};

type RecordMeta_EmployeeRecord_Fragment = {
  __typename?: 'EmployeeRecord';
  _updatedAt: any;
};

type RecordMeta_FeatureToggleRecord_Fragment = {
  __typename?: 'FeatureToggleRecord';
  _updatedAt: any;
};

type RecordMeta_FooterMenuItemRecord_Fragment = {
  __typename?: 'FooterMenuItemRecord';
  _updatedAt: any;
};

type RecordMeta_FooterRecord_Fragment = {
  __typename?: 'FooterRecord';
  _updatedAt: any;
};

type RecordMeta_FullscreenImageCtaRecord_Fragment = {
  __typename?: 'FullscreenImageCtaRecord';
  _updatedAt: any;
};

type RecordMeta_GlobalRecord_Fragment = {
  __typename?: 'GlobalRecord';
  _updatedAt: any;
};

type RecordMeta_GridContainerBlockRecord_Fragment = {
  __typename?: 'GridContainerBlockRecord';
  _updatedAt: any;
};

type RecordMeta_GridFourcolBlockRecord_Fragment = {
  __typename?: 'GridFourcolBlockRecord';
  _updatedAt: any;
};

type RecordMeta_GridThreecolBlockRecord_Fragment = {
  __typename?: 'GridThreecolBlockRecord';
  _updatedAt: any;
};

type RecordMeta_GridTwocolBlockRecord_Fragment = {
  __typename?: 'GridTwocolBlockRecord';
  _updatedAt: any;
};

type RecordMeta_HeroBlockRecord_Fragment = {
  __typename?: 'HeroBlockRecord';
  _updatedAt: any;
};

type RecordMeta_IconLinkRecord_Fragment = {
  __typename?: 'IconLinkRecord';
  _updatedAt: any;
};

type RecordMeta_ImageRecord_Fragment = {
  __typename?: 'ImageRecord';
  _updatedAt: any;
};

type RecordMeta_ImportHistoryRecord_Fragment = {
  __typename?: 'ImportHistoryRecord';
  _updatedAt: any;
};

type RecordMeta_ItemRecord_Fragment = {
  __typename?: 'ItemRecord';
  _updatedAt: any;
};

type RecordMeta_JobOpportunitiesListPageRecord_Fragment = {
  __typename?: 'JobOpportunitiesListPageRecord';
  _updatedAt: any;
};

type RecordMeta_JobOpportunitiesPageRecord_Fragment = {
  __typename?: 'JobOpportunitiesPageRecord';
  _updatedAt: any;
};

type RecordMeta_JobsListBlockRecord_Fragment = {
  __typename?: 'JobsListBlockRecord';
  _updatedAt: any;
};

type RecordMeta_LandingPageRecord_Fragment = {
  __typename?: 'LandingPageRecord';
  _updatedAt: any;
};

type RecordMeta_LanguageRecord_Fragment = {
  __typename?: 'LanguageRecord';
  _updatedAt: any;
};

type RecordMeta_LinkRecord_Fragment = {
  __typename?: 'LinkRecord';
  _updatedAt: any;
};

type RecordMeta_MediaWithCaptionRecord_Fragment = {
  __typename?: 'MediaWithCaptionRecord';
  _updatedAt: any;
};

type RecordMeta_MenuItemRecord_Fragment = {
  __typename?: 'MenuItemRecord';
  _updatedAt: any;
};

type RecordMeta_MenuRecord_Fragment = {
  __typename?: 'MenuRecord';
  _updatedAt: any;
};

type RecordMeta_NewsAndReportsListBlockRecord_Fragment = {
  __typename?: 'NewsAndReportsListBlockRecord';
  _updatedAt: any;
};

type RecordMeta_NewsListBlockRecord_Fragment = {
  __typename?: 'NewsListBlockRecord';
  _updatedAt: any;
};

type RecordMeta_NewsListPageRecord_Fragment = {
  __typename?: 'NewsListPageRecord';
  _updatedAt: any;
};

type RecordMeta_NewsPageRecord_Fragment = {
  __typename?: 'NewsPageRecord';
  _updatedAt: any;
};

type RecordMeta_OfficeRecord_Fragment = {
  __typename?: 'OfficeRecord';
  _updatedAt: any;
};

type RecordMeta_OfficesBlockRecord_Fragment = {
  __typename?: 'OfficesBlockRecord';
  _updatedAt: any;
};

type RecordMeta_OverlayRecord_Fragment = {
  __typename?: 'OverlayRecord';
  _updatedAt: any;
};

type RecordMeta_PageNavigationBlockRecord_Fragment = {
  __typename?: 'PageNavigationBlockRecord';
  _updatedAt: any;
};

type RecordMeta_PageNotFoundRecord_Fragment = {
  __typename?: 'PageNotFoundRecord';
  _updatedAt: any;
};

type RecordMeta_PlugBlockRecord_Fragment = {
  __typename?: 'PlugBlockRecord';
  _updatedAt: any;
};

type RecordMeta_ReportsListBlockRecord_Fragment = {
  __typename?: 'ReportsListBlockRecord';
  _updatedAt: any;
};

type RecordMeta_ReportsListPageRecord_Fragment = {
  __typename?: 'ReportsListPageRecord';
  _updatedAt: any;
};

type RecordMeta_ReportsListingRecord_Fragment = {
  __typename?: 'ReportsListingRecord';
  _updatedAt: any;
};

type RecordMeta_SimpleTitleAndTextBlockRecord_Fragment = {
  __typename?: 'SimpleTitleAndTextBlockRecord';
  _updatedAt: any;
};

type RecordMeta_SiteLocaleRecord_Fragment = {
  __typename?: 'SiteLocaleRecord';
  _updatedAt: any;
};

type RecordMeta_SliderBlockRecord_Fragment = {
  __typename?: 'SliderBlockRecord';
  _updatedAt: any;
};

type RecordMeta_StatementBlockRecord_Fragment = {
  __typename?: 'StatementBlockRecord';
  _updatedAt: any;
};

type RecordMeta_SubheadingBlockRecord_Fragment = {
  __typename?: 'SubheadingBlockRecord';
  _updatedAt: any;
};

type RecordMeta_SubmenuRecord_Fragment = {
  __typename?: 'SubmenuRecord';
  _updatedAt: any;
};

type RecordMeta_SustainabilityIndexPageRecord_Fragment = {
  __typename?: 'SustainabilityIndexPageRecord';
  _updatedAt: any;
};

type RecordMeta_SustainabilityPageRecord_Fragment = {
  __typename?: 'SustainabilityPageRecord';
  _updatedAt: any;
};

type RecordMeta_SustainabilityReportsBlockRecord_Fragment = {
  __typename?: 'SustainabilityReportsBlockRecord';
  _updatedAt: any;
};

type RecordMeta_TextBlockRecord_Fragment = {
  __typename?: 'TextBlockRecord';
  _updatedAt: any;
};

type RecordMeta_TwoColumnImageAndTextRecord_Fragment = {
  __typename?: 'TwoColumnImageAndTextRecord';
  _updatedAt: any;
};

type RecordMeta_TwoColumnTextIntroRecord_Fragment = {
  __typename?: 'TwoColumnTextIntroRecord';
  _updatedAt: any;
};

type RecordMeta_VideoRecord_Fragment = {
  __typename?: 'VideoRecord';
  _updatedAt: any;
};

export type RecordMetaFragment =
  | RecordMeta_AboutUsPageRecord_Fragment
  | RecordMeta_ArticlesBlockRecord_Fragment
  | RecordMeta_BrandPageRecord_Fragment
  | RecordMeta_BrandsBlockRecord_Fragment
  | RecordMeta_BrandsListPageRecord_Fragment
  | RecordMeta_BulletListRecord_Fragment
  | RecordMeta_CampaignPageRecord_Fragment
  | RecordMeta_ConsentBoxRecord_Fragment
  | RecordMeta_ContactPageRecord_Fragment
  | RecordMeta_CtaButtonRecord_Fragment
  | RecordMeta_DocumentLinkBlockRecord_Fragment
  | RecordMeta_EmployeeRecord_Fragment
  | RecordMeta_FeatureToggleRecord_Fragment
  | RecordMeta_FooterMenuItemRecord_Fragment
  | RecordMeta_FooterRecord_Fragment
  | RecordMeta_FullscreenImageCtaRecord_Fragment
  | RecordMeta_GlobalRecord_Fragment
  | RecordMeta_GridContainerBlockRecord_Fragment
  | RecordMeta_GridFourcolBlockRecord_Fragment
  | RecordMeta_GridThreecolBlockRecord_Fragment
  | RecordMeta_GridTwocolBlockRecord_Fragment
  | RecordMeta_HeroBlockRecord_Fragment
  | RecordMeta_IconLinkRecord_Fragment
  | RecordMeta_ImageRecord_Fragment
  | RecordMeta_ImportHistoryRecord_Fragment
  | RecordMeta_ItemRecord_Fragment
  | RecordMeta_JobOpportunitiesListPageRecord_Fragment
  | RecordMeta_JobOpportunitiesPageRecord_Fragment
  | RecordMeta_JobsListBlockRecord_Fragment
  | RecordMeta_LandingPageRecord_Fragment
  | RecordMeta_LanguageRecord_Fragment
  | RecordMeta_LinkRecord_Fragment
  | RecordMeta_MediaWithCaptionRecord_Fragment
  | RecordMeta_MenuItemRecord_Fragment
  | RecordMeta_MenuRecord_Fragment
  | RecordMeta_NewsAndReportsListBlockRecord_Fragment
  | RecordMeta_NewsListBlockRecord_Fragment
  | RecordMeta_NewsListPageRecord_Fragment
  | RecordMeta_NewsPageRecord_Fragment
  | RecordMeta_OfficeRecord_Fragment
  | RecordMeta_OfficesBlockRecord_Fragment
  | RecordMeta_OverlayRecord_Fragment
  | RecordMeta_PageNavigationBlockRecord_Fragment
  | RecordMeta_PageNotFoundRecord_Fragment
  | RecordMeta_PlugBlockRecord_Fragment
  | RecordMeta_ReportsListBlockRecord_Fragment
  | RecordMeta_ReportsListPageRecord_Fragment
  | RecordMeta_ReportsListingRecord_Fragment
  | RecordMeta_SimpleTitleAndTextBlockRecord_Fragment
  | RecordMeta_SiteLocaleRecord_Fragment
  | RecordMeta_SliderBlockRecord_Fragment
  | RecordMeta_StatementBlockRecord_Fragment
  | RecordMeta_SubheadingBlockRecord_Fragment
  | RecordMeta_SubmenuRecord_Fragment
  | RecordMeta_SustainabilityIndexPageRecord_Fragment
  | RecordMeta_SustainabilityPageRecord_Fragment
  | RecordMeta_SustainabilityReportsBlockRecord_Fragment
  | RecordMeta_TextBlockRecord_Fragment
  | RecordMeta_TwoColumnImageAndTextRecord_Fragment
  | RecordMeta_TwoColumnTextIntroRecord_Fragment
  | RecordMeta_VideoRecord_Fragment;

export type ResponsiveImageFragment = {
  __typename?: 'ResponsiveImage';
  aspectRatio: any;
  base64?: string | null;
  bgColor?: string | null;
  height: any;
  sizes: string;
  src: string;
  srcSet: string;
  webpSrcSet: string;
  width: any;
};

export type UploadVideoFragment = {
  __typename?: 'UploadVideoField';
  mp4Url?: string | null;
  streamingUrl: string;
  thumbnailUrl: string;
  mp4Low?: string | null;
};

export type VideoFileFragment = {
  __typename?: 'FileField';
  alt?: string | null;
  url: string;
  title?: string | null;
  video?: {
    __typename?: 'UploadVideoField';
    mp4Url?: string | null;
    streamingUrl: string;
    thumbnailUrl: string;
    mp4Low?: string | null;
  } | null;
};

export type VideoUrlFragment = {
  __typename?: 'FileField';
  alt?: string | null;
  url: string;
  title?: string | null;
};

export const CollectionMetadataFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'collectionMetadata' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CollectionMetadata' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
      },
    },
  ],
} as unknown as DocumentNode<CollectionMetadataFragment, unknown>;
export const BulletListFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'bulletList' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BulletListRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bullets' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberedList' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BulletListFragment, unknown>;
export const ResponsiveImageFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ResponsiveImageFragment, unknown>;
export const DynamicImageFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'dynamicImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'max' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '1800' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DynamicImageFragment, unknown>;
export const DynamicContentImageFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'dynamicContentImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ImageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'dynamicImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'max' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '1800' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DynamicContentImageFragment, unknown>;
export const ImageBasicFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBasic' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ImageBasicFragment, unknown>;
export const ImageTwoByThreeFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageTwoByThree' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '2:3',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBasic' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ImageTwoByThreeFragment, unknown>;
export const FocalPointFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'focalPoint' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'focalPoint' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'y' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FocalPointFragment, unknown>;
export const HexFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'hex' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ColorField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hex' } }],
      },
    },
  ],
} as unknown as DocumentNode<HexFragment, unknown>;
export const ImageLoadFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageLoad' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'focalPoint' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'focalPoint' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'focalPoint' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'focalPoint' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'y' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'hex' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ColorField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hex' } }],
      },
    },
  ],
} as unknown as DocumentNode<ImageLoadFragment, unknown>;
export const EmployeeFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'employee' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'EmployeeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'description' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'profileImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageTwoByThree' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'profileImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBasic' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'focalPoint' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'focalPoint' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'y' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'hex' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ColorField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hex' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageTwoByThree' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '2:3',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageLoad' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'focalPoint' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'focalPoint' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EmployeeFragment, unknown>;
export const FullscreenImageCtaFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'fullscreenImageCta' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FullscreenImageCtaRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageMobile' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'auto' },
                            value: { kind: 'EnumValue', value: 'format' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '1620' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageTablet' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'auto' },
                            value: { kind: 'EnumValue', value: 'format' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'auto' },
                            value: { kind: 'EnumValue', value: 'format' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '1620' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FullscreenImageCtaFragment, unknown>;
export const TextFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'text' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'smallHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'text' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TextFragment, unknown>;
export const TwoColumnImageAndTextFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnImageAndText' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnImageAndTextRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reverse' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'focalPoint' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'focalPoint' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'y' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'hex' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ColorField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hex' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'dynamicImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'max' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '1800' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageLoad' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'focalPoint' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'focalPoint' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TwoColumnImageAndTextFragment, unknown>;
export const TwoColumnTextIntroFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnTextIntro' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnTextIntroRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TwoColumnTextIntroFragment, unknown>;
export const UploadVideoFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'uploadVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UploadVideoField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mp4Url' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'mp4Low' },
            name: { kind: 'Name', value: 'mp4Url' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'res' },
                value: { kind: 'EnumValue', value: 'low' },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'streamingUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'thumbnailUrl' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UploadVideoFragment, unknown>;
export const ImageSixteenByNineFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSixteenByNine' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '16:9',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBasic' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ImageSixteenByNineFragment, unknown>;
export const VideoFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'video' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VideoRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'video' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'uploadVideo' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'videoThumbnail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSixteenByNine' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBasic' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'uploadVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UploadVideoField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mp4Url' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'mp4Low' },
            name: { kind: 'Name', value: 'mp4Url' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'res' },
                value: { kind: 'EnumValue', value: 'low' },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'streamingUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'thumbnailUrl' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSixteenByNine' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '16:9',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<VideoFragment, unknown>;
export const FeatureToggleFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'featureToggle' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FeatureToggleRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'landingPageContentArea' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsPageContentArea' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FeatureToggleFragment, unknown>;
export const LinkFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'link' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LinkRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LinkFragment, unknown>;
export const FooterMenuItemFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'footerMenuItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FooterMenuItemRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'heading' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'links' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'includeCookieToggle' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FooterMenuItemFragment, unknown>;
export const IconLinkFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'iconLink' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'IconLinkRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'icon' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBasic' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBasic' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IconLinkFragment, unknown>;
export const FooterFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'footer' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FooterRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'bottomIntro' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cookieSettings' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'footerLogo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBasic' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hultaforsBrands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'link' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'menu' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'link' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'menuItems' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'footerMenuItem' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'moreInfoText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerLogin' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selectCountryLabel' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'socialMediaLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'socialMediaMenu' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'iconLink' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'useNewFooter' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBasic' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'link' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LinkRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'footerMenuItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FooterMenuItemRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'heading' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'links' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'includeCookieToggle' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'iconLink' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'IconLinkRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'icon' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBasic' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FooterFragment, unknown>;
export const ImageFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'image' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ImageFragment, unknown>;
export const LanguageFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'language' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LanguageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'flag' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'symbol' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBasic' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBasic' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LanguageFragment, unknown>;
export const GlobalContentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'globalContent' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GlobalRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'navigationLogo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'image' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'changeLanguage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'closeLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deadline' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'loading' } },
          { kind: 'Field', name: { kind: 'Name', value: 'loadMoreNews' } },
          { kind: 'Field', name: { kind: 'Name', value: 'localWebLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'menu' } },
          { kind: 'Field', name: { kind: 'Name', value: 'moreNewsCta' } },
          { kind: 'Field', name: { kind: 'Name', value: 'moreNewsHeader' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'partnerPortalLabel' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerPortalUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'play' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shopLinkTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shopLinkUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'showMoreJobsLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'viewOnMapLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'languages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'language' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'nextLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previousLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sliderNavigationLabel' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'moreReportsCta' } },
          { kind: 'Field', name: { kind: 'Name', value: 'loadMoreReports' } },
          { kind: 'Field', name: { kind: 'Name', value: 'clearIconLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'searchIconLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchBoxPlaceholder' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'viewAllButtonLabel' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchResultsPageTitle' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'firstPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previousPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'goToPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'searchResultCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'noSearchResults' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBasic' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'image' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'language' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LanguageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'flag' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'symbol' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBasic' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GlobalContentFragment, unknown>;
export const HeroImageDesktopFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroImageDesktop' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '1440' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<HeroImageDesktopFragment, unknown>;
export const HeroImageLandscapeFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroImageLandscape' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '1620' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<HeroImageLandscapeFragment, unknown>;
export const HeroImageMobileFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroImageMobile' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '1620' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<HeroImageMobileFragment, unknown>;
export const HeroImagePortraitFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroImagePortrait' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2160' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<HeroImagePortraitFragment, unknown>;
export const SubMenuItemFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'subMenuItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ItemRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pageLink' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'BrandPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SustainabilityPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'AboutUsPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SubMenuItemFragment, unknown>;
export const MenuItemFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'menuItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MenuItemRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submenu' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'menuItems' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'subMenuItem' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'subMenuItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ItemRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pageLink' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'BrandPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SustainabilityPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'AboutUsPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MenuItemFragment, unknown>;
export const MenuFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'menu' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MenuRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'menuItems' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'menuItem' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'subMenuItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ItemRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pageLink' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'BrandPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SustainabilityPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'AboutUsPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'menuItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MenuItemRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submenu' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'menuItems' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'subMenuItem' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MenuFragment, unknown>;
export const SeoFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'seo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SeoField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SeoFragment, unknown>;
export const JobOpportunitiesPageListingFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobOpportunitiesPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'department' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<JobOpportunitiesPageListingFragment, unknown>;
export const NewsPageListingFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'focalPoint' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'focalPoint' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'y' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'hex' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ColorField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hex' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageLoad' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'focalPoint' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'focalPoint' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NewsPageListingFragment, unknown>;
export const FileLinkFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'fileLink' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'uploadId' },
            name: { kind: 'Name', value: 'id' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FileLinkFragment, unknown>;
export const ReportsPageListingFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListingRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pdf' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'focalPoint' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'focalPoint' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'y' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'hex' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ColorField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hex' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageLoad' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'focalPoint' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'focalPoint' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'fileLink' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'uploadId' },
            name: { kind: 'Name', value: 'id' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ReportsPageListingFragment, unknown>;
export const ArticlesBlockFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'articlesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ArticlesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isJobArticles' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'jobPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'newsPageListing' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'reportsPageListing' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'focalPoint' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'focalPoint' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'y' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'hex' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ColorField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hex' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageLoad' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'focalPoint' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'focalPoint' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'fileLink' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'uploadId' },
            name: { kind: 'Name', value: 'id' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobOpportunitiesPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'department' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListingRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pdf' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ArticlesBlockFragment, unknown>;
export const ImageSquareFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSquare' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '1:1',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBasic' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ImageSquareFragment, unknown>;
export const BrandFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brand' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'brandName' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSquare' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBasic' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'focalPoint' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'focalPoint' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'y' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'hex' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ColorField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hex' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSquare' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '1:1',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageLoad' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'focalPoint' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'focalPoint' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BrandFragment, unknown>;
export const BrandsBlockFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brandsBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandsBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hideLabels' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBasic' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSquare' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '1:1',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'focalPoint' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'focalPoint' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'y' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'hex' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ColorField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hex' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageLoad' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'focalPoint' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'focalPoint' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brand' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'brandName' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSquare' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BrandsBlockFragment, unknown>;
export const BulletListBlockFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'bulletListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BulletListRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bullets' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberedList' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BulletListBlockFragment, unknown>;
export const DocumentLinkBlockFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'documentLinkBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DocumentLinkBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'documents' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'fileLink' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'uploadId' },
            name: { kind: 'Name', value: 'id' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DocumentLinkBlockFragment, unknown>;
export const EmployeeBlockFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'employeeBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'EmployeeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'description' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'profileImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'focalPoint' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'focalPoint' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'y' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'hex' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ColorField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hex' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageLoad' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'focalPoint' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'focalPoint' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EmployeeBlockFragment, unknown>;
export const OverlayFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'overlay' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OverlayRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'color' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'opacity' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'hex' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ColorField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hex' } }],
      },
    },
  ],
} as unknown as DocumentNode<OverlayFragment, unknown>;
export const CtaButtonFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ctaButton' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CtaButtonRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CtaButtonFragment, unknown>;
export const MuxVideoFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'muxVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'muxPlaybackId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MuxVideoFragment, unknown>;
export const HeroBlockFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HeroBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'boxColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'textColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'focalPoint' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'focalPoint' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'y' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'hex' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ColorField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hex' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageLoad' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'focalPoint' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'focalPoint' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'overlay' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OverlayRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'color' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'opacity' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ctaButton' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CtaButtonRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'muxVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'muxPlaybackId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<HeroBlockFragment, unknown>;
export const ImageBlockFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ImageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'focalPoint' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'focalPoint' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'y' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'hex' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ColorField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hex' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'dynamicImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'max' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '1800' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageLoad' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'focalPoint' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'focalPoint' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ImageBlockFragment, unknown>;
export const TextBlockFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'textBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'smallHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'text' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ctaButton' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CtaButtonRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TextBlockFragment, unknown>;
export const MediaWithCaptionFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'mediaWithCaption' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MediaWithCaptionRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'media' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caption' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'centerText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'textOnImage' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'dynamicImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'max' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '1800' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'focalPoint' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'focalPoint' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'y' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'hex' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ColorField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hex' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageLoad' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'focalPoint' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'focalPoint' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ctaButton' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CtaButtonRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ImageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'textBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'smallHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'text' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MediaWithCaptionFragment, unknown>;
export const NewsListBlockFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'standalone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'largeTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'itemsToShow' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NewsListBlockFragment, unknown>;
export const ReportsListBlockFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'standalone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'largeTitle' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ReportsListBlockFragment, unknown>;
export const GridTwoColBlockFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridTwoColBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridTwocolBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'mediaWithCaption' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'newsListBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'reportsListBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'dynamicImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'max' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '1800' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'focalPoint' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'focalPoint' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'y' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'hex' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ColorField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hex' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageLoad' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'focalPoint' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'focalPoint' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ImageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ctaButton' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CtaButtonRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'textBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'smallHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'text' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'mediaWithCaption' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MediaWithCaptionRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'media' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caption' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'centerText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'textOnImage' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'standalone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'largeTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'itemsToShow' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'standalone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'largeTitle' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GridTwoColBlockFragment, unknown>;
export const GridThreeColBlockFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridThreeColBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridThreecolBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'mediaWithCaption' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridTwoColBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'dynamicImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'max' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '1800' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'focalPoint' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'focalPoint' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'y' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'hex' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ColorField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hex' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageLoad' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'focalPoint' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'focalPoint' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ImageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ctaButton' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CtaButtonRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'textBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'smallHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'text' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'mediaWithCaption' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MediaWithCaptionRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'media' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caption' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'centerText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'textOnImage' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'standalone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'largeTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'itemsToShow' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'standalone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'largeTitle' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridTwoColBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridTwocolBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'mediaWithCaption' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'newsListBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'reportsListBlock' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GridThreeColBlockFragment, unknown>;
export const GridFourColBlockFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridFourColBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridFourcolBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'mediaWithCaption' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'dynamicImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'max' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '1800' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'focalPoint' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'focalPoint' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'y' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'hex' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ColorField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hex' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageLoad' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'focalPoint' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'focalPoint' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ImageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ctaButton' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CtaButtonRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'textBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'smallHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'text' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'mediaWithCaption' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MediaWithCaptionRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'media' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caption' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'centerText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'textOnImage' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GridFourColBlockFragment, unknown>;
export const GridContainerBlockFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridContainerBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridContainerBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'backgroundColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'textColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fullwidth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gap' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridTwoColBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridThreeColBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridFourColBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'dynamicImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'max' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '1800' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'focalPoint' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'focalPoint' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'y' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'hex' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ColorField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hex' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageLoad' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'focalPoint' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'focalPoint' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ImageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ctaButton' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CtaButtonRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'textBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'smallHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'text' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'mediaWithCaption' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MediaWithCaptionRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'media' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caption' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'centerText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'textOnImage' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'standalone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'largeTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'itemsToShow' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'standalone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'largeTitle' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridTwoColBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridTwocolBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'mediaWithCaption' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'newsListBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'reportsListBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridThreeColBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridThreecolBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'mediaWithCaption' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridTwoColBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridFourColBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridFourcolBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'mediaWithCaption' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GridContainerBlockFragment, unknown>;
export const JobsListBlockFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<JobsListBlockFragment, unknown>;
export const NewsAndReportsListBlockFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsAndReportsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsAndReportsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'newsTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'news' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NewsPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'publishDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'reportsTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportsImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reports' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ReportsListingRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'publishDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pdf' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'fileLink' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'focalPoint' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'focalPoint' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'y' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'hex' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ColorField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hex' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageLoad' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'focalPoint' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'focalPoint' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'fileLink' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'uploadId' },
            name: { kind: 'Name', value: 'id' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NewsAndReportsListBlockFragment, unknown>;
export const OfficeFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'office' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'websiteUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OfficeFragment, unknown>;
export const OfficesBlockFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'officesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'offices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'office' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'office' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'websiteUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OfficesBlockFragment, unknown>;
export const PlugBlockFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'plugBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PlugBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBasic' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSquare' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '1:1',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'focalPoint' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'focalPoint' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'y' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'hex' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ColorField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hex' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageLoad' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'focalPoint' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'focalPoint' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brand' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'brandName' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSquare' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PlugBlockFragment, unknown>;
export const SimpleTitleAndTextBlockFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'simpleTitleAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SimpleTitleAndTextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'topLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SimpleTitleAndTextBlockFragment, unknown>;
export const HeroImageTabletFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroImageTablet' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<HeroImageTabletFragment, unknown>;
export const StatementBlockFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'statementBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StatementBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blackBackground' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          { kind: 'Field', name: { kind: 'Name', value: 'small' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkUrl' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageMobile' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '1728' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageTablet' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroImageTablet' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageDesktop' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '1620' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'focalPoint' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'focalPoint' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'y' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'hex' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ColorField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hex' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroImageTablet' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageLoad' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'focalPoint' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'focalPoint' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'overlay' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OverlayRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'color' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'opacity' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<StatementBlockFragment, unknown>;
export const TwoColumnImageAndTextBlockFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnImageAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnImageAndTextRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reverse' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'focalPoint' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'focalPoint' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'y' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'hex' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ColorField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hex' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'dynamicImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'max' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '1800' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageLoad' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'focalPoint' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'focalPoint' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TwoColumnImageAndTextBlockFragment, unknown>;
export const TwoColumnTextIntroBlockFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnTextIntroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnTextIntroRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TwoColumnTextIntroBlockFragment, unknown>;
export const VideoBlockFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'videoBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VideoRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'autoplay' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'video' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'uploadVideo' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'videoThumbnail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSixteenByNine' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'muxVideo' },
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBasic' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'uploadVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UploadVideoField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mp4Url' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'mp4Low' },
            name: { kind: 'Name', value: 'mp4Url' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'res' },
                value: { kind: 'EnumValue', value: 'low' },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'streamingUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'thumbnailUrl' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSixteenByNine' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '16:9',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'muxVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'muxPlaybackId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<VideoBlockFragment, unknown>;
export const SliderBlockFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'sliderBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SliderBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'arrows' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slideAnimation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'delay' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'dots' },
            name: { kind: 'Name', value: 'navigationDots' },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'heroes' },
            name: { kind: 'Name', value: 'slides' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'hex' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ColorField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hex' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'focalPoint' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'focalPoint' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'y' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageLoad' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'focalPoint' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'focalPoint' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'overlay' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OverlayRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'color' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'opacity' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ctaButton' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CtaButtonRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'muxVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'muxPlaybackId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HeroBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'boxColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'textColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SliderBlockFragment, unknown>;
export const SubheadingBlockFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'subheadingBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SubheadingBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButton' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'backgroundColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ctaButton' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CtaButtonRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'hex' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ColorField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hex' } }],
      },
    },
  ],
} as unknown as DocumentNode<SubheadingBlockFragment, unknown>;
export const SustainabilityReportsBlockFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'sustainabilityReportsBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SustainabilityReportsBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reports' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'fileLink' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'uploadId' },
            name: { kind: 'Name', value: 'id' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SustainabilityReportsBlockFragment, unknown>;
export const AboutUsPageContentAreaFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'aboutUsPageContentArea' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AboutUsPageModelContentAreaField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'articlesBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'brandsBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'bulletListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'documentLinkBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'employeeBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'heroBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'gridContainerBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'jobsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'newsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'newsAndReportsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'officesBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'plugBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'simpleTitleAndTextBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'statementBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'textBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'twoColumnImageAndTextBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'twoColumnTextIntroBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'videoBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'sliderBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'subheadingBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'sustainabilityReportsBlock' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobOpportunitiesPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'department' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'focalPoint' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'focalPoint' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'y' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'hex' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ColorField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hex' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageLoad' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'focalPoint' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'focalPoint' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'fileLink' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'uploadId' },
            name: { kind: 'Name', value: 'id' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListingRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pdf' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBasic' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSquare' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '1:1',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brand' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'brandName' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSquare' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'overlay' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OverlayRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'color' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'opacity' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ctaButton' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CtaButtonRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'muxVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'muxPlaybackId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'dynamicImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'max' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '1800' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ImageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'textBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'smallHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'text' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'mediaWithCaption' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MediaWithCaptionRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'media' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caption' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'centerText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'textOnImage' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'standalone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'largeTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'itemsToShow' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'standalone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'largeTitle' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridTwoColBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridTwocolBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'mediaWithCaption' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'newsListBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'reportsListBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridThreeColBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridThreecolBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'mediaWithCaption' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridTwoColBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridFourColBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridFourcolBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'mediaWithCaption' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'office' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'websiteUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroImageTablet' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'uploadVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UploadVideoField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mp4Url' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'mp4Low' },
            name: { kind: 'Name', value: 'mp4Url' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'res' },
                value: { kind: 'EnumValue', value: 'low' },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'streamingUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'thumbnailUrl' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSixteenByNine' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '16:9',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HeroBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'boxColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'textColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'articlesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ArticlesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isJobArticles' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'jobPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'newsPageListing' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'reportsPageListing' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brandsBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandsBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hideLabels' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'bulletListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BulletListRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bullets' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberedList' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'documentLinkBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DocumentLinkBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'documents' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'employeeBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'EmployeeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'description' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'profileImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridContainerBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridContainerBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'backgroundColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'textColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fullwidth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gap' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridTwoColBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridThreeColBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridFourColBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsAndReportsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsAndReportsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'newsTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'news' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NewsPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'publishDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'reportsTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportsImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reports' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ReportsListingRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'publishDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pdf' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'fileLink' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'officesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'offices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'office' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'plugBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PlugBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'simpleTitleAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SimpleTitleAndTextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'topLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'statementBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StatementBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blackBackground' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          { kind: 'Field', name: { kind: 'Name', value: 'small' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkUrl' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageMobile' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '1728' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageTablet' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroImageTablet' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageDesktop' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '1620' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnImageAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnImageAndTextRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reverse' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnTextIntroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnTextIntroRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'videoBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VideoRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'autoplay' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'video' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'uploadVideo' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'videoThumbnail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSixteenByNine' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'muxVideo' },
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'sliderBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SliderBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'arrows' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slideAnimation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'delay' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'dots' },
            name: { kind: 'Name', value: 'navigationDots' },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'heroes' },
            name: { kind: 'Name', value: 'slides' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'subheadingBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SubheadingBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButton' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'backgroundColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'sustainabilityReportsBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SustainabilityReportsBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reports' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AboutUsPageContentAreaFragment, unknown>;
export const AboutUsPageContentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'aboutUsPageContent' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AboutUsPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'seo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'seo' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'pageLocales' },
            name: { kind: 'Name', value: '_locales' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentArea' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'aboutUsPageContentArea' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobOpportunitiesPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'department' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'focalPoint' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'focalPoint' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'y' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'hex' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ColorField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hex' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageLoad' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'focalPoint' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'focalPoint' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'fileLink' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'uploadId' },
            name: { kind: 'Name', value: 'id' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListingRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pdf' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'articlesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ArticlesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isJobArticles' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'jobPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'newsPageListing' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'reportsPageListing' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBasic' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSquare' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '1:1',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brand' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'brandName' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSquare' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brandsBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandsBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hideLabels' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'bulletListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BulletListRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bullets' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberedList' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'documentLinkBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DocumentLinkBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'documents' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'employeeBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'EmployeeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'description' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'profileImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'overlay' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OverlayRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'color' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'opacity' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ctaButton' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CtaButtonRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'muxVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'muxPlaybackId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HeroBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'boxColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'textColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'dynamicImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'max' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '1800' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ImageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'textBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'smallHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'text' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'mediaWithCaption' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MediaWithCaptionRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'media' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caption' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'centerText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'textOnImage' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'standalone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'largeTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'itemsToShow' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'standalone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'largeTitle' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridTwoColBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridTwocolBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'mediaWithCaption' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'newsListBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'reportsListBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridThreeColBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridThreecolBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'mediaWithCaption' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridTwoColBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridFourColBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridFourcolBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'mediaWithCaption' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridContainerBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridContainerBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'backgroundColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'textColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fullwidth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gap' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridTwoColBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridThreeColBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridFourColBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsAndReportsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsAndReportsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'newsTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'news' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NewsPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'publishDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'reportsTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportsImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reports' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ReportsListingRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'publishDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pdf' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'fileLink' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'office' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'websiteUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'officesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'offices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'office' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'plugBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PlugBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'simpleTitleAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SimpleTitleAndTextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'topLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroImageTablet' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'statementBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StatementBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blackBackground' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          { kind: 'Field', name: { kind: 'Name', value: 'small' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkUrl' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageMobile' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '1728' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageTablet' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroImageTablet' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageDesktop' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '1620' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnImageAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnImageAndTextRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reverse' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnTextIntroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnTextIntroRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'uploadVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UploadVideoField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mp4Url' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'mp4Low' },
            name: { kind: 'Name', value: 'mp4Url' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'res' },
                value: { kind: 'EnumValue', value: 'low' },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'streamingUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'thumbnailUrl' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSixteenByNine' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '16:9',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'videoBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VideoRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'autoplay' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'video' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'uploadVideo' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'videoThumbnail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSixteenByNine' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'muxVideo' },
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'sliderBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SliderBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'arrows' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slideAnimation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'delay' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'dots' },
            name: { kind: 'Name', value: 'navigationDots' },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'heroes' },
            name: { kind: 'Name', value: 'slides' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'subheadingBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SubheadingBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButton' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'backgroundColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'sustainabilityReportsBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SustainabilityReportsBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reports' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'seo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SeoField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'aboutUsPageContentArea' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AboutUsPageModelContentAreaField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'articlesBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'brandsBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'bulletListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'documentLinkBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'employeeBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'heroBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'gridContainerBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'jobsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'newsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'newsAndReportsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'officesBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'plugBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'simpleTitleAndTextBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'statementBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'textBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'twoColumnImageAndTextBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'twoColumnTextIntroBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'videoBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'sliderBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'subheadingBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'sustainabilityReportsBlock' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AboutUsPageContentFragment, unknown>;
export const LogoFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'logo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'max' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '200' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LogoFragment, unknown>;
export const BrandPageContentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brandPageContent' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'heroTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkToWebsite' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkToWebsiteText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'heroImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'brandName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'seo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'seo' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'logo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'logo' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'pageLocales' },
            name: { kind: 'Name', value: '_locales' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'focalPoint' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'focalPoint' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'y' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'hex' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ColorField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hex' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageLoad' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'focalPoint' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'focalPoint' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'seo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SeoField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'logo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'max' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '200' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BrandPageContentFragment, unknown>;
export const BrandsListPageContentAreaFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brandsListPageContentArea' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandsListPageModelContentAreaField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'textBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'twoColumnImageAndTextBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'statementBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'twoColumnTextIntroBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'videoBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'employeeBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'bulletListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'heroBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'plugBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'brandsBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'articlesBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'officesBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'simpleTitleAndTextBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'newsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'newsAndReportsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'documentLinkBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'sliderBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'reportsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'gridContainerBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'subheadingBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'sustainabilityReportsBlock' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ctaButton' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CtaButtonRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'dynamicImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'max' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '1800' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'focalPoint' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'focalPoint' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'y' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'hex' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ColorField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hex' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageLoad' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'focalPoint' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'focalPoint' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroImageTablet' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'overlay' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OverlayRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'color' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'opacity' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'uploadVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UploadVideoField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mp4Url' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'mp4Low' },
            name: { kind: 'Name', value: 'mp4Url' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'res' },
                value: { kind: 'EnumValue', value: 'low' },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'streamingUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'thumbnailUrl' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBasic' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSixteenByNine' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '16:9',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'muxVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'muxPlaybackId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSquare' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '1:1',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brand' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'brandName' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSquare' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobOpportunitiesPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'department' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'fileLink' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'uploadId' },
            name: { kind: 'Name', value: 'id' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListingRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pdf' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'office' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'websiteUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HeroBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'boxColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'textColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ImageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'textBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'smallHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'text' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'mediaWithCaption' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MediaWithCaptionRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'media' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caption' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'centerText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'textOnImage' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'standalone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'largeTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'itemsToShow' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'standalone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'largeTitle' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridTwoColBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridTwocolBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'mediaWithCaption' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'newsListBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'reportsListBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridThreeColBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridThreecolBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'mediaWithCaption' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridTwoColBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridFourColBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridFourcolBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'mediaWithCaption' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnImageAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnImageAndTextRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reverse' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'statementBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StatementBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blackBackground' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          { kind: 'Field', name: { kind: 'Name', value: 'small' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkUrl' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageMobile' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '1728' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageTablet' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroImageTablet' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageDesktop' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '1620' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnTextIntroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnTextIntroRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'videoBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VideoRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'autoplay' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'video' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'uploadVideo' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'videoThumbnail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSixteenByNine' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'muxVideo' },
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'employeeBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'EmployeeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'description' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'profileImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'bulletListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BulletListRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bullets' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberedList' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'plugBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PlugBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brandsBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandsBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hideLabels' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'articlesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ArticlesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isJobArticles' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'jobPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'newsPageListing' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'reportsPageListing' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'officesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'offices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'office' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'simpleTitleAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SimpleTitleAndTextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'topLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsAndReportsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsAndReportsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'newsTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'news' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NewsPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'publishDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'reportsTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportsImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reports' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ReportsListingRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'publishDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pdf' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'fileLink' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'documentLinkBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DocumentLinkBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'documents' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'sliderBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SliderBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'arrows' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slideAnimation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'delay' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'dots' },
            name: { kind: 'Name', value: 'navigationDots' },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'heroes' },
            name: { kind: 'Name', value: 'slides' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridContainerBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridContainerBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'backgroundColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'textColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fullwidth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gap' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridTwoColBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridThreeColBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridFourColBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'subheadingBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SubheadingBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButton' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'backgroundColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'sustainabilityReportsBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SustainabilityReportsBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reports' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BrandsListPageContentAreaFragment, unknown>;
export const BrandsListPageContentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brandsListPageContent' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandsListPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'pageLocales' },
            name: { kind: 'Name', value: '_locales' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'seo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'seo' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentArea' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brandsListPageContentArea' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ctaButton' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CtaButtonRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'textBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'smallHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'text' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'dynamicImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'max' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '1800' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'focalPoint' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'focalPoint' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'y' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'hex' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ColorField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hex' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageLoad' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'focalPoint' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'focalPoint' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ImageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnImageAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnImageAndTextRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reverse' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroImageTablet' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'overlay' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OverlayRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'color' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'opacity' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'statementBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StatementBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blackBackground' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          { kind: 'Field', name: { kind: 'Name', value: 'small' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkUrl' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageMobile' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '1728' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageTablet' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroImageTablet' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageDesktop' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '1620' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnTextIntroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnTextIntroRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'uploadVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UploadVideoField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mp4Url' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'mp4Low' },
            name: { kind: 'Name', value: 'mp4Url' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'res' },
                value: { kind: 'EnumValue', value: 'low' },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'streamingUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'thumbnailUrl' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBasic' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSixteenByNine' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '16:9',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'muxVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'muxPlaybackId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'videoBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VideoRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'autoplay' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'video' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'uploadVideo' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'videoThumbnail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSixteenByNine' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'muxVideo' },
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'employeeBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'EmployeeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'description' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'profileImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'bulletListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BulletListRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bullets' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberedList' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HeroBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'boxColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'textColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSquare' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '1:1',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brand' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'brandName' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSquare' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'plugBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PlugBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brandsBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandsBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hideLabels' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobOpportunitiesPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'department' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'fileLink' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'uploadId' },
            name: { kind: 'Name', value: 'id' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListingRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pdf' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'articlesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ArticlesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isJobArticles' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'jobPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'newsPageListing' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'reportsPageListing' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'office' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'websiteUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'officesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'offices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'office' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'simpleTitleAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SimpleTitleAndTextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'topLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'standalone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'largeTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'itemsToShow' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsAndReportsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsAndReportsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'newsTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'news' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NewsPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'publishDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'reportsTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportsImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reports' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ReportsListingRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'publishDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pdf' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'fileLink' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'documentLinkBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DocumentLinkBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'documents' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'sliderBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SliderBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'arrows' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slideAnimation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'delay' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'dots' },
            name: { kind: 'Name', value: 'navigationDots' },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'heroes' },
            name: { kind: 'Name', value: 'slides' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'standalone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'largeTitle' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'mediaWithCaption' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MediaWithCaptionRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'media' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caption' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'centerText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'textOnImage' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridTwoColBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridTwocolBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'mediaWithCaption' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'newsListBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'reportsListBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridThreeColBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridThreecolBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'mediaWithCaption' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridTwoColBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridFourColBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridFourcolBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'mediaWithCaption' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridContainerBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridContainerBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'backgroundColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'textColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fullwidth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gap' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridTwoColBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridThreeColBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridFourColBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'subheadingBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SubheadingBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButton' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'backgroundColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'sustainabilityReportsBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SustainabilityReportsBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reports' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'seo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SeoField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brandsListPageContentArea' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandsListPageModelContentAreaField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'textBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'twoColumnImageAndTextBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'statementBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'twoColumnTextIntroBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'videoBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'employeeBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'bulletListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'heroBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'plugBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'brandsBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'articlesBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'officesBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'simpleTitleAndTextBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'newsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'newsAndReportsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'documentLinkBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'sliderBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'reportsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'gridContainerBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'subheadingBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'sustainabilityReportsBlock' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BrandsListPageContentFragment, unknown>;
export const CampaignPageContentAreaFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'campaignPageContentArea' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CampaignPageModelContentAreaField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'articlesBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'brandsBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'bulletListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'documentLinkBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'employeeBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'heroBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'gridContainerBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'jobsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'newsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'newsAndReportsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'officesBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'plugBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'simpleTitleAndTextBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'statementBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'textBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'twoColumnImageAndTextBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'twoColumnTextIntroBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'videoBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'sliderBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'subheadingBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'sustainabilityReportsBlock' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobOpportunitiesPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'department' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'focalPoint' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'focalPoint' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'y' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'hex' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ColorField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hex' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageLoad' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'focalPoint' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'focalPoint' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'fileLink' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'uploadId' },
            name: { kind: 'Name', value: 'id' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListingRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pdf' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBasic' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSquare' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '1:1',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brand' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'brandName' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSquare' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'overlay' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OverlayRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'color' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'opacity' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ctaButton' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CtaButtonRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'muxVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'muxPlaybackId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'dynamicImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'max' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '1800' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ImageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'textBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'smallHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'text' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'mediaWithCaption' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MediaWithCaptionRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'media' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caption' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'centerText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'textOnImage' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'standalone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'largeTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'itemsToShow' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'standalone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'largeTitle' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridTwoColBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridTwocolBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'mediaWithCaption' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'newsListBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'reportsListBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridThreeColBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridThreecolBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'mediaWithCaption' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridTwoColBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridFourColBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridFourcolBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'mediaWithCaption' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'office' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'websiteUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroImageTablet' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'uploadVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UploadVideoField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mp4Url' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'mp4Low' },
            name: { kind: 'Name', value: 'mp4Url' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'res' },
                value: { kind: 'EnumValue', value: 'low' },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'streamingUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'thumbnailUrl' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSixteenByNine' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '16:9',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HeroBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'boxColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'textColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'articlesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ArticlesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isJobArticles' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'jobPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'newsPageListing' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'reportsPageListing' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brandsBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandsBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hideLabels' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'bulletListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BulletListRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bullets' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberedList' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'documentLinkBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DocumentLinkBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'documents' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'employeeBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'EmployeeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'description' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'profileImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridContainerBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridContainerBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'backgroundColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'textColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fullwidth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gap' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridTwoColBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridThreeColBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridFourColBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsAndReportsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsAndReportsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'newsTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'news' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NewsPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'publishDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'reportsTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportsImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reports' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ReportsListingRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'publishDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pdf' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'fileLink' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'officesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'offices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'office' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'plugBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PlugBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'simpleTitleAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SimpleTitleAndTextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'topLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'statementBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StatementBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blackBackground' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          { kind: 'Field', name: { kind: 'Name', value: 'small' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkUrl' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageMobile' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '1728' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageTablet' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroImageTablet' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageDesktop' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '1620' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnImageAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnImageAndTextRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reverse' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnTextIntroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnTextIntroRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'videoBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VideoRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'autoplay' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'video' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'uploadVideo' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'videoThumbnail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSixteenByNine' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'muxVideo' },
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'sliderBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SliderBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'arrows' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slideAnimation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'delay' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'dots' },
            name: { kind: 'Name', value: 'navigationDots' },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'heroes' },
            name: { kind: 'Name', value: 'slides' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'subheadingBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SubheadingBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButton' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'backgroundColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'sustainabilityReportsBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SustainabilityReportsBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reports' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CampaignPageContentAreaFragment, unknown>;
export const CampaignPageContentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'campaignPageContent' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CampaignPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'pageLocales' },
            name: { kind: 'Name', value: '_locales' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'seo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'seo' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentArea' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'campaignPageContentArea' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobOpportunitiesPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'department' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'focalPoint' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'focalPoint' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'y' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'hex' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ColorField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hex' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageLoad' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'focalPoint' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'focalPoint' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'fileLink' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'uploadId' },
            name: { kind: 'Name', value: 'id' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListingRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pdf' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'articlesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ArticlesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isJobArticles' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'jobPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'newsPageListing' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'reportsPageListing' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBasic' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSquare' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '1:1',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brand' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'brandName' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSquare' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brandsBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandsBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hideLabels' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'bulletListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BulletListRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bullets' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberedList' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'documentLinkBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DocumentLinkBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'documents' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'employeeBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'EmployeeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'description' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'profileImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'overlay' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OverlayRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'color' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'opacity' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ctaButton' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CtaButtonRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'muxVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'muxPlaybackId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HeroBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'boxColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'textColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'dynamicImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'max' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '1800' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ImageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'textBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'smallHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'text' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'mediaWithCaption' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MediaWithCaptionRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'media' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caption' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'centerText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'textOnImage' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'standalone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'largeTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'itemsToShow' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'standalone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'largeTitle' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridTwoColBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridTwocolBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'mediaWithCaption' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'newsListBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'reportsListBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridThreeColBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridThreecolBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'mediaWithCaption' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridTwoColBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridFourColBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridFourcolBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'mediaWithCaption' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridContainerBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridContainerBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'backgroundColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'textColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fullwidth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gap' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridTwoColBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridThreeColBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridFourColBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsAndReportsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsAndReportsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'newsTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'news' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NewsPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'publishDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'reportsTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportsImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reports' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ReportsListingRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'publishDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pdf' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'fileLink' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'office' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'websiteUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'officesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'offices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'office' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'plugBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PlugBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'simpleTitleAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SimpleTitleAndTextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'topLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroImageTablet' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'statementBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StatementBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blackBackground' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          { kind: 'Field', name: { kind: 'Name', value: 'small' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkUrl' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageMobile' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '1728' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageTablet' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroImageTablet' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageDesktop' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '1620' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnImageAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnImageAndTextRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reverse' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnTextIntroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnTextIntroRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'uploadVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UploadVideoField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mp4Url' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'mp4Low' },
            name: { kind: 'Name', value: 'mp4Url' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'res' },
                value: { kind: 'EnumValue', value: 'low' },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'streamingUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'thumbnailUrl' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSixteenByNine' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '16:9',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'videoBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VideoRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'autoplay' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'video' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'uploadVideo' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'videoThumbnail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSixteenByNine' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'muxVideo' },
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'sliderBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SliderBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'arrows' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slideAnimation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'delay' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'dots' },
            name: { kind: 'Name', value: 'navigationDots' },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'heroes' },
            name: { kind: 'Name', value: 'slides' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'subheadingBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SubheadingBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButton' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'backgroundColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'sustainabilityReportsBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SustainabilityReportsBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reports' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'seo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SeoField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'campaignPageContentArea' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CampaignPageModelContentAreaField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'articlesBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'brandsBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'bulletListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'documentLinkBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'employeeBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'heroBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'gridContainerBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'jobsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'newsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'newsAndReportsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'officesBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'plugBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'simpleTitleAndTextBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'statementBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'textBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'twoColumnImageAndTextBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'twoColumnTextIntroBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'videoBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'sliderBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'subheadingBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'sustainabilityReportsBlock' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CampaignPageContentFragment, unknown>;
export const ContactPageContentAreaFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'contactPageContentArea' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ContactPageModelContentAreaField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'articlesBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'brandsBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'bulletListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'documentLinkBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'employeeBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'heroBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'gridContainerBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'jobsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'newsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'officesBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'plugBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'simpleTitleAndTextBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'statementBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'textBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'twoColumnImageAndTextBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'twoColumnTextIntroBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'videoBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'sliderBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'subheadingBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'sustainabilityReportsBlock' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobOpportunitiesPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'department' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'focalPoint' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'focalPoint' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'y' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'hex' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ColorField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hex' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageLoad' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'focalPoint' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'focalPoint' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'fileLink' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'uploadId' },
            name: { kind: 'Name', value: 'id' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListingRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pdf' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBasic' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSquare' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '1:1',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brand' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'brandName' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSquare' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'overlay' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OverlayRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'color' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'opacity' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ctaButton' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CtaButtonRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'muxVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'muxPlaybackId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'dynamicImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'max' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '1800' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ImageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'textBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'smallHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'text' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'mediaWithCaption' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MediaWithCaptionRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'media' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caption' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'centerText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'textOnImage' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'standalone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'largeTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'itemsToShow' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'standalone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'largeTitle' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridTwoColBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridTwocolBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'mediaWithCaption' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'newsListBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'reportsListBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridThreeColBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridThreecolBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'mediaWithCaption' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridTwoColBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridFourColBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridFourcolBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'mediaWithCaption' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'office' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'websiteUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroImageTablet' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'uploadVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UploadVideoField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mp4Url' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'mp4Low' },
            name: { kind: 'Name', value: 'mp4Url' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'res' },
                value: { kind: 'EnumValue', value: 'low' },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'streamingUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'thumbnailUrl' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSixteenByNine' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '16:9',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HeroBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'boxColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'textColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'articlesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ArticlesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isJobArticles' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'jobPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'newsPageListing' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'reportsPageListing' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brandsBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandsBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hideLabels' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'bulletListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BulletListRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bullets' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberedList' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'documentLinkBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DocumentLinkBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'documents' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'employeeBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'EmployeeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'description' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'profileImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridContainerBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridContainerBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'backgroundColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'textColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fullwidth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gap' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridTwoColBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridThreeColBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridFourColBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'officesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'offices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'office' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'plugBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PlugBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'simpleTitleAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SimpleTitleAndTextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'topLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'statementBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StatementBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blackBackground' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          { kind: 'Field', name: { kind: 'Name', value: 'small' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkUrl' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageMobile' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '1728' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageTablet' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroImageTablet' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageDesktop' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '1620' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnImageAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnImageAndTextRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reverse' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnTextIntroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnTextIntroRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'videoBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VideoRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'autoplay' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'video' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'uploadVideo' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'videoThumbnail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSixteenByNine' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'muxVideo' },
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'sliderBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SliderBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'arrows' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slideAnimation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'delay' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'dots' },
            name: { kind: 'Name', value: 'navigationDots' },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'heroes' },
            name: { kind: 'Name', value: 'slides' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'subheadingBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SubheadingBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButton' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'backgroundColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'sustainabilityReportsBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SustainabilityReportsBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reports' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContactPageContentAreaFragment, unknown>;
export const ContactPageContentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'contactPageContent' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ContactPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'pageLocales' },
            name: { kind: 'Name', value: '_locales' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'seo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'seo' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentArea' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'contactPageContentArea' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobOpportunitiesPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'department' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'focalPoint' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'focalPoint' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'y' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'hex' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ColorField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hex' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageLoad' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'focalPoint' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'focalPoint' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'fileLink' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'uploadId' },
            name: { kind: 'Name', value: 'id' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListingRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pdf' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'articlesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ArticlesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isJobArticles' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'jobPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'newsPageListing' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'reportsPageListing' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBasic' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSquare' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '1:1',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brand' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'brandName' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSquare' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brandsBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandsBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hideLabels' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'bulletListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BulletListRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bullets' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberedList' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'documentLinkBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DocumentLinkBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'documents' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'employeeBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'EmployeeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'description' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'profileImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'overlay' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OverlayRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'color' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'opacity' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ctaButton' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CtaButtonRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'muxVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'muxPlaybackId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HeroBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'boxColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'textColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'dynamicImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'max' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '1800' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ImageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'textBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'smallHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'text' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'mediaWithCaption' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MediaWithCaptionRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'media' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caption' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'centerText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'textOnImage' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'standalone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'largeTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'itemsToShow' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'standalone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'largeTitle' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridTwoColBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridTwocolBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'mediaWithCaption' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'newsListBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'reportsListBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridThreeColBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridThreecolBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'mediaWithCaption' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridTwoColBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridFourColBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridFourcolBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'mediaWithCaption' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridContainerBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridContainerBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'backgroundColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'textColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fullwidth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gap' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridTwoColBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridThreeColBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridFourColBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'office' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'websiteUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'officesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'offices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'office' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'plugBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PlugBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'simpleTitleAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SimpleTitleAndTextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'topLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroImageTablet' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'statementBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StatementBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blackBackground' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          { kind: 'Field', name: { kind: 'Name', value: 'small' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkUrl' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageMobile' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '1728' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageTablet' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroImageTablet' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageDesktop' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '1620' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnImageAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnImageAndTextRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reverse' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnTextIntroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnTextIntroRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'uploadVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UploadVideoField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mp4Url' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'mp4Low' },
            name: { kind: 'Name', value: 'mp4Url' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'res' },
                value: { kind: 'EnumValue', value: 'low' },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'streamingUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'thumbnailUrl' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSixteenByNine' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '16:9',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'videoBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VideoRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'autoplay' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'video' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'uploadVideo' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'videoThumbnail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSixteenByNine' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'muxVideo' },
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'sliderBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SliderBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'arrows' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slideAnimation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'delay' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'dots' },
            name: { kind: 'Name', value: 'navigationDots' },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'heroes' },
            name: { kind: 'Name', value: 'slides' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'subheadingBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SubheadingBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButton' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'backgroundColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'sustainabilityReportsBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SustainabilityReportsBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reports' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'seo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SeoField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'contactPageContentArea' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ContactPageModelContentAreaField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'articlesBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'brandsBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'bulletListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'documentLinkBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'employeeBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'heroBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'gridContainerBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'jobsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'newsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'officesBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'plugBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'simpleTitleAndTextBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'statementBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'textBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'twoColumnImageAndTextBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'twoColumnTextIntroBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'videoBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'sliderBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'subheadingBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'sustainabilityReportsBlock' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContactPageContentFragment, unknown>;
export const JobOpportunitiesListPageContentAreaFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobOpportunitiesListPageContentArea' },
      typeCondition: {
        kind: 'NamedType',
        name: {
          kind: 'Name',
          value: 'JobOpportunitiesListPageModelContentAreaField',
        },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'articlesBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'brandsBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'bulletListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'documentLinkBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'employeeBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'heroBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'jobsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'newsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'officesBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'plugBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'simpleTitleAndTextBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'statementBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'textBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'twoColumnImageAndTextBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'twoColumnTextIntroBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'videoBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'sliderBlock' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobOpportunitiesPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'department' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'focalPoint' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'focalPoint' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'y' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'hex' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ColorField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hex' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageLoad' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'focalPoint' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'focalPoint' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'fileLink' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'uploadId' },
            name: { kind: 'Name', value: 'id' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListingRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pdf' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBasic' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSquare' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '1:1',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brand' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'brandName' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSquare' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'overlay' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OverlayRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'color' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'opacity' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ctaButton' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CtaButtonRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'muxVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'muxPlaybackId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'dynamicImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'max' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '1800' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'office' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'websiteUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroImageTablet' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'uploadVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UploadVideoField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mp4Url' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'mp4Low' },
            name: { kind: 'Name', value: 'mp4Url' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'res' },
                value: { kind: 'EnumValue', value: 'low' },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'streamingUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'thumbnailUrl' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSixteenByNine' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '16:9',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HeroBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'boxColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'textColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'articlesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ArticlesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isJobArticles' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'jobPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'newsPageListing' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'reportsPageListing' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brandsBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandsBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hideLabels' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'bulletListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BulletListRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bullets' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberedList' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'documentLinkBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DocumentLinkBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'documents' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'employeeBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'EmployeeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'description' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'profileImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ImageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'standalone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'largeTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'itemsToShow' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'officesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'offices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'office' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'plugBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PlugBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'simpleTitleAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SimpleTitleAndTextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'topLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'statementBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StatementBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blackBackground' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          { kind: 'Field', name: { kind: 'Name', value: 'small' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkUrl' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageMobile' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '1728' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageTablet' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroImageTablet' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageDesktop' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '1620' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'textBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'smallHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'text' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnImageAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnImageAndTextRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reverse' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnTextIntroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnTextIntroRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'videoBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VideoRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'autoplay' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'video' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'uploadVideo' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'videoThumbnail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSixteenByNine' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'muxVideo' },
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'sliderBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SliderBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'arrows' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slideAnimation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'delay' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'dots' },
            name: { kind: 'Name', value: 'navigationDots' },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'heroes' },
            name: { kind: 'Name', value: 'slides' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroBlock' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  JobOpportunitiesListPageContentAreaFragment,
  unknown
>;
export const JobOpportunitiesListPageContentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobOpportunitiesListPageContent' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobOpportunitiesListPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'pageLocales' },
            name: { kind: 'Name', value: '_locales' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'seo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'seo' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentArea' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'jobOpportunitiesListPageContentArea',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobOpportunitiesPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'department' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'focalPoint' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'focalPoint' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'y' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'hex' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ColorField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hex' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageLoad' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'focalPoint' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'focalPoint' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'fileLink' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'uploadId' },
            name: { kind: 'Name', value: 'id' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListingRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pdf' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'articlesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ArticlesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isJobArticles' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'jobPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'newsPageListing' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'reportsPageListing' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBasic' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSquare' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '1:1',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brand' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'brandName' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSquare' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brandsBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandsBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hideLabels' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'bulletListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BulletListRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bullets' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberedList' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'documentLinkBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DocumentLinkBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'documents' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'employeeBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'EmployeeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'description' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'profileImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'overlay' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OverlayRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'color' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'opacity' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ctaButton' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CtaButtonRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'muxVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'muxPlaybackId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HeroBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'boxColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'textColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'dynamicImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'max' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '1800' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ImageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'standalone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'largeTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'itemsToShow' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'office' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'websiteUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'officesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'offices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'office' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'plugBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PlugBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'simpleTitleAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SimpleTitleAndTextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'topLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroImageTablet' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'statementBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StatementBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blackBackground' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          { kind: 'Field', name: { kind: 'Name', value: 'small' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkUrl' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageMobile' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '1728' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageTablet' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroImageTablet' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageDesktop' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '1620' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'textBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'smallHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'text' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnImageAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnImageAndTextRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reverse' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnTextIntroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnTextIntroRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'uploadVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UploadVideoField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mp4Url' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'mp4Low' },
            name: { kind: 'Name', value: 'mp4Url' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'res' },
                value: { kind: 'EnumValue', value: 'low' },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'streamingUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'thumbnailUrl' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSixteenByNine' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '16:9',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'videoBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VideoRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'autoplay' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'video' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'uploadVideo' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'videoThumbnail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSixteenByNine' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'muxVideo' },
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'sliderBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SliderBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'arrows' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slideAnimation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'delay' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'dots' },
            name: { kind: 'Name', value: 'navigationDots' },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'heroes' },
            name: { kind: 'Name', value: 'slides' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'seo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SeoField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobOpportunitiesListPageContentArea' },
      typeCondition: {
        kind: 'NamedType',
        name: {
          kind: 'Name',
          value: 'JobOpportunitiesListPageModelContentAreaField',
        },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'articlesBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'brandsBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'bulletListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'documentLinkBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'employeeBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'heroBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'jobsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'newsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'officesBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'plugBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'simpleTitleAndTextBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'statementBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'textBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'twoColumnImageAndTextBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'twoColumnTextIntroBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'videoBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'sliderBlock' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<JobOpportunitiesListPageContentFragment, unknown>;
export const JobOpportunitiesPageContentAreaFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobOpportunitiesPageContentArea' },
      typeCondition: {
        kind: 'NamedType',
        name: {
          kind: 'Name',
          value: 'JobOpportunitiesPageModelContentAreaField',
        },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'articlesBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'brandsBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'bulletListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'documentLinkBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'employeeBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'heroBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'jobsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'newsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'officesBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'plugBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'simpleTitleAndTextBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'statementBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'textBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'twoColumnImageAndTextBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'twoColumnTextIntroBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'videoBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'sliderBlock' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobOpportunitiesPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'department' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'focalPoint' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'focalPoint' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'y' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'hex' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ColorField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hex' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageLoad' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'focalPoint' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'focalPoint' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'fileLink' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'uploadId' },
            name: { kind: 'Name', value: 'id' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListingRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pdf' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBasic' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSquare' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '1:1',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brand' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'brandName' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSquare' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'overlay' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OverlayRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'color' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'opacity' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ctaButton' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CtaButtonRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'muxVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'muxPlaybackId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'dynamicImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'max' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '1800' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'office' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'websiteUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroImageTablet' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'uploadVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UploadVideoField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mp4Url' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'mp4Low' },
            name: { kind: 'Name', value: 'mp4Url' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'res' },
                value: { kind: 'EnumValue', value: 'low' },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'streamingUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'thumbnailUrl' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSixteenByNine' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '16:9',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HeroBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'boxColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'textColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'articlesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ArticlesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isJobArticles' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'jobPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'newsPageListing' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'reportsPageListing' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brandsBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandsBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hideLabels' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'bulletListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BulletListRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bullets' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberedList' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'documentLinkBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DocumentLinkBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'documents' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'employeeBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'EmployeeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'description' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'profileImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ImageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'standalone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'largeTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'itemsToShow' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'officesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'offices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'office' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'plugBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PlugBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'simpleTitleAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SimpleTitleAndTextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'topLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'statementBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StatementBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blackBackground' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          { kind: 'Field', name: { kind: 'Name', value: 'small' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkUrl' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageMobile' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '1728' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageTablet' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroImageTablet' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageDesktop' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '1620' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'textBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'smallHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'text' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnImageAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnImageAndTextRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reverse' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnTextIntroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnTextIntroRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'videoBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VideoRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'autoplay' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'video' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'uploadVideo' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'videoThumbnail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSixteenByNine' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'muxVideo' },
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'sliderBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SliderBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'arrows' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slideAnimation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'delay' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'dots' },
            name: { kind: 'Name', value: 'navigationDots' },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'heroes' },
            name: { kind: 'Name', value: 'slides' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroBlock' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<JobOpportunitiesPageContentAreaFragment, unknown>;
export const JobOpportunitiesPageContentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobOpportunitiesPageContent' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobOpportunitiesPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'pageLocales' },
            name: { kind: 'Name', value: '_locales' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'seo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'seo' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationDeadline' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentArea' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'jobOpportunitiesPageContentArea',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobOpportunitiesPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'department' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'focalPoint' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'focalPoint' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'y' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'hex' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ColorField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hex' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageLoad' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'focalPoint' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'focalPoint' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'fileLink' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'uploadId' },
            name: { kind: 'Name', value: 'id' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListingRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pdf' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'articlesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ArticlesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isJobArticles' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'jobPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'newsPageListing' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'reportsPageListing' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBasic' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSquare' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '1:1',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brand' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'brandName' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSquare' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brandsBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandsBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hideLabels' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'bulletListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BulletListRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bullets' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberedList' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'documentLinkBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DocumentLinkBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'documents' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'employeeBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'EmployeeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'description' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'profileImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'overlay' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OverlayRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'color' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'opacity' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ctaButton' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CtaButtonRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'muxVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'muxPlaybackId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HeroBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'boxColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'textColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'dynamicImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'max' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '1800' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ImageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'standalone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'largeTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'itemsToShow' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'office' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'websiteUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'officesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'offices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'office' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'plugBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PlugBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'simpleTitleAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SimpleTitleAndTextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'topLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroImageTablet' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'statementBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StatementBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blackBackground' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          { kind: 'Field', name: { kind: 'Name', value: 'small' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkUrl' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageMobile' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '1728' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageTablet' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroImageTablet' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageDesktop' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '1620' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'textBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'smallHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'text' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnImageAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnImageAndTextRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reverse' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnTextIntroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnTextIntroRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'uploadVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UploadVideoField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mp4Url' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'mp4Low' },
            name: { kind: 'Name', value: 'mp4Url' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'res' },
                value: { kind: 'EnumValue', value: 'low' },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'streamingUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'thumbnailUrl' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSixteenByNine' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '16:9',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'videoBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VideoRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'autoplay' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'video' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'uploadVideo' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'videoThumbnail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSixteenByNine' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'muxVideo' },
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'sliderBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SliderBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'arrows' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slideAnimation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'delay' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'dots' },
            name: { kind: 'Name', value: 'navigationDots' },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'heroes' },
            name: { kind: 'Name', value: 'slides' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'seo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SeoField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobOpportunitiesPageContentArea' },
      typeCondition: {
        kind: 'NamedType',
        name: {
          kind: 'Name',
          value: 'JobOpportunitiesPageModelContentAreaField',
        },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'articlesBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'brandsBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'bulletListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'documentLinkBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'employeeBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'heroBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'jobsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'newsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'officesBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'plugBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'simpleTitleAndTextBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'statementBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'textBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'twoColumnImageAndTextBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'twoColumnTextIntroBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'videoBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'sliderBlock' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<JobOpportunitiesPageContentFragment, unknown>;
export const LandingPageContentAreaFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'landingPageContentArea' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LandingPageModelContentAreaField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'articlesBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'brandsBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'bulletListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'documentLinkBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'employeeBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'heroBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'gridContainerBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'jobsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'newsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'newsAndReportsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'officesBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'plugBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'simpleTitleAndTextBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'statementBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'textBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'twoColumnImageAndTextBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'twoColumnTextIntroBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'videoBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'sliderBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'subheadingBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'sustainabilityReportsBlock' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobOpportunitiesPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'department' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'focalPoint' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'focalPoint' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'y' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'hex' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ColorField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hex' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageLoad' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'focalPoint' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'focalPoint' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'fileLink' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'uploadId' },
            name: { kind: 'Name', value: 'id' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListingRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pdf' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBasic' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSquare' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '1:1',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brand' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'brandName' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSquare' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'overlay' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OverlayRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'color' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'opacity' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ctaButton' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CtaButtonRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'muxVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'muxPlaybackId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'dynamicImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'max' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '1800' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ImageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'textBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'smallHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'text' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'mediaWithCaption' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MediaWithCaptionRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'media' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caption' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'centerText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'textOnImage' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'standalone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'largeTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'itemsToShow' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'standalone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'largeTitle' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridTwoColBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridTwocolBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'mediaWithCaption' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'newsListBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'reportsListBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridThreeColBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridThreecolBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'mediaWithCaption' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridTwoColBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridFourColBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridFourcolBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'mediaWithCaption' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'office' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'websiteUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroImageTablet' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'uploadVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UploadVideoField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mp4Url' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'mp4Low' },
            name: { kind: 'Name', value: 'mp4Url' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'res' },
                value: { kind: 'EnumValue', value: 'low' },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'streamingUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'thumbnailUrl' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSixteenByNine' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '16:9',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HeroBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'boxColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'textColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'articlesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ArticlesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isJobArticles' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'jobPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'newsPageListing' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'reportsPageListing' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brandsBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandsBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hideLabels' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'bulletListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BulletListRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bullets' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberedList' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'documentLinkBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DocumentLinkBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'documents' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'employeeBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'EmployeeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'description' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'profileImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridContainerBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridContainerBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'backgroundColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'textColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fullwidth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gap' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridTwoColBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridThreeColBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridFourColBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsAndReportsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsAndReportsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'newsTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'news' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NewsPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'publishDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'reportsTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportsImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reports' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ReportsListingRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'publishDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pdf' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'fileLink' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'officesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'offices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'office' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'plugBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PlugBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'simpleTitleAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SimpleTitleAndTextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'topLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'statementBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StatementBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blackBackground' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          { kind: 'Field', name: { kind: 'Name', value: 'small' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkUrl' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageMobile' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '1728' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageTablet' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroImageTablet' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageDesktop' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '1620' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnImageAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnImageAndTextRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reverse' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnTextIntroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnTextIntroRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'videoBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VideoRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'autoplay' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'video' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'uploadVideo' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'videoThumbnail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSixteenByNine' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'muxVideo' },
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'sliderBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SliderBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'arrows' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slideAnimation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'delay' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'dots' },
            name: { kind: 'Name', value: 'navigationDots' },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'heroes' },
            name: { kind: 'Name', value: 'slides' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'subheadingBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SubheadingBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButton' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'backgroundColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'sustainabilityReportsBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SustainabilityReportsBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reports' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LandingPageContentAreaFragment, unknown>;
export const LandingPageContentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'landingPageContent' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LandingPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'pageLocales' },
            name: { kind: 'Name', value: '_locales' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'seo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'seo' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentArea' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'landingPageContentArea' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobOpportunitiesPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'department' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'focalPoint' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'focalPoint' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'y' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'hex' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ColorField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hex' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageLoad' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'focalPoint' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'focalPoint' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'fileLink' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'uploadId' },
            name: { kind: 'Name', value: 'id' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListingRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pdf' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'articlesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ArticlesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isJobArticles' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'jobPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'newsPageListing' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'reportsPageListing' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBasic' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSquare' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '1:1',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brand' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'brandName' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSquare' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brandsBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandsBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hideLabels' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'bulletListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BulletListRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bullets' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberedList' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'documentLinkBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DocumentLinkBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'documents' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'employeeBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'EmployeeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'description' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'profileImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'overlay' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OverlayRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'color' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'opacity' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ctaButton' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CtaButtonRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'muxVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'muxPlaybackId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HeroBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'boxColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'textColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'dynamicImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'max' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '1800' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ImageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'textBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'smallHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'text' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'mediaWithCaption' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MediaWithCaptionRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'media' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caption' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'centerText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'textOnImage' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'standalone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'largeTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'itemsToShow' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'standalone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'largeTitle' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridTwoColBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridTwocolBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'mediaWithCaption' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'newsListBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'reportsListBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridThreeColBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridThreecolBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'mediaWithCaption' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridTwoColBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridFourColBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridFourcolBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'mediaWithCaption' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridContainerBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridContainerBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'backgroundColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'textColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fullwidth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gap' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridTwoColBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridThreeColBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridFourColBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsAndReportsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsAndReportsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'newsTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'news' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NewsPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'publishDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'reportsTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportsImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reports' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ReportsListingRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'publishDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pdf' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'fileLink' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'office' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'websiteUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'officesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'offices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'office' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'plugBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PlugBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'simpleTitleAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SimpleTitleAndTextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'topLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroImageTablet' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'statementBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StatementBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blackBackground' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          { kind: 'Field', name: { kind: 'Name', value: 'small' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkUrl' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageMobile' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '1728' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageTablet' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroImageTablet' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageDesktop' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '1620' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnImageAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnImageAndTextRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reverse' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnTextIntroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnTextIntroRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'uploadVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UploadVideoField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mp4Url' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'mp4Low' },
            name: { kind: 'Name', value: 'mp4Url' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'res' },
                value: { kind: 'EnumValue', value: 'low' },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'streamingUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'thumbnailUrl' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSixteenByNine' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '16:9',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'videoBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VideoRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'autoplay' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'video' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'uploadVideo' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'videoThumbnail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSixteenByNine' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'muxVideo' },
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'sliderBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SliderBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'arrows' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slideAnimation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'delay' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'dots' },
            name: { kind: 'Name', value: 'navigationDots' },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'heroes' },
            name: { kind: 'Name', value: 'slides' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'subheadingBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SubheadingBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButton' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'backgroundColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'sustainabilityReportsBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SustainabilityReportsBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reports' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'seo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SeoField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'landingPageContentArea' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LandingPageModelContentAreaField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'articlesBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'brandsBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'bulletListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'documentLinkBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'employeeBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'heroBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'gridContainerBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'jobsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'newsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'newsAndReportsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'officesBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'plugBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'simpleTitleAndTextBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'statementBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'textBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'twoColumnImageAndTextBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'twoColumnTextIntroBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'videoBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'sliderBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'subheadingBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'sustainabilityReportsBlock' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LandingPageContentFragment, unknown>;
export const NewsListPageContentAreaFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsListPageContentArea' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsListPageModelContentAreaField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'articlesBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'brandsBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'bulletListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'documentLinkBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'employeeBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'heroBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'jobsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'newsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'newsAndReportsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'officesBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'plugBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'simpleTitleAndTextBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'statementBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'textBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'twoColumnImageAndTextBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'twoColumnTextIntroBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'videoBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'sliderBlock' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobOpportunitiesPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'department' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'focalPoint' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'focalPoint' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'y' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'hex' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ColorField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hex' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageLoad' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'focalPoint' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'focalPoint' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'fileLink' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'uploadId' },
            name: { kind: 'Name', value: 'id' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListingRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pdf' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBasic' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSquare' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '1:1',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brand' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'brandName' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSquare' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'overlay' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OverlayRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'color' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'opacity' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ctaButton' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CtaButtonRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'muxVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'muxPlaybackId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'dynamicImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'max' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '1800' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'office' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'websiteUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroImageTablet' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'uploadVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UploadVideoField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mp4Url' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'mp4Low' },
            name: { kind: 'Name', value: 'mp4Url' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'res' },
                value: { kind: 'EnumValue', value: 'low' },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'streamingUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'thumbnailUrl' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSixteenByNine' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '16:9',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HeroBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'boxColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'textColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'articlesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ArticlesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isJobArticles' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'jobPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'newsPageListing' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'reportsPageListing' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brandsBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandsBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hideLabels' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'bulletListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BulletListRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bullets' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberedList' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'documentLinkBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DocumentLinkBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'documents' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'employeeBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'EmployeeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'description' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'profileImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ImageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'standalone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'largeTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'itemsToShow' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsAndReportsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsAndReportsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'newsTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'news' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NewsPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'publishDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'reportsTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportsImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reports' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ReportsListingRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'publishDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pdf' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'fileLink' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'officesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'offices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'office' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'plugBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PlugBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'simpleTitleAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SimpleTitleAndTextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'topLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'statementBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StatementBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blackBackground' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          { kind: 'Field', name: { kind: 'Name', value: 'small' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkUrl' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageMobile' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '1728' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageTablet' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroImageTablet' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageDesktop' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '1620' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'textBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'smallHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'text' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnImageAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnImageAndTextRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reverse' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnTextIntroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnTextIntroRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'videoBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VideoRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'autoplay' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'video' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'uploadVideo' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'videoThumbnail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSixteenByNine' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'muxVideo' },
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'sliderBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SliderBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'arrows' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slideAnimation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'delay' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'dots' },
            name: { kind: 'Name', value: 'navigationDots' },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'heroes' },
            name: { kind: 'Name', value: 'slides' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroBlock' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NewsListPageContentAreaFragment, unknown>;
export const NewsListPageContentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsListPageContent' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsListPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'pageLocales' },
            name: { kind: 'Name', value: '_locales' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'seo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'seo' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentArea' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'newsListPageContentArea' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobOpportunitiesPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'department' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'focalPoint' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'focalPoint' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'y' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'hex' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ColorField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hex' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageLoad' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'focalPoint' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'focalPoint' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'fileLink' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'uploadId' },
            name: { kind: 'Name', value: 'id' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListingRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pdf' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'articlesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ArticlesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isJobArticles' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'jobPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'newsPageListing' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'reportsPageListing' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBasic' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSquare' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '1:1',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brand' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'brandName' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSquare' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brandsBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandsBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hideLabels' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'bulletListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BulletListRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bullets' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberedList' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'documentLinkBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DocumentLinkBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'documents' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'employeeBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'EmployeeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'description' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'profileImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'overlay' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OverlayRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'color' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'opacity' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ctaButton' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CtaButtonRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'muxVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'muxPlaybackId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HeroBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'boxColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'textColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'dynamicImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'max' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '1800' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ImageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'standalone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'largeTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'itemsToShow' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsAndReportsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsAndReportsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'newsTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'news' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NewsPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'publishDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'reportsTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportsImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reports' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ReportsListingRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'publishDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pdf' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'fileLink' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'office' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'websiteUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'officesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'offices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'office' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'plugBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PlugBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'simpleTitleAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SimpleTitleAndTextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'topLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroImageTablet' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'statementBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StatementBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blackBackground' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          { kind: 'Field', name: { kind: 'Name', value: 'small' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkUrl' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageMobile' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '1728' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageTablet' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroImageTablet' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageDesktop' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '1620' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'textBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'smallHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'text' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnImageAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnImageAndTextRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reverse' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnTextIntroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnTextIntroRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'uploadVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UploadVideoField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mp4Url' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'mp4Low' },
            name: { kind: 'Name', value: 'mp4Url' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'res' },
                value: { kind: 'EnumValue', value: 'low' },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'streamingUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'thumbnailUrl' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSixteenByNine' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '16:9',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'videoBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VideoRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'autoplay' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'video' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'uploadVideo' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'videoThumbnail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSixteenByNine' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'muxVideo' },
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'sliderBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SliderBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'arrows' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slideAnimation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'delay' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'dots' },
            name: { kind: 'Name', value: 'navigationDots' },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'heroes' },
            name: { kind: 'Name', value: 'slides' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'seo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SeoField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsListPageContentArea' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsListPageModelContentAreaField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'articlesBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'brandsBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'bulletListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'documentLinkBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'employeeBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'heroBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'jobsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'newsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'newsAndReportsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'officesBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'plugBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'simpleTitleAndTextBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'statementBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'textBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'twoColumnImageAndTextBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'twoColumnTextIntroBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'videoBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'sliderBlock' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NewsListPageContentFragment, unknown>;
export const NewsPageContentAreaFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsPageContentArea' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsPageModelContentAreaField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'articlesBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'brandsBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'bulletListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'documentLinkBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'employeeBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'heroBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'jobsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'newsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'newsAndReportsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'officesBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'plugBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'simpleTitleAndTextBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'statementBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'textBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'twoColumnImageAndTextBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'twoColumnTextIntroBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'videoBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'sliderBlock' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobOpportunitiesPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'department' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'focalPoint' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'focalPoint' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'y' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'hex' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ColorField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hex' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageLoad' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'focalPoint' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'focalPoint' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'fileLink' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'uploadId' },
            name: { kind: 'Name', value: 'id' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListingRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pdf' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBasic' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSquare' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '1:1',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brand' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'brandName' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSquare' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'overlay' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OverlayRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'color' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'opacity' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ctaButton' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CtaButtonRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'muxVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'muxPlaybackId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'dynamicImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'max' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '1800' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'office' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'websiteUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroImageTablet' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'uploadVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UploadVideoField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mp4Url' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'mp4Low' },
            name: { kind: 'Name', value: 'mp4Url' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'res' },
                value: { kind: 'EnumValue', value: 'low' },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'streamingUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'thumbnailUrl' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSixteenByNine' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '16:9',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HeroBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'boxColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'textColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'articlesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ArticlesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isJobArticles' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'jobPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'newsPageListing' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'reportsPageListing' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brandsBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandsBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hideLabels' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'bulletListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BulletListRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bullets' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberedList' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'documentLinkBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DocumentLinkBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'documents' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'employeeBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'EmployeeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'description' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'profileImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ImageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'standalone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'largeTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'itemsToShow' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsAndReportsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsAndReportsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'newsTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'news' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NewsPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'publishDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'reportsTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportsImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reports' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ReportsListingRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'publishDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pdf' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'fileLink' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'officesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'offices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'office' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'plugBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PlugBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'simpleTitleAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SimpleTitleAndTextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'topLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'statementBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StatementBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blackBackground' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          { kind: 'Field', name: { kind: 'Name', value: 'small' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkUrl' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageMobile' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '1728' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageTablet' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroImageTablet' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageDesktop' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '1620' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'textBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'smallHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'text' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnImageAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnImageAndTextRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reverse' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnTextIntroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnTextIntroRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'videoBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VideoRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'autoplay' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'video' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'uploadVideo' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'videoThumbnail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSixteenByNine' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'muxVideo' },
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'sliderBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SliderBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'arrows' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slideAnimation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'delay' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'dots' },
            name: { kind: 'Name', value: 'navigationDots' },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'heroes' },
            name: { kind: 'Name', value: 'slides' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroBlock' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NewsPageContentAreaFragment, unknown>;
export const NewsPageContentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsPageContent' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentArea' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'newsPageContentArea' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'seo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'seo' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'pageLocales' },
            name: { kind: 'Name', value: '_locales' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'focalPoint' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'focalPoint' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'y' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'hex' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ColorField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hex' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobOpportunitiesPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'department' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageLoad' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'focalPoint' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'focalPoint' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'fileLink' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'uploadId' },
            name: { kind: 'Name', value: 'id' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListingRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pdf' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'articlesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ArticlesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isJobArticles' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'jobPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'newsPageListing' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'reportsPageListing' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBasic' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSquare' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '1:1',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brand' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'brandName' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSquare' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brandsBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandsBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hideLabels' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'bulletListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BulletListRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bullets' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberedList' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'documentLinkBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DocumentLinkBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'documents' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'employeeBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'EmployeeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'description' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'profileImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'overlay' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OverlayRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'color' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'opacity' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ctaButton' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CtaButtonRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'muxVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'muxPlaybackId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HeroBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'boxColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'textColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'dynamicImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'max' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '1800' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ImageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'standalone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'largeTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'itemsToShow' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsAndReportsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsAndReportsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'newsTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'news' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NewsPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'publishDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'reportsTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportsImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reports' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ReportsListingRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'publishDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pdf' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'fileLink' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'office' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'websiteUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'officesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'offices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'office' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'plugBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PlugBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'simpleTitleAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SimpleTitleAndTextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'topLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroImageTablet' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'statementBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StatementBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blackBackground' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          { kind: 'Field', name: { kind: 'Name', value: 'small' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkUrl' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageMobile' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '1728' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageTablet' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroImageTablet' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageDesktop' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '1620' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'textBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'smallHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'text' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnImageAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnImageAndTextRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reverse' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnTextIntroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnTextIntroRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'uploadVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UploadVideoField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mp4Url' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'mp4Low' },
            name: { kind: 'Name', value: 'mp4Url' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'res' },
                value: { kind: 'EnumValue', value: 'low' },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'streamingUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'thumbnailUrl' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSixteenByNine' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '16:9',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'videoBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VideoRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'autoplay' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'video' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'uploadVideo' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'videoThumbnail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSixteenByNine' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'muxVideo' },
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'sliderBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SliderBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'arrows' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slideAnimation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'delay' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'dots' },
            name: { kind: 'Name', value: 'navigationDots' },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'heroes' },
            name: { kind: 'Name', value: 'slides' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsPageContentArea' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsPageModelContentAreaField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'articlesBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'brandsBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'bulletListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'documentLinkBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'employeeBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'heroBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'jobsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'newsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'newsAndReportsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'officesBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'plugBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'simpleTitleAndTextBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'statementBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'textBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'twoColumnImageAndTextBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'twoColumnTextIntroBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'videoBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'sliderBlock' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'seo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SeoField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NewsPageContentFragment, unknown>;
export const PageNotFoundContentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'pageNotFoundContent' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PageNotFoundRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'backToHomeScreenButton' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PageNotFoundContentFragment, unknown>;
export const ReportsListPageContentAreaFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsListPageContentArea' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListPageModelContentAreaField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'articlesBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'brandsBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'bulletListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'documentLinkBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'employeeBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'heroBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'jobsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'newsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'newsAndReportsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'officesBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'plugBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'simpleTitleAndTextBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'statementBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'textBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'twoColumnImageAndTextBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'twoColumnTextIntroBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'videoBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'sliderBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'reportsListBlock' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobOpportunitiesPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'department' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'focalPoint' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'focalPoint' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'y' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'hex' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ColorField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hex' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageLoad' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'focalPoint' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'focalPoint' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'fileLink' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'uploadId' },
            name: { kind: 'Name', value: 'id' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListingRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pdf' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBasic' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSquare' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '1:1',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brand' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'brandName' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSquare' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'overlay' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OverlayRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'color' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'opacity' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ctaButton' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CtaButtonRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'muxVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'muxPlaybackId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'dynamicImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'max' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '1800' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'office' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'websiteUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroImageTablet' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'uploadVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UploadVideoField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mp4Url' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'mp4Low' },
            name: { kind: 'Name', value: 'mp4Url' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'res' },
                value: { kind: 'EnumValue', value: 'low' },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'streamingUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'thumbnailUrl' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSixteenByNine' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '16:9',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HeroBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'boxColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'textColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'articlesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ArticlesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isJobArticles' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'jobPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'newsPageListing' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'reportsPageListing' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brandsBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandsBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hideLabels' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'bulletListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BulletListRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bullets' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberedList' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'documentLinkBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DocumentLinkBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'documents' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'employeeBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'EmployeeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'description' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'profileImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ImageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'standalone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'largeTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'itemsToShow' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsAndReportsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsAndReportsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'newsTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'news' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NewsPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'publishDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'reportsTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportsImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reports' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ReportsListingRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'publishDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pdf' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'fileLink' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'officesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'offices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'office' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'plugBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PlugBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'simpleTitleAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SimpleTitleAndTextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'topLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'statementBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StatementBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blackBackground' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          { kind: 'Field', name: { kind: 'Name', value: 'small' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkUrl' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageMobile' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '1728' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageTablet' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroImageTablet' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageDesktop' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '1620' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'textBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'smallHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'text' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnImageAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnImageAndTextRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reverse' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnTextIntroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnTextIntroRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'videoBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VideoRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'autoplay' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'video' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'uploadVideo' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'videoThumbnail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSixteenByNine' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'muxVideo' },
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'sliderBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SliderBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'arrows' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slideAnimation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'delay' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'dots' },
            name: { kind: 'Name', value: 'navigationDots' },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'heroes' },
            name: { kind: 'Name', value: 'slides' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'standalone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'largeTitle' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ReportsListPageContentAreaFragment, unknown>;
export const ReportsListPageContentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsListPageContent' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'pageLocales' },
            name: { kind: 'Name', value: '_locales' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'seo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'seo' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentArea' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'reportsListPageContentArea' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobOpportunitiesPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'department' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'focalPoint' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'focalPoint' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'y' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'hex' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ColorField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hex' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageLoad' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'focalPoint' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'focalPoint' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'fileLink' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'uploadId' },
            name: { kind: 'Name', value: 'id' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListingRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pdf' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'articlesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ArticlesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isJobArticles' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'jobPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'newsPageListing' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'reportsPageListing' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBasic' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSquare' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '1:1',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brand' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'brandName' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSquare' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brandsBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandsBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hideLabels' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'bulletListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BulletListRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bullets' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberedList' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'documentLinkBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DocumentLinkBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'documents' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'employeeBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'EmployeeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'description' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'profileImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'overlay' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OverlayRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'color' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'opacity' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ctaButton' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CtaButtonRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'muxVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'muxPlaybackId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HeroBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'boxColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'textColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'dynamicImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'max' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '1800' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ImageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'standalone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'largeTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'itemsToShow' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsAndReportsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsAndReportsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'newsTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'news' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NewsPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'publishDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'reportsTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportsImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reports' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ReportsListingRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'publishDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pdf' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'fileLink' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'office' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'websiteUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'officesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'offices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'office' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'plugBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PlugBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'simpleTitleAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SimpleTitleAndTextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'topLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroImageTablet' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'statementBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StatementBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blackBackground' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          { kind: 'Field', name: { kind: 'Name', value: 'small' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkUrl' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageMobile' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '1728' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageTablet' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroImageTablet' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageDesktop' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '1620' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'textBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'smallHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'text' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnImageAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnImageAndTextRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reverse' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnTextIntroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnTextIntroRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'uploadVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UploadVideoField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mp4Url' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'mp4Low' },
            name: { kind: 'Name', value: 'mp4Url' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'res' },
                value: { kind: 'EnumValue', value: 'low' },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'streamingUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'thumbnailUrl' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSixteenByNine' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '16:9',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'videoBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VideoRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'autoplay' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'video' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'uploadVideo' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'videoThumbnail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSixteenByNine' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'muxVideo' },
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'sliderBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SliderBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'arrows' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slideAnimation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'delay' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'dots' },
            name: { kind: 'Name', value: 'navigationDots' },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'heroes' },
            name: { kind: 'Name', value: 'slides' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'standalone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'largeTitle' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'seo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SeoField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsListPageContentArea' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListPageModelContentAreaField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'articlesBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'brandsBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'bulletListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'documentLinkBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'employeeBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'heroBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'jobsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'newsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'newsAndReportsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'officesBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'plugBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'simpleTitleAndTextBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'statementBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'textBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'twoColumnImageAndTextBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'twoColumnTextIntroBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'videoBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'sliderBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'reportsListBlock' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ReportsListPageContentFragment, unknown>;
export const ReportsListingContentAreaFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsListingContentArea' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListPageModelContentAreaField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'articlesBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'brandsBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'bulletListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'documentLinkBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'employeeBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'heroBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'jobsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'newsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'officesBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'plugBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'simpleTitleAndTextBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'statementBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'textBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'twoColumnImageAndTextBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'twoColumnTextIntroBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'videoBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'sliderBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'reportsListBlock' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobOpportunitiesPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'department' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'focalPoint' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'focalPoint' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'y' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'hex' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ColorField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hex' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageLoad' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'focalPoint' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'focalPoint' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'fileLink' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'uploadId' },
            name: { kind: 'Name', value: 'id' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListingRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pdf' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBasic' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSquare' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '1:1',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brand' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'brandName' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSquare' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'overlay' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OverlayRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'color' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'opacity' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ctaButton' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CtaButtonRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'muxVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'muxPlaybackId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'dynamicImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'max' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '1800' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'office' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'websiteUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroImageTablet' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'uploadVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UploadVideoField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mp4Url' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'mp4Low' },
            name: { kind: 'Name', value: 'mp4Url' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'res' },
                value: { kind: 'EnumValue', value: 'low' },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'streamingUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'thumbnailUrl' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSixteenByNine' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '16:9',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HeroBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'boxColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'textColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'articlesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ArticlesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isJobArticles' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'jobPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'newsPageListing' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'reportsPageListing' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brandsBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandsBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hideLabels' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'bulletListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BulletListRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bullets' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberedList' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'documentLinkBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DocumentLinkBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'documents' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'employeeBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'EmployeeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'description' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'profileImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ImageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'standalone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'largeTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'itemsToShow' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'officesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'offices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'office' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'plugBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PlugBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'simpleTitleAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SimpleTitleAndTextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'topLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'statementBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StatementBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blackBackground' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          { kind: 'Field', name: { kind: 'Name', value: 'small' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkUrl' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageMobile' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '1728' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageTablet' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroImageTablet' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageDesktop' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '1620' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'textBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'smallHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'text' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnImageAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnImageAndTextRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reverse' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnTextIntroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnTextIntroRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'videoBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VideoRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'autoplay' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'video' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'uploadVideo' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'videoThumbnail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSixteenByNine' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'muxVideo' },
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'sliderBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SliderBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'arrows' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slideAnimation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'delay' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'dots' },
            name: { kind: 'Name', value: 'navigationDots' },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'heroes' },
            name: { kind: 'Name', value: 'slides' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'standalone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'largeTitle' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ReportsListingContentAreaFragment, unknown>;
export const ReportsListingContentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsListingContent' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListingRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pdf' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'seo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'seo' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'pageLocales' },
            name: { kind: 'Name', value: '_locales' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'focalPoint' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'focalPoint' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'y' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'hex' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ColorField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hex' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageLoad' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'focalPoint' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'focalPoint' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'fileLink' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'uploadId' },
            name: { kind: 'Name', value: 'id' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'seo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SeoField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ReportsListingContentFragment, unknown>;
export const PageNavigationBlockFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'pageNavigationBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PageNavigationBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'links' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'link' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'link' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LinkRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PageNavigationBlockFragment, unknown>;
export const SustainabilityIndexPageContentAreaFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'sustainabilityIndexPageContentArea' },
      typeCondition: {
        kind: 'NamedType',
        name: {
          kind: 'Name',
          value: 'SustainabilityIndexPageModelContentAreaField',
        },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'textBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'twoColumnImageAndTextBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'statementBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'twoColumnTextIntroBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'videoBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'employeeBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'bulletListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'heroBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'plugBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'brandsBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'articlesBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'officesBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'simpleTitleAndTextBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'newsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'newsAndReportsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'documentLinkBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'sliderBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'reportsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'gridContainerBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'subheadingBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'sustainabilityReportsBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'pageNavigationBlock' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ctaButton' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CtaButtonRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'dynamicImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'max' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '1800' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'focalPoint' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'focalPoint' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'y' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'hex' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ColorField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hex' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageLoad' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'focalPoint' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'focalPoint' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroImageTablet' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'overlay' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OverlayRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'color' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'opacity' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'uploadVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UploadVideoField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mp4Url' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'mp4Low' },
            name: { kind: 'Name', value: 'mp4Url' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'res' },
                value: { kind: 'EnumValue', value: 'low' },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'streamingUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'thumbnailUrl' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBasic' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSixteenByNine' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '16:9',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'muxVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'muxPlaybackId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSquare' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '1:1',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brand' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'brandName' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSquare' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobOpportunitiesPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'department' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'fileLink' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'uploadId' },
            name: { kind: 'Name', value: 'id' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListingRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pdf' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'office' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'websiteUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HeroBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'boxColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'textColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ImageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'textBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'smallHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'text' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'mediaWithCaption' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MediaWithCaptionRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'media' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caption' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'centerText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'textOnImage' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'standalone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'largeTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'itemsToShow' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'standalone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'largeTitle' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridTwoColBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridTwocolBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'mediaWithCaption' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'newsListBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'reportsListBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridThreeColBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridThreecolBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'mediaWithCaption' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridTwoColBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridFourColBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridFourcolBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'mediaWithCaption' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'link' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LinkRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnImageAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnImageAndTextRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reverse' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'statementBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StatementBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blackBackground' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          { kind: 'Field', name: { kind: 'Name', value: 'small' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkUrl' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageMobile' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '1728' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageTablet' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroImageTablet' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageDesktop' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '1620' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnTextIntroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnTextIntroRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'videoBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VideoRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'autoplay' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'video' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'uploadVideo' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'videoThumbnail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSixteenByNine' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'muxVideo' },
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'employeeBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'EmployeeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'description' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'profileImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'bulletListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BulletListRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bullets' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberedList' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'plugBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PlugBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brandsBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandsBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hideLabels' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'articlesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ArticlesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isJobArticles' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'jobPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'newsPageListing' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'reportsPageListing' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'officesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'offices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'office' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'simpleTitleAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SimpleTitleAndTextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'topLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsAndReportsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsAndReportsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'newsTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'news' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NewsPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'publishDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'reportsTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportsImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reports' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ReportsListingRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'publishDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pdf' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'fileLink' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'documentLinkBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DocumentLinkBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'documents' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'sliderBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SliderBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'arrows' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slideAnimation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'delay' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'dots' },
            name: { kind: 'Name', value: 'navigationDots' },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'heroes' },
            name: { kind: 'Name', value: 'slides' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridContainerBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridContainerBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'backgroundColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'textColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fullwidth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gap' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridTwoColBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridThreeColBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridFourColBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'subheadingBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SubheadingBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButton' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'backgroundColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'sustainabilityReportsBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SustainabilityReportsBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reports' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'pageNavigationBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PageNavigationBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'links' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'link' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SustainabilityIndexPageContentAreaFragment,
  unknown
>;
export const SustainabilityIndexPageContentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'sustainabilityIndexPageContent' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SustainabilityIndexPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'pageLocales' },
            name: { kind: 'Name', value: '_locales' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'seo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'seo' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentArea' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'sustainabilityIndexPageContentArea',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ctaButton' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CtaButtonRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'textBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'smallHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'text' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'dynamicImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'max' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '1800' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'focalPoint' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'focalPoint' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'y' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'hex' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ColorField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hex' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageLoad' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'focalPoint' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'focalPoint' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ImageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnImageAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnImageAndTextRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reverse' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroImageTablet' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'overlay' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OverlayRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'color' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'opacity' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'statementBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StatementBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blackBackground' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          { kind: 'Field', name: { kind: 'Name', value: 'small' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkUrl' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageMobile' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '1728' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageTablet' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroImageTablet' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageDesktop' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '1620' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnTextIntroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnTextIntroRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'uploadVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UploadVideoField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mp4Url' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'mp4Low' },
            name: { kind: 'Name', value: 'mp4Url' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'res' },
                value: { kind: 'EnumValue', value: 'low' },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'streamingUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'thumbnailUrl' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBasic' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSixteenByNine' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '16:9',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'muxVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'muxPlaybackId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'videoBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VideoRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'autoplay' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'video' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'uploadVideo' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'videoThumbnail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSixteenByNine' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'muxVideo' },
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'employeeBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'EmployeeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'description' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'profileImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'bulletListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BulletListRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bullets' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberedList' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HeroBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'boxColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'textColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSquare' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '1:1',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brand' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'brandName' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSquare' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'plugBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PlugBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brandsBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandsBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hideLabels' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobOpportunitiesPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'department' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'fileLink' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'uploadId' },
            name: { kind: 'Name', value: 'id' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListingRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pdf' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'articlesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ArticlesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isJobArticles' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'jobPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'newsPageListing' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'reportsPageListing' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'office' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'websiteUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'officesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'offices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'office' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'simpleTitleAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SimpleTitleAndTextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'topLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'standalone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'largeTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'itemsToShow' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsAndReportsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsAndReportsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'newsTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'news' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NewsPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'publishDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'reportsTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportsImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reports' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ReportsListingRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'publishDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pdf' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'fileLink' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'documentLinkBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DocumentLinkBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'documents' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'sliderBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SliderBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'arrows' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slideAnimation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'delay' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'dots' },
            name: { kind: 'Name', value: 'navigationDots' },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'heroes' },
            name: { kind: 'Name', value: 'slides' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'standalone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'largeTitle' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'mediaWithCaption' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MediaWithCaptionRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'media' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caption' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'centerText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'textOnImage' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridTwoColBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridTwocolBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'mediaWithCaption' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'newsListBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'reportsListBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridThreeColBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridThreecolBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'mediaWithCaption' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridTwoColBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridFourColBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridFourcolBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'mediaWithCaption' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridContainerBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridContainerBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'backgroundColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'textColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fullwidth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gap' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridTwoColBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridThreeColBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridFourColBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'subheadingBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SubheadingBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButton' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'backgroundColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'sustainabilityReportsBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SustainabilityReportsBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reports' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'link' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LinkRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'pageNavigationBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PageNavigationBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'links' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'link' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'seo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SeoField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'sustainabilityIndexPageContentArea' },
      typeCondition: {
        kind: 'NamedType',
        name: {
          kind: 'Name',
          value: 'SustainabilityIndexPageModelContentAreaField',
        },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'textBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'twoColumnImageAndTextBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'statementBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'twoColumnTextIntroBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'videoBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'employeeBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'bulletListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'heroBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'plugBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'brandsBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'articlesBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'officesBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'simpleTitleAndTextBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'newsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'newsAndReportsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'documentLinkBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'sliderBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'reportsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'gridContainerBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'subheadingBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'sustainabilityReportsBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'pageNavigationBlock' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SustainabilityIndexPageContentFragment, unknown>;
export const SustainabilityPageContentAreaFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'sustainabilityPageContentArea' },
      typeCondition: {
        kind: 'NamedType',
        name: {
          kind: 'Name',
          value: 'SustainabilityPageModelContentAreaField',
        },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'articlesBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'brandsBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'bulletListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'documentLinkBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'employeeBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'heroBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'gridContainerBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'jobsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'newsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'newsAndReportsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'officesBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'plugBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'simpleTitleAndTextBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'statementBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'textBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'twoColumnImageAndTextBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'twoColumnTextIntroBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'videoBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'sliderBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'subheadingBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'sustainabilityReportsBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'pageNavigationBlock' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobOpportunitiesPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'department' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'focalPoint' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'focalPoint' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'y' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'hex' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ColorField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hex' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageLoad' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'focalPoint' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'focalPoint' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'fileLink' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'uploadId' },
            name: { kind: 'Name', value: 'id' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListingRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pdf' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBasic' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSquare' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '1:1',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brand' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'brandName' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSquare' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'overlay' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OverlayRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'color' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'opacity' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ctaButton' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CtaButtonRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'muxVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'muxPlaybackId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'dynamicImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'max' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '1800' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ImageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'textBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'smallHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'text' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'mediaWithCaption' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MediaWithCaptionRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'media' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caption' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'centerText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'textOnImage' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'standalone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'largeTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'itemsToShow' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'standalone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'largeTitle' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridTwoColBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridTwocolBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'mediaWithCaption' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'newsListBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'reportsListBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridThreeColBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridThreecolBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'mediaWithCaption' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridTwoColBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridFourColBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridFourcolBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'mediaWithCaption' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'office' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'websiteUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroImageTablet' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'uploadVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UploadVideoField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mp4Url' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'mp4Low' },
            name: { kind: 'Name', value: 'mp4Url' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'res' },
                value: { kind: 'EnumValue', value: 'low' },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'streamingUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'thumbnailUrl' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSixteenByNine' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '16:9',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HeroBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'boxColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'textColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'link' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LinkRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'articlesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ArticlesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isJobArticles' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'jobPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'newsPageListing' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'reportsPageListing' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brandsBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandsBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hideLabels' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'bulletListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BulletListRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bullets' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberedList' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'documentLinkBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DocumentLinkBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'documents' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'employeeBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'EmployeeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'description' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'profileImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridContainerBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridContainerBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'backgroundColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'textColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fullwidth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gap' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridTwoColBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridThreeColBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridFourColBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsAndReportsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsAndReportsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'newsTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'news' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NewsPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'publishDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'reportsTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportsImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reports' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ReportsListingRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'publishDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pdf' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'fileLink' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'officesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'offices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'office' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'plugBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PlugBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'simpleTitleAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SimpleTitleAndTextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'topLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'statementBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StatementBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blackBackground' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          { kind: 'Field', name: { kind: 'Name', value: 'small' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkUrl' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageMobile' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '1728' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageTablet' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroImageTablet' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageDesktop' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '1620' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnImageAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnImageAndTextRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reverse' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnTextIntroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnTextIntroRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'videoBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VideoRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'autoplay' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'video' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'uploadVideo' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'videoThumbnail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSixteenByNine' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'muxVideo' },
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'sliderBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SliderBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'arrows' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slideAnimation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'delay' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'dots' },
            name: { kind: 'Name', value: 'navigationDots' },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'heroes' },
            name: { kind: 'Name', value: 'slides' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'subheadingBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SubheadingBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButton' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'backgroundColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'sustainabilityReportsBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SustainabilityReportsBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reports' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'pageNavigationBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PageNavigationBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'links' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'link' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SustainabilityPageContentAreaFragment, unknown>;
export const SustainabilityPageContentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'sustainabilityPageContent' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SustainabilityPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'pageLocales' },
            name: { kind: 'Name', value: '_locales' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'seo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'seo' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentArea' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'sustainabilityPageContentArea',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobOpportunitiesPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'department' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'focalPoint' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'focalPoint' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'y' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'hex' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ColorField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hex' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageLoad' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'focalPoint' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'focalPoint' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'fileLink' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'uploadId' },
            name: { kind: 'Name', value: 'id' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListingRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pdf' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'articlesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ArticlesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isJobArticles' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'jobPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'newsPageListing' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'reportsPageListing' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBasic' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSquare' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '1:1',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brand' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'brandName' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSquare' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brandsBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandsBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hideLabels' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'bulletListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BulletListRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bullets' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberedList' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'documentLinkBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DocumentLinkBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'documents' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'employeeBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'EmployeeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'description' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'profileImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'overlay' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OverlayRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'color' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'opacity' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ctaButton' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CtaButtonRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'muxVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'muxPlaybackId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HeroBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'boxColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'textColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'dynamicImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'max' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '1800' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ImageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'textBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'smallHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'text' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'mediaWithCaption' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MediaWithCaptionRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'media' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caption' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'centerText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'textOnImage' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'standalone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'largeTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'itemsToShow' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'standalone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'largeTitle' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridTwoColBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridTwocolBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'mediaWithCaption' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'newsListBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'reportsListBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridThreeColBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridThreecolBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'mediaWithCaption' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridTwoColBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridFourColBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridFourcolBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'mediaWithCaption' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridContainerBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridContainerBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'backgroundColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'textColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fullwidth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gap' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridTwoColBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridThreeColBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridFourColBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsAndReportsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsAndReportsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'newsTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'news' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NewsPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'publishDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'reportsTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportsImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reports' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ReportsListingRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'publishDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pdf' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'fileLink' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'office' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'websiteUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'officesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'offices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'office' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'plugBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PlugBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'simpleTitleAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SimpleTitleAndTextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'topLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroImageTablet' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'statementBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StatementBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blackBackground' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          { kind: 'Field', name: { kind: 'Name', value: 'small' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkUrl' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageMobile' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '1728' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageTablet' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroImageTablet' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageDesktop' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '1620' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnImageAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnImageAndTextRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reverse' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnTextIntroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnTextIntroRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'uploadVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UploadVideoField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mp4Url' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'mp4Low' },
            name: { kind: 'Name', value: 'mp4Url' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'res' },
                value: { kind: 'EnumValue', value: 'low' },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'streamingUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'thumbnailUrl' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSixteenByNine' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '16:9',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'videoBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VideoRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'autoplay' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'video' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'uploadVideo' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'videoThumbnail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSixteenByNine' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'muxVideo' },
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'sliderBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SliderBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'arrows' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slideAnimation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'delay' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'dots' },
            name: { kind: 'Name', value: 'navigationDots' },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'heroes' },
            name: { kind: 'Name', value: 'slides' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'subheadingBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SubheadingBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButton' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'backgroundColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'sustainabilityReportsBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SustainabilityReportsBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reports' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'link' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LinkRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'pageNavigationBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PageNavigationBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'links' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'link' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'seo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SeoField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'sustainabilityPageContentArea' },
      typeCondition: {
        kind: 'NamedType',
        name: {
          kind: 'Name',
          value: 'SustainabilityPageModelContentAreaField',
        },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'articlesBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'brandsBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'bulletListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'documentLinkBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'employeeBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'heroBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'gridContainerBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'jobsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'newsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'newsAndReportsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'officesBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'plugBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'simpleTitleAndTextBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'statementBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'textBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'twoColumnImageAndTextBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'twoColumnTextIntroBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'videoBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'sliderBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'subheadingBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'sustainabilityReportsBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'pageNavigationBlock' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SustainabilityPageContentFragment, unknown>;
export const SiteLocaleFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'siteLocale' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SiteLocaleRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SiteLocaleFragment, unknown>;
export const ImageDynamicFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageDynamic' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'auto' },
                      value: { kind: 'EnumValue', value: 'format' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBasic' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ImageDynamicFragment, unknown>;
export const ImageFourByThreeFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageFourByThree' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '4:3',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBasic' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ImageFourByThreeFragment, unknown>;
export const ImageThirtyTwoByNineFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageThirtyTwoByNine' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '32:9',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBasic' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ImageThirtyTwoByNineFragment, unknown>;
export const ImageThreeByFourFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageThreeByFour' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '3:4',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBasic' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ImageThreeByFourFragment, unknown>;
export const ImageThreeByTwoFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageThreeByTwo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '3:2',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBasic' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ImageThreeByTwoFragment, unknown>;
export const ImageTwelveByFiveFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageTwelveByFive' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '12:5',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBasic' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ImageTwelveByFiveFragment, unknown>;
export const ImageTwentyOneByNineFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageTwentyOneByNine' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '21:9',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBasic' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ImageTwentyOneByNineFragment, unknown>;
export const RecordMetaFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'recordMeta' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'RecordInterface' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RecordMetaFragment, unknown>;
export const VideoUrlFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'videoUrl' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<VideoUrlFragment, unknown>;
export const VideoFileFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'videoFile' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'videoUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'uploadVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'videoUrl' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'uploadVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UploadVideoField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mp4Url' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'mp4Low' },
            name: { kind: 'Name', value: 'mp4Url' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'res' },
                value: { kind: 'EnumValue', value: 'low' },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'streamingUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'thumbnailUrl' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<VideoFileFragment, unknown>;
export const AboutUsPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'aboutUsPage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'locale' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'SiteLocale' },
          },
          defaultValue: { kind: 'EnumValue', value: 'en' },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'aboutUsPage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'slug' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'slug' },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: '_locales' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'allIn' },
                            value: {
                              kind: 'ListValue',
                              values: [
                                {
                                  kind: 'Variable',
                                  name: { kind: 'Name', value: 'locale' },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'aboutUsPageContent' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'globalContent' },
            name: { kind: 'Name', value: 'global' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'globalContent' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'featureToggle' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'featureToggle' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'menu' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'menu' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'footer' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'footer' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'seo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SeoField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobOpportunitiesPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'department' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'focalPoint' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'focalPoint' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'y' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'hex' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ColorField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hex' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageLoad' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'focalPoint' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'focalPoint' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'fileLink' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'uploadId' },
            name: { kind: 'Name', value: 'id' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListingRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pdf' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'articlesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ArticlesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isJobArticles' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'jobPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'newsPageListing' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'reportsPageListing' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBasic' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSquare' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '1:1',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brand' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'brandName' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSquare' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brandsBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandsBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hideLabels' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'bulletListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BulletListRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bullets' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberedList' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'documentLinkBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DocumentLinkBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'documents' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'employeeBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'EmployeeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'description' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'profileImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'overlay' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OverlayRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'color' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'opacity' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ctaButton' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CtaButtonRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'muxVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'muxPlaybackId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HeroBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'boxColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'textColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'dynamicImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'max' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '1800' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ImageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'textBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'smallHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'text' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'mediaWithCaption' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MediaWithCaptionRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'media' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caption' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'centerText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'textOnImage' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'standalone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'largeTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'itemsToShow' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'standalone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'largeTitle' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridTwoColBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridTwocolBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'mediaWithCaption' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'newsListBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'reportsListBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridThreeColBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridThreecolBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'mediaWithCaption' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridTwoColBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridFourColBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridFourcolBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'mediaWithCaption' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridContainerBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridContainerBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'backgroundColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'textColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fullwidth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gap' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridTwoColBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridThreeColBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridFourColBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsAndReportsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsAndReportsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'newsTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'news' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NewsPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'publishDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'reportsTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportsImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reports' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ReportsListingRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'publishDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pdf' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'fileLink' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'office' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'websiteUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'officesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'offices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'office' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'plugBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PlugBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'simpleTitleAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SimpleTitleAndTextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'topLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroImageTablet' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'statementBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StatementBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blackBackground' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          { kind: 'Field', name: { kind: 'Name', value: 'small' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkUrl' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageMobile' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '1728' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageTablet' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroImageTablet' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageDesktop' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '1620' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnImageAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnImageAndTextRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reverse' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnTextIntroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnTextIntroRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'uploadVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UploadVideoField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mp4Url' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'mp4Low' },
            name: { kind: 'Name', value: 'mp4Url' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'res' },
                value: { kind: 'EnumValue', value: 'low' },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'streamingUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'thumbnailUrl' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSixteenByNine' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '16:9',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'videoBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VideoRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'autoplay' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'video' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'uploadVideo' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'videoThumbnail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSixteenByNine' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'muxVideo' },
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'sliderBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SliderBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'arrows' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slideAnimation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'delay' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'dots' },
            name: { kind: 'Name', value: 'navigationDots' },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'heroes' },
            name: { kind: 'Name', value: 'slides' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'subheadingBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SubheadingBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButton' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'backgroundColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'sustainabilityReportsBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SustainabilityReportsBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reports' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'aboutUsPageContentArea' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AboutUsPageModelContentAreaField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'articlesBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'brandsBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'bulletListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'documentLinkBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'employeeBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'heroBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'gridContainerBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'jobsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'newsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'newsAndReportsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'officesBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'plugBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'simpleTitleAndTextBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'statementBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'textBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'twoColumnImageAndTextBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'twoColumnTextIntroBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'videoBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'sliderBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'subheadingBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'sustainabilityReportsBlock' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'image' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'language' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LanguageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'flag' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'symbol' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBasic' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'subMenuItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ItemRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pageLink' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'BrandPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SustainabilityPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'AboutUsPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'menuItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MenuItemRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submenu' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'menuItems' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'subMenuItem' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'link' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LinkRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'footerMenuItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FooterMenuItemRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'heading' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'links' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'includeCookieToggle' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'iconLink' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'IconLinkRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'icon' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBasic' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'aboutUsPageContent' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AboutUsPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'seo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'seo' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'pageLocales' },
            name: { kind: 'Name', value: '_locales' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentArea' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'aboutUsPageContentArea' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'globalContent' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GlobalRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'navigationLogo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'image' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'changeLanguage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'closeLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deadline' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'loading' } },
          { kind: 'Field', name: { kind: 'Name', value: 'loadMoreNews' } },
          { kind: 'Field', name: { kind: 'Name', value: 'localWebLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'menu' } },
          { kind: 'Field', name: { kind: 'Name', value: 'moreNewsCta' } },
          { kind: 'Field', name: { kind: 'Name', value: 'moreNewsHeader' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'partnerPortalLabel' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerPortalUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'play' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shopLinkTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shopLinkUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'showMoreJobsLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'viewOnMapLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'languages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'language' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'nextLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previousLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sliderNavigationLabel' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'moreReportsCta' } },
          { kind: 'Field', name: { kind: 'Name', value: 'loadMoreReports' } },
          { kind: 'Field', name: { kind: 'Name', value: 'clearIconLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'searchIconLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchBoxPlaceholder' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'viewAllButtonLabel' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchResultsPageTitle' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'firstPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previousPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'goToPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'searchResultCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'noSearchResults' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'featureToggle' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FeatureToggleRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'landingPageContentArea' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsPageContentArea' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'menu' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MenuRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'menuItems' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'menuItem' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'footer' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FooterRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'bottomIntro' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cookieSettings' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'footerLogo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBasic' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hultaforsBrands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'link' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'menu' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'link' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'menuItems' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'footerMenuItem' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'moreInfoText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerLogin' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selectCountryLabel' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'socialMediaLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'socialMediaMenu' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'iconLink' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'useNewFooter' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AboutUsPageQuery, AboutUsPageQueryVariables>;
export const AllJobsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'allJobs' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'locale' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'SiteLocale' },
          },
          defaultValue: { kind: 'EnumValue', value: 'en' },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'pageSize' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'IntType' } },
          defaultValue: { kind: 'IntValue', value: '25' },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'IntType' } },
          defaultValue: { kind: 'IntValue', value: '0' },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'items' },
            name: { kind: 'Name', value: 'allJobOpportunitiesPages' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'pageSize' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'skip' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'skip' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderBy' },
                value: { kind: 'EnumValue', value: 'publishDate_DESC' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'meta' },
            name: { kind: 'Name', value: '_allJobOpportunitiesPagesMeta' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'collectionMetadata' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobOpportunitiesPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'department' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'collectionMetadata' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CollectionMetadata' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
      },
    },
  ],
} as unknown as DocumentNode<AllJobsQuery, AllJobsQueryVariables>;
export const AllNewsPagesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'allNewsPages' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'locale' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'SiteLocale' },
          },
          defaultValue: { kind: 'EnumValue', value: 'en' },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'pageSize' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'IntType' } },
          defaultValue: { kind: 'IntValue', value: '5' },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'IntType' } },
          defaultValue: { kind: 'IntValue', value: '0' },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'items' },
            name: { kind: 'Name', value: 'allNewsPages' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'pageSize' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'skip' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'skip' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderBy' },
                value: { kind: 'EnumValue', value: 'publishDate_DESC' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'newsPageListing' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'meta' },
            name: { kind: 'Name', value: '_allNewsPagesMeta' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'collectionMetadata' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'focalPoint' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'focalPoint' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'y' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'hex' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ColorField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hex' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageLoad' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'focalPoint' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'focalPoint' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'collectionMetadata' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CollectionMetadata' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
      },
    },
  ],
} as unknown as DocumentNode<AllNewsPagesQuery, AllNewsPagesQueryVariables>;
export const AllReportsListingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'allReportsListings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'locale' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'SiteLocale' },
          },
          defaultValue: { kind: 'EnumValue', value: 'en' },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'pageSize' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'IntType' } },
          defaultValue: { kind: 'IntValue', value: '5' },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'IntType' } },
          defaultValue: { kind: 'IntValue', value: '0' },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'items' },
            name: { kind: 'Name', value: 'allReportsListings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'pageSize' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'skip' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'skip' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderBy' },
                value: { kind: 'EnumValue', value: 'publishDate_DESC' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'reportsPageListing' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'meta' },
            name: { kind: 'Name', value: '_allReportsListingsMeta' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'collectionMetadata' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'focalPoint' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'focalPoint' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'y' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'hex' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ColorField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hex' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageLoad' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'focalPoint' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'focalPoint' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'fileLink' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'uploadId' },
            name: { kind: 'Name', value: 'id' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListingRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pdf' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'collectionMetadata' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CollectionMetadata' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
      },
    },
  ],
} as unknown as DocumentNode<
  AllReportsListingsQuery,
  AllReportsListingsQueryVariables
>;
export const BrandPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'brandPage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'locale' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'SiteLocale' },
          },
          defaultValue: { kind: 'EnumValue', value: 'en' },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brandPage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'slug' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'slug' },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: '_locales' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'allIn' },
                            value: {
                              kind: 'ListValue',
                              values: [
                                {
                                  kind: 'Variable',
                                  name: { kind: 'Name', value: 'locale' },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brandPageContent' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'globalContent' },
            name: { kind: 'Name', value: 'global' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'globalContent' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'featureToggle' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'featureToggle' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'menu' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'menu' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'footer' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'footer' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'focalPoint' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'focalPoint' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'y' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'hex' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ColorField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hex' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageLoad' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'focalPoint' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'focalPoint' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'seo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SeoField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'logo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'max' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '200' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'image' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBasic' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'language' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LanguageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'flag' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'symbol' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBasic' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'subMenuItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ItemRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pageLink' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'BrandPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SustainabilityPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'AboutUsPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'menuItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MenuItemRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submenu' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'menuItems' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'subMenuItem' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'link' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LinkRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'footerMenuItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FooterMenuItemRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'heading' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'links' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'includeCookieToggle' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'iconLink' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'IconLinkRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'icon' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBasic' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brandPageContent' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'heroTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkToWebsite' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkToWebsiteText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'heroImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'brandName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'seo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'seo' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'logo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'logo' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'pageLocales' },
            name: { kind: 'Name', value: '_locales' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'globalContent' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GlobalRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'navigationLogo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'image' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'changeLanguage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'closeLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deadline' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'loading' } },
          { kind: 'Field', name: { kind: 'Name', value: 'loadMoreNews' } },
          { kind: 'Field', name: { kind: 'Name', value: 'localWebLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'menu' } },
          { kind: 'Field', name: { kind: 'Name', value: 'moreNewsCta' } },
          { kind: 'Field', name: { kind: 'Name', value: 'moreNewsHeader' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'partnerPortalLabel' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerPortalUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'play' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shopLinkTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shopLinkUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'showMoreJobsLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'viewOnMapLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'languages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'language' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'nextLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previousLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sliderNavigationLabel' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'moreReportsCta' } },
          { kind: 'Field', name: { kind: 'Name', value: 'loadMoreReports' } },
          { kind: 'Field', name: { kind: 'Name', value: 'clearIconLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'searchIconLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchBoxPlaceholder' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'viewAllButtonLabel' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchResultsPageTitle' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'firstPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previousPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'goToPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'searchResultCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'noSearchResults' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'featureToggle' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FeatureToggleRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'landingPageContentArea' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsPageContentArea' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'menu' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MenuRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'menuItems' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'menuItem' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'footer' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FooterRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'bottomIntro' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cookieSettings' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'footerLogo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBasic' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hultaforsBrands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'link' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'menu' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'link' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'menuItems' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'footerMenuItem' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'moreInfoText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerLogin' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selectCountryLabel' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'socialMediaLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'socialMediaMenu' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'iconLink' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'useNewFooter' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BrandPageQuery, BrandPageQueryVariables>;
export const BrandsListPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'brandsListPage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'locale' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'SiteLocale' },
          },
          defaultValue: { kind: 'EnumValue', value: 'en' },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brandsListPage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brandsListPageContent' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'globalContent' },
            name: { kind: 'Name', value: 'global' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'globalContent' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'featureToggle' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'featureToggle' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'menu' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'menu' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'footer' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'footer' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'seo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SeoField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ctaButton' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CtaButtonRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'textBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'smallHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'text' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'dynamicImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'max' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '1800' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'focalPoint' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'focalPoint' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'y' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'hex' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ColorField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hex' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageLoad' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'focalPoint' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'focalPoint' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ImageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnImageAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnImageAndTextRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reverse' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroImageTablet' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'overlay' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OverlayRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'color' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'opacity' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'statementBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StatementBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blackBackground' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          { kind: 'Field', name: { kind: 'Name', value: 'small' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkUrl' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageMobile' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '1728' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageTablet' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroImageTablet' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageDesktop' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '1620' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnTextIntroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnTextIntroRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'uploadVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UploadVideoField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mp4Url' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'mp4Low' },
            name: { kind: 'Name', value: 'mp4Url' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'res' },
                value: { kind: 'EnumValue', value: 'low' },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'streamingUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'thumbnailUrl' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBasic' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSixteenByNine' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '16:9',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'muxVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'muxPlaybackId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'videoBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VideoRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'autoplay' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'video' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'uploadVideo' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'videoThumbnail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSixteenByNine' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'muxVideo' },
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'employeeBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'EmployeeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'description' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'profileImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'bulletListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BulletListRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bullets' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberedList' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HeroBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'boxColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'textColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSquare' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '1:1',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brand' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'brandName' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSquare' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'plugBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PlugBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brandsBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandsBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hideLabels' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobOpportunitiesPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'department' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'fileLink' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'uploadId' },
            name: { kind: 'Name', value: 'id' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListingRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pdf' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'articlesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ArticlesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isJobArticles' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'jobPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'newsPageListing' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'reportsPageListing' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'office' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'websiteUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'officesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'offices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'office' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'simpleTitleAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SimpleTitleAndTextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'topLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'standalone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'largeTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'itemsToShow' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsAndReportsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsAndReportsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'newsTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'news' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NewsPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'publishDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'reportsTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportsImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reports' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ReportsListingRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'publishDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pdf' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'fileLink' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'documentLinkBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DocumentLinkBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'documents' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'sliderBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SliderBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'arrows' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slideAnimation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'delay' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'dots' },
            name: { kind: 'Name', value: 'navigationDots' },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'heroes' },
            name: { kind: 'Name', value: 'slides' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'standalone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'largeTitle' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'mediaWithCaption' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MediaWithCaptionRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'media' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caption' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'centerText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'textOnImage' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridTwoColBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridTwocolBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'mediaWithCaption' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'newsListBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'reportsListBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridThreeColBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridThreecolBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'mediaWithCaption' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridTwoColBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridFourColBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridFourcolBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'mediaWithCaption' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridContainerBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridContainerBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'backgroundColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'textColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fullwidth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gap' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridTwoColBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridThreeColBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridFourColBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'subheadingBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SubheadingBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButton' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'backgroundColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'sustainabilityReportsBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SustainabilityReportsBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reports' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brandsListPageContentArea' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandsListPageModelContentAreaField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'textBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'twoColumnImageAndTextBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'statementBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'twoColumnTextIntroBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'videoBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'employeeBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'bulletListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'heroBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'plugBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'brandsBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'articlesBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'officesBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'simpleTitleAndTextBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'newsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'newsAndReportsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'documentLinkBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'sliderBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'reportsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'gridContainerBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'subheadingBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'sustainabilityReportsBlock' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'image' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'language' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LanguageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'flag' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'symbol' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBasic' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'subMenuItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ItemRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pageLink' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'BrandPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SustainabilityPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'AboutUsPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'menuItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MenuItemRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submenu' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'menuItems' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'subMenuItem' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'link' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LinkRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'footerMenuItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FooterMenuItemRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'heading' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'links' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'includeCookieToggle' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'iconLink' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'IconLinkRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'icon' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBasic' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brandsListPageContent' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandsListPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'pageLocales' },
            name: { kind: 'Name', value: '_locales' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'seo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'seo' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentArea' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brandsListPageContentArea' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'globalContent' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GlobalRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'navigationLogo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'image' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'changeLanguage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'closeLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deadline' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'loading' } },
          { kind: 'Field', name: { kind: 'Name', value: 'loadMoreNews' } },
          { kind: 'Field', name: { kind: 'Name', value: 'localWebLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'menu' } },
          { kind: 'Field', name: { kind: 'Name', value: 'moreNewsCta' } },
          { kind: 'Field', name: { kind: 'Name', value: 'moreNewsHeader' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'partnerPortalLabel' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerPortalUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'play' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shopLinkTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shopLinkUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'showMoreJobsLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'viewOnMapLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'languages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'language' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'nextLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previousLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sliderNavigationLabel' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'moreReportsCta' } },
          { kind: 'Field', name: { kind: 'Name', value: 'loadMoreReports' } },
          { kind: 'Field', name: { kind: 'Name', value: 'clearIconLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'searchIconLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchBoxPlaceholder' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'viewAllButtonLabel' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchResultsPageTitle' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'firstPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previousPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'goToPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'searchResultCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'noSearchResults' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'featureToggle' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FeatureToggleRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'landingPageContentArea' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsPageContentArea' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'menu' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MenuRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'menuItems' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'menuItem' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'footer' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FooterRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'bottomIntro' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cookieSettings' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'footerLogo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBasic' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hultaforsBrands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'link' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'menu' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'link' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'menuItems' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'footerMenuItem' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'moreInfoText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerLogin' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selectCountryLabel' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'socialMediaLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'socialMediaMenu' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'iconLink' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'useNewFooter' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BrandsListPageQuery, BrandsListPageQueryVariables>;
export const CampaignPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'campaignPage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'locale' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'SiteLocale' },
          },
          defaultValue: { kind: 'EnumValue', value: 'en' },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'campaignPage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'slug' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'slug' },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: '_locales' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'allIn' },
                            value: {
                              kind: 'ListValue',
                              values: [
                                {
                                  kind: 'Variable',
                                  name: { kind: 'Name', value: 'locale' },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'campaignPageContent' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'globalContent' },
            name: { kind: 'Name', value: 'global' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'globalContent' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'featureToggle' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'featureToggle' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'menu' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'menu' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'footer' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'footer' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'seo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SeoField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobOpportunitiesPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'department' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'focalPoint' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'focalPoint' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'y' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'hex' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ColorField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hex' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageLoad' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'focalPoint' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'focalPoint' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'fileLink' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'uploadId' },
            name: { kind: 'Name', value: 'id' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListingRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pdf' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'articlesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ArticlesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isJobArticles' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'jobPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'newsPageListing' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'reportsPageListing' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBasic' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSquare' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '1:1',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brand' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'brandName' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSquare' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brandsBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandsBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hideLabels' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'bulletListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BulletListRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bullets' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberedList' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'documentLinkBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DocumentLinkBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'documents' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'employeeBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'EmployeeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'description' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'profileImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'overlay' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OverlayRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'color' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'opacity' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ctaButton' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CtaButtonRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'muxVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'muxPlaybackId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HeroBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'boxColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'textColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'dynamicImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'max' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '1800' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ImageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'textBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'smallHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'text' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'mediaWithCaption' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MediaWithCaptionRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'media' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caption' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'centerText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'textOnImage' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'standalone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'largeTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'itemsToShow' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'standalone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'largeTitle' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridTwoColBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridTwocolBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'mediaWithCaption' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'newsListBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'reportsListBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridThreeColBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridThreecolBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'mediaWithCaption' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridTwoColBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridFourColBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridFourcolBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'mediaWithCaption' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridContainerBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridContainerBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'backgroundColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'textColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fullwidth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gap' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridTwoColBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridThreeColBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridFourColBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsAndReportsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsAndReportsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'newsTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'news' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NewsPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'publishDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'reportsTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportsImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reports' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ReportsListingRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'publishDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pdf' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'fileLink' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'office' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'websiteUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'officesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'offices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'office' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'plugBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PlugBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'simpleTitleAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SimpleTitleAndTextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'topLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroImageTablet' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'statementBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StatementBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blackBackground' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          { kind: 'Field', name: { kind: 'Name', value: 'small' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkUrl' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageMobile' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '1728' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageTablet' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroImageTablet' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageDesktop' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '1620' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnImageAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnImageAndTextRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reverse' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnTextIntroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnTextIntroRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'uploadVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UploadVideoField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mp4Url' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'mp4Low' },
            name: { kind: 'Name', value: 'mp4Url' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'res' },
                value: { kind: 'EnumValue', value: 'low' },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'streamingUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'thumbnailUrl' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSixteenByNine' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '16:9',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'videoBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VideoRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'autoplay' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'video' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'uploadVideo' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'videoThumbnail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSixteenByNine' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'muxVideo' },
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'sliderBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SliderBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'arrows' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slideAnimation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'delay' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'dots' },
            name: { kind: 'Name', value: 'navigationDots' },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'heroes' },
            name: { kind: 'Name', value: 'slides' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'subheadingBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SubheadingBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButton' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'backgroundColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'sustainabilityReportsBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SustainabilityReportsBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reports' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'campaignPageContentArea' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CampaignPageModelContentAreaField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'articlesBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'brandsBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'bulletListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'documentLinkBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'employeeBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'heroBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'gridContainerBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'jobsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'newsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'newsAndReportsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'officesBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'plugBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'simpleTitleAndTextBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'statementBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'textBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'twoColumnImageAndTextBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'twoColumnTextIntroBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'videoBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'sliderBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'subheadingBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'sustainabilityReportsBlock' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'image' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'language' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LanguageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'flag' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'symbol' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBasic' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'subMenuItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ItemRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pageLink' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'BrandPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SustainabilityPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'AboutUsPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'menuItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MenuItemRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submenu' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'menuItems' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'subMenuItem' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'link' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LinkRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'footerMenuItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FooterMenuItemRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'heading' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'links' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'includeCookieToggle' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'iconLink' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'IconLinkRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'icon' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBasic' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'campaignPageContent' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CampaignPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'pageLocales' },
            name: { kind: 'Name', value: '_locales' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'seo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'seo' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentArea' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'campaignPageContentArea' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'globalContent' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GlobalRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'navigationLogo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'image' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'changeLanguage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'closeLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deadline' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'loading' } },
          { kind: 'Field', name: { kind: 'Name', value: 'loadMoreNews' } },
          { kind: 'Field', name: { kind: 'Name', value: 'localWebLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'menu' } },
          { kind: 'Field', name: { kind: 'Name', value: 'moreNewsCta' } },
          { kind: 'Field', name: { kind: 'Name', value: 'moreNewsHeader' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'partnerPortalLabel' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerPortalUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'play' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shopLinkTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shopLinkUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'showMoreJobsLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'viewOnMapLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'languages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'language' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'nextLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previousLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sliderNavigationLabel' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'moreReportsCta' } },
          { kind: 'Field', name: { kind: 'Name', value: 'loadMoreReports' } },
          { kind: 'Field', name: { kind: 'Name', value: 'clearIconLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'searchIconLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchBoxPlaceholder' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'viewAllButtonLabel' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchResultsPageTitle' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'firstPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previousPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'goToPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'searchResultCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'noSearchResults' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'featureToggle' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FeatureToggleRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'landingPageContentArea' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsPageContentArea' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'menu' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MenuRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'menuItems' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'menuItem' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'footer' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FooterRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'bottomIntro' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cookieSettings' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'footerLogo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBasic' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hultaforsBrands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'link' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'menu' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'link' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'menuItems' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'footerMenuItem' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'moreInfoText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerLogin' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selectCountryLabel' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'socialMediaLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'socialMediaMenu' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'iconLink' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'useNewFooter' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CampaignPageQuery, CampaignPageQueryVariables>;
export const ContactPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'contactPage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'locale' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'SiteLocale' },
          },
          defaultValue: { kind: 'EnumValue', value: 'en' },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactPage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'contactPageContent' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'globalContent' },
            name: { kind: 'Name', value: 'global' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'globalContent' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'featureToggle' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'featureToggle' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'menu' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'menu' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'footer' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'footer' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'seo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SeoField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobOpportunitiesPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'department' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'focalPoint' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'focalPoint' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'y' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'hex' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ColorField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hex' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageLoad' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'focalPoint' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'focalPoint' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'fileLink' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'uploadId' },
            name: { kind: 'Name', value: 'id' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListingRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pdf' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'articlesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ArticlesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isJobArticles' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'jobPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'newsPageListing' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'reportsPageListing' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBasic' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSquare' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '1:1',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brand' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'brandName' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSquare' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brandsBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandsBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hideLabels' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'bulletListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BulletListRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bullets' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberedList' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'documentLinkBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DocumentLinkBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'documents' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'employeeBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'EmployeeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'description' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'profileImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'overlay' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OverlayRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'color' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'opacity' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ctaButton' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CtaButtonRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'muxVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'muxPlaybackId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HeroBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'boxColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'textColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'dynamicImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'max' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '1800' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ImageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'textBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'smallHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'text' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'mediaWithCaption' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MediaWithCaptionRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'media' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caption' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'centerText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'textOnImage' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'standalone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'largeTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'itemsToShow' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'standalone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'largeTitle' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridTwoColBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridTwocolBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'mediaWithCaption' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'newsListBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'reportsListBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridThreeColBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridThreecolBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'mediaWithCaption' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridTwoColBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridFourColBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridFourcolBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'mediaWithCaption' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridContainerBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridContainerBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'backgroundColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'textColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fullwidth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gap' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridTwoColBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridThreeColBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridFourColBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'office' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'websiteUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'officesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'offices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'office' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'plugBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PlugBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'simpleTitleAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SimpleTitleAndTextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'topLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroImageTablet' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'statementBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StatementBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blackBackground' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          { kind: 'Field', name: { kind: 'Name', value: 'small' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkUrl' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageMobile' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '1728' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageTablet' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroImageTablet' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageDesktop' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '1620' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnImageAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnImageAndTextRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reverse' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnTextIntroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnTextIntroRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'uploadVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UploadVideoField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mp4Url' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'mp4Low' },
            name: { kind: 'Name', value: 'mp4Url' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'res' },
                value: { kind: 'EnumValue', value: 'low' },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'streamingUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'thumbnailUrl' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSixteenByNine' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '16:9',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'videoBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VideoRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'autoplay' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'video' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'uploadVideo' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'videoThumbnail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSixteenByNine' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'muxVideo' },
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'sliderBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SliderBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'arrows' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slideAnimation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'delay' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'dots' },
            name: { kind: 'Name', value: 'navigationDots' },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'heroes' },
            name: { kind: 'Name', value: 'slides' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'subheadingBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SubheadingBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButton' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'backgroundColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'sustainabilityReportsBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SustainabilityReportsBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reports' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'contactPageContentArea' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ContactPageModelContentAreaField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'articlesBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'brandsBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'bulletListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'documentLinkBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'employeeBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'heroBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'gridContainerBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'jobsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'newsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'officesBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'plugBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'simpleTitleAndTextBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'statementBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'textBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'twoColumnImageAndTextBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'twoColumnTextIntroBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'videoBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'sliderBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'subheadingBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'sustainabilityReportsBlock' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'image' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'language' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LanguageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'flag' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'symbol' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBasic' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'subMenuItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ItemRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pageLink' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'BrandPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SustainabilityPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'AboutUsPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'menuItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MenuItemRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submenu' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'menuItems' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'subMenuItem' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'link' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LinkRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'footerMenuItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FooterMenuItemRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'heading' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'links' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'includeCookieToggle' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'iconLink' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'IconLinkRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'icon' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBasic' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'contactPageContent' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ContactPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'pageLocales' },
            name: { kind: 'Name', value: '_locales' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'seo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'seo' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentArea' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'contactPageContentArea' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'globalContent' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GlobalRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'navigationLogo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'image' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'changeLanguage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'closeLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deadline' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'loading' } },
          { kind: 'Field', name: { kind: 'Name', value: 'loadMoreNews' } },
          { kind: 'Field', name: { kind: 'Name', value: 'localWebLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'menu' } },
          { kind: 'Field', name: { kind: 'Name', value: 'moreNewsCta' } },
          { kind: 'Field', name: { kind: 'Name', value: 'moreNewsHeader' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'partnerPortalLabel' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerPortalUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'play' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shopLinkTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shopLinkUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'showMoreJobsLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'viewOnMapLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'languages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'language' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'nextLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previousLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sliderNavigationLabel' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'moreReportsCta' } },
          { kind: 'Field', name: { kind: 'Name', value: 'loadMoreReports' } },
          { kind: 'Field', name: { kind: 'Name', value: 'clearIconLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'searchIconLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchBoxPlaceholder' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'viewAllButtonLabel' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchResultsPageTitle' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'firstPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previousPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'goToPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'searchResultCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'noSearchResults' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'featureToggle' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FeatureToggleRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'landingPageContentArea' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsPageContentArea' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'menu' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MenuRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'menuItems' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'menuItem' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'footer' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FooterRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'bottomIntro' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cookieSettings' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'footerLogo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBasic' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hultaforsBrands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'link' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'menu' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'link' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'menuItems' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'footerMenuItem' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'moreInfoText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerLogin' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selectCountryLabel' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'socialMediaLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'socialMediaMenu' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'iconLink' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'useNewFooter' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContactPageQuery, ContactPageQueryVariables>;
export const JobOpportunitiesListPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'jobOpportunitiesListPage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'locale' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'SiteLocale' },
          },
          defaultValue: { kind: 'EnumValue', value: 'en' },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'jobOpportunitiesListPage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'jobOpportunitiesListPageContent',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'globalContent' },
            name: { kind: 'Name', value: 'global' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'globalContent' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'featureToggle' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'featureToggle' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'menu' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'menu' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'footer' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'footer' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'seo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SeoField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobOpportunitiesPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'department' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'focalPoint' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'focalPoint' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'y' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'hex' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ColorField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hex' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageLoad' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'focalPoint' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'focalPoint' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'fileLink' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'uploadId' },
            name: { kind: 'Name', value: 'id' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListingRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pdf' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'articlesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ArticlesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isJobArticles' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'jobPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'newsPageListing' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'reportsPageListing' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBasic' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSquare' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '1:1',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brand' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'brandName' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSquare' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brandsBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandsBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hideLabels' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'bulletListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BulletListRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bullets' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberedList' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'documentLinkBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DocumentLinkBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'documents' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'employeeBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'EmployeeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'description' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'profileImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'overlay' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OverlayRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'color' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'opacity' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ctaButton' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CtaButtonRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'muxVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'muxPlaybackId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HeroBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'boxColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'textColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'dynamicImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'max' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '1800' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ImageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'standalone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'largeTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'itemsToShow' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'office' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'websiteUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'officesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'offices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'office' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'plugBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PlugBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'simpleTitleAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SimpleTitleAndTextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'topLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroImageTablet' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'statementBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StatementBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blackBackground' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          { kind: 'Field', name: { kind: 'Name', value: 'small' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkUrl' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageMobile' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '1728' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageTablet' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroImageTablet' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageDesktop' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '1620' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'textBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'smallHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'text' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnImageAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnImageAndTextRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reverse' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnTextIntroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnTextIntroRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'uploadVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UploadVideoField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mp4Url' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'mp4Low' },
            name: { kind: 'Name', value: 'mp4Url' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'res' },
                value: { kind: 'EnumValue', value: 'low' },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'streamingUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'thumbnailUrl' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSixteenByNine' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '16:9',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'videoBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VideoRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'autoplay' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'video' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'uploadVideo' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'videoThumbnail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSixteenByNine' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'muxVideo' },
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'sliderBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SliderBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'arrows' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slideAnimation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'delay' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'dots' },
            name: { kind: 'Name', value: 'navigationDots' },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'heroes' },
            name: { kind: 'Name', value: 'slides' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobOpportunitiesListPageContentArea' },
      typeCondition: {
        kind: 'NamedType',
        name: {
          kind: 'Name',
          value: 'JobOpportunitiesListPageModelContentAreaField',
        },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'articlesBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'brandsBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'bulletListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'documentLinkBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'employeeBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'heroBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'jobsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'newsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'officesBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'plugBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'simpleTitleAndTextBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'statementBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'textBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'twoColumnImageAndTextBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'twoColumnTextIntroBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'videoBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'sliderBlock' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'image' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'language' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LanguageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'flag' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'symbol' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBasic' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'subMenuItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ItemRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pageLink' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'BrandPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SustainabilityPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'AboutUsPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'menuItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MenuItemRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submenu' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'menuItems' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'subMenuItem' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'link' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LinkRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'footerMenuItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FooterMenuItemRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'heading' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'links' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'includeCookieToggle' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'iconLink' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'IconLinkRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'icon' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBasic' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobOpportunitiesListPageContent' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobOpportunitiesListPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'pageLocales' },
            name: { kind: 'Name', value: '_locales' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'seo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'seo' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentArea' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'jobOpportunitiesListPageContentArea',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'globalContent' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GlobalRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'navigationLogo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'image' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'changeLanguage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'closeLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deadline' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'loading' } },
          { kind: 'Field', name: { kind: 'Name', value: 'loadMoreNews' } },
          { kind: 'Field', name: { kind: 'Name', value: 'localWebLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'menu' } },
          { kind: 'Field', name: { kind: 'Name', value: 'moreNewsCta' } },
          { kind: 'Field', name: { kind: 'Name', value: 'moreNewsHeader' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'partnerPortalLabel' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerPortalUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'play' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shopLinkTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shopLinkUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'showMoreJobsLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'viewOnMapLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'languages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'language' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'nextLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previousLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sliderNavigationLabel' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'moreReportsCta' } },
          { kind: 'Field', name: { kind: 'Name', value: 'loadMoreReports' } },
          { kind: 'Field', name: { kind: 'Name', value: 'clearIconLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'searchIconLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchBoxPlaceholder' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'viewAllButtonLabel' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchResultsPageTitle' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'firstPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previousPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'goToPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'searchResultCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'noSearchResults' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'featureToggle' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FeatureToggleRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'landingPageContentArea' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsPageContentArea' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'menu' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MenuRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'menuItems' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'menuItem' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'footer' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FooterRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'bottomIntro' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cookieSettings' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'footerLogo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBasic' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hultaforsBrands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'link' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'menu' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'link' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'menuItems' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'footerMenuItem' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'moreInfoText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerLogin' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selectCountryLabel' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'socialMediaLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'socialMediaMenu' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'iconLink' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'useNewFooter' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  JobOpportunitiesListPageQuery,
  JobOpportunitiesListPageQueryVariables
>;
export const JobOpportunitiesPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'jobOpportunitiesPage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'locale' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'SiteLocale' },
          },
          defaultValue: { kind: 'EnumValue', value: 'en' },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'jobOpportunitiesPage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'fallbackLocales' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'slug' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'slug' },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: '_locales' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'allIn' },
                            value: {
                              kind: 'ListValue',
                              values: [
                                {
                                  kind: 'Variable',
                                  name: { kind: 'Name', value: 'locale' },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'jobOpportunitiesPageContent' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'globalContent' },
            name: { kind: 'Name', value: 'global' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'globalContent' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'featureToggle' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'featureToggle' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'menu' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'menu' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'footer' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'footer' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'seo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SeoField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobOpportunitiesPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'department' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'focalPoint' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'focalPoint' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'y' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'hex' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ColorField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hex' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageLoad' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'focalPoint' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'focalPoint' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'fileLink' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'uploadId' },
            name: { kind: 'Name', value: 'id' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListingRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pdf' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'articlesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ArticlesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isJobArticles' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'jobPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'newsPageListing' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'reportsPageListing' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBasic' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSquare' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '1:1',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brand' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'brandName' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSquare' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brandsBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandsBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hideLabels' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'bulletListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BulletListRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bullets' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberedList' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'documentLinkBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DocumentLinkBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'documents' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'employeeBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'EmployeeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'description' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'profileImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'overlay' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OverlayRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'color' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'opacity' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ctaButton' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CtaButtonRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'muxVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'muxPlaybackId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HeroBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'boxColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'textColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'dynamicImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'max' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '1800' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ImageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'standalone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'largeTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'itemsToShow' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'office' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'websiteUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'officesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'offices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'office' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'plugBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PlugBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'simpleTitleAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SimpleTitleAndTextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'topLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroImageTablet' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'statementBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StatementBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blackBackground' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          { kind: 'Field', name: { kind: 'Name', value: 'small' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkUrl' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageMobile' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '1728' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageTablet' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroImageTablet' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageDesktop' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '1620' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'textBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'smallHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'text' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnImageAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnImageAndTextRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reverse' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnTextIntroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnTextIntroRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'uploadVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UploadVideoField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mp4Url' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'mp4Low' },
            name: { kind: 'Name', value: 'mp4Url' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'res' },
                value: { kind: 'EnumValue', value: 'low' },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'streamingUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'thumbnailUrl' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSixteenByNine' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '16:9',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'videoBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VideoRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'autoplay' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'video' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'uploadVideo' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'videoThumbnail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSixteenByNine' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'muxVideo' },
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'sliderBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SliderBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'arrows' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slideAnimation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'delay' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'dots' },
            name: { kind: 'Name', value: 'navigationDots' },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'heroes' },
            name: { kind: 'Name', value: 'slides' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobOpportunitiesPageContentArea' },
      typeCondition: {
        kind: 'NamedType',
        name: {
          kind: 'Name',
          value: 'JobOpportunitiesPageModelContentAreaField',
        },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'articlesBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'brandsBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'bulletListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'documentLinkBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'employeeBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'heroBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'jobsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'newsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'officesBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'plugBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'simpleTitleAndTextBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'statementBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'textBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'twoColumnImageAndTextBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'twoColumnTextIntroBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'videoBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'sliderBlock' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'image' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'language' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LanguageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'flag' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'symbol' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBasic' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'subMenuItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ItemRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pageLink' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'BrandPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SustainabilityPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'AboutUsPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'menuItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MenuItemRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submenu' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'menuItems' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'subMenuItem' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'link' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LinkRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'footerMenuItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FooterMenuItemRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'heading' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'links' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'includeCookieToggle' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'iconLink' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'IconLinkRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'icon' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBasic' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobOpportunitiesPageContent' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobOpportunitiesPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'pageLocales' },
            name: { kind: 'Name', value: '_locales' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'seo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'seo' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationDeadline' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentArea' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'jobOpportunitiesPageContentArea',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'globalContent' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GlobalRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'navigationLogo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'image' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'changeLanguage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'closeLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deadline' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'loading' } },
          { kind: 'Field', name: { kind: 'Name', value: 'loadMoreNews' } },
          { kind: 'Field', name: { kind: 'Name', value: 'localWebLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'menu' } },
          { kind: 'Field', name: { kind: 'Name', value: 'moreNewsCta' } },
          { kind: 'Field', name: { kind: 'Name', value: 'moreNewsHeader' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'partnerPortalLabel' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerPortalUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'play' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shopLinkTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shopLinkUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'showMoreJobsLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'viewOnMapLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'languages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'language' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'nextLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previousLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sliderNavigationLabel' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'moreReportsCta' } },
          { kind: 'Field', name: { kind: 'Name', value: 'loadMoreReports' } },
          { kind: 'Field', name: { kind: 'Name', value: 'clearIconLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'searchIconLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchBoxPlaceholder' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'viewAllButtonLabel' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchResultsPageTitle' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'firstPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previousPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'goToPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'searchResultCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'noSearchResults' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'featureToggle' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FeatureToggleRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'landingPageContentArea' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsPageContentArea' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'menu' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MenuRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'menuItems' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'menuItem' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'footer' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FooterRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'bottomIntro' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cookieSettings' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'footerLogo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBasic' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hultaforsBrands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'link' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'menu' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'link' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'menuItems' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'footerMenuItem' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'moreInfoText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerLogin' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selectCountryLabel' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'socialMediaLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'socialMediaMenu' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'iconLink' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'useNewFooter' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  JobOpportunitiesPageQuery,
  JobOpportunitiesPageQueryVariables
>;
export const LandingPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'landingPage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'locale' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'SiteLocale' },
          },
          defaultValue: { kind: 'EnumValue', value: 'en' },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'landingPage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'landingPageContent' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'globalContent' },
            name: { kind: 'Name', value: 'global' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'globalContent' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'featureToggle' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'featureToggle' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'menu' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'menu' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'footer' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'footer' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'seo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SeoField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobOpportunitiesPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'department' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'focalPoint' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'focalPoint' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'y' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'hex' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ColorField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hex' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageLoad' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'focalPoint' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'focalPoint' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'fileLink' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'uploadId' },
            name: { kind: 'Name', value: 'id' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListingRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pdf' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'articlesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ArticlesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isJobArticles' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'jobPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'newsPageListing' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'reportsPageListing' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBasic' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSquare' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '1:1',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brand' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'brandName' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSquare' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brandsBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandsBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hideLabels' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'bulletListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BulletListRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bullets' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberedList' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'documentLinkBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DocumentLinkBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'documents' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'employeeBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'EmployeeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'description' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'profileImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'overlay' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OverlayRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'color' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'opacity' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ctaButton' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CtaButtonRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'muxVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'muxPlaybackId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HeroBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'boxColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'textColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'dynamicImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'max' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '1800' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ImageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'textBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'smallHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'text' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'mediaWithCaption' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MediaWithCaptionRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'media' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caption' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'centerText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'textOnImage' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'standalone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'largeTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'itemsToShow' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'standalone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'largeTitle' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridTwoColBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridTwocolBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'mediaWithCaption' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'newsListBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'reportsListBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridThreeColBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridThreecolBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'mediaWithCaption' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridTwoColBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridFourColBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridFourcolBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'mediaWithCaption' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridContainerBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridContainerBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'backgroundColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'textColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fullwidth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gap' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridTwoColBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridThreeColBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridFourColBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsAndReportsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsAndReportsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'newsTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'news' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NewsPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'publishDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'reportsTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportsImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reports' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ReportsListingRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'publishDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pdf' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'fileLink' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'office' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'websiteUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'officesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'offices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'office' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'plugBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PlugBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'simpleTitleAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SimpleTitleAndTextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'topLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroImageTablet' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'statementBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StatementBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blackBackground' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          { kind: 'Field', name: { kind: 'Name', value: 'small' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkUrl' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageMobile' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '1728' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageTablet' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroImageTablet' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageDesktop' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '1620' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnImageAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnImageAndTextRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reverse' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnTextIntroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnTextIntroRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'uploadVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UploadVideoField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mp4Url' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'mp4Low' },
            name: { kind: 'Name', value: 'mp4Url' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'res' },
                value: { kind: 'EnumValue', value: 'low' },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'streamingUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'thumbnailUrl' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSixteenByNine' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '16:9',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'videoBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VideoRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'autoplay' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'video' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'uploadVideo' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'videoThumbnail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSixteenByNine' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'muxVideo' },
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'sliderBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SliderBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'arrows' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slideAnimation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'delay' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'dots' },
            name: { kind: 'Name', value: 'navigationDots' },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'heroes' },
            name: { kind: 'Name', value: 'slides' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'subheadingBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SubheadingBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButton' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'backgroundColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'sustainabilityReportsBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SustainabilityReportsBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reports' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'landingPageContentArea' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LandingPageModelContentAreaField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'articlesBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'brandsBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'bulletListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'documentLinkBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'employeeBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'heroBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'gridContainerBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'jobsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'newsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'newsAndReportsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'officesBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'plugBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'simpleTitleAndTextBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'statementBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'textBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'twoColumnImageAndTextBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'twoColumnTextIntroBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'videoBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'sliderBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'subheadingBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'sustainabilityReportsBlock' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'image' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'language' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LanguageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'flag' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'symbol' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBasic' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'subMenuItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ItemRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pageLink' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'BrandPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SustainabilityPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'AboutUsPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'menuItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MenuItemRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submenu' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'menuItems' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'subMenuItem' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'link' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LinkRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'footerMenuItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FooterMenuItemRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'heading' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'links' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'includeCookieToggle' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'iconLink' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'IconLinkRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'icon' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBasic' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'landingPageContent' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LandingPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'pageLocales' },
            name: { kind: 'Name', value: '_locales' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'seo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'seo' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentArea' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'landingPageContentArea' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'globalContent' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GlobalRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'navigationLogo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'image' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'changeLanguage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'closeLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deadline' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'loading' } },
          { kind: 'Field', name: { kind: 'Name', value: 'loadMoreNews' } },
          { kind: 'Field', name: { kind: 'Name', value: 'localWebLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'menu' } },
          { kind: 'Field', name: { kind: 'Name', value: 'moreNewsCta' } },
          { kind: 'Field', name: { kind: 'Name', value: 'moreNewsHeader' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'partnerPortalLabel' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerPortalUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'play' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shopLinkTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shopLinkUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'showMoreJobsLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'viewOnMapLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'languages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'language' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'nextLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previousLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sliderNavigationLabel' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'moreReportsCta' } },
          { kind: 'Field', name: { kind: 'Name', value: 'loadMoreReports' } },
          { kind: 'Field', name: { kind: 'Name', value: 'clearIconLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'searchIconLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchBoxPlaceholder' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'viewAllButtonLabel' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchResultsPageTitle' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'firstPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previousPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'goToPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'searchResultCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'noSearchResults' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'featureToggle' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FeatureToggleRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'landingPageContentArea' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsPageContentArea' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'menu' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MenuRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'menuItems' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'menuItem' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'footer' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FooterRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'bottomIntro' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cookieSettings' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'footerLogo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBasic' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hultaforsBrands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'link' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'menu' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'link' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'menuItems' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'footerMenuItem' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'moreInfoText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerLogin' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selectCountryLabel' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'socialMediaLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'socialMediaMenu' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'iconLink' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'useNewFooter' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LandingPageQuery, LandingPageQueryVariables>;
export const NewsListPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'newsListPage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'locale' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'SiteLocale' },
          },
          defaultValue: { kind: 'EnumValue', value: 'en' },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsListPage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'newsListPageContent' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'globalContent' },
            name: { kind: 'Name', value: 'global' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'globalContent' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'featureToggle' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'featureToggle' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'menu' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'menu' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'footer' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'footer' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'seo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SeoField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobOpportunitiesPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'department' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'focalPoint' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'focalPoint' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'y' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'hex' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ColorField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hex' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageLoad' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'focalPoint' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'focalPoint' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'fileLink' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'uploadId' },
            name: { kind: 'Name', value: 'id' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListingRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pdf' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'articlesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ArticlesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isJobArticles' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'jobPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'newsPageListing' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'reportsPageListing' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBasic' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSquare' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '1:1',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brand' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'brandName' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSquare' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brandsBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandsBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hideLabels' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'bulletListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BulletListRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bullets' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberedList' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'documentLinkBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DocumentLinkBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'documents' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'employeeBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'EmployeeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'description' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'profileImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'overlay' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OverlayRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'color' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'opacity' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ctaButton' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CtaButtonRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'muxVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'muxPlaybackId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HeroBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'boxColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'textColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'dynamicImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'max' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '1800' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ImageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'standalone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'largeTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'itemsToShow' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsAndReportsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsAndReportsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'newsTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'news' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NewsPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'publishDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'reportsTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportsImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reports' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ReportsListingRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'publishDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pdf' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'fileLink' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'office' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'websiteUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'officesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'offices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'office' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'plugBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PlugBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'simpleTitleAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SimpleTitleAndTextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'topLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroImageTablet' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'statementBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StatementBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blackBackground' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          { kind: 'Field', name: { kind: 'Name', value: 'small' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkUrl' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageMobile' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '1728' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageTablet' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroImageTablet' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageDesktop' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '1620' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'textBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'smallHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'text' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnImageAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnImageAndTextRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reverse' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnTextIntroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnTextIntroRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'uploadVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UploadVideoField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mp4Url' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'mp4Low' },
            name: { kind: 'Name', value: 'mp4Url' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'res' },
                value: { kind: 'EnumValue', value: 'low' },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'streamingUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'thumbnailUrl' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSixteenByNine' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '16:9',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'videoBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VideoRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'autoplay' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'video' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'uploadVideo' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'videoThumbnail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSixteenByNine' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'muxVideo' },
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'sliderBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SliderBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'arrows' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slideAnimation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'delay' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'dots' },
            name: { kind: 'Name', value: 'navigationDots' },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'heroes' },
            name: { kind: 'Name', value: 'slides' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsListPageContentArea' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsListPageModelContentAreaField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'articlesBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'brandsBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'bulletListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'documentLinkBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'employeeBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'heroBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'jobsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'newsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'newsAndReportsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'officesBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'plugBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'simpleTitleAndTextBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'statementBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'textBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'twoColumnImageAndTextBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'twoColumnTextIntroBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'videoBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'sliderBlock' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'image' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'language' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LanguageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'flag' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'symbol' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBasic' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'subMenuItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ItemRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pageLink' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'BrandPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SustainabilityPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'AboutUsPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'menuItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MenuItemRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submenu' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'menuItems' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'subMenuItem' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'link' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LinkRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'footerMenuItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FooterMenuItemRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'heading' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'links' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'includeCookieToggle' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'iconLink' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'IconLinkRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'icon' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBasic' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsListPageContent' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsListPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'pageLocales' },
            name: { kind: 'Name', value: '_locales' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'seo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'seo' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentArea' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'newsListPageContentArea' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'globalContent' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GlobalRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'navigationLogo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'image' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'changeLanguage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'closeLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deadline' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'loading' } },
          { kind: 'Field', name: { kind: 'Name', value: 'loadMoreNews' } },
          { kind: 'Field', name: { kind: 'Name', value: 'localWebLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'menu' } },
          { kind: 'Field', name: { kind: 'Name', value: 'moreNewsCta' } },
          { kind: 'Field', name: { kind: 'Name', value: 'moreNewsHeader' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'partnerPortalLabel' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerPortalUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'play' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shopLinkTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shopLinkUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'showMoreJobsLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'viewOnMapLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'languages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'language' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'nextLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previousLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sliderNavigationLabel' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'moreReportsCta' } },
          { kind: 'Field', name: { kind: 'Name', value: 'loadMoreReports' } },
          { kind: 'Field', name: { kind: 'Name', value: 'clearIconLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'searchIconLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchBoxPlaceholder' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'viewAllButtonLabel' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchResultsPageTitle' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'firstPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previousPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'goToPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'searchResultCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'noSearchResults' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'featureToggle' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FeatureToggleRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'landingPageContentArea' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsPageContentArea' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'menu' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MenuRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'menuItems' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'menuItem' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'footer' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FooterRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'bottomIntro' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cookieSettings' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'footerLogo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBasic' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hultaforsBrands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'link' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'menu' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'link' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'menuItems' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'footerMenuItem' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'moreInfoText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerLogin' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selectCountryLabel' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'socialMediaLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'socialMediaMenu' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'iconLink' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'useNewFooter' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NewsListPageQuery, NewsListPageQueryVariables>;
export const NewsPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'newsPage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'locale' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'SiteLocale' },
          },
          defaultValue: { kind: 'EnumValue', value: 'en' },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'numberOfRelated' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'IntType' } },
          defaultValue: { kind: 'IntValue', value: '10' },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsPage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'slug' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'slug' },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: '_locales' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'allIn' },
                            value: {
                              kind: 'ListValue',
                              values: [
                                {
                                  kind: 'Variable',
                                  name: { kind: 'Name', value: 'locale' },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'newsPageContent' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allNewsPages' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'numberOfRelated' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderBy' },
                value: { kind: 'EnumValue', value: 'publishDate_DESC' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'slug' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'neq' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'slug' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'newsPageListing' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: '_allNewsPagesMeta' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'collectionMetadata' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'globalContent' },
            name: { kind: 'Name', value: 'global' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'globalContent' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'featureToggle' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'featureToggle' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'menu' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'menu' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'footer' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'footer' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'focalPoint' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'focalPoint' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'y' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'hex' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ColorField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hex' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageLoad' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'focalPoint' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'focalPoint' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobOpportunitiesPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'department' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'fileLink' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'uploadId' },
            name: { kind: 'Name', value: 'id' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListingRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pdf' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'articlesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ArticlesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isJobArticles' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'jobPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'newsPageListing' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'reportsPageListing' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBasic' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSquare' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '1:1',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brand' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'brandName' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSquare' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brandsBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandsBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hideLabels' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'bulletListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BulletListRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bullets' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberedList' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'documentLinkBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DocumentLinkBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'documents' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'employeeBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'EmployeeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'description' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'profileImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'overlay' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OverlayRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'color' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'opacity' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ctaButton' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CtaButtonRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'muxVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'muxPlaybackId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HeroBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'boxColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'textColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'dynamicImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'max' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '1800' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ImageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'standalone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'largeTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'itemsToShow' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsAndReportsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsAndReportsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'newsTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'news' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NewsPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'publishDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'reportsTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportsImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reports' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ReportsListingRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'publishDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pdf' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'fileLink' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'office' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'websiteUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'officesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'offices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'office' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'plugBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PlugBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'simpleTitleAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SimpleTitleAndTextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'topLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroImageTablet' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'statementBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StatementBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blackBackground' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          { kind: 'Field', name: { kind: 'Name', value: 'small' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkUrl' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageMobile' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '1728' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageTablet' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroImageTablet' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageDesktop' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '1620' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'textBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'smallHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'text' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnImageAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnImageAndTextRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reverse' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnTextIntroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnTextIntroRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'uploadVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UploadVideoField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mp4Url' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'mp4Low' },
            name: { kind: 'Name', value: 'mp4Url' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'res' },
                value: { kind: 'EnumValue', value: 'low' },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'streamingUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'thumbnailUrl' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSixteenByNine' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '16:9',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'videoBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VideoRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'autoplay' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'video' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'uploadVideo' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'videoThumbnail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSixteenByNine' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'muxVideo' },
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'sliderBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SliderBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'arrows' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slideAnimation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'delay' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'dots' },
            name: { kind: 'Name', value: 'navigationDots' },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'heroes' },
            name: { kind: 'Name', value: 'slides' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsPageContentArea' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsPageModelContentAreaField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'articlesBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'brandsBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'bulletListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'documentLinkBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'employeeBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'heroBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'jobsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'newsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'newsAndReportsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'officesBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'plugBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'simpleTitleAndTextBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'statementBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'textBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'twoColumnImageAndTextBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'twoColumnTextIntroBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'videoBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'sliderBlock' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'seo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SeoField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'image' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'language' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LanguageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'flag' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'symbol' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBasic' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'subMenuItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ItemRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pageLink' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'BrandPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SustainabilityPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'AboutUsPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'menuItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MenuItemRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submenu' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'menuItems' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'subMenuItem' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'link' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LinkRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'footerMenuItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FooterMenuItemRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'heading' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'links' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'includeCookieToggle' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'iconLink' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'IconLinkRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'icon' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBasic' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsPageContent' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentArea' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'newsPageContentArea' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'seo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'seo' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'pageLocales' },
            name: { kind: 'Name', value: '_locales' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'collectionMetadata' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CollectionMetadata' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'globalContent' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GlobalRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'navigationLogo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'image' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'changeLanguage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'closeLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deadline' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'loading' } },
          { kind: 'Field', name: { kind: 'Name', value: 'loadMoreNews' } },
          { kind: 'Field', name: { kind: 'Name', value: 'localWebLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'menu' } },
          { kind: 'Field', name: { kind: 'Name', value: 'moreNewsCta' } },
          { kind: 'Field', name: { kind: 'Name', value: 'moreNewsHeader' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'partnerPortalLabel' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerPortalUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'play' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shopLinkTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shopLinkUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'showMoreJobsLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'viewOnMapLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'languages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'language' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'nextLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previousLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sliderNavigationLabel' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'moreReportsCta' } },
          { kind: 'Field', name: { kind: 'Name', value: 'loadMoreReports' } },
          { kind: 'Field', name: { kind: 'Name', value: 'clearIconLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'searchIconLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchBoxPlaceholder' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'viewAllButtonLabel' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchResultsPageTitle' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'firstPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previousPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'goToPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'searchResultCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'noSearchResults' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'featureToggle' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FeatureToggleRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'landingPageContentArea' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsPageContentArea' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'menu' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MenuRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'menuItems' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'menuItem' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'footer' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FooterRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'bottomIntro' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cookieSettings' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'footerLogo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBasic' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hultaforsBrands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'link' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'menu' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'link' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'menuItems' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'footerMenuItem' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'moreInfoText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerLogin' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selectCountryLabel' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'socialMediaLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'socialMediaMenu' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'iconLink' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'useNewFooter' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NewsPageQuery, NewsPageQueryVariables>;
export const PageNotFoundDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'pageNotFound' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'locale' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'SiteLocale' },
          },
          defaultValue: { kind: 'EnumValue', value: 'en' },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pageNotFound' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'pageNotFoundContent' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'globalContent' },
            name: { kind: 'Name', value: 'global' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'globalContent' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'featureToggle' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'featureToggle' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'menu' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'menu' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'footer' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'footer' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'image' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBasic' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'language' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LanguageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'flag' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'symbol' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBasic' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'subMenuItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ItemRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pageLink' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'BrandPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SustainabilityPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'AboutUsPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'menuItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MenuItemRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submenu' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'menuItems' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'subMenuItem' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'link' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LinkRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'footerMenuItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FooterMenuItemRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'heading' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'links' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'includeCookieToggle' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'iconLink' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'IconLinkRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'icon' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBasic' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'pageNotFoundContent' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PageNotFoundRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'backToHomeScreenButton' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'globalContent' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GlobalRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'navigationLogo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'image' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'changeLanguage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'closeLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deadline' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'loading' } },
          { kind: 'Field', name: { kind: 'Name', value: 'loadMoreNews' } },
          { kind: 'Field', name: { kind: 'Name', value: 'localWebLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'menu' } },
          { kind: 'Field', name: { kind: 'Name', value: 'moreNewsCta' } },
          { kind: 'Field', name: { kind: 'Name', value: 'moreNewsHeader' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'partnerPortalLabel' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerPortalUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'play' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shopLinkTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shopLinkUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'showMoreJobsLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'viewOnMapLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'languages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'language' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'nextLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previousLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sliderNavigationLabel' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'moreReportsCta' } },
          { kind: 'Field', name: { kind: 'Name', value: 'loadMoreReports' } },
          { kind: 'Field', name: { kind: 'Name', value: 'clearIconLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'searchIconLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchBoxPlaceholder' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'viewAllButtonLabel' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchResultsPageTitle' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'firstPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previousPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'goToPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'searchResultCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'noSearchResults' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'featureToggle' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FeatureToggleRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'landingPageContentArea' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsPageContentArea' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'menu' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MenuRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'menuItems' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'menuItem' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'footer' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FooterRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'bottomIntro' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cookieSettings' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'footerLogo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBasic' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hultaforsBrands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'link' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'menu' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'link' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'menuItems' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'footerMenuItem' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'moreInfoText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerLogin' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selectCountryLabel' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'socialMediaLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'socialMediaMenu' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'iconLink' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'useNewFooter' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PageNotFoundQuery, PageNotFoundQueryVariables>;
export const ReportsListPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'reportsListPage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'locale' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'SiteLocale' },
          },
          defaultValue: { kind: 'EnumValue', value: 'en' },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportsListPage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'reportsListPageContent' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'globalContent' },
            name: { kind: 'Name', value: 'global' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'globalContent' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'featureToggle' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'featureToggle' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'menu' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'menu' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'footer' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'footer' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'seo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SeoField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobOpportunitiesPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'department' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'focalPoint' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'focalPoint' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'y' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'hex' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ColorField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hex' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageLoad' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'focalPoint' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'focalPoint' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'fileLink' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'uploadId' },
            name: { kind: 'Name', value: 'id' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListingRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pdf' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'articlesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ArticlesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isJobArticles' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'jobPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'newsPageListing' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'reportsPageListing' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBasic' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSquare' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '1:1',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brand' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'brandName' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSquare' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brandsBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandsBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hideLabels' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'bulletListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BulletListRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bullets' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberedList' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'documentLinkBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DocumentLinkBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'documents' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'employeeBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'EmployeeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'description' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'profileImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'overlay' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OverlayRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'color' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'opacity' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ctaButton' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CtaButtonRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'muxVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'muxPlaybackId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HeroBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'boxColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'textColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'dynamicImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'max' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '1800' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ImageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'standalone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'largeTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'itemsToShow' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsAndReportsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsAndReportsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'newsTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'news' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NewsPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'publishDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'reportsTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportsImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reports' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ReportsListingRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'publishDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pdf' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'fileLink' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'office' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'websiteUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'officesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'offices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'office' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'plugBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PlugBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'simpleTitleAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SimpleTitleAndTextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'topLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroImageTablet' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'statementBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StatementBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blackBackground' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          { kind: 'Field', name: { kind: 'Name', value: 'small' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkUrl' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageMobile' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '1728' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageTablet' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroImageTablet' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageDesktop' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '1620' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'textBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'smallHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'text' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnImageAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnImageAndTextRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reverse' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnTextIntroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnTextIntroRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'uploadVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UploadVideoField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mp4Url' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'mp4Low' },
            name: { kind: 'Name', value: 'mp4Url' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'res' },
                value: { kind: 'EnumValue', value: 'low' },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'streamingUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'thumbnailUrl' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSixteenByNine' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '16:9',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'videoBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VideoRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'autoplay' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'video' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'uploadVideo' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'videoThumbnail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSixteenByNine' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'muxVideo' },
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'sliderBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SliderBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'arrows' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slideAnimation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'delay' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'dots' },
            name: { kind: 'Name', value: 'navigationDots' },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'heroes' },
            name: { kind: 'Name', value: 'slides' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'standalone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'largeTitle' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsListPageContentArea' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListPageModelContentAreaField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'articlesBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'brandsBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'bulletListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'documentLinkBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'employeeBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'heroBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'jobsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'newsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'newsAndReportsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'officesBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'plugBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'simpleTitleAndTextBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'statementBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'textBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'twoColumnImageAndTextBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'twoColumnTextIntroBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'videoBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'sliderBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'reportsListBlock' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'image' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'language' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LanguageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'flag' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'symbol' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBasic' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'subMenuItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ItemRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pageLink' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'BrandPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SustainabilityPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'AboutUsPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'menuItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MenuItemRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submenu' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'menuItems' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'subMenuItem' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'link' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LinkRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'footerMenuItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FooterMenuItemRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'heading' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'links' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'includeCookieToggle' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'iconLink' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'IconLinkRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'icon' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBasic' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsListPageContent' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'pageLocales' },
            name: { kind: 'Name', value: '_locales' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'seo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'seo' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentArea' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'reportsListPageContentArea' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'globalContent' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GlobalRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'navigationLogo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'image' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'changeLanguage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'closeLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deadline' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'loading' } },
          { kind: 'Field', name: { kind: 'Name', value: 'loadMoreNews' } },
          { kind: 'Field', name: { kind: 'Name', value: 'localWebLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'menu' } },
          { kind: 'Field', name: { kind: 'Name', value: 'moreNewsCta' } },
          { kind: 'Field', name: { kind: 'Name', value: 'moreNewsHeader' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'partnerPortalLabel' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerPortalUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'play' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shopLinkTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shopLinkUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'showMoreJobsLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'viewOnMapLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'languages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'language' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'nextLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previousLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sliderNavigationLabel' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'moreReportsCta' } },
          { kind: 'Field', name: { kind: 'Name', value: 'loadMoreReports' } },
          { kind: 'Field', name: { kind: 'Name', value: 'clearIconLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'searchIconLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchBoxPlaceholder' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'viewAllButtonLabel' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchResultsPageTitle' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'firstPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previousPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'goToPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'searchResultCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'noSearchResults' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'featureToggle' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FeatureToggleRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'landingPageContentArea' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsPageContentArea' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'menu' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MenuRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'menuItems' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'menuItem' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'footer' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FooterRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'bottomIntro' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cookieSettings' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'footerLogo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBasic' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hultaforsBrands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'link' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'menu' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'link' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'menuItems' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'footerMenuItem' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'moreInfoText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerLogin' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selectCountryLabel' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'socialMediaLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'socialMediaMenu' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'iconLink' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'useNewFooter' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReportsListPageQuery,
  ReportsListPageQueryVariables
>;
export const ReportsListingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'reportsListing' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'locale' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'SiteLocale' },
          },
          defaultValue: { kind: 'EnumValue', value: 'en' },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'numberOfRelated' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'IntType' } },
          defaultValue: { kind: 'IntValue', value: '10' },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportsListing' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'slug' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'slug' },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: '_locales' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'allIn' },
                            value: {
                              kind: 'ListValue',
                              values: [
                                {
                                  kind: 'Variable',
                                  name: { kind: 'Name', value: 'locale' },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'reportsListingContent' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allReportsListings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'numberOfRelated' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderBy' },
                value: { kind: 'EnumValue', value: 'publishDate_DESC' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'slug' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'neq' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'slug' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'reportsPageListing' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: '_allReportsListingsMeta' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'collectionMetadata' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'globalContent' },
            name: { kind: 'Name', value: 'global' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'globalContent' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'featureToggle' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'featureToggle' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'menu' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'menu' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'footer' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'footer' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'focalPoint' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'focalPoint' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'y' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'hex' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ColorField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hex' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageLoad' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'focalPoint' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'focalPoint' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'fileLink' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'uploadId' },
            name: { kind: 'Name', value: 'id' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'seo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SeoField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'image' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBasic' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'language' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LanguageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'flag' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'symbol' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBasic' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'subMenuItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ItemRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pageLink' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'BrandPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SustainabilityPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'AboutUsPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'menuItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MenuItemRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submenu' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'menuItems' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'subMenuItem' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'link' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LinkRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'footerMenuItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FooterMenuItemRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'heading' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'links' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'includeCookieToggle' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'iconLink' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'IconLinkRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'icon' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBasic' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsListingContent' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListingRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pdf' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'seo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'seo' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'pageLocales' },
            name: { kind: 'Name', value: '_locales' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListingRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pdf' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'collectionMetadata' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CollectionMetadata' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'globalContent' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GlobalRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'navigationLogo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'image' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'changeLanguage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'closeLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deadline' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'loading' } },
          { kind: 'Field', name: { kind: 'Name', value: 'loadMoreNews' } },
          { kind: 'Field', name: { kind: 'Name', value: 'localWebLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'menu' } },
          { kind: 'Field', name: { kind: 'Name', value: 'moreNewsCta' } },
          { kind: 'Field', name: { kind: 'Name', value: 'moreNewsHeader' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'partnerPortalLabel' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerPortalUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'play' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shopLinkTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shopLinkUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'showMoreJobsLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'viewOnMapLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'languages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'language' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'nextLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previousLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sliderNavigationLabel' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'moreReportsCta' } },
          { kind: 'Field', name: { kind: 'Name', value: 'loadMoreReports' } },
          { kind: 'Field', name: { kind: 'Name', value: 'clearIconLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'searchIconLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchBoxPlaceholder' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'viewAllButtonLabel' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchResultsPageTitle' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'firstPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previousPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'goToPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'searchResultCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'noSearchResults' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'featureToggle' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FeatureToggleRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'landingPageContentArea' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsPageContentArea' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'menu' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MenuRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'menuItems' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'menuItem' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'footer' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FooterRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'bottomIntro' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cookieSettings' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'footerLogo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBasic' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hultaforsBrands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'link' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'menu' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'link' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'menuItems' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'footerMenuItem' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'moreInfoText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerLogin' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selectCountryLabel' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'socialMediaLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'socialMediaMenu' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'iconLink' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'useNewFooter' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ReportsListingQuery, ReportsListingQueryVariables>;
export const SiteLocaleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'siteLocale' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'locale' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'SiteLocale' },
          },
          defaultValue: { kind: 'EnumValue', value: 'en' },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'siteLocale' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'siteLocale' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'siteLocale' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SiteLocaleRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SiteLocaleQuery, SiteLocaleQueryVariables>;
export const SitemapDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'sitemap' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'locale' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'SiteLocale' },
          },
          defaultValue: { kind: 'EnumValue', value: 'en' },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'landingPage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'recordMeta' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactPage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'recordMeta' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'office' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderBy' },
                value: { kind: 'EnumValue', value: '_updatedAt_DESC' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'recordMeta' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsListPage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'recordMeta' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsPage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderBy' },
                value: { kind: 'EnumValue', value: '_updatedAt_DESC' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'recordMeta' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'jobOpportunitiesListPage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'recordMeta' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'jobOpportunitiesPage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderBy' },
                value: { kind: 'EnumValue', value: '_updatedAt_DESC' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: '_locales' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'allIn' },
                            value: {
                              kind: 'ListValue',
                              values: [
                                {
                                  kind: 'Variable',
                                  name: { kind: 'Name', value: 'locale' },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'recordMeta' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allNewsPages' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'StringValue', value: '100', block: false },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: '_locales' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'allIn' },
                            value: {
                              kind: 'ListValue',
                              values: [
                                {
                                  kind: 'Variable',
                                  name: { kind: 'Name', value: 'locale' },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'recordMeta' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allReportsListings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'StringValue', value: '100', block: false },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: '_locales' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'allIn' },
                            value: {
                              kind: 'ListValue',
                              values: [
                                {
                                  kind: 'Variable',
                                  name: { kind: 'Name', value: 'locale' },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'recordMeta' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allJobOpportunitiesPages' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'StringValue', value: '100', block: false },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: '_locales' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'allIn' },
                            value: {
                              kind: 'ListValue',
                              values: [
                                {
                                  kind: 'Variable',
                                  name: { kind: 'Name', value: 'locale' },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'recordMeta' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allBrandPages' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'StringValue', value: '100', block: false },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: '_locales' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'allIn' },
                            value: {
                              kind: 'ListValue',
                              values: [
                                {
                                  kind: 'Variable',
                                  name: { kind: 'Name', value: 'locale' },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'recordMeta' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allAboutUsPages' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'StringValue', value: '100', block: false },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: '_locales' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'allIn' },
                            value: {
                              kind: 'ListValue',
                              values: [
                                {
                                  kind: 'Variable',
                                  name: { kind: 'Name', value: 'locale' },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'recordMeta' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allSustainabilityPages' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'StringValue', value: '100', block: false },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: '_locales' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'allIn' },
                            value: {
                              kind: 'ListValue',
                              values: [
                                {
                                  kind: 'Variable',
                                  name: { kind: 'Name', value: 'locale' },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'recordMeta' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'recordMeta' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'RecordInterface' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '_updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SitemapQuery, SitemapQueryVariables>;
export const StaticPathsAllAboutUsPagesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'staticPathsAllAboutUsPages' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allAboutUsPages' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'StringValue', value: '100', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: '_locales' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StaticPathsAllAboutUsPagesQuery,
  StaticPathsAllAboutUsPagesQueryVariables
>;
export const StaticPathsAllBrandPagesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'staticPathsAllBrandPages' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allBrandPages' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'StringValue', value: '100', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: '_locales' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StaticPathsAllBrandPagesQuery,
  StaticPathsAllBrandPagesQueryVariables
>;
export const StaticPathsAllCampaignPagesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'staticPathsAllCampaignPages' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allCampaignPages' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'StringValue', value: '100', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: '_locales' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StaticPathsAllCampaignPagesQuery,
  StaticPathsAllCampaignPagesQueryVariables
>;
export const StaticPathsAllJobOpportunitiesPagesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'staticPathsAllJobOpportunitiesPages' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allJobOpportunitiesPages' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'StringValue', value: '100', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: '_locales' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StaticPathsAllJobOpportunitiesPagesQuery,
  StaticPathsAllJobOpportunitiesPagesQueryVariables
>;
export const StaticPathsAllNewsPagesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'staticPathsAllNewsPages' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allNewsPages' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'StringValue', value: '100', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: '_locales' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StaticPathsAllNewsPagesQuery,
  StaticPathsAllNewsPagesQueryVariables
>;
export const StaticPathsAllReportsListingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'staticPathsAllReportsListings' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allReportsListings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'StringValue', value: '100', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: '_locales' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StaticPathsAllReportsListingsQuery,
  StaticPathsAllReportsListingsQueryVariables
>;
export const StaticPathsAllSustainabilityPagesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'staticPathsAllSustainabilityPages' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allSustainabilityPages' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'StringValue', value: '100', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: '_locales' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StaticPathsAllSustainabilityPagesQuery,
  StaticPathsAllSustainabilityPagesQueryVariables
>;
export const SustainabilityIndexPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'sustainabilityIndexPage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'locale' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'SiteLocale' },
          },
          defaultValue: { kind: 'EnumValue', value: 'en' },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sustainabilityIndexPage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'sustainabilityIndexPageContent',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'globalContent' },
            name: { kind: 'Name', value: 'global' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'globalContent' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'featureToggle' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'featureToggle' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'menu' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'menu' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'footer' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'footer' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'seo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SeoField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ctaButton' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CtaButtonRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'textBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'smallHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'text' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'dynamicImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'max' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '1800' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'focalPoint' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'focalPoint' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'y' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'hex' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ColorField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hex' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageLoad' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'focalPoint' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'focalPoint' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ImageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnImageAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnImageAndTextRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reverse' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroImageTablet' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'overlay' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OverlayRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'color' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'opacity' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'statementBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StatementBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blackBackground' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          { kind: 'Field', name: { kind: 'Name', value: 'small' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkUrl' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageMobile' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '1728' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageTablet' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroImageTablet' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageDesktop' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '1620' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnTextIntroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnTextIntroRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'uploadVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UploadVideoField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mp4Url' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'mp4Low' },
            name: { kind: 'Name', value: 'mp4Url' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'res' },
                value: { kind: 'EnumValue', value: 'low' },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'streamingUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'thumbnailUrl' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBasic' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSixteenByNine' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '16:9',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'muxVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'muxPlaybackId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'videoBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VideoRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'autoplay' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'video' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'uploadVideo' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'videoThumbnail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSixteenByNine' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'muxVideo' },
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'employeeBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'EmployeeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'description' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'profileImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'bulletListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BulletListRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bullets' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberedList' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HeroBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'boxColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'textColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSquare' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '1:1',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brand' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'brandName' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSquare' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'plugBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PlugBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brandsBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandsBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hideLabels' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobOpportunitiesPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'department' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'fileLink' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'uploadId' },
            name: { kind: 'Name', value: 'id' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListingRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pdf' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'articlesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ArticlesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isJobArticles' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'jobPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'newsPageListing' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'reportsPageListing' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'office' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'websiteUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'officesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'offices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'office' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'simpleTitleAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SimpleTitleAndTextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'topLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'standalone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'largeTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'itemsToShow' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsAndReportsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsAndReportsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'newsTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'news' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NewsPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'publishDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'reportsTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportsImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reports' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ReportsListingRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'publishDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pdf' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'fileLink' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'documentLinkBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DocumentLinkBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'documents' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'sliderBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SliderBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'arrows' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slideAnimation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'delay' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'dots' },
            name: { kind: 'Name', value: 'navigationDots' },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'heroes' },
            name: { kind: 'Name', value: 'slides' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'standalone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'largeTitle' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'mediaWithCaption' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MediaWithCaptionRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'media' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caption' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'centerText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'textOnImage' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridTwoColBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridTwocolBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'mediaWithCaption' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'newsListBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'reportsListBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridThreeColBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridThreecolBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'mediaWithCaption' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridTwoColBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridFourColBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridFourcolBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'mediaWithCaption' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridContainerBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridContainerBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'backgroundColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'textColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fullwidth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gap' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridTwoColBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridThreeColBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridFourColBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'subheadingBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SubheadingBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButton' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'backgroundColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'sustainabilityReportsBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SustainabilityReportsBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reports' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'link' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LinkRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'pageNavigationBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PageNavigationBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'links' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'link' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'sustainabilityIndexPageContentArea' },
      typeCondition: {
        kind: 'NamedType',
        name: {
          kind: 'Name',
          value: 'SustainabilityIndexPageModelContentAreaField',
        },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'textBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'twoColumnImageAndTextBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'statementBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'twoColumnTextIntroBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'videoBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'employeeBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'bulletListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'heroBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'plugBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'brandsBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'articlesBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'officesBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'simpleTitleAndTextBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'newsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'newsAndReportsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'documentLinkBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'sliderBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'reportsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'gridContainerBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'subheadingBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'sustainabilityReportsBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'pageNavigationBlock' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'image' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'language' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LanguageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'flag' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'symbol' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBasic' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'subMenuItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ItemRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pageLink' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'BrandPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SustainabilityPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'AboutUsPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'menuItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MenuItemRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submenu' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'menuItems' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'subMenuItem' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'footerMenuItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FooterMenuItemRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'heading' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'links' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'includeCookieToggle' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'iconLink' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'IconLinkRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'icon' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBasic' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'sustainabilityIndexPageContent' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SustainabilityIndexPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'pageLocales' },
            name: { kind: 'Name', value: '_locales' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'seo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'seo' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentArea' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'sustainabilityIndexPageContentArea',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'globalContent' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GlobalRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'navigationLogo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'image' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'changeLanguage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'closeLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deadline' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'loading' } },
          { kind: 'Field', name: { kind: 'Name', value: 'loadMoreNews' } },
          { kind: 'Field', name: { kind: 'Name', value: 'localWebLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'menu' } },
          { kind: 'Field', name: { kind: 'Name', value: 'moreNewsCta' } },
          { kind: 'Field', name: { kind: 'Name', value: 'moreNewsHeader' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'partnerPortalLabel' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerPortalUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'play' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shopLinkTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shopLinkUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'showMoreJobsLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'viewOnMapLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'languages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'language' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'nextLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previousLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sliderNavigationLabel' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'moreReportsCta' } },
          { kind: 'Field', name: { kind: 'Name', value: 'loadMoreReports' } },
          { kind: 'Field', name: { kind: 'Name', value: 'clearIconLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'searchIconLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchBoxPlaceholder' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'viewAllButtonLabel' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchResultsPageTitle' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'firstPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previousPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'goToPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'searchResultCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'noSearchResults' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'featureToggle' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FeatureToggleRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'landingPageContentArea' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsPageContentArea' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'menu' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MenuRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'menuItems' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'menuItem' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'footer' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FooterRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'bottomIntro' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cookieSettings' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'footerLogo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBasic' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hultaforsBrands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'link' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'menu' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'link' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'menuItems' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'footerMenuItem' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'moreInfoText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerLogin' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selectCountryLabel' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'socialMediaLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'socialMediaMenu' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'iconLink' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'useNewFooter' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SustainabilityIndexPageQuery,
  SustainabilityIndexPageQueryVariables
>;
export const SustainabilityPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'sustainabilityPage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'locale' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'SiteLocale' },
          },
          defaultValue: { kind: 'EnumValue', value: 'en' },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sustainabilityPage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'slug' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'slug' },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: '_locales' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'allIn' },
                            value: {
                              kind: 'ListValue',
                              values: [
                                {
                                  kind: 'Variable',
                                  name: { kind: 'Name', value: 'locale' },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'sustainabilityPageContent' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'globalContent' },
            name: { kind: 'Name', value: 'global' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'globalContent' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'featureToggle' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'featureToggle' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'menu' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'menu' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'footer' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'locale' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'footer' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'seo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SeoField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobOpportunitiesPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'department' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'focalPoint' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'focalPoint' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'y' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'hex' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ColorField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hex' } }],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageLoad' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'focalPoint' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'focalPoint' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'fileLink' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'uploadId' },
            name: { kind: 'Name', value: 'id' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsPageListing' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListingRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pdf' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'articlesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ArticlesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isJobArticles' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'jobPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'jobOpportunitiesPageListing' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'newsPageListing' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportPages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'reportsPageListing' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBasic' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'format' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'responsiveImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ResponsiveImage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'aspectRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base64' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'src' } },
          { kind: 'Field', name: { kind: 'Name', value: 'srcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'webpSrcSet' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSquare' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '1:1',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brand' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'brandName' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSquare' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'imageForListview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'brandsBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BrandsBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hideLabels' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'bulletListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'BulletListRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bullets' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberedList' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'documentLinkBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'DocumentLinkBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'documents' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'employeeBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'EmployeeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'description' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'image' },
            name: { kind: 'Name', value: 'profileImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'overlay' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OverlayRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'color' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'opacity' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ctaButton' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CtaButtonRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variant' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'muxVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'blurUpThumb' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'muxPlaybackId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HeroBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ctaUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'boxColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'textColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'dynamicImage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'max' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '1800' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ImageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullWidth' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'textBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'smallHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'text' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'markdown' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButtons' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'mediaWithCaption' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MediaWithCaptionRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'media' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caption' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'centerText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'textOnImage' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'standalone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'largeTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'itemsToShow' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'reportsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ReportsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'standalone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'largeTitle' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridTwoColBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridTwocolBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'mediaWithCaption' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'newsListBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'reportsListBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridThreeColBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridThreecolBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'mediaWithCaption' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridTwoColBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridFourColBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridFourcolBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'mediaWithCaption' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'textBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'gridContainerBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GridContainerBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'backgroundColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'textColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fullwidth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gap' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridTwoColBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridThreeColBlock' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'gridFourColBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'jobsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'JobsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'newsAndReportsListBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'NewsAndReportsListBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'newsTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'news' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NewsPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'publishDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'reportsTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportsImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reports' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ReportsListingRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'publishDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pdf' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'fileLink' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'office' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficeRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'websiteUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'officesBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OfficesBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'offices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'office' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'plugBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PlugBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'brand' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'simpleTitleAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SimpleTitleAndTextBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'topLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'heroImageTablet' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'w' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'h' },
                      value: { kind: 'IntValue', value: '2880' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'statementBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'StatementBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blackBackground' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
          { kind: 'Field', name: { kind: 'Name', value: 'small' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkUrl' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageMobile' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '1728' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageTablet' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroImageTablet' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageDesktop' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsiveImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'locale' },
                      value: { kind: 'EnumValue', value: 'en' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'imgixParams' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fit' },
                            value: { kind: 'EnumValue', value: 'crop' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'crop' },
                            value: { kind: 'EnumValue', value: 'focalpoint' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'w' },
                            value: { kind: 'IntValue', value: '2880' },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'h' },
                            value: { kind: 'IntValue', value: '1620' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'responsiveImage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'backgroundImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageOverlay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'overlay' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnImageAndTextBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnImageAndTextRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reverse' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'dynamicImage' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'imageLoad' },
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageLoad' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'twoColumnTextIntroBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TwoColumnTextIntroRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'header' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'uploadVideo' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UploadVideoField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'mp4Url' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'mp4Low' },
            name: { kind: 'Name', value: 'mp4Url' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'res' },
                value: { kind: 'EnumValue', value: 'low' },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'streamingUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'thumbnailUrl' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'imageSixteenByNine' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBasic' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'EnumValue', value: 'en' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imgixParams' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fit' },
                      value: { kind: 'EnumValue', value: 'crop' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'crop' },
                      value: { kind: 'EnumValue', value: 'focalpoint' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ar' },
                      value: {
                        kind: 'StringValue',
                        value: '16:9',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fm' },
                      value: { kind: 'EnumValue', value: 'jpg' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'q' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'videoBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'VideoRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'autoplay' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'video' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'uploadVideo' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'videoThumbnail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageSixteenByNine' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'muxVideo' },
            name: { kind: 'Name', value: 'video' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'muxVideo' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'sliderBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SliderBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'arrows' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slideAnimation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'delay' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'dots' },
            name: { kind: 'Name', value: 'navigationDots' },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'heroes' },
            name: { kind: 'Name', value: 'slides' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'heroBlock' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'subheadingBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SubheadingBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ctaButton' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ctaButton' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'backgroundColor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'hex' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'sustainabilityReportsBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SustainabilityReportsBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reports' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fileLink' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'link' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LinkRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'pageNavigationBlock' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PageNavigationBlockRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'links' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'link' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'sustainabilityPageContentArea' },
      typeCondition: {
        kind: 'NamedType',
        name: {
          kind: 'Name',
          value: 'SustainabilityPageModelContentAreaField',
        },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'articlesBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'brandsBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'bulletListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'documentLinkBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'employeeBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'heroBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'gridContainerBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'imageBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'jobsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'newsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'newsAndReportsListBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'officesBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'plugBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'simpleTitleAndTextBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'statementBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'textBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'twoColumnImageAndTextBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'twoColumnTextIntroBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'videoBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'sliderBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'subheadingBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'sustainabilityReportsBlock' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'pageNavigationBlock' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'image' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FileField' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsiveImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'responsiveImage' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'language' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LanguageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'flag' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'symbol' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBasic' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'subMenuItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ItemRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pageLink' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'BrandPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SustainabilityPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'AboutUsPageRecord' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'menuItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MenuItemRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submenu' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'menuItems' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'subMenuItem' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'footerMenuItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FooterMenuItemRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'heading' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'links' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'includeCookieToggle' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'iconLink' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'IconLinkRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'icon' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBasic' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'sustainabilityPageContent' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SustainabilityPageRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'pageLocales' },
            name: { kind: 'Name', value: '_locales' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'seo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'seo' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentArea' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'sustainabilityPageContentArea',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'globalContent' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'GlobalRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'navigationLogo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'image' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'changeLanguage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'closeLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deadline' } },
          { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'loading' } },
          { kind: 'Field', name: { kind: 'Name', value: 'loadMoreNews' } },
          { kind: 'Field', name: { kind: 'Name', value: 'localWebLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'menu' } },
          { kind: 'Field', name: { kind: 'Name', value: 'moreNewsCta' } },
          { kind: 'Field', name: { kind: 'Name', value: 'moreNewsHeader' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'partnerPortalLabel' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerPortalUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'play' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shopLinkTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shopLinkUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'showMoreJobsLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'viewOnMapLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'languages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'language' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'nextLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previousLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sliderNavigationLabel' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'moreReportsCta' } },
          { kind: 'Field', name: { kind: 'Name', value: 'loadMoreReports' } },
          { kind: 'Field', name: { kind: 'Name', value: 'clearIconLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'searchIconLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchBoxPlaceholder' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'viewAllButtonLabel' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchResultsPageTitle' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'firstPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previousPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'goToPageLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'searchResultCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'noSearchResults' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'featureToggle' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FeatureToggleRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'landingPageContentArea' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newsPageContentArea' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'menu' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MenuRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'menuItems' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'menuItem' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'footer' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FooterRecord' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'bottomIntro' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cookieSettings' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'footerLogo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'imageBasic' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'introText' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hultaforsBrands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'link' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'menu' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'link' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'menuItems' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'footerMenuItem' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'moreInfoText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'partnerLogin' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selectCountryLabel' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'socialMediaLabel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'socialMediaMenu' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'iconLink' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'useNewFooter' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SustainabilityPageQuery,
  SustainabilityPageQueryVariables
>;
